var q1 = Object.defineProperty;
var mm = (t) => {
  throw TypeError(t);
};
var G1 = (t, e, n) => e in t ? q1(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var $e = (t, e, n) => G1(t, typeof e != "symbol" ? e + "" : e, n), J1 = (t, e, n) => e.has(t) || mm("Cannot " + n);
var ks = (t, e, n) => (J1(t, e, "read from private field"), n ? n.call(t) : e.get(t)), gm = (t, e, n) => e.has(t) ? mm("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, n);
import * as vm from "vue";
import { defineComponent as j, computed as A, createElementBlock as K, openBlock as w, unref as p, normalizeClass as Ie, getCurrentInstance as Cn, inject as yc, shallowRef as ri, ref as F, onBeforeMount as X1, watch as Ke, onMounted as ze, onUnmounted as En, effectScope as Cp, isRef as bt, h as Kn, Fragment as Me, createVNode as q, Text as Q1, createBlock as I, resolveDynamicComponent as On, withCtx as S, renderSlot as $, createCommentVNode as V, createTextVNode as We, toDisplayString as Se, createElementVNode as be, renderList as et, normalizeStyle as Lt, mergeModels as it, useModel as ut, normalizeProps as Ye, mergeProps as oe, getCurrentScope as bc, onScopeDispose as kc, shallowReadonly as fi, Comment as Ay, cloneVNode as Z1, readonly as Ep, toValue as fr, customRef as My, watchEffect as Nn, onBeforeUnmount as is, reactive as eo, toRefs as Gt, nextTick as nt, provide as Iy, withKeys as to, toHandlerKey as e_, camelize as Dy, Teleport as wc, toRef as Bi, markRaw as Py, withModifiers as Xe, watchPostEffect as Ny, mergeDefaults as $y, watchSyncEffect as t_, withMemo as n_, guardReactiveProps as ot, useSlots as uo, toHandlers as r_, useAttrs as _l, createSlots as At, withDirectives as Xr, vModelText as Cl, vModelDynamic as o_, resolveComponent as a_, Transition as ss, render as ym, onBeforeUpdate as i_, vShow as cu, useId as Op } from "vue";
const ce = (t) => t === !0 || t === "true", Si = (t) => t === !1 || t === "false", s_ = ["aria-hidden"], ht = /* @__PURE__ */ j({
  __name: "KIcon",
  props: {
    icon: {},
    size: {}
  },
  setup(t) {
    const e = t, n = A(() => {
      var o;
      const r = {
        "k-icon": !0,
        [`k-icon-${(o = e.size) == null ? void 0 : o.replace(".", "_")}`]: !!e.size
      };
      if (Array.isArray(e.icon) && e.icon.length == 2) {
        const [a, i] = e.icon, s = i.startsWith("fa-") ? i : "fa-" + i;
        r[a] = !0, r[s] = !0;
      } else
        r[e.icon] = !0;
      return r;
    });
    return (r, o) => (w(), K("i", {
      class: Ie(n.value),
      "aria-hidden": r.$attrs["aria-hidden"] !== void 0 ? p(ce)(r.$attrs["aria-hidden"]) : !0
    }, null, 10, s_));
  }
});
/*!
  * shared v9.14.2
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const Ir = typeof window < "u";
let Qn, za;
if (process.env.NODE_ENV !== "production") {
  const t = Ir && window.performance;
  t && t.mark && t.measure && t.clearMarks && // @ts-ignore browser compat
  t.clearMeasures && (Qn = (e) => {
    t.mark(e);
  }, za = (e, n, r) => {
    t.measure(e, n, r), t.clearMarks(n), t.clearMarks(r);
  });
}
const l_ = /\{([0-9a-zA-Z]+)\}/g;
function Tp(t, ...e) {
  return e.length === 1 && gt(e[0]) && (e = e[0]), (!e || !e.hasOwnProperty) && (e = {}), t.replace(l_, (n, r) => e.hasOwnProperty(r) ? e[r] : "");
}
const co = (t, e = !1) => e ? Symbol.for(t) : Symbol(t), u_ = (t, e, n) => c_({ l: t, k: e, s: n }), c_ = (t) => JSON.stringify(t).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), jt = (t) => typeof t == "number" && isFinite(t), d_ = (t) => Ly(t) === "[object Date]", la = (t) => Ly(t) === "[object RegExp]", _c = (t) => Ze(t) && Object.keys(t).length === 0, gn = Object.assign, f_ = Object.create, Et = (t = null) => f_(t);
let bm;
const Oo = () => bm || (bm = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : Et());
function km(t) {
  return t.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const p_ = Object.prototype.hasOwnProperty;
function xr(t, e) {
  return p_.call(t, e);
}
const xt = Array.isArray, Ct = (t) => typeof t == "function", Ae = (t) => typeof t == "string", dt = (t) => typeof t == "boolean", gt = (t) => t !== null && typeof t == "object", h_ = (t) => gt(t) && Ct(t.then) && Ct(t.catch), Ry = Object.prototype.toString, Ly = (t) => Ry.call(t), Ze = (t) => {
  if (!gt(t))
    return !1;
  const e = Object.getPrototypeOf(t);
  return e === null || e.constructor === Object;
}, m_ = (t) => t == null ? "" : xt(t) || Ze(t) && t.toString === Ry ? JSON.stringify(t, null, 2) : String(t);
function g_(t, e = "") {
  return t.reduce((n, r, o) => o === 0 ? n + r : n + e + r, "");
}
const wm = 2;
function v_(t, e = 0, n = t.length) {
  const r = t.split(/\r?\n/);
  let o = 0;
  const a = [];
  for (let i = 0; i < r.length; i++)
    if (o += r[i].length + 1, o >= e) {
      for (let s = i - wm; s <= i + wm || n > o; s++) {
        if (s < 0 || s >= r.length)
          continue;
        const l = s + 1;
        a.push(`${l}${" ".repeat(3 - String(l).length)}|  ${r[s]}`);
        const u = r[s].length;
        if (s === i) {
          const c = e - (o - u) + 1, d = Math.max(1, n > o ? u - c : n - e);
          a.push("   |  " + " ".repeat(c) + "^".repeat(d));
        } else if (s > i) {
          if (n > o) {
            const c = Math.max(Math.min(n - o, u), 1);
            a.push("   |  " + "^".repeat(c));
          }
          o += u + 1;
        }
      }
      break;
    }
  return a.join(`
`);
}
function Cc(t) {
  let e = t;
  return () => ++e;
}
function Zt(t, e) {
  typeof console < "u" && (console.warn("[intlify] " + t), e && console.warn(e.stack));
}
const _m = {};
function By(t) {
  _m[t] || (_m[t] = !0, Zt(t));
}
function Sp() {
  const t = /* @__PURE__ */ new Map();
  return {
    events: t,
    on(n, r) {
      const o = t.get(n);
      o && o.push(r) || t.set(n, [r]);
    },
    off(n, r) {
      const o = t.get(n);
      o && o.splice(o.indexOf(r) >>> 0, 1);
    },
    emit(n, r) {
      (t.get(n) || []).slice().map((o) => o(r)), (t.get("*") || []).slice().map((o) => o(n, r));
    }
  };
}
const Wl = (t) => !gt(t) || xt(t);
function du(t, e) {
  if (Wl(t) || Wl(e))
    throw new Error("Invalid value");
  const n = [{ src: t, des: e }];
  for (; n.length; ) {
    const { src: r, des: o } = n.pop();
    Object.keys(r).forEach((a) => {
      a !== "__proto__" && (gt(r[a]) && !gt(o[a]) && (o[a] = Array.isArray(r[a]) ? [] : Et()), Wl(o[a]) || Wl(r[a]) ? o[a] = r[a] : n.push({ src: r[a], des: o[a] }));
    });
  }
}
/*!
  * message-compiler v9.14.2
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function y_(t, e, n) {
  return { line: t, column: e, offset: n };
}
function bu(t, e, n) {
  return { start: t, end: e };
}
const b_ = /\{([0-9a-zA-Z]+)\}/g;
function Fy(t, ...e) {
  return e.length === 1 && k_(e[0]) && (e = e[0]), (!e || !e.hasOwnProperty) && (e = {}), t.replace(b_, (n, r) => e.hasOwnProperty(r) ? e[r] : "");
}
const Vy = Object.assign, Cm = (t) => typeof t == "string", k_ = (t) => t !== null && typeof t == "object";
function Hy(t, e = "") {
  return t.reduce((n, r, o) => o === 0 ? n + r : n + e + r, "");
}
const Ec = {
  USE_MODULO_SYNTAX: 1,
  __EXTEND_POINT__: 2
}, w_ = {
  [Ec.USE_MODULO_SYNTAX]: "Use modulo before '{{0}}'."
};
function __(t, e, ...n) {
  const r = Fy(w_[t], ...n || []), o = { message: String(r), code: t };
  return e && (o.location = e), o;
}
const Je = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16,
  // Special value for higher-order compilers to pick up the last code
  // to avoid collision of error codes. This should always be kept as the last
  // item.
  __EXTEND_POINT__: 17
}, C_ = {
  // tokenizer error messages
  [Je.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [Je.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [Je.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [Je.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [Je.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [Je.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [Je.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [Je.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [Je.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [Je.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [Je.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [Je.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [Je.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [Je.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [Je.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [Je.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function ls(t, e, n = {}) {
  const { domain: r, messages: o, args: a } = n, i = Fy((o || C_)[t] || "", ...a || []), s = new SyntaxError(String(i));
  return s.code = t, e && (s.location = e), s.domain = r, s;
}
function E_(t) {
  throw t;
}
const O_ = /<\/?[\w\s="/.':;#-\/]+>/, T_ = (t) => O_.test(t), mo = " ", S_ = "\r", Mn = `
`, x_ = "\u2028", A_ = "\u2029";
function M_(t) {
  const e = t;
  let n = 0, r = 1, o = 1, a = 0;
  const i = (T) => e[T] === S_ && e[T + 1] === Mn, s = (T) => e[T] === Mn, l = (T) => e[T] === A_, u = (T) => e[T] === x_, c = (T) => i(T) || s(T) || l(T) || u(T), d = () => n, f = () => r, h = () => o, m = () => a, g = (T) => i(T) || l(T) || u(T) ? Mn : e[T], y = () => g(n), b = () => g(n + a);
  function C() {
    return a = 0, c(n) && (r++, o = 0), i(n) && n++, n++, o++, e[n];
  }
  function k() {
    return i(n + a) && a++, a++, e[n + a];
  }
  function v() {
    n = 0, r = 1, o = 1, a = 0;
  }
  function E(T = 0) {
    a = T;
  }
  function _() {
    const T = n + a;
    for (; T !== n; )
      C();
    a = 0;
  }
  return {
    index: d,
    line: f,
    column: h,
    peekOffset: m,
    charAt: g,
    currentChar: y,
    currentPeek: b,
    next: C,
    peek: k,
    reset: v,
    resetPeek: E,
    skipToPeek: _
  };
}
const Vo = void 0, I_ = ".", Em = "'", D_ = "tokenizer";
function P_(t, e = {}) {
  const n = e.location !== !1, r = M_(t), o = () => r.index(), a = () => y_(r.line(), r.column(), r.index()), i = a(), s = o(), l = {
    currentType: 14,
    offset: s,
    startLoc: i,
    endLoc: i,
    lastType: 14,
    lastOffset: s,
    lastStartLoc: i,
    lastEndLoc: i,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, u = () => l, { onError: c } = e;
  function d(L, x, Y, ...ge) {
    const Ge = u();
    if (x.column += Y, x.offset += Y, c) {
      const rt = n ? bu(Ge.startLoc, x) : null, Te = ls(L, rt, {
        domain: D_,
        args: ge
      });
      c(Te);
    }
  }
  function f(L, x, Y) {
    L.endLoc = a(), L.currentType = x;
    const ge = { type: x };
    return n && (ge.loc = bu(L.startLoc, L.endLoc)), Y != null && (ge.value = Y), ge;
  }
  const h = (L) => f(
    L,
    14
    /* TokenTypes.EOF */
  );
  function m(L, x) {
    return L.currentChar() === x ? (L.next(), x) : (d(Je.EXPECTED_TOKEN, a(), 0, x), "");
  }
  function g(L) {
    let x = "";
    for (; L.currentPeek() === mo || L.currentPeek() === Mn; )
      x += L.currentPeek(), L.peek();
    return x;
  }
  function y(L) {
    const x = g(L);
    return L.skipToPeek(), x;
  }
  function b(L) {
    if (L === Vo)
      return !1;
    const x = L.charCodeAt(0);
    return x >= 97 && x <= 122 || // a-z
    x >= 65 && x <= 90 || // A-Z
    x === 95;
  }
  function C(L) {
    if (L === Vo)
      return !1;
    const x = L.charCodeAt(0);
    return x >= 48 && x <= 57;
  }
  function k(L, x) {
    const { currentType: Y } = x;
    if (Y !== 2)
      return !1;
    g(L);
    const ge = b(L.currentPeek());
    return L.resetPeek(), ge;
  }
  function v(L, x) {
    const { currentType: Y } = x;
    if (Y !== 2)
      return !1;
    g(L);
    const ge = L.currentPeek() === "-" ? L.peek() : L.currentPeek(), Ge = C(ge);
    return L.resetPeek(), Ge;
  }
  function E(L, x) {
    const { currentType: Y } = x;
    if (Y !== 2)
      return !1;
    g(L);
    const ge = L.currentPeek() === Em;
    return L.resetPeek(), ge;
  }
  function _(L, x) {
    const { currentType: Y } = x;
    if (Y !== 8)
      return !1;
    g(L);
    const ge = L.currentPeek() === ".";
    return L.resetPeek(), ge;
  }
  function T(L, x) {
    const { currentType: Y } = x;
    if (Y !== 9)
      return !1;
    g(L);
    const ge = b(L.currentPeek());
    return L.resetPeek(), ge;
  }
  function M(L, x) {
    const { currentType: Y } = x;
    if (!(Y === 8 || Y === 12))
      return !1;
    g(L);
    const ge = L.currentPeek() === ":";
    return L.resetPeek(), ge;
  }
  function O(L, x) {
    const { currentType: Y } = x;
    if (Y !== 10)
      return !1;
    const ge = () => {
      const rt = L.currentPeek();
      return rt === "{" ? b(L.peek()) : rt === "@" || rt === "%" || rt === "|" || rt === ":" || rt === "." || rt === mo || !rt ? !1 : rt === Mn ? (L.peek(), ge()) : z(L, !1);
    }, Ge = ge();
    return L.resetPeek(), Ge;
  }
  function R(L) {
    g(L);
    const x = L.currentPeek() === "|";
    return L.resetPeek(), x;
  }
  function N(L) {
    const x = g(L), Y = L.currentPeek() === "%" && L.peek() === "{";
    return L.resetPeek(), {
      isModulo: Y,
      hasSpace: x.length > 0
    };
  }
  function z(L, x = !0) {
    const Y = (Ge = !1, rt = "", Te = !1) => {
      const ae = L.currentPeek();
      return ae === "{" ? rt === "%" ? !1 : Ge : ae === "@" || !ae ? rt === "%" ? !0 : Ge : ae === "%" ? (L.peek(), Y(Ge, "%", !0)) : ae === "|" ? rt === "%" || Te ? !0 : !(rt === mo || rt === Mn) : ae === mo ? (L.peek(), Y(!0, mo, Te)) : ae === Mn ? (L.peek(), Y(!0, Mn, Te)) : !0;
    }, ge = Y();
    return x && L.resetPeek(), ge;
  }
  function te(L, x) {
    const Y = L.currentChar();
    return Y === Vo ? Vo : x(Y) ? (L.next(), Y) : null;
  }
  function H(L) {
    const x = L.charCodeAt(0);
    return x >= 97 && x <= 122 || // a-z
    x >= 65 && x <= 90 || // A-Z
    x >= 48 && x <= 57 || // 0-9
    x === 95 || // _
    x === 36;
  }
  function U(L) {
    return te(L, H);
  }
  function W(L) {
    const x = L.charCodeAt(0);
    return x >= 97 && x <= 122 || // a-z
    x >= 65 && x <= 90 || // A-Z
    x >= 48 && x <= 57 || // 0-9
    x === 95 || // _
    x === 36 || // $
    x === 45;
  }
  function Q(L) {
    return te(L, W);
  }
  function de(L) {
    const x = L.charCodeAt(0);
    return x >= 48 && x <= 57;
  }
  function re(L) {
    return te(L, de);
  }
  function J(L) {
    const x = L.charCodeAt(0);
    return x >= 48 && x <= 57 || // 0-9
    x >= 65 && x <= 70 || // A-F
    x >= 97 && x <= 102;
  }
  function Ce(L) {
    return te(L, J);
  }
  function ie(L) {
    let x = "", Y = "";
    for (; x = re(L); )
      Y += x;
    return Y;
  }
  function ee(L) {
    y(L);
    const x = L.currentChar();
    return x !== "%" && d(Je.EXPECTED_TOKEN, a(), 0, x), L.next(), "%";
  }
  function D(L) {
    let x = "";
    for (; ; ) {
      const Y = L.currentChar();
      if (Y === "{" || Y === "}" || Y === "@" || Y === "|" || !Y)
        break;
      if (Y === "%")
        if (z(L))
          x += Y, L.next();
        else
          break;
      else if (Y === mo || Y === Mn)
        if (z(L))
          x += Y, L.next();
        else {
          if (R(L))
            break;
          x += Y, L.next();
        }
      else
        x += Y, L.next();
    }
    return x;
  }
  function G(L) {
    y(L);
    let x = "", Y = "";
    for (; x = Q(L); )
      Y += x;
    return L.currentChar() === Vo && d(Je.UNTERMINATED_CLOSING_BRACE, a(), 0), Y;
  }
  function fe(L) {
    y(L);
    let x = "";
    return L.currentChar() === "-" ? (L.next(), x += `-${ie(L)}`) : x += ie(L), L.currentChar() === Vo && d(Je.UNTERMINATED_CLOSING_BRACE, a(), 0), x;
  }
  function P(L) {
    return L !== Em && L !== Mn;
  }
  function se(L) {
    y(L), m(L, "'");
    let x = "", Y = "";
    for (; x = te(L, P); )
      x === "\\" ? Y += ke(L) : Y += x;
    const ge = L.currentChar();
    return ge === Mn || ge === Vo ? (d(Je.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, a(), 0), ge === Mn && (L.next(), m(L, "'")), Y) : (m(L, "'"), Y);
  }
  function ke(L) {
    const x = L.currentChar();
    switch (x) {
      case "\\":
      case "'":
        return L.next(), `\\${x}`;
      case "u":
        return Le(L, x, 4);
      case "U":
        return Le(L, x, 6);
      default:
        return d(Je.UNKNOWN_ESCAPE_SEQUENCE, a(), 0, x), "";
    }
  }
  function Le(L, x, Y) {
    m(L, x);
    let ge = "";
    for (let Ge = 0; Ge < Y; Ge++) {
      const rt = Ce(L);
      if (!rt) {
        d(Je.INVALID_UNICODE_ESCAPE_SEQUENCE, a(), 0, `\\${x}${ge}${L.currentChar()}`);
        break;
      }
      ge += rt;
    }
    return `\\${x}${ge}`;
  }
  function ne(L) {
    return L !== "{" && L !== "}" && L !== mo && L !== Mn;
  }
  function ye(L) {
    y(L);
    let x = "", Y = "";
    for (; x = te(L, ne); )
      Y += x;
    return Y;
  }
  function pe(L) {
    let x = "", Y = "";
    for (; x = U(L); )
      Y += x;
    return Y;
  }
  function Z(L) {
    const x = (Y) => {
      const ge = L.currentChar();
      return ge === "{" || ge === "%" || ge === "@" || ge === "|" || ge === "(" || ge === ")" || !ge || ge === mo ? Y : (Y += ge, L.next(), x(Y));
    };
    return x("");
  }
  function B(L) {
    y(L);
    const x = m(
      L,
      "|"
      /* TokenChars.Pipe */
    );
    return y(L), x;
  }
  function me(L, x) {
    let Y = null;
    switch (L.currentChar()) {
      case "{":
        return x.braceNest >= 1 && d(Je.NOT_ALLOW_NEST_PLACEHOLDER, a(), 0), L.next(), Y = f(
          x,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), y(L), x.braceNest++, Y;
      case "}":
        return x.braceNest > 0 && x.currentType === 2 && d(Je.EMPTY_PLACEHOLDER, a(), 0), L.next(), Y = f(
          x,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), x.braceNest--, x.braceNest > 0 && y(L), x.inLinked && x.braceNest === 0 && (x.inLinked = !1), Y;
      case "@":
        return x.braceNest > 0 && d(Je.UNTERMINATED_CLOSING_BRACE, a(), 0), Y = Ve(L, x) || h(x), x.braceNest = 0, Y;
      default: {
        let Ge = !0, rt = !0, Te = !0;
        if (R(L))
          return x.braceNest > 0 && d(Je.UNTERMINATED_CLOSING_BRACE, a(), 0), Y = f(x, 1, B(L)), x.braceNest = 0, x.inLinked = !1, Y;
        if (x.braceNest > 0 && (x.currentType === 5 || x.currentType === 6 || x.currentType === 7))
          return d(Je.UNTERMINATED_CLOSING_BRACE, a(), 0), x.braceNest = 0, Ee(L, x);
        if (Ge = k(L, x))
          return Y = f(x, 5, G(L)), y(L), Y;
        if (rt = v(L, x))
          return Y = f(x, 6, fe(L)), y(L), Y;
        if (Te = E(L, x))
          return Y = f(x, 7, se(L)), y(L), Y;
        if (!Ge && !rt && !Te)
          return Y = f(x, 13, ye(L)), d(Je.INVALID_TOKEN_IN_PLACEHOLDER, a(), 0, Y.value), y(L), Y;
        break;
      }
    }
    return Y;
  }
  function Ve(L, x) {
    const { currentType: Y } = x;
    let ge = null;
    const Ge = L.currentChar();
    switch ((Y === 8 || Y === 9 || Y === 12 || Y === 10) && (Ge === Mn || Ge === mo) && d(Je.INVALID_LINKED_FORMAT, a(), 0), Ge) {
      case "@":
        return L.next(), ge = f(
          x,
          8,
          "@"
          /* TokenChars.LinkedAlias */
        ), x.inLinked = !0, ge;
      case ".":
        return y(L), L.next(), f(
          x,
          9,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return y(L), L.next(), f(
          x,
          10,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return R(L) ? (ge = f(x, 1, B(L)), x.braceNest = 0, x.inLinked = !1, ge) : _(L, x) || M(L, x) ? (y(L), Ve(L, x)) : T(L, x) ? (y(L), f(x, 12, pe(L))) : O(L, x) ? (y(L), Ge === "{" ? me(L, x) || ge : f(x, 11, Z(L))) : (Y === 8 && d(Je.INVALID_LINKED_FORMAT, a(), 0), x.braceNest = 0, x.inLinked = !1, Ee(L, x));
    }
  }
  function Ee(L, x) {
    let Y = {
      type: 14
      /* TokenTypes.EOF */
    };
    if (x.braceNest > 0)
      return me(L, x) || h(x);
    if (x.inLinked)
      return Ve(L, x) || h(x);
    switch (L.currentChar()) {
      case "{":
        return me(L, x) || h(x);
      case "}":
        return d(Je.UNBALANCED_CLOSING_BRACE, a(), 0), L.next(), f(
          x,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return Ve(L, x) || h(x);
      default: {
        if (R(L))
          return Y = f(x, 1, B(L)), x.braceNest = 0, x.inLinked = !1, Y;
        const { isModulo: Ge, hasSpace: rt } = N(L);
        if (Ge)
          return rt ? f(x, 0, D(L)) : f(x, 4, ee(L));
        if (z(L))
          return f(x, 0, D(L));
        break;
      }
    }
    return Y;
  }
  function st() {
    const { currentType: L, offset: x, startLoc: Y, endLoc: ge } = l;
    return l.lastType = L, l.lastOffset = x, l.lastStartLoc = Y, l.lastEndLoc = ge, l.offset = o(), l.startLoc = a(), r.currentChar() === Vo ? f(
      l,
      14
      /* TokenTypes.EOF */
    ) : Ee(r, l);
  }
  return {
    nextToken: st,
    currentOffset: o,
    currentPosition: a,
    context: u
  };
}
const N_ = "parser", $_ = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function R_(t, e, n) {
  switch (t) {
    case "\\\\":
      return "\\";
    // eslint-disable-next-line no-useless-escape
    case "\\'":
      return "'";
    default: {
      const r = parseInt(e || n, 16);
      return r <= 55295 || r >= 57344 ? String.fromCodePoint(r) : "�";
    }
  }
}
function L_(t = {}) {
  const e = t.location !== !1, { onError: n, onWarn: r } = t;
  function o(k, v, E, _, ...T) {
    const M = k.currentPosition();
    if (M.offset += _, M.column += _, n) {
      const O = e ? bu(E, M) : null, R = ls(v, O, {
        domain: N_,
        args: T
      });
      n(R);
    }
  }
  function a(k, v, E, _, ...T) {
    const M = k.currentPosition();
    if (M.offset += _, M.column += _, r) {
      const O = e ? bu(E, M) : null;
      r(__(v, O, T));
    }
  }
  function i(k, v, E) {
    const _ = { type: k };
    return e && (_.start = v, _.end = v, _.loc = { start: E, end: E }), _;
  }
  function s(k, v, E, _) {
    e && (k.end = v, k.loc && (k.loc.end = E));
  }
  function l(k, v) {
    const E = k.context(), _ = i(3, E.offset, E.startLoc);
    return _.value = v, s(_, k.currentOffset(), k.currentPosition()), _;
  }
  function u(k, v) {
    const E = k.context(), { lastOffset: _, lastStartLoc: T } = E, M = i(5, _, T);
    return M.index = parseInt(v, 10), k.nextToken(), s(M, k.currentOffset(), k.currentPosition()), M;
  }
  function c(k, v, E) {
    const _ = k.context(), { lastOffset: T, lastStartLoc: M } = _, O = i(4, T, M);
    return O.key = v, E === !0 && (O.modulo = !0), k.nextToken(), s(O, k.currentOffset(), k.currentPosition()), O;
  }
  function d(k, v) {
    const E = k.context(), { lastOffset: _, lastStartLoc: T } = E, M = i(9, _, T);
    return M.value = v.replace($_, R_), k.nextToken(), s(M, k.currentOffset(), k.currentPosition()), M;
  }
  function f(k) {
    const v = k.nextToken(), E = k.context(), { lastOffset: _, lastStartLoc: T } = E, M = i(8, _, T);
    return v.type !== 12 ? (o(k, Je.UNEXPECTED_EMPTY_LINKED_MODIFIER, E.lastStartLoc, 0), M.value = "", s(M, _, T), {
      nextConsumeToken: v,
      node: M
    }) : (v.value == null && o(k, Je.UNEXPECTED_LEXICAL_ANALYSIS, E.lastStartLoc, 0, wr(v)), M.value = v.value || "", s(M, k.currentOffset(), k.currentPosition()), {
      node: M
    });
  }
  function h(k, v) {
    const E = k.context(), _ = i(7, E.offset, E.startLoc);
    return _.value = v, s(_, k.currentOffset(), k.currentPosition()), _;
  }
  function m(k) {
    const v = k.context(), E = i(6, v.offset, v.startLoc);
    let _ = k.nextToken();
    if (_.type === 9) {
      const T = f(k);
      E.modifier = T.node, _ = T.nextConsumeToken || k.nextToken();
    }
    switch (_.type !== 10 && o(k, Je.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, wr(_)), _ = k.nextToken(), _.type === 2 && (_ = k.nextToken()), _.type) {
      case 11:
        _.value == null && o(k, Je.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, wr(_)), E.key = h(k, _.value || "");
        break;
      case 5:
        _.value == null && o(k, Je.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, wr(_)), E.key = c(k, _.value || "");
        break;
      case 6:
        _.value == null && o(k, Je.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, wr(_)), E.key = u(k, _.value || "");
        break;
      case 7:
        _.value == null && o(k, Je.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, wr(_)), E.key = d(k, _.value || "");
        break;
      default: {
        o(k, Je.UNEXPECTED_EMPTY_LINKED_KEY, v.lastStartLoc, 0);
        const T = k.context(), M = i(7, T.offset, T.startLoc);
        return M.value = "", s(M, T.offset, T.startLoc), E.key = M, s(E, T.offset, T.startLoc), {
          nextConsumeToken: _,
          node: E
        };
      }
    }
    return s(E, k.currentOffset(), k.currentPosition()), {
      node: E
    };
  }
  function g(k) {
    const v = k.context(), E = v.currentType === 1 ? k.currentOffset() : v.offset, _ = v.currentType === 1 ? v.endLoc : v.startLoc, T = i(2, E, _);
    T.items = [];
    let M = null, O = null;
    do {
      const z = M || k.nextToken();
      switch (M = null, z.type) {
        case 0:
          z.value == null && o(k, Je.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, wr(z)), T.items.push(l(k, z.value || ""));
          break;
        case 6:
          z.value == null && o(k, Je.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, wr(z)), T.items.push(u(k, z.value || ""));
          break;
        case 4:
          O = !0;
          break;
        case 5:
          z.value == null && o(k, Je.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, wr(z)), T.items.push(c(k, z.value || "", !!O)), O && (a(k, Ec.USE_MODULO_SYNTAX, v.lastStartLoc, 0, wr(z)), O = null);
          break;
        case 7:
          z.value == null && o(k, Je.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, wr(z)), T.items.push(d(k, z.value || ""));
          break;
        case 8: {
          const te = m(k);
          T.items.push(te.node), M = te.nextConsumeToken || null;
          break;
        }
      }
    } while (v.currentType !== 14 && v.currentType !== 1);
    const R = v.currentType === 1 ? v.lastOffset : k.currentOffset(), N = v.currentType === 1 ? v.lastEndLoc : k.currentPosition();
    return s(T, R, N), T;
  }
  function y(k, v, E, _) {
    const T = k.context();
    let M = _.items.length === 0;
    const O = i(1, v, E);
    O.cases = [], O.cases.push(_);
    do {
      const R = g(k);
      M || (M = R.items.length === 0), O.cases.push(R);
    } while (T.currentType !== 14);
    return M && o(k, Je.MUST_HAVE_MESSAGES_IN_PLURAL, E, 0), s(O, k.currentOffset(), k.currentPosition()), O;
  }
  function b(k) {
    const v = k.context(), { offset: E, startLoc: _ } = v, T = g(k);
    return v.currentType === 14 ? T : y(k, E, _, T);
  }
  function C(k) {
    const v = P_(k, Vy({}, t)), E = v.context(), _ = i(0, E.offset, E.startLoc);
    return e && _.loc && (_.loc.source = k), _.body = b(v), t.onCacheKey && (_.cacheKey = t.onCacheKey(k)), E.currentType !== 14 && o(v, Je.UNEXPECTED_LEXICAL_ANALYSIS, E.lastStartLoc, 0, k[E.offset] || ""), s(_, v.currentOffset(), v.currentPosition()), _;
  }
  return { parse: C };
}
function wr(t) {
  if (t.type === 14)
    return "EOF";
  const e = (t.value || "").replace(/\r?\n/gu, "\\n");
  return e.length > 10 ? e.slice(0, 9) + "…" : e;
}
function B_(t, e = {}) {
  const n = {
    ast: t,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (a) => (n.helpers.add(a), a) };
}
function Om(t, e) {
  for (let n = 0; n < t.length; n++)
    xp(t[n], e);
}
function xp(t, e) {
  switch (t.type) {
    case 1:
      Om(t.cases, e), e.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      Om(t.items, e);
      break;
    case 6: {
      xp(t.key, e), e.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), e.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      e.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), e.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      e.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), e.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function F_(t, e = {}) {
  const n = B_(t);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), t.body && xp(t.body, n);
  const r = n.context();
  t.helpers = Array.from(r.helpers);
}
function V_(t) {
  const e = t.body;
  return e.type === 2 ? Tm(e) : e.cases.forEach((n) => Tm(n)), t;
}
function Tm(t) {
  if (t.items.length === 1) {
    const e = t.items[0];
    (e.type === 3 || e.type === 9) && (t.static = e.value, delete e.value);
  } else {
    const e = [];
    for (let n = 0; n < t.items.length; n++) {
      const r = t.items[n];
      if (!(r.type === 3 || r.type === 9) || r.value == null)
        break;
      e.push(r.value);
    }
    if (e.length === t.items.length) {
      t.static = Hy(e);
      for (let n = 0; n < t.items.length; n++) {
        const r = t.items[n];
        (r.type === 3 || r.type === 9) && delete r.value;
      }
    }
  }
}
const H_ = "minifier";
function ki(t) {
  switch (t.t = t.type, t.type) {
    case 0: {
      const e = t;
      ki(e.body), e.b = e.body, delete e.body;
      break;
    }
    case 1: {
      const e = t, n = e.cases;
      for (let r = 0; r < n.length; r++)
        ki(n[r]);
      e.c = n, delete e.cases;
      break;
    }
    case 2: {
      const e = t, n = e.items;
      for (let r = 0; r < n.length; r++)
        ki(n[r]);
      e.i = n, delete e.items, e.static && (e.s = e.static, delete e.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const e = t;
      e.value && (e.v = e.value, delete e.value);
      break;
    }
    case 6: {
      const e = t;
      ki(e.key), e.k = e.key, delete e.key, e.modifier && (ki(e.modifier), e.m = e.modifier, delete e.modifier);
      break;
    }
    case 5: {
      const e = t;
      e.i = e.index, delete e.index;
      break;
    }
    case 4: {
      const e = t;
      e.k = e.key, delete e.key;
      break;
    }
    default:
      throw ls(Je.UNHANDLED_MINIFIER_NODE_TYPE, null, {
        domain: H_,
        args: [t.type]
      });
  }
  delete t.type;
}
const U_ = "parser";
function W_(t, e) {
  const { filename: n, breakLineCode: r, needIndent: o } = e, a = e.location !== !1, i = {
    filename: n,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: r,
    needIndent: o,
    indentLevel: 0
  };
  a && t.loc && (i.source = t.loc.source);
  const s = () => i;
  function l(g, y) {
    i.code += g;
  }
  function u(g, y = !0) {
    const b = y ? r : "";
    l(o ? b + "  ".repeat(g) : b);
  }
  function c(g = !0) {
    const y = ++i.indentLevel;
    g && u(y);
  }
  function d(g = !0) {
    const y = --i.indentLevel;
    g && u(y);
  }
  function f() {
    u(i.indentLevel);
  }
  return {
    context: s,
    push: l,
    indent: c,
    deindent: d,
    newline: f,
    helper: (g) => `_${g}`,
    needIndent: () => i.needIndent
  };
}
function K_(t, e) {
  const { helper: n } = t;
  t.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), Fi(t, e.key), e.modifier ? (t.push(", "), Fi(t, e.modifier), t.push(", _type")) : t.push(", undefined, _type"), t.push(")");
}
function j_(t, e) {
  const { helper: n, needIndent: r } = t;
  t.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), t.indent(r());
  const o = e.items.length;
  for (let a = 0; a < o && (Fi(t, e.items[a]), a !== o - 1); a++)
    t.push(", ");
  t.deindent(r()), t.push("])");
}
function z_(t, e) {
  const { helper: n, needIndent: r } = t;
  if (e.cases.length > 1) {
    t.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), t.indent(r());
    const o = e.cases.length;
    for (let a = 0; a < o && (Fi(t, e.cases[a]), a !== o - 1); a++)
      t.push(", ");
    t.deindent(r()), t.push("])");
  }
}
function Y_(t, e) {
  e.body ? Fi(t, e.body) : t.push("null");
}
function Fi(t, e) {
  const { helper: n } = t;
  switch (e.type) {
    case 0:
      Y_(t, e);
      break;
    case 1:
      z_(t, e);
      break;
    case 2:
      j_(t, e);
      break;
    case 6:
      K_(t, e);
      break;
    case 8:
      t.push(JSON.stringify(e.value), e);
      break;
    case 7:
      t.push(JSON.stringify(e.value), e);
      break;
    case 5:
      t.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${e.index}))`, e);
      break;
    case 4:
      t.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(e.key)}))`, e);
      break;
    case 9:
      t.push(JSON.stringify(e.value), e);
      break;
    case 3:
      t.push(JSON.stringify(e.value), e);
      break;
    default:
      throw ls(Je.UNHANDLED_CODEGEN_NODE_TYPE, null, {
        domain: U_,
        args: [e.type]
      });
  }
}
const q_ = (t, e = {}) => {
  const n = Cm(e.mode) ? e.mode : "normal", r = Cm(e.filename) ? e.filename : "message.intl";
  e.sourceMap;
  const o = e.breakLineCode != null ? e.breakLineCode : n === "arrow" ? ";" : `
`, a = e.needIndent ? e.needIndent : n !== "arrow", i = t.helpers || [], s = W_(t, {
    filename: r,
    breakLineCode: o,
    needIndent: a
  });
  s.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), s.indent(a), i.length > 0 && (s.push(`const { ${Hy(i.map((c) => `${c}: _${c}`), ", ")} } = ctx`), s.newline()), s.push("return "), Fi(s, t), s.deindent(a), s.push("}"), delete t.helpers;
  const { code: l, map: u } = s.context();
  return {
    ast: t,
    code: l,
    map: u ? u.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function G_(t, e = {}) {
  const n = Vy({}, e), r = !!n.jit, o = !!n.minify, a = n.optimize == null ? !0 : n.optimize, s = L_(n).parse(t);
  return r ? (a && V_(s), o && ki(s), { ast: s, code: "" }) : (F_(s, n), q_(s, n));
}
/*!
  * core-base v9.14.2
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function J_() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Oo().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_JIT_COMPILATION__ != "boolean" && (Oo().__INTLIFY_JIT_COMPILATION__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Oo().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
const ha = [];
ha[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
ha[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
ha[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
ha[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
ha[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
ha[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
ha[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const X_ = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function Q_(t) {
  return X_.test(t);
}
function Z_(t) {
  const e = t.charCodeAt(0), n = t.charCodeAt(t.length - 1);
  return e === n && (e === 34 || e === 39) ? t.slice(1, -1) : t;
}
function eC(t) {
  if (t == null)
    return "o";
  switch (t.charCodeAt(0)) {
    case 91:
    // [
    case 93:
    // ]
    case 46:
    // .
    case 34:
    // "
    case 39:
      return t;
    case 95:
    // _
    case 36:
    // $
    case 45:
      return "i";
    case 9:
    // Tab (HT)
    case 10:
    // Newline (LF)
    case 13:
    // Return (CR)
    case 160:
    // No-break space (NBSP)
    case 65279:
    // Byte Order Mark (BOM)
    case 8232:
    // Line Separator (LS)
    case 8233:
      return "w";
  }
  return "i";
}
function tC(t) {
  const e = t.trim();
  return t.charAt(0) === "0" && isNaN(parseInt(t)) ? !1 : Q_(e) ? Z_(e) : "*" + e;
}
function nC(t) {
  const e = [];
  let n = -1, r = 0, o = 0, a, i, s, l, u, c, d;
  const f = [];
  f[
    0
    /* Actions.APPEND */
  ] = () => {
    i === void 0 ? i = s : i += s;
  }, f[
    1
    /* Actions.PUSH */
  ] = () => {
    i !== void 0 && (e.push(i), i = void 0);
  }, f[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    f[
      0
      /* Actions.APPEND */
    ](), o++;
  }, f[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (o > 0)
      o--, r = 4, f[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (o = 0, i === void 0 || (i = tC(i), i === !1))
        return !1;
      f[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function h() {
    const m = t[n + 1];
    if (r === 5 && m === "'" || r === 6 && m === '"')
      return n++, s = "\\" + m, f[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; r !== null; )
    if (n++, a = t[n], !(a === "\\" && h())) {
      if (l = eC(a), d = ha[r], u = d[l] || d.l || 8, u === 8 || (r = u[0], u[1] !== void 0 && (c = f[u[1]], c && (s = a, c() === !1))))
        return;
      if (r === 7)
        return e;
    }
}
const Sm = /* @__PURE__ */ new Map();
function rC(t, e) {
  return gt(t) ? t[e] : null;
}
function oC(t, e) {
  if (!gt(t))
    return null;
  let n = Sm.get(e);
  if (n || (n = nC(e), n && Sm.set(e, n)), !n)
    return null;
  const r = n.length;
  let o = t, a = 0;
  for (; a < r; ) {
    const i = o[n[a]];
    if (i === void 0 || Ct(o))
      return null;
    o = i, a++;
  }
  return o;
}
const aC = (t) => t, iC = (t) => "", sC = "text", lC = (t) => t.length === 0 ? "" : g_(t), uC = m_;
function xm(t, e) {
  return t = Math.abs(t), e === 2 ? t ? t > 1 ? 1 : 0 : 1 : t ? Math.min(t, 2) : 0;
}
function cC(t) {
  const e = jt(t.pluralIndex) ? t.pluralIndex : -1;
  return t.named && (jt(t.named.count) || jt(t.named.n)) ? jt(t.named.count) ? t.named.count : jt(t.named.n) ? t.named.n : e : e;
}
function dC(t, e) {
  e.count || (e.count = t), e.n || (e.n = t);
}
function fC(t = {}) {
  const e = t.locale, n = cC(t), r = gt(t.pluralRules) && Ae(e) && Ct(t.pluralRules[e]) ? t.pluralRules[e] : xm, o = gt(t.pluralRules) && Ae(e) && Ct(t.pluralRules[e]) ? xm : void 0, a = (b) => b[r(n, b.length, o)], i = t.list || [], s = (b) => i[b], l = t.named || Et();
  jt(t.pluralIndex) && dC(n, l);
  const u = (b) => l[b];
  function c(b) {
    const C = Ct(t.messages) ? t.messages(b) : gt(t.messages) ? t.messages[b] : !1;
    return C || (t.parent ? t.parent.message(b) : iC);
  }
  const d = (b) => t.modifiers ? t.modifiers[b] : aC, f = Ze(t.processor) && Ct(t.processor.normalize) ? t.processor.normalize : lC, h = Ze(t.processor) && Ct(t.processor.interpolate) ? t.processor.interpolate : uC, m = Ze(t.processor) && Ae(t.processor.type) ? t.processor.type : sC, y = {
    list: s,
    named: u,
    plural: a,
    linked: (b, ...C) => {
      const [k, v] = C;
      let E = "text", _ = "";
      C.length === 1 ? gt(k) ? (_ = k.modifier || _, E = k.type || E) : Ae(k) && (_ = k || _) : C.length === 2 && (Ae(k) && (_ = k || _), Ae(v) && (E = v || E));
      const T = c(b)(y), M = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        E === "vnode" && xt(T) && _ ? T[0] : T
      );
      return _ ? d(_)(M, E) : M;
    },
    message: c,
    type: m,
    interpolate: h,
    normalize: f,
    values: gn(Et(), i, l)
  };
  return y;
}
let Gs = null;
function pC(t) {
  Gs = t;
}
function hC(t, e, n) {
  Gs && Gs.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: t,
    version: e,
    meta: n
  });
}
const mC = /* @__PURE__ */ gC(
  "function:translate"
  /* IntlifyDevToolsHooks.FunctionTranslate */
);
function gC(t) {
  return (e) => Gs && Gs.emit(t, e);
}
const Uy = Ec.__EXTEND_POINT__, Ta = Cc(Uy), In = {
  NOT_FOUND_KEY: Uy,
  // 2
  FALLBACK_TO_TRANSLATE: Ta(),
  // 3
  CANNOT_FORMAT_NUMBER: Ta(),
  // 4
  FALLBACK_TO_NUMBER_FORMAT: Ta(),
  // 5
  CANNOT_FORMAT_DATE: Ta(),
  // 6
  FALLBACK_TO_DATE_FORMAT: Ta(),
  // 7
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: Ta(),
  // 8
  __EXTEND_POINT__: Ta()
  // 9
}, vC = {
  [In.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [In.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [In.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [In.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [In.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [In.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [In.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function Ya(t, ...e) {
  return Tp(vC[t], ...e);
}
const Wy = Je.__EXTEND_POINT__, Sa = Cc(Wy), sn = {
  INVALID_ARGUMENT: Wy,
  // 17
  INVALID_DATE_ARGUMENT: Sa(),
  // 18
  INVALID_ISO_DATE_ARGUMENT: Sa(),
  // 19
  NOT_SUPPORT_NON_STRING_MESSAGE: Sa(),
  // 20
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: Sa(),
  // 21
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: Sa(),
  // 22
  NOT_SUPPORT_LOCALE_TYPE: Sa(),
  // 23
  __EXTEND_POINT__: Sa()
  // 24
};
function Yr(t) {
  return ls(t, null, process.env.NODE_ENV !== "production" ? { messages: yC } : void 0);
}
const yC = {
  [sn.INVALID_ARGUMENT]: "Invalid arguments",
  [sn.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [sn.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [sn.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [sn.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [sn.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [sn.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function Ap(t, e) {
  return e.locale != null ? Am(e.locale) : Am(t.locale);
}
let ld;
function Am(t) {
  if (Ae(t))
    return t;
  if (Ct(t)) {
    if (t.resolvedOnce && ld != null)
      return ld;
    if (t.constructor.name === "Function") {
      const e = t();
      if (h_(e))
        throw Yr(sn.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return ld = e;
    } else
      throw Yr(sn.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw Yr(sn.NOT_SUPPORT_LOCALE_TYPE);
}
function bC(t, e, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...xt(e) ? e : gt(e) ? Object.keys(e) : Ae(e) ? [e] : [n]
  ])];
}
function Ky(t, e, n) {
  const r = Ae(n) ? n : Vi, o = t;
  o.__localeChainCache || (o.__localeChainCache = /* @__PURE__ */ new Map());
  let a = o.__localeChainCache.get(r);
  if (!a) {
    a = [];
    let i = [n];
    for (; xt(i); )
      i = Mm(a, i, e);
    const s = xt(e) || !Ze(e) ? e : e.default ? e.default : null;
    i = Ae(s) ? [s] : s, xt(i) && Mm(a, i, !1), o.__localeChainCache.set(r, a);
  }
  return a;
}
function Mm(t, e, n) {
  let r = !0;
  for (let o = 0; o < e.length && dt(r); o++) {
    const a = e[o];
    Ae(a) && (r = kC(t, e[o], n));
  }
  return r;
}
function kC(t, e, n) {
  let r;
  const o = e.split("-");
  do {
    const a = o.join("-");
    r = wC(t, a, n), o.splice(-1, 1);
  } while (o.length && r === !0);
  return r;
}
function wC(t, e, n) {
  let r = !1;
  if (!t.includes(e) && (r = !0, e)) {
    r = e[e.length - 1] !== "!";
    const o = e.replace(/!/g, "");
    t.push(o), (xt(n) || Ze(n)) && n[o] && (r = n[o]);
  }
  return r;
}
const _C = "9.14.2", Oc = -1, Vi = "en-US", ku = "", Im = (t) => `${t.charAt(0).toLocaleUpperCase()}${t.substr(1)}`;
function CC() {
  return {
    upper: (t, e) => e === "text" && Ae(t) ? t.toUpperCase() : e === "vnode" && gt(t) && "__v_isVNode" in t ? t.children.toUpperCase() : t,
    lower: (t, e) => e === "text" && Ae(t) ? t.toLowerCase() : e === "vnode" && gt(t) && "__v_isVNode" in t ? t.children.toLowerCase() : t,
    capitalize: (t, e) => e === "text" && Ae(t) ? Im(t) : e === "vnode" && gt(t) && "__v_isVNode" in t ? Im(t.children) : t
  };
}
let jy;
function Dm(t) {
  jy = t;
}
let zy;
function EC(t) {
  zy = t;
}
let Yy;
function OC(t) {
  Yy = t;
}
let qy = null;
const TC = /* @__NO_SIDE_EFFECTS__ */ (t) => {
  qy = t;
}, SC = /* @__NO_SIDE_EFFECTS__ */ () => qy;
let Gy = null;
const Pm = (t) => {
  Gy = t;
}, xC = () => Gy;
let Nm = 0;
function AC(t = {}) {
  const e = Ct(t.onWarn) ? t.onWarn : Zt, n = Ae(t.version) ? t.version : _C, r = Ae(t.locale) || Ct(t.locale) ? t.locale : Vi, o = Ct(r) ? Vi : r, a = xt(t.fallbackLocale) || Ze(t.fallbackLocale) || Ae(t.fallbackLocale) || t.fallbackLocale === !1 ? t.fallbackLocale : o, i = Ze(t.messages) ? t.messages : ud(o), s = Ze(t.datetimeFormats) ? t.datetimeFormats : ud(o), l = Ze(t.numberFormats) ? t.numberFormats : ud(o), u = gn(Et(), t.modifiers, CC()), c = t.pluralRules || Et(), d = Ct(t.missing) ? t.missing : null, f = dt(t.missingWarn) || la(t.missingWarn) ? t.missingWarn : !0, h = dt(t.fallbackWarn) || la(t.fallbackWarn) ? t.fallbackWarn : !0, m = !!t.fallbackFormat, g = !!t.unresolving, y = Ct(t.postTranslation) ? t.postTranslation : null, b = Ze(t.processor) ? t.processor : null, C = dt(t.warnHtmlMessage) ? t.warnHtmlMessage : !0, k = !!t.escapeParameter, v = Ct(t.messageCompiler) ? t.messageCompiler : jy;
  process.env.NODE_ENV !== "production" && Ct(t.messageCompiler) && By(Ya(In.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const E = Ct(t.messageResolver) ? t.messageResolver : zy || rC, _ = Ct(t.localeFallbacker) ? t.localeFallbacker : Yy || bC, T = gt(t.fallbackContext) ? t.fallbackContext : void 0, M = t, O = gt(M.__datetimeFormatters) ? M.__datetimeFormatters : /* @__PURE__ */ new Map(), R = gt(M.__numberFormatters) ? M.__numberFormatters : /* @__PURE__ */ new Map(), N = gt(M.__meta) ? M.__meta : {};
  Nm++;
  const z = {
    version: n,
    cid: Nm,
    locale: r,
    fallbackLocale: a,
    messages: i,
    modifiers: u,
    pluralRules: c,
    missing: d,
    missingWarn: f,
    fallbackWarn: h,
    fallbackFormat: m,
    unresolving: g,
    postTranslation: y,
    processor: b,
    warnHtmlMessage: C,
    escapeParameter: k,
    messageCompiler: v,
    messageResolver: E,
    localeFallbacker: _,
    fallbackContext: T,
    onWarn: e,
    __meta: N
  };
  return z.datetimeFormats = s, z.numberFormats = l, z.__datetimeFormatters = O, z.__numberFormatters = R, process.env.NODE_ENV !== "production" && (z.__v_emitter = M.__v_emitter != null ? M.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && hC(z, n, N), z;
}
const ud = (t) => ({ [t]: Et() });
function Tc(t, e) {
  return t instanceof RegExp ? t.test(e) : t;
}
function Jy(t, e) {
  return t instanceof RegExp ? t.test(e) : t;
}
function Mp(t, e, n, r, o) {
  const { missing: a, onWarn: i } = t;
  if (process.env.NODE_ENV !== "production") {
    const s = t.__v_emitter;
    s && s.emit("missing", {
      locale: n,
      key: e,
      type: o,
      groupId: `${o}:${e}`
    });
  }
  if (a !== null) {
    const s = a(t, n, e, o);
    return Ae(s) ? s : e;
  } else
    return process.env.NODE_ENV !== "production" && Jy(r, e) && i(Ya(In.NOT_FOUND_KEY, { key: e, locale: n })), e;
}
function ws(t, e, n) {
  const r = t;
  r.__localeChainCache = /* @__PURE__ */ new Map(), t.localeFallbacker(t, n, e);
}
function Xy(t, e) {
  return t === e ? !1 : t.split("-")[0] === e.split("-")[0];
}
function MC(t, e) {
  const n = e.indexOf(t);
  if (n === -1)
    return !1;
  for (let r = n + 1; r < e.length; r++)
    if (Xy(t, e[r]))
      return !0;
  return !1;
}
function cd(t) {
  return (n) => IC(n, t);
}
function IC(t, e) {
  const n = PC(e);
  if (n == null)
    throw Js(
      0
      /* NodeTypes.Resource */
    );
  if (Ip(n) === 1) {
    const a = $C(n);
    return t.plural(a.reduce((i, s) => [
      ...i,
      $m(t, s)
    ], []));
  } else
    return $m(t, n);
}
const DC = ["b", "body"];
function PC(t) {
  return ma(t, DC);
}
const NC = ["c", "cases"];
function $C(t) {
  return ma(t, NC, []);
}
function $m(t, e) {
  const n = LC(e);
  if (n != null)
    return t.type === "text" ? n : t.normalize([n]);
  {
    const r = FC(e).reduce((o, a) => [...o, df(t, a)], []);
    return t.normalize(r);
  }
}
const RC = ["s", "static"];
function LC(t) {
  return ma(t, RC);
}
const BC = ["i", "items"];
function FC(t) {
  return ma(t, BC, []);
}
function df(t, e) {
  const n = Ip(e);
  switch (n) {
    case 3:
      return Kl(e, n);
    case 9:
      return Kl(e, n);
    case 4: {
      const r = e;
      if (xr(r, "k") && r.k)
        return t.interpolate(t.named(r.k));
      if (xr(r, "key") && r.key)
        return t.interpolate(t.named(r.key));
      throw Js(n);
    }
    case 5: {
      const r = e;
      if (xr(r, "i") && jt(r.i))
        return t.interpolate(t.list(r.i));
      if (xr(r, "index") && jt(r.index))
        return t.interpolate(t.list(r.index));
      throw Js(n);
    }
    case 6: {
      const r = e, o = WC(r), a = jC(r);
      return t.linked(df(t, a), o ? df(t, o) : void 0, t.type);
    }
    case 7:
      return Kl(e, n);
    case 8:
      return Kl(e, n);
    default:
      throw new Error(`unhandled node on format message part: ${n}`);
  }
}
const VC = ["t", "type"];
function Ip(t) {
  return ma(t, VC);
}
const HC = ["v", "value"];
function Kl(t, e) {
  const n = ma(t, HC);
  if (n)
    return n;
  throw Js(e);
}
const UC = ["m", "modifier"];
function WC(t) {
  return ma(t, UC);
}
const KC = ["k", "key"];
function jC(t) {
  const e = ma(t, KC);
  if (e)
    return e;
  throw Js(
    6
    /* NodeTypes.Linked */
  );
}
function ma(t, e, n) {
  for (let r = 0; r < e.length; r++) {
    const o = e[r];
    if (xr(t, o) && t[o] != null)
      return t[o];
  }
  return n;
}
function Js(t) {
  return new Error(`unhandled node type: ${t}`);
}
const zC = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function Qy(t, e) {
  e && T_(t) && Zt(Tp(zC, { source: t }));
}
const Zy = (t) => t;
let xi = Et();
function eb(t) {
  t.code === Ec.USE_MODULO_SYNTAX && Zt(`The use of named interpolation with modulo syntax is deprecated. It will be removed in v10.
reference: https://vue-i18n.intlify.dev/guide/essentials/syntax#rails-i18n-format 
(message compiler warning message: ${t.message})`);
}
function ua(t) {
  return gt(t) && Ip(t) === 0 && (xr(t, "b") || xr(t, "body"));
}
function tb(t, e = {}) {
  let n = !1;
  const r = e.onError || E_;
  return e.onError = (o) => {
    n = !0, r(o);
  }, { ...G_(t, e), detectError: n };
}
const YC = /* @__NO_SIDE_EFFECTS__ */ (t, e) => {
  if (!Ae(t))
    throw Yr(sn.NOT_SUPPORT_NON_STRING_MESSAGE);
  process.env.NODE_ENV !== "production" && (e.onWarn = eb);
  {
    const n = dt(e.warnHtmlMessage) ? e.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && Qy(t, n);
    const o = (e.onCacheKey || Zy)(t), a = xi[o];
    if (a)
      return a;
    const { code: i, detectError: s } = tb(t, e), l = new Function(`return ${i}`)();
    return s ? l : xi[o] = l;
  }
};
function qC(t, e) {
  if (process.env.NODE_ENV !== "production" && (e.onWarn = eb), __INTLIFY_JIT_COMPILATION__ && !__INTLIFY_DROP_MESSAGE_COMPILER__ && Ae(t)) {
    const n = dt(e.warnHtmlMessage) ? e.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && Qy(t, n);
    const o = (e.onCacheKey || Zy)(t), a = xi[o];
    if (a)
      return a;
    const { ast: i, detectError: s } = tb(t, {
      ...e,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), l = cd(i);
    return s ? l : xi[o] = l;
  } else {
    if (process.env.NODE_ENV !== "production" && !ua(t))
      return Zt(`the message that is resolve with key '${e.key}' is not supported for jit compilation`), () => t;
    const n = t.cacheKey;
    if (n) {
      const r = xi[n];
      return r || (xi[n] = cd(t));
    } else
      return cd(t);
  }
}
const Rm = () => "", ur = (t) => Ct(t);
function Lm(t, ...e) {
  const { fallbackFormat: n, postTranslation: r, unresolving: o, messageCompiler: a, fallbackLocale: i, messages: s } = t, [l, u] = ff(...e), c = dt(u.missingWarn) ? u.missingWarn : t.missingWarn, d = dt(u.fallbackWarn) ? u.fallbackWarn : t.fallbackWarn, f = dt(u.escapeParameter) ? u.escapeParameter : t.escapeParameter, h = !!u.resolvedMessage, m = Ae(u.default) || dt(u.default) ? dt(u.default) ? a ? l : () => l : u.default : n ? a ? l : () => l : "", g = n || m !== "", y = Ap(t, u);
  f && GC(u);
  let [b, C, k] = h ? [
    l,
    y,
    s[y] || Et()
  ] : nb(t, l, y, i, d, c), v = b, E = l;
  if (!h && !(Ae(v) || ua(v) || ur(v)) && g && (v = m, E = v), !h && (!(Ae(v) || ua(v) || ur(v)) || !Ae(C)))
    return o ? Oc : l;
  if (process.env.NODE_ENV !== "production" && Ae(v) && t.messageCompiler == null)
    return Zt(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${l}'.`), l;
  let _ = !1;
  const T = () => {
    _ = !0;
  }, M = ur(v) ? v : rb(t, l, C, v, E, T);
  if (_)
    return v;
  const O = ZC(t, C, k, u), R = fC(O), N = JC(t, M, R), z = r ? r(N, l) : N;
  if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const te = {
      timestamp: Date.now(),
      key: Ae(l) ? l : ur(v) ? v.key : "",
      locale: C || (ur(v) ? v.locale : ""),
      format: Ae(v) ? v : ur(v) ? v.source : "",
      message: z
    };
    te.meta = gn({}, t.__meta, /* @__PURE__ */ SC() || {}), mC(te);
  }
  return z;
}
function GC(t) {
  xt(t.list) ? t.list = t.list.map((e) => Ae(e) ? km(e) : e) : gt(t.named) && Object.keys(t.named).forEach((e) => {
    Ae(t.named[e]) && (t.named[e] = km(t.named[e]));
  });
}
function nb(t, e, n, r, o, a) {
  const { messages: i, onWarn: s, messageResolver: l, localeFallbacker: u } = t, c = u(t, r, n);
  let d = Et(), f, h = null, m = n, g = null;
  const y = "translate";
  for (let b = 0; b < c.length; b++) {
    if (f = g = c[b], process.env.NODE_ENV !== "production" && n !== f && !Xy(n, f) && Tc(o, e) && s(Ya(In.FALLBACK_TO_TRANSLATE, {
      key: e,
      target: f
    })), process.env.NODE_ENV !== "production" && n !== f) {
      const E = t.__v_emitter;
      E && E.emit("fallback", {
        type: y,
        key: e,
        from: m,
        to: g,
        groupId: `${y}:${e}`
      });
    }
    d = i[f] || Et();
    let C = null, k, v;
    if (process.env.NODE_ENV !== "production" && Ir && (C = window.performance.now(), k = "intlify-message-resolve-start", v = "intlify-message-resolve-end", Qn && Qn(k)), (h = l(d, e)) === null && (h = d[e]), process.env.NODE_ENV !== "production" && Ir) {
      const E = window.performance.now(), _ = t.__v_emitter;
      _ && C && h && _.emit("message-resolve", {
        type: "message-resolve",
        key: e,
        message: h,
        time: E - C,
        groupId: `${y}:${e}`
      }), k && v && Qn && za && (Qn(v), za("intlify message resolve", k, v));
    }
    if (Ae(h) || ua(h) || ur(h))
      break;
    if (!MC(f, c)) {
      const E = Mp(
        t,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        e,
        f,
        a,
        y
      );
      E !== e && (h = E);
    }
    m = g;
  }
  return [h, f, d];
}
function rb(t, e, n, r, o, a) {
  const { messageCompiler: i, warnHtmlMessage: s } = t;
  if (ur(r)) {
    const f = r;
    return f.locale = f.locale || n, f.key = f.key || e, f;
  }
  if (i == null) {
    const f = () => r;
    return f.locale = n, f.key = e, f;
  }
  let l = null, u, c;
  process.env.NODE_ENV !== "production" && Ir && (l = window.performance.now(), u = "intlify-message-compilation-start", c = "intlify-message-compilation-end", Qn && Qn(u));
  const d = i(r, XC(t, n, o, r, s, a));
  if (process.env.NODE_ENV !== "production" && Ir) {
    const f = window.performance.now(), h = t.__v_emitter;
    h && l && h.emit("message-compilation", {
      type: "message-compilation",
      message: r,
      time: f - l,
      groupId: `translate:${e}`
    }), u && c && Qn && za && (Qn(c), za("intlify message compilation", u, c));
  }
  return d.locale = n, d.key = e, d.source = r, d;
}
function JC(t, e, n) {
  let r = null, o, a;
  process.env.NODE_ENV !== "production" && Ir && (r = window.performance.now(), o = "intlify-message-evaluation-start", a = "intlify-message-evaluation-end", Qn && Qn(o));
  const i = e(n);
  if (process.env.NODE_ENV !== "production" && Ir) {
    const s = window.performance.now(), l = t.__v_emitter;
    l && r && l.emit("message-evaluation", {
      type: "message-evaluation",
      value: i,
      time: s - r,
      groupId: `translate:${e.key}`
    }), o && a && Qn && za && (Qn(a), za("intlify message evaluation", o, a));
  }
  return i;
}
function ff(...t) {
  const [e, n, r] = t, o = Et();
  if (!Ae(e) && !jt(e) && !ur(e) && !ua(e))
    throw Yr(sn.INVALID_ARGUMENT);
  const a = jt(e) ? String(e) : (ur(e), e);
  return jt(n) ? o.plural = n : Ae(n) ? o.default = n : Ze(n) && !_c(n) ? o.named = n : xt(n) && (o.list = n), jt(r) ? o.plural = r : Ae(r) ? o.default = r : Ze(r) && gn(o, r), [a, o];
}
function XC(t, e, n, r, o, a) {
  return {
    locale: e,
    key: n,
    warnHtmlMessage: o,
    onError: (i) => {
      if (a && a(i), process.env.NODE_ENV !== "production") {
        const s = QC(r), l = `Message compilation error: ${i.message}`, u = i.location && s && v_(s, i.location.start.offset, i.location.end.offset), c = t.__v_emitter;
        c && s && c.emit("compile-error", {
          message: s,
          error: i.message,
          start: i.location && i.location.start.offset,
          end: i.location && i.location.end.offset,
          groupId: `translate:${n}`
        }), console.error(u ? `${l}
${u}` : l);
      } else
        throw i;
    },
    onCacheKey: (i) => u_(e, n, i)
  };
}
function QC(t) {
  if (Ae(t))
    return t;
  if (t.loc && t.loc.source)
    return t.loc.source;
}
function ZC(t, e, n, r) {
  const { modifiers: o, pluralRules: a, messageResolver: i, fallbackLocale: s, fallbackWarn: l, missingWarn: u, fallbackContext: c } = t, f = {
    locale: e,
    modifiers: o,
    pluralRules: a,
    messages: (h) => {
      let m = i(n, h);
      if (m == null && c) {
        const [, , g] = nb(c, h, e, s, l, u);
        m = i(g, h);
      }
      if (Ae(m) || ua(m)) {
        let g = !1;
        const b = rb(t, h, e, m, h, () => {
          g = !0;
        });
        return g ? Rm : b;
      } else return ur(m) ? m : Rm;
    }
  };
  return t.processor && (f.processor = t.processor), r.list && (f.list = r.list), r.named && (f.named = r.named), jt(r.plural) && (f.pluralIndex = r.plural), f;
}
const Bm = typeof Intl < "u", ob = {
  dateTimeFormat: Bm && typeof Intl.DateTimeFormat < "u",
  numberFormat: Bm && typeof Intl.NumberFormat < "u"
};
function Fm(t, ...e) {
  const { datetimeFormats: n, unresolving: r, fallbackLocale: o, onWarn: a, localeFallbacker: i } = t, { __datetimeFormatters: s } = t;
  if (process.env.NODE_ENV !== "production" && !ob.dateTimeFormat)
    return a(Ya(In.CANNOT_FORMAT_DATE)), ku;
  const [l, u, c, d] = pf(...e), f = dt(c.missingWarn) ? c.missingWarn : t.missingWarn, h = dt(c.fallbackWarn) ? c.fallbackWarn : t.fallbackWarn, m = !!c.part, g = Ap(t, c), y = i(
    t,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    o,
    g
  );
  if (!Ae(l) || l === "")
    return new Intl.DateTimeFormat(g, d).format(u);
  let b = {}, C, k = null, v = g, E = null;
  const _ = "datetime format";
  for (let O = 0; O < y.length; O++) {
    if (C = E = y[O], process.env.NODE_ENV !== "production" && g !== C && Tc(h, l) && a(Ya(In.FALLBACK_TO_DATE_FORMAT, {
      key: l,
      target: C
    })), process.env.NODE_ENV !== "production" && g !== C) {
      const R = t.__v_emitter;
      R && R.emit("fallback", {
        type: _,
        key: l,
        from: v,
        to: E,
        groupId: `${_}:${l}`
      });
    }
    if (b = n[C] || {}, k = b[l], Ze(k))
      break;
    Mp(t, l, C, f, _), v = E;
  }
  if (!Ze(k) || !Ae(C))
    return r ? Oc : l;
  let T = `${C}__${l}`;
  _c(d) || (T = `${T}__${JSON.stringify(d)}`);
  let M = s.get(T);
  return M || (M = new Intl.DateTimeFormat(C, gn({}, k, d)), s.set(T, M)), m ? M.formatToParts(u) : M.format(u);
}
const ab = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function pf(...t) {
  const [e, n, r, o] = t, a = Et();
  let i = Et(), s;
  if (Ae(e)) {
    const l = e.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!l)
      throw Yr(sn.INVALID_ISO_DATE_ARGUMENT);
    const u = l[3] ? l[3].trim().startsWith("T") ? `${l[1].trim()}${l[3].trim()}` : `${l[1].trim()}T${l[3].trim()}` : l[1].trim();
    s = new Date(u);
    try {
      s.toISOString();
    } catch {
      throw Yr(sn.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (d_(e)) {
    if (isNaN(e.getTime()))
      throw Yr(sn.INVALID_DATE_ARGUMENT);
    s = e;
  } else if (jt(e))
    s = e;
  else
    throw Yr(sn.INVALID_ARGUMENT);
  return Ae(n) ? a.key = n : Ze(n) && Object.keys(n).forEach((l) => {
    ab.includes(l) ? i[l] = n[l] : a[l] = n[l];
  }), Ae(r) ? a.locale = r : Ze(r) && (i = r), Ze(o) && (i = o), [a.key || "", s, a, i];
}
function Vm(t, e, n) {
  const r = t;
  for (const o in n) {
    const a = `${e}__${o}`;
    r.__datetimeFormatters.has(a) && r.__datetimeFormatters.delete(a);
  }
}
function Hm(t, ...e) {
  const { numberFormats: n, unresolving: r, fallbackLocale: o, onWarn: a, localeFallbacker: i } = t, { __numberFormatters: s } = t;
  if (process.env.NODE_ENV !== "production" && !ob.numberFormat)
    return a(Ya(In.CANNOT_FORMAT_NUMBER)), ku;
  const [l, u, c, d] = hf(...e), f = dt(c.missingWarn) ? c.missingWarn : t.missingWarn, h = dt(c.fallbackWarn) ? c.fallbackWarn : t.fallbackWarn, m = !!c.part, g = Ap(t, c), y = i(
    t,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    o,
    g
  );
  if (!Ae(l) || l === "")
    return new Intl.NumberFormat(g, d).format(u);
  let b = {}, C, k = null, v = g, E = null;
  const _ = "number format";
  for (let O = 0; O < y.length; O++) {
    if (C = E = y[O], process.env.NODE_ENV !== "production" && g !== C && Tc(h, l) && a(Ya(In.FALLBACK_TO_NUMBER_FORMAT, {
      key: l,
      target: C
    })), process.env.NODE_ENV !== "production" && g !== C) {
      const R = t.__v_emitter;
      R && R.emit("fallback", {
        type: _,
        key: l,
        from: v,
        to: E,
        groupId: `${_}:${l}`
      });
    }
    if (b = n[C] || {}, k = b[l], Ze(k))
      break;
    Mp(t, l, C, f, _), v = E;
  }
  if (!Ze(k) || !Ae(C))
    return r ? Oc : l;
  let T = `${C}__${l}`;
  _c(d) || (T = `${T}__${JSON.stringify(d)}`);
  let M = s.get(T);
  return M || (M = new Intl.NumberFormat(C, gn({}, k, d)), s.set(T, M)), m ? M.formatToParts(u) : M.format(u);
}
const ib = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function hf(...t) {
  const [e, n, r, o] = t, a = Et();
  let i = Et();
  if (!jt(e))
    throw Yr(sn.INVALID_ARGUMENT);
  const s = e;
  return Ae(n) ? a.key = n : Ze(n) && Object.keys(n).forEach((l) => {
    ib.includes(l) ? i[l] = n[l] : a[l] = n[l];
  }), Ae(r) ? a.locale = r : Ze(r) && (i = r), Ze(o) && (i = o), [a.key || "", s, a, i];
}
function Um(t, e, n) {
  const r = t;
  for (const o in n) {
    const a = `${e}__${o}`;
    r.__numberFormatters.has(a) && r.__numberFormatters.delete(a);
  }
}
J_();
function eE() {
  return sb().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function sb() {
  return typeof navigator < "u" && typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : {};
}
const tE = typeof Proxy == "function", nE = "devtools-plugin:setup", rE = "plugin:settings:set";
let pi, mf;
function oE() {
  var t;
  return pi !== void 0 || (typeof window < "u" && window.performance ? (pi = !0, mf = window.performance) : typeof globalThis < "u" && (!((t = globalThis.perf_hooks) === null || t === void 0) && t.performance) ? (pi = !0, mf = globalThis.perf_hooks.performance) : pi = !1), pi;
}
function aE() {
  return oE() ? mf.now() : Date.now();
}
class iE {
  constructor(e, n) {
    this.target = null, this.targetQueue = [], this.onQueue = [], this.plugin = e, this.hook = n;
    const r = {};
    if (e.settings)
      for (const i in e.settings) {
        const s = e.settings[i];
        r[i] = s.defaultValue;
      }
    const o = `__vue-devtools-plugin-settings__${e.id}`;
    let a = Object.assign({}, r);
    try {
      const i = localStorage.getItem(o), s = JSON.parse(i);
      Object.assign(a, s);
    } catch {
    }
    this.fallbacks = {
      getSettings() {
        return a;
      },
      setSettings(i) {
        try {
          localStorage.setItem(o, JSON.stringify(i));
        } catch {
        }
        a = i;
      },
      now() {
        return aE();
      }
    }, n && n.on(rE, (i, s) => {
      i === this.plugin.id && this.fallbacks.setSettings(s);
    }), this.proxiedOn = new Proxy({}, {
      get: (i, s) => this.target ? this.target.on[s] : (...l) => {
        this.onQueue.push({
          method: s,
          args: l
        });
      }
    }), this.proxiedTarget = new Proxy({}, {
      get: (i, s) => this.target ? this.target[s] : s === "on" ? this.proxiedOn : Object.keys(this.fallbacks).includes(s) ? (...l) => (this.targetQueue.push({
        method: s,
        args: l,
        resolve: () => {
        }
      }), this.fallbacks[s](...l)) : (...l) => new Promise((u) => {
        this.targetQueue.push({
          method: s,
          args: l,
          resolve: u
        });
      })
    });
  }
  async setRealTarget(e) {
    this.target = e;
    for (const n of this.onQueue)
      this.target.on[n.method](...n.args);
    for (const n of this.targetQueue)
      n.resolve(await this.target[n.method](...n.args));
  }
}
function sE(t, e) {
  const n = t, r = sb(), o = eE(), a = tE && n.enableEarlyProxy;
  if (o && (r.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !a))
    o.emit(nE, t, e);
  else {
    const i = a ? new iE(n, o) : null;
    (r.__VUE_DEVTOOLS_PLUGINS__ = r.__VUE_DEVTOOLS_PLUGINS__ || []).push({
      pluginDescriptor: n,
      setupFn: e,
      proxy: i
    }), i && e(i.proxiedTarget);
  }
}
/*!
  * vue-i18n v9.14.2
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const lE = "9.14.2";
function uE() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (Oo().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (Oo().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_JIT_COMPILATION__ != "boolean" && (Oo().__INTLIFY_JIT_COMPILATION__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Oo().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Oo().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const lb = In.__EXTEND_POINT__, go = Cc(lb), Nt = {
  FALLBACK_TO_ROOT: lb,
  // 9
  NOT_SUPPORTED_PRESERVE: go(),
  // 10
  NOT_SUPPORTED_FORMATTER: go(),
  // 11
  NOT_SUPPORTED_PRESERVE_DIRECTIVE: go(),
  // 12
  NOT_SUPPORTED_GET_CHOICE_INDEX: go(),
  // 13
  COMPONENT_NAME_LEGACY_COMPATIBLE: go(),
  // 14
  NOT_FOUND_PARENT_SCOPE: go(),
  // 15
  IGNORE_OBJ_FLATTEN: go(),
  // 16
  NOTICE_DROP_ALLOW_COMPOSITION: go(),
  // 17
  NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG: go()
  // 18
}, cE = {
  [Nt.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [Nt.NOT_SUPPORTED_PRESERVE]: "Not supported 'preserve'.",
  [Nt.NOT_SUPPORTED_FORMATTER]: "Not supported 'formatter'.",
  [Nt.NOT_SUPPORTED_PRESERVE_DIRECTIVE]: "Not supported 'preserveDirectiveContent'.",
  [Nt.NOT_SUPPORTED_GET_CHOICE_INDEX]: "Not supported 'getChoiceIndex'.",
  [Nt.COMPONENT_NAME_LEGACY_COMPATIBLE]: "Component name legacy compatible: '{name}' -> 'i18n'",
  [Nt.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [Nt.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  [Nt.NOTICE_DROP_ALLOW_COMPOSITION]: "'allowComposition' option will be dropped in the next major version. For more information, please see 👉 https://tinyurl.com/2p97mcze",
  [Nt.NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG]: "'translateExistCompatible' option will be dropped in the next major version."
};
function Wn(t, ...e) {
  return Tp(cE[t], ...e);
}
const ub = sn.__EXTEND_POINT__, Vn = Cc(ub), vt = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: ub,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: Vn(),
  // 25
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: Vn(),
  // 26
  NOT_INSTALLED: Vn(),
  // 27
  NOT_AVAILABLE_IN_LEGACY_MODE: Vn(),
  // 28
  // directive module errors
  REQUIRED_VALUE: Vn(),
  // 29
  INVALID_VALUE: Vn(),
  // 30
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: Vn(),
  // 31
  NOT_INSTALLED_WITH_PROVIDE: Vn(),
  // 32
  // unexpected error
  UNEXPECTED_ERROR: Vn(),
  // 33
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: Vn(),
  // 34
  // bridge support vue 2.x only
  BRIDGE_SUPPORT_VUE_2_ONLY: Vn(),
  // 35
  // need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
  MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: Vn(),
  // 36
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: Vn(),
  // 37
  // for enhancement
  __EXTEND_POINT__: Vn()
  // 38
};
function tn(t, ...e) {
  return ls(t, null, process.env.NODE_ENV !== "production" ? { messages: dE, args: e } : void 0);
}
const dE = {
  [vt.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [vt.INVALID_ARGUMENT]: "Invalid argument",
  [vt.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [vt.NOT_INSTALLED]: "Need to install with `app.use` function",
  [vt.UNEXPECTED_ERROR]: "Unexpected error",
  [vt.NOT_AVAILABLE_IN_LEGACY_MODE]: "Not available in legacy mode",
  [vt.REQUIRED_VALUE]: "Required in value: {0}",
  [vt.INVALID_VALUE]: "Invalid value",
  [vt.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [vt.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [vt.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [vt.BRIDGE_SUPPORT_VUE_2_ONLY]: "vue-i18n-bridge support Vue 2.x only",
  [vt.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION]: "Must define ‘i18n’ option or custom block in Composition API with using local scope in Legacy API mode",
  [vt.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, gf = /* @__PURE__ */ co("__translateVNode"), vf = /* @__PURE__ */ co("__datetimeParts"), yf = /* @__PURE__ */ co("__numberParts"), qa = /* @__PURE__ */ co("__enableEmitter"), Xs = /* @__PURE__ */ co("__disableEmitter"), cb = co("__setPluralRules"), db = /* @__PURE__ */ co("__injectWithOption"), bf = /* @__PURE__ */ co("__dispose");
function Qs(t) {
  if (!gt(t))
    return t;
  for (const e in t)
    if (xr(t, e))
      if (!e.includes("."))
        gt(t[e]) && Qs(t[e]);
      else {
        const n = e.split("."), r = n.length - 1;
        let o = t, a = !1;
        for (let i = 0; i < r; i++) {
          if (n[i] in o || (o[n[i]] = Et()), !gt(o[n[i]])) {
            process.env.NODE_ENV !== "production" && Zt(Wn(Nt.IGNORE_OBJ_FLATTEN, {
              key: n[i]
            })), a = !0;
            break;
          }
          o = o[n[i]];
        }
        a || (o[n[r]] = t[e], delete t[e]), gt(o[n[r]]) && Qs(o[n[r]]);
      }
  return t;
}
function Sc(t, e) {
  const { messages: n, __i18n: r, messageResolver: o, flatJson: a } = e, i = Ze(n) ? n : xt(r) ? Et() : { [t]: Et() };
  if (xt(r) && r.forEach((s) => {
    if ("locale" in s && "resource" in s) {
      const { locale: l, resource: u } = s;
      l ? (i[l] = i[l] || Et(), du(u, i[l])) : du(u, i);
    } else
      Ae(s) && du(JSON.parse(s), i);
  }), o == null && a)
    for (const s in i)
      xr(i, s) && Qs(i[s]);
  return i;
}
function fb(t) {
  return t.type;
}
function pb(t, e, n) {
  let r = gt(e.messages) ? e.messages : Et();
  "__i18nGlobal" in n && (r = Sc(t.locale.value, {
    messages: r,
    __i18n: n.__i18nGlobal
  }));
  const o = Object.keys(r);
  o.length && o.forEach((a) => {
    t.mergeLocaleMessage(a, r[a]);
  });
  {
    if (gt(e.datetimeFormats)) {
      const a = Object.keys(e.datetimeFormats);
      a.length && a.forEach((i) => {
        t.mergeDateTimeFormat(i, e.datetimeFormats[i]);
      });
    }
    if (gt(e.numberFormats)) {
      const a = Object.keys(e.numberFormats);
      a.length && a.forEach((i) => {
        t.mergeNumberFormat(i, e.numberFormats[i]);
      });
    }
  }
}
function Wm(t) {
  return q(Q1, null, t, 0);
}
const Km = "__INTLIFY_META__", jm = () => [], fE = () => !1;
let zm = 0;
function Ym(t) {
  return (e, n, r, o) => t(n, r, Cn() || void 0, o);
}
const pE = /* @__NO_SIDE_EFFECTS__ */ () => {
  const t = Cn();
  let e = null;
  return t && (e = fb(t)[Km]) ? { [Km]: e } : null;
};
function Dp(t = {}, e) {
  const { __root: n, __injectWithOption: r } = t, o = n === void 0, a = t.flatJson, i = Ir ? F : ri, s = !!t.translateExistCompatible;
  process.env.NODE_ENV !== "production" && s && By(Wn(Nt.NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG));
  let l = dt(t.inheritLocale) ? t.inheritLocale : !0;
  const u = i(
    // prettier-ignore
    n && l ? n.locale.value : Ae(t.locale) ? t.locale : Vi
  ), c = i(
    // prettier-ignore
    n && l ? n.fallbackLocale.value : Ae(t.fallbackLocale) || xt(t.fallbackLocale) || Ze(t.fallbackLocale) || t.fallbackLocale === !1 ? t.fallbackLocale : u.value
  ), d = i(Sc(u.value, t)), f = i(Ze(t.datetimeFormats) ? t.datetimeFormats : { [u.value]: {} }), h = i(Ze(t.numberFormats) ? t.numberFormats : { [u.value]: {} });
  let m = n ? n.missingWarn : dt(t.missingWarn) || la(t.missingWarn) ? t.missingWarn : !0, g = n ? n.fallbackWarn : dt(t.fallbackWarn) || la(t.fallbackWarn) ? t.fallbackWarn : !0, y = n ? n.fallbackRoot : dt(t.fallbackRoot) ? t.fallbackRoot : !0, b = !!t.fallbackFormat, C = Ct(t.missing) ? t.missing : null, k = Ct(t.missing) ? Ym(t.missing) : null, v = Ct(t.postTranslation) ? t.postTranslation : null, E = n ? n.warnHtmlMessage : dt(t.warnHtmlMessage) ? t.warnHtmlMessage : !0, _ = !!t.escapeParameter;
  const T = n ? n.modifiers : Ze(t.modifiers) ? t.modifiers : {};
  let M = t.pluralRules || n && n.pluralRules, O;
  O = (() => {
    o && Pm(null);
    const ae = {
      version: lE,
      locale: u.value,
      fallbackLocale: c.value,
      messages: d.value,
      modifiers: T,
      pluralRules: M,
      missing: k === null ? void 0 : k,
      missingWarn: m,
      fallbackWarn: g,
      fallbackFormat: b,
      unresolving: !0,
      postTranslation: v === null ? void 0 : v,
      warnHtmlMessage: E,
      escapeParameter: _,
      messageResolver: t.messageResolver,
      messageCompiler: t.messageCompiler,
      __meta: { framework: "vue" }
    };
    ae.datetimeFormats = f.value, ae.numberFormats = h.value, ae.__datetimeFormatters = Ze(O) ? O.__datetimeFormatters : void 0, ae.__numberFormatters = Ze(O) ? O.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (ae.__v_emitter = Ze(O) ? O.__v_emitter : void 0);
    const ve = AC(ae);
    return o && Pm(ve), ve;
  })(), ws(O, u.value, c.value);
  function N() {
    return [
      u.value,
      c.value,
      d.value,
      f.value,
      h.value
    ];
  }
  const z = A({
    get: () => u.value,
    set: (ae) => {
      u.value = ae, O.locale = u.value;
    }
  }), te = A({
    get: () => c.value,
    set: (ae) => {
      c.value = ae, O.fallbackLocale = c.value, ws(O, u.value, ae);
    }
  }), H = A(() => d.value), U = /* @__PURE__ */ A(() => f.value), W = /* @__PURE__ */ A(() => h.value);
  function Q() {
    return Ct(v) ? v : null;
  }
  function de(ae) {
    v = ae, O.postTranslation = ae;
  }
  function re() {
    return C;
  }
  function J(ae) {
    ae !== null && (k = Ym(ae)), C = ae, O.missing = k;
  }
  function Ce(ae, ve) {
    return ae !== "translate" || !ve.resolvedMessage;
  }
  const ie = (ae, ve, pt, Ot, Sn, Fr) => {
    N();
    let or;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, o || (O.fallbackContext = n ? xC() : void 0), or = ae(O);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, o || (O.fallbackContext = void 0);
    }
    if (pt !== "translate exists" && // for not `te` (e.g `t`)
    jt(or) && or === Oc || pt === "translate exists" && !or) {
      const [ue, Re] = ve();
      if (process.env.NODE_ENV !== "production" && n && Ae(ue) && Ce(pt, Re) && (y && (Tc(g, ue) || Jy(m, ue)) && Zt(Wn(Nt.FALLBACK_TO_ROOT, {
        key: ue,
        type: pt
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: Ue } = O;
        Ue && y && Ue.emit("fallback", {
          type: pt,
          key: ue,
          to: "global",
          groupId: `${pt}:${ue}`
        });
      }
      return n && y ? Ot(n) : Sn(ue);
    } else {
      if (Fr(or))
        return or;
      throw tn(vt.UNEXPECTED_RETURN_TYPE);
    }
  };
  function ee(...ae) {
    return ie((ve) => Reflect.apply(Lm, null, [ve, ...ae]), () => ff(...ae), "translate", (ve) => Reflect.apply(ve.t, ve, [...ae]), (ve) => ve, (ve) => Ae(ve));
  }
  function D(...ae) {
    const [ve, pt, Ot] = ae;
    if (Ot && !gt(Ot))
      throw tn(vt.INVALID_ARGUMENT);
    return ee(ve, pt, gn({ resolvedMessage: !0 }, Ot || {}));
  }
  function G(...ae) {
    return ie((ve) => Reflect.apply(Fm, null, [ve, ...ae]), () => pf(...ae), "datetime format", (ve) => Reflect.apply(ve.d, ve, [...ae]), () => ku, (ve) => Ae(ve));
  }
  function fe(...ae) {
    return ie((ve) => Reflect.apply(Hm, null, [ve, ...ae]), () => hf(...ae), "number format", (ve) => Reflect.apply(ve.n, ve, [...ae]), () => ku, (ve) => Ae(ve));
  }
  function P(ae) {
    return ae.map((ve) => Ae(ve) || jt(ve) || dt(ve) ? Wm(String(ve)) : ve);
  }
  const ke = {
    normalize: P,
    interpolate: (ae) => ae,
    type: "vnode"
  };
  function Le(...ae) {
    return ie(
      (ve) => {
        let pt;
        const Ot = ve;
        try {
          Ot.processor = ke, pt = Reflect.apply(Lm, null, [Ot, ...ae]);
        } finally {
          Ot.processor = null;
        }
        return pt;
      },
      () => ff(...ae),
      "translate",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (ve) => ve[gf](...ae),
      (ve) => [Wm(ve)],
      (ve) => xt(ve)
    );
  }
  function ne(...ae) {
    return ie(
      (ve) => Reflect.apply(Hm, null, [ve, ...ae]),
      () => hf(...ae),
      "number format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (ve) => ve[yf](...ae),
      jm,
      (ve) => Ae(ve) || xt(ve)
    );
  }
  function ye(...ae) {
    return ie(
      (ve) => Reflect.apply(Fm, null, [ve, ...ae]),
      () => pf(...ae),
      "datetime format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (ve) => ve[vf](...ae),
      jm,
      (ve) => Ae(ve) || xt(ve)
    );
  }
  function pe(ae) {
    M = ae, O.pluralRules = M;
  }
  function Z(ae, ve) {
    return ie(() => {
      if (!ae)
        return !1;
      const pt = Ae(ve) ? ve : u.value, Ot = Ve(pt), Sn = O.messageResolver(Ot, ae);
      return s ? Sn != null : ua(Sn) || ur(Sn) || Ae(Sn);
    }, () => [ae], "translate exists", (pt) => Reflect.apply(pt.te, pt, [ae, ve]), fE, (pt) => dt(pt));
  }
  function B(ae) {
    let ve = null;
    const pt = Ky(O, c.value, u.value);
    for (let Ot = 0; Ot < pt.length; Ot++) {
      const Sn = d.value[pt[Ot]] || {}, Fr = O.messageResolver(Sn, ae);
      if (Fr != null) {
        ve = Fr;
        break;
      }
    }
    return ve;
  }
  function me(ae) {
    const ve = B(ae);
    return ve ?? (n ? n.tm(ae) || {} : {});
  }
  function Ve(ae) {
    return d.value[ae] || {};
  }
  function Ee(ae, ve) {
    if (a) {
      const pt = { [ae]: ve };
      for (const Ot in pt)
        xr(pt, Ot) && Qs(pt[Ot]);
      ve = pt[ae];
    }
    d.value[ae] = ve, O.messages = d.value;
  }
  function st(ae, ve) {
    d.value[ae] = d.value[ae] || {};
    const pt = { [ae]: ve };
    if (a)
      for (const Ot in pt)
        xr(pt, Ot) && Qs(pt[Ot]);
    ve = pt[ae], du(ve, d.value[ae]), O.messages = d.value;
  }
  function L(ae) {
    return f.value[ae] || {};
  }
  function x(ae, ve) {
    f.value[ae] = ve, O.datetimeFormats = f.value, Vm(O, ae, ve);
  }
  function Y(ae, ve) {
    f.value[ae] = gn(f.value[ae] || {}, ve), O.datetimeFormats = f.value, Vm(O, ae, ve);
  }
  function ge(ae) {
    return h.value[ae] || {};
  }
  function Ge(ae, ve) {
    h.value[ae] = ve, O.numberFormats = h.value, Um(O, ae, ve);
  }
  function rt(ae, ve) {
    h.value[ae] = gn(h.value[ae] || {}, ve), O.numberFormats = h.value, Um(O, ae, ve);
  }
  zm++, n && Ir && (Ke(n.locale, (ae) => {
    l && (u.value = ae, O.locale = ae, ws(O, u.value, c.value));
  }), Ke(n.fallbackLocale, (ae) => {
    l && (c.value = ae, O.fallbackLocale = ae, ws(O, u.value, c.value));
  }));
  const Te = {
    id: zm,
    locale: z,
    fallbackLocale: te,
    get inheritLocale() {
      return l;
    },
    set inheritLocale(ae) {
      l = ae, ae && n && (u.value = n.locale.value, c.value = n.fallbackLocale.value, ws(O, u.value, c.value));
    },
    get availableLocales() {
      return Object.keys(d.value).sort();
    },
    messages: H,
    get modifiers() {
      return T;
    },
    get pluralRules() {
      return M || {};
    },
    get isGlobal() {
      return o;
    },
    get missingWarn() {
      return m;
    },
    set missingWarn(ae) {
      m = ae, O.missingWarn = m;
    },
    get fallbackWarn() {
      return g;
    },
    set fallbackWarn(ae) {
      g = ae, O.fallbackWarn = g;
    },
    get fallbackRoot() {
      return y;
    },
    set fallbackRoot(ae) {
      y = ae;
    },
    get fallbackFormat() {
      return b;
    },
    set fallbackFormat(ae) {
      b = ae, O.fallbackFormat = b;
    },
    get warnHtmlMessage() {
      return E;
    },
    set warnHtmlMessage(ae) {
      E = ae, O.warnHtmlMessage = ae;
    },
    get escapeParameter() {
      return _;
    },
    set escapeParameter(ae) {
      _ = ae, O.escapeParameter = ae;
    },
    t: ee,
    getLocaleMessage: Ve,
    setLocaleMessage: Ee,
    mergeLocaleMessage: st,
    getPostTranslationHandler: Q,
    setPostTranslationHandler: de,
    getMissingHandler: re,
    setMissingHandler: J,
    [cb]: pe
  };
  return Te.datetimeFormats = U, Te.numberFormats = W, Te.rt = D, Te.te = Z, Te.tm = me, Te.d = G, Te.n = fe, Te.getDateTimeFormat = L, Te.setDateTimeFormat = x, Te.mergeDateTimeFormat = Y, Te.getNumberFormat = ge, Te.setNumberFormat = Ge, Te.mergeNumberFormat = rt, Te[db] = r, Te[gf] = Le, Te[vf] = ye, Te[yf] = ne, process.env.NODE_ENV !== "production" && (Te[qa] = (ae) => {
    O.__v_emitter = ae;
  }, Te[Xs] = () => {
    O.__v_emitter = void 0;
  }), Te;
}
function hE(t) {
  const e = Ae(t.locale) ? t.locale : Vi, n = Ae(t.fallbackLocale) || xt(t.fallbackLocale) || Ze(t.fallbackLocale) || t.fallbackLocale === !1 ? t.fallbackLocale : e, r = Ct(t.missing) ? t.missing : void 0, o = dt(t.silentTranslationWarn) || la(t.silentTranslationWarn) ? !t.silentTranslationWarn : !0, a = dt(t.silentFallbackWarn) || la(t.silentFallbackWarn) ? !t.silentFallbackWarn : !0, i = dt(t.fallbackRoot) ? t.fallbackRoot : !0, s = !!t.formatFallbackMessages, l = Ze(t.modifiers) ? t.modifiers : {}, u = t.pluralizationRules, c = Ct(t.postTranslation) ? t.postTranslation : void 0, d = Ae(t.warnHtmlInMessage) ? t.warnHtmlInMessage !== "off" : !0, f = !!t.escapeParameterHtml, h = dt(t.sync) ? t.sync : !0;
  process.env.NODE_ENV !== "production" && t.formatter && Zt(Wn(Nt.NOT_SUPPORTED_FORMATTER)), process.env.NODE_ENV !== "production" && t.preserveDirectiveContent && Zt(Wn(Nt.NOT_SUPPORTED_PRESERVE_DIRECTIVE));
  let m = t.messages;
  if (Ze(t.sharedMessages)) {
    const _ = t.sharedMessages;
    m = Object.keys(_).reduce((M, O) => {
      const R = M[O] || (M[O] = {});
      return gn(R, _[O]), M;
    }, m || {});
  }
  const { __i18n: g, __root: y, __injectWithOption: b } = t, C = t.datetimeFormats, k = t.numberFormats, v = t.flatJson, E = t.translateExistCompatible;
  return {
    locale: e,
    fallbackLocale: n,
    messages: m,
    flatJson: v,
    datetimeFormats: C,
    numberFormats: k,
    missing: r,
    missingWarn: o,
    fallbackWarn: a,
    fallbackRoot: i,
    fallbackFormat: s,
    modifiers: l,
    pluralRules: u,
    postTranslation: c,
    warnHtmlMessage: d,
    escapeParameter: f,
    messageResolver: t.messageResolver,
    inheritLocale: h,
    translateExistCompatible: E,
    __i18n: g,
    __root: y,
    __injectWithOption: b
  };
}
function kf(t = {}, e) {
  {
    const n = Dp(hE(t)), { __extender: r } = t, o = {
      // id
      id: n.id,
      // locale
      get locale() {
        return n.locale.value;
      },
      set locale(a) {
        n.locale.value = a;
      },
      // fallbackLocale
      get fallbackLocale() {
        return n.fallbackLocale.value;
      },
      set fallbackLocale(a) {
        n.fallbackLocale.value = a;
      },
      // messages
      get messages() {
        return n.messages.value;
      },
      // datetimeFormats
      get datetimeFormats() {
        return n.datetimeFormats.value;
      },
      // numberFormats
      get numberFormats() {
        return n.numberFormats.value;
      },
      // availableLocales
      get availableLocales() {
        return n.availableLocales;
      },
      // formatter
      get formatter() {
        return process.env.NODE_ENV !== "production" && Zt(Wn(Nt.NOT_SUPPORTED_FORMATTER)), {
          interpolate() {
            return [];
          }
        };
      },
      set formatter(a) {
        process.env.NODE_ENV !== "production" && Zt(Wn(Nt.NOT_SUPPORTED_FORMATTER));
      },
      // missing
      get missing() {
        return n.getMissingHandler();
      },
      set missing(a) {
        n.setMissingHandler(a);
      },
      // silentTranslationWarn
      get silentTranslationWarn() {
        return dt(n.missingWarn) ? !n.missingWarn : n.missingWarn;
      },
      set silentTranslationWarn(a) {
        n.missingWarn = dt(a) ? !a : a;
      },
      // silentFallbackWarn
      get silentFallbackWarn() {
        return dt(n.fallbackWarn) ? !n.fallbackWarn : n.fallbackWarn;
      },
      set silentFallbackWarn(a) {
        n.fallbackWarn = dt(a) ? !a : a;
      },
      // modifiers
      get modifiers() {
        return n.modifiers;
      },
      // formatFallbackMessages
      get formatFallbackMessages() {
        return n.fallbackFormat;
      },
      set formatFallbackMessages(a) {
        n.fallbackFormat = a;
      },
      // postTranslation
      get postTranslation() {
        return n.getPostTranslationHandler();
      },
      set postTranslation(a) {
        n.setPostTranslationHandler(a);
      },
      // sync
      get sync() {
        return n.inheritLocale;
      },
      set sync(a) {
        n.inheritLocale = a;
      },
      // warnInHtmlMessage
      get warnHtmlInMessage() {
        return n.warnHtmlMessage ? "warn" : "off";
      },
      set warnHtmlInMessage(a) {
        n.warnHtmlMessage = a !== "off";
      },
      // escapeParameterHtml
      get escapeParameterHtml() {
        return n.escapeParameter;
      },
      set escapeParameterHtml(a) {
        n.escapeParameter = a;
      },
      // preserveDirectiveContent
      get preserveDirectiveContent() {
        return process.env.NODE_ENV !== "production" && Zt(Wn(Nt.NOT_SUPPORTED_PRESERVE_DIRECTIVE)), !0;
      },
      set preserveDirectiveContent(a) {
        process.env.NODE_ENV !== "production" && Zt(Wn(Nt.NOT_SUPPORTED_PRESERVE_DIRECTIVE));
      },
      // pluralizationRules
      get pluralizationRules() {
        return n.pluralRules || {};
      },
      // for internal
      __composer: n,
      // t
      t(...a) {
        const [i, s, l] = a, u = {};
        let c = null, d = null;
        if (!Ae(i))
          throw tn(vt.INVALID_ARGUMENT);
        const f = i;
        return Ae(s) ? u.locale = s : xt(s) ? c = s : Ze(s) && (d = s), xt(l) ? c = l : Ze(l) && (d = l), Reflect.apply(n.t, n, [
          f,
          c || d || {},
          u
        ]);
      },
      rt(...a) {
        return Reflect.apply(n.rt, n, [...a]);
      },
      // tc
      tc(...a) {
        const [i, s, l] = a, u = { plural: 1 };
        let c = null, d = null;
        if (!Ae(i))
          throw tn(vt.INVALID_ARGUMENT);
        const f = i;
        return Ae(s) ? u.locale = s : jt(s) ? u.plural = s : xt(s) ? c = s : Ze(s) && (d = s), Ae(l) ? u.locale = l : xt(l) ? c = l : Ze(l) && (d = l), Reflect.apply(n.t, n, [
          f,
          c || d || {},
          u
        ]);
      },
      // te
      te(a, i) {
        return n.te(a, i);
      },
      // tm
      tm(a) {
        return n.tm(a);
      },
      // getLocaleMessage
      getLocaleMessage(a) {
        return n.getLocaleMessage(a);
      },
      // setLocaleMessage
      setLocaleMessage(a, i) {
        n.setLocaleMessage(a, i);
      },
      // mergeLocaleMessage
      mergeLocaleMessage(a, i) {
        n.mergeLocaleMessage(a, i);
      },
      // d
      d(...a) {
        return Reflect.apply(n.d, n, [...a]);
      },
      // getDateTimeFormat
      getDateTimeFormat(a) {
        return n.getDateTimeFormat(a);
      },
      // setDateTimeFormat
      setDateTimeFormat(a, i) {
        n.setDateTimeFormat(a, i);
      },
      // mergeDateTimeFormat
      mergeDateTimeFormat(a, i) {
        n.mergeDateTimeFormat(a, i);
      },
      // n
      n(...a) {
        return Reflect.apply(n.n, n, [...a]);
      },
      // getNumberFormat
      getNumberFormat(a) {
        return n.getNumberFormat(a);
      },
      // setNumberFormat
      setNumberFormat(a, i) {
        n.setNumberFormat(a, i);
      },
      // mergeNumberFormat
      mergeNumberFormat(a, i) {
        n.mergeNumberFormat(a, i);
      },
      // getChoiceIndex
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      getChoiceIndex(a, i) {
        return process.env.NODE_ENV !== "production" && Zt(Wn(Nt.NOT_SUPPORTED_GET_CHOICE_INDEX)), -1;
      }
    };
    return o.__extender = r, process.env.NODE_ENV !== "production" && (o.__enableEmitter = (a) => {
      const i = n;
      i[qa] && i[qa](a);
    }, o.__disableEmitter = () => {
      const a = n;
      a[Xs] && a[Xs]();
    }), o;
  }
}
const Pp = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (t) => t === "parent" || t === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function mE({ slots: t }, e) {
  return e.length === 1 && e[0] === "default" ? (t.default ? t.default() : []).reduce((r, o) => [
    ...r,
    // prettier-ignore
    ...o.type === Me ? o.children : [o]
  ], []) : e.reduce((n, r) => {
    const o = t[r];
    return o && (n[r] = o()), n;
  }, Et());
}
function hb(t) {
  return Me;
}
const gE = /* @__PURE__ */ j({
  /* eslint-disable */
  name: "i18n-t",
  props: gn({
    keypath: {
      type: String,
      required: !0
    },
    plural: {
      type: [Number, String],
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      validator: (t) => jt(t) || !isNaN(t)
    }
  }, Pp),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(t, e) {
    const { slots: n, attrs: r } = e, o = t.i18n || Mt({
      useScope: t.scope,
      __useComponent: !0
    });
    return () => {
      const a = Object.keys(n).filter((d) => d !== "_"), i = Et();
      t.locale && (i.locale = t.locale), t.plural !== void 0 && (i.plural = Ae(t.plural) ? +t.plural : t.plural);
      const s = mE(e, a), l = o[gf](t.keypath, s, i), u = gn(Et(), r), c = Ae(t.tag) || gt(t.tag) ? t.tag : hb();
      return Kn(c, u, l);
    };
  }
}), dd = gE;
function vE(t) {
  return xt(t) && !Ae(t[0]);
}
function mb(t, e, n, r) {
  const { slots: o, attrs: a } = e;
  return () => {
    const i = { part: !0 };
    let s = Et();
    t.locale && (i.locale = t.locale), Ae(t.format) ? i.key = t.format : gt(t.format) && (Ae(t.format.key) && (i.key = t.format.key), s = Object.keys(t.format).reduce((f, h) => n.includes(h) ? gn(Et(), f, { [h]: t.format[h] }) : f, Et()));
    const l = r(t.value, i, s);
    let u = [i.key];
    xt(l) ? u = l.map((f, h) => {
      const m = o[f.type], g = m ? m({ [f.type]: f.value, index: h, parts: l }) : [f.value];
      return vE(g) && (g[0].key = `${f.type}-${h}`), g;
    }) : Ae(l) && (u = [l]);
    const c = gn(Et(), a), d = Ae(t.tag) || gt(t.tag) ? t.tag : hb();
    return Kn(d, c, u);
  };
}
const yE = /* @__PURE__ */ j({
  /* eslint-disable */
  name: "i18n-n",
  props: gn({
    value: {
      type: Number,
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, Pp),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(t, e) {
    const n = t.i18n || Mt({
      useScope: t.scope,
      __useComponent: !0
    });
    return mb(t, e, ib, (...r) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      n[yf](...r)
    ));
  }
}), qm = yE, bE = /* @__PURE__ */ j({
  /* eslint-disable */
  name: "i18n-d",
  props: gn({
    value: {
      type: [Number, Date],
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, Pp),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(t, e) {
    const n = t.i18n || Mt({
      useScope: t.scope,
      __useComponent: !0
    });
    return mb(t, e, ab, (...r) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      n[vf](...r)
    ));
  }
}), Gm = bE;
function kE(t, e) {
  const n = t;
  if (t.mode === "composition")
    return n.__getInstance(e) || t.global;
  {
    const r = n.__getInstance(e);
    return r != null ? r.__composer : t.global.__composer;
  }
}
function wE(t) {
  const e = (i) => {
    const { instance: s, modifiers: l, value: u } = i;
    if (!s || !s.$)
      throw tn(vt.UNEXPECTED_ERROR);
    const c = kE(t, s.$);
    process.env.NODE_ENV !== "production" && l.preserve && Zt(Wn(Nt.NOT_SUPPORTED_PRESERVE));
    const d = Jm(u);
    return [
      Reflect.apply(c.t, c, [...Xm(d)]),
      c
    ];
  };
  return {
    created: (i, s) => {
      const [l, u] = e(s);
      Ir && t.global === u && (i.__i18nWatcher = Ke(u.locale, () => {
        s.instance && s.instance.$forceUpdate();
      })), i.__composer = u, i.textContent = l;
    },
    unmounted: (i) => {
      Ir && i.__i18nWatcher && (i.__i18nWatcher(), i.__i18nWatcher = void 0, delete i.__i18nWatcher), i.__composer && (i.__composer = void 0, delete i.__composer);
    },
    beforeUpdate: (i, { value: s }) => {
      if (i.__composer) {
        const l = i.__composer, u = Jm(s);
        i.textContent = Reflect.apply(l.t, l, [
          ...Xm(u)
        ]);
      }
    },
    getSSRProps: (i) => {
      const [s] = e(i);
      return { textContent: s };
    }
  };
}
function Jm(t) {
  if (Ae(t))
    return { path: t };
  if (Ze(t)) {
    if (!("path" in t))
      throw tn(vt.REQUIRED_VALUE, "path");
    return t;
  } else
    throw tn(vt.INVALID_VALUE);
}
function Xm(t) {
  const { path: e, locale: n, args: r, choice: o, plural: a } = t, i = {}, s = r || {};
  return Ae(n) && (i.locale = n), jt(o) && (i.plural = o), jt(a) && (i.plural = a), [e, s, i];
}
function _E(t, e, ...n) {
  const r = Ze(n[0]) ? n[0] : {}, o = !!r.useI18nComponentName, a = dt(r.globalInstall) ? r.globalInstall : !0;
  process.env.NODE_ENV !== "production" && a && o && Zt(Wn(Nt.COMPONENT_NAME_LEGACY_COMPATIBLE, {
    name: dd.name
  })), a && ([o ? "i18n" : dd.name, "I18nT"].forEach((i) => t.component(i, dd)), [qm.name, "I18nN"].forEach((i) => t.component(i, qm)), [Gm.name, "I18nD"].forEach((i) => t.component(i, Gm))), t.directive("t", wE(e));
}
const fd = {
  "vue-devtools-plugin-vue-i18n": "Vue I18n devtools",
  "vue-i18n-resource-inspector": "I18n Resources",
  "vue-i18n-timeline": "Vue I18n"
}, CE = {
  "vue-i18n-resource-inspector": "Search for scopes ..."
}, EE = {
  "vue-i18n-timeline": 16764185
}, gb = "vue-i18n: composer properties";
let wf;
async function OE(t, e) {
  return new Promise((n, r) => {
    try {
      sE({
        id: "vue-devtools-plugin-vue-i18n",
        label: fd[
          "vue-devtools-plugin-vue-i18n"
          /* VueDevToolsIDs.PLUGIN */
        ],
        packageName: "vue-i18n",
        homepage: "https://vue-i18n.intlify.dev",
        logo: "https://vue-i18n.intlify.dev/vue-i18n-devtools-logo.png",
        componentStateTypes: [gb],
        app: t
        // eslint-disable-line @typescript-eslint/no-explicit-any
      }, (o) => {
        wf = o, o.on.visitComponentTree(({ componentInstance: i, treeNode: s }) => {
          TE(i, s, e);
        }), o.on.inspectComponent(({ componentInstance: i, instanceData: s }) => {
          i.vnode.el && i.vnode.el.__VUE_I18N__ && s && (e.mode === "legacy" ? i.vnode.el.__VUE_I18N__ !== e.global.__composer && Qm(s, i.vnode.el.__VUE_I18N__) : Qm(s, i.vnode.el.__VUE_I18N__));
        }), o.addInspector({
          id: "vue-i18n-resource-inspector",
          label: fd[
            "vue-i18n-resource-inspector"
            /* VueDevToolsIDs.CUSTOM_INSPECTOR */
          ],
          icon: "language",
          treeFilterPlaceholder: CE[
            "vue-i18n-resource-inspector"
            /* VueDevToolsIDs.CUSTOM_INSPECTOR */
          ]
        }), o.on.getInspectorTree((i) => {
          i.app === t && i.inspectorId === "vue-i18n-resource-inspector" && IE(i, e);
        });
        const a = /* @__PURE__ */ new Map();
        o.on.getInspectorState(async (i) => {
          if (i.app === t && i.inspectorId === "vue-i18n-resource-inspector")
            if (o.unhighlightElement(), PE(i, e), i.nodeId === "global") {
              if (!a.has(i.app)) {
                const [s] = await o.getComponentInstances(i.app);
                a.set(i.app, s);
              }
              o.highlightElement(a.get(i.app));
            } else {
              const s = DE(i.nodeId, e);
              s && o.highlightElement(s);
            }
        }), o.on.editInspectorState((i) => {
          i.app === t && i.inspectorId === "vue-i18n-resource-inspector" && $E(i, e);
        }), o.addTimelineLayer({
          id: "vue-i18n-timeline",
          label: fd[
            "vue-i18n-timeline"
            /* VueDevToolsIDs.TIMELINE */
          ],
          color: EE[
            "vue-i18n-timeline"
            /* VueDevToolsIDs.TIMELINE */
          ]
        }), n(!0);
      });
    } catch (o) {
      console.error(o), r(!1);
    }
  });
}
function vb(t) {
  return t.type.name || t.type.displayName || t.type.__file || "Anonymous";
}
function TE(t, e, n) {
  const r = n.mode === "composition" ? n.global : n.global.__composer;
  if (t && t.vnode.el && t.vnode.el.__VUE_I18N__ && t.vnode.el.__VUE_I18N__ !== r) {
    const o = {
      label: `i18n (${vb(t)} Scope)`,
      textColor: 0,
      backgroundColor: 16764185
    };
    e.tags.push(o);
  }
}
function Qm(t, e) {
  const n = gb;
  t.state.push({
    type: n,
    key: "locale",
    editable: !0,
    value: e.locale.value
  }), t.state.push({
    type: n,
    key: "availableLocales",
    editable: !1,
    value: e.availableLocales
  }), t.state.push({
    type: n,
    key: "fallbackLocale",
    editable: !0,
    value: e.fallbackLocale.value
  }), t.state.push({
    type: n,
    key: "inheritLocale",
    editable: !0,
    value: e.inheritLocale
  }), t.state.push({
    type: n,
    key: "messages",
    editable: !1,
    value: Np(e.messages.value)
  }), t.state.push({
    type: n,
    key: "datetimeFormats",
    editable: !1,
    value: e.datetimeFormats.value
  }), t.state.push({
    type: n,
    key: "numberFormats",
    editable: !1,
    value: e.numberFormats.value
  });
}
function Np(t) {
  const e = {};
  return Object.keys(t).forEach((n) => {
    const r = t[n];
    Ct(r) && "source" in r ? e[n] = ME(r) : ua(r) && r.loc && r.loc.source ? e[n] = r.loc.source : gt(r) ? e[n] = Np(r) : e[n] = r;
  }), e;
}
const SE = {
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "&": "&amp;"
};
function xE(t) {
  return t.replace(/[<>"&]/g, AE);
}
function AE(t) {
  return SE[t] || t;
}
function ME(t) {
  return {
    _custom: {
      type: "function",
      display: `<span>ƒ</span> ${t.source ? `("${xE(t.source)}")` : "(?)"}`
    }
  };
}
function IE(t, e) {
  t.rootNodes.push({
    id: "global",
    label: "Global Scope"
  });
  const n = e.mode === "composition" ? e.global : e.global.__composer;
  for (const [r, o] of e.__instances) {
    const a = e.mode === "composition" ? o : o.__composer;
    n !== a && t.rootNodes.push({
      id: a.id.toString(),
      label: `${vb(r)} Scope`
    });
  }
}
function DE(t, e) {
  let n = null;
  if (t !== "global") {
    for (const [r, o] of e.__instances.entries())
      if (o.id.toString() === t) {
        n = r;
        break;
      }
  }
  return n;
}
function yb(t, e) {
  if (t === "global")
    return e.mode === "composition" ? e.global : e.global.__composer;
  {
    const n = Array.from(e.__instances.values()).find((r) => r.id.toString() === t);
    return n ? e.mode === "composition" ? n : n.__composer : null;
  }
}
function PE(t, e) {
  const n = yb(t.nodeId, e);
  return n && (t.state = NE(n)), null;
}
function NE(t) {
  const e = {}, n = "Locale related info", r = [
    {
      type: n,
      key: "locale",
      editable: !0,
      value: t.locale.value
    },
    {
      type: n,
      key: "fallbackLocale",
      editable: !0,
      value: t.fallbackLocale.value
    },
    {
      type: n,
      key: "availableLocales",
      editable: !1,
      value: t.availableLocales
    },
    {
      type: n,
      key: "inheritLocale",
      editable: !0,
      value: t.inheritLocale
    }
  ];
  e[n] = r;
  const o = "Locale messages info", a = [
    {
      type: o,
      key: "messages",
      editable: !1,
      value: Np(t.messages.value)
    }
  ];
  e[o] = a;
  {
    const i = "Datetime formats info", s = [
      {
        type: i,
        key: "datetimeFormats",
        editable: !1,
        value: t.datetimeFormats.value
      }
    ];
    e[i] = s;
    const l = "Datetime formats info", u = [
      {
        type: l,
        key: "numberFormats",
        editable: !1,
        value: t.numberFormats.value
      }
    ];
    e[l] = u;
  }
  return e;
}
function Zs(t, e) {
  if (wf) {
    let n;
    e && "groupId" in e && (n = e.groupId, delete e.groupId), wf.addTimelineEvent({
      layerId: "vue-i18n-timeline",
      event: {
        title: t,
        groupId: n,
        time: Date.now(),
        meta: {},
        data: e || {},
        logType: t === "compile-error" ? "error" : t === "fallback" || t === "missing" ? "warning" : "default"
      }
    });
  }
}
function $E(t, e) {
  const n = yb(t.nodeId, e);
  if (n) {
    const [r] = t.path;
    r === "locale" && Ae(t.state.value) ? n.locale.value = t.state.value : r === "fallbackLocale" && (Ae(t.state.value) || xt(t.state.value) || gt(t.state.value)) ? n.fallbackLocale.value = t.state.value : r === "inheritLocale" && dt(t.state.value) && (n.inheritLocale = t.state.value);
  }
}
function RE(t, e, n) {
  return {
    beforeCreate() {
      const r = Cn();
      if (!r)
        throw tn(vt.UNEXPECTED_ERROR);
      const o = this.$options;
      if (o.i18n) {
        const a = o.i18n;
        if (o.__i18n && (a.__i18n = o.__i18n), a.__root = e, this === this.$root)
          this.$i18n = Zm(t, a);
        else {
          a.__injectWithOption = !0, a.__extender = n.__vueI18nExtend, this.$i18n = kf(a);
          const i = this.$i18n;
          i.__extender && (i.__disposer = i.__extender(this.$i18n));
        }
      } else if (o.__i18n)
        if (this === this.$root)
          this.$i18n = Zm(t, o);
        else {
          this.$i18n = kf({
            __i18n: o.__i18n,
            __injectWithOption: !0,
            __extender: n.__vueI18nExtend,
            __root: e
          });
          const a = this.$i18n;
          a.__extender && (a.__disposer = a.__extender(this.$i18n));
        }
      else
        this.$i18n = t;
      o.__i18nGlobal && pb(e, o, o), this.$t = (...a) => this.$i18n.t(...a), this.$rt = (...a) => this.$i18n.rt(...a), this.$tc = (...a) => this.$i18n.tc(...a), this.$te = (a, i) => this.$i18n.te(a, i), this.$d = (...a) => this.$i18n.d(...a), this.$n = (...a) => this.$i18n.n(...a), this.$tm = (a) => this.$i18n.tm(a), n.__setInstance(r, this.$i18n);
    },
    mounted() {
      if (process.env.NODE_ENV !== "production" && this.$el && this.$i18n) {
        const r = this.$i18n;
        this.$el.__VUE_I18N__ = r.__composer;
        const o = this.__v_emitter = Sp();
        r.__enableEmitter && r.__enableEmitter(o), o.on("*", Zs);
      }
    },
    unmounted() {
      const r = Cn();
      if (!r)
        throw tn(vt.UNEXPECTED_ERROR);
      const o = this.$i18n;
      process.env.NODE_ENV !== "production" && this.$el && this.$el.__VUE_I18N__ && (this.__v_emitter && (this.__v_emitter.off("*", Zs), delete this.__v_emitter), this.$i18n && (o.__disableEmitter && o.__disableEmitter(), delete this.$el.__VUE_I18N__)), delete this.$t, delete this.$rt, delete this.$tc, delete this.$te, delete this.$d, delete this.$n, delete this.$tm, o.__disposer && (o.__disposer(), delete o.__disposer, delete o.__extender), n.__deleteInstance(r), delete this.$i18n;
    }
  };
}
function Zm(t, e) {
  t.locale = e.locale || t.locale, t.fallbackLocale = e.fallbackLocale || t.fallbackLocale, t.missing = e.missing || t.missing, t.silentTranslationWarn = e.silentTranslationWarn || t.silentFallbackWarn, t.silentFallbackWarn = e.silentFallbackWarn || t.silentFallbackWarn, t.formatFallbackMessages = e.formatFallbackMessages || t.formatFallbackMessages, t.postTranslation = e.postTranslation || t.postTranslation, t.warnHtmlInMessage = e.warnHtmlInMessage || t.warnHtmlInMessage, t.escapeParameterHtml = e.escapeParameterHtml || t.escapeParameterHtml, t.sync = e.sync || t.sync, t.__composer[cb](e.pluralizationRules || t.pluralizationRules);
  const n = Sc(t.locale, {
    messages: e.messages,
    __i18n: e.__i18n
  });
  return Object.keys(n).forEach((r) => t.mergeLocaleMessage(r, n[r])), e.datetimeFormats && Object.keys(e.datetimeFormats).forEach((r) => t.mergeDateTimeFormat(r, e.datetimeFormats[r])), e.numberFormats && Object.keys(e.numberFormats).forEach((r) => t.mergeNumberFormat(r, e.numberFormats[r])), t;
}
const LE = /* @__PURE__ */ co("global-vue-i18n");
function BE(t = {}, e) {
  const n = __VUE_I18N_LEGACY_API__ && dt(t.legacy) ? t.legacy : __VUE_I18N_LEGACY_API__, r = dt(t.globalInjection) ? t.globalInjection : !0, o = __VUE_I18N_LEGACY_API__ && n ? !!t.allowComposition : !0, a = /* @__PURE__ */ new Map(), [i, s] = FE(t, n), l = /* @__PURE__ */ co(process.env.NODE_ENV !== "production" ? "vue-i18n" : "");
  process.env.NODE_ENV !== "production" && n && o && Zt(Wn(Nt.NOTICE_DROP_ALLOW_COMPOSITION));
  function u(f) {
    return a.get(f) || null;
  }
  function c(f, h) {
    a.set(f, h);
  }
  function d(f) {
    a.delete(f);
  }
  {
    const f = {
      // mode
      get mode() {
        return __VUE_I18N_LEGACY_API__ && n ? "legacy" : "composition";
      },
      // allowComposition
      get allowComposition() {
        return o;
      },
      // install plugin
      async install(h, ...m) {
        if (process.env.NODE_ENV !== "production" && (h.__VUE_I18N__ = f), h.__VUE_I18N_SYMBOL__ = l, h.provide(h.__VUE_I18N_SYMBOL__, f), Ze(m[0])) {
          const b = m[0];
          f.__composerExtend = b.__composerExtend, f.__vueI18nExtend = b.__vueI18nExtend;
        }
        let g = null;
        !n && r && (g = qE(h, f.global)), __VUE_I18N_FULL_INSTALL__ && _E(h, f, ...m), __VUE_I18N_LEGACY_API__ && n && h.mixin(RE(s, s.__composer, f));
        const y = h.unmount;
        if (h.unmount = () => {
          g && g(), f.dispose(), y();
        }, process.env.NODE_ENV !== "production") {
          if (!await OE(h, f))
            throw tn(vt.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN);
          const C = Sp();
          if (n) {
            const k = s;
            k.__enableEmitter && k.__enableEmitter(C);
          } else {
            const k = s;
            k[qa] && k[qa](C);
          }
          C.on("*", Zs);
        }
      },
      // global accessor
      get global() {
        return s;
      },
      dispose() {
        i.stop();
      },
      // @internal
      __instances: a,
      // @internal
      __getInstance: u,
      // @internal
      __setInstance: c,
      // @internal
      __deleteInstance: d
    };
    return f;
  }
}
function Mt(t = {}) {
  const e = Cn();
  if (e == null)
    throw tn(vt.MUST_BE_CALL_SETUP_TOP);
  if (!e.isCE && e.appContext.app != null && !e.appContext.app.__VUE_I18N_SYMBOL__)
    throw tn(vt.NOT_INSTALLED);
  const n = VE(e), r = UE(n), o = fb(e), a = HE(t, o);
  if (__VUE_I18N_LEGACY_API__ && n.mode === "legacy" && !t.__useComponent) {
    if (!n.allowComposition)
      throw tn(vt.NOT_AVAILABLE_IN_LEGACY_MODE);
    return zE(e, a, r, t);
  }
  if (a === "global")
    return pb(r, t, o), r;
  if (a === "parent") {
    let l = WE(n, e, t.__useComponent);
    return l == null && (process.env.NODE_ENV !== "production" && Zt(Wn(Nt.NOT_FOUND_PARENT_SCOPE)), l = r), l;
  }
  const i = n;
  let s = i.__getInstance(e);
  if (s == null) {
    const l = gn({}, t);
    "__i18n" in o && (l.__i18n = o.__i18n), r && (l.__root = r), s = Dp(l), i.__composerExtend && (s[bf] = i.__composerExtend(s)), jE(i, e, s), i.__setInstance(e, s);
  }
  return s;
}
function FE(t, e, n) {
  const r = Cp();
  {
    const o = __VUE_I18N_LEGACY_API__ && e ? r.run(() => kf(t)) : r.run(() => Dp(t));
    if (o == null)
      throw tn(vt.UNEXPECTED_ERROR);
    return [r, o];
  }
}
function VE(t) {
  {
    const e = yc(t.isCE ? LE : t.appContext.app.__VUE_I18N_SYMBOL__);
    if (!e)
      throw tn(t.isCE ? vt.NOT_INSTALLED_WITH_PROVIDE : vt.UNEXPECTED_ERROR);
    return e;
  }
}
function HE(t, e) {
  return _c(t) ? "__i18n" in e ? "local" : "global" : t.useScope ? t.useScope : "local";
}
function UE(t) {
  return t.mode === "composition" ? t.global : t.global.__composer;
}
function WE(t, e, n = !1) {
  let r = null;
  const o = e.root;
  let a = KE(e, n);
  for (; a != null; ) {
    const i = t;
    if (t.mode === "composition")
      r = i.__getInstance(a);
    else if (__VUE_I18N_LEGACY_API__) {
      const s = i.__getInstance(a);
      s != null && (r = s.__composer, n && r && !r[db] && (r = null));
    }
    if (r != null || o === a)
      break;
    a = a.parent;
  }
  return r;
}
function KE(t, e = !1) {
  return t == null ? null : e && t.vnode.ctx || t.parent;
}
function jE(t, e, n) {
  let r = null;
  ze(() => {
    if (process.env.NODE_ENV !== "production" && e.vnode.el) {
      e.vnode.el.__VUE_I18N__ = n, r = Sp();
      const o = n;
      o[qa] && o[qa](r), r.on("*", Zs);
    }
  }, e), En(() => {
    const o = n;
    process.env.NODE_ENV !== "production" && e.vnode.el && e.vnode.el.__VUE_I18N__ && (r && r.off("*", Zs), o[Xs] && o[Xs](), delete e.vnode.el.__VUE_I18N__), t.__deleteInstance(e);
    const a = o[bf];
    a && (a(), delete o[bf]);
  }, e);
}
function zE(t, e, n, r = {}) {
  const o = e === "local", a = ri(null);
  if (o && t.proxy && !(t.proxy.$options.i18n || t.proxy.$options.__i18n))
    throw tn(vt.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION);
  const i = dt(r.inheritLocale) ? r.inheritLocale : !Ae(r.locale), s = F(
    // prettier-ignore
    !o || i ? n.locale.value : Ae(r.locale) ? r.locale : Vi
  ), l = F(
    // prettier-ignore
    !o || i ? n.fallbackLocale.value : Ae(r.fallbackLocale) || xt(r.fallbackLocale) || Ze(r.fallbackLocale) || r.fallbackLocale === !1 ? r.fallbackLocale : s.value
  ), u = F(Sc(s.value, r)), c = F(Ze(r.datetimeFormats) ? r.datetimeFormats : { [s.value]: {} }), d = F(Ze(r.numberFormats) ? r.numberFormats : { [s.value]: {} }), f = o ? n.missingWarn : dt(r.missingWarn) || la(r.missingWarn) ? r.missingWarn : !0, h = o ? n.fallbackWarn : dt(r.fallbackWarn) || la(r.fallbackWarn) ? r.fallbackWarn : !0, m = o ? n.fallbackRoot : dt(r.fallbackRoot) ? r.fallbackRoot : !0, g = !!r.fallbackFormat, y = Ct(r.missing) ? r.missing : null, b = Ct(r.postTranslation) ? r.postTranslation : null, C = o ? n.warnHtmlMessage : dt(r.warnHtmlMessage) ? r.warnHtmlMessage : !0, k = !!r.escapeParameter, v = o ? n.modifiers : Ze(r.modifiers) ? r.modifiers : {}, E = r.pluralRules || o && n.pluralRules;
  function _() {
    return [
      s.value,
      l.value,
      u.value,
      c.value,
      d.value
    ];
  }
  const T = A({
    get: () => a.value ? a.value.locale.value : s.value,
    set: (Z) => {
      a.value && (a.value.locale.value = Z), s.value = Z;
    }
  }), M = A({
    get: () => a.value ? a.value.fallbackLocale.value : l.value,
    set: (Z) => {
      a.value && (a.value.fallbackLocale.value = Z), l.value = Z;
    }
  }), O = A(() => a.value ? a.value.messages.value : u.value), R = A(() => c.value), N = A(() => d.value);
  function z() {
    return a.value ? a.value.getPostTranslationHandler() : b;
  }
  function te(Z) {
    a.value && a.value.setPostTranslationHandler(Z);
  }
  function H() {
    return a.value ? a.value.getMissingHandler() : y;
  }
  function U(Z) {
    a.value && a.value.setMissingHandler(Z);
  }
  function W(Z) {
    return _(), Z();
  }
  function Q(...Z) {
    return a.value ? W(() => Reflect.apply(a.value.t, null, [...Z])) : W(() => "");
  }
  function de(...Z) {
    return a.value ? Reflect.apply(a.value.rt, null, [...Z]) : "";
  }
  function re(...Z) {
    return a.value ? W(() => Reflect.apply(a.value.d, null, [...Z])) : W(() => "");
  }
  function J(...Z) {
    return a.value ? W(() => Reflect.apply(a.value.n, null, [...Z])) : W(() => "");
  }
  function Ce(Z) {
    return a.value ? a.value.tm(Z) : {};
  }
  function ie(Z, B) {
    return a.value ? a.value.te(Z, B) : !1;
  }
  function ee(Z) {
    return a.value ? a.value.getLocaleMessage(Z) : {};
  }
  function D(Z, B) {
    a.value && (a.value.setLocaleMessage(Z, B), u.value[Z] = B);
  }
  function G(Z, B) {
    a.value && a.value.mergeLocaleMessage(Z, B);
  }
  function fe(Z) {
    return a.value ? a.value.getDateTimeFormat(Z) : {};
  }
  function P(Z, B) {
    a.value && (a.value.setDateTimeFormat(Z, B), c.value[Z] = B);
  }
  function se(Z, B) {
    a.value && a.value.mergeDateTimeFormat(Z, B);
  }
  function ke(Z) {
    return a.value ? a.value.getNumberFormat(Z) : {};
  }
  function Le(Z, B) {
    a.value && (a.value.setNumberFormat(Z, B), d.value[Z] = B);
  }
  function ne(Z, B) {
    a.value && a.value.mergeNumberFormat(Z, B);
  }
  const ye = {
    get id() {
      return a.value ? a.value.id : -1;
    },
    locale: T,
    fallbackLocale: M,
    messages: O,
    datetimeFormats: R,
    numberFormats: N,
    get inheritLocale() {
      return a.value ? a.value.inheritLocale : i;
    },
    set inheritLocale(Z) {
      a.value && (a.value.inheritLocale = Z);
    },
    get availableLocales() {
      return a.value ? a.value.availableLocales : Object.keys(u.value);
    },
    get modifiers() {
      return a.value ? a.value.modifiers : v;
    },
    get pluralRules() {
      return a.value ? a.value.pluralRules : E;
    },
    get isGlobal() {
      return a.value ? a.value.isGlobal : !1;
    },
    get missingWarn() {
      return a.value ? a.value.missingWarn : f;
    },
    set missingWarn(Z) {
      a.value && (a.value.missingWarn = Z);
    },
    get fallbackWarn() {
      return a.value ? a.value.fallbackWarn : h;
    },
    set fallbackWarn(Z) {
      a.value && (a.value.missingWarn = Z);
    },
    get fallbackRoot() {
      return a.value ? a.value.fallbackRoot : m;
    },
    set fallbackRoot(Z) {
      a.value && (a.value.fallbackRoot = Z);
    },
    get fallbackFormat() {
      return a.value ? a.value.fallbackFormat : g;
    },
    set fallbackFormat(Z) {
      a.value && (a.value.fallbackFormat = Z);
    },
    get warnHtmlMessage() {
      return a.value ? a.value.warnHtmlMessage : C;
    },
    set warnHtmlMessage(Z) {
      a.value && (a.value.warnHtmlMessage = Z);
    },
    get escapeParameter() {
      return a.value ? a.value.escapeParameter : k;
    },
    set escapeParameter(Z) {
      a.value && (a.value.escapeParameter = Z);
    },
    t: Q,
    getPostTranslationHandler: z,
    setPostTranslationHandler: te,
    getMissingHandler: H,
    setMissingHandler: U,
    rt: de,
    d: re,
    n: J,
    tm: Ce,
    te: ie,
    getLocaleMessage: ee,
    setLocaleMessage: D,
    mergeLocaleMessage: G,
    getDateTimeFormat: fe,
    setDateTimeFormat: P,
    mergeDateTimeFormat: se,
    getNumberFormat: ke,
    setNumberFormat: Le,
    mergeNumberFormat: ne
  };
  function pe(Z) {
    Z.locale.value = s.value, Z.fallbackLocale.value = l.value, Object.keys(u.value).forEach((B) => {
      Z.mergeLocaleMessage(B, u.value[B]);
    }), Object.keys(c.value).forEach((B) => {
      Z.mergeDateTimeFormat(B, c.value[B]);
    }), Object.keys(d.value).forEach((B) => {
      Z.mergeNumberFormat(B, d.value[B]);
    }), Z.escapeParameter = k, Z.fallbackFormat = g, Z.fallbackRoot = m, Z.fallbackWarn = h, Z.missingWarn = f, Z.warnHtmlMessage = C;
  }
  return X1(() => {
    if (t.proxy == null || t.proxy.$i18n == null)
      throw tn(vt.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
    const Z = a.value = t.proxy.$i18n.__composer;
    e === "global" ? (s.value = Z.locale.value, l.value = Z.fallbackLocale.value, u.value = Z.messages.value, c.value = Z.datetimeFormats.value, d.value = Z.numberFormats.value) : o && pe(Z);
  }), ye;
}
const YE = [
  "locale",
  "fallbackLocale",
  "availableLocales"
], eg = ["t", "rt", "d", "n", "tm", "te"];
function qE(t, e) {
  const n = /* @__PURE__ */ Object.create(null);
  return YE.forEach((o) => {
    const a = Object.getOwnPropertyDescriptor(e, o);
    if (!a)
      throw tn(vt.UNEXPECTED_ERROR);
    const i = bt(a.value) ? {
      get() {
        return a.value.value;
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      set(s) {
        a.value.value = s;
      }
    } : {
      get() {
        return a.get && a.get();
      }
    };
    Object.defineProperty(n, o, i);
  }), t.config.globalProperties.$i18n = n, eg.forEach((o) => {
    const a = Object.getOwnPropertyDescriptor(e, o);
    if (!a || !a.value)
      throw tn(vt.UNEXPECTED_ERROR);
    Object.defineProperty(t.config.globalProperties, `$${o}`, a);
  }), () => {
    delete t.config.globalProperties.$i18n, eg.forEach((o) => {
      delete t.config.globalProperties[`$${o}`];
    });
  };
}
uE();
__INTLIFY_JIT_COMPILATION__ ? Dm(qC) : Dm(YC);
EC(oC);
OC(Ky);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const t = Oo();
  t.__INTLIFY__ = !0, pC(t.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
const GE = { class: "sr-only" }, $p = /* @__PURE__ */ j({
  __name: "KLink",
  props: {
    noIcon: { type: [Boolean, String] },
    as: { default: "a" },
    text: {},
    target: {},
    href: {},
    rel: {}
  },
  setup(t) {
    const e = t, n = A(() => e.target == "_blank"), { t: r } = Mt(), o = A(
      () => !e.href || e.href.startsWith("#") || e.href.startsWith("/") || e.href.startsWith(window.location.origin)
    ), a = A(() => ({
      [e.class]: !!e.class,
      "k-link": !0,
      "k-external-link": n.value
    })), i = A(() => e.rel || (o.value ? void 0 : "noreferrer"));
    return (s, l) => (w(), I(On(s.as), {
      class: Ie(a.value),
      rel: i.value,
      target: s.target,
      href: s.href
    }, {
      default: S(() => [
        $(s.$slots, "default", {}, () => [
          We(Se(s.text), 1)
        ]),
        n.value ? (w(), K(Me, { key: 0 }, [
          p(ce)(s.noIcon) ? V("", !0) : (w(), I(ht, {
            key: 0,
            icon: "fas fa-external-link k-external-link-icon",
            size: "0.75x"
          })),
          be("span", GE, Se(" " + p(r)("k-opensInNewTab")), 1)
        ], 64)) : V("", !0)
      ]),
      _: 3
    }, 8, ["class", "rel", "target", "href"]));
  }
}), JE = { class: "k-icon-list" }, XE = { key: 1 }, bb = /* @__PURE__ */ j({
  __name: "KIconList",
  props: {
    icon: {},
    items: {}
  },
  setup(t) {
    const e = t, n = A(
      () => {
        var r;
        return ((r = e.items) == null ? void 0 : r.map((o) => typeof o == "string" ? {
          icon: e.icon,
          text: o
        } : o)) || [];
      }
    );
    return (r, o) => (w(), K("ul", JE, [
      (w(!0), K(Me, null, et(n.value, (a, i) => (w(), K("li", { key: i }, [
        a.icon ? (w(), I(ht, {
          key: 0,
          icon: a.icon,
          class: "k-icon-list-icon"
        }, null, 8, ["icon"])) : V("", !0),
        $(r.$slots, "default", {
          item: a,
          index: i
        }, () => [
          a.href ? (w(), I($p, {
            key: 0,
            text: a.text,
            href: a.href
          }, null, 8, ["text", "href"])) : (w(), K("span", XE, Se(a.text), 1))
        ])
      ]))), 128))
    ]));
  }
}), QE = ["alt", "src"], ZE = /* @__PURE__ */ j({
  __name: "KImage",
  props: {
    alt: {},
    src: {},
    aspectRatio: {},
    cover: { type: Boolean },
    height: {},
    maxHeight: {},
    width: {},
    maxWidth: {}
  },
  setup(t) {
    const e = t, n = A(() => ({
      "k-img": !0,
      "k-img-cover": e.cover
    })), r = (a) => typeof a == "number" ? `${a}px` : a, o = A(() => ({
      aspectRatio: e.aspectRatio,
      height: r(e.height),
      maxHeight: r(e.maxHeight),
      width: r(e.width),
      maxWidth: r(e.maxWidth)
    }));
    return (a, i) => (w(), K("img", {
      alt: a.alt,
      src: a.src,
      class: Ie(n.value),
      style: Lt(o.value)
    }, null, 14, QE));
  }
}), eO = { class: "sr-only" }, Rp = /* @__PURE__ */ j({
  __name: "KSpinner",
  props: {
    size: { default: "1x" },
    color: {},
    variant: { default: "primary" },
    speed: { default: "fast" },
    srText: {}
  },
  setup(t) {
    const { t: e } = Mt(), n = t, r = A(() => {
      var a;
      return {
        [`k-spinner-${n.variant}`]: !!n.variant,
        [`k-spinner-${n.speed}`]: typeof n.speed == "string",
        [`k-spinner-size-${(a = n.size) == null ? void 0 : a.replace(".", "_")}`]: typeof n.size == "string"
      };
    }), o = A(() => ({
      borderColor: n.color,
      borderTopColor: n.color ? "transparent" : void 0
    }));
    return (a, i) => (w(), K("div", {
      class: Ie(["k-spinner", r.value]),
      style: Lt(o.value),
      role: "status"
    }, [
      be("span", eO, Se(a.srText || p(e)("k-loading")), 1)
    ], 6));
  }
}), qr = /* @__PURE__ */ j({
  __name: "KHeading",
  props: {
    level: { default: 1 },
    as: {}
  },
  setup(t) {
    const e = t, n = A(() => e.as || `h${e.level}`), r = A(() => ({ [`k-h${e.level}`]: !!e.as }));
    return (o, a) => (w(), I(On(n.value), {
      class: Ie(r.value)
    }, {
      default: S(() => [
        $(o.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), tO = ["role"], nO = {
  key: 0,
  class: "k-alert-icon"
}, rO = { class: "k-alert-content" }, oO = { key: 1 }, aO = { key: 1 }, iO = ["aria-label"], ZU = /* @__PURE__ */ j({
  __name: "KAlert",
  props: /* @__PURE__ */ it({
    icon: {},
    variant: { default: "info" },
    loading: { type: [Boolean, String] },
    title: {},
    titleLevel: { default: 4 },
    text: {},
    listIcon: {},
    dismissible: { type: [Boolean, String] }
  }, {
    modelValue: { type: Boolean, default: !0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ it(["dismiss"], ["update:modelValue"]),
  setup(t, { emit: e }) {
    const { t: n } = Mt(), r = e, o = ut(t, "modelValue"), a = t, i = A(() => `h${a.titleLevel}`), s = A(() => ({
      [`k-alert-${a.variant}`]: !!a.variant
    })), l = A(() => a.variant === "info" ? "status" : "alert"), u = A(() => a.variant === "info" ? "text" : a.variant), c = () => {
      o.value = !1, r("dismiss");
    };
    return (d, f) => o.value ? (w(), K("div", {
      key: 0,
      class: Ie(["k-alert", s.value]),
      role: l.value
    }, [
      d.icon || p(ce)(d.loading) ? (w(), K("div", nO, [
        d.icon && !p(ce)(d.loading) ? (w(), I(ht, {
          key: 0,
          icon: d.icon,
          size: "1.5x"
        }, null, 8, ["icon"])) : V("", !0),
        p(ce)(d.loading) ? (w(), I(Rp, {
          key: 1,
          size: "1.5x",
          variant: u.value
        }, null, 8, ["variant"])) : V("", !0)
      ])) : V("", !0),
      be("div", rO, [
        $(d.$slots, "default", {}, () => [
          d.title ? (w(), I(qr, {
            key: 0,
            as: i.value,
            level: 4
          }, {
            default: S(() => [
              We(Se(d.title), 1)
            ]),
            _: 1
          }, 8, ["as"])) : V("", !0),
          d.text && typeof d.text == "string" ? (w(), K("p", oO, Se(d.text), 1)) : V("", !0),
          d.text && Array.isArray(d.text) ? (w(), K(Me, { key: 2 }, [
            d.listIcon ? (w(), I(bb, {
              key: 0,
              icon: d.listIcon,
              items: d.text
            }, null, 8, ["icon", "items"])) : (w(), K("ul", aO, [
              (w(!0), K(Me, null, et(d.text, (h, m) => (w(), K("li", { key: m }, Se(h), 1))), 128))
            ]))
          ], 64)) : V("", !0)
        ])
      ]),
      p(ce)(d.dismissible) ? (w(), K("button", {
        key: 1,
        type: "button",
        class: "k-alert-close",
        "aria-label": p(n)("k-close"),
        onClick: c
      }, [
        q(ht, { icon: ["fas", "fa-xmark"] })
      ], 8, iO)) : V("", !0)
    ], 10, tO)) : V("", !0);
  }
}), sO = ["tabindex", "aria-label"], lO = { class: "k-card-inner" }, uO = {
  key: 0,
  class: "k-card-header"
}, cO = {
  key: 1,
  class: "k-card-subtitle"
}, dO = { class: "k-card-content" }, fO = { key: 0 }, pO = {
  key: 1,
  class: "k-card-footer"
}, hO = { key: 0 }, e8 = /* @__PURE__ */ j({
  __name: "KCard",
  props: {
    title: {},
    titleLevel: { default: 4 },
    subtitle: {},
    text: {},
    footer: {},
    image: {},
    imagePosition: { default: "top" },
    imageMaxSize: { default: 300 },
    clickable: { type: [Boolean, String] }
  },
  setup(t) {
    const e = t, n = A(() => `h${e.titleLevel}`), r = A(() => ({
      "k-card": !0,
      [`k-card-${e.imagePosition}-image`]: !!e.imagePosition,
      "k-card-clickable": ce(e.clickable)
    })), o = A(() => ({
      src: e.image || "",
      class: "k-card-image",
      alt: e.title || "Image",
      maxWidth: e.imagePosition == "left" ? e.imageMaxSize : void 0,
      maxHeight: e.imagePosition == "top" ? e.imageMaxSize : void 0,
      cover: !0
    }));
    return (a, i) => (w(), K("section", {
      class: Ie(r.value),
      tabindex: p(ce)(a.clickable) ? 0 : void 0,
      "aria-label": e.title
    }, [
      a.image ? (w(), I(ZE, Ye(oe({ key: 0 }, o.value)), null, 16)) : V("", !0),
      be("div", lO, [
        a.$slots.header || e.title || e.subtitle ? (w(), K("div", uO, [
          e.title ? (w(), I(qr, {
            key: 0,
            as: n.value,
            level: 4,
            class: "k-card-title"
          }, {
            default: S(() => [
              We(Se(e.title), 1)
            ]),
            _: 1
          }, 8, ["as"])) : V("", !0),
          e.subtitle ? (w(), K("p", cO, Se(e.subtitle), 1)) : V("", !0),
          $(a.$slots, "header")
        ])) : V("", !0),
        be("div", dO, [
          $(a.$slots, "default", {}, () => [
            e.text ? (w(), K("p", fO, Se(e.text), 1)) : V("", !0)
          ])
        ]),
        a.$slots.footer || e.footer ? (w(), K("div", pO, [
          $(a.$slots, "footer", {}, () => [
            e.footer ? (w(), K("p", hO, Se(e.footer), 1)) : V("", !0)
          ])
        ])) : V("", !0)
      ])
    ], 10, sO));
  }
}), mO = ["top", "right", "bottom", "left"], ca = Math.min, Gn = Math.max, wu = Math.round, jl = Math.floor, Qr = (t) => ({
  x: t,
  y: t
}), gO = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, vO = {
  start: "end",
  end: "start"
};
function _f(t, e, n) {
  return Gn(t, ca(e, n));
}
function Do(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function Po(t) {
  return t.split("-")[0];
}
function us(t) {
  return t.split("-")[1];
}
function Lp(t) {
  return t === "x" ? "y" : "x";
}
function Bp(t) {
  return t === "y" ? "height" : "width";
}
function Ao(t) {
  return ["top", "bottom"].includes(Po(t)) ? "y" : "x";
}
function Fp(t) {
  return Lp(Ao(t));
}
function yO(t, e, n) {
  n === void 0 && (n = !1);
  const r = us(t), o = Fp(t), a = Bp(o);
  let i = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return e.reference[a] > e.floating[a] && (i = _u(i)), [i, _u(i)];
}
function bO(t) {
  const e = _u(t);
  return [Cf(t), e, Cf(e)];
}
function Cf(t) {
  return t.replace(/start|end/g, (e) => vO[e]);
}
function kO(t, e, n) {
  const r = ["left", "right"], o = ["right", "left"], a = ["top", "bottom"], i = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? o : r : e ? r : o;
    case "left":
    case "right":
      return e ? a : i;
    default:
      return [];
  }
}
function wO(t, e, n, r) {
  const o = us(t);
  let a = kO(Po(t), n === "start", r);
  return o && (a = a.map((i) => i + "-" + o), e && (a = a.concat(a.map(Cf)))), a;
}
function _u(t) {
  return t.replace(/left|right|bottom|top/g, (e) => gO[e]);
}
function _O(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function kb(t) {
  return typeof t != "number" ? _O(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function Cu(t) {
  const {
    x: e,
    y: n,
    width: r,
    height: o
  } = t;
  return {
    width: r,
    height: o,
    top: n,
    left: e,
    right: e + r,
    bottom: n + o,
    x: e,
    y: n
  };
}
function tg(t, e, n) {
  let {
    reference: r,
    floating: o
  } = t;
  const a = Ao(e), i = Fp(e), s = Bp(i), l = Po(e), u = a === "y", c = r.x + r.width / 2 - o.width / 2, d = r.y + r.height / 2 - o.height / 2, f = r[s] / 2 - o[s] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: c,
        y: r.y - o.height
      };
      break;
    case "bottom":
      h = {
        x: c,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      h = {
        x: r.x - o.width,
        y: d
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (us(e)) {
    case "start":
      h[i] -= f * (n && u ? -1 : 1);
      break;
    case "end":
      h[i] += f * (n && u ? -1 : 1);
      break;
  }
  return h;
}
const CO = async (t, e, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: a = [],
    platform: i
  } = n, s = a.filter(Boolean), l = await (i.isRTL == null ? void 0 : i.isRTL(e));
  let u = await i.getElementRects({
    reference: t,
    floating: e,
    strategy: o
  }), {
    x: c,
    y: d
  } = tg(u, r, l), f = r, h = {}, m = 0;
  for (let g = 0; g < s.length; g++) {
    const {
      name: y,
      fn: b
    } = s[g], {
      x: C,
      y: k,
      data: v,
      reset: E
    } = await b({
      x: c,
      y: d,
      initialPlacement: r,
      placement: f,
      strategy: o,
      middlewareData: h,
      rects: u,
      platform: i,
      elements: {
        reference: t,
        floating: e
      }
    });
    c = C ?? c, d = k ?? d, h = {
      ...h,
      [y]: {
        ...h[y],
        ...v
      }
    }, E && m <= 50 && (m++, typeof E == "object" && (E.placement && (f = E.placement), E.rects && (u = E.rects === !0 ? await i.getElementRects({
      reference: t,
      floating: e,
      strategy: o
    }) : E.rects), {
      x: c,
      y: d
    } = tg(u, f, l)), g = -1);
  }
  return {
    x: c,
    y: d,
    placement: f,
    strategy: o,
    middlewareData: h
  };
};
async function el(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: r,
    y: o,
    platform: a,
    rects: i,
    elements: s,
    strategy: l
  } = t, {
    boundary: u = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: h = 0
  } = Do(e, t), m = kb(h), y = s[f ? d === "floating" ? "reference" : "floating" : d], b = Cu(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(y))) == null || n ? y : y.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: u,
    rootBoundary: c,
    strategy: l
  })), C = d === "floating" ? {
    x: r,
    y: o,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, k = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), v = await (a.isElement == null ? void 0 : a.isElement(k)) ? await (a.getScale == null ? void 0 : a.getScale(k)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, E = Cu(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: C,
    offsetParent: k,
    strategy: l
  }) : C);
  return {
    top: (b.top - E.top + m.top) / v.y,
    bottom: (E.bottom - b.bottom + m.bottom) / v.y,
    left: (b.left - E.left + m.left) / v.x,
    right: (E.right - b.right + m.right) / v.x
  };
}
const EO = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: a,
      platform: i,
      elements: s,
      middlewareData: l
    } = e, {
      element: u,
      padding: c = 0
    } = Do(t, e) || {};
    if (u == null)
      return {};
    const d = kb(c), f = {
      x: n,
      y: r
    }, h = Fp(o), m = Bp(h), g = await i.getDimensions(u), y = h === "y", b = y ? "top" : "left", C = y ? "bottom" : "right", k = y ? "clientHeight" : "clientWidth", v = a.reference[m] + a.reference[h] - f[h] - a.floating[m], E = f[h] - a.reference[h], _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(u));
    let T = _ ? _[k] : 0;
    (!T || !await (i.isElement == null ? void 0 : i.isElement(_))) && (T = s.floating[k] || a.floating[m]);
    const M = v / 2 - E / 2, O = T / 2 - g[m] / 2 - 1, R = ca(d[b], O), N = ca(d[C], O), z = R, te = T - g[m] - N, H = T / 2 - g[m] / 2 + M, U = _f(z, H, te), W = !l.arrow && us(o) != null && H !== U && a.reference[m] / 2 - (H < z ? R : N) - g[m] / 2 < 0, Q = W ? H < z ? H - z : H - te : 0;
    return {
      [h]: f[h] + Q,
      data: {
        [h]: U,
        centerOffset: H - U - Q,
        ...W && {
          alignmentOffset: Q
        }
      },
      reset: W
    };
  }
}), OO = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, r;
      const {
        placement: o,
        middlewareData: a,
        rects: i,
        initialPlacement: s,
        platform: l,
        elements: u
      } = e, {
        mainAxis: c = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: g = !0,
        ...y
      } = Do(t, e);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const b = Po(o), C = Ao(s), k = Po(s) === s, v = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), E = f || (k || !g ? [_u(s)] : bO(s)), _ = m !== "none";
      !f && _ && E.push(...wO(s, g, m, v));
      const T = [s, ...E], M = await el(e, y), O = [];
      let R = ((r = a.flip) == null ? void 0 : r.overflows) || [];
      if (c && O.push(M[b]), d) {
        const U = yO(o, i, v);
        O.push(M[U[0]], M[U[1]]);
      }
      if (R = [...R, {
        placement: o,
        overflows: O
      }], !O.every((U) => U <= 0)) {
        var N, z;
        const U = (((N = a.flip) == null ? void 0 : N.index) || 0) + 1, W = T[U];
        if (W) {
          var te;
          const de = d === "alignment" ? C !== Ao(W) : !1, re = ((te = R[0]) == null ? void 0 : te.overflows[0]) > 0;
          if (!de || re)
            return {
              data: {
                index: U,
                overflows: R
              },
              reset: {
                placement: W
              }
            };
        }
        let Q = (z = R.filter((de) => de.overflows[0] <= 0).sort((de, re) => de.overflows[1] - re.overflows[1])[0]) == null ? void 0 : z.placement;
        if (!Q)
          switch (h) {
            case "bestFit": {
              var H;
              const de = (H = R.filter((re) => {
                if (_) {
                  const J = Ao(re.placement);
                  return J === C || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  J === "y";
                }
                return !0;
              }).map((re) => [re.placement, re.overflows.filter((J) => J > 0).reduce((J, Ce) => J + Ce, 0)]).sort((re, J) => re[1] - J[1])[0]) == null ? void 0 : H[0];
              de && (Q = de);
              break;
            }
            case "initialPlacement":
              Q = s;
              break;
          }
        if (o !== Q)
          return {
            reset: {
              placement: Q
            }
          };
      }
      return {};
    }
  };
};
function ng(t, e) {
  return {
    top: t.top - e.height,
    right: t.right - e.width,
    bottom: t.bottom - e.height,
    left: t.left - e.width
  };
}
function rg(t) {
  return mO.some((e) => t[e] >= 0);
}
const TO = function(t) {
  return t === void 0 && (t = {}), {
    name: "hide",
    options: t,
    async fn(e) {
      const {
        rects: n
      } = e, {
        strategy: r = "referenceHidden",
        ...o
      } = Do(t, e);
      switch (r) {
        case "referenceHidden": {
          const a = await el(e, {
            ...o,
            elementContext: "reference"
          }), i = ng(a, n.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: rg(i)
            }
          };
        }
        case "escaped": {
          const a = await el(e, {
            ...o,
            altBoundary: !0
          }), i = ng(a, n.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: rg(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function SO(t, e) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = t, a = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), i = Po(n), s = us(n), l = Ao(n) === "y", u = ["left", "top"].includes(i) ? -1 : 1, c = a && l ? -1 : 1, d = Do(e, t);
  let {
    mainAxis: f,
    crossAxis: h,
    alignmentAxis: m
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return s && typeof m == "number" && (h = s === "end" ? m * -1 : m), l ? {
    x: h * c,
    y: f * u
  } : {
    x: f * u,
    y: h * c
  };
}
const xO = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, r;
      const {
        x: o,
        y: a,
        placement: i,
        middlewareData: s
      } = e, l = await SO(e, t);
      return i === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: o + l.x,
        y: a + l.y,
        data: {
          ...l,
          placement: i
        }
      };
    }
  };
}, AO = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: r,
        placement: o
      } = e, {
        mainAxis: a = !0,
        crossAxis: i = !1,
        limiter: s = {
          fn: (y) => {
            let {
              x: b,
              y: C
            } = y;
            return {
              x: b,
              y: C
            };
          }
        },
        ...l
      } = Do(t, e), u = {
        x: n,
        y: r
      }, c = await el(e, l), d = Ao(Po(o)), f = Lp(d);
      let h = u[f], m = u[d];
      if (a) {
        const y = f === "y" ? "top" : "left", b = f === "y" ? "bottom" : "right", C = h + c[y], k = h - c[b];
        h = _f(C, h, k);
      }
      if (i) {
        const y = d === "y" ? "top" : "left", b = d === "y" ? "bottom" : "right", C = m + c[y], k = m - c[b];
        m = _f(C, m, k);
      }
      const g = s.fn({
        ...e,
        [f]: h,
        [d]: m
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - r,
          enabled: {
            [f]: a,
            [d]: i
          }
        }
      };
    }
  };
}, MO = function(t) {
  return t === void 0 && (t = {}), {
    options: t,
    fn(e) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: a,
        middlewareData: i
      } = e, {
        offset: s = 0,
        mainAxis: l = !0,
        crossAxis: u = !0
      } = Do(t, e), c = {
        x: n,
        y: r
      }, d = Ao(o), f = Lp(d);
      let h = c[f], m = c[d];
      const g = Do(s, e), y = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (l) {
        const k = f === "y" ? "height" : "width", v = a.reference[f] - a.floating[k] + y.mainAxis, E = a.reference[f] + a.reference[k] - y.mainAxis;
        h < v ? h = v : h > E && (h = E);
      }
      if (u) {
        var b, C;
        const k = f === "y" ? "width" : "height", v = ["top", "left"].includes(Po(o)), E = a.reference[d] - a.floating[k] + (v && ((b = i.offset) == null ? void 0 : b[d]) || 0) + (v ? 0 : y.crossAxis), _ = a.reference[d] + a.reference[k] + (v ? 0 : ((C = i.offset) == null ? void 0 : C[d]) || 0) - (v ? y.crossAxis : 0);
        m < E ? m = E : m > _ && (m = _);
      }
      return {
        [f]: h,
        [d]: m
      };
    }
  };
}, IO = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      var n, r;
      const {
        placement: o,
        rects: a,
        platform: i,
        elements: s
      } = e, {
        apply: l = () => {
        },
        ...u
      } = Do(t, e), c = await el(e, u), d = Po(o), f = us(o), h = Ao(o) === "y", {
        width: m,
        height: g
      } = a.floating;
      let y, b;
      d === "top" || d === "bottom" ? (y = d, b = f === (await (i.isRTL == null ? void 0 : i.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (b = d, y = f === "end" ? "top" : "bottom");
      const C = g - c.top - c.bottom, k = m - c.left - c.right, v = ca(g - c[y], C), E = ca(m - c[b], k), _ = !e.middlewareData.shift;
      let T = v, M = E;
      if ((n = e.middlewareData.shift) != null && n.enabled.x && (M = k), (r = e.middlewareData.shift) != null && r.enabled.y && (T = C), _ && !f) {
        const R = Gn(c.left, 0), N = Gn(c.right, 0), z = Gn(c.top, 0), te = Gn(c.bottom, 0);
        h ? M = m - 2 * (R !== 0 || N !== 0 ? R + N : Gn(c.left, c.right)) : T = g - 2 * (z !== 0 || te !== 0 ? z + te : Gn(c.top, c.bottom));
      }
      await l({
        ...e,
        availableWidth: M,
        availableHeight: T
      });
      const O = await i.getDimensions(s.floating);
      return m !== O.width || g !== O.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function xc() {
  return typeof window < "u";
}
function oi(t) {
  return Vp(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function er(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function fo(t) {
  var e;
  return (e = (Vp(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function Vp(t) {
  return xc() ? t instanceof Node || t instanceof er(t).Node : !1;
}
function Dr(t) {
  return xc() ? t instanceof Element || t instanceof er(t).Element : !1;
}
function no(t) {
  return xc() ? t instanceof HTMLElement || t instanceof er(t).HTMLElement : !1;
}
function og(t) {
  return !xc() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof er(t).ShadowRoot;
}
function El(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: r,
    display: o
  } = Pr(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + r + n) && !["inline", "contents"].includes(o);
}
function DO(t) {
  return ["table", "td", "th"].includes(oi(t));
}
function Ac(t) {
  return [":popover-open", ":modal"].some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
function Hp(t) {
  const e = Up(), n = Dr(t) ? Pr(t) : t;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function PO(t) {
  let e = da(t);
  for (; no(e) && !Hi(e); ) {
    if (Hp(e))
      return e;
    if (Ac(e))
      return null;
    e = da(e);
  }
  return null;
}
function Up() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Hi(t) {
  return ["html", "body", "#document"].includes(oi(t));
}
function Pr(t) {
  return er(t).getComputedStyle(t);
}
function Mc(t) {
  return Dr(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function da(t) {
  if (oi(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    og(t) && t.host || // Fallback.
    fo(t)
  );
  return og(e) ? e.host : e;
}
function wb(t) {
  const e = da(t);
  return Hi(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : no(e) && El(e) ? e : wb(e);
}
function tl(t, e, n) {
  var r;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const o = wb(t), a = o === ((r = t.ownerDocument) == null ? void 0 : r.body), i = er(o);
  if (a) {
    const s = Ef(i);
    return e.concat(i, i.visualViewport || [], El(o) ? o : [], s && n ? tl(s) : []);
  }
  return e.concat(o, tl(o, [], n));
}
function Ef(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function _b(t) {
  const e = Pr(t);
  let n = parseFloat(e.width) || 0, r = parseFloat(e.height) || 0;
  const o = no(t), a = o ? t.offsetWidth : n, i = o ? t.offsetHeight : r, s = wu(n) !== a || wu(r) !== i;
  return s && (n = a, r = i), {
    width: n,
    height: r,
    $: s
  };
}
function Wp(t) {
  return Dr(t) ? t : t.contextElement;
}
function Pi(t) {
  const e = Wp(t);
  if (!no(e))
    return Qr(1);
  const n = e.getBoundingClientRect(), {
    width: r,
    height: o,
    $: a
  } = _b(e);
  let i = (a ? wu(n.width) : n.width) / r, s = (a ? wu(n.height) : n.height) / o;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const NO = /* @__PURE__ */ Qr(0);
function Cb(t) {
  const e = er(t);
  return !Up() || !e.visualViewport ? NO : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function $O(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== er(t) ? !1 : e;
}
function Ga(t, e, n, r) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const o = t.getBoundingClientRect(), a = Wp(t);
  let i = Qr(1);
  e && (r ? Dr(r) && (i = Pi(r)) : i = Pi(t));
  const s = $O(a, n, r) ? Cb(a) : Qr(0);
  let l = (o.left + s.x) / i.x, u = (o.top + s.y) / i.y, c = o.width / i.x, d = o.height / i.y;
  if (a) {
    const f = er(a), h = r && Dr(r) ? er(r) : r;
    let m = f, g = Ef(m);
    for (; g && r && h !== m; ) {
      const y = Pi(g), b = g.getBoundingClientRect(), C = Pr(g), k = b.left + (g.clientLeft + parseFloat(C.paddingLeft)) * y.x, v = b.top + (g.clientTop + parseFloat(C.paddingTop)) * y.y;
      l *= y.x, u *= y.y, c *= y.x, d *= y.y, l += k, u += v, m = er(g), g = Ef(m);
    }
  }
  return Cu({
    width: c,
    height: d,
    x: l,
    y: u
  });
}
function Kp(t, e) {
  const n = Mc(t).scrollLeft;
  return e ? e.left + n : Ga(fo(t)).left + n;
}
function Eb(t, e, n) {
  n === void 0 && (n = !1);
  const r = t.getBoundingClientRect(), o = r.left + e.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    Kp(t, r)
  )), a = r.top + e.scrollTop;
  return {
    x: o,
    y: a
  };
}
function RO(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: r,
    strategy: o
  } = t;
  const a = o === "fixed", i = fo(r), s = e ? Ac(e.floating) : !1;
  if (r === i || s && a)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = Qr(1);
  const c = Qr(0), d = no(r);
  if ((d || !d && !a) && ((oi(r) !== "body" || El(i)) && (l = Mc(r)), no(r))) {
    const h = Ga(r);
    u = Pi(r), c.x = h.x + r.clientLeft, c.y = h.y + r.clientTop;
  }
  const f = i && !d && !a ? Eb(i, l, !0) : Qr(0);
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - l.scrollLeft * u.x + c.x + f.x,
    y: n.y * u.y - l.scrollTop * u.y + c.y + f.y
  };
}
function LO(t) {
  return Array.from(t.getClientRects());
}
function BO(t) {
  const e = fo(t), n = Mc(t), r = t.ownerDocument.body, o = Gn(e.scrollWidth, e.clientWidth, r.scrollWidth, r.clientWidth), a = Gn(e.scrollHeight, e.clientHeight, r.scrollHeight, r.clientHeight);
  let i = -n.scrollLeft + Kp(t);
  const s = -n.scrollTop;
  return Pr(r).direction === "rtl" && (i += Gn(e.clientWidth, r.clientWidth) - o), {
    width: o,
    height: a,
    x: i,
    y: s
  };
}
function FO(t, e) {
  const n = er(t), r = fo(t), o = n.visualViewport;
  let a = r.clientWidth, i = r.clientHeight, s = 0, l = 0;
  if (o) {
    a = o.width, i = o.height;
    const u = Up();
    (!u || u && e === "fixed") && (s = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: a,
    height: i,
    x: s,
    y: l
  };
}
function VO(t, e) {
  const n = Ga(t, !0, e === "fixed"), r = n.top + t.clientTop, o = n.left + t.clientLeft, a = no(t) ? Pi(t) : Qr(1), i = t.clientWidth * a.x, s = t.clientHeight * a.y, l = o * a.x, u = r * a.y;
  return {
    width: i,
    height: s,
    x: l,
    y: u
  };
}
function ag(t, e, n) {
  let r;
  if (e === "viewport")
    r = FO(t, n);
  else if (e === "document")
    r = BO(fo(t));
  else if (Dr(e))
    r = VO(e, n);
  else {
    const o = Cb(t);
    r = {
      x: e.x - o.x,
      y: e.y - o.y,
      width: e.width,
      height: e.height
    };
  }
  return Cu(r);
}
function Ob(t, e) {
  const n = da(t);
  return n === e || !Dr(n) || Hi(n) ? !1 : Pr(n).position === "fixed" || Ob(n, e);
}
function HO(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let r = tl(t, [], !1).filter((s) => Dr(s) && oi(s) !== "body"), o = null;
  const a = Pr(t).position === "fixed";
  let i = a ? da(t) : t;
  for (; Dr(i) && !Hi(i); ) {
    const s = Pr(i), l = Hp(i);
    !l && s.position === "fixed" && (o = null), (a ? !l && !o : !l && s.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || El(i) && !l && Ob(t, i)) ? r = r.filter((c) => c !== i) : o = s, i = da(i);
  }
  return e.set(t, r), r;
}
function UO(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = t;
  const i = [...n === "clippingAncestors" ? Ac(e) ? [] : HO(e, this._c) : [].concat(n), r], s = i[0], l = i.reduce((u, c) => {
    const d = ag(e, c, o);
    return u.top = Gn(d.top, u.top), u.right = ca(d.right, u.right), u.bottom = ca(d.bottom, u.bottom), u.left = Gn(d.left, u.left), u;
  }, ag(e, s, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function WO(t) {
  const {
    width: e,
    height: n
  } = _b(t);
  return {
    width: e,
    height: n
  };
}
function KO(t, e, n) {
  const r = no(e), o = fo(e), a = n === "fixed", i = Ga(t, !0, a, e);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Qr(0);
  function u() {
    l.x = Kp(o);
  }
  if (r || !r && !a)
    if ((oi(e) !== "body" || El(o)) && (s = Mc(e)), r) {
      const h = Ga(e, !0, a, e);
      l.x = h.x + e.clientLeft, l.y = h.y + e.clientTop;
    } else o && u();
  a && !r && o && u();
  const c = o && !r && !a ? Eb(o, s) : Qr(0), d = i.left + s.scrollLeft - l.x - c.x, f = i.top + s.scrollTop - l.y - c.y;
  return {
    x: d,
    y: f,
    width: i.width,
    height: i.height
  };
}
function pd(t) {
  return Pr(t).position === "static";
}
function ig(t, e) {
  if (!no(t) || Pr(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let n = t.offsetParent;
  return fo(t) === n && (n = n.ownerDocument.body), n;
}
function Tb(t, e) {
  const n = er(t);
  if (Ac(t))
    return n;
  if (!no(t)) {
    let o = da(t);
    for (; o && !Hi(o); ) {
      if (Dr(o) && !pd(o))
        return o;
      o = da(o);
    }
    return n;
  }
  let r = ig(t, e);
  for (; r && DO(r) && pd(r); )
    r = ig(r, e);
  return r && Hi(r) && pd(r) && !Hp(r) ? n : r || PO(t) || n;
}
const jO = async function(t) {
  const e = this.getOffsetParent || Tb, n = this.getDimensions, r = await n(t.floating);
  return {
    reference: KO(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function zO(t) {
  return Pr(t).direction === "rtl";
}
const YO = {
  convertOffsetParentRelativeRectToViewportRelativeRect: RO,
  getDocumentElement: fo,
  getClippingRect: UO,
  getOffsetParent: Tb,
  getElementRects: jO,
  getClientRects: LO,
  getDimensions: WO,
  getScale: Pi,
  isElement: Dr,
  isRTL: zO
};
function Sb(t, e) {
  return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
}
function qO(t, e) {
  let n = null, r;
  const o = fo(t);
  function a() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function i(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), a();
    const u = t.getBoundingClientRect(), {
      left: c,
      top: d,
      width: f,
      height: h
    } = u;
    if (s || e(), !f || !h)
      return;
    const m = jl(d), g = jl(o.clientWidth - (c + f)), y = jl(o.clientHeight - (d + h)), b = jl(c), k = {
      rootMargin: -m + "px " + -g + "px " + -y + "px " + -b + "px",
      threshold: Gn(0, ca(1, l)) || 1
    };
    let v = !0;
    function E(_) {
      const T = _[0].intersectionRatio;
      if (T !== l) {
        if (!v)
          return i();
        T ? i(!1, T) : r = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      T === 1 && !Sb(u, t.getBoundingClientRect()) && i(), v = !1;
    }
    try {
      n = new IntersectionObserver(E, {
        ...k,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(E, k);
    }
    n.observe(t);
  }
  return i(!0), a;
}
function GO(t, e, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: a = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, u = Wp(t), c = o || a ? [...u ? tl(u) : [], ...tl(e)] : [];
  c.forEach((b) => {
    o && b.addEventListener("scroll", n, {
      passive: !0
    }), a && b.addEventListener("resize", n);
  });
  const d = u && s ? qO(u, n) : null;
  let f = -1, h = null;
  i && (h = new ResizeObserver((b) => {
    let [C] = b;
    C && C.target === u && h && (h.unobserve(e), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var k;
      (k = h) == null || k.observe(e);
    })), n();
  }), u && !l && h.observe(u), h.observe(e));
  let m, g = l ? Ga(t) : null;
  l && y();
  function y() {
    const b = Ga(t);
    g && !Sb(g, b) && n(), g = b, m = requestAnimationFrame(y);
  }
  return n(), () => {
    var b;
    c.forEach((C) => {
      o && C.removeEventListener("scroll", n), a && C.removeEventListener("resize", n);
    }), d == null || d(), (b = h) == null || b.disconnect(), h = null, l && cancelAnimationFrame(m);
  };
}
const JO = xO, XO = AO, sg = OO, QO = IO, ZO = TO, eT = EO, tT = MO, nT = (t, e, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: YO,
    ...n
  }, a = {
    ...o.platform,
    _c: r
  };
  return CO(t, e, {
    ...o,
    platform: a
  });
};
function rT(t) {
  return t != null && typeof t == "object" && "$el" in t;
}
function Of(t) {
  if (rT(t)) {
    const e = t.$el;
    return Vp(e) && oi(e) === "#comment" ? null : e;
  }
  return t;
}
function wi(t) {
  return typeof t == "function" ? t() : p(t);
}
function oT(t) {
  return {
    name: "arrow",
    options: t,
    fn(e) {
      const n = Of(wi(t.element));
      return n == null ? {} : eT({
        element: n,
        padding: t.padding
      }).fn(e);
    }
  };
}
function xb(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function lg(t, e) {
  const n = xb(t);
  return Math.round(e * n) / n;
}
function aT(t, e, n) {
  n === void 0 && (n = {});
  const r = n.whileElementsMounted, o = A(() => {
    var T;
    return (T = wi(n.open)) != null ? T : !0;
  }), a = A(() => wi(n.middleware)), i = A(() => {
    var T;
    return (T = wi(n.placement)) != null ? T : "bottom";
  }), s = A(() => {
    var T;
    return (T = wi(n.strategy)) != null ? T : "absolute";
  }), l = A(() => {
    var T;
    return (T = wi(n.transform)) != null ? T : !0;
  }), u = A(() => Of(t.value)), c = A(() => Of(e.value)), d = F(0), f = F(0), h = F(s.value), m = F(i.value), g = ri({}), y = F(!1), b = A(() => {
    const T = {
      position: h.value,
      left: "0",
      top: "0"
    };
    if (!c.value)
      return T;
    const M = lg(c.value, d.value), O = lg(c.value, f.value);
    return l.value ? {
      ...T,
      transform: "translate(" + M + "px, " + O + "px)",
      ...xb(c.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: h.value,
      left: M + "px",
      top: O + "px"
    };
  });
  let C;
  function k() {
    if (u.value == null || c.value == null)
      return;
    const T = o.value;
    nT(u.value, c.value, {
      middleware: a.value,
      placement: i.value,
      strategy: s.value
    }).then((M) => {
      d.value = M.x, f.value = M.y, h.value = M.strategy, m.value = M.placement, g.value = M.middlewareData, y.value = T !== !1;
    });
  }
  function v() {
    typeof C == "function" && (C(), C = void 0);
  }
  function E() {
    if (v(), r === void 0) {
      k();
      return;
    }
    if (u.value != null && c.value != null) {
      C = r(u.value, c.value, k);
      return;
    }
  }
  function _() {
    o.value || (y.value = !1);
  }
  return Ke([a, i, s, o], k, {
    flush: "sync"
  }), Ke([u, c], E, {
    flush: "sync"
  }), Ke(o, _, {
    flush: "sync"
  }), bc() && kc(v), {
    x: fi(d),
    y: fi(f),
    strategy: fi(h),
    placement: fi(m),
    middlewareData: fi(g),
    isPositioned: fi(y),
    floatingStyles: b,
    update: k
  };
}
function jp(t) {
  return t ? t.flatMap((e) => e.type === Me ? jp(e.children) : [e]) : [];
}
const Tf = j({
  name: "PrimitiveSlot",
  inheritAttrs: !1,
  setup(t, { attrs: e, slots: n }) {
    return () => {
      var l, u;
      if (!n.default)
        return null;
      const r = jp(n.default()), o = r.findIndex((c) => c.type !== Ay);
      if (o === -1)
        return r;
      const a = r[o];
      (l = a.props) == null || delete l.ref;
      const i = a.props ? oe(e, a.props) : e;
      e.class && ((u = a.props) != null && u.class) && delete a.props.class;
      const s = Z1(a, i);
      for (const c in i)
        c.startsWith("on") && (s.props || (s.props = {}), s.props[c] = i[c]);
      return r.length === 1 ? s : (r[o] = s, r);
    };
  }
}), iT = ["area", "img", "input"], He = j({
  name: "Primitive",
  inheritAttrs: !1,
  props: {
    asChild: {
      type: Boolean,
      default: !1
    },
    as: {
      type: [String, Object],
      default: "div"
    }
  },
  setup(t, { attrs: e, slots: n }) {
    const r = t.asChild ? "template" : t.as;
    return typeof r == "string" && iT.includes(r) ? () => Kn(r, e) : r !== "template" ? () => Kn(t.as, e, { default: n.default }) : () => Kn(Tf, e, { default: n.default });
  }
}), Ic = /* @__PURE__ */ j({
  __name: "VisuallyHidden",
  props: {
    feature: { default: "focusable" },
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  setup(t) {
    return (e, n) => (w(), I(p(He), {
      as: e.as,
      "as-child": e.asChild,
      "aria-hidden": e.feature === "focusable" ? "true" : void 0,
      "data-hidden": e.feature === "fully-hidden" ? "" : void 0,
      tabindex: e.feature === "fully-hidden" ? "-1" : void 0,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: "1px",
        height: "1px",
        padding: 0,
        margin: "-1px",
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        clipPath: "inset(50%)",
        whiteSpace: "nowrap",
        wordWrap: "normal"
      }
    }, {
      default: S(() => [
        $(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child", "aria-hidden", "data-hidden", "tabindex"]));
  }
});
function sT(t, e) {
  var n;
  const r = ri();
  return Nn(() => {
    r.value = t();
  }, {
    ...e,
    flush: (n = void 0) != null ? n : "sync"
  }), Ep(r);
}
function cs(t) {
  return bc() ? (kc(t), !0) : !1;
}
function Ns() {
  const t = /* @__PURE__ */ new Set(), e = (a) => {
    t.delete(a);
  };
  return {
    on: (a) => {
      t.add(a);
      const i = () => e(a);
      return cs(i), {
        off: i
      };
    },
    off: e,
    trigger: (...a) => Promise.all(Array.from(t).map((i) => i(...a))),
    clear: () => {
      t.clear();
    }
  };
}
function lT(t) {
  let e = !1, n;
  const r = Cp(!0);
  return (...o) => (e || (n = r.run(() => t(...o)), e = !0), n);
}
function Ab(t) {
  let e = 0, n, r;
  const o = () => {
    e -= 1, r && e <= 0 && (r.stop(), n = void 0, r = void 0);
  };
  return (...a) => (e += 1, r || (r = Cp(!0), n = r.run(() => t(...a))), cs(o), n);
}
function uT(t) {
  if (!bt(t))
    return eo(t);
  const e = new Proxy({}, {
    get(n, r, o) {
      return p(Reflect.get(t.value, r, o));
    },
    set(n, r, o) {
      return bt(t.value[r]) && !bt(o) ? t.value[r].value = o : t.value[r] = o, !0;
    },
    deleteProperty(n, r) {
      return Reflect.deleteProperty(t.value, r);
    },
    has(n, r) {
      return Reflect.has(t.value, r);
    },
    ownKeys() {
      return Object.keys(t.value);
    },
    getOwnPropertyDescriptor() {
      return {
        enumerable: !0,
        configurable: !0
      };
    }
  });
  return eo(e);
}
function cT(t) {
  return uT(A(t));
}
function dT(t, ...e) {
  const n = e.flat(), r = n[0];
  return cT(() => Object.fromEntries(typeof r == "function" ? Object.entries(Gt(t)).filter(([o, a]) => !r(fr(a), o)) : Object.entries(Gt(t)).filter((o) => !n.includes(o[0]))));
}
const Lo = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const fT = (t) => typeof t < "u", pT = Object.prototype.toString, hT = (t) => pT.call(t) === "[object Object]", ug = /* @__PURE__ */ mT();
function mT() {
  var t, e;
  return Lo && ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function gT(t) {
  return Cn();
}
function hd(t) {
  return Array.isArray(t) ? t : [t];
}
function zp(t, e = 1e4) {
  return My((n, r) => {
    let o = fr(t), a;
    const i = () => setTimeout(() => {
      o = fr(t), r();
    }, fr(e));
    return cs(() => {
      clearTimeout(a);
    }), {
      get() {
        return n(), o;
      },
      set(s) {
        o = s, r(), clearTimeout(a), a = i();
      }
    };
  });
}
const vT = fr;
function yT(t, e) {
  gT() && is(t, e);
}
function Mb(t, e, n = {}) {
  const {
    immediate: r = !0,
    immediateCallback: o = !1
  } = n, a = ri(!1);
  let i = null;
  function s() {
    i && (clearTimeout(i), i = null);
  }
  function l() {
    a.value = !1, s();
  }
  function u(...c) {
    o && t(), s(), a.value = !0, i = setTimeout(() => {
      a.value = !1, i = null, t(...c);
    }, fr(e));
  }
  return r && (a.value = !0, Lo && u()), cs(l), {
    isPending: Ep(a),
    start: u,
    stop: l
  };
}
function bT(t, e, n) {
  return Ke(
    t,
    e,
    {
      ...n,
      immediate: !0
    }
  );
}
const Dc = Lo ? window : void 0;
function ro(t) {
  var e;
  const n = fr(t);
  return (e = n == null ? void 0 : n.$el) != null ? e : n;
}
function No(...t) {
  const e = [], n = () => {
    e.forEach((s) => s()), e.length = 0;
  }, r = (s, l, u, c) => (s.addEventListener(l, u, c), () => s.removeEventListener(l, u, c)), o = A(() => {
    const s = hd(fr(t[0])).filter((l) => l != null);
    return s.every((l) => typeof l != "string") ? s : void 0;
  }), a = bT(
    () => {
      var s, l;
      return [
        (l = (s = o.value) == null ? void 0 : s.map((u) => ro(u))) != null ? l : [Dc].filter((u) => u != null),
        hd(fr(o.value ? t[1] : t[0])),
        hd(p(o.value ? t[2] : t[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        fr(o.value ? t[3] : t[2])
      ];
    },
    ([s, l, u, c]) => {
      if (n(), !(s != null && s.length) || !(l != null && l.length) || !(u != null && u.length))
        return;
      const d = hT(c) ? { ...c } : c;
      e.push(
        ...s.flatMap(
          (f) => l.flatMap(
            (h) => u.map((m) => r(f, h, m, d))
          )
        )
      );
    },
    { flush: "post" }
  ), i = () => {
    a(), n();
  };
  return cs(n), i;
}
function Ib() {
  const t = ri(!1), e = Cn();
  return e && ze(() => {
    t.value = !0;
  }, e), t;
}
function kT(t) {
  const e = Ib();
  return A(() => (e.value, !!t()));
}
function wT(t) {
  return typeof t == "function" ? t : typeof t == "string" ? (e) => e.key === t : Array.isArray(t) ? (e) => t.includes(e.key) : () => !0;
}
function _T(...t) {
  let e, n, r = {};
  t.length === 3 ? (e = t[0], n = t[1], r = t[2]) : t.length === 2 ? typeof t[1] == "object" ? (e = !0, n = t[0], r = t[1]) : (e = t[0], n = t[1]) : (e = !0, n = t[0]);
  const {
    target: o = Dc,
    eventName: a = "keydown",
    passive: i = !1,
    dedupe: s = !1
  } = r, l = wT(e);
  return No(o, a, (c) => {
    c.repeat && fr(s) || l(c) && n(c);
  }, i);
}
function CT(t) {
  return JSON.parse(JSON.stringify(t));
}
function ET(t, e, n = {}) {
  const { window: r = Dc, ...o } = n;
  let a;
  const i = kT(() => r && "ResizeObserver" in r), s = () => {
    a && (a.disconnect(), a = void 0);
  }, l = A(() => {
    const d = fr(t);
    return Array.isArray(d) ? d.map((f) => ro(f)) : [ro(d)];
  }), u = Ke(
    l,
    (d) => {
      if (s(), i.value && r) {
        a = new ResizeObserver(e);
        for (const f of d)
          f && a.observe(f, o);
      }
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    s(), u();
  };
  return cs(c), {
    isSupported: i,
    stop: c
  };
}
function Xt(t, e, n, r = {}) {
  var o, a, i;
  const {
    clone: s = !1,
    passive: l = !1,
    eventName: u,
    deep: c = !1,
    defaultValue: d,
    shouldEmit: f
  } = r, h = Cn(), m = n || (h == null ? void 0 : h.emit) || ((o = h == null ? void 0 : h.$emit) == null ? void 0 : o.bind(h)) || ((i = (a = h == null ? void 0 : h.proxy) == null ? void 0 : a.$emit) == null ? void 0 : i.bind(h == null ? void 0 : h.proxy));
  let g = u;
  e || (e = "modelValue"), g = g || `update:${e.toString()}`;
  const y = (k) => s ? typeof s == "function" ? s(k) : CT(k) : k, b = () => fT(t[e]) ? y(t[e]) : d, C = (k) => {
    f ? f(k) && m(g, k) : m(g, k);
  };
  if (l) {
    const k = b(), v = F(k);
    let E = !1;
    return Ke(
      () => t[e],
      (_) => {
        E || (E = !0, v.value = y(_), nt(() => E = !1));
      }
    ), Ke(
      v,
      (_) => {
        !E && (_ !== t[e] || c) && C(_);
      },
      { deep: c }
    ), v;
  } else
    return A({
      get() {
        return b();
      },
      set(k) {
        C(k);
      }
    });
}
function yt(t, e) {
  const n = typeof t == "string" && !e ? `${t}Context` : e, r = Symbol(n);
  return [(i) => {
    const s = yc(r, i);
    if (s || s === null)
      return s;
    throw new Error(
      `Injection \`${r.toString()}\` not found. Component must be used within ${Array.isArray(t) ? `one of the following components: ${t.join(
        ", "
      )}` : `\`${t}\``}`
    );
  }, (i) => (Iy(r, i), i)];
}
function cg(t) {
  return typeof t == "string" ? `'${t}'` : new OT().serialize(t);
}
const OT = /* @__PURE__ */ function() {
  var e;
  class t {
    constructor() {
      gm(this, e, /* @__PURE__ */ new Map());
    }
    compare(r, o) {
      const a = typeof r, i = typeof o;
      return a === "string" && i === "string" ? r.localeCompare(o) : a === "number" && i === "number" ? r - o : String.prototype.localeCompare.call(this.serialize(r, !0), this.serialize(o, !0));
    }
    serialize(r, o) {
      if (r === null) return "null";
      switch (typeof r) {
        case "string":
          return o ? r : `'${r}'`;
        case "bigint":
          return `${r}n`;
        case "object":
          return this.$object(r);
        case "function":
          return this.$function(r);
      }
      return String(r);
    }
    serializeObject(r) {
      const o = Object.prototype.toString.call(r);
      if (o !== "[object Object]") return this.serializeBuiltInType(o.length < 10 ? `unknown:${o}` : o.slice(8, -1), r);
      const a = r.constructor, i = a === Object || a === void 0 ? "" : a.name;
      if (i !== "" && globalThis[i] === a) return this.serializeBuiltInType(i, r);
      if (typeof r.toJSON == "function") {
        const s = r.toJSON();
        return i + (s !== null && typeof s == "object" ? this.$object(s) : `(${this.serialize(s)})`);
      }
      return this.serializeObjectEntries(i, Object.entries(r));
    }
    serializeBuiltInType(r, o) {
      const a = this["$" + r];
      if (a) return a.call(this, o);
      if (typeof (o == null ? void 0 : o.entries) == "function") return this.serializeObjectEntries(r, o.entries());
      throw new Error(`Cannot serialize ${r}`);
    }
    serializeObjectEntries(r, o) {
      const a = Array.from(o).sort((s, l) => this.compare(s[0], l[0]));
      let i = `${r}{`;
      for (let s = 0; s < a.length; s++) {
        const [l, u] = a[s];
        i += `${this.serialize(l, !0)}:${this.serialize(u)}`, s < a.length - 1 && (i += ",");
      }
      return i + "}";
    }
    $object(r) {
      let o = ks(this, e).get(r);
      return o === void 0 && (ks(this, e).set(r, `#${ks(this, e).size}`), o = this.serializeObject(r), ks(this, e).set(r, o)), o;
    }
    $function(r) {
      const o = Function.prototype.toString.call(r);
      return o.slice(-15) === "[native code] }" ? `${r.name || ""}()[native]` : `${r.name}(${r.length})${o.replace(/\s*\n\s*/g, "")}`;
    }
    $Array(r) {
      let o = "[";
      for (let a = 0; a < r.length; a++) o += this.serialize(r[a]), a < r.length - 1 && (o += ",");
      return o + "]";
    }
    $Date(r) {
      try {
        return `Date(${r.toISOString()})`;
      } catch {
        return "Date(null)";
      }
    }
    $ArrayBuffer(r) {
      return `ArrayBuffer[${new Uint8Array(r).join(",")}]`;
    }
    $Set(r) {
      return `Set${this.$Array(Array.from(r).sort((o, a) => this.compare(o, a)))}`;
    }
    $Map(r) {
      return this.serializeObjectEntries("Map", r.entries());
    }
  }
  e = new WeakMap();
  for (const n of ["Error", "RegExp", "URL"]) t.prototype["$" + n] = function(r) {
    return `${n}(${r})`;
  };
  for (const n of ["Int8Array", "Uint8Array", "Uint8ClampedArray", "Int16Array", "Uint16Array", "Int32Array", "Uint32Array", "Float32Array", "Float64Array"]) t.prototype["$" + n] = function(r) {
    return `${n}[${r.join(",")}]`;
  };
  for (const n of ["BigInt64Array", "BigUint64Array"]) t.prototype["$" + n] = function(r) {
    return `${n}[${r.join("n,")}${r.length > 0 ? "n" : ""}]`;
  };
  return t;
}();
function oo(t, e) {
  return t === e || cg(t) === cg(e);
}
function nl(t) {
  return t == null;
}
function Sf(t, e) {
  return nl(t) ? !1 : Array.isArray(t) ? t.some((n) => oo(n, e)) : oo(t, e);
}
function TT({ type: t, defaultValue: e, modelValue: n }) {
  const r = n || e;
  return n !== void 0 || e !== void 0 ? Array.isArray(r) ? "multiple" : "single" : t ?? "single";
}
function ST({ type: t, defaultValue: e, modelValue: n }) {
  return t || TT({ type: t, defaultValue: e, modelValue: n });
}
function xT({ type: t, defaultValue: e }) {
  return e !== void 0 ? e : t === "single" ? void 0 : [];
}
function AT(t, e) {
  const n = A(() => ST(t)), r = Xt(t, "modelValue", e, {
    defaultValue: xT(t),
    passive: t.modelValue === void 0,
    deep: !0
  });
  function o(i) {
    if (n.value === "single")
      r.value = oo(i, r.value) ? void 0 : i;
    else {
      const s = Array.isArray(r.value) ? [...r.value || []] : [r.value].filter(Boolean);
      if (Sf(s, i)) {
        const l = s.findIndex((u) => oo(u, i));
        s.splice(l, 1);
      } else
        s.push(i);
      r.value = s;
    }
  }
  const a = A(() => n.value === "single");
  return {
    modelValue: r,
    changeModelValue: o,
    isSingle: a
  };
}
const [Pc, t8] = yt("ConfigProvider");
function ga(t) {
  const e = Pc({
    dir: F("ltr")
  });
  return A(() => {
    var n;
    return (t == null ? void 0 : t.value) || ((n = e.dir) == null ? void 0 : n.value) || "ltr";
  });
}
function De() {
  const t = Cn(), e = F(), n = A(() => {
    var i, s;
    return ["#text", "#comment"].includes((i = e.value) == null ? void 0 : i.$el.nodeName) ? (s = e.value) == null ? void 0 : s.$el.nextElementSibling : ro(e);
  }), r = Object.assign({}, t.exposed), o = {};
  for (const i in t.props)
    Object.defineProperty(o, i, {
      enumerable: !0,
      configurable: !0,
      get: () => t.props[i]
    });
  if (Object.keys(r).length > 0)
    for (const i in r)
      Object.defineProperty(o, i, {
        enumerable: !0,
        configurable: !0,
        get: () => r[i]
      });
  Object.defineProperty(o, "$el", {
    enumerable: !0,
    configurable: !0,
    get: () => t.vnode.el
  }), t.exposed = o;
  function a(i) {
    e.value = i, i && (Object.defineProperty(o, "$el", {
      enumerable: !0,
      configurable: !0,
      get: () => i instanceof Element ? i : i.$el
    }), t.exposed = o);
  }
  return { forwardRef: a, currentRef: e, currentElement: n };
}
const [Nc, MT] = yt("AccordionRoot"), IT = /* @__PURE__ */ j({
  __name: "AccordionRoot",
  props: {
    collapsible: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    dir: {},
    orientation: { default: "vertical" },
    unmountOnHide: { type: Boolean, default: !0 },
    asChild: { type: Boolean },
    as: {},
    type: {},
    modelValue: {},
    defaultValue: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, r = e, { dir: o, disabled: a, unmountOnHide: i } = Gt(n), s = ga(o), { modelValue: l, changeModelValue: u, isSingle: c } = AT(n, r), { forwardRef: d, currentElement: f } = De();
    return MT({
      disabled: a,
      direction: s,
      orientation: n.orientation,
      parentElement: f,
      isSingle: c,
      collapsible: n.collapsible,
      modelValue: l,
      changeModelValue: u,
      unmountOnHide: i
    }), (h, m) => (w(), I(p(He), {
      ref: p(d),
      "as-child": h.asChild,
      as: h.as
    }, {
      default: S(() => [
        $(h.$slots, "default", { modelValue: p(l) })
      ]),
      _: 3
    }, 8, ["as-child", "as"]));
  }
}), [Db, DT] = yt("CollapsibleRoot"), PT = /* @__PURE__ */ j({
  __name: "CollapsibleRoot",
  props: {
    defaultOpen: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    disabled: { type: Boolean },
    unmountOnHide: { type: Boolean, default: !0 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:open"],
  setup(t, { expose: e, emit: n }) {
    const r = t, a = Xt(r, "open", n, {
      defaultValue: r.defaultOpen,
      passive: r.open === void 0
    }), { disabled: i, unmountOnHide: s } = Gt(r);
    return DT({
      contentId: "",
      disabled: i,
      open: a,
      unmountOnHide: s,
      onOpenToggle: () => {
        a.value = !a.value;
      }
    }), e({ open: a }), De(), (l, u) => (w(), I(p(He), {
      as: l.as,
      "as-child": r.asChild,
      "data-state": p(a) ? "open" : "closed",
      "data-disabled": p(i) ? "" : void 0
    }, {
      default: S(() => [
        $(l.$slots, "default", { open: p(a) })
      ]),
      _: 3
    }, 8, ["as", "as-child", "data-state", "data-disabled"]));
  }
}), NT = ["INPUT", "TEXTAREA"];
function Pb(t, e, n, r = {}) {
  if (!e || r.enableIgnoredElement && NT.includes(e.nodeName))
    return null;
  const {
    arrowKeyOptions: o = "both",
    attributeName: a = "[data-reka-collection-item]",
    itemsArray: i = [],
    loop: s = !0,
    dir: l = "ltr",
    preventScroll: u = !0,
    focus: c = !1
  } = r, [d, f, h, m, g, y] = [
    t.key === "ArrowRight",
    t.key === "ArrowLeft",
    t.key === "ArrowUp",
    t.key === "ArrowDown",
    t.key === "Home",
    t.key === "End"
  ], b = h || m, C = d || f;
  if (!g && !y && (!b && !C || o === "vertical" && C || o === "horizontal" && b))
    return null;
  const k = n ? Array.from(n.querySelectorAll(a)) : i;
  if (!k.length)
    return null;
  u && t.preventDefault();
  let v = null;
  return C || b ? v = Nb(k, e, {
    goForward: b ? m : l === "ltr" ? d : f,
    loop: s
  }) : g ? v = k.at(0) || null : y && (v = k.at(-1) || null), c && (v == null || v.focus()), v;
}
function Nb(t, e, n, r = t.length) {
  if (--r === 0)
    return null;
  const o = t.indexOf(e), a = n.goForward ? o + 1 : o - 1;
  if (!n.loop && (a < 0 || a >= t.length))
    return null;
  const i = (a + t.length) % t.length, s = t[i];
  return s ? s.hasAttribute("disabled") && s.getAttribute("disabled") !== "false" ? Nb(
    t,
    s,
    n,
    r
  ) : s : null;
}
const [Yp, $T] = yt("AccordionItem"), RT = /* @__PURE__ */ j({
  __name: "AccordionItem",
  props: {
    disabled: { type: Boolean },
    value: {},
    unmountOnHide: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(t, { expose: e }) {
    const n = t, r = Nc(), o = A(
      () => r.isSingle.value ? n.value === r.modelValue.value : Array.isArray(r.modelValue.value) && r.modelValue.value.includes(n.value)
    ), a = A(() => r.disabled.value || n.disabled), i = A(() => a.value ? "" : void 0), s = A(
      () => o.value ? "open" : "closed"
      /* Closed */
    );
    e({ open: o, dataDisabled: i });
    const { currentRef: l, currentElement: u } = De();
    $T({
      open: o,
      dataState: s,
      disabled: a,
      dataDisabled: i,
      triggerId: "",
      currentRef: l,
      currentElement: u,
      value: A(() => n.value)
    });
    function c(d) {
      var g;
      const f = d.target;
      if (Array.from(((g = r.parentElement.value) == null ? void 0 : g.querySelectorAll("[data-reka-collection-item]")) ?? []).findIndex((y) => y === f) === -1)
        return null;
      Pb(
        d,
        u.value,
        r.parentElement.value,
        {
          arrowKeyOptions: r.orientation,
          dir: r.direction.value,
          focus: !0
        }
      );
    }
    return (d, f) => (w(), I(p(PT), {
      "data-orientation": p(r).orientation,
      "data-disabled": i.value,
      "data-state": s.value,
      disabled: a.value,
      open: o.value,
      as: n.as,
      "as-child": n.asChild,
      "unmount-on-hide": p(r).unmountOnHide.value,
      onKeydown: to(c, ["up", "down", "left", "right", "home", "end"])
    }, {
      default: S(() => [
        $(d.$slots, "default", { open: o.value })
      ]),
      _: 3
    }, 8, ["data-orientation", "data-disabled", "data-state", "disabled", "open", "as", "as-child", "unmount-on-hide"]));
  }
});
let LT = 0;
function Bt(t, e = "reka") {
  if (t)
    return t;
  const n = Pc({ useId: void 0 });
  return vm.useId ? `${e}-${vm.useId()}` : n.useId ? `${e}-${n.useId()}` : `${e}-${++LT}`;
}
function BT(t, e) {
  const n = F(t);
  function r(a) {
    return e[n.value][a] ?? n.value;
  }
  return {
    state: n,
    dispatch: (a) => {
      n.value = r(a);
    }
  };
}
function FT(t, e) {
  var y;
  const n = F({}), r = F("none"), o = F(t), a = t.value ? "mounted" : "unmounted";
  let i;
  const s = ((y = e.value) == null ? void 0 : y.ownerDocument.defaultView) ?? Dc, { state: l, dispatch: u } = BT(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  }), c = (b) => {
    var C;
    if (Lo) {
      const k = new CustomEvent(b, { bubbles: !1, cancelable: !1 });
      (C = e.value) == null || C.dispatchEvent(k);
    }
  };
  Ke(
    t,
    async (b, C) => {
      var v;
      const k = C !== b;
      if (await nt(), k) {
        const E = r.value, _ = zl(e.value);
        b ? (u("MOUNT"), c("enter"), _ === "none" && c("after-enter")) : _ === "none" || _ === "undefined" || ((v = n.value) == null ? void 0 : v.display) === "none" ? (u("UNMOUNT"), c("leave"), c("after-leave")) : C && E !== _ ? (u("ANIMATION_OUT"), c("leave")) : (u("UNMOUNT"), c("after-leave"));
      }
    },
    { immediate: !0 }
  );
  const d = (b) => {
    const C = zl(e.value), k = C.includes(
      b.animationName
    ), v = l.value === "mounted" ? "enter" : "leave";
    if (b.target === e.value && k && (c(`after-${v}`), u("ANIMATION_END"), !o.value)) {
      const E = e.value.style.animationFillMode;
      e.value.style.animationFillMode = "forwards", i = s == null ? void 0 : s.setTimeout(() => {
        var _;
        ((_ = e.value) == null ? void 0 : _.style.animationFillMode) === "forwards" && (e.value.style.animationFillMode = E);
      });
    }
    b.target === e.value && C === "none" && u("ANIMATION_END");
  }, f = (b) => {
    b.target === e.value && (r.value = zl(e.value));
  }, h = Ke(
    e,
    (b, C) => {
      b ? (n.value = getComputedStyle(b), b.addEventListener("animationstart", f), b.addEventListener("animationcancel", d), b.addEventListener("animationend", d)) : (u("ANIMATION_END"), i !== void 0 && (s == null || s.clearTimeout(i)), C == null || C.removeEventListener("animationstart", f), C == null || C.removeEventListener("animationcancel", d), C == null || C.removeEventListener("animationend", d));
    },
    { immediate: !0 }
  ), m = Ke(l, () => {
    const b = zl(e.value);
    r.value = l.value === "mounted" ? b : "none";
  });
  return En(() => {
    h(), m();
  }), {
    isPresent: A(
      () => ["mounted", "unmountSuspended"].includes(l.value)
    )
  };
}
function zl(t) {
  return t && getComputedStyle(t).animationName || "none";
}
const Rr = j({
  name: "Presence",
  props: {
    present: {
      type: Boolean,
      required: !0
    },
    forceMount: {
      type: Boolean
    }
  },
  slots: {},
  setup(t, { slots: e, expose: n }) {
    var u;
    const { present: r, forceMount: o } = Gt(t), a = F(), { isPresent: i } = FT(r, a);
    n({ present: i });
    let s = e.default({ present: i.value });
    s = jp(s || []);
    const l = Cn();
    if (s && (s == null ? void 0 : s.length) > 1) {
      const c = (u = l == null ? void 0 : l.parent) != null && u.type.name ? `<${l.parent.type.name} />` : "component";
      throw new Error(
        [
          `Detected an invalid children for \`${c}\` for  \`Presence\` component.`,
          "",
          "Note: Presence works similarly to `v-if` directly, but it waits for animation/transition to finished before unmounting. So it expect only one direct child of valid VNode type.",
          "You can apply a few solutions:",
          [
            "Provide a single child element so that `presence` directive attach correctly.",
            "Ensure the first child is an actual element instead of a raw text node or comment node."
          ].map((d) => `  - ${d}`).join(`
`)
        ].join(`
`)
      );
    }
    return () => o.value || r.value || i.value ? Kn(e.default({ present: i.value })[0], {
      ref: (c) => {
        const d = ro(c);
        return typeof (d == null ? void 0 : d.hasAttribute) > "u" || (d != null && d.hasAttribute("data-reka-popper-content-wrapper") ? a.value = d.firstElementChild : a.value = d), d;
      }
    }) : null;
  }
}), VT = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "CollapsibleContent",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["contentFound"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = Db();
    o.contentId || (o.contentId = Bt(void 0, "reka-collapsible-content"));
    const a = F(), { forwardRef: i, currentElement: s } = De(), l = F(0), u = F(0), c = A(() => o.open.value), d = F(c.value), f = F();
    Ke(
      () => {
        var m;
        return [c.value, (m = a.value) == null ? void 0 : m.present];
      },
      async () => {
        await nt();
        const m = s.value;
        if (!m)
          return;
        f.value = f.value || {
          transitionDuration: m.style.transitionDuration,
          animationName: m.style.animationName
        }, m.style.transitionDuration = "0s", m.style.animationName = "none";
        const g = m.getBoundingClientRect();
        u.value = g.height, l.value = g.width, d.value || (m.style.transitionDuration = f.value.transitionDuration, m.style.animationName = f.value.animationName);
      },
      {
        immediate: !0
      }
    );
    const h = A(() => d.value && o.open.value);
    return ze(() => {
      requestAnimationFrame(() => {
        d.value = !1;
      });
    }), No(s, "beforematch", (m) => {
      requestAnimationFrame(() => {
        o.onOpenToggle(), r("contentFound");
      });
    }), (m, g) => (w(), I(p(Rr), {
      ref_key: "presentRef",
      ref: a,
      present: m.forceMount || p(o).open.value,
      "force-mount": !0
    }, {
      default: S(({ present: y }) => {
        var b;
        return [
          q(p(He), oe(m.$attrs, {
            id: p(o).contentId,
            ref: p(i),
            "as-child": n.asChild,
            as: m.as,
            hidden: y ? void 0 : p(o).unmountOnHide.value ? "" : "until-found",
            "data-state": h.value ? void 0 : p(o).open.value ? "open" : "closed",
            "data-disabled": (b = p(o).disabled) != null && b.value ? "" : void 0,
            style: {
              "--reka-collapsible-content-height": `${u.value}px`,
              "--reka-collapsible-content-width": `${l.value}px`
            }
          }), {
            default: S(() => [
              !p(o).unmountOnHide.value || y ? $(m.$slots, "default", { key: 0 }) : V("", !0)
            ]),
            _: 2
          }, 1040, ["id", "as-child", "as", "hidden", "data-state", "data-disabled", "style"])
        ];
      }),
      _: 3
    }, 8, ["present"]));
  }
}), HT = /* @__PURE__ */ j({
  __name: "AccordionContent",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const e = t, n = Nc(), r = Yp();
    return De(), (o, a) => (w(), I(p(VT), {
      role: "region",
      "as-child": e.asChild,
      as: o.as,
      "force-mount": e.forceMount,
      "aria-labelledby": p(r).triggerId,
      "data-state": p(r).dataState.value,
      "data-disabled": p(r).dataDisabled.value,
      "data-orientation": p(n).orientation,
      style: { "--reka-accordion-content-width": "var(--reka-collapsible-content-width)", "--reka-accordion-content-height": "var(--reka-collapsible-content-height)" },
      onContentFound: a[0] || (a[0] = (i) => p(n).changeModelValue(p(r).value.value))
    }, {
      default: S(() => [
        $(o.$slots, "default")
      ]),
      _: 3
    }, 8, ["as-child", "as", "force-mount", "aria-labelledby", "data-state", "data-disabled", "data-orientation"]));
  }
}), UT = /* @__PURE__ */ j({
  __name: "AccordionHeader",
  props: {
    asChild: { type: Boolean },
    as: { default: "h3" }
  },
  setup(t) {
    const e = t, n = Nc(), r = Yp();
    return De(), (o, a) => (w(), I(p(He), {
      as: e.as,
      "as-child": e.asChild,
      "data-orientation": p(n).orientation,
      "data-state": p(r).dataState.value,
      "data-disabled": p(r).dataDisabled.value
    }, {
      default: S(() => [
        $(o.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child", "data-orientation", "data-state", "data-disabled"]));
  }
}), WT = /* @__PURE__ */ j({
  __name: "CollapsibleTrigger",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(t) {
    const e = t;
    De();
    const n = Db();
    return (r, o) => {
      var a, i;
      return w(), I(p(He), {
        type: r.as === "button" ? "button" : void 0,
        as: r.as,
        "as-child": e.asChild,
        "aria-controls": p(n).contentId,
        "aria-expanded": p(n).open.value,
        "data-state": p(n).open.value ? "open" : "closed",
        "data-disabled": (a = p(n).disabled) != null && a.value ? "" : void 0,
        disabled: (i = p(n).disabled) == null ? void 0 : i.value,
        onClick: p(n).onOpenToggle
      }, {
        default: S(() => [
          $(r.$slots, "default")
        ]),
        _: 3
      }, 8, ["type", "as", "as-child", "aria-controls", "aria-expanded", "data-state", "data-disabled", "disabled", "onClick"]);
    };
  }
}), KT = /* @__PURE__ */ j({
  __name: "AccordionTrigger",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const e = t, n = Nc(), r = Yp();
    r.triggerId || (r.triggerId = Bt(void 0, "reka-accordion-trigger"));
    function o() {
      const a = n.isSingle.value && r.open.value && !n.collapsible;
      r.disabled.value || a || n.changeModelValue(r.value.value);
    }
    return (a, i) => (w(), I(p(WT), {
      id: p(r).triggerId,
      ref: p(r).currentRef,
      "data-reka-collection-item": "",
      as: e.as,
      "as-child": e.asChild,
      "aria-disabled": p(r).disabled.value || void 0,
      "aria-expanded": p(r).open.value || !1,
      "data-disabled": p(r).dataDisabled.value,
      "data-orientation": p(n).orientation,
      "data-state": p(r).dataState.value,
      disabled: p(r).disabled.value,
      onClick: o
    }, {
      default: S(() => [
        $(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["id", "as", "as-child", "aria-disabled", "aria-expanded", "data-disabled", "data-orientation", "data-state", "disabled"]));
  }
}), [po, jT] = yt("DialogRoot"), zT = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "DialogRoot",
  props: {
    open: { type: Boolean, default: void 0 },
    defaultOpen: { type: Boolean, default: !1 },
    modal: { type: Boolean, default: !0 }
  },
  emits: ["update:open"],
  setup(t, { emit: e }) {
    const n = t, o = Xt(n, "open", e, {
      defaultValue: n.defaultOpen,
      passive: n.open === void 0
    }), a = F(), i = F(), { modal: s } = Gt(n);
    return jT({
      open: o,
      modal: s,
      openModal: () => {
        o.value = !0;
      },
      onOpenChange: (l) => {
        o.value = l;
      },
      onOpenToggle: () => {
        o.value = !o.value;
      },
      contentId: "",
      titleId: "",
      descriptionId: "",
      triggerElement: a,
      contentElement: i
    }), (l, u) => $(l.$slots, "default", { open: p(o) });
  }
}), YT = /* @__PURE__ */ j({
  __name: "DialogClose",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(t) {
    const e = t;
    De();
    const n = po();
    return (r, o) => (w(), I(p(He), oe(e, {
      type: r.as === "button" ? "button" : void 0,
      onClick: o[0] || (o[0] = (a) => p(n).onOpenChange(!1))
    }), {
      default: S(() => [
        $(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["type"]));
  }
});
function Ol(t) {
  const e = Cn(), n = e == null ? void 0 : e.type.emits, r = {};
  return n != null && n.length || console.warn(
    `No emitted event found. Please check component: ${e == null ? void 0 : e.type.__name}`
  ), n == null || n.forEach((o) => {
    r[e_(Dy(o))] = (...a) => t(o, ...a);
  }), r;
}
function Tl(t, e, n) {
  const r = n.originalEvent.target, o = new CustomEvent(t, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  e && r.addEventListener(t, e, { once: !0 }), r.dispatchEvent(o);
}
const qT = "dismissableLayer.pointerDownOutside", GT = "dismissableLayer.focusOutside";
function $b(t, e) {
  const n = e.closest(
    "[data-dismissable-layer]"
  ), r = t.dataset.dismissableLayer === "" ? t : t.querySelector(
    "[data-dismissable-layer]"
  ), o = Array.from(
    t.ownerDocument.querySelectorAll("[data-dismissable-layer]")
  );
  return !!(n && (r === n || o.indexOf(r) < o.indexOf(n)));
}
function JT(t, e) {
  var a;
  const n = ((a = e == null ? void 0 : e.value) == null ? void 0 : a.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), r = F(!1), o = F(() => {
  });
  return Nn((i) => {
    if (!Lo)
      return;
    const s = async (u) => {
      const c = u.target;
      if (!(!(e != null && e.value) || !c)) {
        if ($b(e.value, c)) {
          r.value = !1;
          return;
        }
        if (u.target && !r.value) {
          let d = function() {
            Tl(
              qT,
              t,
              f
            );
          };
          const f = { originalEvent: u };
          u.pointerType === "touch" ? (n.removeEventListener("click", o.value), o.value = d, n.addEventListener("click", o.value, {
            once: !0
          })) : d();
        } else
          n.removeEventListener("click", o.value);
        r.value = !1;
      }
    }, l = window.setTimeout(() => {
      n.addEventListener("pointerdown", s);
    }, 0);
    i(() => {
      window.clearTimeout(l), n.removeEventListener("pointerdown", s), n.removeEventListener("click", o.value);
    });
  }), {
    onPointerDownCapture: () => r.value = !0
  };
}
function XT(t, e) {
  var o;
  const n = ((o = e == null ? void 0 : e.value) == null ? void 0 : o.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), r = F(!1);
  return Nn((a) => {
    if (!Lo)
      return;
    const i = async (s) => {
      if (!(e != null && e.value))
        return;
      await nt(), await nt();
      const l = s.target;
      !e.value || !l || $b(e.value, l) || s.target && !r.value && Tl(
        GT,
        t,
        { originalEvent: s }
      );
    };
    n.addEventListener("focusin", i), a(() => n.removeEventListener("focusin", i));
  }), {
    onFocusCapture: () => r.value = !0,
    onBlurCapture: () => r.value = !1
  };
}
const vo = eo({
  layersRoot: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), ds = /* @__PURE__ */ j({
  __name: "DismissableLayer",
  props: {
    disableOutsidePointerEvents: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss"],
  setup(t, { emit: e }) {
    const n = t, r = e, { forwardRef: o, currentElement: a } = De(), i = A(
      () => {
        var m;
        return ((m = a.value) == null ? void 0 : m.ownerDocument) ?? globalThis.document;
      }
    ), s = A(() => vo.layersRoot), l = A(() => a.value ? Array.from(s.value).indexOf(a.value) : -1), u = A(() => vo.layersWithOutsidePointerEventsDisabled.size > 0), c = A(() => {
      const m = Array.from(s.value), [g] = [...vo.layersWithOutsidePointerEventsDisabled].slice(-1), y = m.indexOf(g);
      return l.value >= y;
    }), d = JT(async (m) => {
      const g = [...vo.branches].some(
        (y) => y == null ? void 0 : y.contains(m.target)
      );
      !c.value || g || (r("pointerDownOutside", m), r("interactOutside", m), await nt(), m.defaultPrevented || r("dismiss"));
    }, a), f = XT((m) => {
      [...vo.branches].some(
        (y) => y == null ? void 0 : y.contains(m.target)
      ) || (r("focusOutside", m), r("interactOutside", m), m.defaultPrevented || r("dismiss"));
    }, a);
    _T("Escape", (m) => {
      l.value === s.value.size - 1 && (r("escapeKeyDown", m), m.defaultPrevented || r("dismiss"));
    });
    let h;
    return Nn((m) => {
      a.value && (n.disableOutsidePointerEvents && (vo.layersWithOutsidePointerEventsDisabled.size === 0 && (h = i.value.body.style.pointerEvents, i.value.body.style.pointerEvents = "none"), vo.layersWithOutsidePointerEventsDisabled.add(a.value)), s.value.add(a.value), m(() => {
        n.disableOutsidePointerEvents && vo.layersWithOutsidePointerEventsDisabled.size === 1 && (i.value.body.style.pointerEvents = h);
      }));
    }), Nn((m) => {
      m(() => {
        a.value && (s.value.delete(a.value), vo.layersWithOutsidePointerEventsDisabled.delete(a.value));
      });
    }), (m, g) => (w(), I(p(He), {
      ref: p(o),
      "as-child": m.asChild,
      as: m.as,
      "data-dismissable-layer": "",
      style: Lt({
        pointerEvents: u.value ? c.value ? "auto" : "none" : void 0
      }),
      onFocusCapture: p(f).onFocusCapture,
      onBlurCapture: p(f).onBlurCapture,
      onPointerdownCapture: p(d).onPointerDownCapture
    }, {
      default: S(() => [
        $(m.$slots, "default")
      ]),
      _: 3
    }, 8, ["as-child", "as", "style", "onFocusCapture", "onBlurCapture", "onPointerdownCapture"]));
  }
});
function Pn() {
  let t = document.activeElement;
  if (t == null)
    return null;
  for (; t != null && t.shadowRoot != null && t.shadowRoot.activeElement != null; )
    t = t.shadowRoot.activeElement;
  return t;
}
const QT = "menu.itemSelect", xf = ["Enter", " "], ZT = ["ArrowDown", "PageUp", "Home"], Rb = ["ArrowUp", "PageDown", "End"], eS = [...ZT, ...Rb], tS = {
  ltr: [...xf, "ArrowRight"],
  rtl: [...xf, "ArrowLeft"]
}, nS = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
};
function qp(t) {
  return t ? "open" : "closed";
}
function Af(t) {
  const e = Pn();
  for (const n of t)
    if (n === e || (n.focus(), Pn() !== e))
      return;
}
function rS(t, e) {
  const { x: n, y: r } = t;
  let o = !1;
  for (let a = 0, i = e.length - 1; a < e.length; i = a++) {
    const s = e[a].x, l = e[a].y, u = e[i].x, c = e[i].y;
    l > r != c > r && n < (u - s) * (r - l) / (c - l) + s && (o = !o);
  }
  return o;
}
function oS(t, e) {
  if (!e)
    return !1;
  const n = { x: t.clientX, y: t.clientY };
  return rS(n, e);
}
function rl(t) {
  return t.pointerType === "mouse";
}
const aS = "DialogTitle", iS = "DialogContent";
function sS({
  titleName: t = aS,
  contentName: e = iS,
  componentLink: n = "dialog.html#title",
  titleId: r,
  descriptionId: o,
  contentElement: a
}) {
  const i = `Warning: \`${e}\` requires a \`${t}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://www.reka-ui.com/docs/components/${n}`, s = `Warning: Missing \`Description\` or \`aria-describedby="undefined"\` for ${e}.`;
  ze(() => {
    var c;
    document.getElementById(r) || console.warn(i);
    const u = (c = a.value) == null ? void 0 : c.getAttribute("aria-describedby");
    o && u && (document.getElementById(o) || console.warn(s));
  });
}
const lS = lT(() => F([]));
function uS() {
  const t = lS();
  return {
    add(e) {
      const n = t.value[0];
      e !== n && (n == null || n.pause()), t.value = dg(t.value, e), t.value.unshift(e);
    },
    remove(e) {
      var n;
      t.value = dg(t.value, e), (n = t.value[0]) == null || n.resume();
    }
  };
}
function dg(t, e) {
  const n = [...t], r = n.indexOf(e);
  return r !== -1 && n.splice(r, 1), n;
}
function cS(t) {
  return t.filter((e) => e.tagName !== "A");
}
const md = "focusScope.autoFocusOnMount", gd = "focusScope.autoFocusOnUnmount", fg = { bubbles: !1, cancelable: !0 };
function dS(t, { select: e = !1 } = {}) {
  const n = Pn();
  for (const r of t)
    if (Ko(r, { select: e }), Pn() !== n)
      return !0;
}
function fS(t) {
  const e = Lb(t), n = pg(e, t), r = pg(e.reverse(), t);
  return [n, r];
}
function Lb(t) {
  const e = [], n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) e.push(n.currentNode);
  return e;
}
function pg(t, e) {
  for (const n of t)
    if (!pS(n, { upTo: e }))
      return n;
}
function pS(t, { upTo: e }) {
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  for (; t; ) {
    if (e !== void 0 && t === e)
      return !1;
    if (getComputedStyle(t).display === "none")
      return !0;
    t = t.parentElement;
  }
  return !1;
}
function hS(t) {
  return t instanceof HTMLInputElement && "select" in t;
}
function Ko(t, { select: e = !1 } = {}) {
  if (t && t.focus) {
    const n = Pn();
    t.focus({ preventScroll: !0 }), t !== n && hS(t) && e && t.select();
  }
}
const $c = /* @__PURE__ */ j({
  __name: "FocusScope",
  props: {
    loop: { type: Boolean, default: !1 },
    trapped: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["mountAutoFocus", "unmountAutoFocus"],
  setup(t, { emit: e }) {
    const n = t, r = e, { currentRef: o, currentElement: a } = De(), i = F(null), s = uS(), l = eo({
      paused: !1,
      pause() {
        this.paused = !0;
      },
      resume() {
        this.paused = !1;
      }
    });
    Nn((c) => {
      if (!Lo)
        return;
      const d = a.value;
      if (!n.trapped)
        return;
      function f(y) {
        if (l.paused || !d)
          return;
        const b = y.target;
        d.contains(b) ? i.value = b : Ko(i.value, { select: !0 });
      }
      function h(y) {
        if (l.paused || !d)
          return;
        const b = y.relatedTarget;
        b !== null && (d.contains(b) || Ko(i.value, { select: !0 }));
      }
      function m(y) {
        d.contains(i.value) || Ko(d);
      }
      document.addEventListener("focusin", f), document.addEventListener("focusout", h);
      const g = new MutationObserver(m);
      d && g.observe(d, { childList: !0, subtree: !0 }), c(() => {
        document.removeEventListener("focusin", f), document.removeEventListener("focusout", h), g.disconnect();
      });
    }), Nn(async (c) => {
      const d = a.value;
      if (await nt(), !d)
        return;
      s.add(l);
      const f = Pn();
      if (!d.contains(f)) {
        const m = new CustomEvent(md, fg);
        d.addEventListener(md, (g) => r("mountAutoFocus", g)), d.dispatchEvent(m), m.defaultPrevented || (dS(cS(Lb(d)), {
          select: !0
        }), Pn() === f && Ko(d));
      }
      c(() => {
        d.removeEventListener(md, (y) => r("mountAutoFocus", y));
        const m = new CustomEvent(gd, fg), g = (y) => {
          r("unmountAutoFocus", y);
        };
        d.addEventListener(gd, g), d.dispatchEvent(m), setTimeout(() => {
          m.defaultPrevented || Ko(f ?? document.body, { select: !0 }), d.removeEventListener(gd, g), s.remove(l);
        }, 0);
      });
    });
    function u(c) {
      if (!n.loop && !n.trapped || l.paused)
        return;
      const d = c.key === "Tab" && !c.altKey && !c.ctrlKey && !c.metaKey, f = Pn();
      if (d && f) {
        const h = c.currentTarget, [m, g] = fS(h);
        m && g ? !c.shiftKey && f === g ? (c.preventDefault(), n.loop && Ko(m, { select: !0 })) : c.shiftKey && f === m && (c.preventDefault(), n.loop && Ko(g, { select: !0 })) : f === h && c.preventDefault();
      }
    }
    return (c, d) => (w(), I(p(He), {
      ref_key: "currentRef",
      ref: o,
      tabindex: "-1",
      "as-child": c.asChild,
      as: c.as,
      onKeydown: u
    }, {
      default: S(() => [
        $(c.$slots, "default")
      ]),
      _: 3
    }, 8, ["as-child", "as"]));
  }
}), Bb = /* @__PURE__ */ j({
  __name: "DialogContentImpl",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = po(), { forwardRef: a, currentElement: i } = De();
    return o.titleId || (o.titleId = Bt(void 0, "reka-dialog-title")), o.descriptionId || (o.descriptionId = Bt(void 0, "reka-dialog-description")), ze(() => {
      o.contentElement = i, Pn() !== document.body && (o.triggerElement.value = Pn());
    }), process.env.NODE_ENV !== "production" && sS({
      titleName: "DialogTitle",
      contentName: "DialogContent",
      componentLink: "dialog.html#title",
      titleId: o.titleId,
      descriptionId: o.descriptionId,
      contentElement: i
    }), (s, l) => (w(), I(p($c), {
      "as-child": "",
      loop: "",
      trapped: n.trapFocus,
      onMountAutoFocus: l[5] || (l[5] = (u) => r("openAutoFocus", u)),
      onUnmountAutoFocus: l[6] || (l[6] = (u) => r("closeAutoFocus", u))
    }, {
      default: S(() => [
        q(p(ds), oe({
          id: p(o).contentId,
          ref: p(a),
          as: s.as,
          "as-child": s.asChild,
          "disable-outside-pointer-events": s.disableOutsidePointerEvents,
          role: "dialog",
          "aria-describedby": p(o).descriptionId,
          "aria-labelledby": p(o).titleId,
          "data-state": p(qp)(p(o).open.value)
        }, s.$attrs, {
          onDismiss: l[0] || (l[0] = (u) => p(o).onOpenChange(!1)),
          onEscapeKeyDown: l[1] || (l[1] = (u) => r("escapeKeyDown", u)),
          onFocusOutside: l[2] || (l[2] = (u) => r("focusOutside", u)),
          onInteractOutside: l[3] || (l[3] = (u) => r("interactOutside", u)),
          onPointerDownOutside: l[4] || (l[4] = (u) => r("pointerDownOutside", u))
        }), {
          default: S(() => [
            $(s.$slots, "default")
          ]),
          _: 3
        }, 16, ["id", "as", "as-child", "disable-outside-pointer-events", "aria-describedby", "aria-labelledby", "data-state"])
      ]),
      _: 3
    }, 8, ["trapped"]));
  }
});
var mS = function(t) {
  if (typeof document > "u")
    return null;
  var e = Array.isArray(t) ? t[0] : t;
  return e.ownerDocument.body;
}, hi = /* @__PURE__ */ new WeakMap(), Yl = /* @__PURE__ */ new WeakMap(), ql = {}, vd = 0, Fb = function(t) {
  return t && (t.host || Fb(t.parentNode));
}, gS = function(t, e) {
  return e.map(function(n) {
    if (t.contains(n))
      return n;
    var r = Fb(n);
    return r && t.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", t, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, vS = function(t, e, n, r) {
  var o = gS(e, Array.isArray(t) ? t : [t]);
  ql[n] || (ql[n] = /* @__PURE__ */ new WeakMap());
  var a = ql[n], i = [], s = /* @__PURE__ */ new Set(), l = new Set(o), u = function(d) {
    !d || s.has(d) || (s.add(d), u(d.parentNode));
  };
  o.forEach(u);
  var c = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(f) {
      if (s.has(f))
        c(f);
      else
        try {
          var h = f.getAttribute(r), m = h !== null && h !== "false", g = (hi.get(f) || 0) + 1, y = (a.get(f) || 0) + 1;
          hi.set(f, g), a.set(f, y), i.push(f), g === 1 && m && Yl.set(f, !0), y === 1 && f.setAttribute(n, "true"), m || f.setAttribute(r, "true");
        } catch (b) {
          console.error("aria-hidden: cannot operate on ", f, b);
        }
    });
  };
  return c(e), s.clear(), vd++, function() {
    i.forEach(function(d) {
      var f = hi.get(d) - 1, h = a.get(d) - 1;
      hi.set(d, f), a.set(d, h), f || (Yl.has(d) || d.removeAttribute(r), Yl.delete(d)), h || d.removeAttribute(n);
    }), vd--, vd || (hi = /* @__PURE__ */ new WeakMap(), hi = /* @__PURE__ */ new WeakMap(), Yl = /* @__PURE__ */ new WeakMap(), ql = {});
  };
}, yS = function(t, e, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(t) ? t : [t]), o = mS(t);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), vS(r, o, n, "aria-hidden")) : function() {
    return null;
  };
};
function Sl(t) {
  let e;
  Ke(() => ro(t), (n) => {
    n ? e = yS(n) : e && e();
  }), En(() => {
    e && e();
  });
}
const bS = /* @__PURE__ */ j({
  __name: "DialogContentModal",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = po(), a = Ol(r), { forwardRef: i, currentElement: s } = De();
    return Sl(s), (l, u) => (w(), I(Bb, oe({ ...n, ...p(a) }, {
      ref: p(i),
      "trap-focus": p(o).open.value,
      "disable-outside-pointer-events": !0,
      onCloseAutoFocus: u[0] || (u[0] = (c) => {
        var d;
        c.defaultPrevented || (c.preventDefault(), (d = p(o).triggerElement.value) == null || d.focus());
      }),
      onPointerDownOutside: u[1] || (u[1] = (c) => {
        const d = c.detail.originalEvent, f = d.button === 0 && d.ctrlKey === !0;
        (d.button === 2 || f) && c.preventDefault();
      }),
      onFocusOutside: u[2] || (u[2] = (c) => {
        c.preventDefault();
      })
    }), {
      default: S(() => [
        $(l.$slots, "default")
      ]),
      _: 3
    }, 16, ["trap-focus"]));
  }
}), kS = /* @__PURE__ */ j({
  __name: "DialogContentNonModal",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(t, { emit: e }) {
    const n = t, o = Ol(e);
    De();
    const a = po(), i = F(!1), s = F(!1);
    return (l, u) => (w(), I(Bb, oe({ ...n, ...p(o) }, {
      "trap-focus": !1,
      "disable-outside-pointer-events": !1,
      onCloseAutoFocus: u[0] || (u[0] = (c) => {
        var d;
        c.defaultPrevented || (i.value || (d = p(a).triggerElement.value) == null || d.focus(), c.preventDefault()), i.value = !1, s.value = !1;
      }),
      onInteractOutside: u[1] || (u[1] = (c) => {
        var h;
        c.defaultPrevented || (i.value = !0, c.detail.originalEvent.type === "pointerdown" && (s.value = !0));
        const d = c.target;
        ((h = p(a).triggerElement.value) == null ? void 0 : h.contains(d)) && c.preventDefault(), c.detail.originalEvent.type === "focusin" && s.value && c.preventDefault();
      })
    }), {
      default: S(() => [
        $(l.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), wS = /* @__PURE__ */ j({
  __name: "DialogContent",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = po(), a = Ol(r), { forwardRef: i } = De();
    return (s, l) => (w(), I(p(Rr), {
      present: s.forceMount || p(o).open.value
    }, {
      default: S(() => [
        p(o).modal.value ? (w(), I(bS, oe({
          key: 0,
          ref: p(i)
        }, { ...n, ...p(a), ...s.$attrs }), {
          default: S(() => [
            $(s.$slots, "default")
          ]),
          _: 3
        }, 16)) : (w(), I(kS, oe({
          key: 1,
          ref: p(i)
        }, { ...n, ...p(a), ...s.$attrs }), {
          default: S(() => [
            $(s.$slots, "default")
          ]),
          _: 3
        }, 16))
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), _S = /* @__PURE__ */ j({
  __name: "DialogDescription",
  props: {
    asChild: { type: Boolean },
    as: { default: "p" }
  },
  setup(t) {
    const e = t;
    De();
    const n = po();
    return (r, o) => (w(), I(p(He), oe(e, {
      id: p(n).descriptionId
    }), {
      default: S(() => [
        $(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["id"]));
  }
});
function yd(t) {
  if (t === null || typeof t != "object")
    return !1;
  const e = Object.getPrototypeOf(t);
  return e !== null && e !== Object.prototype && Object.getPrototypeOf(e) !== null || Symbol.iterator in t ? !1 : Symbol.toStringTag in t ? Object.prototype.toString.call(t) === "[object Module]" : !0;
}
function Mf(t, e, n = ".", r) {
  if (!yd(e))
    return Mf(t, {}, n, r);
  const o = Object.assign({}, e);
  for (const a in t) {
    if (a === "__proto__" || a === "constructor")
      continue;
    const i = t[a];
    i != null && (r && r(o, a, i, n) || (Array.isArray(i) && Array.isArray(o[a]) ? o[a] = [...i, ...o[a]] : yd(i) && yd(o[a]) ? o[a] = Mf(
      i,
      o[a],
      (n ? `${n}.` : "") + a.toString(),
      r
    ) : o[a] = i));
  }
  return o;
}
function CS(t) {
  return (...e) => (
    // eslint-disable-next-line unicorn/no-array-reduce
    e.reduce((n, r) => Mf(n, r, "", t), {})
  );
}
const ES = CS(), OS = Ab(() => {
  const t = F(/* @__PURE__ */ new Map()), e = F(), n = A(() => {
    for (const i of t.value.values())
      if (i)
        return !0;
    return !1;
  }), r = Pc({
    scrollBody: F(!0)
  });
  let o = null;
  const a = () => {
    document.body.style.paddingRight = "", document.body.style.marginRight = "", document.body.style.pointerEvents = "", document.body.style.removeProperty("--scrollbar-width"), document.body.style.overflow = e.value ?? "", ug && (o == null || o()), e.value = void 0;
  };
  return Ke(n, (i, s) => {
    var d;
    if (!Lo)
      return;
    if (!i) {
      s && a();
      return;
    }
    e.value === void 0 && (e.value = document.body.style.overflow);
    const l = window.innerWidth - document.documentElement.clientWidth, u = { padding: l, margin: 0 }, c = (d = r.scrollBody) != null && d.value ? typeof r.scrollBody.value == "object" ? ES({
      padding: r.scrollBody.value.padding === !0 ? l : r.scrollBody.value.padding,
      margin: r.scrollBody.value.margin === !0 ? l : r.scrollBody.value.margin
    }, u) : u : { padding: 0, margin: 0 };
    l > 0 && (document.body.style.paddingRight = typeof c.padding == "number" ? `${c.padding}px` : String(c.padding), document.body.style.marginRight = typeof c.margin == "number" ? `${c.margin}px` : String(c.margin), document.body.style.setProperty("--scrollbar-width", `${l}px`), document.body.style.overflow = "hidden"), ug && (o = No(
      document,
      "touchmove",
      (f) => TS(f),
      { passive: !1 }
    )), nt(() => {
      document.body.style.pointerEvents = "none", document.body.style.overflow = "hidden";
    });
  }, { immediate: !0, flush: "sync" }), t;
});
function xl(t) {
  const e = Math.random().toString(36).substring(2, 7), n = OS();
  n.value.set(e, t ?? !1);
  const r = A({
    get: () => n.value.get(e) ?? !1,
    set: (o) => n.value.set(e, o)
  });
  return yT(() => {
    n.value.delete(e);
  }), r;
}
function Vb(t) {
  const e = window.getComputedStyle(t);
  if (e.overflowX === "scroll" || e.overflowY === "scroll" || e.overflowX === "auto" && t.clientWidth < t.scrollWidth || e.overflowY === "auto" && t.clientHeight < t.scrollHeight)
    return !0;
  {
    const n = t.parentNode;
    return !(n instanceof Element) || n.tagName === "BODY" ? !1 : Vb(n);
  }
}
function TS(t) {
  const e = t || window.event, n = e.target;
  return n instanceof Element && Vb(n) ? !1 : e.touches.length > 1 ? !0 : (e.preventDefault && e.cancelable && e.preventDefault(), !1);
}
const SS = /* @__PURE__ */ j({
  __name: "DialogOverlayImpl",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const e = po();
    return xl(!0), De(), (n, r) => (w(), I(p(He), {
      as: n.as,
      "as-child": n.asChild,
      "data-state": p(e).open.value ? "open" : "closed",
      style: { "pointer-events": "auto" }
    }, {
      default: S(() => [
        $(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child", "data-state"]));
  }
}), xS = /* @__PURE__ */ j({
  __name: "DialogOverlay",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const e = po(), { forwardRef: n } = De();
    return (r, o) => {
      var a;
      return (a = p(e)) != null && a.modal.value ? (w(), I(p(Rr), {
        key: 0,
        present: r.forceMount || p(e).open.value
      }, {
        default: S(() => [
          q(SS, oe(r.$attrs, {
            ref: p(n),
            as: r.as,
            "as-child": r.asChild
          }), {
            default: S(() => [
              $(r.$slots, "default")
            ]),
            _: 3
          }, 16, ["as", "as-child"])
        ]),
        _: 3
      }, 8, ["present"])) : V("", !0);
    };
  }
}), fs = /* @__PURE__ */ j({
  __name: "Teleport",
  props: {
    to: { default: "body" },
    disabled: { type: Boolean },
    defer: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(t) {
    const e = Ib();
    return (n, r) => p(e) || n.forceMount ? (w(), I(wc, {
      key: 0,
      to: n.to,
      disabled: n.disabled,
      defer: n.defer
    }, [
      $(n.$slots, "default")
    ], 8, ["to", "disabled", "defer"])) : V("", !0);
  }
});
function ps(t) {
  const e = Cn(), n = Object.keys((e == null ? void 0 : e.type.props) ?? {}).reduce((o, a) => {
    const i = (e == null ? void 0 : e.type.props[a]).default;
    return i !== void 0 && (o[a] = i), o;
  }, {}), r = Bi(t);
  return A(() => {
    const o = {}, a = (e == null ? void 0 : e.vnode.props) ?? {};
    return Object.keys(a).forEach((i) => {
      o[Dy(i)] = a[i];
    }), Object.keys({ ...n, ...o }).reduce((i, s) => (r.value[s] !== void 0 && (i[s] = r.value[s]), i), {});
  });
}
function vr(t, e) {
  const n = ps(t), r = e ? Ol(e) : {};
  return A(() => ({
    ...n.value,
    ...r
  }));
}
const hg = /* @__PURE__ */ j({
  __name: "DialogTitle",
  props: {
    asChild: { type: Boolean },
    as: { default: "h2" }
  },
  setup(t) {
    const e = t, n = po();
    return De(), (r, o) => (w(), I(p(He), oe(e, {
      id: p(n).titleId
    }), {
      default: S(() => [
        $(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["id"]));
  }
}), AS = /* @__PURE__ */ j({
  __name: "DialogTrigger",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(t) {
    const e = t, n = po(), { forwardRef: r, currentElement: o } = De();
    return n.contentId || (n.contentId = Bt(void 0, "reka-dialog-content")), ze(() => {
      n.triggerElement.value = o.value;
    }), (a, i) => (w(), I(p(He), oe(e, {
      ref: p(r),
      type: a.as === "button" ? "button" : void 0,
      "aria-haspopup": "dialog",
      "aria-expanded": p(n).open.value || !1,
      "aria-controls": p(n).open.value ? p(n).contentId : void 0,
      "data-state": p(n).open.value ? "open" : "closed",
      onClick: p(n).onOpenToggle
    }), {
      default: S(() => [
        $(a.$slots, "default")
      ]),
      _: 3
    }, 16, ["type", "aria-expanded", "aria-controls", "data-state", "onClick"]));
  }
});
function Ja() {
  const t = F(), e = A(() => {
    var n, r;
    return ["#text", "#comment"].includes((n = t.value) == null ? void 0 : n.$el.nodeName) ? (r = t.value) == null ? void 0 : r.$el.nextElementSibling : ro(t);
  });
  return {
    primitiveElement: t,
    currentElement: e
  };
}
function MS() {
  return {
    ALT: "Alt",
    ARROW_DOWN: "ArrowDown",
    ARROW_LEFT: "ArrowLeft",
    ARROW_RIGHT: "ArrowRight",
    ARROW_UP: "ArrowUp",
    BACKSPACE: "Backspace",
    CAPS_LOCK: "CapsLock",
    CONTROL: "Control",
    DELETE: "Delete",
    END: "End",
    ENTER: "Enter",
    ESCAPE: "Escape",
    F1: "F1",
    F10: "F10",
    F11: "F11",
    F12: "F12",
    F2: "F2",
    F3: "F3",
    F4: "F4",
    F5: "F5",
    F6: "F6",
    F7: "F7",
    F8: "F8",
    F9: "F9",
    HOME: "Home",
    META: "Meta",
    PAGE_DOWN: "PageDown",
    PAGE_UP: "PageUp",
    SHIFT: "Shift",
    SPACE: " ",
    TAB: "Tab",
    CTRL: "Control",
    ASTERISK: "*",
    SPACE_CODE: "Space"
  };
}
function hs(t) {
  return A(() => {
    var e;
    return vT(t) ? !!((e = ro(t)) != null && e.closest("form")) : !0;
  });
}
const mg = "data-reka-collection-item";
function Lr(t = {}) {
  const { key: e = "", isProvider: n = !1 } = t, r = `${e}CollectionProvider`;
  let o;
  if (n) {
    const c = F(/* @__PURE__ */ new Map());
    o = {
      collectionRef: F(),
      itemMap: c
    }, Iy(r, o);
  } else
    o = yc(r);
  const a = (c = !1) => {
    const d = o.collectionRef.value;
    if (!d)
      return [];
    const f = Array.from(d.querySelectorAll(`[${mg}]`)), m = Array.from(o.itemMap.value.values()).sort(
      (g, y) => f.indexOf(g.ref) - f.indexOf(y.ref)
    );
    return c ? m : m.filter((g) => g.ref.dataset.disabled !== "");
  }, i = j({
    name: "CollectionSlot",
    setup(c, { slots: d }) {
      const { primitiveElement: f, currentElement: h } = Ja();
      return Ke(h, () => {
        o.collectionRef.value = h.value;
      }), () => Kn(Tf, { ref: f }, d);
    }
  }), s = j({
    name: "CollectionItem",
    inheritAttrs: !1,
    props: {
      value: {
        // It accepts any value
        validator: () => !0
      }
    },
    setup(c, { slots: d, attrs: f }) {
      const { primitiveElement: h, currentElement: m } = Ja();
      return Nn((g) => {
        if (m.value) {
          const y = Py(m.value);
          o.itemMap.value.set(y, { ref: m.value, value: c.value }), g(() => o.itemMap.value.delete(y));
        }
      }), () => Kn(Tf, { ...f, [mg]: "", ref: h }, d);
    }
  }), l = A(() => Array.from(o.itemMap.value.values())), u = A(() => o.itemMap.value.size);
  return { getItems: a, reactiveItems: l, itemMapSize: u, CollectionSlot: i, CollectionItem: s };
}
const IS = "rovingFocusGroup.onEntryFocus", DS = { bubbles: !1, cancelable: !0 }, PS = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function NS(t, e) {
  return e !== "rtl" ? t : t === "ArrowLeft" ? "ArrowRight" : t === "ArrowRight" ? "ArrowLeft" : t;
}
function Hb(t, e, n) {
  const r = NS(t.key, n);
  if (!(e === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(e === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return PS[r];
}
function Ub(t, e = !1) {
  const n = Pn();
  for (const r of t)
    if (r === n || (r.focus({ preventScroll: e }), Pn() !== n))
      return;
}
function $S(t, e) {
  return t.map((n, r) => t[(e + r) % t.length]);
}
const [RS, LS] = yt("RovingFocusGroup"), Wb = /* @__PURE__ */ j({
  __name: "RovingFocusGroup",
  props: {
    orientation: { default: void 0 },
    dir: {},
    loop: { type: Boolean, default: !1 },
    currentTabStopId: {},
    defaultCurrentTabStopId: {},
    preventScrollOnEntryFocus: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["entryFocus", "update:currentTabStopId"],
  setup(t, { expose: e, emit: n }) {
    const r = t, o = n, { loop: a, orientation: i, dir: s } = Gt(r), l = ga(s), u = Xt(r, "currentTabStopId", o, {
      defaultValue: r.defaultCurrentTabStopId,
      passive: r.currentTabStopId === void 0
    }), c = F(!1), d = F(!1), f = F(0), { getItems: h, CollectionSlot: m } = Lr({ isProvider: !0 });
    function g(b) {
      const C = !d.value;
      if (b.currentTarget && b.target === b.currentTarget && C && !c.value) {
        const k = new CustomEvent(IS, DS);
        if (b.currentTarget.dispatchEvent(k), o("entryFocus", k), !k.defaultPrevented) {
          const v = h().map((M) => M.ref).filter((M) => M.dataset.disabled !== ""), E = v.find((M) => M.getAttribute("data-active") === ""), _ = v.find(
            (M) => M.id === u.value
          ), T = [E, _, ...v].filter(
            Boolean
          );
          Ub(T, r.preventScrollOnEntryFocus);
        }
      }
      d.value = !1;
    }
    function y() {
      setTimeout(() => {
        d.value = !1;
      }, 1);
    }
    return e({
      getItems: h
    }), LS({
      loop: a,
      dir: l,
      orientation: i,
      currentTabStopId: u,
      onItemFocus: (b) => {
        u.value = b;
      },
      onItemShiftTab: () => {
        c.value = !0;
      },
      onFocusableItemAdd: () => {
        f.value++;
      },
      onFocusableItemRemove: () => {
        f.value--;
      }
    }), (b, C) => (w(), I(p(m), null, {
      default: S(() => [
        q(p(He), {
          tabindex: c.value || f.value === 0 ? -1 : 0,
          "data-orientation": p(i),
          as: b.as,
          "as-child": b.asChild,
          dir: p(l),
          style: { outline: "none" },
          onMousedown: C[0] || (C[0] = (k) => d.value = !0),
          onMouseup: y,
          onFocus: g,
          onBlur: C[1] || (C[1] = (k) => c.value = !1)
        }, {
          default: S(() => [
            $(b.$slots, "default")
          ]),
          _: 3
        }, 8, ["tabindex", "data-orientation", "as", "as-child", "dir"])
      ]),
      _: 3
    }));
  }
}), gg = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "VisuallyHiddenInputBubble",
  props: {
    name: {},
    value: {},
    checked: { type: Boolean, default: void 0 },
    required: { type: Boolean },
    disabled: { type: Boolean },
    feature: { default: "fully-hidden" }
  },
  setup(t) {
    const e = t, { primitiveElement: n, currentElement: r } = Ja(), o = A(() => e.checked ?? e.value);
    return Ke(o, (a, i) => {
      if (!r.value)
        return;
      const s = r.value, l = window.HTMLInputElement.prototype, c = Object.getOwnPropertyDescriptor(l, "value").set;
      if (c && a !== i) {
        const d = new Event("input", { bubbles: !0 }), f = new Event("change", { bubbles: !0 });
        c.call(s, a), s.dispatchEvent(d), s.dispatchEvent(f);
      }
    }), (a, i) => (w(), I(Ic, oe({
      ref_key: "primitiveElement",
      ref: n
    }, { ...e, ...a.$attrs }, { as: "input" }), null, 16));
  }
}), Al = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "VisuallyHiddenInput",
  props: {
    name: {},
    value: {},
    checked: { type: Boolean, default: void 0 },
    required: { type: Boolean },
    disabled: { type: Boolean },
    feature: { default: "fully-hidden" }
  },
  setup(t) {
    const e = t, n = A(
      () => typeof e.value == "object" && Array.isArray(e.value) && e.value.length === 0 && e.required
    ), r = A(() => typeof e.value == "string" || typeof e.value == "number" || typeof e.value == "boolean" ? [{ name: e.name, value: e.value }] : typeof e.value == "object" && Array.isArray(e.value) ? e.value.flatMap((o, a) => typeof o == "object" ? Object.entries(o).map(([i, s]) => ({ name: `[${e.name}][${a}][${i}]`, value: s })) : { name: `[${e.name}][${a}]`, value: o }) : e.value !== null && typeof e.value == "object" && !Array.isArray(e.value) ? Object.entries(e.value).map(([o, a]) => ({ name: `[${e.name}][${o}]`, value: a })) : []);
    return (o, a) => n.value ? (w(), I(gg, oe({ key: o.name }, { ...e, ...o.$attrs }, {
      name: o.name,
      value: o.value
    }), null, 16, ["name", "value"])) : (w(!0), K(Me, { key: 1 }, et(r.value, (i) => (w(), I(gg, oe({
      key: i.name,
      ref_for: !0
    }, { ...e, ...o.$attrs }, {
      name: i.name,
      value: i.value
    }), null, 16, ["name", "value"]))), 128));
  }
}), [BS, n8] = yt("CheckboxGroupRoot");
function Eu(t) {
  return t === "indeterminate";
}
function Kb(t) {
  return Eu(t) ? "indeterminate" : t ? "checked" : "unchecked";
}
const jb = /* @__PURE__ */ j({
  __name: "RovingFocusItem",
  props: {
    tabStopId: {},
    focusable: { type: Boolean, default: !0 },
    active: { type: Boolean },
    allowShiftKey: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  setup(t) {
    const e = t, n = RS(), r = Bt(), o = A(() => e.tabStopId || r), a = A(
      () => n.currentTabStopId.value === o.value
    ), { getItems: i, CollectionItem: s } = Lr();
    ze(() => {
      e.focusable && n.onFocusableItemAdd();
    }), En(() => {
      e.focusable && n.onFocusableItemRemove();
    });
    function l(u) {
      if (u.key === "Tab" && u.shiftKey) {
        n.onItemShiftTab();
        return;
      }
      if (u.target !== u.currentTarget)
        return;
      const c = Hb(
        u,
        n.orientation.value,
        n.dir.value
      );
      if (c !== void 0) {
        if (u.metaKey || u.ctrlKey || u.altKey || !e.allowShiftKey && u.shiftKey)
          return;
        u.preventDefault();
        let d = [...i().map((f) => f.ref).filter((f) => f.dataset.disabled !== "")];
        if (c === "last")
          d.reverse();
        else if (c === "prev" || c === "next") {
          c === "prev" && d.reverse();
          const f = d.indexOf(
            u.currentTarget
          );
          d = n.loop.value ? $S(d, f + 1) : d.slice(f + 1);
        }
        nt(() => Ub(d));
      }
    }
    return (u, c) => (w(), I(p(s), null, {
      default: S(() => [
        q(p(He), {
          tabindex: a.value ? 0 : -1,
          "data-orientation": p(n).orientation.value,
          "data-active": u.active ? "" : void 0,
          "data-disabled": u.focusable ? void 0 : "",
          as: u.as,
          "as-child": u.asChild,
          onMousedown: c[0] || (c[0] = (d) => {
            u.focusable ? p(n).onItemFocus(o.value) : d.preventDefault();
          }),
          onFocus: c[1] || (c[1] = (d) => p(n).onItemFocus(o.value)),
          onKeydown: l
        }, {
          default: S(() => [
            $(u.$slots, "default")
          ]),
          _: 3
        }, 8, ["tabindex", "data-orientation", "data-active", "data-disabled", "as", "as-child"])
      ]),
      _: 3
    }));
  }
}), [FS, VS] = yt("CheckboxRoot"), HS = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "CheckboxRoot",
  props: {
    defaultValue: { type: [Boolean, String] },
    modelValue: { type: [Boolean, String, null], default: void 0 },
    disabled: { type: Boolean },
    value: { default: "on" },
    id: {},
    asChild: { type: Boolean },
    as: { default: "button" },
    name: {},
    required: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, r = e, { forwardRef: o, currentElement: a } = De(), i = BS(null), s = Xt(n, "modelValue", r, {
      defaultValue: n.defaultValue,
      passive: n.modelValue === void 0
    }), l = A(() => (i == null ? void 0 : i.disabled.value) || n.disabled), u = A(() => nl(i == null ? void 0 : i.modelValue.value) ? s.value === "indeterminate" ? "indeterminate" : s.value : Sf(i.modelValue.value, n.value));
    function c() {
      if (nl(i == null ? void 0 : i.modelValue.value))
        s.value = Eu(s.value) ? !0 : !s.value;
      else {
        const h = [...i.modelValue.value || []];
        if (Sf(h, n.value)) {
          const m = h.findIndex((g) => oo(g, n.value));
          h.splice(m, 1);
        } else
          h.push(n.value);
        i.modelValue.value = h;
      }
    }
    const d = hs(a), f = A(() => {
      var h;
      return n.id && a.value ? (h = document.querySelector(`[for="${n.id}"]`)) == null ? void 0 : h.innerText : void 0;
    });
    return VS({
      disabled: l,
      state: u
    }), (h, m) => {
      var g, y;
      return w(), I(On((g = p(i)) != null && g.rovingFocus.value ? p(jb) : p(He)), oe(h.$attrs, {
        id: h.id,
        ref: p(o),
        role: "checkbox",
        "as-child": h.asChild,
        as: h.as,
        type: h.as === "button" ? "button" : void 0,
        "aria-checked": p(Eu)(u.value) ? "mixed" : u.value,
        "aria-required": h.required,
        "aria-label": h.$attrs["aria-label"] || f.value,
        "data-state": p(Kb)(u.value),
        "data-disabled": l.value ? "" : void 0,
        disabled: l.value,
        focusable: (y = p(i)) != null && y.rovingFocus.value ? !l.value : void 0,
        onKeydown: to(Xe(() => {
        }, ["prevent"]), ["enter"]),
        onClick: c
      }), {
        default: S(() => [
          $(h.$slots, "default", {
            modelValue: p(s),
            state: u.value
          }),
          p(d) && h.name && !p(i) ? (w(), I(p(Al), {
            key: 0,
            type: "checkbox",
            checked: !!u.value,
            name: h.name,
            value: h.value,
            disabled: l.value,
            required: h.required
          }, null, 8, ["checked", "name", "value", "disabled", "required"])) : V("", !0)
        ]),
        _: 3
      }, 16, ["id", "as-child", "as", "type", "aria-checked", "aria-required", "aria-label", "data-state", "data-disabled", "disabled", "focusable", "onKeydown"]);
    };
  }
}), US = /* @__PURE__ */ j({
  __name: "CheckboxIndicator",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  setup(t) {
    const { forwardRef: e } = De(), n = FS();
    return (r, o) => (w(), I(p(Rr), {
      present: r.forceMount || p(Eu)(p(n).state.value) || p(n).state.value === !0
    }, {
      default: S(() => [
        q(p(He), oe({
          ref: p(e),
          "data-state": p(Kb)(p(n).state.value),
          "data-disabled": p(n).disabled.value ? "" : void 0,
          style: { pointerEvents: "none" },
          "as-child": r.asChild,
          as: r.as
        }, r.$attrs), {
          default: S(() => [
            $(r.$slots, "default")
          ]),
          _: 3
        }, 16, ["data-state", "data-disabled", "as-child", "as"])
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), [zb, WS] = yt("PopperRoot"), ms = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "PopperRoot",
  setup(t) {
    const e = F();
    return WS({
      anchor: e,
      onAnchorChange: (n) => e.value = n
    }), (n, r) => $(n.$slots, "default");
  }
}), Ml = /* @__PURE__ */ j({
  __name: "PopperAnchor",
  props: {
    reference: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const e = t, { forwardRef: n, currentElement: r } = De(), o = zb();
    return Ny(() => {
      o.onAnchorChange(e.reference ?? r.value);
    }), (a, i) => (w(), I(p(He), {
      ref: p(n),
      as: a.as,
      "as-child": a.asChild
    }, {
      default: S(() => [
        $(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child"]));
  }
}), Yb = /* @__PURE__ */ j({
  __name: "ComboboxAnchor",
  props: {
    reference: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const { forwardRef: e } = De();
    return (n, r) => (w(), I(p(Ml), {
      "as-child": "",
      reference: n.reference
    }, {
      default: S(() => [
        q(p(He), oe({
          ref: p(e),
          "as-child": n.asChild,
          as: n.as
        }, n.$attrs), {
          default: S(() => [
            $(n.$slots, "default")
          ]),
          _: 3
        }, 16, ["as-child", "as"])
      ]),
      _: 3
    }, 8, ["reference"]));
  }
}), KS = {
  key: 0,
  d: "M0 0L6 6L12 0"
}, jS = {
  key: 1,
  d: "M0 0L4.58579 4.58579C5.36683 5.36683 6.63316 5.36684 7.41421 4.58579L12 0"
}, zS = /* @__PURE__ */ j({
  __name: "Arrow",
  props: {
    width: { default: 10 },
    height: { default: 5 },
    rounded: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "svg" }
  },
  setup(t) {
    const e = t;
    return De(), (n, r) => (w(), I(p(He), oe(e, {
      width: n.width,
      height: n.height,
      viewBox: n.asChild ? void 0 : "0 0 12 6",
      preserveAspectRatio: n.asChild ? void 0 : "none"
    }), {
      default: S(() => [
        $(n.$slots, "default", {}, () => [
          n.rounded ? (w(), K("path", jS)) : (w(), K("path", KS))
        ])
      ]),
      _: 3
    }, 16, ["width", "height", "viewBox", "preserveAspectRatio"]));
  }
});
function YS(t) {
  return t !== null;
}
function qS(t) {
  return {
    name: "transformOrigin",
    options: t,
    fn(e) {
      var y, b, C;
      const { placement: n, rects: r, middlewareData: o } = e, i = ((y = o.arrow) == null ? void 0 : y.centerOffset) !== 0, s = i ? 0 : t.arrowWidth, l = i ? 0 : t.arrowHeight, [u, c] = If(n), d = { start: "0%", center: "50%", end: "100%" }[c], f = (((b = o.arrow) == null ? void 0 : b.x) ?? 0) + s / 2, h = (((C = o.arrow) == null ? void 0 : C.y) ?? 0) + l / 2;
      let m = "", g = "";
      return u === "bottom" ? (m = i ? d : `${f}px`, g = `${-l}px`) : u === "top" ? (m = i ? d : `${f}px`, g = `${r.floating.height + l}px`) : u === "right" ? (m = `${-l}px`, g = i ? d : `${h}px`) : u === "left" && (m = `${r.floating.width + l}px`, g = i ? d : `${h}px`), { data: { x: m, y: g } };
    }
  };
}
function If(t) {
  const [e, n = "center"] = t.split("-");
  return [e, n];
}
function GS(t) {
  const e = F(), n = A(() => {
    var o;
    return ((o = e.value) == null ? void 0 : o.width) ?? 0;
  }), r = A(() => {
    var o;
    return ((o = e.value) == null ? void 0 : o.height) ?? 0;
  });
  return ze(() => {
    const o = ro(t);
    if (o) {
      e.value = { width: o.offsetWidth, height: o.offsetHeight };
      const a = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const s = i[0];
        let l, u;
        if ("borderBoxSize" in s) {
          const c = s.borderBoxSize, d = Array.isArray(c) ? c[0] : c;
          l = d.inlineSize, u = d.blockSize;
        } else
          l = o.offsetWidth, u = o.offsetHeight;
        e.value = { width: l, height: u };
      });
      return a.observe(o, { box: "border-box" }), () => a.unobserve(o);
    } else
      e.value = void 0;
  }), {
    width: n,
    height: r
  };
}
const qb = {
  side: "bottom",
  sideOffset: 0,
  align: "center",
  alignOffset: 0,
  arrowPadding: 0,
  avoidCollisions: !0,
  collisionBoundary: () => [],
  collisionPadding: 0,
  sticky: "partial",
  hideWhenDetached: !1,
  positionStrategy: "fixed",
  updatePositionStrategy: "optimized",
  prioritizePosition: !1
}, [JS, XS] = yt("PopperContent"), Il = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "PopperContent",
  props: /* @__PURE__ */ $y({
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    positionStrategy: {},
    updatePositionStrategy: {},
    disableUpdateOnLayoutShift: { type: Boolean },
    prioritizePosition: { type: Boolean },
    reference: {},
    asChild: { type: Boolean },
    as: {}
  }, {
    ...qb
  }),
  emits: ["placed"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = zb(), { forwardRef: a, currentElement: i } = De(), s = F(), l = F(), { width: u, height: c } = GS(l), d = A(
      () => n.side + (n.align !== "center" ? `-${n.align}` : "")
    ), f = A(() => typeof n.collisionPadding == "number" ? n.collisionPadding : { top: 0, right: 0, bottom: 0, left: 0, ...n.collisionPadding }), h = A(() => Array.isArray(n.collisionBoundary) ? n.collisionBoundary : [n.collisionBoundary]), m = A(() => ({
      padding: f.value,
      boundary: h.value.filter(YS),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: h.value.length > 0
    })), g = sT(() => [
      JO({
        mainAxis: n.sideOffset + c.value,
        alignmentAxis: n.alignOffset
      }),
      n.prioritizePosition && n.avoidCollisions && sg({
        ...m.value
      }),
      n.avoidCollisions && XO({
        mainAxis: !0,
        crossAxis: !!n.prioritizePosition,
        limiter: n.sticky === "partial" ? tT() : void 0,
        ...m.value
      }),
      !n.prioritizePosition && n.avoidCollisions && sg({
        ...m.value
      }),
      QO({
        ...m.value,
        apply: ({ elements: N, rects: z, availableWidth: te, availableHeight: H }) => {
          const { width: U, height: W } = z.reference, Q = N.floating.style;
          Q.setProperty(
            "--reka-popper-available-width",
            `${te}px`
          ), Q.setProperty(
            "--reka-popper-available-height",
            `${H}px`
          ), Q.setProperty(
            "--reka-popper-anchor-width",
            `${U}px`
          ), Q.setProperty(
            "--reka-popper-anchor-height",
            `${W}px`
          );
        }
      }),
      l.value && oT({ element: l.value, padding: n.arrowPadding }),
      qS({
        arrowWidth: u.value,
        arrowHeight: c.value
      }),
      n.hideWhenDetached && ZO({ strategy: "referenceHidden", ...m.value })
    ]), y = A(() => n.reference ?? o.anchor.value), { floatingStyles: b, placement: C, isPositioned: k, middlewareData: v } = aT(
      y,
      s,
      {
        strategy: n.positionStrategy,
        placement: d,
        whileElementsMounted: (...N) => GO(...N, {
          layoutShift: !n.disableUpdateOnLayoutShift,
          animationFrame: n.updatePositionStrategy === "always"
        }),
        middleware: g
      }
    ), E = A(
      () => If(C.value)[0]
    ), _ = A(
      () => If(C.value)[1]
    );
    Ny(() => {
      k.value && r("placed");
    });
    const T = A(
      () => {
        var N;
        return ((N = v.value.arrow) == null ? void 0 : N.centerOffset) !== 0;
      }
    ), M = F("");
    Nn(() => {
      i.value && (M.value = window.getComputedStyle(i.value).zIndex);
    });
    const O = A(() => {
      var N;
      return ((N = v.value.arrow) == null ? void 0 : N.x) ?? 0;
    }), R = A(() => {
      var N;
      return ((N = v.value.arrow) == null ? void 0 : N.y) ?? 0;
    });
    return XS({
      placedSide: E,
      onArrowChange: (N) => l.value = N,
      arrowX: O,
      arrowY: R,
      shouldHideArrow: T
    }), (N, z) => {
      var te, H, U;
      return w(), K("div", {
        ref_key: "floatingRef",
        ref: s,
        "data-reka-popper-content-wrapper": "",
        style: Lt({
          ...p(b),
          transform: p(k) ? p(b).transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: M.value,
          "--reka-popper-transform-origin": [
            (te = p(v).transformOrigin) == null ? void 0 : te.x,
            (H = p(v).transformOrigin) == null ? void 0 : H.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((U = p(v).hide) == null ? void 0 : U.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        })
      }, [
        q(p(He), oe({ ref: p(a) }, N.$attrs, {
          "as-child": n.asChild,
          as: N.as,
          "data-side": E.value,
          "data-align": _.value,
          style: {
            // if the PopperContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: p(k) ? void 0 : "none"
          }
        }), {
          default: S(() => [
            $(N.$slots, "default")
          ]),
          _: 3
        }, 16, ["as-child", "as", "data-side", "data-align", "style"])
      ], 4);
    };
  }
}), QS = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Gp = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "PopperArrow",
  props: {
    width: {},
    height: {},
    rounded: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "svg" }
  },
  setup(t) {
    const { forwardRef: e } = De(), n = JS(), r = A(() => QS[n.placedSide.value]);
    return (o, a) => {
      var i, s, l, u;
      return w(), K("span", {
        ref: (c) => {
          p(n).onArrowChange(c);
        },
        style: Lt({
          position: "absolute",
          left: (i = p(n).arrowX) != null && i.value ? `${(s = p(n).arrowX) == null ? void 0 : s.value}px` : void 0,
          top: (l = p(n).arrowY) != null && l.value ? `${(u = p(n).arrowY) == null ? void 0 : u.value}px` : void 0,
          [r.value]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[p(n).placedSide.value],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[p(n).placedSide.value],
          visibility: p(n).shouldHideArrow.value ? "hidden" : void 0
        })
      }, [
        q(zS, oe(o.$attrs, {
          ref: p(e),
          style: {
            display: "block"
          },
          as: o.as,
          "as-child": o.asChild,
          rounded: o.rounded,
          width: o.width,
          height: o.height
        }), {
          default: S(() => [
            $(o.$slots, "default")
          ]),
          _: 3
        }, 16, ["as", "as-child", "rounded", "width", "height"])
      ], 4);
    };
  }
});
function ZS(t) {
  const e = A(() => p(t)), n = A(() => new Intl.Collator("en", { usage: "search", ...e.value }));
  return {
    startsWith: (i, s) => s.length === 0 ? !0 : (i = i.normalize("NFC"), s = s.normalize("NFC"), n.value.compare(i.slice(0, s.length), s) === 0),
    endsWith: (i, s) => s.length === 0 ? !0 : (i = i.normalize("NFC"), s = s.normalize("NFC"), n.value.compare(i.slice(-s.length), s) === 0),
    contains: (i, s) => {
      if (s.length === 0)
        return !0;
      i = i.normalize("NFC"), s = s.normalize("NFC");
      let l = 0;
      const u = s.length;
      for (; l + u <= i.length; l++) {
        const c = i.slice(l, l + u);
        if (n.value.compare(s, c) === 0)
          return !0;
      }
      return !1;
    }
  };
}
function ex(t, e, n) {
  return t === void 0 ? !1 : Array.isArray(t) ? t.some((r) => $s(r, e, n)) : $s(t, e, n);
}
function $s(t, e, n) {
  return t === void 0 || e === void 0 ? !1 : typeof t == "string" ? t === e : typeof n == "function" ? n(t, e) : typeof n == "string" ? (t == null ? void 0 : t[n]) === (e == null ? void 0 : e[n]) : oo(t, e);
}
function Rc(t) {
  const e = zp("", 1e3);
  return {
    search: e,
    handleTypeaheadSearch: (o, a) => {
      e.value = e.value + o;
      {
        const i = Pn(), s = a.map((f) => {
          var h, m;
          return {
            ...f,
            textValue: ((h = f.value) == null ? void 0 : h.textValue) ?? ((m = f.ref.textContent) == null ? void 0 : m.trim()) ?? ""
          };
        }), l = s.find((f) => f.ref === i), u = s.map((f) => f.textValue), c = nx(u, e.value, l == null ? void 0 : l.textValue), d = s.find((f) => f.textValue === c);
        return d && d.ref.focus(), d == null ? void 0 : d.ref;
      }
    },
    resetTypeahead: () => {
      e.value = "";
    }
  };
}
function tx(t, e) {
  return t.map((n, r) => t[(e + r) % t.length]);
}
function nx(t, e, n) {
  const o = e.length > 1 && Array.from(e).every((u) => u === e[0]) ? e[0] : e, a = n ? t.indexOf(n) : -1;
  let i = tx(t, Math.max(a, 0));
  o.length === 1 && (i = i.filter((u) => u !== n));
  const l = i.find(
    (u) => u.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function rx(t, e, n) {
  const r = t.findIndex((s) => oo(s, e)), o = t.findIndex((s) => oo(s, n));
  if (r === -1 || o === -1)
    return [];
  const [a, i] = [r, o].sort((s, l) => s - l);
  return t.slice(a, i + 1);
}
const [Lc, ox] = yt("ListboxRoot"), Gb = /* @__PURE__ */ j({
  __name: "ListboxRoot",
  props: {
    modelValue: {},
    defaultValue: {},
    multiple: { type: Boolean },
    orientation: { default: "vertical" },
    dir: {},
    disabled: { type: Boolean },
    selectionBehavior: { default: "toggle" },
    highlightOnHover: { type: Boolean },
    by: {},
    asChild: { type: Boolean },
    as: {},
    name: {},
    required: { type: Boolean }
  },
  emits: ["update:modelValue", "highlight", "entryFocus", "leave"],
  setup(t, { expose: e, emit: n }) {
    const r = t, o = n, { multiple: a, highlightOnHover: i, orientation: s, disabled: l, selectionBehavior: u, dir: c } = Gt(r), { getItems: d } = Lr({ isProvider: !0 }), { handleTypeaheadSearch: f } = Rc(), { primitiveElement: h, currentElement: m } = Ja(), g = MS(), y = ga(c), b = hs(m), C = F(), k = F(!1), v = F(!0), E = Xt(r, "modelValue", o, {
      defaultValue: r.defaultValue ?? (a.value ? [] : void 0),
      passive: r.modelValue === void 0,
      deep: !0
    });
    function _(P) {
      if (k.value = !0, r.multiple) {
        const se = Array.isArray(E.value) ? [...E.value] : [], ke = se.findIndex((Le) => $s(Le, P, r.by));
        r.selectionBehavior === "toggle" ? (ke === -1 ? se.push(P) : se.splice(ke, 1), E.value = se) : (E.value = [P], C.value = P);
      } else
        r.selectionBehavior === "toggle" && $s(E.value, P, r.by) ? E.value = void 0 : E.value = P;
      setTimeout(() => {
        k.value = !1;
      }, 1);
    }
    const T = F(null), M = F(null), O = F(!1), R = F(!1), N = Ns(), z = Ns(), te = Ns();
    function H() {
      return d().map((P) => P.ref).filter((P) => P.dataset.disabled !== "");
    }
    function U(P, se = !0) {
      if (!P)
        return;
      T.value = P, v.value && T.value.focus(), se && T.value.scrollIntoView({ block: "nearest" });
      const ke = d().find((Le) => Le.ref === P);
      o("highlight", ke);
    }
    function W(P) {
      if (O.value)
        te.trigger(P);
      else {
        const se = d().find((ke) => $s(ke.value, P, r.by));
        se && (T.value = se.ref, U(se.ref));
      }
    }
    function Q(P) {
      T.value && T.value.isConnected && (P.preventDefault(), P.stopPropagation(), R.value || T.value.click());
    }
    function de(P) {
      if (v.value) {
        if (k.value = !0, O.value)
          z.trigger(P);
        else {
          const se = P.altKey || P.ctrlKey || P.metaKey;
          if (se && P.key === "a" && a.value) {
            const ke = d(), Le = ke.map((ne) => ne.value);
            E.value = [...Le], P.preventDefault(), U(ke[ke.length - 1].ref);
          } else if (!se) {
            const ke = f(P.key, d());
            ke && U(ke);
          }
        }
        setTimeout(() => {
          k.value = !1;
        }, 1);
      }
    }
    function re() {
      R.value = !0;
    }
    function J() {
      requestAnimationFrame(() => {
        R.value = !1;
      });
    }
    function Ce() {
      nt(() => {
        const P = new KeyboardEvent("keydown", { key: "PageUp" });
        D(P);
      });
    }
    function ie(P) {
      const se = T.value;
      se != null && se.isConnected && (M.value = se), T.value = null, o("leave", P);
    }
    function ee(P) {
      var ke, Le;
      const se = new CustomEvent("listbox.entryFocus", { bubbles: !1, cancelable: !0 });
      if ((ke = P.currentTarget) == null || ke.dispatchEvent(se), o("entryFocus", se), !se.defaultPrevented)
        if (M.value)
          U(M.value);
        else {
          const ne = (Le = H()) == null ? void 0 : Le[0];
          U(ne);
        }
    }
    function D(P) {
      const se = Hb(P, s.value, y.value);
      if (!se)
        return;
      let ke = H();
      if (T.value) {
        if (se === "last")
          ke.reverse();
        else if (se === "prev" || se === "next") {
          se === "prev" && ke.reverse();
          const Le = ke.indexOf(T.value);
          ke = ke.slice(Le + 1);
        }
        G(P, ke[0]);
      }
      if (ke.length) {
        const Le = !T.value && se === "prev" ? ke.length - 1 : 0;
        U(ke[Le]);
      }
      if (O.value)
        return z.trigger(P);
    }
    function G(P, se) {
      var Le;
      if (!(O.value || r.selectionBehavior !== "replace" || !a.value || !Array.isArray(E.value) || (P.altKey || P.ctrlKey || P.metaKey) && !P.shiftKey) && P.shiftKey) {
        const ne = d().filter((Z) => Z.ref.dataset.disabled !== "");
        let ye = (Le = ne.find((Z) => Z.ref === se)) == null ? void 0 : Le.value;
        if (P.key === g.END ? ye = ne[ne.length - 1].value : P.key === g.HOME && (ye = ne[0].value), !ye || !C.value)
          return;
        const pe = rx(ne.map((Z) => Z.value), C.value, ye);
        E.value = pe;
      }
    }
    async function fe(P) {
      if (await nt(), O.value)
        N.trigger(P);
      else {
        const se = H(), ke = se.find((Le) => Le.dataset.state === "checked");
        ke ? U(ke) : se.length && U(se[0]);
      }
    }
    return Ke(E, () => {
      k.value || nt(() => {
        fe();
      });
    }, { immediate: !0, deep: !0 }), e({
      highlightedElement: T,
      highlightItem: W,
      highlightFirstItem: Ce,
      highlightSelected: fe,
      getItems: d
    }), ox({
      modelValue: E,
      // @ts-expect-error ignoring
      onValueChange: _,
      multiple: a,
      orientation: s,
      dir: y,
      disabled: l,
      highlightOnHover: i,
      highlightedElement: T,
      isVirtual: O,
      virtualFocusHook: N,
      virtualKeydownHook: z,
      virtualHighlightHook: te,
      by: r.by,
      firstValue: C,
      selectionBehavior: u,
      focusable: v,
      onLeave: ie,
      onEnter: ee,
      changeHighlight: U,
      onKeydownEnter: Q,
      onKeydownNavigation: D,
      onKeydownTypeAhead: de,
      onCompositionStart: re,
      onCompositionEnd: J,
      highlightFirstItem: Ce
    }), (P, se) => (w(), I(p(He), {
      ref_key: "primitiveElement",
      ref: h,
      as: P.as,
      "as-child": P.asChild,
      dir: p(y),
      "data-disabled": p(l) ? "" : void 0,
      onPointerleave: ie,
      onFocusout: se[0] || (se[0] = async (ke) => {
        const Le = ke.relatedTarget || ke.target;
        await nt(), T.value && p(m) && !p(m).contains(Le) && ie(ke);
      })
    }, {
      default: S(() => [
        $(P.$slots, "default", { modelValue: p(E) }),
        p(b) && P.name ? (w(), I(p(Al), {
          key: 0,
          name: P.name,
          value: p(E),
          disabled: p(l),
          required: P.required
        }, null, 8, ["name", "value", "disabled", "required"])) : V("", !0)
      ]),
      _: 3
    }, 8, ["as", "as-child", "dir", "data-disabled"]));
  }
}), [Bo, ax] = yt("ComboboxRoot"), Jb = /* @__PURE__ */ j({
  __name: "ComboboxRoot",
  props: {
    open: { type: Boolean, default: void 0 },
    defaultOpen: { type: Boolean },
    resetSearchTermOnBlur: { type: Boolean, default: !0 },
    resetSearchTermOnSelect: { type: Boolean, default: !0 },
    ignoreFilter: { type: Boolean },
    modelValue: {},
    defaultValue: {},
    multiple: { type: Boolean },
    dir: {},
    disabled: { type: Boolean },
    highlightOnHover: { type: Boolean },
    by: {},
    asChild: { type: Boolean },
    as: {},
    name: {},
    required: { type: Boolean }
  },
  emits: ["update:modelValue", "highlight", "update:open"],
  setup(t, { expose: e, emit: n }) {
    var z, te, H;
    const r = t, o = n, { primitiveElement: a, currentElement: i } = Ja(), { multiple: s, disabled: l, ignoreFilter: u, resetSearchTermOnSelect: c, dir: d } = Gt(r), f = ga(d), h = Xt(r, "modelValue", o, {
      // @ts-expect-error ignore the type error here
      defaultValue: r.defaultValue ?? (s.value ? [] : void 0),
      passive: r.modelValue === void 0,
      deep: !0
    }), m = Xt(r, "open", o, {
      defaultValue: r.defaultOpen,
      passive: r.open === void 0
    });
    async function g(U) {
      var W, Q;
      m.value = U, O.search = "", U ? (await nt(), (W = a.value) == null || W.highlightSelected(), b.value = !0) : b.value = !1, (Q = k.value) == null || Q.focus(), setTimeout(() => {
        !U && r.resetSearchTermOnBlur && y.trigger();
      }, 1);
    }
    const y = Ns(), b = F(!1), C = F(!1), k = F(), v = F(), E = A(() => {
      var U;
      return ((U = a.value) == null ? void 0 : U.highlightedElement) ?? void 0;
    }), _ = F(/* @__PURE__ */ new Map()), T = F(/* @__PURE__ */ new Map()), { contains: M } = ZS({ sensitivity: "base" }), O = eo({
      search: "",
      filtered: {
        /** The count of all visible items. */
        count: 0,
        /** Map from visible item id to its search score. */
        items: /* @__PURE__ */ new Map(),
        /** Set of groups with at least one visible item. */
        groups: /* @__PURE__ */ new Set()
      }
    });
    function R() {
      if (!O.search || r.ignoreFilter || C.value) {
        O.filtered.count = _.value.size;
        return;
      }
      O.filtered.groups = /* @__PURE__ */ new Set();
      let U = 0;
      for (const [W, Q] of _.value) {
        const de = M(Q, O.search);
        O.filtered.items.set(W, de ? 1 : 0), de && U++;
      }
      for (const [W, Q] of T.value)
        for (const de of Q)
          if (O.filtered.items.get(de) > 0) {
            O.filtered.groups.add(W);
            break;
          }
      O.filtered.count = U;
    }
    Ke([() => O.search, () => _.value.size], () => {
      R();
    }, { immediate: !0 }), Ke(() => m.value, () => {
      nt(() => {
        m.value && R();
      });
    }, { flush: "post" });
    const N = Cn();
    return ze(() => {
      var U, W, Q;
      N != null && N.exposed && (N.exposed.highlightItem = (U = a.value) == null ? void 0 : U.highlightItem, N.exposed.highlightFirstItem = (W = a.value) == null ? void 0 : W.highlightFirstItem, N.exposed.highlightSelected = (Q = a.value) == null ? void 0 : Q.highlightSelected);
    }), e({
      filtered: A(() => O.filtered),
      highlightedElement: E,
      highlightItem: (z = a.value) == null ? void 0 : z.highlightItem,
      highlightFirstItem: (te = a.value) == null ? void 0 : te.highlightFirstItem,
      highlightSelected: (H = a.value) == null ? void 0 : H.highlightSelected
    }), ax({
      modelValue: h,
      multiple: s,
      disabled: l,
      open: m,
      onOpenChange: g,
      contentId: "",
      isUserInputted: b,
      isVirtual: C,
      inputElement: k,
      highlightedElement: E,
      onInputElementChange: (U) => k.value = U,
      triggerElement: v,
      onTriggerElementChange: (U) => v.value = U,
      parentElement: i,
      resetSearchTermOnSelect: c,
      onResetSearchTerm: y.on,
      allItems: _,
      allGroups: T,
      filterState: O,
      ignoreFilter: u
    }), (U, W) => (w(), I(p(ms), null, {
      default: S(() => [
        q(p(Gb), oe({
          ref_key: "primitiveElement",
          ref: a
        }, U.$attrs, {
          modelValue: p(h),
          "onUpdate:modelValue": W[0] || (W[0] = (Q) => bt(h) ? h.value = Q : null),
          style: {
            pointerEvents: p(m) ? "auto" : void 0
          },
          as: U.as,
          "as-child": U.asChild,
          dir: p(f),
          multiple: p(s),
          name: U.name,
          required: U.required,
          disabled: p(l),
          "highlight-on-hover": !0,
          by: r.by,
          onHighlight: W[1] || (W[1] = (Q) => o("highlight", Q))
        }), {
          default: S(() => [
            $(U.$slots, "default", {
              open: p(m),
              modelValue: p(h)
            })
          ]),
          _: 3
        }, 16, ["modelValue", "style", "as", "as-child", "dir", "multiple", "name", "required", "disabled", "by"])
      ]),
      _: 3
    }));
  }
}), Xb = /* @__PURE__ */ j({
  __name: "ListboxContent",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const { CollectionSlot: e } = Lr(), n = Lc(), r = zp(!1, 10);
    return (o, a) => (w(), I(p(e), null, {
      default: S(() => [
        q(p(He), {
          role: "listbox",
          as: o.as,
          "as-child": o.asChild,
          tabindex: p(n).focusable.value ? p(n).highlightedElement.value ? "-1" : "0" : void 0,
          "aria-orientation": p(n).orientation.value,
          "aria-multiselectable": !!p(n).multiple.value,
          "data-orientation": p(n).orientation.value,
          onMousedown: a[0] || (a[0] = Xe((i) => r.value = !0, ["left"])),
          onFocus: a[1] || (a[1] = (i) => {
            p(r) || p(n).onEnter(i);
          }),
          onKeydown: [
            a[2] || (a[2] = to(Xe((i) => {
              p(n).focusable.value && p(n).onKeydownNavigation(i);
            }, ["prevent"]), ["down", "up", "left", "right", "home", "end"])),
            to(p(n).onKeydownEnter, ["enter"]),
            p(n).onKeydownTypeAhead
          ]
        }, {
          default: S(() => [
            $(o.$slots, "default")
          ]),
          _: 3
        }, 8, ["as", "as-child", "tabindex", "aria-orientation", "aria-multiselectable", "data-orientation", "onKeydown"])
      ]),
      _: 3
    }));
  }
}), [r8, ix] = yt("ComboboxContent"), sx = /* @__PURE__ */ j({
  __name: "ComboboxContentImpl",
  props: {
    position: { default: "inline" },
    bodyLock: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    positionStrategy: {},
    updatePositionStrategy: {},
    disableUpdateOnLayoutShift: { type: Boolean },
    prioritizePosition: { type: Boolean },
    reference: {},
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside"],
  setup(t, { emit: e }) {
    const n = t, r = e, { position: o } = Gt(n), a = Bo(), { forwardRef: i, currentElement: s } = De();
    xl(n.bodyLock), Sl(a.parentElement);
    const l = A(() => n.position === "popper" ? n : {}), u = ps(l.value), c = {
      // Ensure border-box for floating-ui calculations
      boxSizing: "border-box",
      "--reka-combobox-content-transform-origin": "var(--reka-popper-transform-origin)",
      "--reka-combobox-content-available-width": "var(--reka-popper-available-width)",
      "--reka-combobox-content-available-height": "var(--reka-popper-available-height)",
      "--reka-combobox-trigger-width": "var(--reka-popper-anchor-width)",
      "--reka-combobox-trigger-height": "var(--reka-popper-anchor-height)"
    };
    ix({ position: o });
    const d = F(!1);
    return ze(() => {
      a.inputElement.value && (d.value = s.value.contains(a.inputElement.value), d.value && a.inputElement.value.focus());
    }), En(() => {
      var f;
      d.value && ((f = a.triggerElement.value) == null || f.focus());
    }), (f, h) => (w(), I(p(Xb), { "as-child": "" }, {
      default: S(() => [
        q(p(ds), {
          "as-child": "",
          "disable-outside-pointer-events": f.disableOutsidePointerEvents,
          onDismiss: h[0] || (h[0] = (m) => p(a).onOpenChange(!1)),
          onFocusOutside: h[1] || (h[1] = (m) => {
            var g;
            (g = p(a).parentElement.value) != null && g.contains(m.target) && m.preventDefault(), r("focusOutside", m);
          }),
          onInteractOutside: h[2] || (h[2] = (m) => r("interactOutside", m)),
          onEscapeKeyDown: h[3] || (h[3] = (m) => r("escapeKeyDown", m)),
          onPointerDownOutside: h[4] || (h[4] = (m) => {
            var g;
            (g = p(a).parentElement.value) != null && g.contains(m.target) && m.preventDefault(), r("pointerDownOutside", m);
          })
        }, {
          default: S(() => [
            (w(), I(On(p(o) === "popper" ? p(Il) : p(He)), oe({ ...f.$attrs, ...p(u) }, {
              id: p(a).contentId,
              ref: p(i),
              "data-state": p(a).open.value ? "open" : "closed",
              style: {
                // flex layout so we can place the scroll buttons properly
                display: "flex",
                flexDirection: "column",
                // reset the outline by default as the content MAY get focused
                outline: "none",
                ...p(o) === "popper" ? c : {}
              }
            }), {
              default: S(() => [
                $(f.$slots, "default")
              ]),
              _: 3
            }, 16, ["id", "data-state", "style"]))
          ]),
          _: 3
        }, 8, ["disable-outside-pointer-events"])
      ]),
      _: 3
    }));
  }
}), lx = /* @__PURE__ */ j({
  __name: "ComboboxCancel",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(t) {
    const e = t;
    De();
    const n = Bo();
    function r() {
      n.filterState.search = "", n.inputElement.value && (n.inputElement.value.value = "", n.inputElement.value.focus());
    }
    return (o, a) => (w(), I(p(He), oe({
      type: o.as === "button" ? "button" : void 0
    }, e, {
      tabindex: "-1",
      onClick: r
    }), {
      default: S(() => [
        $(o.$slots, "default")
      ]),
      _: 3
    }, 16, ["type"]));
  }
}), Qb = /* @__PURE__ */ j({
  __name: "ComboboxContent",
  props: {
    forceMount: { type: Boolean },
    position: {},
    bodyLock: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    positionStrategy: {},
    updatePositionStrategy: {},
    disableUpdateOnLayoutShift: { type: Boolean },
    prioritizePosition: { type: Boolean },
    reference: {},
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside"],
  setup(t, { emit: e }) {
    const o = vr(t, e), { forwardRef: a } = De(), i = Bo();
    return i.contentId || (i.contentId = Bt(void 0, "reka-combobox-content")), (s, l) => (w(), I(p(Rr), {
      present: s.forceMount || p(i).open.value
    }, {
      default: S(() => [
        q(sx, oe({ ...p(o), ...s.$attrs }, { ref: p(a) }), {
          default: S(() => [
            $(s.$slots, "default")
          ]),
          _: 3
        }, 16)
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), Zb = /* @__PURE__ */ j({
  __name: "ComboboxEmpty",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const e = t, n = Bo(), r = A(
      () => n.ignoreFilter.value ? n.allItems.value.size === 0 : !!n.filterState.search && n.filterState.filtered.count === 0
    );
    return (o, a) => r.value ? (w(), I(p(He), Ye(oe({ key: 0 }, e)), {
      default: S(() => [
        $(o.$slots, "default", {}, () => [
          a[0] || (a[0] = We("No options"))
        ])
      ]),
      _: 3
    }, 16)) : V("", !0);
  }
}), [ux, cx] = yt("ListboxGroup"), e0 = /* @__PURE__ */ j({
  __name: "ListboxGroup",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const e = t, n = Bt(void 0, "reka-listbox-group");
    return cx({ id: n }), (r, o) => (w(), I(p(He), oe({ role: "group" }, e, { "aria-labelledby": p(n) }), {
      default: S(() => [
        $(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["aria-labelledby"]));
  }
}), [t0, dx] = yt("ComboboxGroup"), n0 = /* @__PURE__ */ j({
  __name: "ComboboxGroup",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const e = t, n = Bt(void 0, "reka-combobox-group"), r = Bo(), o = A(() => r.ignoreFilter.value ? !0 : r.filterState.search ? r.filterState.filtered.groups.has(n) : !0), a = dx({
      id: n,
      labelId: ""
    });
    return ze(() => {
      r.allGroups.value.has(n) || r.allGroups.value.set(n, /* @__PURE__ */ new Set());
    }), En(() => {
      r.allGroups.value.delete(n);
    }), (i, s) => (w(), I(p(e0), oe({
      id: p(n),
      "aria-labelledby": p(a).labelId
    }, e, {
      hidden: o.value ? void 0 : !0
    }), {
      default: S(() => [
        $(i.$slots, "default")
      ]),
      _: 3
    }, 16, ["id", "aria-labelledby", "hidden"]));
  }
}), fx = /* @__PURE__ */ j({
  __name: "ListboxFilter",
  props: {
    modelValue: {},
    autoFocus: { type: Boolean },
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "input" }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, o = Xt(n, "modelValue", e, {
      defaultValue: "",
      passive: n.modelValue === void 0
    }), a = Lc(), { primitiveElement: i, currentElement: s } = Ja(), l = A(() => n.disabled || a.disabled.value || !1), u = F();
    return t_(() => {
      var c;
      return u.value = (c = a.highlightedElement.value) == null ? void 0 : c.id;
    }), ze(() => {
      a.focusable.value = !1, setTimeout(() => {
        var c;
        n.autoFocus && ((c = s.value) == null || c.focus());
      }, 1);
    }), En(() => {
      a.focusable.value = !0;
    }), (c, d) => (w(), I(p(He), {
      ref_key: "primitiveElement",
      ref: i,
      as: c.as,
      "as-child": c.asChild,
      value: p(o),
      disabled: l.value ? "" : void 0,
      "data-disabled": l.value ? "" : void 0,
      "aria-disabled": l.value ?? void 0,
      "aria-activedescendant": u.value,
      type: "text",
      onKeydown: [
        to(Xe(p(a).onKeydownNavigation, ["prevent"]), ["down", "up", "home", "end"]),
        to(p(a).onKeydownEnter, ["enter"])
      ],
      onInput: d[0] || (d[0] = (f) => {
        o.value = f.target.value, p(a).highlightFirstItem(f);
      }),
      onCompositionstart: p(a).onCompositionStart,
      onCompositionend: p(a).onCompositionEnd
    }, {
      default: S(() => [
        $(c.$slots, "default", { modelValue: p(o) })
      ]),
      _: 3
    }, 8, ["as", "as-child", "value", "disabled", "data-disabled", "aria-disabled", "aria-activedescendant", "onKeydown", "onCompositionstart", "onCompositionend"]));
  }
}), px = "listbox.select", [hx, mx] = yt("ListboxItem"), r0 = /* @__PURE__ */ j({
  __name: "ListboxItem",
  props: {
    value: {},
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "div" }
  },
  emits: ["select"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = Bt(void 0, "reka-listbox-item"), { CollectionItem: a } = Lr(), { forwardRef: i, currentElement: s } = De(), l = Lc(), u = A(() => s.value === l.highlightedElement.value), c = A(() => ex(l.modelValue.value, n.value, l.by)), d = A(() => l.disabled.value || n.disabled);
    async function f(m) {
      r("select", m), !(m != null && m.defaultPrevented) && !d.value && m && (l.onValueChange(n.value), l.changeHighlight(s.value));
    }
    function h(m) {
      const g = { originalEvent: m, value: n.value };
      Tl(px, f, g);
    }
    return mx({
      isSelected: c
    }), (m, g) => (w(), I(p(a), { value: m.value }, {
      default: S(() => [
        n_([u.value, c.value], () => q(p(He), oe({ id: p(o) }, m.$attrs, {
          ref: p(i),
          role: "option",
          tabindex: p(l).focusable.value ? u.value ? "0" : "-1" : -1,
          "aria-selected": c.value,
          as: m.as,
          "as-child": m.asChild,
          disabled: d.value ? "" : void 0,
          "data-disabled": d.value ? "" : void 0,
          "data-highlighted": u.value ? "" : void 0,
          "data-state": c.value ? "checked" : "unchecked",
          onClick: h,
          onKeydown: to(Xe(h, ["prevent"]), ["space"]),
          onPointermove: g[0] || (g[0] = (y) => {
            p(l).highlightedElement.value !== p(s) && (p(l).highlightOnHover.value ? p(l).changeHighlight(p(s), !1) : p(l).focusable.value || p(l).changeHighlight(p(s), !1));
          })
        }), {
          default: S(() => [
            $(m.$slots, "default")
          ]),
          _: 3
        }, 16, ["id", "tabindex", "aria-selected", "as", "as-child", "disabled", "data-disabled", "data-highlighted", "data-state", "onKeydown"]), g, 1)
      ]),
      _: 3
    }, 8, ["value"]));
  }
}), o0 = /* @__PURE__ */ j({
  __name: "ComboboxItem",
  props: {
    textValue: {},
    value: {},
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["select"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = Bt(void 0, "reka-combobox-item"), a = Bo(), i = t0(null), { primitiveElement: s, currentElement: l } = Ja();
    if (n.value === "")
      throw new Error(
        "A <ComboboxItem /> must have a value prop that is not an empty string. This is because the Combobox value can be set to an empty string to clear the selection and show the placeholder."
      );
    const u = A(() => {
      if (a.isVirtual.value || a.ignoreFilter.value || !a.filterState.search)
        return !0;
      {
        const c = a.filterState.filtered.items.get(o);
        return c === void 0 ? !0 : c > 0;
      }
    });
    return ze(() => {
      var d;
      a.allItems.value.set(o, n.textValue || l.value.textContent || l.value.innerText);
      const c = i == null ? void 0 : i.id;
      c && (a.allGroups.value.has(c) ? (d = a.allGroups.value.get(c)) == null || d.add(o) : a.allGroups.value.set(c, /* @__PURE__ */ new Set([o])));
    }), En(() => {
      a.allItems.value.delete(o);
    }), (c, d) => u.value ? (w(), I(p(r0), oe({ key: 0 }, n, {
      id: p(o),
      ref_key: "primitiveElement",
      ref: s,
      disabled: p(a).disabled.value || c.disabled,
      onSelect: d[0] || (d[0] = (f) => {
        r("select", f), !f.defaultPrevented && !p(a).multiple.value && !c.disabled && !p(a).disabled.value && (f.preventDefault(), p(a).onOpenChange(!1), p(a).modelValue.value = n.value);
      })
    }), {
      default: S(() => [
        $(c.$slots, "default", {}, () => [
          We(Se(c.value), 1)
        ])
      ]),
      _: 3
    }, 16, ["id", "disabled"])) : V("", !0);
  }
}), a0 = /* @__PURE__ */ j({
  __name: "ListboxItemIndicator",
  props: {
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  setup(t) {
    const e = t;
    De();
    const n = hx();
    return (r, o) => p(n).isSelected.value ? (w(), I(p(He), oe({
      key: 0,
      "aria-hidden": "true"
    }, e), {
      default: S(() => [
        $(r.$slots, "default")
      ]),
      _: 3
    }, 16)) : V("", !0);
  }
}), i0 = /* @__PURE__ */ j({
  __name: "ComboboxItemIndicator",
  props: {
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  setup(t) {
    const e = t;
    return (n, r) => (w(), I(p(a0), Ye(ot(e)), {
      default: S(() => [
        $(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), s0 = /* @__PURE__ */ j({
  __name: "ComboboxLabel",
  props: {
    for: {},
    asChild: { type: Boolean },
    as: { default: "div" }
  },
  setup(t) {
    const e = t;
    De();
    const n = t0({ id: "", labelId: "" });
    return n.labelId || (n.labelId = Bt(void 0, "reka-combobox-group-label")), (r, o) => (w(), I(p(He), oe(e, {
      id: p(n).labelId
    }), {
      default: S(() => [
        $(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["id"]));
  }
}), l0 = /* @__PURE__ */ j({
  __name: "ComboboxPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    defer: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(t) {
    const e = t;
    return (n, r) => (w(), I(p(fs), Ye(ot(e)), {
      default: S(() => [
        $(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), u0 = /* @__PURE__ */ j({
  __name: "ComboboxTrigger",
  props: {
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(t) {
    const e = t, { forwardRef: n, currentElement: r } = De(), o = Bo(), a = A(() => e.disabled || o.disabled.value || !1);
    return ze(() => {
      r.value && o.onTriggerElementChange(r.value);
    }), (i, s) => (w(), I(p(He), oe(e, {
      ref: p(n),
      type: i.as === "button" ? "button" : void 0,
      tabindex: "-1",
      "aria-label": "Show popup",
      "aria-haspopup": "listbox",
      "aria-expanded": p(o).open.value,
      "aria-controls": p(o).contentId,
      "data-state": p(o).open.value ? "open" : "closed",
      disabled: a.value,
      "data-disabled": a.value ? "" : void 0,
      "aria-disabled": a.value ?? void 0,
      onClick: s[0] || (s[0] = (l) => p(o).onOpenChange(!p(o).open.value))
    }), {
      default: S(() => [
        $(i.$slots, "default")
      ]),
      _: 3
    }, 16, ["type", "aria-expanded", "aria-controls", "data-state", "disabled", "data-disabled", "aria-disabled"]));
  }
});
function c0(t) {
  const e = Pc({
    nonce: F()
  });
  return A(() => {
    var n;
    return (t == null ? void 0 : t.value) || ((n = e.nonce) == null ? void 0 : n.value);
  });
}
const d0 = /* @__PURE__ */ j({
  __name: "ComboboxViewport",
  props: {
    nonce: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const e = t, { forwardRef: n } = De(), { nonce: r } = Gt(e), o = c0(r), a = Bo();
    return (i, s) => (w(), K(Me, null, [
      q(p(He), oe({ ...i.$attrs, ...e }, {
        ref: p(n),
        "data-reka-combobox-viewport": "",
        role: "presentation",
        style: {
          // we use position: 'relative' here on the `viewport` so that when we call
          // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
          // (independent of the scrollUpButton).
          position: "relative",
          flex: p(a).isVirtual.value ? void 0 : 1,
          overflow: "auto"
        }
      }), {
        default: S(() => [
          $(i.$slots, "default")
        ]),
        _: 3
      }, 16, ["style"]),
      q(p(He), {
        as: "style",
        nonce: p(o)
      }, {
        default: S(() => s[0] || (s[0] = [
          We(" /* Hide scrollbars cross-browser and enable momentum scroll for touch devices */ [data-reka-combobox-viewport] { scrollbar-width:none; -ms-overflow-style: none; -webkit-overflow-scrolling: touch; } [data-reka-combobox-viewport]::-webkit-scrollbar { display: none; } ")
        ])),
        _: 1
      }, 8, ["nonce"])
    ], 64));
  }
}), gx = /* @__PURE__ */ j({
  __name: "MenuArrow",
  props: {
    width: {},
    height: {},
    rounded: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const e = t;
    return (n, r) => (w(), I(p(Gp), Ye(ot(e)), {
      default: S(() => [
        $(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
});
function vx() {
  const t = F(!1);
  return ze(() => {
    No("keydown", () => {
      t.value = !0;
    }, { capture: !0, passive: !0 }), No(["pointerdown", "pointermove"], () => {
      t.value = !1;
    }, { capture: !0, passive: !0 });
  }), t;
}
const yx = Ab(vx), [ai, f0] = yt(["MenuRoot", "MenuSub"], "MenuContext"), [Dl, bx] = yt("MenuRoot"), kx = /* @__PURE__ */ j({
  __name: "MenuRoot",
  props: {
    open: { type: Boolean, default: !1 },
    dir: {},
    modal: { type: Boolean, default: !0 }
  },
  emits: ["update:open"],
  setup(t, { emit: e }) {
    const n = t, r = e, { modal: o, dir: a } = Gt(n), i = ga(a), s = Xt(n, "open", r), l = F(), u = yx();
    return f0({
      open: s,
      onOpenChange: (c) => {
        s.value = c;
      },
      content: l,
      onContentChange: (c) => {
        l.value = c;
      }
    }), bx({
      onClose: () => {
        s.value = !1;
      },
      isUsingKeyboardRef: u,
      dir: i,
      modal: o
    }), (c, d) => (w(), I(p(ms), null, {
      default: S(() => [
        $(c.$slots, "default")
      ]),
      _: 3
    }));
  }
});
let bd = 0;
function Jp() {
  Nn((t) => {
    if (!Lo)
      return;
    const e = document.querySelectorAll("[data-reka-focus-guard]");
    document.body.insertAdjacentElement(
      "afterbegin",
      e[0] ?? vg()
    ), document.body.insertAdjacentElement(
      "beforeend",
      e[1] ?? vg()
    ), bd++, t(() => {
      bd === 1 && document.querySelectorAll("[data-reka-focus-guard]").forEach((n) => n.remove()), bd--;
    });
  });
}
function vg() {
  const t = document.createElement("span");
  return t.setAttribute("data-reka-focus-guard", ""), t.tabIndex = 0, t.style.outline = "none", t.style.opacity = "0", t.style.position = "fixed", t.style.pointerEvents = "none", t;
}
const [Xp, wx] = yt("MenuContent"), Qp = /* @__PURE__ */ j({
  __name: "MenuContentImpl",
  props: /* @__PURE__ */ $y({
    loop: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    disableOutsideScroll: { type: Boolean },
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    positionStrategy: {},
    updatePositionStrategy: {},
    disableUpdateOnLayoutShift: { type: Boolean },
    prioritizePosition: { type: Boolean },
    reference: {},
    asChild: { type: Boolean },
    as: {}
  }, {
    ...qb
  }),
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "entryFocus", "openAutoFocus", "closeAutoFocus", "dismiss"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = ai(), a = Dl(), { trapFocus: i, disableOutsidePointerEvents: s, loop: l } = Gt(n);
    Jp(), xl(s.value);
    const u = F(""), c = F(0), d = F(0), f = F(null), h = F("right"), m = F(0), g = F(null), y = F(), { forwardRef: b, currentElement: C } = De(), { handleTypeaheadSearch: k } = Rc();
    Ke(C, (O) => {
      o.onContentChange(O);
    }), En(() => {
      window.clearTimeout(c.value);
    });
    function v(O) {
      var N, z;
      return h.value === ((N = f.value) == null ? void 0 : N.side) && oS(O, (z = f.value) == null ? void 0 : z.area);
    }
    async function E(O) {
      var R;
      r("openAutoFocus", O), !O.defaultPrevented && (O.preventDefault(), (R = C.value) == null || R.focus({
        preventScroll: !0
      }));
    }
    function _(O) {
      var Q;
      if (O.defaultPrevented)
        return;
      const N = O.target.closest("[data-reka-menu-content]") === O.currentTarget, z = O.ctrlKey || O.altKey || O.metaKey, te = O.key.length === 1, H = Pb(
        O,
        Pn(),
        C.value,
        {
          loop: l.value,
          arrowKeyOptions: "vertical",
          dir: a == null ? void 0 : a.dir.value,
          focus: !0,
          attributeName: "[data-reka-collection-item]:not([data-disabled])"
        }
      );
      if (H)
        return H == null ? void 0 : H.focus();
      if (O.code === "Space")
        return;
      const U = ((Q = y.value) == null ? void 0 : Q.getItems()) ?? [];
      if (N && (O.key === "Tab" && O.preventDefault(), !z && te && k(O.key, U)), O.target !== C.value || !eS.includes(O.key))
        return;
      O.preventDefault();
      const W = [...U.map((de) => de.ref)];
      Rb.includes(O.key) && W.reverse(), Af(W);
    }
    function T(O) {
      var R, N;
      (N = (R = O == null ? void 0 : O.currentTarget) == null ? void 0 : R.contains) != null && N.call(R, O.target) || (window.clearTimeout(c.value), u.value = "");
    }
    function M(O) {
      var z;
      if (!rl(O))
        return;
      const R = O.target, N = m.value !== O.clientX;
      if ((z = O == null ? void 0 : O.currentTarget) != null && z.contains(R) && N) {
        const te = O.clientX > m.value ? "right" : "left";
        h.value = te, m.value = O.clientX;
      }
    }
    return wx({
      onItemEnter: (O) => !!v(O),
      onItemLeave: (O) => {
        var R;
        v(O) || ((R = C.value) == null || R.focus(), g.value = null);
      },
      onTriggerLeave: (O) => !!v(O),
      searchRef: u,
      pointerGraceTimerRef: d,
      onPointerGraceIntentChange: (O) => {
        f.value = O;
      }
    }), (O, R) => (w(), I(p($c), {
      "as-child": "",
      trapped: p(i),
      onMountAutoFocus: E,
      onUnmountAutoFocus: R[7] || (R[7] = (N) => r("closeAutoFocus", N))
    }, {
      default: S(() => [
        q(p(ds), {
          "as-child": "",
          "disable-outside-pointer-events": p(s),
          onEscapeKeyDown: R[2] || (R[2] = (N) => r("escapeKeyDown", N)),
          onPointerDownOutside: R[3] || (R[3] = (N) => r("pointerDownOutside", N)),
          onFocusOutside: R[4] || (R[4] = (N) => r("focusOutside", N)),
          onInteractOutside: R[5] || (R[5] = (N) => r("interactOutside", N)),
          onDismiss: R[6] || (R[6] = (N) => r("dismiss"))
        }, {
          default: S(() => [
            q(p(Wb), {
              ref_key: "rovingFocusGroupRef",
              ref: y,
              "current-tab-stop-id": g.value,
              "onUpdate:currentTabStopId": R[0] || (R[0] = (N) => g.value = N),
              "as-child": "",
              orientation: "vertical",
              dir: p(a).dir.value,
              loop: p(l),
              onEntryFocus: R[1] || (R[1] = (N) => {
                r("entryFocus", N), p(a).isUsingKeyboardRef.value || N.preventDefault();
              })
            }, {
              default: S(() => [
                q(p(Il), {
                  ref: p(b),
                  role: "menu",
                  as: O.as,
                  "as-child": O.asChild,
                  "aria-orientation": "vertical",
                  "data-reka-menu-content": "",
                  "data-state": p(qp)(p(o).open.value),
                  dir: p(a).dir.value,
                  side: O.side,
                  "side-offset": O.sideOffset,
                  align: O.align,
                  "align-offset": O.alignOffset,
                  "avoid-collisions": O.avoidCollisions,
                  "collision-boundary": O.collisionBoundary,
                  "collision-padding": O.collisionPadding,
                  "arrow-padding": O.arrowPadding,
                  "prioritize-position": O.prioritizePosition,
                  "position-strategy": O.positionStrategy,
                  "update-position-strategy": O.updatePositionStrategy,
                  sticky: O.sticky,
                  "hide-when-detached": O.hideWhenDetached,
                  reference: O.reference,
                  onKeydown: _,
                  onBlur: T,
                  onPointermove: M
                }, {
                  default: S(() => [
                    $(O.$slots, "default")
                  ]),
                  _: 3
                }, 8, ["as", "as-child", "data-state", "dir", "side", "side-offset", "align", "align-offset", "avoid-collisions", "collision-boundary", "collision-padding", "arrow-padding", "prioritize-position", "position-strategy", "update-position-strategy", "sticky", "hide-when-detached", "reference"])
              ]),
              _: 3
            }, 8, ["current-tab-stop-id", "dir", "loop"])
          ]),
          _: 3
        }, 8, ["disable-outside-pointer-events"])
      ]),
      _: 3
    }, 8, ["trapped"]));
  }
}), p0 = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "MenuItemImpl",
  props: {
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const e = t, n = Xp(), { forwardRef: r } = De(), { CollectionItem: o } = Lr(), a = F(!1);
    async function i(l) {
      if (!l.defaultPrevented && rl(l)) {
        if (e.disabled)
          n.onItemLeave(l);
        else if (!n.onItemEnter(l)) {
          const c = l.currentTarget;
          c == null || c.focus({ preventScroll: !0 });
        }
      }
    }
    async function s(l) {
      await nt(), !l.defaultPrevented && rl(l) && n.onItemLeave(l);
    }
    return (l, u) => (w(), I(p(o), {
      value: { textValue: l.textValue }
    }, {
      default: S(() => [
        q(p(He), oe({
          ref: p(r),
          role: "menuitem",
          tabindex: "-1"
        }, l.$attrs, {
          as: l.as,
          "as-child": l.asChild,
          "aria-disabled": l.disabled || void 0,
          "data-disabled": l.disabled ? "" : void 0,
          "data-highlighted": a.value ? "" : void 0,
          onPointermove: i,
          onPointerleave: s,
          onFocus: u[0] || (u[0] = async (c) => {
            await nt(), !(c.defaultPrevented || l.disabled) && (a.value = !0);
          }),
          onBlur: u[1] || (u[1] = async (c) => {
            await nt(), !c.defaultPrevented && (a.value = !1);
          })
        }), {
          default: S(() => [
            $(l.$slots, "default")
          ]),
          _: 3
        }, 16, ["as", "as-child", "aria-disabled", "data-disabled", "data-highlighted"])
      ]),
      _: 3
    }, 8, ["value"]));
  }
}), _x = /* @__PURE__ */ j({
  __name: "MenuItem",
  props: {
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["select"],
  setup(t, { emit: e }) {
    const n = t, r = e, { forwardRef: o, currentElement: a } = De(), i = Dl(), s = Xp(), l = F(!1);
    async function u() {
      const c = a.value;
      if (!n.disabled && c) {
        const d = new CustomEvent(QT, {
          bubbles: !0,
          cancelable: !0
        });
        r("select", d), await nt(), d.defaultPrevented ? l.value = !1 : i.onClose();
      }
    }
    return (c, d) => (w(), I(p0, oe(n, {
      ref: p(o),
      onClick: u,
      onPointerdown: d[0] || (d[0] = () => {
        l.value = !0;
      }),
      onPointerup: d[1] || (d[1] = async (f) => {
        var h;
        await nt(), !f.defaultPrevented && (l.value || (h = f.currentTarget) == null || h.click());
      }),
      onKeydown: d[2] || (d[2] = async (f) => {
        const h = p(s).searchRef.value !== "";
        c.disabled || h && f.key === " " || p(xf).includes(f.key) && (f.currentTarget.click(), f.preventDefault());
      })
    }), {
      default: S(() => [
        $(c.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Cx = /* @__PURE__ */ j({
  __name: "MenuRootContentModal",
  props: {
    loop: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    positionStrategy: {},
    updatePositionStrategy: {},
    disableUpdateOnLayoutShift: { type: Boolean },
    prioritizePosition: { type: Boolean },
    reference: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "entryFocus", "openAutoFocus", "closeAutoFocus"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = vr(n, r), a = ai(), { forwardRef: i, currentElement: s } = De();
    return Sl(s), (l, u) => (w(), I(Qp, oe(p(o), {
      ref: p(i),
      "trap-focus": p(a).open.value,
      "disable-outside-pointer-events": p(a).open.value,
      "disable-outside-scroll": !0,
      onDismiss: u[0] || (u[0] = (c) => p(a).onOpenChange(!1)),
      onFocusOutside: u[1] || (u[1] = Xe((c) => r("focusOutside", c), ["prevent"]))
    }), {
      default: S(() => [
        $(l.$slots, "default")
      ]),
      _: 3
    }, 16, ["trap-focus", "disable-outside-pointer-events"]));
  }
}), Ex = /* @__PURE__ */ j({
  __name: "MenuRootContentNonModal",
  props: {
    loop: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    positionStrategy: {},
    updatePositionStrategy: {},
    disableUpdateOnLayoutShift: { type: Boolean },
    prioritizePosition: { type: Boolean },
    reference: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "entryFocus", "openAutoFocus", "closeAutoFocus"],
  setup(t, { emit: e }) {
    const o = vr(t, e), a = ai();
    return (i, s) => (w(), I(Qp, oe(p(o), {
      "trap-focus": !1,
      "disable-outside-pointer-events": !1,
      "disable-outside-scroll": !1,
      onDismiss: s[0] || (s[0] = (l) => p(a).onOpenChange(!1))
    }), {
      default: S(() => [
        $(i.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Ox = /* @__PURE__ */ j({
  __name: "MenuContent",
  props: {
    forceMount: { type: Boolean },
    loop: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    positionStrategy: {},
    updatePositionStrategy: {},
    disableUpdateOnLayoutShift: { type: Boolean },
    prioritizePosition: { type: Boolean },
    reference: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "entryFocus", "openAutoFocus", "closeAutoFocus"],
  setup(t, { emit: e }) {
    const o = vr(t, e), a = ai(), i = Dl();
    return (s, l) => (w(), I(p(Rr), {
      present: s.forceMount || p(a).open.value
    }, {
      default: S(() => [
        p(i).modal.value ? (w(), I(Cx, Ye(oe({ key: 0 }, { ...s.$attrs, ...p(o) })), {
          default: S(() => [
            $(s.$slots, "default")
          ]),
          _: 3
        }, 16)) : (w(), I(Ex, Ye(oe({ key: 1 }, { ...s.$attrs, ...p(o) })), {
          default: S(() => [
            $(s.$slots, "default")
          ]),
          _: 3
        }, 16))
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), Tx = /* @__PURE__ */ j({
  __name: "MenuLabel",
  props: {
    asChild: { type: Boolean },
    as: { default: "div" }
  },
  setup(t) {
    const e = t;
    return (n, r) => (w(), I(p(He), Ye(ot(e)), {
      default: S(() => [
        $(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Sx = /* @__PURE__ */ j({
  __name: "MenuPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    defer: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(t) {
    const e = t;
    return (n, r) => (w(), I(p(fs), Ye(ot(e)), {
      default: S(() => [
        $(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), xx = /* @__PURE__ */ j({
  __name: "MenuSeparator",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const e = t;
    return (n, r) => (w(), I(p(He), oe(e, {
      role: "separator",
      "aria-orientation": "horizontal"
    }), {
      default: S(() => [
        $(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), [h0, Ax] = yt("MenuSub"), Mx = /* @__PURE__ */ j({
  __name: "MenuSub",
  props: {
    open: { type: Boolean, default: void 0 }
  },
  emits: ["update:open"],
  setup(t, { emit: e }) {
    const n = t, o = Xt(n, "open", e, {
      defaultValue: !1,
      passive: n.open === void 0
    }), a = ai(), i = F(), s = F();
    return Nn((l) => {
      (a == null ? void 0 : a.open.value) === !1 && (o.value = !1), l(() => o.value = !1);
    }), f0({
      open: o,
      onOpenChange: (l) => {
        o.value = l;
      },
      content: s,
      onContentChange: (l) => {
        s.value = l;
      }
    }), Ax({
      triggerId: "",
      contentId: "",
      trigger: i,
      onTriggerChange: (l) => {
        i.value = l;
      }
    }), (l, u) => (w(), I(p(ms), null, {
      default: S(() => [
        $(l.$slots, "default")
      ]),
      _: 3
    }));
  }
}), Ix = /* @__PURE__ */ j({
  __name: "MenuSubContent",
  props: {
    forceMount: { type: Boolean },
    loop: { type: Boolean },
    sideOffset: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    positionStrategy: {},
    updatePositionStrategy: {},
    disableUpdateOnLayoutShift: { type: Boolean },
    prioritizePosition: { type: Boolean, default: !0 },
    reference: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "entryFocus", "openAutoFocus", "closeAutoFocus"],
  setup(t, { emit: e }) {
    const o = vr(t, e), a = ai(), i = Dl(), s = h0(), { forwardRef: l, currentElement: u } = De();
    return s.contentId || (s.contentId = Bt(void 0, "reka-menu-sub-content")), (c, d) => (w(), I(p(Rr), {
      present: c.forceMount || p(a).open.value
    }, {
      default: S(() => [
        q(Qp, oe(p(o), {
          id: p(s).contentId,
          ref: p(l),
          "aria-labelledby": p(s).triggerId,
          align: "start",
          side: p(i).dir.value === "rtl" ? "left" : "right",
          "disable-outside-pointer-events": !1,
          "disable-outside-scroll": !1,
          "trap-focus": !1,
          onOpenAutoFocus: d[0] || (d[0] = Xe((f) => {
            var h;
            p(i).isUsingKeyboardRef.value && ((h = p(u)) == null || h.focus());
          }, ["prevent"])),
          onCloseAutoFocus: d[1] || (d[1] = Xe(() => {
          }, ["prevent"])),
          onFocusOutside: d[2] || (d[2] = (f) => {
            f.defaultPrevented || f.target !== p(s).trigger.value && p(a).onOpenChange(!1);
          }),
          onEscapeKeyDown: d[3] || (d[3] = (f) => {
            p(i).onClose(), f.preventDefault();
          }),
          onKeydown: d[4] || (d[4] = (f) => {
            var g, y;
            const h = (g = f.currentTarget) == null ? void 0 : g.contains(f.target), m = p(nS)[p(i).dir.value].includes(f.key);
            h && m && (p(a).onOpenChange(!1), (y = p(s).trigger.value) == null || y.focus(), f.preventDefault());
          })
        }), {
          default: S(() => [
            $(c.$slots, "default")
          ]),
          _: 3
        }, 16, ["id", "aria-labelledby", "side"])
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), m0 = /* @__PURE__ */ j({
  __name: "MenuAnchor",
  props: {
    reference: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const e = t;
    return (n, r) => (w(), I(p(Ml), Ye(ot(e)), {
      default: S(() => [
        $(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Dx = /* @__PURE__ */ j({
  __name: "MenuSubTrigger",
  props: {
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const e = t, n = ai(), r = Dl(), o = h0(), a = Xp(), i = F(null);
    o.triggerId || (o.triggerId = Bt(void 0, "reka-menu-sub-trigger"));
    function s() {
      i.value && window.clearTimeout(i.value), i.value = null;
    }
    En(() => {
      s();
    });
    function l(d) {
      !rl(d) || a.onItemEnter(d) || !e.disabled && !n.open.value && !i.value && (a.onPointerGraceIntentChange(null), i.value = window.setTimeout(() => {
        n.onOpenChange(!0), s();
      }, 100));
    }
    async function u(d) {
      var h, m;
      if (!rl(d))
        return;
      s();
      const f = (h = n.content.value) == null ? void 0 : h.getBoundingClientRect();
      if (f != null && f.width) {
        const g = (m = n.content.value) == null ? void 0 : m.dataset.side, y = g === "right", b = y ? -5 : 5, C = f[y ? "left" : "right"], k = f[y ? "right" : "left"];
        a.onPointerGraceIntentChange({
          area: [
            // Apply a bleed on clientX to ensure that our exit point is
            // consistently within polygon bounds
            { x: d.clientX + b, y: d.clientY },
            { x: C, y: f.top },
            { x: k, y: f.top },
            { x: k, y: f.bottom },
            { x: C, y: f.bottom }
          ],
          side: g
        }), window.clearTimeout(a.pointerGraceTimerRef.value), a.pointerGraceTimerRef.value = window.setTimeout(
          () => a.onPointerGraceIntentChange(null),
          300
        );
      } else {
        if (a.onTriggerLeave(d))
          return;
        a.onPointerGraceIntentChange(null);
      }
    }
    async function c(d) {
      var h;
      const f = a.searchRef.value !== "";
      e.disabled || f && d.key === " " || tS[r.dir.value].includes(d.key) && (n.onOpenChange(!0), await nt(), (h = n.content.value) == null || h.focus(), d.preventDefault());
    }
    return (d, f) => (w(), I(m0, { "as-child": "" }, {
      default: S(() => [
        q(p0, oe(e, {
          id: p(o).triggerId,
          ref: (h) => {
            var m;
            (m = p(o)) == null || m.onTriggerChange(h == null ? void 0 : h.$el);
          },
          "aria-haspopup": "menu",
          "aria-expanded": p(n).open.value,
          "aria-controls": p(o).contentId,
          "data-state": p(qp)(p(n).open.value),
          onClick: f[0] || (f[0] = async (h) => {
            e.disabled || h.defaultPrevented || (h.currentTarget.focus(), p(n).open.value || p(n).onOpenChange(!0));
          }),
          onPointermove: l,
          onPointerleave: u,
          onKeydown: c
        }), {
          default: S(() => [
            $(d.$slots, "default")
          ]),
          _: 3
        }, 16, ["id", "aria-expanded", "aria-controls", "data-state"])
      ]),
      _: 3
    }));
  }
}), [gs, Px] = yt("PopoverRoot"), Nx = /* @__PURE__ */ j({
  __name: "PopoverRoot",
  props: {
    defaultOpen: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    modal: { type: Boolean, default: !1 }
  },
  emits: ["update:open"],
  setup(t, { emit: e }) {
    const n = t, r = e, { modal: o } = Gt(n), a = Xt(n, "open", r, {
      defaultValue: n.defaultOpen,
      passive: n.open === void 0
    }), i = F(), s = F(!1);
    return Px({
      contentId: "",
      triggerId: "",
      modal: o,
      open: a,
      onOpenChange: (l) => {
        a.value = l;
      },
      onOpenToggle: () => {
        a.value = !a.value;
      },
      triggerElement: i,
      hasCustomAnchor: s
    }), (l, u) => (w(), I(p(ms), null, {
      default: S(() => [
        $(l.$slots, "default", { open: p(a) })
      ]),
      _: 3
    }));
  }
}), $x = /* @__PURE__ */ j({
  __name: "PopoverArrow",
  props: {
    width: { default: 10 },
    height: { default: 5 },
    rounded: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "svg" }
  },
  setup(t) {
    const e = t;
    return De(), (n, r) => (w(), I(p(Gp), Ye(ot(e)), {
      default: S(() => [
        $(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Rx = /* @__PURE__ */ j({
  __name: "PopoverClose",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(t) {
    const e = t;
    De();
    const n = gs();
    return (r, o) => (w(), I(p(He), {
      type: r.as === "button" ? "button" : void 0,
      as: r.as,
      "as-child": e.asChild,
      onClick: o[0] || (o[0] = (a) => p(n).onOpenChange(!1))
    }, {
      default: S(() => [
        $(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["type", "as", "as-child"]));
  }
}), Lx = /* @__PURE__ */ j({
  __name: "PopoverPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    defer: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(t) {
    const e = t;
    return (n, r) => (w(), I(p(fs), Ye(ot(e)), {
      default: S(() => [
        $(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), g0 = /* @__PURE__ */ j({
  __name: "PopoverContentImpl",
  props: {
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    positionStrategy: {},
    updatePositionStrategy: {},
    disableUpdateOnLayoutShift: { type: Boolean },
    prioritizePosition: { type: Boolean },
    reference: {},
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = ps(dT(n, "trapFocus", "disableOutsidePointerEvents")), { forwardRef: a } = De(), i = gs();
    return Jp(), (s, l) => (w(), I(p($c), {
      "as-child": "",
      loop: "",
      trapped: s.trapFocus,
      onMountAutoFocus: l[5] || (l[5] = (u) => r("openAutoFocus", u)),
      onUnmountAutoFocus: l[6] || (l[6] = (u) => r("closeAutoFocus", u))
    }, {
      default: S(() => [
        q(p(ds), {
          "as-child": "",
          "disable-outside-pointer-events": s.disableOutsidePointerEvents,
          onPointerDownOutside: l[0] || (l[0] = (u) => r("pointerDownOutside", u)),
          onInteractOutside: l[1] || (l[1] = (u) => r("interactOutside", u)),
          onEscapeKeyDown: l[2] || (l[2] = (u) => r("escapeKeyDown", u)),
          onFocusOutside: l[3] || (l[3] = (u) => r("focusOutside", u)),
          onDismiss: l[4] || (l[4] = (u) => p(i).onOpenChange(!1))
        }, {
          default: S(() => [
            q(p(Il), oe(p(o), {
              id: p(i).contentId,
              ref: p(a),
              "data-state": p(i).open.value ? "open" : "closed",
              "aria-labelledby": p(i).triggerId,
              style: {
                "--reka-popover-content-transform-origin": "var(--reka-popper-transform-origin)",
                "--reka-popover-content-available-width": "var(--reka-popper-available-width)",
                "--reka-popover-content-available-height": "var(--reka-popper-available-height)",
                "--reka-popover-trigger-width": "var(--reka-popper-anchor-width)",
                "--reka-popover-trigger-height": "var(--reka-popper-anchor-height)"
              },
              role: "dialog"
            }), {
              default: S(() => [
                $(s.$slots, "default")
              ]),
              _: 3
            }, 16, ["id", "data-state", "aria-labelledby"])
          ]),
          _: 3
        }, 8, ["disable-outside-pointer-events"])
      ]),
      _: 3
    }, 8, ["trapped"]));
  }
}), Bx = /* @__PURE__ */ j({
  __name: "PopoverContentModal",
  props: {
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    positionStrategy: {},
    updatePositionStrategy: {},
    disableUpdateOnLayoutShift: { type: Boolean },
    prioritizePosition: { type: Boolean },
    reference: {},
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = gs(), a = F(!1);
    xl(!0);
    const i = vr(n, r), { forwardRef: s, currentElement: l } = De();
    return Sl(l), (u, c) => (w(), I(g0, oe(p(i), {
      ref: p(s),
      "trap-focus": p(o).open.value,
      "disable-outside-pointer-events": "",
      onCloseAutoFocus: c[0] || (c[0] = Xe(
        (d) => {
          var f;
          r("closeAutoFocus", d), a.value || (f = p(o).triggerElement.value) == null || f.focus();
        },
        ["prevent"]
      )),
      onPointerDownOutside: c[1] || (c[1] = (d) => {
        r("pointerDownOutside", d);
        const f = d.detail.originalEvent, h = f.button === 0 && f.ctrlKey === !0, m = f.button === 2 || h;
        a.value = m;
      }),
      onFocusOutside: c[2] || (c[2] = Xe(() => {
      }, ["prevent"]))
    }), {
      default: S(() => [
        $(u.$slots, "default")
      ]),
      _: 3
    }, 16, ["trap-focus"]));
  }
}), Fx = /* @__PURE__ */ j({
  __name: "PopoverContentNonModal",
  props: {
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    positionStrategy: {},
    updatePositionStrategy: {},
    disableUpdateOnLayoutShift: { type: Boolean },
    prioritizePosition: { type: Boolean },
    reference: {},
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = gs(), a = F(!1), i = F(!1), s = vr(n, r);
    return (l, u) => (w(), I(g0, oe(p(s), {
      "trap-focus": !1,
      "disable-outside-pointer-events": !1,
      onCloseAutoFocus: u[0] || (u[0] = (c) => {
        var d;
        r("closeAutoFocus", c), c.defaultPrevented || (a.value || (d = p(o).triggerElement.value) == null || d.focus(), c.preventDefault()), a.value = !1, i.value = !1;
      }),
      onInteractOutside: u[1] || (u[1] = async (c) => {
        var h;
        r("interactOutside", c), c.defaultPrevented || (a.value = !0, c.detail.originalEvent.type === "pointerdown" && (i.value = !0));
        const d = c.target;
        ((h = p(o).triggerElement.value) == null ? void 0 : h.contains(d)) && c.preventDefault(), c.detail.originalEvent.type === "focusin" && i.value && c.preventDefault();
      })
    }), {
      default: S(() => [
        $(l.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Vx = /* @__PURE__ */ j({
  __name: "PopoverContent",
  props: {
    forceMount: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    positionStrategy: {},
    updatePositionStrategy: {},
    disableUpdateOnLayoutShift: { type: Boolean },
    prioritizePosition: { type: Boolean },
    reference: {},
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = gs(), a = vr(n, r), { forwardRef: i } = De();
    return o.contentId || (o.contentId = Bt(void 0, "reka-popover-content")), (s, l) => (w(), I(p(Rr), {
      present: s.forceMount || p(o).open.value
    }, {
      default: S(() => [
        p(o).modal.value ? (w(), I(Bx, oe({ key: 0 }, p(a), { ref: p(i) }), {
          default: S(() => [
            $(s.$slots, "default")
          ]),
          _: 3
        }, 16)) : (w(), I(Fx, oe({ key: 1 }, p(a), { ref: p(i) }), {
          default: S(() => [
            $(s.$slots, "default")
          ]),
          _: 3
        }, 16))
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), Hx = /* @__PURE__ */ j({
  __name: "PopoverTrigger",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(t) {
    const e = t, n = gs(), { forwardRef: r, currentElement: o } = De();
    return n.triggerId || (n.triggerId = Bt(void 0, "reka-popover-trigger")), ze(() => {
      n.triggerElement.value = o.value;
    }), (a, i) => (w(), I(On(p(n).hasCustomAnchor.value ? p(He) : p(Ml)), { "as-child": "" }, {
      default: S(() => [
        q(p(He), {
          id: p(n).triggerId,
          ref: p(r),
          type: a.as === "button" ? "button" : void 0,
          "aria-haspopup": "dialog",
          "aria-expanded": p(n).open.value,
          "aria-controls": p(n).contentId,
          "data-state": p(n).open.value ? "open" : "closed",
          as: a.as,
          "as-child": e.asChild,
          onClick: p(n).onOpenToggle
        }, {
          default: S(() => [
            $(a.$slots, "default")
          ]),
          _: 3
        }, 8, ["id", "type", "aria-expanded", "aria-controls", "data-state", "as", "as-child", "onClick"])
      ]),
      _: 3
    }));
  }
}), Ux = /* @__PURE__ */ j({
  __name: "DialogPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    defer: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(t) {
    const e = t;
    return (n, r) => (w(), I(p(fs), Ye(ot(e)), {
      default: S(() => [
        $(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Wx = /* @__PURE__ */ j({
  __name: "DropdownMenuArrow",
  props: {
    width: { default: 10 },
    height: { default: 5 },
    rounded: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "svg" }
  },
  setup(t) {
    const e = t;
    return De(), (n, r) => (w(), I(p(gx), Ye(ot(e)), {
      default: S(() => [
        $(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), [v0, Kx] = yt("DropdownMenuRoot"), jx = /* @__PURE__ */ j({
  __name: "DropdownMenuRoot",
  props: {
    defaultOpen: { type: Boolean },
    open: { type: Boolean, default: void 0 },
    dir: {},
    modal: { type: Boolean, default: !0 }
  },
  emits: ["update:open"],
  setup(t, { emit: e }) {
    const n = t, r = e;
    De();
    const o = Xt(n, "open", r, {
      defaultValue: n.defaultOpen,
      passive: n.open === void 0
    }), a = F(), { modal: i, dir: s } = Gt(n), l = ga(s);
    return Kx({
      open: o,
      onOpenChange: (u) => {
        o.value = u;
      },
      onOpenToggle: () => {
        o.value = !o.value;
      },
      triggerId: "",
      triggerElement: a,
      contentId: "",
      modal: i,
      dir: l
    }), (u, c) => (w(), I(p(kx), {
      open: p(o),
      "onUpdate:open": c[0] || (c[0] = (d) => bt(o) ? o.value = d : null),
      dir: p(l),
      modal: p(i)
    }, {
      default: S(() => [
        $(u.$slots, "default", { open: p(o) })
      ]),
      _: 3
    }, 8, ["open", "dir", "modal"]));
  }
}), zx = /* @__PURE__ */ j({
  __name: "DropdownMenuContent",
  props: {
    forceMount: { type: Boolean },
    loop: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    positionStrategy: {},
    updatePositionStrategy: {},
    disableUpdateOnLayoutShift: { type: Boolean },
    prioritizePosition: { type: Boolean },
    reference: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "closeAutoFocus"],
  setup(t, { emit: e }) {
    const o = vr(t, e);
    De();
    const a = v0(), i = F(!1);
    function s(l) {
      l.defaultPrevented || (i.value || setTimeout(() => {
        var u;
        (u = a.triggerElement.value) == null || u.focus();
      }, 0), i.value = !1, l.preventDefault());
    }
    return a.contentId || (a.contentId = Bt(void 0, "reka-dropdown-menu-content")), (l, u) => {
      var c;
      return w(), I(p(Ox), oe(p(o), {
        id: p(a).contentId,
        "aria-labelledby": (c = p(a)) == null ? void 0 : c.triggerId,
        style: {
          "--reka-dropdown-menu-content-transform-origin": "var(--reka-popper-transform-origin)",
          "--reka-dropdown-menu-content-available-width": "var(--reka-popper-available-width)",
          "--reka-dropdown-menu-content-available-height": "var(--reka-popper-available-height)",
          "--reka-dropdown-menu-trigger-width": "var(--reka-popper-anchor-width)",
          "--reka-dropdown-menu-trigger-height": "var(--reka-popper-anchor-height)"
        },
        onCloseAutoFocus: s,
        onInteractOutside: u[0] || (u[0] = (d) => {
          var g;
          if (d.defaultPrevented) return;
          const f = d.detail.originalEvent, h = f.button === 0 && f.ctrlKey === !0, m = f.button === 2 || h;
          (!p(a).modal.value || m) && (i.value = !0), (g = p(a).triggerElement.value) != null && g.contains(d.target) && d.preventDefault();
        })
      }), {
        default: S(() => [
          $(l.$slots, "default")
        ]),
        _: 3
      }, 16, ["id", "aria-labelledby"]);
    };
  }
}), Yx = /* @__PURE__ */ j({
  __name: "DropdownMenuItem",
  props: {
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["select"],
  setup(t, { emit: e }) {
    const n = t, o = Ol(e);
    return De(), (a, i) => (w(), I(p(_x), Ye(ot({ ...n, ...p(o) })), {
      default: S(() => [
        $(a.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), qx = /* @__PURE__ */ j({
  __name: "DropdownMenuLabel",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const e = t;
    return De(), (n, r) => (w(), I(p(Tx), Ye(ot(e)), {
      default: S(() => [
        $(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), y0 = /* @__PURE__ */ j({
  __name: "DropdownMenuPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    defer: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(t) {
    const e = t;
    return (n, r) => (w(), I(p(Sx), Ye(ot(e)), {
      default: S(() => [
        $(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Gx = /* @__PURE__ */ j({
  __name: "DropdownMenuSeparator",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const e = t;
    return De(), (n, r) => (w(), I(p(xx), Ye(ot(e)), {
      default: S(() => [
        $(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Jx = /* @__PURE__ */ j({
  __name: "DropdownMenuSub",
  props: {
    defaultOpen: { type: Boolean },
    open: { type: Boolean, default: void 0 }
  },
  emits: ["update:open"],
  setup(t, { emit: e }) {
    const n = t, o = Xt(n, "open", e, {
      passive: n.open === void 0,
      defaultValue: n.defaultOpen ?? !1
    });
    return De(), (a, i) => (w(), I(p(Mx), {
      open: p(o),
      "onUpdate:open": i[0] || (i[0] = (s) => bt(o) ? o.value = s : null)
    }, {
      default: S(() => [
        $(a.$slots, "default", { open: p(o) })
      ]),
      _: 3
    }, 8, ["open"]));
  }
}), Xx = /* @__PURE__ */ j({
  __name: "DropdownMenuSubContent",
  props: {
    forceMount: { type: Boolean },
    loop: { type: Boolean },
    sideOffset: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    positionStrategy: {},
    updatePositionStrategy: {},
    disableUpdateOnLayoutShift: { type: Boolean },
    prioritizePosition: { type: Boolean },
    reference: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "entryFocus", "openAutoFocus", "closeAutoFocus"],
  setup(t, { emit: e }) {
    const o = vr(t, e);
    return De(), (a, i) => (w(), I(p(Ix), oe(p(o), { style: {
      "--reka-dropdown-menu-content-transform-origin": "var(--reka-popper-transform-origin)",
      "--reka-dropdown-menu-content-available-width": "var(--reka-popper-available-width)",
      "--reka-dropdown-menu-content-available-height": "var(--reka-popper-available-height)",
      "--reka-dropdown-menu-trigger-width": "var(--reka-popper-anchor-width)",
      "--reka-dropdown-menu-trigger-height": "var(--reka-popper-anchor-height)"
    } }), {
      default: S(() => [
        $(a.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Qx = /* @__PURE__ */ j({
  __name: "DropdownMenuSubTrigger",
  props: {
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const e = t;
    return De(), (n, r) => (w(), I(p(Dx), Ye(ot(e)), {
      default: S(() => [
        $(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Zx = /* @__PURE__ */ j({
  __name: "DropdownMenuTrigger",
  props: {
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(t) {
    const e = t, n = v0(), { forwardRef: r, currentElement: o } = De();
    return ze(() => {
      n.triggerElement = o;
    }), n.triggerId || (n.triggerId = Bt(void 0, "reka-dropdown-menu-trigger")), (a, i) => (w(), I(p(m0), { "as-child": "" }, {
      default: S(() => [
        q(p(He), {
          id: p(n).triggerId,
          ref: p(r),
          type: a.as === "button" ? "button" : void 0,
          "as-child": e.asChild,
          as: a.as,
          "aria-haspopup": "menu",
          "aria-expanded": p(n).open.value,
          "aria-controls": p(n).open.value ? p(n).contentId : void 0,
          "data-disabled": a.disabled ? "" : void 0,
          disabled: a.disabled,
          "data-state": p(n).open.value ? "open" : "closed",
          onClick: i[0] || (i[0] = async (s) => {
            var l;
            !a.disabled && s.button === 0 && s.ctrlKey === !1 && ((l = p(n)) == null || l.onOpenToggle(), await nt(), p(n).open.value && s.preventDefault());
          }),
          onKeydown: i[1] || (i[1] = to(
            (s) => {
              a.disabled || (["Enter", " "].includes(s.key) && p(n).onOpenToggle(), s.key === "ArrowDown" && p(n).onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(s.key) && s.preventDefault());
            },
            ["enter", "space", "arrow-down"]
          ))
        }, {
          default: S(() => [
            $(a.$slots, "default")
          ]),
          _: 3
        }, 8, ["id", "type", "as-child", "as", "aria-expanded", "aria-controls", "data-disabled", "disabled", "data-state"])
      ]),
      _: 3
    }));
  }
});
function eA(t, e) {
  const n = zp(!1, 300), r = F(null), o = Ns();
  function a() {
    r.value = null, n.value = !1;
  }
  function i(s, l) {
    const u = s.currentTarget, c = { x: s.clientX, y: s.clientY }, d = tA(c, u.getBoundingClientRect()), f = nA(c, d), h = rA(l.getBoundingClientRect()), m = aA([...f, ...h]);
    r.value = m, n.value = !0;
  }
  return Nn((s) => {
    if (t.value && e.value) {
      const l = (c) => i(c, e.value), u = (c) => i(c, t.value);
      t.value.addEventListener("pointerleave", l), e.value.addEventListener("pointerleave", u), s(() => {
        var c, d;
        (c = t.value) == null || c.removeEventListener("pointerleave", l), (d = e.value) == null || d.removeEventListener("pointerleave", u);
      });
    }
  }), Nn((s) => {
    var l;
    if (r.value) {
      const u = (c) => {
        var y, b;
        if (!r.value || !(c.target instanceof HTMLElement))
          return;
        const d = c.target, f = { x: c.clientX, y: c.clientY }, h = ((y = t.value) == null ? void 0 : y.contains(d)) || ((b = e.value) == null ? void 0 : b.contains(d)), m = !oA(f, r.value), g = !!d.closest("[data-grace-area-trigger]");
        h ? a() : (m || g) && (a(), o.trigger());
      };
      (l = t.value) == null || l.ownerDocument.addEventListener("pointermove", u), s(() => {
        var c;
        return (c = t.value) == null ? void 0 : c.ownerDocument.removeEventListener("pointermove", u);
      });
    }
  }), {
    isPointerInTransit: n,
    onPointerExit: o.on
  };
}
function tA(t, e) {
  const n = Math.abs(e.top - t.y), r = Math.abs(e.bottom - t.y), o = Math.abs(e.right - t.x), a = Math.abs(e.left - t.x);
  switch (Math.min(n, r, o, a)) {
    case a:
      return "left";
    case o:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function nA(t, e, n = 5) {
  const r = [];
  switch (e) {
    case "top":
      r.push(
        { x: t.x - n, y: t.y + n },
        { x: t.x + n, y: t.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: t.x - n, y: t.y - n },
        { x: t.x + n, y: t.y - n }
      );
      break;
    case "left":
      r.push(
        { x: t.x + n, y: t.y - n },
        { x: t.x + n, y: t.y + n }
      );
      break;
    case "right":
      r.push(
        { x: t.x - n, y: t.y - n },
        { x: t.x - n, y: t.y + n }
      );
      break;
  }
  return r;
}
function rA(t) {
  const { top: e, right: n, bottom: r, left: o } = t;
  return [
    { x: o, y: e },
    { x: n, y: e },
    { x: n, y: r },
    { x: o, y: r }
  ];
}
function oA(t, e) {
  const { x: n, y: r } = t;
  let o = !1;
  for (let a = 0, i = e.length - 1; a < e.length; i = a++) {
    const s = e[a].x, l = e[a].y, u = e[i].x, c = e[i].y;
    l > r != c > r && n < (u - s) * (r - l) / (c - l) + s && (o = !o);
  }
  return o;
}
function aA(t) {
  const e = t.slice();
  return e.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), iA(e);
}
function iA(t) {
  if (t.length <= 1)
    return t.slice();
  const e = [];
  for (let r = 0; r < t.length; r++) {
    const o = t[r];
    for (; e.length >= 2; ) {
      const a = e[e.length - 1], i = e[e.length - 2];
      if ((a.x - i.x) * (o.y - i.y) >= (a.y - i.y) * (o.x - i.x))
        e.pop();
      else break;
    }
    e.push(o);
  }
  e.pop();
  const n = [];
  for (let r = t.length - 1; r >= 0; r--) {
    const o = t[r];
    for (; n.length >= 2; ) {
      const a = n[n.length - 1], i = n[n.length - 2];
      if ((a.x - i.x) * (o.y - i.y) >= (a.y - i.y) * (o.x - i.x))
        n.pop();
      else break;
    }
    n.push(o);
  }
  return n.pop(), e.length === 1 && n.length === 1 && e[0].x === n[0].x && e[0].y === n[0].y ? e : e.concat(n);
}
const sA = /* @__PURE__ */ j({
  __name: "ListboxGroupLabel",
  props: {
    for: {},
    asChild: { type: Boolean },
    as: { default: "div" }
  },
  setup(t) {
    const e = t, n = ux({ id: "" });
    return (r, o) => (w(), I(p(He), oe(e, {
      id: p(n).id
    }), {
      default: S(() => [
        $(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["id"]));
  }
});
function yg(t, e = Number.NEGATIVE_INFINITY, n = Number.POSITIVE_INFINITY) {
  return Math.min(n, Math.max(e, t));
}
const lA = "radio.select";
function uA(t, e, n) {
  Tl(lA, n, { originalEvent: t, value: e });
}
const cA = /* @__PURE__ */ j({
  __name: "Radio",
  props: {
    id: {},
    value: {},
    disabled: { type: Boolean, default: !1 },
    checked: { type: Boolean, default: void 0 },
    asChild: { type: Boolean },
    as: { default: "button" },
    name: {},
    required: { type: Boolean }
  },
  emits: ["update:checked", "select"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = Xt(n, "checked", r, {
      passive: n.checked === void 0
    }), { value: a } = Gt(n), { forwardRef: i, currentElement: s } = De(), l = hs(s), u = A(() => {
      var d;
      return n.id && s.value ? ((d = document.querySelector(`[for="${n.id}"]`)) == null ? void 0 : d.innerText) ?? n.value : void 0;
    });
    function c(d) {
      uA(d, n.value, (f) => {
        r("select", f), !(f != null && f.defaultPrevented) && (o.value = !0, l.value && f.stopPropagation());
      });
    }
    return (d, f) => (w(), I(p(He), oe(d.$attrs, {
      id: d.id,
      ref: p(i),
      role: "radio",
      type: d.as === "button" ? "button" : void 0,
      as: d.as,
      "aria-checked": p(o),
      "aria-label": u.value,
      "as-child": d.asChild,
      disabled: d.disabled ? "" : void 0,
      "data-state": p(o) ? "checked" : "unchecked",
      "data-disabled": d.disabled ? "" : void 0,
      value: p(a),
      required: d.required,
      name: d.name,
      onClick: Xe(c, ["stop"])
    }), {
      default: S(() => [
        $(d.$slots, "default", { checked: p(o) }),
        p(l) && d.name ? (w(), I(p(Al), {
          key: 0,
          type: "radio",
          tabindex: "-1",
          value: p(a),
          checked: !!p(o),
          name: d.name,
          disabled: d.disabled,
          required: d.required
        }, null, 8, ["value", "checked", "name", "disabled", "required"])) : V("", !0)
      ]),
      _: 3
    }, 16, ["id", "type", "as", "aria-checked", "aria-label", "as-child", "disabled", "data-state", "data-disabled", "value", "required", "name"]));
  }
}), [dA, fA] = yt("RadioGroupRoot"), pA = /* @__PURE__ */ j({
  __name: "RadioGroupRoot",
  props: {
    modelValue: {},
    defaultValue: {},
    disabled: { type: Boolean, default: !1 },
    orientation: { default: void 0 },
    dir: {},
    loop: { type: Boolean, default: !0 },
    asChild: { type: Boolean },
    as: {},
    name: {},
    required: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, r = e, { forwardRef: o, currentElement: a } = De(), i = Xt(n, "modelValue", r, {
      defaultValue: n.defaultValue,
      passive: n.modelValue === void 0
    }), { disabled: s, loop: l, orientation: u, name: c, required: d, dir: f } = Gt(n), h = ga(f), m = hs(a);
    return fA({
      modelValue: i,
      changeModelValue: (g) => {
        i.value = g;
      },
      disabled: s,
      loop: l,
      orientation: u,
      name: c == null ? void 0 : c.value,
      required: d
    }), (g, y) => (w(), I(p(Wb), {
      "as-child": "",
      orientation: p(u),
      dir: p(h),
      loop: p(l)
    }, {
      default: S(() => [
        q(p(He), {
          ref: p(o),
          role: "radiogroup",
          "data-disabled": p(s) ? "" : void 0,
          "as-child": g.asChild,
          as: g.as,
          "aria-orientation": p(u),
          "aria-required": p(d),
          dir: p(h)
        }, {
          default: S(() => [
            $(g.$slots, "default", { modelValue: p(i) }),
            p(m) && p(c) ? (w(), I(p(Al), {
              key: 0,
              required: p(d),
              disabled: p(s),
              value: p(i),
              name: p(c)
            }, null, 8, ["required", "disabled", "value", "name"])) : V("", !0)
          ]),
          _: 3
        }, 8, ["data-disabled", "as-child", "as", "aria-orientation", "aria-required", "dir"])
      ]),
      _: 3
    }, 8, ["orientation", "dir", "loop"]));
  }
}), [hA, mA] = yt("RadioGroupItem"), gA = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "RadioGroupItem",
  props: {
    id: {},
    value: {},
    disabled: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: { default: "button" },
    name: {},
    required: { type: Boolean }
  },
  emits: ["select"],
  setup(t, { emit: e }) {
    const n = t, r = e, { forwardRef: o, currentElement: a } = De(), i = dA(), s = A(() => i.disabled.value || n.disabled), l = A(() => i.required.value || n.required), u = A(() => {
      var h;
      return oo((h = i.modelValue) == null ? void 0 : h.value, n.value);
    });
    mA({ disabled: s, checked: u });
    const c = F(!1), d = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"];
    No("keydown", (h) => {
      d.includes(h.key) && (c.value = !0);
    }), No("keyup", () => {
      c.value = !1;
    });
    function f() {
      setTimeout(() => {
        var h;
        c.value && ((h = a.value) == null || h.click());
      }, 0);
    }
    return (h, m) => (w(), I(p(jb), {
      checked: u.value,
      disabled: s.value,
      "as-child": "",
      focusable: !s.value,
      active: u.value
    }, {
      default: S(() => [
        q(cA, oe({ ...h.$attrs, ...n }, {
          ref: p(o),
          checked: u.value,
          required: l.value,
          disabled: s.value,
          "onUpdate:checked": m[0] || (m[0] = (g) => p(i).changeModelValue(h.value)),
          onSelect: m[1] || (m[1] = (g) => r("select", g)),
          onKeydown: m[2] || (m[2] = to(Xe(() => {
          }, ["prevent"]), ["enter"])),
          onFocus: f
        }), {
          default: S(() => [
            $(h.$slots, "default", {
              checked: u.value,
              required: l.value,
              disabled: s.value
            })
          ]),
          _: 3
        }, 16, ["checked", "required", "disabled"])
      ]),
      _: 3
    }, 8, ["checked", "disabled", "focusable", "active"]));
  }
}), vA = /* @__PURE__ */ j({
  __name: "RadioGroupIndicator",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  setup(t) {
    const { forwardRef: e } = De(), n = hA();
    return (r, o) => (w(), I(p(Rr), {
      present: r.forceMount || p(n).checked.value
    }, {
      default: S(() => [
        q(p(He), oe({
          ref: p(e),
          "data-state": p(n).checked.value ? "checked" : "unchecked",
          "data-disabled": p(n).disabled.value ? "" : void 0,
          "as-child": r.asChild,
          as: r.as
        }, r.$attrs), {
          default: S(() => [
            $(r.$slots, "default")
          ]),
          _: 3
        }, 16, ["data-state", "data-disabled", "as-child", "as"])
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), yA = [" ", "Enter", "ArrowUp", "ArrowDown"], bA = [" ", "Enter"], Er = 10;
function Ou(t, e, n) {
  return t === void 0 ? !1 : Array.isArray(t) ? t.some((r) => Df(r, e, n)) : Df(t, e, n);
}
function Df(t, e, n) {
  return t === void 0 || e === void 0 ? !1 : typeof t == "string" ? t === e : typeof n == "function" ? n(t, e) : typeof n == "string" ? (t == null ? void 0 : t[n]) === (e == null ? void 0 : e[n]) : oo(t, e);
}
function kA(t) {
  return t == null || t === "" || Array.isArray(t) && t.length === 0;
}
const wA = /* @__PURE__ */ j({
  __name: "BubbleSelect",
  props: {
    autocomplete: {},
    autofocus: { type: Boolean },
    disabled: { type: Boolean },
    form: {},
    multiple: { type: Boolean },
    name: {},
    required: { type: Boolean },
    size: {},
    value: {}
  },
  setup(t) {
    const e = t, n = F();
    return Ke(() => e.value, (r, o) => {
      const a = window.HTMLSelectElement.prototype, s = Object.getOwnPropertyDescriptor(
        a,
        "value"
      ).set;
      if (r !== o && s && n.value) {
        const l = new Event("change", { bubbles: !0 });
        s.call(n.value, r), n.value.dispatchEvent(l);
      }
    }), (r, o) => (w(), I(p(Ic), { "as-child": "" }, {
      default: S(() => [
        be("select", oe({
          ref_key: "selectElement",
          ref: n
        }, e), [
          $(r.$slots, "default")
        ], 16)
      ]),
      _: 3
    }));
  }
}), _A = {
  key: 0,
  value: ""
}, [ii, b0] = yt("SelectRoot"), CA = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "SelectRoot",
  props: {
    open: { type: Boolean, default: void 0 },
    defaultOpen: { type: Boolean },
    defaultValue: {},
    modelValue: { default: void 0 },
    by: {},
    dir: {},
    multiple: { type: Boolean },
    autocomplete: {},
    disabled: { type: Boolean },
    name: {},
    required: { type: Boolean }
  },
  emits: ["update:modelValue", "update:open"],
  setup(t, { emit: e }) {
    const n = t, r = e, { required: o, disabled: a, multiple: i, dir: s } = Gt(n), l = Xt(n, "modelValue", r, {
      defaultValue: n.defaultValue ?? (i.value ? [] : void 0),
      passive: n.modelValue === void 0,
      deep: !0
    }), u = Xt(n, "open", r, {
      defaultValue: n.defaultOpen,
      passive: n.open === void 0
    }), c = F(), d = F(), f = F({
      x: 0,
      y: 0
    }), h = A(() => {
      var k;
      return i.value && Array.isArray(l.value) ? ((k = l.value) == null ? void 0 : k.length) === 0 : nl(l.value);
    });
    Lr({ isProvider: !0 });
    const m = ga(s), g = hs(c), y = F(/* @__PURE__ */ new Set()), b = A(() => Array.from(y.value).map((k) => k.value).join(";"));
    function C(k) {
      if (i.value) {
        const v = Array.isArray(l.value) ? [...l.value] : [], E = v.findIndex((_) => Df(_, k, n.by));
        E === -1 ? v.push(k) : v.splice(E, 1), l.value = [...v];
      } else
        l.value = k;
    }
    return b0({
      triggerElement: c,
      onTriggerChange: (k) => {
        c.value = k;
      },
      valueElement: d,
      onValueElementChange: (k) => {
        d.value = k;
      },
      contentId: "",
      modelValue: l,
      // @ts-expect-error Missing infer for AcceptableValue
      onValueChange: C,
      by: n.by,
      open: u,
      multiple: i,
      required: o,
      onOpenChange: (k) => {
        u.value = k;
      },
      dir: m,
      triggerPointerDownPosRef: f,
      disabled: a,
      isEmptyModelValue: h,
      optionsSet: y,
      onOptionAdd: (k) => y.value.add(k),
      onOptionRemove: (k) => y.value.delete(k)
    }), (k, v) => (w(), I(p(ms), null, {
      default: S(() => [
        $(k.$slots, "default", {
          modelValue: p(l),
          open: p(u)
        }),
        p(g) ? (w(), I(wA, {
          key: b.value,
          "aria-hidden": "true",
          tabindex: "-1",
          multiple: p(i),
          required: p(o),
          name: k.name,
          autocomplete: k.autocomplete,
          disabled: p(a),
          value: p(l)
        }, {
          default: S(() => [
            p(nl)(p(l)) ? (w(), K("option", _A)) : V("", !0),
            (w(!0), K(Me, null, et(Array.from(y.value), (E) => (w(), K("option", oe({
              key: E.value ?? "",
              ref_for: !0
            }, E), null, 16))), 128))
          ]),
          _: 1
        }, 8, ["multiple", "required", "name", "autocomplete", "disabled", "value"])) : V("", !0)
      ]),
      _: 3
    }));
  }
}), [EA, OA] = yt("SelectItemAlignedPosition"), TA = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "SelectItemAlignedPosition",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["placed"],
  setup(t, { emit: e }) {
    const n = t, r = e, { getItems: o } = Lr(), a = ii(), i = Bc(), s = F(!1), l = F(!0), u = F(), { forwardRef: c, currentElement: d } = De(), { viewport: f, selectedItem: h, selectedItemText: m, focusSelectedItem: g } = i;
    function y() {
      if (a.triggerElement.value && a.valueElement.value && u.value && d.value && (f != null && f.value) && (h != null && h.value) && (m != null && m.value)) {
        const k = a.triggerElement.value.getBoundingClientRect(), v = d.value.getBoundingClientRect(), E = a.valueElement.value.getBoundingClientRect(), _ = m.value.getBoundingClientRect();
        if (a.dir.value !== "rtl") {
          const P = _.left - v.left, se = E.left - P, ke = k.left - se, Le = k.width + ke, ne = Math.max(Le, v.width), ye = window.innerWidth - Er, pe = yg(se, Er, Math.max(Er, ye - ne));
          u.value.style.minWidth = `${Le}px`, u.value.style.left = `${pe}px`;
        } else {
          const P = v.right - _.right, se = window.innerWidth - E.right - P, ke = window.innerWidth - k.right - se, Le = k.width + ke, ne = Math.max(Le, v.width), ye = window.innerWidth - Er, pe = yg(
            se,
            Er,
            Math.max(Er, ye - ne)
          );
          u.value.style.minWidth = `${Le}px`, u.value.style.right = `${pe}px`;
        }
        const T = o().map((P) => P.ref), M = window.innerHeight - Er * 2, O = f.value.scrollHeight, R = window.getComputedStyle(d.value), N = Number.parseInt(
          R.borderTopWidth,
          10
        ), z = Number.parseInt(R.paddingTop, 10), te = Number.parseInt(
          R.borderBottomWidth,
          10
        ), H = Number.parseInt(
          R.paddingBottom,
          10
        ), U = N + z + O + H + te, W = Math.min(
          h.value.offsetHeight * 5,
          U
        ), Q = window.getComputedStyle(f.value), de = Number.parseInt(Q.paddingTop, 10), re = Number.parseInt(
          Q.paddingBottom,
          10
        ), J = k.top + k.height / 2 - Er, Ce = M - J, ie = h.value.offsetHeight / 2, ee = h.value.offsetTop + ie, D = N + z + ee, G = U - D;
        if (D <= J) {
          const P = h.value === T[T.length - 1];
          u.value.style.bottom = "0px";
          const se = d.value.clientHeight - f.value.offsetTop - f.value.offsetHeight, ke = Math.max(
            Ce,
            ie + (P ? re : 0) + se + te
          ), Le = D + ke;
          u.value.style.height = `${Le}px`;
        } else {
          const P = h.value === T[0];
          u.value.style.top = "0px";
          const ke = Math.max(
            J,
            N + f.value.offsetTop + (P ? de : 0) + ie
          ) + G;
          u.value.style.height = `${ke}px`, f.value.scrollTop = D - J + f.value.offsetTop;
        }
        u.value.style.margin = `${Er}px 0`, u.value.style.minHeight = `${W}px`, u.value.style.maxHeight = `${M}px`, r("placed"), requestAnimationFrame(() => s.value = !0);
      }
    }
    const b = F("");
    ze(async () => {
      await nt(), y(), d.value && (b.value = window.getComputedStyle(d.value).zIndex);
    });
    function C(k) {
      k && l.value === !0 && (y(), g == null || g(), l.value = !1);
    }
    return ET(a.triggerElement, () => {
      y();
    }), OA({
      contentWrapper: u,
      shouldExpandOnScrollRef: s,
      onScrollButtonChange: C
    }), (k, v) => (w(), K("div", {
      ref_key: "contentWrapperElement",
      ref: u,
      style: Lt({
        display: "flex",
        flexDirection: "column",
        position: "fixed",
        zIndex: b.value
      })
    }, [
      q(p(He), oe({
        ref: p(c),
        style: {
          // When we get the height of the content, it includes borders. If we were to set
          // the height without having `boxSizing: 'border-box'` it would be too big.
          boxSizing: "border-box",
          // We need to ensure the content doesn't get taller than the wrapper
          maxHeight: "100%"
        }
      }, { ...k.$attrs, ...n }), {
        default: S(() => [
          $(k.$slots, "default")
        ]),
        _: 3
      }, 16)
    ], 4));
  }
}), SA = /* @__PURE__ */ j({
  __name: "SelectPopperPosition",
  props: {
    side: {},
    sideOffset: {},
    align: { default: "start" },
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: { default: Er },
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    positionStrategy: {},
    updatePositionStrategy: {},
    disableUpdateOnLayoutShift: { type: Boolean },
    prioritizePosition: { type: Boolean },
    reference: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const n = ps(t);
    return (r, o) => (w(), I(p(Il), oe(p(n), { style: {
      // Ensure border-box for floating-ui calculations
      boxSizing: "border-box",
      "--reka-select-content-transform-origin": "var(--reka-popper-transform-origin)",
      "--reka-select-content-available-width": "var(--reka-popper-available-width)",
      "--reka-select-content-available-height": "var(--reka-popper-available-height)",
      "--reka-select-trigger-width": "var(--reka-popper-anchor-width)",
      "--reka-select-trigger-height": "var(--reka-popper-anchor-height)"
    } }), {
      default: S(() => [
        $(r.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), xA = {
  onViewportChange: () => {
  },
  itemTextRefCallback: () => {
  },
  itemRefCallback: () => {
  }
}, [Bc, k0] = yt("SelectContent"), AA = /* @__PURE__ */ j({
  __name: "SelectContentImpl",
  props: {
    position: { default: "item-aligned" },
    bodyLock: { type: Boolean, default: !0 },
    side: {},
    sideOffset: {},
    align: { default: "start" },
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    positionStrategy: {},
    updatePositionStrategy: {},
    disableUpdateOnLayoutShift: { type: Boolean },
    prioritizePosition: { type: Boolean },
    reference: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["closeAutoFocus", "escapeKeyDown", "pointerDownOutside"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = ii();
    Jp(), xl(n.bodyLock);
    const { CollectionSlot: a, getItems: i } = Lr(), s = F();
    Sl(s);
    const { search: l, handleTypeaheadSearch: u } = Rc(), c = F(), d = F(), f = F(), h = F(!1), m = F(!1), g = F(!1);
    function y() {
      d.value && s.value && Af([d.value, s.value]);
    }
    Ke(h, () => {
      y();
    });
    const { onOpenChange: b, triggerPointerDownPosRef: C } = o;
    Nn((_) => {
      if (!s.value)
        return;
      let T = { x: 0, y: 0 };
      const M = (R) => {
        var N, z;
        T = {
          x: Math.abs(
            Math.round(R.pageX) - (((N = C.value) == null ? void 0 : N.x) ?? 0)
          ),
          y: Math.abs(
            Math.round(R.pageY) - (((z = C.value) == null ? void 0 : z.y) ?? 0)
          )
        };
      }, O = (R) => {
        var N;
        R.pointerType !== "touch" && (T.x <= 10 && T.y <= 10 ? R.preventDefault() : (N = s.value) != null && N.contains(R.target) || b(!1), document.removeEventListener("pointermove", M), C.value = null);
      };
      C.value !== null && (document.addEventListener("pointermove", M), document.addEventListener("pointerup", O, {
        capture: !0,
        once: !0
      })), _(() => {
        document.removeEventListener("pointermove", M), document.removeEventListener("pointerup", O, {
          capture: !0
        });
      });
    });
    function k(_) {
      const T = _.ctrlKey || _.altKey || _.metaKey;
      if (_.key === "Tab" && _.preventDefault(), !T && _.key.length === 1 && u(_.key, i()), ["ArrowUp", "ArrowDown", "Home", "End"].includes(_.key)) {
        let O = [...i().map((R) => R.ref)];
        if (["ArrowUp", "End"].includes(_.key) && (O = O.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(_.key)) {
          const R = _.target, N = O.indexOf(R);
          O = O.slice(N + 1);
        }
        setTimeout(() => Af(O)), _.preventDefault();
      }
    }
    const v = A(() => n.position === "popper" ? n : {}), E = ps(v.value);
    return k0({
      content: s,
      viewport: c,
      onViewportChange: (_) => {
        c.value = _;
      },
      itemRefCallback: (_, T, M) => {
        const O = !m.value && !M, R = Ou(o.modelValue.value, T, o.by);
        if (o.multiple.value) {
          if (g.value)
            return;
          (R || O) && (d.value = _, R && (g.value = !0));
        } else
          (R || O) && (d.value = _);
        O && (m.value = !0);
      },
      selectedItem: d,
      selectedItemText: f,
      onItemLeave: () => {
        var _;
        (_ = s.value) == null || _.focus();
      },
      itemTextRefCallback: (_, T, M) => {
        const O = !m.value && !M;
        (Ou(o.modelValue.value, T, o.by) || O) && (f.value = _);
      },
      focusSelectedItem: y,
      position: n.position,
      isPositioned: h,
      searchRef: l
    }), (_, T) => (w(), I(p(a), null, {
      default: S(() => [
        q(p($c), {
          "as-child": "",
          onMountAutoFocus: T[6] || (T[6] = Xe(() => {
          }, ["prevent"])),
          onUnmountAutoFocus: T[7] || (T[7] = (M) => {
            var O;
            r("closeAutoFocus", M), !M.defaultPrevented && ((O = p(o).triggerElement.value) == null || O.focus({ preventScroll: !0 }), M.preventDefault());
          })
        }, {
          default: S(() => [
            q(p(ds), {
              "as-child": "",
              "disable-outside-pointer-events": "",
              onFocusOutside: T[2] || (T[2] = Xe(() => {
              }, ["prevent"])),
              onDismiss: T[3] || (T[3] = (M) => p(o).onOpenChange(!1)),
              onEscapeKeyDown: T[4] || (T[4] = (M) => r("escapeKeyDown", M)),
              onPointerDownOutside: T[5] || (T[5] = (M) => r("pointerDownOutside", M))
            }, {
              default: S(() => [
                (w(), I(On(
                  _.position === "popper" ? SA : TA
                ), oe({ ..._.$attrs, ...p(E) }, {
                  id: p(o).contentId,
                  ref: (M) => {
                    s.value = p(ro)(M);
                  },
                  role: "listbox",
                  "data-state": p(o).open.value ? "open" : "closed",
                  dir: p(o).dir.value,
                  style: {
                    // flex layout so we can place the scroll buttons properly
                    display: "flex",
                    flexDirection: "column",
                    // reset the outline by default as the content MAY get focused
                    outline: "none"
                  },
                  onContextmenu: T[0] || (T[0] = Xe(() => {
                  }, ["prevent"])),
                  onPlaced: T[1] || (T[1] = (M) => h.value = !0),
                  onKeydown: k
                }), {
                  default: S(() => [
                    $(_.$slots, "default")
                  ]),
                  _: 3
                }, 16, ["id", "data-state", "dir", "onKeydown"]))
              ]),
              _: 3
            })
          ]),
          _: 3
        })
      ]),
      _: 3
    }));
  }
}), MA = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "SelectProvider",
  props: {
    context: {}
  },
  setup(t) {
    return b0(t.context), k0(xA), (n, r) => $(n.$slots, "default");
  }
}), IA = { key: 1 }, DA = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "SelectContent",
  props: {
    forceMount: { type: Boolean },
    position: {},
    bodyLock: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    positionStrategy: {},
    updatePositionStrategy: {},
    disableUpdateOnLayoutShift: { type: Boolean },
    prioritizePosition: { type: Boolean },
    reference: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["closeAutoFocus", "escapeKeyDown", "pointerDownOutside"],
  setup(t, { emit: e }) {
    const n = t, o = vr(n, e), a = ii(), i = F();
    ze(() => {
      i.value = new DocumentFragment();
    });
    const s = F(), l = A(() => n.forceMount || a.open.value);
    return (u, c) => {
      var d;
      return l.value ? (w(), I(p(Rr), {
        key: 0,
        ref_key: "presenceRef",
        ref: s,
        present: !0
      }, {
        default: S(() => [
          q(AA, Ye(ot({ ...p(o), ...u.$attrs })), {
            default: S(() => [
              $(u.$slots, "default")
            ]),
            _: 3
          }, 16)
        ]),
        _: 3
      }, 512)) : !((d = s.value) != null && d.present) && i.value ? (w(), K("div", IA, [
        (w(), I(wc, { to: i.value }, [
          q(MA, { context: p(a) }, {
            default: S(() => [
              $(u.$slots, "default")
            ]),
            _: 3
          }, 8, ["context"])
        ], 8, ["to"]))
      ])) : V("", !0);
    };
  }
}), [PA, NA] = yt("SelectGroup"), $A = /* @__PURE__ */ j({
  __name: "SelectGroup",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const e = t, n = Bt(void 0, "reka-select-group");
    return NA({ id: n }), (r, o) => (w(), I(p(He), oe({ role: "group" }, e, { "aria-labelledby": p(n) }), {
      default: S(() => [
        $(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["aria-labelledby"]));
  }
}), [w0, RA] = yt("SelectItem"), LA = /* @__PURE__ */ j({
  __name: "SelectItem",
  props: {
    value: {},
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["select"],
  setup(t, { emit: e }) {
    const n = t, r = e, { disabled: o } = Gt(n), a = ii(), i = Bc(), { forwardRef: s, currentElement: l } = De(), { CollectionItem: u } = Lr(), c = A(() => {
      var v;
      return Ou((v = a.modelValue) == null ? void 0 : v.value, n.value, a.by);
    }), d = F(!1), f = F(n.textValue ?? ""), h = Bt(void 0, "reka-select-item-text"), m = "select.select";
    async function g(v) {
      if (v.defaultPrevented)
        return;
      const E = { originalEvent: v, value: n.value };
      Tl(m, y, E);
    }
    async function y(v) {
      await nt(), r("select", v), !v.defaultPrevented && (o.value || (a.onValueChange(n.value), a.multiple.value || a.onOpenChange(!1)));
    }
    async function b(v) {
      var E, _;
      await nt(), !v.defaultPrevented && (o.value ? (E = i.onItemLeave) == null || E.call(i) : (_ = v.currentTarget) == null || _.focus({ preventScroll: !0 }));
    }
    async function C(v) {
      var E;
      await nt(), !v.defaultPrevented && v.currentTarget === Pn() && ((E = i.onItemLeave) == null || E.call(i));
    }
    async function k(v) {
      var _;
      await nt(), !(v.defaultPrevented || ((_ = i.searchRef) == null ? void 0 : _.value) !== "" && v.key === " ") && (bA.includes(v.key) && g(v), v.key === " " && v.preventDefault());
    }
    if (n.value === "")
      throw new Error(
        "A <SelectItem /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return ze(() => {
      l.value && i.itemRefCallback(
        l.value,
        n.value,
        n.disabled
      );
    }), RA({
      value: n.value,
      disabled: o,
      textId: h,
      isSelected: c,
      onItemTextChange: (v) => {
        f.value = ((f.value || (v == null ? void 0 : v.textContent)) ?? "").trim();
      }
    }), (v, E) => (w(), I(p(u), {
      value: { textValue: f.value }
    }, {
      default: S(() => [
        q(p(He), {
          ref: p(s),
          role: "option",
          "aria-labelledby": p(h),
          "data-highlighted": d.value ? "" : void 0,
          "aria-selected": c.value,
          "data-state": c.value ? "checked" : "unchecked",
          "aria-disabled": p(o) || void 0,
          "data-disabled": p(o) ? "" : void 0,
          tabindex: p(o) ? void 0 : -1,
          as: v.as,
          "as-child": v.asChild,
          onFocus: E[0] || (E[0] = (_) => d.value = !0),
          onBlur: E[1] || (E[1] = (_) => d.value = !1),
          onPointerup: g,
          onPointerdown: E[2] || (E[2] = (_) => {
            _.currentTarget.focus({ preventScroll: !0 });
          }),
          onTouchend: E[3] || (E[3] = Xe(() => {
          }, ["prevent", "stop"])),
          onPointermove: b,
          onPointerleave: C,
          onKeydown: k
        }, {
          default: S(() => [
            $(v.$slots, "default")
          ]),
          _: 3
        }, 8, ["aria-labelledby", "data-highlighted", "aria-selected", "data-state", "aria-disabled", "data-disabled", "tabindex", "as", "as-child"])
      ]),
      _: 3
    }, 8, ["value"]));
  }
}), BA = /* @__PURE__ */ j({
  __name: "SelectItemIndicator",
  props: {
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  setup(t) {
    const e = t, n = w0();
    return (r, o) => p(n).isSelected.value ? (w(), I(p(He), oe({
      key: 0,
      "aria-hidden": "true"
    }, e), {
      default: S(() => [
        $(r.$slots, "default")
      ]),
      _: 3
    }, 16)) : V("", !0);
  }
}), FA = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "SelectItemText",
  props: {
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  setup(t) {
    const e = t, n = ii(), r = Bc(), o = w0(), { forwardRef: a, currentElement: i } = De(), s = A(() => {
      var l, u;
      return {
        value: o.value,
        disabled: o.disabled.value,
        textContent: ((l = i.value) == null ? void 0 : l.textContent) ?? ((u = o.value) == null ? void 0 : u.toString()) ?? ""
      };
    });
    return ze(() => {
      i.value && (o.onItemTextChange(i.value), r.itemTextRefCallback(
        i.value,
        o.value,
        o.disabled.value
      ), n.onOptionAdd(s.value));
    }), is(() => {
      n.onOptionRemove(s.value);
    }), (l, u) => (w(), I(p(He), oe({
      id: p(o).textId,
      ref: p(a)
    }, { ...e, ...l.$attrs }), {
      default: S(() => [
        $(l.$slots, "default")
      ]),
      _: 3
    }, 16, ["id"]));
  }
}), VA = /* @__PURE__ */ j({
  __name: "SelectLabel",
  props: {
    for: {},
    asChild: { type: Boolean },
    as: { default: "div" }
  },
  setup(t) {
    const e = t, n = PA({ id: "" });
    return (r, o) => (w(), I(p(He), oe(e, {
      id: p(n).id
    }), {
      default: S(() => [
        $(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["id"]));
  }
}), HA = /* @__PURE__ */ j({
  __name: "SelectPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    defer: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(t) {
    const e = t;
    return (n, r) => (w(), I(p(fs), Ye(ot(e)), {
      default: S(() => [
        $(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), UA = /* @__PURE__ */ j({
  __name: "SelectTrigger",
  props: {
    disabled: { type: Boolean },
    reference: {},
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(t) {
    const e = t, n = ii(), { forwardRef: r, currentElement: o } = De(), a = A(() => {
      var f;
      return ((f = n.disabled) == null ? void 0 : f.value) || e.disabled;
    });
    n.contentId || (n.contentId = Bt(void 0, "reka-select-content")), ze(() => {
      n.onTriggerChange(o.value);
    });
    const { getItems: i } = Lr(), { search: s, handleTypeaheadSearch: l, resetTypeahead: u } = Rc();
    function c() {
      a.value || (n.onOpenChange(!0), u());
    }
    function d(f) {
      c(), n.triggerPointerDownPosRef.value = {
        x: Math.round(f.pageX),
        y: Math.round(f.pageY)
      };
    }
    return (f, h) => (w(), I(p(Ml), {
      "as-child": "",
      reference: f.reference
    }, {
      default: S(() => {
        var m, g, y, b;
        return [
          q(p(He), {
            ref: p(r),
            role: "combobox",
            type: f.as === "button" ? "button" : void 0,
            "aria-controls": p(n).contentId,
            "aria-expanded": p(n).open.value || !1,
            "aria-required": (m = p(n).required) == null ? void 0 : m.value,
            "aria-autocomplete": "none",
            disabled: a.value,
            dir: (g = p(n)) == null ? void 0 : g.dir.value,
            "data-state": (y = p(n)) != null && y.open.value ? "open" : "closed",
            "data-disabled": a.value ? "" : void 0,
            "data-placeholder": p(kA)((b = p(n).modelValue) == null ? void 0 : b.value) ? "" : void 0,
            "as-child": f.asChild,
            as: f.as,
            onClick: h[0] || (h[0] = (C) => {
              var k;
              (k = C == null ? void 0 : C.currentTarget) == null || k.focus();
            }),
            onPointerdown: h[1] || (h[1] = (C) => {
              if (C.pointerType === "touch")
                return C.preventDefault();
              const k = C.target;
              k.hasPointerCapture(C.pointerId) && k.releasePointerCapture(C.pointerId), C.button === 0 && C.ctrlKey === !1 && (d(C), C.preventDefault());
            }),
            onPointerup: h[2] || (h[2] = Xe(
              (C) => {
                C.pointerType === "touch" && d(C);
              },
              ["prevent"]
            )),
            onKeydown: h[3] || (h[3] = (C) => {
              const k = p(s) !== "";
              !(C.ctrlKey || C.altKey || C.metaKey) && C.key.length === 1 && k && C.key === " " || (p(l)(C.key, p(i)()), p(yA).includes(C.key) && (c(), C.preventDefault()));
            })
          }, {
            default: S(() => [
              $(f.$slots, "default")
            ]),
            _: 3
          }, 8, ["type", "aria-controls", "aria-expanded", "aria-required", "disabled", "dir", "data-state", "data-disabled", "data-placeholder", "as-child", "as"])
        ];
      }),
      _: 3
    }, 8, ["reference"]));
  }
}), WA = /* @__PURE__ */ j({
  __name: "SelectValue",
  props: {
    placeholder: { default: "" },
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  setup(t) {
    const e = t, { forwardRef: n, currentElement: r } = De(), o = ii();
    ze(() => {
      o.valueElement = r;
    });
    const a = A(() => {
      var c;
      let s = [];
      const l = Array.from(o.optionsSet.value), u = (d) => l.find((f) => Ou(d, f.value, o.by));
      return Array.isArray(o.modelValue.value) ? s = o.modelValue.value.map((d) => {
        var f;
        return ((f = u(d)) == null ? void 0 : f.textContent) ?? "";
      }) : s = [((c = u(o.modelValue.value)) == null ? void 0 : c.textContent) ?? ""], s.filter(Boolean);
    }), i = A(() => a.value.length ? a.value.join(", ") : e.placeholder);
    return (s, l) => (w(), I(p(He), {
      ref: p(n),
      as: s.as,
      "as-child": s.asChild,
      style: { pointerEvents: "none" },
      "data-placeholder": a.value.length ? void 0 : e.placeholder
    }, {
      default: S(() => [
        $(s.$slots, "default", {
          selectedLabel: a.value,
          modelValue: p(o).modelValue.value
        }, () => [
          We(Se(i.value), 1)
        ])
      ]),
      _: 3
    }, 8, ["as", "as-child", "data-placeholder"]));
  }
}), KA = /* @__PURE__ */ j({
  __name: "SelectViewport",
  props: {
    nonce: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const e = t, { nonce: n } = Gt(e), r = c0(n), o = Bc(), a = o.position === "item-aligned" ? EA() : void 0, { forwardRef: i, currentElement: s } = De();
    ze(() => {
      o == null || o.onViewportChange(s.value);
    });
    const l = F(0);
    function u(c) {
      const d = c.currentTarget, { shouldExpandOnScrollRef: f, contentWrapper: h } = a ?? {};
      if (f != null && f.value && (h != null && h.value)) {
        const m = Math.abs(l.value - d.scrollTop);
        if (m > 0) {
          const g = window.innerHeight - Er * 2, y = Number.parseFloat(
            h.value.style.minHeight
          ), b = Number.parseFloat(h.value.style.height), C = Math.max(y, b);
          if (C < g) {
            const k = C + m, v = Math.min(g, k), E = k - v;
            h.value.style.height = `${v}px`, h.value.style.bottom === "0px" && (d.scrollTop = E > 0 ? E : 0, h.value.style.justifyContent = "flex-end");
          }
        }
      }
      l.value = d.scrollTop;
    }
    return (c, d) => (w(), K(Me, null, [
      q(p(He), oe({
        ref: p(i),
        "data-reka-select-viewport": "",
        role: "presentation"
      }, { ...c.$attrs, ...e }, {
        style: {
          // we use position: 'relative' here on the `viewport` so that when we call
          // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
          // (independent of the scrollUpButton).
          position: "relative",
          flex: 1,
          overflow: "hidden auto"
        },
        onScroll: u
      }), {
        default: S(() => [
          $(c.$slots, "default")
        ]),
        _: 3
      }, 16),
      q(p(He), {
        as: "style",
        nonce: p(r)
      }, {
        default: S(() => d[0] || (d[0] = [
          We(" /* Hide scrollbars cross-browser and enable momentum scroll for touch devices */ [data-reka-select-viewport] { scrollbar-width:none; -ms-overflow-style: none; -webkit-overflow-scrolling: touch; } [data-reka-select-viewport]::-webkit-scrollbar { display: none; } ")
        ])),
        _: 1
      }, 8, ["nonce"])
    ], 64));
  }
}), [jA, o8] = yt("ToggleGroupRoot"), zA = /* @__PURE__ */ j({
  __name: "Toggle",
  props: {
    defaultValue: { type: Boolean },
    modelValue: { type: [Boolean, null], default: void 0 },
    disabled: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: { default: "button" },
    name: {},
    required: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, r = e, { forwardRef: o, currentElement: a } = De(), i = jA(null), s = Xt(n, "modelValue", r, {
      defaultValue: n.defaultValue,
      passive: n.modelValue === void 0
    });
    function l() {
      s.value = !s.value;
    }
    const u = A(() => s.value ? "on" : "off"), c = hs(a);
    return (d, f) => (w(), I(p(He), {
      ref: p(o),
      type: d.as === "button" ? "button" : void 0,
      "as-child": n.asChild,
      as: d.as,
      "aria-pressed": p(s),
      "data-state": u.value,
      "data-disabled": d.disabled ? "" : void 0,
      disabled: d.disabled,
      onClick: l
    }, {
      default: S(() => [
        $(d.$slots, "default", {
          modelValue: p(s),
          disabled: d.disabled,
          pressed: p(s),
          state: u.value
        }),
        p(c) && d.name && !p(i) ? (w(), I(Al, {
          key: 0,
          type: "checkbox",
          name: d.name,
          value: p(s),
          required: d.required
        }, null, 8, ["name", "value", "required"])) : V("", !0)
      ]),
      _: 3
    }, 8, ["type", "as-child", "as", "aria-pressed", "data-state", "data-disabled", "disabled"]));
  }
}), YA = /* @__PURE__ */ j({
  __name: "TooltipArrow",
  props: {
    width: { default: 10 },
    height: { default: 5 },
    asChild: { type: Boolean },
    as: { default: "svg" }
  },
  setup(t) {
    const e = t;
    return De(), (n, r) => (w(), I(p(Gp), Ye(ot(e)), {
      default: S(() => [
        $(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), _0 = "tooltip.open", [Zp, qA] = yt("TooltipProvider"), GA = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "TooltipProvider",
  props: {
    delayDuration: { default: 700 },
    skipDelayDuration: { default: 300 },
    disableHoverableContent: { type: Boolean, default: !1 },
    disableClosingTrigger: { type: Boolean },
    disabled: { type: Boolean },
    ignoreNonKeyboardFocus: { type: Boolean, default: !1 }
  },
  setup(t) {
    const e = t, { delayDuration: n, skipDelayDuration: r, disableHoverableContent: o, disableClosingTrigger: a, ignoreNonKeyboardFocus: i, disabled: s } = Gt(e);
    De();
    const l = F(!0), u = F(!1), { start: c, stop: d } = Mb(() => {
      l.value = !0;
    }, r, { immediate: !1 });
    return qA({
      isOpenDelayed: l,
      delayDuration: n,
      onOpen() {
        d(), l.value = !1;
      },
      onClose() {
        c();
      },
      isPointerInTransitRef: u,
      disableHoverableContent: o,
      disableClosingTrigger: a,
      disabled: s,
      ignoreNonKeyboardFocus: i
    }), (f, h) => $(f.$slots, "default");
  }
}), [Fc, JA] = yt("TooltipRoot"), XA = /* @__PURE__ */ j({
  __name: "TooltipRoot",
  props: {
    defaultOpen: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    delayDuration: { default: void 0 },
    disableHoverableContent: { type: Boolean, default: void 0 },
    disableClosingTrigger: { type: Boolean, default: void 0 },
    disabled: { type: Boolean, default: void 0 },
    ignoreNonKeyboardFocus: { type: Boolean, default: void 0 }
  },
  emits: ["update:open"],
  setup(t, { emit: e }) {
    const n = t, r = e;
    De();
    const o = Zp(), a = A(() => n.disableHoverableContent ?? o.disableHoverableContent.value), i = A(() => n.disableClosingTrigger ?? o.disableClosingTrigger.value), s = A(() => n.disabled ?? o.disabled.value), l = A(() => n.delayDuration ?? o.delayDuration.value), u = A(() => n.ignoreNonKeyboardFocus ?? o.ignoreNonKeyboardFocus.value), c = Xt(n, "open", r, {
      defaultValue: n.defaultOpen,
      passive: n.open === void 0
    });
    Ke(c, (k) => {
      o.onClose && (k ? (o.onOpen(), document.dispatchEvent(new CustomEvent(_0))) : o.onClose());
    });
    const d = F(!1), f = F(), h = A(() => c.value ? d.value ? "delayed-open" : "instant-open" : "closed"), { start: m, stop: g } = Mb(() => {
      d.value = !0, c.value = !0;
    }, l, { immediate: !1 });
    function y() {
      g(), d.value = !1, c.value = !0;
    }
    function b() {
      g(), c.value = !1;
    }
    function C() {
      m();
    }
    return JA({
      contentId: "",
      open: c,
      stateAttribute: h,
      trigger: f,
      onTriggerChange(k) {
        f.value = k;
      },
      onTriggerEnter() {
        o.isOpenDelayed.value ? C() : y();
      },
      onTriggerLeave() {
        a.value ? b() : g();
      },
      onOpen: y,
      onClose: b,
      disableHoverableContent: a,
      disableClosingTrigger: i,
      disabled: s,
      ignoreNonKeyboardFocus: u
    }), (k, v) => (w(), I(p(ms), null, {
      default: S(() => [
        $(k.$slots, "default", { open: p(c) })
      ]),
      _: 3
    }));
  }
}), C0 = /* @__PURE__ */ j({
  __name: "TooltipContentImpl",
  props: {
    ariaLabel: {},
    asChild: { type: Boolean },
    as: {},
    side: { default: "top" },
    sideOffset: { default: 0 },
    align: { default: "center" },
    alignOffset: {},
    avoidCollisions: { type: Boolean, default: !0 },
    collisionBoundary: { default: () => [] },
    collisionPadding: { default: 0 },
    arrowPadding: { default: 0 },
    sticky: { default: "partial" },
    hideWhenDetached: { type: Boolean, default: !1 },
    positionStrategy: {},
    updatePositionStrategy: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = Fc(), { forwardRef: a } = De(), i = uo(), s = A(() => {
      var c;
      return (c = i.default) == null ? void 0 : c.call(i, {});
    }), l = A(() => {
      var f;
      if (n.ariaLabel)
        return n.ariaLabel;
      let c = "";
      function d(h) {
        typeof h.children == "string" && h.type !== Ay ? c += h.children : Array.isArray(h.children) && h.children.forEach((m) => d(m));
      }
      return (f = s.value) == null || f.forEach((h) => d(h)), c;
    }), u = A(() => {
      const { ariaLabel: c, ...d } = n;
      return d;
    });
    return ze(() => {
      No(window, "scroll", (c) => {
        const d = c.target;
        d != null && d.contains(o.trigger.value) && o.onClose();
      }), No(window, _0, o.onClose);
    }), (c, d) => (w(), I(p(ds), {
      "as-child": "",
      "disable-outside-pointer-events": !1,
      onEscapeKeyDown: d[0] || (d[0] = (f) => r("escapeKeyDown", f)),
      onPointerDownOutside: d[1] || (d[1] = (f) => {
        var h;
        p(o).disableClosingTrigger.value && ((h = p(o).trigger.value) != null && h.contains(f.target)) && f.preventDefault(), r("pointerDownOutside", f);
      }),
      onFocusOutside: d[2] || (d[2] = Xe(() => {
      }, ["prevent"])),
      onDismiss: d[3] || (d[3] = (f) => p(o).onClose())
    }, {
      default: S(() => [
        q(p(Il), oe({
          ref: p(a),
          "data-state": p(o).stateAttribute.value
        }, { ...c.$attrs, ...u.value }, { style: {
          "--reka-tooltip-content-transform-origin": "var(--reka-popper-transform-origin)",
          "--reka-tooltip-content-available-width": "var(--reka-popper-available-width)",
          "--reka-tooltip-content-available-height": "var(--reka-popper-available-height)",
          "--reka-tooltip-trigger-width": "var(--reka-popper-anchor-width)",
          "--reka-tooltip-trigger-height": "var(--reka-popper-anchor-height)"
        } }), {
          default: S(() => [
            $(c.$slots, "default"),
            q(p(Ic), {
              id: p(o).contentId,
              role: "tooltip"
            }, {
              default: S(() => [
                We(Se(l.value), 1)
              ]),
              _: 1
            }, 8, ["id"])
          ]),
          _: 3
        }, 16, ["data-state"])
      ]),
      _: 3
    }));
  }
}), QA = /* @__PURE__ */ j({
  __name: "TooltipContentHoverable",
  props: {
    ariaLabel: {},
    asChild: { type: Boolean },
    as: {},
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    positionStrategy: {},
    updatePositionStrategy: {}
  },
  setup(t) {
    const n = ps(t), { forwardRef: r, currentElement: o } = De(), { trigger: a, onClose: i } = Fc(), s = Zp(), { isPointerInTransit: l, onPointerExit: u } = eA(a, o);
    return s.isPointerInTransitRef = l, u(() => {
      i();
    }), (c, d) => (w(), I(C0, oe({ ref: p(r) }, p(n)), {
      default: S(() => [
        $(c.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), ZA = /* @__PURE__ */ j({
  __name: "TooltipContent",
  props: {
    forceMount: { type: Boolean },
    ariaLabel: {},
    asChild: { type: Boolean },
    as: {},
    side: { default: "top" },
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    positionStrategy: {},
    updatePositionStrategy: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = Fc(), a = vr(n, r), { forwardRef: i } = De();
    return (s, l) => (w(), I(p(Rr), {
      present: s.forceMount || p(o).open.value
    }, {
      default: S(() => [
        (w(), I(On(p(o).disableHoverableContent.value ? C0 : QA), oe({ ref: p(i) }, p(a)), {
          default: S(() => [
            $(s.$slots, "default")
          ]),
          _: 3
        }, 16))
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), eM = /* @__PURE__ */ j({
  __name: "TooltipPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    defer: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(t) {
    const e = t;
    return (n, r) => (w(), I(p(fs), Ye(ot(e)), {
      default: S(() => [
        $(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), tM = /* @__PURE__ */ j({
  __name: "TooltipTrigger",
  props: {
    reference: {},
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(t) {
    const e = t, n = Fc(), r = Zp();
    n.contentId || (n.contentId = Bt(void 0, "reka-tooltip-content"));
    const { forwardRef: o, currentElement: a } = De(), i = F(!1), s = F(!1), l = A(() => n.disabled.value ? {} : {
      click: g,
      focus: h,
      pointermove: d,
      pointerleave: f,
      pointerdown: c,
      blur: m
    });
    ze(() => {
      n.onTriggerChange(a.value);
    });
    function u() {
      setTimeout(() => {
        i.value = !1;
      }, 1);
    }
    function c() {
      n.open && n.onClose(), i.value = !0, document.addEventListener("pointerup", u, { once: !0 });
    }
    function d(y) {
      y.pointerType !== "touch" && !s.value && !r.isPointerInTransitRef.value && (n.onTriggerEnter(), s.value = !0);
    }
    function f() {
      n.onTriggerLeave(), s.value = !1;
    }
    function h(y) {
      var b, C;
      i.value || n.ignoreNonKeyboardFocus.value && !((C = (b = y.target).matches) != null && C.call(b, ":focus-visible")) || n.onOpen();
    }
    function m() {
      n.onClose();
    }
    function g() {
      n.disableClosingTrigger.value || n.onClose();
    }
    return (y, b) => (w(), I(p(Ml), {
      "as-child": "",
      reference: y.reference
    }, {
      default: S(() => [
        q(p(He), oe({
          ref: p(o),
          "aria-describedby": p(n).open.value ? p(n).contentId : void 0,
          "data-state": p(n).stateAttribute.value,
          as: y.as,
          "as-child": e.asChild,
          "data-grace-area-trigger": ""
        }, r_(l.value)), {
          default: S(() => [
            $(y.$slots, "default")
          ]),
          _: 3
        }, 16, ["aria-describedby", "data-state", "as", "as-child"])
      ]),
      _: 3
    }, 8, ["reference"]));
  }
}), nM = {
  key: 0,
  class: "k-modal-header"
}, rM = { key: 1 }, oM = { class: "k-modal-body" }, aM = {
  key: 2,
  class: "k-modal-footer"
}, iM = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "KModal",
  props: /* @__PURE__ */ it({
    title: {},
    titleSrOnly: { type: [Boolean, String] },
    description: {},
    size: { default: "md" },
    dismissible: { type: [Boolean, String], default: !0 },
    closeable: { type: [Boolean, String], default: !0 },
    inline: { type: [Boolean, String] }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ it(["close", "dismiss"], ["update:modelValue"]),
  setup(t, { emit: e }) {
    const { t: n } = Mt(), r = F(""), o = F(), a = ut(t, "modelValue"), i = e, s = t, l = A(() => s.title || n("k-modal-default-title")), u = A(() => ({
      "k-modal": !0,
      [`k-modal-${s.size}`]: !!s.size,
      [`k-modal-animation-${r.value}`]: !!r.value
    }));
    Ke(a, () => {
      a.value ? clearTimeout(o.value) : (i("close"), o.value = setTimeout(() => {
        r.value = "";
      }, 500));
    });
    const c = (y) => {
      Si(s.dismissible) || Si(s.closeable) ? (r.value = "requires-attention", y == null || y.preventDefault()) : i("dismiss");
    }, d = (y) => {
      Si(s.dismissible) || Si(s.closeable) ? (r.value = "requires-attention", y == null || y.preventDefault()) : i("dismiss");
    }, g = {
      toggle: () => a.value = !a.value,
      close: () => a.value = !1,
      open: () => a.value = !0
    };
    return (y, b) => (w(), I(p(zT), {
      open: a.value,
      "onUpdate:open": b[2] || (b[2] = (C) => a.value = C)
    }, {
      default: S(() => [
        y.$slots.trigger ? (w(), I(p(AS), {
          key: 0,
          "as-child": !0
        }, {
          default: S(() => [
            $(y.$slots, "trigger", Ye(ot(g)))
          ]),
          _: 3
        })) : V("", !0),
        q(p(Ux), {
          disabled: p(ce)(y.inline)
        }, {
          default: S(() => [
            q(p(xS), { class: "k-modal-backdrop" }),
            q(p(wS), oe(y.$attrs, {
              class: u.value,
              onInteractOutside: c,
              onEscapeKeyDown: d,
              "aria-describedby": y.description ? "undefined" : void 0,
              "aria-label": l.value,
              onAnimationend: b[1] || (b[1] = (C) => r.value = "none")
            }), {
              default: S(() => [
                y.$slots.header || y.title && !p(ce)(y.titleSrOnly) ? (w(), K("div", nM, [
                  y.title && !p(ce)(y.titleSrOnly) ? (w(), I(p(hg), {
                    key: 0,
                    class: "k-h5 k-modal-title"
                  }, {
                    default: S(() => [
                      We(Se(l.value), 1)
                    ]),
                    _: 1
                  })) : V("", !0),
                  $(y.$slots, "header", Ye(ot(g)))
                ])) : V("", !0),
                !y.title || p(ce)(y.titleSrOnly) ? (w(), K("div", rM, [
                  q(p(Ic), null, {
                    default: S(() => [
                      q(p(hg), null, {
                        default: S(() => [
                          We(Se(l.value), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])) : V("", !0),
                be("div", oM, [
                  y.description ? (w(), I(p(_S), {
                    key: 0,
                    class: "k-modal-description"
                  }, {
                    default: S(() => [
                      We(Se(y.description), 1)
                    ]),
                    _: 1
                  })) : V("", !0),
                  $(y.$slots, "default", Ye(ot(g)))
                ]),
                y.$slots.footer ? (w(), K("div", aM, [
                  $(y.$slots, "footer", Ye(ot(g)))
                ])) : V("", !0),
                p(ce)(y.closeable) ? (w(), I(p(YT), {
                  key: 3,
                  class: "k-modal-close",
                  "aria-label": p(n)("k-close"),
                  onClick: b[0] || (b[0] = () => i("dismiss"))
                }, {
                  default: S(() => [
                    q(ht, { icon: "fa fa-times" })
                  ]),
                  _: 1
                }, 8, ["aria-label"])) : V("", !0)
              ]),
              _: 3
            }, 16, ["class", "aria-describedby", "aria-label"])
          ]),
          _: 3
        }, 8, ["disabled"])
      ]),
      _: 3
    }, 8, ["open"]));
  }
}), sM = {
  "k-show-more": "Näytä lisää",
  "k-show-less": "Näytä vähemmän",
  "k-loading": "Ladataan",
  "k-close": "Sulje",
  "k-opensInNewTab": "Avautuu uuteen välilehteen",
  "k-modal-default-title": "Dialogi",
  "k-yes": "Kyllä",
  "k-no": "Ei",
  "k-ok": "Ok",
  "k-cancel": "Peruuta",
  "k-show-password": "Näytä salasana",
  "k-hide-password": "Piilota salasana",
  "k-select": "Valitse",
  "k-info-button": "Info painike",
  "k-search": "Hae",
  "k-clear": "Tyhjennä",
  "k-searching": "Haetaan...",
  "k-and-other-results": "...ja {0} muuta.",
  "k-no-results": "Ei tuloksia.",
  "k-select-file": "Valitse tiedosto, tai siirrä ja pudota se tähän.",
  "k-select-files": "Valitse tiedostot, tai siirrä ja pudota ne tähän.",
  "k-remove-file": "Poista tiedosto",
  "k-caps-lock": "Caps Lock on päällä. Kirjoitat isoilla kirjaimilla.",
  "k-date-start": "Alkupäivä",
  "k-date-end": "Loppupäivä",
  "k-html-editor": { "text-styles": { heading1: "Otsikko 1", heading2: "Otsikko 2", heading3: "Otsikko 3", heading4: "Otsikko 4", heading5: "Otsikko 5", heading6: "Otsikko 6", paragraph: "Leipäteksti" }, textStyles: "Valitse tekstityyli", bulletList: "Luettelo", orderedList: "Numeroitu luettelo", undo: "Kumoa", redo: "Tee uudelleen", bold: "Lihavointi", italic: "Kursivointi", underline: "Alleviivaus", strike: "Yliviivaus", link: "Linkki", "add-image": "Lisää kuva", "link-button": { "add-link": "Lisää linkki", url: "URL", confirm: "Lisää", "invalid-url": "Anna kelvollinen URL-osoite" }, "image-button": { "add-image": "Lisää kuva", url: "Kuvan URL", confirm: "Lisää", "invalid-url": "Anna kelvollinen URL-osoite" } },
  "k-copy": "Kopioi",
  "k-copied": "Kopioitu!"
}, lM = {
  "k-show-more": "Show more",
  "k-show-less": "Show less",
  "k-loading": "Loading",
  "k-close": "Close",
  "k-opensInNewTab": "Opens in a new tab",
  "k-modal-default-title": "Dialog",
  "k-yes": "Yes",
  "k-no": "No",
  "k-ok": "Ok",
  "k-cancel": "Cancel",
  "k-show-password": "Show password",
  "k-hide-password": "Hide password",
  "k-select": "Select",
  "k-info-button": "Info button",
  "k-search": "Search",
  "k-clear": "Clear",
  "k-searching": "Searching...",
  "k-and-other-results": "...and {0} other results.",
  "k-no-results": "No results.",
  "k-select-file": "Select a file or drag-and-drop it here.",
  "k-select-files": "Select files or drag-and-drop them here.",
  "k-remove-file": "Remove file",
  "k-caps-lock": "Caps Lock is on. You are writing with capital letters.",
  "k-date-start": "Start date",
  "k-date-end": "End date",
  "k-html-editor": { "text-styles": { heading1: "Heading 1", heading2: "Heading 2", heading3: "Heading 3", heading4: "Heading 4", heading5: "Heading 5", heading6: "Heading 6", paragraph: "Paragraph" }, textStyles: "Select text style", bulletList: "Bullet list", orderedList: "Ordered list", undo: "Undo", redo: "Redo", bold: "Bold", italic: "Italic", underline: "Underline", strike: "Strikethrough", link: "Link", "add-image": "Add image", "link-button": { "add-link": "Add link", url: "URL", confirm: "Add", "invalid-url": "Please enter a valid URL" }, "image-button": { "add-image": "Add image", url: "Image URL", confirm: "Add", "invalid-url": "Please enter a valid URL" } },
  "k-copy": "Copy",
  "k-copied": "Copied!"
}, uM = {
  "k-show-more": "Visa mer",
  "k-show-less": "Visa mindre",
  "k-loading": "Laddning",
  "k-close": "Nära",
  "k-opensInNewTab": "Öppnas i ny flik",
  "k-modal-default-title": "Dialog",
  "k-yes": "Ja",
  "k-no": "Nej",
  "k-ok": "Ok",
  "k-cancel": "Avbryt",
  "k-show-password": "Visa lösenord",
  "k-hide-password": "Dölj lösenord",
  "k-select": "Välj",
  "k-info": "Info knapp",
  "k-search": "Sök",
  "k-clear": "Klart",
  "k-searching": "Söker...",
  "k-and-other-results": "...och {0} andra resultat.",
  "k-no-results": "Inga resultat.",
  "k-select-file": "Välj en fil eller dra och släpp den här.",
  "k-select-files": "Välj filer eller dra och släpp dem här.",
  "k-remove-file": "Ta bort fil",
  "k-caps-lock": "Caps Lock är aktiverat. Du skriver med stora bokstäver.",
  "k-date-start": "Startdatum",
  "k-date-end": "Slutdatum",
  "k-html-editor": { "text-styles": { heading1: "Rubrik 1", heading2: "Rubrik 2", heading3: "Rubrik 3", heading4: "Rubrik 4", heading5: "Rubrik 5", heading6: "Rubrik 6", paragraph: "Stycke" }, textStyles: "Välj textstil", bulletList: "Punktlista", orderedList: "Numrerad lista", undo: "Ångra", redo: "Gör om", bold: "Fetstil", italic: "Kursiv", underline: "Understrykning", strike: "Genomstrykning", link: "Länk", "add-image": "Lägg till bild", "link-button": { "add-link": "Lägg till länk", url: "URL", confirm: "Lägg till", "invalid-url": "Ange en giltig URL" }, "image-button": { "add-image": "Lägg till bild", url: "Bildens URL", confirm: "Lägg till", "invalid-url": "Ange en giltig URL" } },
  "k-copy": "Kopiera",
  "k-copied": "Kopierat!"
}, E0 = "kt-vuecomponents", cM = () => yc(E0), dM = (t, e) => {
  var r;
  const n = BE({
    legacy: !1,
    locale: "fi",
    fallbackLocale: "fi",
    messages: ((r = e.i18n) == null ? void 0 : r.messages) || {
      fi: sM,
      sv: uM,
      en: lM
    },
    ...e.i18n
  });
  t.use(n);
}, fM = (t, e) => {
  if (!e.components)
    return;
  Object.entries(e.components).forEach(([r, o]) => {
    t.component(r, o);
  });
}, a8 = {
  // Tyypitykset menee sekaisin asennuksessa, en tiedä miksi joten käytetään any
  install: (t, e) => {
    const n = e || {}, r = t;
    dM(r, n), fM(r, n), t.provide(E0, n);
  }
}, Pf = (...t) => {
  const e = cM();
  e != null && e.disableWarnings || console.warn(...t);
}, pM = { class: "k-btn-container" }, hM = {
  key: 0,
  class: "k-btn-prepend"
}, mM = { class: "k-btn-content" }, gM = { class: "k-btn-text-content" }, vM = {
  key: 1,
  class: "k-btn-append"
}, zt = /* @__PURE__ */ j({
  __name: "KButton",
  props: {
    variant: { default: "primary" },
    icon: {},
    text: {},
    prependIcon: {},
    appendIcon: {},
    tooltip: {},
    loading: { type: [Boolean, String] },
    disabled: { type: [Boolean, String] },
    shadow: { type: [Boolean, String] },
    block: { type: [Boolean, String] },
    type: { default: "button" },
    as: {},
    href: {},
    target: {}
  },
  emits: ["click"],
  setup(t, { emit: e }) {
    const n = _l(), r = e, o = t, a = A(() => ce(o.disabled) || ce(o.loading)), i = A(() => o.as || (o.href ? $p : "button")), s = A(() => n.role || (o.as || o.href ? "button" : void 0)), l = A(() => i.value === "button" ? o.type : void 0), u = (d) => a.value ? (d.preventDefault(), !1) : r("click", d), c = A(() => ({
      "k-btn": !0,
      [`k-btn-${o.variant}`]: !0,
      "k-btn-shadow": ce(o.shadow),
      "k-btn-icon": o.icon,
      "k-btn-block": ce(o.block),
      "k-btn-loading": ce(o.loading),
      "k-disabled": a.value,
      "k-link": o.variant === "link"
    }));
    return o.icon && o.text && Pf(
      "KButton: Icon and text cannot be used together, icon will be displayed. Did you mean to use prependIcon or appendIcon?"
    ), o.icon && !n["aria-label"] && Pf("KButton: Icon-only button should have an aria-label attribute."), (d, f) => (w(), I(On(i.value), {
      class: Ie(c.value),
      disabled: a.value,
      type: l.value,
      role: s.value,
      "aria-disabled": a.value || p(ce)(d.$attrs["aria-disabled"]),
      href: d.href,
      target: d.target,
      onClick: u
    }, {
      default: S(() => [
        be("div", pM, [
          o.prependIcon || p(ce)(d.loading) || d.$slots.prepend ? (w(), K("div", hM, [
            $(d.$slots, "prepend", {}, () => [
              o.prependIcon && !p(ce)(d.loading) ? (w(), I(ht, {
                key: 0,
                icon: o.prependIcon
              }, null, 8, ["icon"])) : V("", !0),
              p(ce)(d.loading) ? (w(), I(Rp, {
                key: 1,
                color: "inherit"
              })) : V("", !0)
            ])
          ])) : V("", !0),
          be("div", mM, [
            $(d.$slots, "default", {}, () => [
              o.icon ? (w(), I(ht, {
                key: 0,
                icon: o.icon
              }, null, 8, ["icon"])) : V("", !0),
              be("span", gM, Se(o.icon ? "" : o.text), 1)
            ])
          ]),
          o.appendIcon || d.$slots.append ? (w(), K("div", vM, [
            $(d.$slots, "append", {}, () => [
              o.appendIcon ? (w(), I(ht, {
                key: 0,
                icon: o.appendIcon
              }, null, 8, ["icon"])) : V("", !0)
            ])
          ])) : V("", !0)
        ])
      ]),
      _: 3
    }, 8, ["class", "disabled", "type", "role", "aria-disabled", "href", "target"]));
  }
}), i8 = /* @__PURE__ */ j({
  __name: "KConfirm",
  props: /* @__PURE__ */ it({
    autoCloseOnCancel: { type: [Boolean, String], default: !0 },
    autoCloseOnConfirm: { type: [Boolean, String], default: !0 },
    mode: { default: "yes-cancel" },
    confirmText: {},
    cancelText: {},
    title: {},
    titleSrOnly: { type: [Boolean, String] },
    description: {},
    size: {},
    dismissible: { type: [Boolean, String], default: !0 },
    closeable: { type: [Boolean, String], default: !0 },
    inline: { type: [Boolean, String] }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ it(["cancel", "confirm"], ["update:modelValue"]),
  setup(t, { emit: e }) {
    const { t: n } = Mt(), r = ut(t, "modelValue"), o = _l(), a = t, i = A(() => ({
      ...o,
      ...a
    })), s = e, l = () => {
      s("confirm") !== !1 && ce(a.autoCloseOnConfirm) && (r.value = !1);
    }, u = () => {
      s("cancel") !== !1 && ce(a.autoCloseOnCancel) && (r.value = !1);
    }, c = () => a.confirmText ? a.confirmText : n({
      "yes-no": "k-yes",
      "yes-cancel": "k-yes",
      "ok-cancel": "k-ok"
    }[a.mode]), d = () => a.cancelText ? a.cancelText : n({
      "yes-no": "k-no",
      "yes-cancel": "k-cancel",
      "ok-cancel": "k-cancel"
    }[a.mode]);
    return (f, h) => (w(), I(iM, oe(i.value, {
      modelValue: r.value,
      "onUpdate:modelValue": h[0] || (h[0] = (m) => r.value = m),
      onDismiss: u
    }), {
      trigger: S((m) => [
        $(f.$slots, "trigger", Ye(ot(m)))
      ]),
      default: S((m) => [
        $(f.$slots, "default", Ye(ot(m)))
      ]),
      footer: S(() => [
        q(zt, { onClick: l }, {
          default: S(() => [
            We(Se(c()), 1)
          ]),
          _: 1
        }),
        q(zt, {
          variant: "secondary",
          onClick: u
        }, {
          default: S(() => [
            We(Se(d()), 1)
          ]),
          _: 1
        })
      ]),
      _: 3
    }, 16, ["modelValue"]));
  }
}), yM = {
  key: 0,
  class: "k-label-required"
}, bM = /* @__PURE__ */ j({
  __name: "KLabel",
  props: {
    variant: {},
    required: { type: [Boolean, String] },
    text: {},
    as: {},
    disabled: { type: [Boolean, String] }
  },
  setup(t) {
    const e = t, n = A(() => ({
      "k-label": !0,
      [`k-label-${e.variant}`]: !!e.variant && e.variant !== "default",
      "k-label-disabled": ce(e.disabled)
    }));
    return (r, o) => (w(), I(On(r.as || "label"), {
      class: Ie(n.value)
    }, {
      default: S(() => [
        be("span", null, [
          $(r.$slots, "default", {}, () => [
            We(Se(r.text), 1)
          ]),
          p(ce)(r.required) ? (w(), K("span", yM, [
            $(r.$slots, "required-star", {}, () => [
              o[0] || (o[0] = We("*"))
            ])
          ])) : V("", !0),
          $(r.$slots, "append")
        ])
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), kM = { class: "sr-only" }, wM = {
  key: 0,
  class: "k-tooltip-prepend-icon"
}, _M = {
  key: 1,
  class: "k-tooltip-append-icon"
}, Hn = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "KTooltip",
  props: /* @__PURE__ */ it({
    text: {},
    side: { default: "top" },
    delayDuration: { default: 400 },
    appendIcon: {},
    prependIcon: {}
  }, {
    open: { type: Boolean, default: void 0 },
    openModifiers: {}
  }),
  emits: ["update:open"],
  setup(t) {
    const e = t, { t: n } = Mt(), r = ut(t, "open"), o = A(() => ({
      "k-tooltip-content": !0,
      [`k-tooltip-animation-${e.side}`]: !!e.side
    })), a = () => r.value = !0;
    return (i, s) => (w(), I(p(GA), {
      disableClosingTrigger: !i.$slots.trigger
    }, {
      default: S(() => [
        q(p(XA), {
          open: r.value,
          "onUpdate:open": s[0] || (s[0] = (l) => r.value = l),
          "delay-duration": e.delayDuration
        }, {
          default: S(() => [
            q(p(tM), { "as-child": !0 }, {
              default: S(() => [
                $(i.$slots, "trigger", {}, () => [
                  be("button", oe({
                    type: "button",
                    class: "k-tooltip"
                  }, i.$attrs, { onClick: a }), [
                    be("span", kM, Se(p(n)("k-info-button")), 1),
                    s[1] || (s[1] = be("span", { "aria-hidden": "true" }, "?", -1))
                  ], 16)
                ])
              ]),
              _: 3
            }),
            q(p(eM), null, {
              default: S(() => [
                q(p(ZA), {
                  side: e.side,
                  "as-child": "",
                  "side-offset": 5,
                  "aria-label": e.text
                }, {
                  default: S(() => [
                    be("div", {
                      class: Ie(o.value)
                    }, [
                      e.prependIcon || i.$slots.prepend ? (w(), K("span", wM, [
                        $(i.$slots, "prepend", {}, () => [
                          e.prependIcon ? (w(), I(ht, {
                            key: 0,
                            icon: e.prependIcon
                          }, null, 8, ["icon"])) : V("", !0)
                        ])
                      ])) : V("", !0),
                      $(i.$slots, "default", {}, () => [
                        We(Se(e.text), 1)
                      ]),
                      e.appendIcon || i.$slots.append ? (w(), K("span", _M, [
                        $(i.$slots, "append", {}, () => [
                          e.appendIcon ? (w(), I(ht, {
                            key: 0,
                            icon: e.appendIcon
                          }, null, 8, ["icon"])) : V("", !0)
                        ])
                      ])) : V("", !0),
                      q(p(YA), {
                        class: "k-tooltip-arrow",
                        size: "8"
                      })
                    ], 2)
                  ]),
                  _: 3
                }, 8, ["side", "aria-label"])
              ]),
              _: 3
            })
          ]),
          _: 3
        }, 8, ["open", "delay-duration"])
      ]),
      _: 3
    }, 8, ["disableClosingTrigger"]));
  }
});
function O0(t) {
  if (typeof t != "object" || !t || Object.keys(t).length === 0)
    return !1;
  const { value: e, text: n } = t;
  return (typeof e == "string" || typeof e == "number") && typeof n == "string";
}
function CM(t) {
  if (typeof t != "object" || !t || Object.keys(t).length === 0)
    return !1;
  const { label: e, items: n } = t;
  return (e === void 0 || typeof e == "string") && (n === void 0 || Array.isArray(n) && n.every(O0));
}
const eh = (t) => typeof t == "boolean" ? !1 : !!(!t || Array.isArray(t) && t.length === 0 || typeof t == "object" && Object.keys(t).length === 0);
function EM(t) {
  return t ? t.flatMap((n) => {
    if (O0(n))
      return n;
    if (CM(n))
      return n.items;
  }).filter((n) => n !== void 0) : void 0;
}
const ho = (t) => A(() => !eh(t.errors)), T0 = (t) => {
  const e = ho(t);
  return A(() => e.value ? !0 : !eh(t.description));
}, Fo = (t) => {
  const e = ho(t), n = uo();
  return A(() => ({
    "k-input": !0,
    [`k-input-${t.variant}`]: !!t.variant && t.variant !== "default",
    "k-input-error": e.value || t.variant === "error",
    "k-input-with-prepend": !!t.prependIcon || !!n.prepend,
    "k-input-with-append": !!t.appendIcon || !!n.append,
    "k-input-disabled": ce(t.disabled)
  }));
}, fn = (t) => {
  var n, r;
  if (!t.id) {
    const o = Cn();
    Pf(
      `${(n = o == null ? void 0 : o.type) == null ? void 0 : n.__name}: 'id' is required for accessibility. Component label: '${(r = o == null ? void 0 : o.props) == null ? void 0 : r.label}'`
    );
  }
  const e = Bt(t.id, "k-input");
  return A(() => e);
}, yn = (t, e) => {
  const n = T0(e);
  return A(() => n.value ? t.value + "-description" : void 0);
}, rr = (t, e, n = eh) => {
  const r = F(n(t.value) && e ? e : t.value);
  return Ke(t, () => r.value = t.value), A({
    get() {
      return r.value;
    },
    set(a) {
      t.value = a, r.value = a;
    }
  });
}, va = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "KInputLabel",
  props: {
    id: {},
    label: {},
    labelSrOnly: { type: [Boolean, String] },
    required: { type: [Boolean, String] },
    disabled: { type: [Boolean, String] },
    marginless: { type: [Boolean, String] },
    emptyValue: {},
    defaultValue: {},
    description: {},
    errors: {},
    variant: {},
    tooltip: {},
    tooltipProps: {},
    inputId: {},
    class: {},
    as: {}
  },
  setup(t) {
    const e = t, n = ho(e), r = A(() => ({
      [e.class]: !!e.class,
      "sr-only": ce(e.labelSrOnly)
    }));
    return (o, a) => (w(), K("div", {
      class: Ie(["k-label-container", e.labelSrOnly ? "sr-only" : void 0])
    }, [
      o.label ? (w(), I(bM, {
        key: 0,
        class: Ie(r.value),
        variant: p(n) ? "error" : o.variant,
        for: o.inputId,
        text: o.label,
        required: o.required,
        as: o.as,
        disabled: o.disabled
      }, {
        append: S(() => [
          o.tooltip ? (w(), I(Hn, oe({ key: 0 }, e.tooltipProps, {
            text: o.tooltip ?? ""
          }), null, 16, ["text"])) : V("", !0)
        ]),
        default: S(() => [
          $(o.$slots, "default", {}, () => [
            We(Se(o.label), 1)
          ])
        ]),
        _: 3
      }, 8, ["class", "variant", "for", "text", "required", "as", "disabled"])) : V("", !0)
    ], 2));
  }
}), Nf = /* @__PURE__ */ j({
  __name: "KCaption",
  props: {
    text: {},
    variant: {},
    icon: {}
  },
  setup(t) {
    const e = t, n = A(() => Array.isArray(e.text) ? e.text : e.text ? [e.text] : []), r = A(() => ({
      "k-caption": !0,
      [`k-caption-${e.variant}`]: !!e.variant && e.variant !== "default",
      "k-caption-iconless": !e.icon && n.value.length > 1
    }));
    return (o, a) => n.value.length || o.$slots.default ? (w(), K("span", {
      key: 0,
      class: Ie(r.value)
    }, [
      $(o.$slots, "default", {}, () => [
        !o.icon && n.value.length == 1 ? (w(), K(Me, { key: 0 }, [
          We(Se(n.value[0]), 1)
        ], 64)) : (w(), I(bb, {
          key: 1,
          items: n.value,
          icon: o.icon
        }, null, 8, ["items", "icon"]))
      ])
    ], 2)) : V("", !0);
  }
}), OM = ["id"], si = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "KInputDescription",
  props: {
    description: {},
    errors: {},
    variant: {},
    descriptionId: {},
    class: {}
  },
  setup(t) {
    const e = t, n = T0(e);
    return (r, o) => p(n) ? (w(), K("span", {
      key: 0,
      id: r.descriptionId,
      class: Ie(e.class)
    }, [
      q(Nf, {
        text: r.description,
        variant: r.variant
      }, null, 8, ["text", "variant"]),
      q(Nf, {
        variant: "error",
        icon: "far fa-circle-exclamation",
        text: r.errors
      }, null, 8, ["text"])
    ], 10, OM)) : V("", !0);
  }
}), TM = {
  key: 0,
  class: "k-input-clear"
}, Pl = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "KInputClear",
  props: /* @__PURE__ */ it({
    id: {},
    label: {},
    labelSrOnly: { type: [Boolean, String] },
    required: { type: [Boolean, String] },
    disabled: { type: [Boolean, String] },
    marginless: { type: [Boolean, String] },
    emptyValue: {},
    defaultValue: {},
    prependIcon: {},
    appendIcon: {},
    clearable: { type: [Boolean, String] }
  }, {
    input: {},
    inputModifiers: {}
  }),
  emits: /* @__PURE__ */ it(["clear"], ["update:input"]),
  setup(t, { emit: e }) {
    const { t: n } = Mt(), r = t, o = ut(t, "input"), a = e, i = A(() => r.emptyValue ?? ""), s = A(() => (o.value ?? "") !== i.value && !ce(r.disabled)), l = () => {
      o.value = i.value, a("clear");
    };
    return (u, c) => s.value ? (w(), K("div", TM, [
      q(Hn, {
        text: p(n)("k-clear")
      }, {
        trigger: S(() => {
          var d;
          return [
            q(zt, {
              variant: "text",
              icon: "fal fa-times",
              "aria-label": `${p(n)("k-clear")} '${(d = u.label) == null ? void 0 : d.toLowerCase()}'`,
              onClick: Xe(l, ["stop"])
            }, null, 8, ["aria-label"])
          ];
        }),
        _: 1
      }, 8, ["text"])
    ])) : V("", !0);
  }
}), SM = {
  key: 0,
  class: "k-input-prepend"
}, xM = {
  key: 1,
  class: "k-input-append"
}, AM = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "KInputIcons",
  props: /* @__PURE__ */ it({
    prependIcon: {},
    appendIcon: {},
    clearable: { type: [Boolean, String] },
    id: {},
    label: {},
    labelSrOnly: { type: [Boolean, String] },
    required: { type: [Boolean, String] },
    disabled: { type: [Boolean, String] },
    marginless: { type: [Boolean, String] },
    emptyValue: {},
    defaultValue: {},
    class: {}
  }, {
    input: {},
    inputModifiers: {}
  }),
  emits: /* @__PURE__ */ it(["clear"], ["update:input"]),
  setup(t, { emit: e }) {
    const n = e, r = ut(t, "input"), o = t;
    return (a, i) => (w(), K("div", {
      class: Ie(["k-input-wrapper", o.class])
    }, [
      a.prependIcon || a.$slots.prepend ? (w(), K("div", SM, [
        $(a.$slots, "prepend", {}, () => [
          a.prependIcon ? (w(), I(ht, {
            key: 0,
            icon: a.prependIcon
          }, null, 8, ["icon"])) : V("", !0)
        ])
      ])) : V("", !0),
      $(a.$slots, "default"),
      a.appendIcon || a.$slots.append ? (w(), K("div", xM, [
        $(a.$slots, "append", {}, () => [
          a.appendIcon ? (w(), I(ht, {
            key: 0,
            icon: a.appendIcon
          }, null, 8, ["icon"])) : V("", !0)
        ])
      ])) : V("", !0),
      p(ce)(a.clearable) ? (w(), I(Pl, oe({
        key: 2,
        input: r.value,
        "onUpdate:input": i[0] || (i[0] = (s) => r.value = s)
      }, o, {
        onClear: i[1] || (i[1] = () => n("clear"))
      }), null, 16, ["input"])) : V("", !0)
    ], 2));
  }
}), li = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "KInputContainer",
  props: {
    id: {},
    label: {},
    labelSrOnly: { type: [Boolean, String] },
    required: { type: [Boolean, String] },
    disabled: { type: [Boolean, String] },
    marginless: { type: [Boolean, String] },
    emptyValue: {},
    defaultValue: {},
    as: {},
    ariaDescribedby: {}
  },
  setup(t) {
    const e = _l(), n = t, r = A(() => [
      {
        "k-input-container": !0,
        "k-input-container-marginless": ce(n.marginless)
      },
      e.class
    ]);
    return (o, a) => (w(), I(On(o.as || "div"), {
      class: Ie(r.value),
      "aria-describedby": o.ariaDescribedby
    }, {
      default: S(() => [
        $(o.$slots, "default")
      ]),
      _: 3
    }, 8, ["class", "aria-describedby"]));
  }
}), yr = /* @__PURE__ */ j({
  __name: "KCommonInput",
  props: /* @__PURE__ */ it({
    id: {},
    label: {},
    labelSrOnly: { type: [Boolean, String] },
    required: { type: [Boolean, String] },
    disabled: { type: [Boolean, String] },
    marginless: { type: [Boolean, String] },
    emptyValue: {},
    defaultValue: {},
    description: {},
    errors: {},
    variant: {},
    tooltip: {},
    tooltipProps: {},
    prependIcon: {},
    appendIcon: {},
    clearable: { type: [Boolean, String] },
    inputId: {},
    wrapperClass: {},
    descriptionId: {},
    class: {}
  }, {
    input: {},
    inputModifiers: {}
  }),
  emits: /* @__PURE__ */ it(["clear"], ["update:input"]),
  setup(t, { emit: e }) {
    const n = t, r = F(), o = ut(t, "input"), a = e, i = () => {
      var l, u, c, d;
      a("clear");
      const s = (c = (u = (l = r.value) == null ? void 0 : l.$el) == null ? void 0 : u.querySelector) == null ? void 0 : c.call(u, "input,select,textarea");
      (d = s == null ? void 0 : s.focus) == null || d.call(s);
    };
    return (s, l) => (w(), I(li, {
      marginless: n.marginless,
      ref_key: "container",
      ref: r
    }, {
      default: S(() => [
        q(va, oe(n, { "input-id": s.inputId }), null, 16, ["input-id"]),
        q(AM, oe({ class: s.wrapperClass }, n, {
          input: o.value,
          "onUpdate:input": l[0] || (l[0] = (u) => o.value = u),
          onClear: i
        }), At({ _: 2 }, [
          et(s.$slots, (u, c) => ({
            name: c,
            fn: S((d) => [
              $(s.$slots, c, Ye(ot(d)))
            ])
          }))
        ]), 1040, ["class", "input"]),
        $(s.$slots, "description", {}, () => [
          s.$slots.description ? V("", !0) : (w(), I(si, Ye(oe({ key: 0 }, n)), null, 16))
        ])
      ]),
      _: 3
    }, 8, ["marginless"]));
  }
}), MM = {
  "+": (t, e) => t + e,
  "-": (t, e) => t - e,
  "*": (t, e) => t * e,
  x: (t, e) => t * e,
  "/": (t, e) => t / e,
  "%": (t, e) => t % e,
  "^": (t, e) => Math.pow(t, e)
}, th = (t) => {
  if (typeof t == "number")
    return t;
  const e = t.replace(/[\s$€+]/g, "").replace(/,/g, ".").trim();
  return parseFloat(e);
}, bg = (t, e = "fi-FI") => {
  if (!t)
    return t;
  const n = t.toString(), r = /([*/+\-x^%])/g, o = n.split(r).map((l) => l.trim()).filter((l) => !!l);
  if (o.length < 3)
    return t;
  let a = 0, i = "";
  return o.forEach((l) => {
    const u = th(l), c = l.match(r);
    if (!u && !c) {
      a = NaN;
      return;
    }
    if (c) {
      i = l.toLowerCase();
      return;
    }
    if (u && i && a) {
      const d = MM[i];
      a = d(a, u);
    } else
      a = u;
    i = "";
  }), S0(a, e) || t;
}, S0 = (t, e = "fi-FI") => {
  if (t === void 0 || t === "")
    return "";
  const n = typeof t == "number" ? t : th(t);
  return isNaN(n) ? "" : n.toLocaleString(e);
}, kd = (t, e, n = "fi-FI") => {
  if (t === void 0 || t === "")
    return "";
  const r = typeof t == "number" ? t : th(t);
  return isNaN(r) ? "" : r.toLocaleString(n, {
    minimumFractionDigits: e,
    maximumFractionDigits: e
  });
}, s8 = (t, e) => Math.floor(Math.random() * (e - t + 1) + t), IM = ["disabled", "id", "aria-describedby", "placeholder"], l8 = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "KNumberInput",
  props: /* @__PURE__ */ it({
    money: { type: [Boolean, String] },
    locale: { default: "fi-FI" },
    digits: {},
    autocalculate: { type: [Boolean, String], default: !0 },
    forceNumber: { type: [Boolean, String] },
    id: {},
    label: {},
    labelSrOnly: { type: [Boolean, String] },
    required: { type: [Boolean, String] },
    disabled: { type: [Boolean, String] },
    marginless: { type: [Boolean, String] },
    emptyValue: {},
    defaultValue: {},
    description: {},
    errors: {},
    variant: {},
    tooltip: {},
    tooltipProps: {},
    prependIcon: {},
    appendIcon: {},
    clearable: { type: [Boolean, String] }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = _l(), n = t, r = ut(t, "modelValue"), o = rr(r, n.defaultValue), a = fn(n), i = A(
      () => n.appendIcon || (n.money ? "fa fa-euro" : void 0)
    ), s = A(() => {
      if (e.placeholder)
        return e.placeholder;
      if (n.digits !== void 0)
        return kd(0, n.digits);
      if (ce(n.money))
        return kd(0, 2);
    }), l = A(() => {
      if (n.digits !== void 0)
        return n.digits;
      if (ce(n.money))
        return 2;
    }), u = yn(a, n), c = Fo(n), d = (h) => {
      var m;
      if (ce(n.autocalculate) && ((m = h.key) == null ? void 0 : m.toLowerCase()) === "enter") {
        const g = o.value, y = bg(g, n.locale);
        g !== y && (o.value = y, h.preventDefault());
      }
    }, f = () => {
      let h = o.value;
      ce(n.autocalculate) && (h = bg(h, n.locale)), ce(n.forceNumber) && (h = S0(h, n.locale)), l.value !== void 0 && (h = kd(h, l.value, n.locale)), o.value !== h && (o.value = h);
    };
    return ze(() => {
      f();
    }), (h, m) => (w(), I(yr, oe(h.$props, {
      input: p(o),
      "onUpdate:input": m[1] || (m[1] = (g) => bt(o) ? o.value = g : null),
      "description-id": p(u),
      "input-id": p(a),
      "append-icon": i.value
    }), At({
      default: S(() => [
        Xr(be("input", oe({
          type: "text",
          inputmode: "numeric"
        }, h.$attrs, {
          disabled: p(ce)(h.disabled),
          id: p(a),
          "onUpdate:modelValue": m[0] || (m[0] = (g) => bt(o) ? o.value = g : null),
          class: p(c),
          "aria-describedby": p(u),
          onBlur: f,
          onKeyup: d,
          placeholder: s.value,
          autocomplete: "off"
        }), null, 16, IM), [
          [Cl, p(o)]
        ])
      ]),
      _: 2
    }, [
      h.$slots.prepend ? {
        name: "prepend",
        fn: S(() => [
          $(h.$slots, "prepend")
        ]),
        key: "0"
      } : void 0,
      h.$slots.append ? {
        name: "append",
        fn: S(() => [
          $(h.$slots, "append")
        ]),
        key: "1"
      } : void 0
    ]), 1040, ["input", "description-id", "input-id", "append-icon"]));
  }
}), DM = ["disabled", "id", "aria-describedby"], nh = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "KTextInput",
  props: /* @__PURE__ */ it({
    id: {},
    label: {},
    labelSrOnly: { type: [Boolean, String] },
    required: { type: [Boolean, String] },
    disabled: { type: [Boolean, String] },
    marginless: { type: [Boolean, String] },
    emptyValue: {},
    defaultValue: {},
    description: {},
    errors: {},
    variant: {},
    tooltip: {},
    tooltipProps: {},
    prependIcon: {},
    appendIcon: {},
    clearable: { type: [Boolean, String] }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ it(["clear"], ["update:modelValue"]),
  setup(t, { expose: e, emit: n }) {
    const r = n, o = t, a = ut(t, "modelValue"), i = rr(a, o.defaultValue), s = F(), l = fn(o), u = yn(l, o), c = Fo(o);
    return e({ focus: () => {
      var f;
      return (f = s.value) == null ? void 0 : f.focus();
    }, element: s }), (f, h) => (w(), I(yr, oe(f.$props, {
      input: p(i),
      "onUpdate:input": h[1] || (h[1] = (m) => bt(i) ? i.value = m : null),
      "description-id": p(u),
      "input-id": p(l),
      onClear: h[2] || (h[2] = () => r("clear"))
    }), At({
      default: S(() => [
        Xr(be("input", oe({
          type: "text",
          ref: "input"
        }, f.$attrs, {
          disabled: p(ce)(f.disabled),
          id: p(l),
          "onUpdate:modelValue": h[0] || (h[0] = (m) => bt(i) ? i.value = m : null),
          class: p(c),
          "aria-describedby": p(u)
        }), null, 16, DM), [
          [Cl, p(i)]
        ])
      ]),
      _: 2
    }, [
      f.$slots.prepend ? {
        name: "prepend",
        fn: S(() => [
          $(f.$slots, "prepend")
        ]),
        key: "0"
      } : void 0,
      f.$slots.append ? {
        name: "append",
        fn: S(() => [
          $(f.$slots, "append")
        ]),
        key: "1"
      } : void 0
    ]), 1040, ["input", "description-id", "input-id"]));
  }
}), PM = ["disabled", "id", "aria-describedby", "rows", "maxlength"], u8 = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "KTextArea",
  props: /* @__PURE__ */ it({
    rows: { default: 3 },
    autosize: { type: [Boolean, String] },
    maxlength: {},
    counter: { type: [Boolean, String], default: void 0 },
    id: {},
    label: {},
    labelSrOnly: { type: [Boolean, String] },
    required: { type: [Boolean, String] },
    disabled: { type: [Boolean, String] },
    marginless: { type: [Boolean, String] },
    emptyValue: {},
    defaultValue: {},
    description: {},
    errors: {},
    variant: {},
    tooltip: {},
    tooltipProps: {},
    prependIcon: {},
    appendIcon: {},
    clearable: { type: [Boolean, String] }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, n = ut(t, "modelValue"), r = rr(n, e.defaultValue), o = () => {
      var m;
      const h = (((m = r.value) == null ? void 0 : m.length) ?? 0).toString();
      return e.maxlength ? h + " / " + e.maxlength : h;
    }, a = F(), i = fn(e), s = A(() => ce(e.counter) || !!e.maxlength && !Si(e.counter)), l = A(() => {
      const h = [];
      return e.description && typeof e.description == "string" && h.push(e.description), e.description && Array.isArray(e.description) && h.push(...e.description), s.value && h.push(o()), h;
    }), u = ho(e), c = A(
      () => u.value || l.value.length > 0 ? i.value + "-description" : void 0
    ), d = Fo(e), f = () => {
      ce(e.autosize) && a.value && (a.value.style.height = "auto", a.value.style.height = a.value.scrollHeight + "px");
    };
    return ze(() => {
      ce(e.autosize) && a.value && a.value.setAttribute("style", "height:" + a.value.scrollHeight + "px;overflow-y:hidden;");
    }), (h, m) => (w(), I(yr, oe(h.$props, {
      input: p(r),
      "onUpdate:input": m[1] || (m[1] = (g) => bt(r) ? r.value = g : null),
      description: l.value,
      "description-id": c.value,
      "input-id": p(i),
      "wrapper-class": "k-textarea-wrapper"
    }), At({
      default: S(() => [
        Xr(be("textarea", oe({
          ref_key: "input",
          ref: a,
          autocomplete: "off"
        }, h.$attrs, {
          disabled: p(ce)(h.disabled),
          id: p(i),
          "onUpdate:modelValue": m[0] || (m[0] = (g) => bt(r) ? r.value = g : null),
          class: p(d),
          "aria-describedby": c.value,
          rows: h.rows,
          onInput: f,
          maxlength: h.maxlength
        }), null, 16, PM), [
          [Cl, p(r)]
        ])
      ]),
      _: 2
    }, [
      h.$slots.prepend ? {
        name: "prepend",
        fn: S(() => [
          $(h.$slots, "prepend")
        ]),
        key: "0"
      } : void 0,
      h.$slots.append ? {
        name: "append",
        fn: S(() => [
          $(h.$slots, "append")
        ]),
        key: "1"
      } : void 0
    ]), 1040, ["input", "description", "description-id", "input-id"]));
  }
});
function x0(t) {
  return bc() ? (kc(t), !0) : !1;
}
function Ui(t) {
  return typeof t == "function" ? t() : p(t);
}
const Vc = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const NM = Object.prototype.toString, $M = (t) => NM.call(t) === "[object Object]", $f = () => {
};
function RM(t, e) {
  function n(...r) {
    return new Promise((o, a) => {
      Promise.resolve(t(() => e.apply(this, r), { fn: e, thisArg: this, args: r })).then(o).catch(a);
    });
  }
  return n;
}
function LM(t, e = {}) {
  let n, r, o = $f;
  const a = (s) => {
    clearTimeout(s), o(), o = $f;
  };
  return (s) => {
    const l = Ui(t), u = Ui(e.maxWait);
    return n && a(n), l <= 0 || u !== void 0 && u <= 0 ? (r && (a(r), r = null), Promise.resolve(s())) : new Promise((c, d) => {
      o = e.rejectOnCancel ? d : c, u && !r && (r = setTimeout(() => {
        n && a(n), r = null, c(s());
      }, u)), n = setTimeout(() => {
        r && a(r), r = null, c(s());
      }, l);
    });
  };
}
function BM(t) {
  let e;
  function n() {
    return e || (e = t()), e;
  }
  return n.reset = async () => {
    const r = e;
    e = void 0, r && await r;
  }, n;
}
function A0(t, e = 200, n = {}) {
  return RM(
    LM(e, n),
    t
  );
}
function FM(t, e, n = {}) {
  const {
    immediate: r = !0
  } = n, o = F(!1);
  let a = null;
  function i() {
    a && (clearTimeout(a), a = null);
  }
  function s() {
    o.value = !1, i();
  }
  function l(...u) {
    i(), o.value = !0, a = setTimeout(() => {
      o.value = !1, a = null, t(...u);
    }, Ui(e));
  }
  return r && (o.value = !0, Vc && l()), x0(s), {
    isPending: Ep(o),
    start: l,
    stop: s
  };
}
function VM(t) {
  var e;
  const n = Ui(t);
  return (e = n == null ? void 0 : n.$el) != null ? e : n;
}
const HM = Vc ? window : void 0, UM = Vc ? window.document : void 0, M0 = Vc ? window.navigator : void 0;
function rh(...t) {
  let e, n, r, o;
  if (typeof t[0] == "string" || Array.isArray(t[0]) ? ([n, r, o] = t, e = HM) : [e, n, r, o] = t, !e)
    return $f;
  Array.isArray(n) || (n = [n]), Array.isArray(r) || (r = [r]);
  const a = [], i = () => {
    a.forEach((c) => c()), a.length = 0;
  }, s = (c, d, f, h) => (c.addEventListener(d, f, h), () => c.removeEventListener(d, f, h)), l = Ke(
    () => [VM(e), Ui(o)],
    ([c, d]) => {
      if (i(), !c)
        return;
      const f = $M(d) ? { ...d } : d;
      a.push(
        ...n.flatMap((h) => r.map((m) => s(c, h, m, f)))
      );
    },
    { immediate: !0, flush: "post" }
  ), u = () => {
    l(), i();
  };
  return x0(u), u;
}
function WM() {
  const t = F(!1), e = Cn();
  return e && ze(() => {
    t.value = !0;
  }, e), t;
}
function I0(t) {
  const e = WM();
  return A(() => (e.value, !!t()));
}
function kg(t, e = {}) {
  const {
    controls: n = !1,
    navigator: r = M0
  } = e, o = I0(() => r && "permissions" in r);
  let a;
  const i = typeof t == "string" ? { name: t } : t, s = F(), l = () => {
    a && (s.value = a.state);
  }, u = BM(async () => {
    if (o.value) {
      if (!a)
        try {
          a = await r.permissions.query(i), rh(a, "change", l), l();
        } catch {
          s.value = "prompt";
        }
      return a;
    }
  });
  return u(), n ? {
    state: s,
    isSupported: o,
    query: u
  } : s;
}
function KM(t = {}) {
  const {
    navigator: e = M0,
    read: n = !1,
    source: r,
    copiedDuring: o = 1500,
    legacy: a = !1
  } = t, i = I0(() => e && "clipboard" in e), s = kg("clipboard-read"), l = kg("clipboard-write"), u = A(() => i.value || a), c = F(""), d = F(!1), f = FM(() => d.value = !1, o);
  function h() {
    i.value && b(s.value) ? e.clipboard.readText().then((C) => {
      c.value = C;
    }) : c.value = y();
  }
  u.value && n && rh(["copy", "cut"], h);
  async function m(C = Ui(r)) {
    u.value && C != null && (i.value && b(l.value) ? await e.clipboard.writeText(C) : g(C), c.value = C, d.value = !0, f.start());
  }
  function g(C) {
    const k = document.createElement("textarea");
    k.value = C ?? "", k.style.position = "absolute", k.style.opacity = "0", document.body.appendChild(k), k.select(), document.execCommand("copy"), k.remove();
  }
  function y() {
    var C, k, v;
    return (v = (k = (C = document == null ? void 0 : document.getSelection) == null ? void 0 : C.call(document)) == null ? void 0 : k.toString()) != null ? v : "";
  }
  function b(C) {
    return C === "granted" || C === "prompt";
  }
  return {
    isSupported: u,
    text: c,
    copied: d,
    copy: m
  };
}
const jM = ["mousedown", "mouseup", "keydown", "keyup"];
function oh(t, e = {}) {
  const {
    events: n = jM,
    document: r = UM,
    initial: o = null
  } = e, a = F(o);
  return r && n.forEach((i) => {
    rh(r, i, (s) => {
      typeof s.getModifierState == "function" && (a.value = s.getModifierState(t));
    });
  }), a;
}
const ya = (t, e) => {
  const n = t.__vccOpts || t;
  for (const [r, o] of e)
    n[r] = o;
  return n;
}, zM = {}, YM = { class: "caps-lock-icon-wrapper" };
function qM(t, e) {
  return w(), K("span", YM, e[0] || (e[0] = [
    be("span", { class: "caps-lock-icon-container" }, [
      be("span", { class: "caps-lock-icon" }, "⇪")
    ], -1)
  ]));
}
const GM = /* @__PURE__ */ ya(zM, [["render", qM]]), JM = ["type", "disabled", "id", "aria-describedby"], XM = { class: "caps-lock-warning" }, c8 = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "KPasswordInput",
  props: /* @__PURE__ */ it({
    toggleable: { type: [Boolean, String], default: !0 },
    capsLockWarning: { type: [Boolean, String], default: !0 },
    id: {},
    label: {},
    labelSrOnly: { type: [Boolean, String] },
    required: { type: [Boolean, String] },
    disabled: { type: [Boolean, String] },
    marginless: { type: [Boolean, String] },
    emptyValue: {},
    defaultValue: {},
    description: {},
    errors: {},
    variant: {},
    tooltip: {},
    tooltipProps: {},
    prependIcon: {},
    appendIcon: {},
    clearable: { type: [Boolean, String] }
  }, {
    modelValue: {},
    modelModifiers: {},
    visible: { type: Boolean, default: !1 },
    visibleModifiers: {}
  }),
  emits: ["update:modelValue", "update:visible"],
  setup(t) {
    const e = t, n = ut(t, "modelValue"), r = rr(n, e.defaultValue), o = ut(t, "visible"), { t: a } = Mt(), i = oh("CapsLock"), s = fn(e), l = yn(s, e), u = Fo({ ...e }), c = A(
      () => o.value ? a("k-hide-password") : a("k-show-password")
    ), d = A(() => e.appendIcon || !ce(e.toggleable) ? e.appendIcon : o.value ? "fas fa-eye-slash" : "fas fa-eye");
    return (f, h) => (w(), I(yr, oe(f.$props, {
      input: p(r),
      "onUpdate:input": h[2] || (h[2] = (m) => bt(r) ? r.value = m : null),
      "description-id": p(l),
      "input-id": p(s),
      variant: f.variant,
      description: f.description
    }), At({
      default: S(() => [
        $(f.$slots, "prepend"),
        Xr(be("input", oe({
          type: o.value ? "text" : "password",
          autocomplete: "current-password"
        }, f.$attrs, {
          disabled: p(ce)(f.disabled),
          id: p(s),
          "onUpdate:modelValue": h[0] || (h[0] = (m) => bt(r) ? r.value = m : null),
          class: p(u),
          "aria-describedby": p(l)
        }), null, 16, JM), [
          [o_, p(r)]
        ])
      ]),
      _: 2
    }, [
      f.capsLockWarning && p(i) ? {
        name: "description",
        fn: S(() => [
          be("span", XM, [
            q(GM),
            q(Nf, null, {
              default: S(() => [
                We(Se(p(a)("k-caps-lock")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        key: "0"
      } : void 0,
      p(ce)(f.toggleable) ? {
        name: "append",
        fn: S(() => [
          q(Hn, { text: c.value }, {
            trigger: S(() => [
              q(zt, {
                type: "button",
                icon: d.value,
                variant: "link",
                "aria-label": c.value,
                onClick: h[1] || (h[1] = () => o.value = !o.value)
              }, null, 8, ["icon", "aria-label"])
            ]),
            _: 1
          }, 8, ["text"])
        ]),
        key: "1"
      } : void 0
    ]), 1040, ["input", "description-id", "input-id", "variant", "description"]));
  }
}), Ai = " ", Rf = /* @__PURE__ */ j({
  __name: "KSelectItem",
  props: {
    disabled: { type: [Boolean, String] },
    value: {},
    text: {},
    tooltip: {},
    selected: { type: Boolean }
  },
  setup(t) {
    return (e, n) => {
      var r;
      return w(), I(p(LA), {
        class: "k-select-item",
        value: ((r = e.value) == null ? void 0 : r.toString()) || p(Ai),
        disabled: p(ce)(e.disabled)
      }, {
        default: S(() => [
          q(p(BA), { class: "k-select-item-indicator" }, {
            default: S(() => [
              q(ht, { icon: "fal fa-check" })
            ]),
            _: 1
          }),
          q(p(FA), null, {
            default: S(() => [
              $(e.$slots, "default", {}, () => [
                We(Se(e.text), 1)
              ])
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 8, ["value", "disabled"]);
    };
  }
}), QM = { class: "k-select-item-group-label-container" }, ZM = /* @__PURE__ */ j({
  __name: "KSelectItemGroup",
  props: {
    identifier: {},
    label: {},
    items: {}
  },
  setup(t) {
    return (e, n) => (w(), I(p($A), { class: "k-select-item-group" }, {
      default: S(() => [
        n[0] || (n[0] = be("hr", null, null, -1)),
        be("div", QM, [
          q(p(VA), { class: "k-select-item-group-label" }, {
            default: S(() => [
              $(e.$slots, "label", {}, () => [
                We(Se(e.label), 1)
              ])
            ]),
            _: 3
          })
        ]),
        $(e.$slots, "default", {}, () => [
          e.items && e.items.length ? (w(!0), K(Me, { key: 0 }, et(e.items, (r, o) => (w(), I(Rf, oe({
            key: r.value || o.toString(),
            ref_for: !0
          }, r), null, 16))), 128)) : V("", !0)
        ])
      ]),
      _: 3
    }));
  }
}), eI = {
  csv: "fa-file-csv",
  pdf: "fa-file-pdf",
  xlsx: "fa-file-excel",
  docx: "fa-file-word",
  doc: "fa-file-word",
  pptx: "fa-file-powerpoint",
  zip: "fa-file-archive",
  png: "fa-file-image",
  gif: "fa-file-image",
  jpg: "fa-file-image",
  jpeg: "fa-file-image",
  txt: "fa-file-alt",
  json: "fa-file-code"
}, As = (t) => {
  var e, n, r;
  return ((r = (n = (e = t == null ? void 0 : t.toLowerCase()) == null ? void 0 : e.normalize("NFKD")) == null ? void 0 : n.replace(/[\u0300-\u036f]/g, "")) == null ? void 0 : r.replace(/[-'",\s]/g, "")) || "";
}, tI = (t, e = "far") => {
  const n = (t == null ? void 0 : t.split(".").pop()) || "";
  return e + " " + (eI[n] || "fa-file");
}, D0 = (t, e) => {
  let n;
  return t == null || t.forEach((r) => {
    var o;
    if ("items" in r) {
      n = D0(r.items, e) || n;
      return;
    }
    "value" in r && ((o = r.value) == null ? void 0 : o.toString()) === (e == null ? void 0 : e.toString()) && (n = { ...r });
  }), n;
}, P0 = (t, e) => t == null ? void 0 : t.find(
  (n) => {
    var r;
    return "items" in n && ((r = n.items) == null ? void 0 : r.some((o) => {
      var a;
      return ((a = o.value) == null ? void 0 : a.toString()) === (e == null ? void 0 : e.toString());
    }));
  }
), wg = (t, e, n) => {
  var r;
  return !!(As((r = t.value) == null ? void 0 : r.toString()) === e || n && As(n + t.text).includes(e) || n && As(t.text + n).includes(e) || !n && As(t.text).includes(e));
}, ah = (t, e) => {
  const n = As(e), r = [];
  return t.forEach((o) => {
    var a, i;
    if ("items" in o) {
      const s = {
        ...o,
        items: (a = o.items) == null ? void 0 : a.filter((l) => wg(l, n, o.label)).map((l) => ({ ...l }))
      };
      (i = s.items) != null && i.length && r.push(s);
      return;
    }
    if ("value" in o && wg(o, n)) {
      r.push({ ...o });
      return;
    }
  }), r;
}, nI = (t, e) => {
  const n = (e == null ? void 0 : e.text) || ((a) => a), r = (e == null ? void 0 : e.value) || ((a, i) => i);
  return Object.entries(t).map(([a, i]) => ({
    text: n(a, i),
    value: r(a, i)
  }));
}, rI = (t, e) => {
  const n = (e == null ? void 0 : e.text) || ((a) => a), r = (e == null ? void 0 : e.value) || ((a, i) => i);
  return Object.entries(t).filter(([a]) => isNaN(Number(a))).map(([a, i]) => ({
    text: n(a, i),
    value: r(a, i)
  }));
}, d8 = (t, e) => {
  const { t: n } = Mt();
  return A(() => nI(t, { text: (e == null ? void 0 : e.text) || n, ...e }));
}, f8 = (t, e) => {
  const { t: n } = Mt();
  return A(() => rI(t, { text: (e == null ? void 0 : e.text) || n, ...e }));
}, oI = { key: 0 }, p8 = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "KSelect",
  props: /* @__PURE__ */ it({
    items: {},
    placeholder: {},
    side: {},
    align: { default: "start" },
    addEmpty: { type: [Boolean, String], default: "when-not-in-items" },
    compact: { type: [Boolean, String] },
    inline: { type: [Boolean, String] },
    id: {},
    label: {},
    labelSrOnly: { type: [Boolean, String] },
    required: { type: [Boolean, String] },
    disabled: { type: [Boolean, String] },
    marginless: { type: [Boolean, String] },
    emptyValue: { default: Ai },
    defaultValue: { default: "" },
    description: {},
    errors: {},
    variant: {},
    tooltip: {},
    tooltipProps: {},
    prependIcon: {},
    appendIcon: {},
    clearable: { type: [Boolean, String], default: !0 }
  }, {
    modelValue: { default: "" },
    modelModifiers: {},
    open: { type: Boolean, default: !1 },
    openModifiers: {}
  }),
  emits: ["update:modelValue", "update:open"],
  setup(t) {
    var C, k;
    const e = t, n = e.defaultValue || ((k = (C = e.items) == null ? void 0 : C.find((v) => "selected" in v && v.selected)) == null ? void 0 : k.value), r = ut(t, "modelValue"), o = rr(r, n == null ? void 0 : n.toString()), a = A(() => D0(e.items, o.value)), i = A(() => P0(e.items, o.value)), s = A(
      () => ce(e.clearable) && !!o.value && o.value !== Ai && !ce(e.disabled)
    ), l = ut(t, "open"), u = F(), c = A(() => e.placeholder || f("k-select")), d = A(() => {
      var v;
      return e.addEmpty == "when-not-in-items" ? e.items && !((v = e.items) != null && v.some((E) => "value" in E && !E.value)) : e.addEmpty;
    }), { t: f } = Mt(), h = fn(e), m = yn(h, e), g = Fo(e), y = A(() => ({
      "k-select-open": l.value,
      ...g.value
    })), b = () => {
      nt(() => {
        var v, E;
        l.value || (E = (v = u.value) == null ? void 0 : v.$el) == null || E.focus();
      });
    };
    return Ke(o, () => {
      o.value === Ai && (o.value = "");
    }), (v, E) => (w(), I(yr, oe(v.$props, {
      input: p(o),
      "onUpdate:input": E[2] || (E[2] = (_) => bt(o) ? o.value = _ : null),
      "description-id": p(m),
      "input-id": p(h),
      "append-icon": void 0,
      clearable: s.value,
      onClear: b
    }), At({
      default: S(() => [
        be("div", {
          class: Ie(["k-select", y.value])
        }, [
          q(p(CA), oe({
            modelValue: p(o),
            "onUpdate:modelValue": E[0] || (E[0] = (_) => bt(o) ? o.value = _ : null),
            open: l.value,
            "onUpdate:open": E[1] || (E[1] = (_) => l.value = _)
          }, v.$attrs, {
            id: `${p(h)}-select`,
            disabled: p(ce)(v.disabled)
          }), {
            default: S(() => [
              q(p(UA), {
                class: "k-select-trigger",
                "aria-label": c.value,
                "aria-describedby": p(m),
                id: p(h),
                ref_key: "trigger",
                ref: u
              }, {
                default: S(() => [
                  q(p(WA), {
                    placeholder: c.value,
                    class: "k-select-value"
                  }, {
                    default: S(() => [
                      $(v.$slots, "selected-item", {
                        item: a.value,
                        group: i.value
                      }, () => {
                        var _, T;
                        return [
                          (_ = i.value) != null && _.label ? (w(), K("span", oI, Se(i.value.label + " - "), 1)) : V("", !0),
                          We(" " + Se(((T = a.value) == null ? void 0 : T.text) || c.value), 1)
                        ];
                      })
                    ]),
                    _: 3
                  }, 8, ["placeholder"]),
                  s.value ? V("", !0) : (w(), I(ht, {
                    key: 0,
                    icon: e.appendIcon || "fal fa-chevron-down"
                  }, null, 8, ["icon"]))
                ]),
                _: 3
              }, 8, ["aria-label", "aria-describedby", "id"]),
              q(p(HA), {
                disabled: p(ce)(v.inline)
              }, {
                default: S(() => [
                  q(p(DA), {
                    position: "popper",
                    class: "k-select-content",
                    "avoid-collisions": "",
                    side: v.side,
                    "side-offset": 5,
                    align: v.align,
                    "body-lock": !1
                  }, {
                    default: S(() => [
                      q(p(KA), { class: "k-select-viewport" }, {
                        default: S(() => [
                          d.value ? (w(), I(Rf, {
                            key: 0,
                            value: p(Ai),
                            text: c.value,
                            class: Ie(["k-select-empty-item", p(ce)(v.$props.compact) ? "k-select-item-compact" : ""])
                          }, null, 8, ["value", "text", "class"])) : V("", !0),
                          e.items && e.items.length ? (w(!0), K(Me, { key: 1 }, et(e.items, (_, T) => (w(), K(Me, null, [
                            "value" in _ ? (w(), I(Rf, oe({
                              class: p(ce)(v.$props.compact) ? "k-select-item-compact" : "",
                              key: _.value || T.toString(),
                              ref_for: !0
                            }, _), null, 16, ["class"])) : V("", !0),
                            "items" in _ ? (w(), I(ZM, oe({
                              key: _.identifier || T.toString(),
                              ref_for: !0
                            }, _), null, 16)) : V("", !0)
                          ], 64))), 256)) : V("", !0)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["side", "align"])
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 3
          }, 16, ["modelValue", "open", "id", "disabled"])
        ], 2)
      ]),
      _: 2
    }, [
      v.$slots.prepend ? {
        name: "prepend",
        fn: S(() => [
          $(v.$slots, "prepend")
        ]),
        key: "0"
      } : void 0,
      v.$slots.append ? {
        name: "append",
        fn: S(() => [
          $(v.$slots, "append")
        ]),
        key: "1"
      } : void 0
    ]), 1040, ["input", "description-id", "input-id", "clearable"]));
  }
}), aI = ["name"], iI = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "KCheckbox",
  props: /* @__PURE__ */ it({
    id: {},
    label: {},
    labelSrOnly: { type: [Boolean, String] },
    required: { type: [Boolean, String] },
    disabled: { type: [Boolean, String] },
    marginless: { type: [Boolean, String] },
    emptyValue: { type: Boolean },
    defaultValue: { type: Boolean },
    description: {},
    errors: {},
    variant: {},
    tooltip: {},
    tooltipProps: {}
  }, {
    modelValue: { type: Boolean, default: void 0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, n = ut(t, "modelValue"), r = rr(n, e.defaultValue), o = ho(e), a = fn(e), i = yn(a, e), s = A(() => ({
      "k-checkbox-wrapper": !0,
      [`k-checkbox-${e.variant}`]: !!e.variant,
      "k-checkbox-disabled": ce(e.disabled),
      "k-checkbox-error": e.variant === "error" || o.value
    }));
    return (l, u) => (w(), I(li, { marginless: l.marginless }, {
      default: S(() => [
        be("div", {
          class: Ie(s.value)
        }, [
          q(p(HS), oe(l.$attrs, {
            modelValue: p(r),
            "onUpdate:modelValue": u[0] || (u[0] = (c) => bt(r) ? r.value = c : null),
            disabled: p(ce)(l.disabled),
            id: p(a),
            class: "k-checkbox",
            value: "true"
          }), {
            default: S(() => [
              q(p(US), { class: "k-checkbox-indicator" }, {
                default: S(() => [
                  q(ht, { icon: "fas fa-check" })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 16, ["modelValue", "disabled", "id"]),
          l.$attrs.name ? (w(), K("input", {
            key: 0,
            type: "hidden",
            name: l.$attrs.name,
            value: "false"
          }, null, 8, aI)) : V("", !0),
          l.label ? (w(), I(va, oe({
            key: 1,
            "input-id": p(a)
          }, e), {
            default: S(() => [
              $(l.$slots, "default")
            ]),
            _: 3
          }, 16, ["input-id"])) : V("", !0)
        ], 2),
        q(si, oe(e, { "description-id": p(i) }), null, 16, ["description-id"])
      ]),
      _: 3
    }, 8, ["marginless"]));
  }
}), Lf = /* @__PURE__ */ j({
  __name: "KAutocompleteItem",
  props: {
    item: {}
  },
  setup(t) {
    return (e, n) => (w(), I(p(o0), {
      class: "k-autocomplete-item",
      value: e.item,
      disabled: p(ce)(e.item.disabled)
    }, {
      default: S(() => [
        q(p(i0), { class: "k-autocomplete-item-indicator" }, {
          default: S(() => [
            q(ht, { icon: "fal fa-check" })
          ]),
          _: 1
        }),
        be("span", null, [
          $(e.$slots, "default", {}, () => [
            We(Se(e.item.text), 1)
          ])
        ])
      ]),
      _: 3
    }, 8, ["value", "disabled"]));
  }
}), sI = { class: "k-autocomplete-item-group-label-container" }, lI = /* @__PURE__ */ j({
  __name: "KAutocompleteItemGroup",
  props: {
    identifier: {},
    label: {},
    items: {}
  },
  setup(t) {
    return (e, n) => (w(), I(p(n0), { class: "k-autocomplete-item-group" }, {
      default: S(() => [
        n[0] || (n[0] = be("hr", null, null, -1)),
        be("div", sI, [
          q(p(s0), { class: "k-autocomplete-item-group-label" }, {
            default: S(() => [
              $(e.$slots, "label", {}, () => [
                We(Se(e.label), 1)
              ])
            ]),
            _: 3
          })
        ]),
        $(e.$slots, "default", {}, () => [
          e.items && e.items.length ? (w(!0), K(Me, { key: 0 }, et(e.items, (r, o) => (w(), I(Lf, {
            key: r.value || o.toString(),
            item: r
          }, null, 8, ["item"]))), 128)) : V("", !0)
        ])
      ]),
      _: 3
    }));
  }
}), uI = { class: "k-combobox-search" }, cI = { class: "k-combobox-search-prepend" }, dI = { class: "k-combobox-search-append" }, N0 = /* @__PURE__ */ j({
  __name: "KComboboxSearch",
  props: /* @__PURE__ */ it({
    id: {},
    searching: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ it(["search"], ["update:modelValue"]),
  setup(t, { emit: e }) {
    const { t: n } = Mt(), r = ut(t, "modelValue"), o = F(), a = Bo(), i = Lc(), s = F(r.value || ""), l = e, u = (h) => i.highlightFirstItem(h || new InputEvent("input")), c = () => {
      r.value = "", l("search", u);
    }, d = () => {
      var h, m;
      (((h = s.value) == null ? void 0 : h.trim()) || "") !== (((m = r.value) == null ? void 0 : m.trim()) || "") && l("search", u), s.value = r.value || "";
    }, f = (h) => {
      const m = h.target;
      a.filterState.search = m.value;
    };
    return Ke(r, () => {
      a.filterState.search = r.value || "";
    }), ze(() => {
      setTimeout(() => {
        var h, m;
        (m = (h = o.value) == null ? void 0 : h.$el) == null || m.focus(), u();
      }, 1);
    }), (h, m) => (w(), K("div", uI, [
      be("div", cI, [
        h.searching ? (w(), I(Rp, {
          key: 0,
          variant: "text"
        })) : (w(), I(ht, {
          key: 1,
          icon: "far fa-search"
        }))
      ]),
      q(p(fx), {
        ref_key: "inputElement",
        ref: o,
        modelValue: r.value,
        "onUpdate:modelValue": m[0] || (m[0] = (g) => r.value = g),
        id: h.id,
        "auto-focus": !1,
        placeholder: p(n)("k-search"),
        "aria-label": p(n)("k-search"),
        "aria-expanded": p(a).open.value,
        "aria-controls": p(a).contentId,
        "aria-autocomplete": "list",
        role: "combobox",
        autocomplete: "off",
        onKeyup: d,
        onInput: f,
        class: "k-combobox-search-input"
      }, null, 8, ["modelValue", "id", "placeholder", "aria-label", "aria-expanded", "aria-controls"]),
      be("div", dI, [
        r.value ? (w(), I(p(lx), {
          key: 0,
          as: zt,
          variant: "text",
          icon: "fal fa-times",
          onClick: c,
          class: "k-combobox-search-clear",
          "aria-label": p(n)("k-clear")
        }, null, 8, ["aria-label"])) : V("", !0)
      ])
    ]));
  }
}), fI = ["name", "value"], $0 = /* @__PURE__ */ j({
  __name: "KInputHiddenValue",
  props: {
    name: {},
    value: {}
  },
  setup(t) {
    const e = t, n = A(() => typeof e.value == "object"), r = A(() => typeof e.value != "string" && Array.isArray(e.value));
    return (o, a) => {
      const i = a_("k-input-hidden-value", !0);
      return o.name && o.value ? (w(), K(Me, { key: 0 }, [
        r.value ? (w(!0), K(Me, { key: 0 }, et(o.value, (s, l) => (w(), I(i, {
          key: `${o.name}-${l}`,
          name: `${o.name}[${l}]`,
          value: s
        }, null, 8, ["name", "value"]))), 128)) : n.value ? (w(!0), K(Me, { key: 1 }, et(Object.entries(o.value), ([s, l]) => (w(), I(i, {
          key: `${o.name}-${s}`,
          name: `${o.name}.${s}`,
          value: l
        }, null, 8, ["name", "value"]))), 128)) : (w(), K("input", {
          key: 2,
          type: "hidden",
          name: o.name,
          value: o.value,
          class: "k-input-hidden-value"
        }, null, 8, fI))
      ], 64)) : V("", !0);
    };
  }
}), pI = {
  key: 0,
  class: "k-autocomplete-selection k-autocomplete-placeholder"
}, hI = {
  key: 1,
  class: "k-autocomplete-selection"
}, mI = { key: 0 }, gI = {
  key: 0,
  class: "k-autocomplete-status"
}, vI = {
  key: 0,
  class: "k-autocomplete-items-prepend"
}, yI = {
  key: 3,
  class: "k-autocomplete-items-append"
}, h8 = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "KAutocomplete",
  props: /* @__PURE__ */ it({
    items: {},
    showItems: {},
    placeholder: {},
    side: {},
    align: { default: "start" },
    addEmpty: { type: [Boolean, String], default: "when-not-in-items" },
    compact: { type: [Boolean, String] },
    debounce: { default: 300 },
    autosearch: { type: [Boolean, String], default: !0 },
    onSearch: {},
    inline: { type: [Boolean, String] },
    avoidCollisions: { type: [Boolean, String] },
    id: {},
    label: {},
    labelSrOnly: { type: [Boolean, String] },
    required: { type: [Boolean, String] },
    disabled: { type: [Boolean, String] },
    marginless: { type: [Boolean, String] },
    emptyValue: { type: Boolean },
    defaultValue: { type: Boolean },
    description: {},
    errors: {},
    variant: {},
    tooltip: {},
    tooltipProps: {},
    prependIcon: {},
    appendIcon: {},
    clearable: { type: [Boolean, String], default: !0 }
  }, {
    modelValue: { default: {} },
    modelModifiers: {},
    open: { type: Boolean, default: !1 },
    openModifiers: {},
    opened: { type: Boolean, default: !1 },
    openedModifiers: {},
    searching: { type: Boolean, default: !1 },
    searchingModifiers: {},
    search: { default: "" },
    searchModifiers: {}
  }),
  emits: ["update:modelValue", "update:open", "update:opened", "update:searching", "update:search"],
  setup(t) {
    const e = t, { t: n } = Mt(), r = ut(t, "modelValue"), o = rr(r, e.defaultValue ?? {}, (N) => !N.value), a = A(() => P0(e.items, o.value.value)), i = A(() => {
      var N;
      return ce(e.clearable) && !!((N = o == null ? void 0 : o.value) != null && N.value) && !ce(e.disabled);
    }), s = ut(t, "open"), l = ut(t, "opened"), u = F(), c = ut(t, "searching"), d = ut(t, "search"), f = F(e.items || []), h = A(
      () => e.showItems ? f.value.slice(0, e.showItems) : f.value
    ), m = A(() => e.placeholder || n("k-select")), g = A(() => e.emptyValue || { text: m.value, value: "" }), y = A(() => {
      var N;
      return e.addEmpty == "when-not-in-items" ? e.items && !((N = e.items) != null && N.some((z) => "value" in z && !z.value)) : e.addEmpty;
    }), b = fn(e), C = yn(b, e), k = Fo(e), v = A(() => ({
      "k-autocomplete-open": s.value,
      ...k.value
    })), E = async () => {
      c.value = !0;
      const N = d.value, z = e.items || [];
      e.onSearch ? await e.onSearch({
        text: N,
        items: z,
        showItems: e.showItems
      }) : d.value ? f.value = await ah(z, N) : f.value = await Promise.resolve(z), c.value = N !== d.value;
    }, _ = A0(E, e.debounce), T = () => {
      var N, z;
      s.value || (z = (N = u.value) == null ? void 0 : N.$el) == null || z.focus();
    };
    Ke(s, () => {
      T();
    });
    const M = (N) => {
      s.value && N.preventDefault();
    }, O = () => {
      o.value = { ...g.value }, T();
    }, R = async (N) => {
      d.value ? await _() : await E(), N == null || N();
    };
    return Ke(
      () => e.items,
      () => f.value = e.items ?? []
    ), Ke(
      s,
      () => {
        s.value && !l.value && ce(e.autosearch) && E(), s.value && (l.value = !0);
      },
      {
        immediate: !0
      }
    ), (N, z) => (w(), I(yr, oe(N.$props, {
      input: p(o),
      "onUpdate:input": z[4] || (z[4] = (te) => bt(o) ? o.value = te : null),
      "description-id": p(C),
      "input-id": p(b),
      "append-icon": void 0,
      clearable: !1,
      "wrapper-class": "k-autocomplete-wrapper"
    }), At({
      default: S(() => [
        q(p(Jb), oe({
          modelValue: p(o),
          "onUpdate:modelValue": z[2] || (z[2] = (te) => bt(o) ? o.value = te : null),
          open: s.value,
          "onUpdate:open": z[3] || (z[3] = (te) => s.value = te)
        }, N.$attrs, {
          id: `${p(b)}-select`,
          disabled: p(ce)(N.disabled),
          class: ["k-autocomplete", v.value],
          name: void 0,
          "reset-search-term-on-select": !1,
          "reset-search-term-on-blur": !1,
          "ignore-filter": ""
        }), {
          default: S(() => [
            q(p(Yb), { class: "k-autocomplete-anchor" }, {
              default: S(() => [
                q(p(u0), {
                  class: "k-autocomplete-trigger",
                  tabindex: 0,
                  onMousedown: M,
                  ref_key: "trigger",
                  ref: u,
                  "aria-label": e.label,
                  id: p(b)
                }, {
                  default: S(() => {
                    var te;
                    return [
                      (te = p(o)) != null && te.value ? (w(), K("span", hI, [
                        $(N.$slots, "selected-item", {
                          item: p(o),
                          group: a.value
                        }, () => {
                          var H;
                          return [
                            (H = a.value) != null && H.label ? (w(), K("span", mI, Se(a.value.label + " - "), 1)) : V("", !0),
                            We(" " + Se(p(o).text), 1)
                          ];
                        })
                      ])) : (w(), K("span", pI, Se(m.value), 1)),
                      i.value ? V("", !0) : (w(), I(ht, {
                        key: 2,
                        icon: e.appendIcon || "fal fa-chevron-down"
                      }, null, 8, ["icon"]))
                    ];
                  }),
                  _: 3
                }, 8, ["aria-label", "id"]),
                i.value ? (w(), I(Pl, oe({
                  key: 0,
                  onClear: O
                }, e, {
                  input: p(o),
                  "onUpdate:input": z[0] || (z[0] = (te) => bt(o) ? o.value = te : null)
                }), null, 16, ["input"])) : V("", !0)
              ]),
              _: 3
            }),
            q(p(l0), {
              disabled: p(ce)(N.inline)
            }, {
              default: S(() => [
                q(p(Qb), {
                  position: "popper",
                  class: "k-autocomplete-content",
                  "avoid-collisions": p(ce)(N.avoidCollisions),
                  side: N.side,
                  align: N.align,
                  "side-offset": 5,
                  "body-lock": !1,
                  "update-position-strategy": "optimized",
                  id: `${p(b)}-content`
                }, {
                  default: S(() => [
                    q(N0, {
                      modelValue: d.value,
                      "onUpdate:modelValue": z[1] || (z[1] = (te) => d.value = te),
                      id: `${p(b)}-search`,
                      searching: c.value,
                      onSearch: R
                    }, null, 8, ["modelValue", "id", "searching"]),
                    q(p(d0), { class: "k-autocomplete-viewport" }, {
                      default: S(() => {
                        var te;
                        return [
                          c.value ? (w(), K("i", gI, Se(p(n)("k-searching")), 1)) : (te = h.value) != null && te.length ? (w(), K(Me, { key: 2 }, [
                            N.$slots["items-prepend"] ? (w(), K("div", vI, [
                              $(N.$slots, "items-prepend")
                            ])) : V("", !0),
                            y.value ? (w(), I(Lf, {
                              key: 1,
                              item: g.value,
                              class: Ie(["k-autocomplete-empty-item", p(ce)(N.$props.compact) ? "k-autocomplete-item-compact" : ""])
                            }, null, 8, ["item", "class"])) : V("", !0),
                            h.value && h.value.length ? (w(!0), K(Me, { key: 2 }, et(h.value, (H, U) => (w(), K(Me, null, [
                              "value" in H ? (w(), I(Lf, {
                                class: Ie(p(ce)(N.$props.compact) ? "k-autocomplete-item-compact" : ""),
                                key: H.value || U.toString(),
                                item: H
                              }, null, 8, ["class", "item"])) : V("", !0),
                              "items" in H ? (w(), I(lI, oe({
                                key: H.identifier || U.toString(),
                                ref_for: !0
                              }, H), null, 16)) : V("", !0)
                            ], 64))), 256)) : V("", !0),
                            f.value.length > h.value.length || N.$slots["items-append"] ? (w(), K("div", yI, [
                              $(N.$slots, "items-append", {}, () => [
                                We(Se(p(n)("k-and-other-results", [f.value.length - h.value.length])), 1)
                              ])
                            ])) : V("", !0)
                          ], 64)) : (w(), I(p(Zb), {
                            key: 1,
                            class: "k-autocomplete-status"
                          }, {
                            default: S(() => [
                              We(Se(p(n)("k-no-results")), 1)
                            ]),
                            _: 1
                          }))
                        ];
                      }),
                      _: 3
                    })
                  ]),
                  _: 3
                }, 8, ["avoid-collisions", "side", "align", "id"])
              ]),
              _: 3
            }, 8, ["disabled"])
          ]),
          _: 3
        }, 16, ["modelValue", "open", "id", "disabled", "class"]),
        N.$attrs.name && typeof N.$attrs.name == "string" ? (w(), I($0, {
          key: 0,
          name: N.$attrs.name,
          value: p(o)
        }, null, 8, ["name", "value"])) : V("", !0)
      ]),
      _: 2
    }, [
      N.$slots.prepend ? {
        name: "prepend",
        fn: S(() => [
          $(N.$slots, "prepend")
        ]),
        key: "0"
      } : void 0,
      N.$slots.append ? {
        name: "append",
        fn: S(() => [
          $(N.$slots, "append")
        ]),
        key: "1"
      } : void 0
    ]), 1040, ["input", "description-id", "input-id"]));
  }
}), R0 = /* @__PURE__ */ j({
  __name: "KComboboxItem",
  props: {
    item: {}
  },
  emits: ["click"],
  setup(t, { emit: e }) {
    const n = e;
    return (r, o) => (w(), I(p(o0), {
      class: "k-combobox-item",
      value: r.item,
      disabled: p(ce)(r.item.disabled),
      onClick: o[0] || (o[0] = () => n("click", r.item))
    }, {
      default: S(() => [
        q(p(i0), { class: "k-combobox-item-indicator" }, {
          default: S(() => [
            q(ht, { icon: "fal fa-check" })
          ]),
          _: 1
        }),
        be("span", null, [
          $(r.$slots, "default", {}, () => [
            We(Se(r.item.text), 1)
          ])
        ])
      ]),
      _: 3
    }, 8, ["value", "disabled"]));
  }
}), bI = { class: "k-combobox-item-group-label-container" }, kI = /* @__PURE__ */ j({
  __name: "KComboboxItemGroup",
  props: {
    identifier: {},
    label: {},
    items: {}
  },
  emits: ["click"],
  setup(t, { emit: e }) {
    const n = e;
    return (r, o) => (w(), I(p(n0), { class: "k-combobox-item-group" }, {
      default: S(() => [
        o[0] || (o[0] = be("hr", null, null, -1)),
        be("div", bI, [
          q(p(s0), { class: "k-combobox-item-group-label" }, {
            default: S(() => [
              $(r.$slots, "label", {}, () => [
                We(Se(r.label), 1)
              ])
            ]),
            _: 3
          })
        ]),
        $(r.$slots, "default", {}, () => [
          r.items && r.items.length ? (w(!0), K(Me, { key: 0 }, et(r.items, (a, i) => (w(), I(R0, {
            key: a.value || i.toString(),
            item: a,
            onClick: (s) => n("click", a)
          }, null, 8, ["item", "onClick"]))), 128)) : V("", !0)
        ])
      ]),
      _: 3
    }));
  }
}), wI = ["aria-label"], _I = {
  key: 0,
  class: "k-chip-prepend"
}, CI = {
  key: 1,
  class: "k-chip-append"
}, EI = /* @__PURE__ */ j({
  __name: "KChip",
  props: /* @__PURE__ */ it({
    text: {},
    variant: { default: "primary" },
    prependIcon: {},
    appendIcon: {},
    closable: { type: [Boolean, String] },
    color: {},
    backgroundColor: {},
    compact: { type: [Boolean, String] },
    size: { default: "1x" },
    rounded: { type: [Boolean, String], default: !0 },
    onClose: {}
  }, {
    visible: { type: Boolean, default: !0 },
    visibleModifiers: {}
  }),
  emits: ["update:visible"],
  setup(t) {
    const e = ut(t, "visible"), n = t, r = A(() => {
      var i;
      return {
        "k-chip": !0,
        [`k-chip-${n.variant}`]: n.variant !== "primary",
        [`k-chip-${(i = n.size) == null ? void 0 : i.replace(".", "_")}`]: n.size !== "1x",
        "k-chip-compact": ce(n.compact),
        "k-chip-rounded": ce(n.rounded),
        "k-chip-closable": ce(n.closable)
      };
    }), o = A(() => ({
      color: n.color,
      backgroundColor: n.backgroundColor,
      borderColor: n.backgroundColor
    })), a = () => {
      var i;
      (i = n.onClose) == null || i.call(n), e.value = !1;
    };
    return (i, s) => e.value ? (w(), K("div", {
      key: 0,
      class: Ie(r.value),
      "aria-label": i.text,
      style: Lt(o.value)
    }, [
      i.$slots.prepend || i.prependIcon ? (w(), K("div", _I, [
        $(i.$slots, "prepend", {}, () => [
          i.prependIcon ? (w(), I(ht, {
            key: 0,
            icon: i.prependIcon
          }, null, 8, ["icon"])) : V("", !0)
        ])
      ])) : V("", !0),
      $(i.$slots, "default", {}, () => [
        We(Se(i.text), 1)
      ]),
      i.$slots.append || i.appendIcon ? (w(), K("div", CI, [
        $(i.$slots, "append", {}, () => [
          i.appendIcon ? (w(), I(ht, {
            key: 0,
            icon: i.appendIcon
          }, null, 8, ["icon"])) : V("", !0)
        ])
      ])) : V("", !0),
      p(ce)(i.closable) ? (w(), I(zt, {
        key: 2,
        variant: "link",
        icon: "far fa-times",
        class: "k-chip-close",
        onClick: Xe(a, ["stop"])
      })) : V("", !0)
    ], 14, wI)) : V("", !0);
  }
}), OI = {
  key: 0,
  class: "k-combobox-placeholder"
}, TI = {
  key: 1,
  class: "k-combobox-selection"
}, SI = {
  key: 0,
  class: "k-combobox-status"
}, xI = {
  key: 0,
  class: "k-combobox-items-prepend"
}, AI = {
  key: 1,
  class: "k-combobox-items-append"
}, m8 = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "KCombobox",
  props: /* @__PURE__ */ it({
    items: {},
    showItems: {},
    placeholder: {},
    side: {},
    align: { default: "start" },
    debounce: { default: 300 },
    autosearch: { type: [Boolean, String], default: !0 },
    onSearch: {},
    inline: { type: [Boolean, String] },
    avoidCollisions: { type: [Boolean, String] },
    id: {},
    label: {},
    labelSrOnly: { type: [Boolean, String] },
    required: { type: [Boolean, String] },
    disabled: { type: [Boolean, String] },
    marginless: { type: [Boolean, String] },
    emptyValue: { type: Boolean },
    defaultValue: { type: Boolean },
    description: {},
    errors: {},
    variant: {},
    tooltip: {},
    tooltipProps: {},
    prependIcon: {},
    appendIcon: {},
    clearable: { type: [Boolean, String], default: !0 }
  }, {
    modelValue: { default: [] },
    modelModifiers: {},
    open: { type: Boolean, default: !1 },
    openModifiers: {},
    opened: { type: Boolean, default: !1 },
    openedModifiers: {},
    searching: { type: Boolean, default: !1 },
    searchingModifiers: {},
    search: { default: "" },
    searchModifiers: {}
  }),
  emits: ["update:modelValue", "update:open", "update:opened", "update:searching", "update:search"],
  setup(t) {
    const e = t, { t: n } = Mt(), r = ut(t, "modelValue"), o = rr(r, e.defaultValue ?? []), a = A(() => {
      var N;
      return ce(e.clearable) && !!((N = o == null ? void 0 : o.value) != null && N.length) && !ce(e.disabled);
    }), i = ut(t, "open"), s = ut(t, "opened"), l = F(), u = F(), c = ut(t, "searching"), d = ut(t, "search"), f = F(e.items || []), h = A(
      () => e.showItems ? f.value.slice(0, e.showItems) : f.value
    ), m = A(() => e.placeholder || n("k-select")), g = fn(e), y = yn(g, e), b = Fo(e), C = A(() => ({
      "k-combobox-open": i.value,
      ...b.value
    })), k = async () => {
      c.value = !0;
      const N = d.value, z = e.items || [];
      e.onSearch ? await e.onSearch({
        text: N,
        items: z,
        showItems: e.showItems
      }) : d.value ? f.value = await ah(z, N) : f.value = await Promise.resolve(z), c.value = N !== d.value;
    }, v = A0(k, e.debounce), E = () => {
      var N, z;
      i.value || (z = (N = l.value) == null ? void 0 : N.$el) == null || z.focus();
    }, _ = () => {
      var N, z;
      i.value && ((z = (N = u.value) == null ? void 0 : N.querySelector("input[type=text]")) == null || z.focus());
    };
    Ke(i, () => {
      E();
    });
    const T = (N) => {
      i.value && N.preventDefault();
    }, M = () => {
      o.value = [], E();
    }, O = (N) => {
      o.value = o.value.filter((z) => z !== N);
    }, R = async (N) => {
      d.value ? await v() : await k(), N == null || N();
    };
    return Ke(
      () => e.items,
      () => f.value = e.items ?? []
    ), Ke(
      i,
      () => {
        i.value && !s.value && ce(e.autosearch) && k(), i.value && (s.value = !0);
      },
      {
        immediate: !0
      }
    ), (N, z) => (w(), I(yr, oe(N.$props, {
      input: p(o),
      "onUpdate:input": z[4] || (z[4] = (te) => bt(o) ? o.value = te : null),
      "description-id": p(y),
      "input-id": p(g),
      "append-icon": void 0,
      clearable: !1,
      "wrapper-class": "k-combobox-wrapper"
    }), At({
      default: S(() => [
        q(p(Jb), oe({
          modelValue: p(o),
          "onUpdate:modelValue": z[2] || (z[2] = (te) => bt(o) ? o.value = te : null),
          open: i.value,
          "onUpdate:open": z[3] || (z[3] = (te) => i.value = te)
        }, N.$attrs, {
          class: ["k-combobox", C.value],
          id: `${p(g)}-select`,
          disabled: p(ce)(N.disabled),
          multiple: "",
          name: void 0,
          "reset-search-term-on-select": !1,
          "reset-search-term-on-blur": !1,
          "ignore-filter": ""
        }), {
          default: S(() => [
            q(p(Yb), { class: "k-combobox-anchor" }, {
              default: S(() => [
                q(p(u0), {
                  class: "k-combobox-trigger",
                  tabindex: 0,
                  onMousedown: T,
                  ref_key: "trigger",
                  ref: l,
                  "aria-label": e.label,
                  id: p(g)
                }, {
                  default: S(() => {
                    var te;
                    return [
                      (te = p(o)) != null && te.length ? (w(), K("span", TI, [
                        (w(!0), K(Me, null, et(p(o), (H) => (w(), I(EI, {
                          class: "k-combobox-selected-item",
                          key: H.value,
                          text: H.text,
                          variant: "input",
                          closable: "",
                          rounded: !1,
                          onClose: () => O(H)
                        }, null, 8, ["text", "onClose"]))), 128))
                      ])) : (w(), K("span", OI, Se(m.value), 1)),
                      a.value ? V("", !0) : (w(), I(ht, {
                        key: 2,
                        icon: e.appendIcon || "fal fa-chevron-down"
                      }, null, 8, ["icon"]))
                    ];
                  }),
                  _: 1
                }, 8, ["aria-label", "id"]),
                a.value ? (w(), I(Pl, oe({
                  key: 0,
                  onClear: M
                }, e, {
                  input: p(o),
                  "onUpdate:input": z[0] || (z[0] = (te) => bt(o) ? o.value = te : null)
                }), null, 16, ["input"])) : V("", !0)
              ]),
              _: 1
            }),
            q(p(l0), {
              disabled: p(ce)(N.inline)
            }, {
              default: S(() => [
                q(p(Qb), {
                  position: "popper",
                  class: "k-combobox-content",
                  "avoid-collisions": p(ce)(N.avoidCollisions),
                  side: N.side,
                  align: N.align,
                  "side-offset": 5,
                  "body-lock": !1,
                  "update-position-strategy": "optimized",
                  id: `${p(g)}-content`
                }, {
                  default: S(() => [
                    be("div", {
                      ref_key: "searchInputContainer",
                      ref: u
                    }, [
                      q(N0, {
                        modelValue: d.value,
                        "onUpdate:modelValue": z[1] || (z[1] = (te) => d.value = te),
                        id: `${p(g)}-search`,
                        searching: c.value,
                        onSearch: R
                      }, null, 8, ["modelValue", "id", "searching"])
                    ], 512),
                    q(p(d0), { class: "k-combobox-viewport" }, {
                      default: S(() => {
                        var te;
                        return [
                          c.value ? (w(), K("i", SI, Se(p(n)("k-searching")), 1)) : (te = h.value) != null && te.length ? h.value && h.value.length ? (w(), K(Me, { key: 2 }, [
                            N.$slots["items-prepend"] ? (w(), K("div", xI, [
                              $(N.$slots, "items-prepend")
                            ])) : V("", !0),
                            (w(!0), K(Me, null, et(h.value, (H, U) => (w(), K(Me, null, [
                              "value" in H ? (w(), I(R0, {
                                key: H.value || U.toString(),
                                item: H,
                                onClick: _
                              }, null, 8, ["item"])) : V("", !0),
                              "items" in H ? (w(), I(kI, oe({
                                key: H.identifier || U.toString(),
                                ref_for: !0
                              }, H, { onClick: _ }), null, 16)) : V("", !0)
                            ], 64))), 256)),
                            f.value.length > h.value.length || N.$slots["items-append"] ? (w(), K("div", AI, [
                              $(N.$slots, "items-append", {}, () => [
                                We(Se(p(n)("k-and-other-results", [f.value.length - h.value.length])), 1)
                              ])
                            ])) : V("", !0)
                          ], 64)) : V("", !0) : (w(), I(p(Zb), {
                            key: 1,
                            class: "k-combobox-status"
                          }, {
                            default: S(() => [
                              We(Se(p(n)("k-no-results")), 1)
                            ]),
                            _: 1
                          }))
                        ];
                      }),
                      _: 3
                    })
                  ]),
                  _: 3
                }, 8, ["avoid-collisions", "side", "align", "id"])
              ]),
              _: 3
            }, 8, ["disabled"])
          ]),
          _: 3
        }, 16, ["modelValue", "open", "id", "disabled", "class"]),
        N.$attrs.name && typeof N.$attrs.name == "string" ? (w(), I($0, {
          key: 0,
          name: N.$attrs.name,
          value: p(o)
        }, null, 8, ["name", "value"])) : V("", !0)
      ]),
      _: 2
    }, [
      N.$slots.prepend ? {
        name: "prepend",
        fn: S(() => [
          $(N.$slots, "prepend")
        ]),
        key: "0"
      } : void 0,
      N.$slots.append ? {
        name: "append",
        fn: S(() => [
          $(N.$slots, "append")
        ]),
        key: "1"
      } : void 0
    ]), 1040, ["input", "description-id", "input-id"]));
  }
}), MI = { class: "sr-only" }, Ni = /* @__PURE__ */ j({
  __name: "KSkeletonBox",
  props: {
    type: {},
    rows: {},
    level: {},
    hasLabel: { type: [Boolean, String] },
    hasDescription: { type: [Boolean, String] },
    width: {},
    height: {}
  },
  setup(t) {
    const e = t, { t: n } = Mt(), r = A(() => ({
      width: e.width,
      height: e.height
    }));
    return (o, a) => (w(), K("div", {
      class: "k-skeleton-box",
      style: Lt(r.value)
    }, [
      be("span", MI, Se(p(n)("k-loading")), 1)
    ], 4));
  }
}), II = { class: "k-skeleton-input-container" }, DI = /* @__PURE__ */ j({
  __name: "KSkeletonInput",
  props: {
    type: {},
    rows: {},
    level: {},
    hasLabel: { type: [Boolean, String] },
    hasDescription: { type: [Boolean, String] },
    width: {},
    height: {}
  },
  setup(t) {
    return (e, n) => (w(), K("div", II, [
      p(ce)(e.hasLabel) ? (w(), I(Ni, {
        key: 0,
        type: "box",
        class: "k-skeleton-label"
      })) : V("", !0),
      q(Ni, oe({
        class: "k-skeleton-input",
        style: { height: `calc(${(e.rows ?? 1) * 1.5}em + 12px)` }
      }, e.$props, {
        type: "box",
        role: "status"
      }), null, 16, ["style"]),
      p(ce)(e.hasDescription) ? (w(), I(Ni, {
        key: 1,
        type: "box",
        class: "k-skeleton-description"
      })) : V("", !0)
    ]));
  }
}), PI = /* @__PURE__ */ j({
  __name: "KSkeletonHeading",
  props: {
    type: {},
    rows: {},
    level: { default: 1 },
    hasLabel: { type: [Boolean, String] },
    hasDescription: { type: [Boolean, String] },
    width: {},
    height: {}
  },
  setup(t) {
    return (e, n) => (w(), I(qr, {
      level: e.level,
      as: "span"
    }, {
      default: S(() => [
        q(Ni, oe({ class: "k-skeleton-heading" }, e.$props, {
          type: "box",
          role: "status"
        }), null, 16)
      ]),
      _: 1
    }, 8, ["level"]));
  }
}), NI = { class: "k-skeleton-text" }, $I = /* @__PURE__ */ j({
  __name: "KSkeletonText",
  props: {
    type: {},
    rows: { default: 2 },
    level: {},
    hasLabel: { type: [Boolean, String] },
    hasDescription: { type: [Boolean, String] },
    width: {},
    height: {}
  },
  setup(t) {
    const e = t, n = A(() => Array.from(Array(e.rows).keys()));
    return (r, o) => (w(), K("div", NI, [
      (w(!0), K(Me, null, et(n.value, (a) => (w(), K("p", {
        key: a,
        class: "k-skeleton-text-line"
      }, [
        q(Ni, oe({ ref_for: !0 }, r.$props, {
          type: "box",
          role: a === 0 ? "status" : void 0
        }), null, 16, ["role"])
      ]))), 128))
    ]));
  }
}), g8 = /* @__PURE__ */ j({
  __name: "KSkeleton",
  props: {
    type: { default: "box" },
    rows: {},
    level: {},
    hasLabel: { type: [Boolean, String] },
    hasDescription: { type: [Boolean, String] },
    width: {},
    height: {}
  },
  setup(t) {
    const e = t, n = A(() => e.type === "box" ? "status" : void 0), r = A(() => ({
      box: Ni,
      input: DI,
      heading: PI,
      text: $I
    }));
    return (o, a) => (w(), I(On(r.value[o.type]), oe(o.$props, { role: n.value }), null, 16, ["role"]));
  }
}), RI = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "KRadio",
  props: {
    name: {},
    id: {},
    value: {},
    label: {},
    labelSrOnly: { type: [Boolean, String] },
    required: { type: [Boolean, String] },
    disabled: { type: [Boolean, String] },
    marginless: { type: [Boolean, String] },
    emptyValue: {},
    defaultValue: {},
    variant: {},
    tooltip: {},
    tooltipProps: {}
  },
  setup(t) {
    const e = t, n = A(() => ({
      "k-radio": !0,
      [`k-radio-${e.variant}`]: !!e.variant
    }));
    return (r, o) => (w(), K("div", {
      class: Ie(n.value)
    }, [
      q(p(gA), {
        class: "k-radio-item",
        id: r.id,
        value: r.value,
        name: r.name,
        disabled: p(ce)(r.disabled)
      }, {
        default: S(() => [
          q(p(vA), { class: "k-radio-indicator" })
        ]),
        _: 1
      }, 8, ["id", "value", "name", "disabled"]),
      q(va, oe(r.$props, {
        "input-id": r.id,
        class: "k-radio-item-label"
      }), {
        default: S(() => [
          $(r.$slots, "default")
        ]),
        _: 3
      }, 16, ["input-id"])
    ], 2));
  }
}), v8 = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "KRadioGroup",
  props: /* @__PURE__ */ it({
    items: { default: () => [] },
    autoselect: { type: [Boolean, String], default: void 0 },
    name: {},
    id: {},
    label: {},
    labelSrOnly: { type: [Boolean, String] },
    required: { type: [Boolean, String] },
    disabled: { type: [Boolean, String] },
    marginless: { type: [Boolean, String] },
    emptyValue: {},
    defaultValue: {},
    description: {},
    errors: {},
    variant: {},
    tooltip: {},
    tooltipProps: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t, { expose: e }) {
    const n = ut(t, "modelValue"), r = t, o = A(() => {
      var c, d, f;
      if (r.defaultValue)
        return r.defaultValue;
      const u = (f = (d = (c = r.items) == null ? void 0 : c.find((h) => h.selected)) == null ? void 0 : d.value) == null ? void 0 : f.toString();
      if (u)
        return u;
      if (ce(r.autoselect) && r.items && r.items.length || ce(r.required) && !Si(r.autoselect) && r.items && r.items.length)
        return r.items[0].value;
    }), a = () => n.value = "", i = ho(r), s = fn(r), l = yn(s, r);
    return e({ clear: a }), (u, c) => (w(), I(li, {
      as: "fieldset",
      marginless: u.marginless,
      "aria-describedby": p(l)
    }, {
      default: S(() => {
        var d;
        return [
          q(va, oe(r, {
            "input-id": p(s),
            as: "legend"
          }), null, 16, ["input-id"]),
          q(p(pA), {
            modelValue: n.value,
            "onUpdate:modelValue": c[0] || (c[0] = (f) => n.value = f),
            id: p(s),
            "default-value": (d = o.value) == null ? void 0 : d.toString(),
            "aria-label": u.label,
            disabled: p(ce)(u.disabled)
          }, {
            default: S(() => [
              (w(!0), K(Me, null, et(u.items, (f, h) => {
                var m;
                return w(), I(RI, {
                  key: h.toString(),
                  id: `${p(s)}-item-${h.toString()}`,
                  name: u.name,
                  disabled: p(ce)(f.disabled) || p(ce)(u.disabled),
                  value: (m = f.value) == null ? void 0 : m.toString(),
                  variant: p(i) ? "error" : u.variant,
                  tooltip: f.tooltip,
                  label: f.text
                }, {
                  default: S(() => [
                    $(u.$slots, "item", oe({ ref_for: !0 }, f))
                  ]),
                  _: 2
                }, 1032, ["id", "name", "disabled", "value", "variant", "tooltip", "label"]);
              }), 128))
            ]),
            _: 3
          }, 8, ["modelValue", "id", "default-value", "aria-label", "disabled"]),
          q(si, oe(r, { "description-id": p(l) }), null, 16, ["description-id"])
        ];
      }),
      _: 3
    }, 8, ["marginless", "aria-describedby"]));
  }
}), y8 = /* @__PURE__ */ j({
  __name: "KCheckboxList",
  props: /* @__PURE__ */ it({
    name: {},
    items: { default: () => [] },
    id: {},
    label: {},
    labelSrOnly: { type: [Boolean, String] },
    required: { type: [Boolean, String] },
    disabled: { type: [Boolean, String] },
    marginless: { type: [Boolean, String] },
    emptyValue: {},
    defaultValue: {},
    description: {},
    errors: {},
    variant: {},
    tooltip: {},
    tooltipProps: {}
  }, {
    modelValue: { default: [] },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t, { expose: e }) {
    var y;
    const n = t, r = oh("Shift"), o = ho(n), a = fn(n), i = F(), s = F(), l = yn(a, n), u = n.defaultValue && n.defaultValue.length > 0 ? n.defaultValue : ((y = n.items) == null ? void 0 : y.filter((b) => b.selected).map((b) => b.value)) ?? [], c = ut(t, "modelValue"), d = rr(c, u), f = (b, C, k) => {
      h(b, k), m(b, C);
    }, h = (b, C) => {
      if (b && !d.value.includes(C.value)) {
        d.value = [...d.value, C.value];
        return;
      }
      b || (d.value = d.value.filter((k) => k !== C.value));
    }, m = (b, C) => {
      var k;
      if (s.value === void 0) {
        s.value = C;
        return;
      }
      if (r.value) {
        const v = Math.min(C, s.value), E = Math.max(C, s.value);
        (k = n.items) == null || k.forEach((_, T) => {
          T >= v && T <= E && h(b, _);
        });
      }
      s.value = C;
    };
    return e({ clear: () => d.value = [] }), (b, C) => (w(), I(li, {
      as: "fieldset",
      marginless: b.marginless,
      "aria-describedby": p(l)
    }, {
      default: S(() => [
        q(va, oe(n, {
          "input-id": p(a),
          as: "legend"
        }), null, 16, ["input-id"]),
        be("div", {
          class: "k-checkbox-list",
          ref_key: "list",
          ref: i
        }, [
          $(b.$slots, "default", {}, () => [
            (w(!0), K(Me, null, et(b.items, (k, v) => (w(), I(iI, {
              "model-value": p(d).includes(k.value),
              "onUpdate:modelValue": (E) => f(E, v, k),
              name: b.name,
              value: k.value,
              key: k.value,
              label: k.text,
              variant: p(o) ? "error" : b.variant,
              tooltip: k.tooltip,
              disabled: p(ce)(k.disabled) || p(ce)(n.disabled),
              id: `${p(a)}-item-${v}`,
              marginless: ""
            }, {
              default: S(() => [
                $(b.$slots, "item", oe({ ref_for: !0 }, k))
              ]),
              _: 2
            }, 1032, ["model-value", "onUpdate:modelValue", "name", "value", "label", "variant", "tooltip", "disabled", "id"]))), 128))
          ])
        ], 512),
        q(si, oe(n, { "description-id": p(l) }), null, 16, ["description-id"])
      ]),
      _: 3
    }, 8, ["marginless", "aria-describedby"]));
  }
}), L0 = 6048e5, LI = 864e5, BI = 6e4, B0 = 36e5, FI = 1e3, _g = Symbol.for("constructDateFrom");
function _t(t, e) {
  return typeof t == "function" ? t(e) : t && typeof t == "object" && _g in t ? t[_g](e) : t instanceof Date ? new t.constructor(e) : new Date(e);
}
function qe(t, e) {
  return _t(e || t, t);
}
function Or(t, e, n) {
  const r = qe(t, n == null ? void 0 : n.in);
  return isNaN(e) ? _t((n == null ? void 0 : n.in) || t, NaN) : (e && r.setDate(r.getDate() + e), r);
}
function Ar(t, e, n) {
  const r = qe(t, n == null ? void 0 : n.in);
  if (isNaN(e)) return _t(t, NaN);
  if (!e)
    return r;
  const o = r.getDate(), a = _t(t, r.getTime());
  a.setMonth(r.getMonth() + e + 1, 0);
  const i = a.getDate();
  return o >= i ? a : (r.setFullYear(
    a.getFullYear(),
    a.getMonth(),
    o
  ), r);
}
function F0(t, e, n) {
  const {
    years: r = 0,
    months: o = 0,
    weeks: a = 0,
    days: i = 0,
    hours: s = 0,
    minutes: l = 0,
    seconds: u = 0
  } = e, c = qe(t, n == null ? void 0 : n.in), d = o || r ? Ar(c, o + r * 12) : c, f = i || a ? Or(d, i + a * 7) : d, h = l + s * 60, g = (u + h * 60) * 1e3;
  return _t(t, +f + g);
}
function VI(t, e, n) {
  return _t(t, +qe(t) + e);
}
function HI(t, e, n) {
  return VI(t, e * B0);
}
let UI = {};
function ui() {
  return UI;
}
function Nr(t, e) {
  var s, l, u, c;
  const n = ui(), r = (e == null ? void 0 : e.weekStartsOn) ?? ((l = (s = e == null ? void 0 : e.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((c = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) ?? 0, o = qe(t, e == null ? void 0 : e.in), a = o.getDay(), i = (a < r ? 7 : 0) + a - r;
  return o.setDate(o.getDate() - i), o.setHours(0, 0, 0, 0), o;
}
function Wi(t, e) {
  return Nr(t, { ...e, weekStartsOn: 1 });
}
function V0(t, e) {
  const n = qe(t, e == null ? void 0 : e.in), r = n.getFullYear(), o = _t(n, 0);
  o.setFullYear(r + 1, 0, 4), o.setHours(0, 0, 0, 0);
  const a = Wi(o), i = _t(n, 0);
  i.setFullYear(r, 0, 4), i.setHours(0, 0, 0, 0);
  const s = Wi(i);
  return n.getTime() >= a.getTime() ? r + 1 : n.getTime() >= s.getTime() ? r : r - 1;
}
function Tu(t) {
  const e = qe(t), n = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return n.setUTCFullYear(e.getFullYear()), +t - +n;
}
function Nl(t, ...e) {
  const n = _t.bind(
    null,
    e.find((r) => typeof r == "object")
  );
  return e.map(n);
}
function Cg(t, e) {
  const n = qe(t, e == null ? void 0 : e.in);
  return n.setHours(0, 0, 0, 0), n;
}
function H0(t, e, n) {
  const [r, o] = Nl(
    n == null ? void 0 : n.in,
    t,
    e
  ), a = Cg(r), i = Cg(o), s = +a - Tu(a), l = +i - Tu(i);
  return Math.round((s - l) / LI);
}
function WI(t, e) {
  const n = V0(t, e), r = _t(t, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), Wi(r);
}
function KI(t, e, n) {
  return Ar(t, e * 3, n);
}
function ih(t, e, n) {
  return Ar(t, e * 12, n);
}
function Eg(t, e) {
  const n = +qe(t) - +qe(e);
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function sh(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function $i(t) {
  return !(!sh(t) && typeof t != "number" || isNaN(+qe(t)));
}
function Og(t, e) {
  const n = qe(t, e == null ? void 0 : e.in);
  return Math.trunc(n.getMonth() / 3) + 1;
}
function jI(t, e, n) {
  const [r, o] = Nl(
    n == null ? void 0 : n.in,
    t,
    e
  );
  return r.getFullYear() - o.getFullYear();
}
function zI(t, e, n) {
  const [r, o] = Nl(
    n == null ? void 0 : n.in,
    t,
    e
  ), a = Eg(r, o), i = Math.abs(jI(r, o));
  r.setFullYear(1584), o.setFullYear(1584);
  const s = Eg(r, o) === -a, l = a * (i - +s);
  return l === 0 ? 0 : l;
}
function U0(t, e) {
  const [n, r] = Nl(t, e.start, e.end);
  return { start: n, end: r };
}
function W0(t, e) {
  const { start: n, end: r } = U0(e == null ? void 0 : e.in, t);
  let o = +n > +r;
  const a = o ? +n : +r, i = o ? r : n;
  i.setHours(0, 0, 0, 0);
  let s = 1;
  const l = [];
  for (; +i <= a; )
    l.push(_t(n, i)), i.setDate(i.getDate() + s), i.setHours(0, 0, 0, 0);
  return o ? l.reverse() : l;
}
function Pa(t, e) {
  const n = qe(t, e == null ? void 0 : e.in), r = n.getMonth(), o = r - r % 3;
  return n.setMonth(o, 1), n.setHours(0, 0, 0, 0), n;
}
function YI(t, e) {
  const { start: n, end: r } = U0(e == null ? void 0 : e.in, t);
  let o = +n > +r;
  const a = o ? +Pa(n) : +Pa(r);
  let i = Pa(o ? r : n), s = 1;
  const l = [];
  for (; +i <= a; )
    l.push(_t(n, i)), i = KI(i, s);
  return o ? l.reverse() : l;
}
function qI(t, e) {
  const n = qe(t, e == null ? void 0 : e.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function K0(t, e) {
  const n = qe(t, e == null ? void 0 : e.in), r = n.getFullYear();
  return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function ol(t, e) {
  const n = qe(t, e == null ? void 0 : e.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function j0(t, e) {
  var s, l, u, c;
  const n = ui(), r = (e == null ? void 0 : e.weekStartsOn) ?? ((l = (s = e == null ? void 0 : e.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((c = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) ?? 0, o = qe(t, e == null ? void 0 : e.in), a = o.getDay(), i = (a < r ? -7 : 0) + 6 - (a - r);
  return o.setDate(o.getDate() + i), o.setHours(23, 59, 59, 999), o;
}
function Tg(t, e) {
  const n = qe(t, e == null ? void 0 : e.in), r = n.getMonth(), o = r - r % 3 + 3;
  return n.setMonth(o, 0), n.setHours(23, 59, 59, 999), n;
}
const GI = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, JI = (t, e, n) => {
  let r;
  const o = GI[t];
  return typeof o == "string" ? r = o : e === 1 ? r = o.one : r = o.other.replace("{{count}}", e.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function wd(t) {
  return (e = {}) => {
    const n = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[n] || t.formats[t.defaultWidth];
  };
}
const XI = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, QI = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, ZI = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, eD = {
  date: wd({
    formats: XI,
    defaultWidth: "full"
  }),
  time: wd({
    formats: QI,
    defaultWidth: "full"
  }),
  dateTime: wd({
    formats: ZI,
    defaultWidth: "full"
  })
}, tD = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, nD = (t, e, n, r) => tD[t];
function _s(t) {
  return (e, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && t.formattingValues) {
      const i = t.defaultFormattingWidth || t.defaultWidth, s = n != null && n.width ? String(n.width) : i;
      o = t.formattingValues[s] || t.formattingValues[i];
    } else {
      const i = t.defaultWidth, s = n != null && n.width ? String(n.width) : t.defaultWidth;
      o = t.values[s] || t.values[i];
    }
    const a = t.argumentCallback ? t.argumentCallback(e) : e;
    return o[a];
  };
}
const rD = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, oD = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, aD = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, iD = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, sD = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, lD = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, uD = (t, e) => {
  const n = Number(t), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, cD = {
  ordinalNumber: uD,
  era: _s({
    values: rD,
    defaultWidth: "wide"
  }),
  quarter: _s({
    values: oD,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: _s({
    values: aD,
    defaultWidth: "wide"
  }),
  day: _s({
    values: iD,
    defaultWidth: "wide"
  }),
  dayPeriod: _s({
    values: sD,
    defaultWidth: "wide",
    formattingValues: lD,
    defaultFormattingWidth: "wide"
  })
};
function Cs(t) {
  return (e, n = {}) => {
    const r = n.width, o = r && t.matchPatterns[r] || t.matchPatterns[t.defaultMatchWidth], a = e.match(o);
    if (!a)
      return null;
    const i = a[0], s = r && t.parsePatterns[r] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(s) ? fD(s, (d) => d.test(i)) : (
      // [TODO] -- I challenge you to fix the type
      dD(s, (d) => d.test(i))
    );
    let u;
    u = t.valueCallback ? t.valueCallback(l) : l, u = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(u)
    ) : u;
    const c = e.slice(i.length);
    return { value: u, rest: c };
  };
}
function dD(t, e) {
  for (const n in t)
    if (Object.prototype.hasOwnProperty.call(t, n) && e(t[n]))
      return n;
}
function fD(t, e) {
  for (let n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function pD(t) {
  return (e, n = {}) => {
    const r = e.match(t.matchPattern);
    if (!r) return null;
    const o = r[0], a = e.match(t.parsePattern);
    if (!a) return null;
    let i = t.valueCallback ? t.valueCallback(a[0]) : a[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    const s = e.slice(o.length);
    return { value: i, rest: s };
  };
}
const hD = /^(\d+)(th|st|nd|rd)?/i, mD = /\d+/i, gD = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, vD = {
  any: [/^b/i, /^(a|c)/i]
}, yD = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, bD = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, kD = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, wD = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, _D = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, CD = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, ED = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, OD = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, TD = {
  ordinalNumber: pD({
    matchPattern: hD,
    parsePattern: mD,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: Cs({
    matchPatterns: gD,
    defaultMatchWidth: "wide",
    parsePatterns: vD,
    defaultParseWidth: "any"
  }),
  quarter: Cs({
    matchPatterns: yD,
    defaultMatchWidth: "wide",
    parsePatterns: bD,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: Cs({
    matchPatterns: kD,
    defaultMatchWidth: "wide",
    parsePatterns: wD,
    defaultParseWidth: "any"
  }),
  day: Cs({
    matchPatterns: _D,
    defaultMatchWidth: "wide",
    parsePatterns: CD,
    defaultParseWidth: "any"
  }),
  dayPeriod: Cs({
    matchPatterns: ED,
    defaultMatchWidth: "any",
    parsePatterns: OD,
    defaultParseWidth: "any"
  })
}, z0 = {
  code: "en-US",
  formatDistance: JI,
  formatLong: eD,
  formatRelative: nD,
  localize: cD,
  match: TD,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function SD(t, e) {
  const n = qe(t, e == null ? void 0 : e.in);
  return H0(n, ol(n)) + 1;
}
function lh(t, e) {
  const n = qe(t, e == null ? void 0 : e.in), r = +Wi(n) - +WI(n);
  return Math.round(r / L0) + 1;
}
function uh(t, e) {
  var c, d, f, h;
  const n = qe(t, e == null ? void 0 : e.in), r = n.getFullYear(), o = ui(), a = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((d = (c = e == null ? void 0 : e.locale) == null ? void 0 : c.options) == null ? void 0 : d.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((h = (f = o.locale) == null ? void 0 : f.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, i = _t((e == null ? void 0 : e.in) || t, 0);
  i.setFullYear(r + 1, 0, a), i.setHours(0, 0, 0, 0);
  const s = Nr(i, e), l = _t((e == null ? void 0 : e.in) || t, 0);
  l.setFullYear(r, 0, a), l.setHours(0, 0, 0, 0);
  const u = Nr(l, e);
  return +n >= +s ? r + 1 : +n >= +u ? r : r - 1;
}
function xD(t, e) {
  var s, l, u, c;
  const n = ui(), r = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((l = (s = e == null ? void 0 : e.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((c = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : c.firstWeekContainsDate) ?? 1, o = uh(t, e), a = _t((e == null ? void 0 : e.in) || t, 0);
  return a.setFullYear(o, 0, r), a.setHours(0, 0, 0, 0), Nr(a, e);
}
function ch(t, e) {
  const n = qe(t, e == null ? void 0 : e.in), r = +Nr(n, e) - +xD(n, e);
  return Math.round(r / L0) + 1;
}
function wt(t, e) {
  const n = t < 0 ? "-" : "", r = Math.abs(t).toString().padStart(e, "0");
  return n + r;
}
const Ho = {
  // Year
  y(t, e) {
    const n = t.getFullYear(), r = n > 0 ? n : 1 - n;
    return wt(e === "yy" ? r % 100 : r, e.length);
  },
  // Month
  M(t, e) {
    const n = t.getMonth();
    return e === "M" ? String(n + 1) : wt(n + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return wt(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const n = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return wt(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return wt(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return wt(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return wt(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const n = e.length, r = t.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return wt(o, e.length);
  }
}, mi = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Sg = {
  // Era
  G: function(t, e, n) {
    const r = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, n) {
    if (e === "yo") {
      const r = t.getFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return Ho.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, n, r) {
    const o = uh(t, r), a = o > 0 ? o : 1 - o;
    if (e === "YY") {
      const i = a % 100;
      return wt(i, 2);
    }
    return e === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : wt(a, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const n = V0(t);
    return wt(n, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const n = t.getFullYear();
    return wt(n, e.length);
  },
  // Quarter
  Q: function(t, e, n) {
    const r = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return wt(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, n) {
    const r = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return wt(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, n) {
    const r = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return Ho.M(t, e);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, n) {
    const r = t.getMonth();
    switch (e) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return wt(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, n, r) {
    const o = ch(t, r);
    return e === "wo" ? n.ordinalNumber(o, { unit: "week" }) : wt(o, e.length);
  },
  // ISO week of year
  I: function(t, e, n) {
    const r = lh(t);
    return e === "Io" ? n.ordinalNumber(r, { unit: "week" }) : wt(r, e.length);
  },
  // Day of the month
  d: function(t, e, n) {
    return e === "do" ? n.ordinalNumber(t.getDate(), { unit: "date" }) : Ho.d(t, e);
  },
  // Day of year
  D: function(t, e, n) {
    const r = SD(t);
    return e === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : wt(r, e.length);
  },
  // Day of week
  E: function(t, e, n) {
    const r = t.getDay();
    switch (e) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, n, r) {
    const o = t.getDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(a);
      // Padded numerical value
      case "ee":
        return wt(a, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(a, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, n, r) {
    const o = t.getDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (same as in `e`)
      case "c":
        return String(a);
      // Padded numerical value
      case "cc":
        return wt(a, e.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, n) {
    const r = t.getDay(), o = r === 0 ? 7 : r;
    switch (e) {
      // 2
      case "i":
        return String(o);
      // 02
      case "ii":
        return wt(o, e.length);
      // 2nd
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, n) {
    const o = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, n) {
    const r = t.getHours();
    let o;
    switch (r === 12 ? o = mi.noon : r === 0 ? o = mi.midnight : o = r / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, n) {
    const r = t.getHours();
    let o;
    switch (r >= 17 ? o = mi.evening : r >= 12 ? o = mi.afternoon : r >= 4 ? o = mi.morning : o = mi.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, n) {
    if (e === "ho") {
      let r = t.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return Ho.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, n) {
    return e === "Ho" ? n.ordinalNumber(t.getHours(), { unit: "hour" }) : Ho.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, n) {
    const r = t.getHours() % 12;
    return e === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : wt(r, e.length);
  },
  // Hour [1-24]
  k: function(t, e, n) {
    let r = t.getHours();
    return r === 0 && (r = 24), e === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : wt(r, e.length);
  },
  // Minute
  m: function(t, e, n) {
    return e === "mo" ? n.ordinalNumber(t.getMinutes(), { unit: "minute" }) : Ho.m(t, e);
  },
  // Second
  s: function(t, e, n) {
    return e === "so" ? n.ordinalNumber(t.getSeconds(), { unit: "second" }) : Ho.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return Ho.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n) {
    const r = t.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (e) {
      // Hours and optional minutes
      case "X":
        return Ag(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Aa(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return Aa(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      // Hours and optional minutes
      case "x":
        return Ag(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Aa(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return Aa(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + xg(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + Aa(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + xg(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + Aa(r, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, n) {
    const r = Math.trunc(+t / 1e3);
    return wt(r, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, n) {
    return wt(+t, e.length);
  }
};
function xg(t, e = "") {
  const n = t > 0 ? "-" : "+", r = Math.abs(t), o = Math.trunc(r / 60), a = r % 60;
  return a === 0 ? n + String(o) : n + String(o) + e + wt(a, 2);
}
function Ag(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + wt(Math.abs(t) / 60, 2) : Aa(t, e);
}
function Aa(t, e = "") {
  const n = t > 0 ? "-" : "+", r = Math.abs(t), o = wt(Math.trunc(r / 60), 2), a = wt(r % 60, 2);
  return n + o + e + a;
}
const Mg = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, Y0 = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, AD = (t, e) => {
  const n = t.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
  if (!o)
    return Mg(t, e);
  let a;
  switch (r) {
    case "P":
      a = e.dateTime({ width: "short" });
      break;
    case "PP":
      a = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      a = e.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", Mg(r, e)).replace("{{time}}", Y0(o, e));
}, Bf = {
  p: Y0,
  P: AD
}, MD = /^D+$/, ID = /^Y+$/, DD = ["D", "DD", "YY", "YYYY"];
function q0(t) {
  return MD.test(t);
}
function G0(t) {
  return ID.test(t);
}
function Ff(t, e, n) {
  const r = PD(t, e, n);
  if (console.warn(r), DD.includes(t)) throw new RangeError(r);
}
function PD(t, e, n) {
  const r = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const ND = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, $D = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, RD = /^'([^]*?)'?$/, LD = /''/g, BD = /[a-zA-Z]/;
function Mr(t, e, n) {
  var c, d, f, h, m, g, y, b;
  const r = ui(), o = (n == null ? void 0 : n.locale) ?? r.locale ?? z0, a = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((d = (c = n == null ? void 0 : n.locale) == null ? void 0 : c.options) == null ? void 0 : d.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((h = (f = r.locale) == null ? void 0 : f.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, i = (n == null ? void 0 : n.weekStartsOn) ?? ((g = (m = n == null ? void 0 : n.locale) == null ? void 0 : m.options) == null ? void 0 : g.weekStartsOn) ?? r.weekStartsOn ?? ((b = (y = r.locale) == null ? void 0 : y.options) == null ? void 0 : b.weekStartsOn) ?? 0, s = qe(t, n == null ? void 0 : n.in);
  if (!$i(s))
    throw new RangeError("Invalid time value");
  let l = e.match($D).map((C) => {
    const k = C[0];
    if (k === "p" || k === "P") {
      const v = Bf[k];
      return v(C, o.formatLong);
    }
    return C;
  }).join("").match(ND).map((C) => {
    if (C === "''")
      return { isToken: !1, value: "'" };
    const k = C[0];
    if (k === "'")
      return { isToken: !1, value: FD(C) };
    if (Sg[k])
      return { isToken: !0, value: C };
    if (k.match(BD))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + k + "`"
      );
    return { isToken: !1, value: C };
  });
  o.localize.preprocessor && (l = o.localize.preprocessor(s, l));
  const u = {
    firstWeekContainsDate: a,
    weekStartsOn: i,
    locale: o
  };
  return l.map((C) => {
    if (!C.isToken) return C.value;
    const k = C.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && G0(k) || !(n != null && n.useAdditionalDayOfYearTokens) && q0(k)) && Ff(k, e, String(t));
    const v = Sg[k[0]];
    return v(s, k, o.localize, u);
  }).join("");
}
function FD(t) {
  const e = t.match(RD);
  return e ? e[1].replace(LD, "'") : t;
}
function VD(t, e) {
  return qe(t, e == null ? void 0 : e.in).getDay();
}
function HD(t, e) {
  const n = qe(t, e == null ? void 0 : e.in), r = n.getFullYear(), o = n.getMonth(), a = _t(n, 0);
  return a.setFullYear(r, o + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
function UD() {
  return Object.assign({}, ui());
}
function $o(t, e) {
  return qe(t, e == null ? void 0 : e.in).getHours();
}
function WD(t, e) {
  const n = qe(t, e == null ? void 0 : e.in).getDay();
  return n === 0 ? 7 : n;
}
function fa(t, e) {
  return qe(t, e == null ? void 0 : e.in).getMinutes();
}
function ft(t, e) {
  return qe(t, e == null ? void 0 : e.in).getMonth();
}
function Ki(t) {
  return qe(t).getSeconds();
}
function Qe(t, e) {
  return qe(t, e == null ? void 0 : e.in).getFullYear();
}
function ji(t, e) {
  return +qe(t) > +qe(e);
}
function al(t, e) {
  return +qe(t) < +qe(e);
}
function Mi(t, e) {
  return +qe(t) == +qe(e);
}
function KD(t, e) {
  const n = jD(e) ? new e(0) : _t(e, 0);
  return n.setFullYear(t.getFullYear(), t.getMonth(), t.getDate()), n.setHours(
    t.getHours(),
    t.getMinutes(),
    t.getSeconds(),
    t.getMilliseconds()
  ), n;
}
function jD(t) {
  var e;
  return typeof t == "function" && ((e = t.prototype) == null ? void 0 : e.constructor) === t;
}
const zD = 10;
class J0 {
  constructor() {
    $e(this, "subPriority", 0);
  }
  validate(e, n) {
    return !0;
  }
}
class YD extends J0 {
  constructor(e, n, r, o, a) {
    super(), this.value = e, this.validateValue = n, this.setValue = r, this.priority = o, a && (this.subPriority = a);
  }
  validate(e, n) {
    return this.validateValue(e, this.value, n);
  }
  set(e, n, r) {
    return this.setValue(e, n, this.value, r);
  }
}
class qD extends J0 {
  constructor(n, r) {
    super();
    $e(this, "priority", zD);
    $e(this, "subPriority", -1);
    this.context = n || ((o) => _t(r, o));
  }
  set(n, r) {
    return r.timestampIsSet ? n : _t(n, KD(n, this.context));
  }
}
class kt {
  run(e, n, r, o) {
    const a = this.parse(e, n, r, o);
    return a ? {
      setter: new YD(
        a.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: a.rest
    } : null;
  }
  validate(e, n, r) {
    return !0;
  }
}
class GD extends kt {
  constructor() {
    super(...arguments);
    $e(this, "priority", 140);
    $e(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return o.era(n, { width: "abbreviated" }) || o.era(n, { width: "narrow" });
      // A, B
      case "GGGGG":
        return o.era(n, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return o.era(n, { width: "wide" }) || o.era(n, { width: "abbreviated" }) || o.era(n, { width: "narrow" });
    }
  }
  set(n, r, o) {
    return r.era = o, n.setFullYear(o, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
const Yt = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, jr = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function qt(t, e) {
  return t && {
    value: e(t.value),
    rest: t.rest
  };
}
function Rt(t, e) {
  const n = e.match(t);
  return n ? {
    value: parseInt(n[0], 10),
    rest: e.slice(n[0].length)
  } : null;
}
function zr(t, e) {
  const n = e.match(t);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: e.slice(1)
    };
  const r = n[1] === "+" ? 1 : -1, o = n[2] ? parseInt(n[2], 10) : 0, a = n[3] ? parseInt(n[3], 10) : 0, i = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (o * B0 + a * BI + i * FI),
    rest: e.slice(n[0].length)
  };
}
function X0(t) {
  return Rt(Yt.anyDigitsSigned, t);
}
function Ut(t, e) {
  switch (t) {
    case 1:
      return Rt(Yt.singleDigit, e);
    case 2:
      return Rt(Yt.twoDigits, e);
    case 3:
      return Rt(Yt.threeDigits, e);
    case 4:
      return Rt(Yt.fourDigits, e);
    default:
      return Rt(new RegExp("^\\d{1," + t + "}"), e);
  }
}
function Su(t, e) {
  switch (t) {
    case 1:
      return Rt(Yt.singleDigitSigned, e);
    case 2:
      return Rt(Yt.twoDigitsSigned, e);
    case 3:
      return Rt(Yt.threeDigitsSigned, e);
    case 4:
      return Rt(Yt.fourDigitsSigned, e);
    default:
      return Rt(new RegExp("^-?\\d{1," + t + "}"), e);
  }
}
function dh(t) {
  switch (t) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Q0(t, e) {
  const n = e > 0, r = n ? e : 1 - e;
  let o;
  if (r <= 50)
    o = t || 100;
  else {
    const a = r + 50, i = Math.trunc(a / 100) * 100, s = t >= a % 100;
    o = t + i - (s ? 100 : 0);
  }
  return n ? o : 1 - o;
}
function Z0(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
class JD extends kt {
  constructor() {
    super(...arguments);
    $e(this, "priority", 130);
    $e(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, r, o) {
    const a = (i) => ({
      year: i,
      isTwoDigitYear: r === "yy"
    });
    switch (r) {
      case "y":
        return qt(Ut(4, n), a);
      case "yo":
        return qt(
          o.ordinalNumber(n, {
            unit: "year"
          }),
          a
        );
      default:
        return qt(Ut(r.length, n), a);
    }
  }
  validate(n, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(n, r, o) {
    const a = n.getFullYear();
    if (o.isTwoDigitYear) {
      const s = Q0(
        o.year,
        a
      );
      return n.setFullYear(s, 0, 1), n.setHours(0, 0, 0, 0), n;
    }
    const i = !("era" in r) || r.era === 1 ? o.year : 1 - o.year;
    return n.setFullYear(i, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class XD extends kt {
  constructor() {
    super(...arguments);
    $e(this, "priority", 130);
    $e(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    const a = (i) => ({
      year: i,
      isTwoDigitYear: r === "YY"
    });
    switch (r) {
      case "Y":
        return qt(Ut(4, n), a);
      case "Yo":
        return qt(
          o.ordinalNumber(n, {
            unit: "year"
          }),
          a
        );
      default:
        return qt(Ut(r.length, n), a);
    }
  }
  validate(n, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(n, r, o, a) {
    const i = uh(n, a);
    if (o.isTwoDigitYear) {
      const l = Q0(
        o.year,
        i
      );
      return n.setFullYear(
        l,
        0,
        a.firstWeekContainsDate
      ), n.setHours(0, 0, 0, 0), Nr(n, a);
    }
    const s = !("era" in r) || r.era === 1 ? o.year : 1 - o.year;
    return n.setFullYear(s, 0, a.firstWeekContainsDate), n.setHours(0, 0, 0, 0), Nr(n, a);
  }
}
class QD extends kt {
  constructor() {
    super(...arguments);
    $e(this, "priority", 130);
    $e(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r) {
    return Su(r === "R" ? 4 : r.length, n);
  }
  set(n, r, o) {
    const a = _t(n, 0);
    return a.setFullYear(o, 0, 4), a.setHours(0, 0, 0, 0), Wi(a);
  }
}
class ZD extends kt {
  constructor() {
    super(...arguments);
    $e(this, "priority", 130);
    $e(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, r) {
    return Su(r === "u" ? 4 : r.length, n);
  }
  set(n, r, o) {
    return n.setFullYear(o, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class eP extends kt {
  constructor() {
    super(...arguments);
    $e(this, "priority", 120);
    $e(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return Ut(r.length, n);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return o.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return o.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return o.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return o.quarter(n, {
          width: "wide",
          context: "formatting"
        }) || o.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 4;
  }
  set(n, r, o) {
    return n.setMonth((o - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class tP extends kt {
  constructor() {
    super(...arguments);
    $e(this, "priority", 120);
    $e(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return Ut(r.length, n);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return o.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return o.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return o.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return o.quarter(n, {
          width: "wide",
          context: "standalone"
        }) || o.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 4;
  }
  set(n, r, o) {
    return n.setMonth((o - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class nP extends kt {
  constructor() {
    super(...arguments);
    $e(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    $e(this, "priority", 110);
  }
  parse(n, r, o) {
    const a = (i) => i - 1;
    switch (r) {
      // 1, 2, ..., 12
      case "M":
        return qt(
          Rt(Yt.month, n),
          a
        );
      // 01, 02, ..., 12
      case "MM":
        return qt(Ut(2, n), a);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return qt(
          o.ordinalNumber(n, {
            unit: "month"
          }),
          a
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return o.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(n, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return o.month(n, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return o.month(n, { width: "wide", context: "formatting" }) || o.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 11;
  }
  set(n, r, o) {
    return n.setMonth(o, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class rP extends kt {
  constructor() {
    super(...arguments);
    $e(this, "priority", 110);
    $e(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    const a = (i) => i - 1;
    switch (r) {
      // 1, 2, ..., 12
      case "L":
        return qt(
          Rt(Yt.month, n),
          a
        );
      // 01, 02, ..., 12
      case "LL":
        return qt(Ut(2, n), a);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return qt(
          o.ordinalNumber(n, {
            unit: "month"
          }),
          a
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return o.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(n, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return o.month(n, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return o.month(n, { width: "wide", context: "standalone" }) || o.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 11;
  }
  set(n, r, o) {
    return n.setMonth(o, 1), n.setHours(0, 0, 0, 0), n;
  }
}
function oP(t, e, n) {
  const r = qe(t, n == null ? void 0 : n.in), o = ch(r, n) - e;
  return r.setDate(r.getDate() - o * 7), qe(r, n == null ? void 0 : n.in);
}
class aP extends kt {
  constructor() {
    super(...arguments);
    $e(this, "priority", 100);
    $e(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "w":
        return Rt(Yt.week, n);
      case "wo":
        return o.ordinalNumber(n, { unit: "week" });
      default:
        return Ut(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 53;
  }
  set(n, r, o, a) {
    return Nr(oP(n, o, a), a);
  }
}
function iP(t, e, n) {
  const r = qe(t, n == null ? void 0 : n.in), o = lh(r, n) - e;
  return r.setDate(r.getDate() - o * 7), r;
}
class sP extends kt {
  constructor() {
    super(...arguments);
    $e(this, "priority", 100);
    $e(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "I":
        return Rt(Yt.week, n);
      case "Io":
        return o.ordinalNumber(n, { unit: "week" });
      default:
        return Ut(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 53;
  }
  set(n, r, o) {
    return Wi(iP(n, o));
  }
}
const lP = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], uP = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class cP extends kt {
  constructor() {
    super(...arguments);
    $e(this, "priority", 90);
    $e(this, "subPriority", 1);
    $e(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "d":
        return Rt(Yt.date, n);
      case "do":
        return o.ordinalNumber(n, { unit: "date" });
      default:
        return Ut(r.length, n);
    }
  }
  validate(n, r) {
    const o = n.getFullYear(), a = Z0(o), i = n.getMonth();
    return a ? r >= 1 && r <= uP[i] : r >= 1 && r <= lP[i];
  }
  set(n, r, o) {
    return n.setDate(o), n.setHours(0, 0, 0, 0), n;
  }
}
class dP extends kt {
  constructor() {
    super(...arguments);
    $e(this, "priority", 90);
    $e(this, "subpriority", 1);
    $e(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "D":
      case "DD":
        return Rt(Yt.dayOfYear, n);
      case "Do":
        return o.ordinalNumber(n, { unit: "date" });
      default:
        return Ut(r.length, n);
    }
  }
  validate(n, r) {
    const o = n.getFullYear();
    return Z0(o) ? r >= 1 && r <= 366 : r >= 1 && r <= 365;
  }
  set(n, r, o) {
    return n.setMonth(0, o), n.setHours(0, 0, 0, 0), n;
  }
}
function fh(t, e, n) {
  var d, f, h, m;
  const r = ui(), o = (n == null ? void 0 : n.weekStartsOn) ?? ((f = (d = n == null ? void 0 : n.locale) == null ? void 0 : d.options) == null ? void 0 : f.weekStartsOn) ?? r.weekStartsOn ?? ((m = (h = r.locale) == null ? void 0 : h.options) == null ? void 0 : m.weekStartsOn) ?? 0, a = qe(t, n == null ? void 0 : n.in), i = a.getDay(), l = (e % 7 + 7) % 7, u = 7 - o, c = e < 0 || e > 6 ? e - (i + u) % 7 : (l + u) % 7 - (i + u) % 7;
  return Or(a, c, n);
}
class fP extends kt {
  constructor() {
    super(...arguments);
    $e(this, "priority", 90);
    $e(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return o.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return o.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
      // Tuesday
      case "EEEE":
      default:
        return o.day(n, { width: "wide", context: "formatting" }) || o.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 6;
  }
  set(n, r, o, a) {
    return n = fh(n, o, a), n.setHours(0, 0, 0, 0), n;
  }
}
class pP extends kt {
  constructor() {
    super(...arguments);
    $e(this, "priority", 90);
    $e(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o, a) {
    const i = (s) => {
      const l = Math.floor((s - 1) / 7) * 7;
      return (s + a.weekStartsOn + 6) % 7 + l;
    };
    switch (r) {
      // 3
      case "e":
      case "ee":
        return qt(Ut(r.length, n), i);
      // 3rd
      case "eo":
        return qt(
          o.ordinalNumber(n, {
            unit: "day"
          }),
          i
        );
      // Tue
      case "eee":
        return o.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return o.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
      // Tuesday
      case "eeee":
      default:
        return o.day(n, { width: "wide", context: "formatting" }) || o.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 6;
  }
  set(n, r, o, a) {
    return n = fh(n, o, a), n.setHours(0, 0, 0, 0), n;
  }
}
class hP extends kt {
  constructor() {
    super(...arguments);
    $e(this, "priority", 90);
    $e(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(n, r, o, a) {
    const i = (s) => {
      const l = Math.floor((s - 1) / 7) * 7;
      return (s + a.weekStartsOn + 6) % 7 + l;
    };
    switch (r) {
      // 3
      case "c":
      case "cc":
        return qt(Ut(r.length, n), i);
      // 3rd
      case "co":
        return qt(
          o.ordinalNumber(n, {
            unit: "day"
          }),
          i
        );
      // Tue
      case "ccc":
        return o.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(n, { width: "short", context: "standalone" }) || o.day(n, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return o.day(n, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return o.day(n, { width: "short", context: "standalone" }) || o.day(n, { width: "narrow", context: "standalone" });
      // Tuesday
      case "cccc":
      default:
        return o.day(n, { width: "wide", context: "standalone" }) || o.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(n, { width: "short", context: "standalone" }) || o.day(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 6;
  }
  set(n, r, o, a) {
    return n = fh(n, o, a), n.setHours(0, 0, 0, 0), n;
  }
}
function mP(t, e, n) {
  const r = qe(t, n == null ? void 0 : n.in), o = WD(r, n), a = e - o;
  return Or(r, a, n);
}
class gP extends kt {
  constructor() {
    super(...arguments);
    $e(this, "priority", 90);
    $e(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    const a = (i) => i === 0 ? 7 : i;
    switch (r) {
      // 2
      case "i":
      case "ii":
        return Ut(r.length, n);
      // 2nd
      case "io":
        return o.ordinalNumber(n, { unit: "day" });
      // Tue
      case "iii":
        return qt(
          o.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      // T
      case "iiiii":
        return qt(
          o.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      // Tu
      case "iiiiii":
        return qt(
          o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      // Tuesday
      case "iiii":
      default:
        return qt(
          o.day(n, {
            width: "wide",
            context: "formatting"
          }) || o.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 7;
  }
  set(n, r, o) {
    return n = mP(n, o), n.setHours(0, 0, 0, 0), n;
  }
}
class vP extends kt {
  constructor() {
    super(...arguments);
    $e(this, "priority", 80);
    $e(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "a":
      case "aa":
      case "aaa":
        return o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return o.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, r, o) {
    return n.setHours(dh(o), 0, 0, 0), n;
  }
}
class yP extends kt {
  constructor() {
    super(...arguments);
    $e(this, "priority", 80);
    $e(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "b":
      case "bb":
      case "bbb":
        return o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return o.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, r, o) {
    return n.setHours(dh(o), 0, 0, 0), n;
  }
}
class bP extends kt {
  constructor() {
    super(...arguments);
    $e(this, "priority", 80);
    $e(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "B":
      case "BB":
      case "BBB":
        return o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return o.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, r, o) {
    return n.setHours(dh(o), 0, 0, 0), n;
  }
}
class kP extends kt {
  constructor() {
    super(...arguments);
    $e(this, "priority", 70);
    $e(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "h":
        return Rt(Yt.hour12h, n);
      case "ho":
        return o.ordinalNumber(n, { unit: "hour" });
      default:
        return Ut(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 12;
  }
  set(n, r, o) {
    const a = n.getHours() >= 12;
    return a && o < 12 ? n.setHours(o + 12, 0, 0, 0) : !a && o === 12 ? n.setHours(0, 0, 0, 0) : n.setHours(o, 0, 0, 0), n;
  }
}
class wP extends kt {
  constructor() {
    super(...arguments);
    $e(this, "priority", 70);
    $e(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "H":
        return Rt(Yt.hour23h, n);
      case "Ho":
        return o.ordinalNumber(n, { unit: "hour" });
      default:
        return Ut(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 23;
  }
  set(n, r, o) {
    return n.setHours(o, 0, 0, 0), n;
  }
}
class _P extends kt {
  constructor() {
    super(...arguments);
    $e(this, "priority", 70);
    $e(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "K":
        return Rt(Yt.hour11h, n);
      case "Ko":
        return o.ordinalNumber(n, { unit: "hour" });
      default:
        return Ut(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 11;
  }
  set(n, r, o) {
    return n.getHours() >= 12 && o < 12 ? n.setHours(o + 12, 0, 0, 0) : n.setHours(o, 0, 0, 0), n;
  }
}
class CP extends kt {
  constructor() {
    super(...arguments);
    $e(this, "priority", 70);
    $e(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "k":
        return Rt(Yt.hour24h, n);
      case "ko":
        return o.ordinalNumber(n, { unit: "hour" });
      default:
        return Ut(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 24;
  }
  set(n, r, o) {
    const a = o <= 24 ? o % 24 : o;
    return n.setHours(a, 0, 0, 0), n;
  }
}
class EP extends kt {
  constructor() {
    super(...arguments);
    $e(this, "priority", 60);
    $e(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "m":
        return Rt(Yt.minute, n);
      case "mo":
        return o.ordinalNumber(n, { unit: "minute" });
      default:
        return Ut(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 59;
  }
  set(n, r, o) {
    return n.setMinutes(o, 0, 0), n;
  }
}
class OP extends kt {
  constructor() {
    super(...arguments);
    $e(this, "priority", 50);
    $e(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "s":
        return Rt(Yt.second, n);
      case "so":
        return o.ordinalNumber(n, { unit: "second" });
      default:
        return Ut(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 59;
  }
  set(n, r, o) {
    return n.setSeconds(o, 0), n;
  }
}
class TP extends kt {
  constructor() {
    super(...arguments);
    $e(this, "priority", 30);
    $e(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, r) {
    const o = (a) => Math.trunc(a * Math.pow(10, -r.length + 3));
    return qt(Ut(r.length, n), o);
  }
  set(n, r, o) {
    return n.setMilliseconds(o), n;
  }
}
class SP extends kt {
  constructor() {
    super(...arguments);
    $e(this, "priority", 10);
    $e(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(n, r) {
    switch (r) {
      case "X":
        return zr(
          jr.basicOptionalMinutes,
          n
        );
      case "XX":
        return zr(jr.basic, n);
      case "XXXX":
        return zr(
          jr.basicOptionalSeconds,
          n
        );
      case "XXXXX":
        return zr(
          jr.extendedOptionalSeconds,
          n
        );
      case "XXX":
      default:
        return zr(jr.extended, n);
    }
  }
  set(n, r, o) {
    return r.timestampIsSet ? n : _t(
      n,
      n.getTime() - Tu(n) - o
    );
  }
}
class xP extends kt {
  constructor() {
    super(...arguments);
    $e(this, "priority", 10);
    $e(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(n, r) {
    switch (r) {
      case "x":
        return zr(
          jr.basicOptionalMinutes,
          n
        );
      case "xx":
        return zr(jr.basic, n);
      case "xxxx":
        return zr(
          jr.basicOptionalSeconds,
          n
        );
      case "xxxxx":
        return zr(
          jr.extendedOptionalSeconds,
          n
        );
      case "xxx":
      default:
        return zr(jr.extended, n);
    }
  }
  set(n, r, o) {
    return r.timestampIsSet ? n : _t(
      n,
      n.getTime() - Tu(n) - o
    );
  }
}
class AP extends kt {
  constructor() {
    super(...arguments);
    $e(this, "priority", 40);
    $e(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return X0(n);
  }
  set(n, r, o) {
    return [_t(n, o * 1e3), { timestampIsSet: !0 }];
  }
}
class MP extends kt {
  constructor() {
    super(...arguments);
    $e(this, "priority", 20);
    $e(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return X0(n);
  }
  set(n, r, o) {
    return [_t(n, o), { timestampIsSet: !0 }];
  }
}
const IP = {
  G: new GD(),
  y: new JD(),
  Y: new XD(),
  R: new QD(),
  u: new ZD(),
  Q: new eP(),
  q: new tP(),
  M: new nP(),
  L: new rP(),
  w: new aP(),
  I: new sP(),
  d: new cP(),
  D: new dP(),
  E: new fP(),
  e: new pP(),
  c: new hP(),
  i: new gP(),
  a: new vP(),
  b: new yP(),
  B: new bP(),
  h: new kP(),
  H: new wP(),
  K: new _P(),
  k: new CP(),
  m: new EP(),
  s: new OP(),
  S: new TP(),
  X: new SP(),
  x: new xP(),
  t: new AP(),
  T: new MP()
}, DP = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, PP = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, NP = /^'([^]*?)'?$/, $P = /''/g, RP = /\S/, LP = /[a-zA-Z]/;
function La(t, e, n, r) {
  var y, b, C, k, v, E, _, T;
  const o = () => _t((r == null ? void 0 : r.in) || n, NaN), a = UD(), i = (r == null ? void 0 : r.locale) ?? a.locale ?? z0, s = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((b = (y = r == null ? void 0 : r.locale) == null ? void 0 : y.options) == null ? void 0 : b.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((k = (C = a.locale) == null ? void 0 : C.options) == null ? void 0 : k.firstWeekContainsDate) ?? 1, l = (r == null ? void 0 : r.weekStartsOn) ?? ((E = (v = r == null ? void 0 : r.locale) == null ? void 0 : v.options) == null ? void 0 : E.weekStartsOn) ?? a.weekStartsOn ?? ((T = (_ = a.locale) == null ? void 0 : _.options) == null ? void 0 : T.weekStartsOn) ?? 0;
  if (!e)
    return t ? o() : qe(n, r == null ? void 0 : r.in);
  const u = {
    firstWeekContainsDate: s,
    weekStartsOn: l,
    locale: i
  }, c = [new qD(r == null ? void 0 : r.in, n)], d = e.match(PP).map((M) => {
    const O = M[0];
    if (O in Bf) {
      const R = Bf[O];
      return R(M, i.formatLong);
    }
    return M;
  }).join("").match(DP), f = [];
  for (let M of d) {
    !(r != null && r.useAdditionalWeekYearTokens) && G0(M) && Ff(M, e, t), !(r != null && r.useAdditionalDayOfYearTokens) && q0(M) && Ff(M, e, t);
    const O = M[0], R = IP[O];
    if (R) {
      const { incompatibleTokens: N } = R;
      if (Array.isArray(N)) {
        const te = f.find(
          (H) => N.includes(H.token) || H.token === O
        );
        if (te)
          throw new RangeError(
            `The format string mustn't contain \`${te.fullToken}\` and \`${M}\` at the same time`
          );
      } else if (R.incompatibleTokens === "*" && f.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${M}\` and any other token at the same time`
        );
      f.push({ token: O, fullToken: M });
      const z = R.run(
        t,
        M,
        i.match,
        u
      );
      if (!z)
        return o();
      c.push(z.setter), t = z.rest;
    } else {
      if (O.match(LP))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + O + "`"
        );
      if (M === "''" ? M = "'" : O === "'" && (M = BP(M)), t.indexOf(M) === 0)
        t = t.slice(M.length);
      else
        return o();
    }
  }
  if (t.length > 0 && RP.test(t))
    return o();
  const h = c.map((M) => M.priority).sort((M, O) => O - M).filter((M, O, R) => R.indexOf(M) === O).map(
    (M) => c.filter((O) => O.priority === M).sort((O, R) => R.subPriority - O.subPriority)
  ).map((M) => M[0]);
  let m = qe(n, r == null ? void 0 : r.in);
  if (isNaN(+m)) return o();
  const g = {};
  for (const M of h) {
    if (!M.validate(m, u))
      return o();
    const O = M.set(m, g, u);
    Array.isArray(O) ? (m = O[0], Object.assign(g, O[1])) : m = O;
  }
  return m;
}
function BP(t) {
  return t.match(NP)[1].replace($P, "'");
}
function _d(t, e, n) {
  return $i(La(t, e, /* @__PURE__ */ new Date(), n));
}
function Ig(t, e, n) {
  const [r, o] = Nl(
    n == null ? void 0 : n.in,
    t,
    e
  );
  return +Pa(r) == +Pa(o);
}
function FP(t, e, n) {
  return Or(t, -e, n);
}
function ek(t, e, n) {
  const r = qe(t, n == null ? void 0 : n.in), o = r.getFullYear(), a = r.getDate(), i = _t(t, 0);
  i.setFullYear(o, e, 15), i.setHours(0, 0, 0, 0);
  const s = HD(i);
  return r.setMonth(e, Math.min(a, s)), r;
}
function Tt(t, e, n) {
  let r = qe(t, n == null ? void 0 : n.in);
  return isNaN(+r) ? _t(t, NaN) : (e.year != null && r.setFullYear(e.year), e.month != null && (r = ek(r, e.month)), e.date != null && r.setDate(e.date), e.hours != null && r.setHours(e.hours), e.minutes != null && r.setMinutes(e.minutes), e.seconds != null && r.setSeconds(e.seconds), e.milliseconds != null && r.setMilliseconds(e.milliseconds), r);
}
function VP(t, e, n) {
  const r = qe(t, n == null ? void 0 : n.in);
  return r.setHours(e), r;
}
function tk(t, e, n) {
  const r = qe(t, n == null ? void 0 : n.in);
  return r.setMilliseconds(e), r;
}
function HP(t, e, n) {
  const r = qe(t, n == null ? void 0 : n.in);
  return r.setMinutes(e), r;
}
function nk(t, e, n) {
  const r = qe(t, n == null ? void 0 : n.in);
  return r.setSeconds(e), r;
}
function Gr(t, e, n) {
  const r = qe(t, n == null ? void 0 : n.in);
  return isNaN(+r) ? _t(t, NaN) : (r.setFullYear(e), r);
}
function zi(t, e, n) {
  return Ar(t, -e, n);
}
function UP(t, e, n) {
  const {
    years: r = 0,
    months: o = 0,
    weeks: a = 0,
    days: i = 0,
    hours: s = 0,
    minutes: l = 0,
    seconds: u = 0
  } = e, c = zi(t, o + r * 12, n), d = FP(c, i + a * 7, n), f = l + s * 60, m = (u + f * 60) * 1e3;
  return _t(t, +d - m);
}
function rk(t, e, n) {
  return ih(t, -e, n);
}
function vs() {
  const t = _l();
  return w(), K(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img",
      ...t
    },
    [
      be("path", {
        d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
      }),
      be("path", {
        d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      be("path", {
        d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      be("path", {
        d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
      })
    ]
  );
}
vs.compatConfig = {
  MODE: 3
};
function ok() {
  return w(), K(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      be("path", {
        d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
      }),
      be("path", {
        d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
ok.compatConfig = {
  MODE: 3
};
function ph() {
  return w(), K(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      be("path", {
        d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
ph.compatConfig = {
  MODE: 3
};
function hh() {
  return w(), K(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      be("path", {
        d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
      })
    ]
  );
}
hh.compatConfig = {
  MODE: 3
};
function mh() {
  return w(), K(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      be("path", {
        d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
      }),
      be("path", {
        d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      })
    ]
  );
}
mh.compatConfig = {
  MODE: 3
};
function gh() {
  return w(), K(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      be("path", {
        d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
gh.compatConfig = {
  MODE: 3
};
function vh() {
  return w(), K(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      be("path", {
        d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
vh.compatConfig = {
  MODE: 3
};
const jn = (t, e) => e ? new Date(t.toLocaleString("en-US", { timeZone: e })) : new Date(t), yh = (t, e, n) => Vf(t, e, n) || we(), WP = (t, e, n) => {
  const r = e.dateInTz ? jn(new Date(t), e.dateInTz) : we(t);
  return n ? $n(r, !0) : r;
}, Vf = (t, e, n) => {
  if (!t) return null;
  const r = n ? $n(we(t), !0) : we(t);
  return e ? e.exactMatch ? WP(t, e, n) : jn(r, e.timezone) : r;
}, KP = (t, e) => {
  if (!t) return 0;
  const n = /* @__PURE__ */ new Date(), r = new Date(n.toLocaleString("en-US", { timeZone: "UTC" })), o = new Date(n.toLocaleString("en-US", { timeZone: t })), a = (e ?? o).getTimezoneOffset() / 60;
  return (+r - +o) / (1e3 * 60 * 60) - a;
};
var _r = /* @__PURE__ */ ((t) => (t.month = "month", t.year = "year", t))(_r || {}), Cr = /* @__PURE__ */ ((t) => (t.top = "top", t.bottom = "bottom", t))(Cr || {}), Ba = /* @__PURE__ */ ((t) => (t.header = "header", t.calendar = "calendar", t.timePicker = "timePicker", t))(Ba || {}), wn = /* @__PURE__ */ ((t) => (t.month = "month", t.year = "year", t.calendar = "calendar", t.time = "time", t.minutes = "minutes", t.hours = "hours", t.seconds = "seconds", t))(wn || {});
const jP = ["timestamp", "date", "iso"];
var An = /* @__PURE__ */ ((t) => (t.up = "up", t.down = "down", t.left = "left", t.right = "right", t))(An || {}), Dt = /* @__PURE__ */ ((t) => (t.arrowUp = "ArrowUp", t.arrowDown = "ArrowDown", t.arrowLeft = "ArrowLeft", t.arrowRight = "ArrowRight", t.enter = "Enter", t.space = " ", t.esc = "Escape", t.tab = "Tab", t.home = "Home", t.end = "End", t.pageUp = "PageUp", t.pageDown = "PageDown", t))(Dt || {});
function Dg(t) {
  return (e) => new Intl.DateTimeFormat(t, { weekday: "short", timeZone: "UTC" }).format(/* @__PURE__ */ new Date(`2017-01-0${e}T00:00:00+00:00`)).slice(0, 2);
}
function zP(t) {
  return (e) => Mr(jn(/* @__PURE__ */ new Date(`2017-01-0${e}T00:00:00+00:00`), "UTC"), "EEEEEE", { locale: t });
}
const YP = (t, e, n) => {
  const r = [1, 2, 3, 4, 5, 6, 7];
  let o;
  if (t !== null)
    try {
      o = r.map(zP(t));
    } catch {
      o = r.map(Dg(e));
    }
  else
    o = r.map(Dg(e));
  const a = o.slice(0, n), i = o.slice(n + 1, o.length);
  return [o[n]].concat(...i).concat(...a);
}, bh = (t, e, n) => {
  const r = [];
  for (let o = +t[0]; o <= +t[1]; o++)
    r.push({ value: +o, text: lk(o, e) });
  return n ? r.reverse() : r;
}, ak = (t, e, n) => {
  const r = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((a) => {
    const i = a < 10 ? `0${a}` : a;
    return /* @__PURE__ */ new Date(`2017-${i}-01T00:00:00+00:00`);
  });
  if (t !== null)
    try {
      const a = n === "long" ? "LLLL" : "LLL";
      return r.map((i, s) => {
        const l = Mr(jn(i, "UTC"), a, { locale: t });
        return {
          text: l.charAt(0).toUpperCase() + l.substring(1),
          value: s
        };
      });
    } catch {
    }
  const o = new Intl.DateTimeFormat(e, { month: n, timeZone: "UTC" });
  return r.map((a, i) => {
    const s = o.format(a);
    return {
      text: s.charAt(0).toUpperCase() + s.substring(1),
      value: i
    };
  });
}, qP = (t) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][t], en = (t) => {
  const e = p(t);
  return e != null && e.$el ? e == null ? void 0 : e.$el : e;
}, GP = (t) => ({ type: "dot", ...t ?? {} }), ik = (t) => Array.isArray(t) ? !!t[0] && !!t[1] : !1, kh = {
  prop: (t) => `"${t}" prop must be enabled!`,
  dateArr: (t) => `You need to use array as "model-value" binding in order to support "${t}"`
}, an = (t) => t, Pg = (t) => t === 0 ? t : !t || isNaN(+t) ? null : +t, Ng = (t) => t === null, sk = (t) => {
  if (t)
    return [...t.querySelectorAll("input, button, select, textarea, a[href]")][0];
}, JP = (t) => {
  const e = [], n = (r) => r.filter((o) => o);
  for (let r = 0; r < t.length; r += 3) {
    const o = [t[r], t[r + 1], t[r + 2]];
    e.push(n(o));
  }
  return e;
}, il = (t, e, n) => {
  const r = n != null, o = e != null;
  if (!r && !o) return !1;
  const a = +n, i = +e;
  return r && o ? +t > a || +t < i : r ? +t > a : o ? +t < i : !1;
}, Yi = (t, e) => JP(t).map((n) => n.map((r) => {
  const { active: o, disabled: a, isBetween: i, highlighted: s } = e(r);
  return {
    ...r,
    active: o,
    disabled: a,
    className: {
      dp__overlay_cell_active: o,
      dp__overlay_cell: !o,
      dp__overlay_cell_disabled: a,
      dp__overlay_cell_pad: !0,
      dp__overlay_cell_active_disabled: a && o,
      dp__cell_in_between: i,
      "dp--highlighted": s
    }
  };
})), ta = (t, e, n = !1) => {
  t && e.allowStopPropagation && (n && t.stopImmediatePropagation(), t.stopPropagation());
}, XP = () => [
  "a[href]",
  "area[href]",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
  "[data-datepicker-instance]"
].join(", ");
function QP(t, e) {
  let n = [...document.querySelectorAll(XP())];
  n = n.filter((o) => !t.contains(o) || o.hasAttribute("data-datepicker-instance"));
  const r = n.indexOf(t);
  if (r >= 0 && (e ? r - 1 >= 0 : r + 1 <= n.length))
    return n[r + (e ? -1 : 1)];
}
const Hf = (t, e) => t == null ? void 0 : t.querySelector(`[data-dp-element="${e}"]`), lk = (t, e) => new Intl.NumberFormat(e, { useGrouping: !1, style: "decimal" }).format(t), wh = (t) => Mr(t, "dd-MM-yyyy"), Cd = (t) => Array.isArray(t), xu = (t, e) => e.get(wh(t)), ZP = (t, e) => t ? e ? e instanceof Map ? !!xu(t, e) : e(we(t)) : !1 : !0, Dn = (t, e, n = !1, r) => {
  if (t.key === Dt.enter || t.key === Dt.space)
    return n && t.preventDefault(), e();
  if (r) return r(t);
}, $g = () => ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].some(
  (t) => navigator.userAgent.includes(t)
) || navigator.userAgent.includes("Mac") && "ontouchend" in document, Rg = (t, e, n, r, o, a) => {
  const i = La(t, e.slice(0, t.length), /* @__PURE__ */ new Date(), { locale: a });
  return $i(i) && sh(i) ? r || o ? i : Tt(i, {
    hours: +n.hours,
    minutes: +(n == null ? void 0 : n.minutes),
    seconds: +(n == null ? void 0 : n.seconds),
    milliseconds: 0
  }) : null;
}, eN = (t, e, n, r, o, a) => {
  const i = Array.isArray(n) ? n[0] : n;
  if (typeof e == "string")
    return Rg(t, e, i, r, o, a);
  if (Array.isArray(e)) {
    let s = null;
    for (const l of e)
      if (s = Rg(t, l, i, r, o, a), s)
        break;
    return s;
  }
  return typeof e == "function" ? e(t) : null;
}, we = (t) => t ? new Date(t) : /* @__PURE__ */ new Date(), tN = (t, e, n) => {
  if (e) {
    const o = (t.getMonth() + 1).toString().padStart(2, "0"), a = t.getDate().toString().padStart(2, "0"), i = t.getHours().toString().padStart(2, "0"), s = t.getMinutes().toString().padStart(2, "0"), l = n ? t.getSeconds().toString().padStart(2, "0") : "00";
    return `${t.getFullYear()}-${o}-${a}T${i}:${s}:${l}.000Z`;
  }
  const r = Date.UTC(
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate(),
    t.getUTCHours(),
    t.getUTCMinutes(),
    t.getUTCSeconds()
  );
  return new Date(r).toISOString();
}, $n = (t, e) => {
  const n = we(JSON.parse(JSON.stringify(t))), r = Tt(n, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
  return e ? qI(r) : r;
}, na = (t, e, n, r) => {
  let o = t ? we(t) : we();
  return (e || e === 0) && (o = VP(o, +e)), (n || n === 0) && (o = HP(o, +n)), (r || r === 0) && (o = nk(o, +r)), tk(o, 0);
}, Vt = (t, e) => !t || !e ? !1 : al($n(t), $n(e)), mt = (t, e) => !t || !e ? !1 : Mi($n(t), $n(e)), Kt = (t, e) => !t || !e ? !1 : ji($n(t), $n(e)), Hc = (t, e, n) => t != null && t[0] && t != null && t[1] ? Kt(n, t[0]) && Vt(n, t[1]) : t != null && t[0] && e ? Kt(n, t[0]) && Vt(n, e) || Vt(n, t[0]) && Kt(n, e) : !1, Tr = (t) => {
  const e = Tt(new Date(t), { date: 1 });
  return $n(e);
}, Ed = (t, e, n) => e && (n || n === 0) ? Object.fromEntries(
  ["hours", "minutes", "seconds"].map((r) => r === e ? [r, n] : [r, isNaN(+t[r]) ? void 0 : +t[r]])
) : {
  hours: isNaN(+t.hours) ? void 0 : +t.hours,
  minutes: isNaN(+t.minutes) ? void 0 : +t.minutes,
  seconds: isNaN(+t.seconds) ? void 0 : +t.seconds
}, Fa = (t) => ({
  hours: $o(t),
  minutes: fa(t),
  seconds: Ki(t)
}), uk = (t, e) => {
  if (e) {
    const n = Qe(we(e));
    if (n > t) return 12;
    if (n === t) return ft(we(e));
  }
}, ck = (t, e) => {
  if (e) {
    const n = Qe(we(e));
    return n < t ? -1 : n === t ? ft(we(e)) : void 0;
  }
}, qi = (t) => {
  if (t) return Qe(we(t));
}, dk = (t, e) => {
  const n = Kt(t, e) ? e : t, r = Kt(e, t) ? e : t;
  return W0({ start: n, end: r });
}, nN = (t) => {
  const e = Ar(t, 1);
  return { month: ft(e), year: Qe(e) };
}, Eo = (t, e) => {
  const n = Nr(t, { weekStartsOn: +e }), r = j0(t, { weekStartsOn: +e });
  return [n, r];
}, fk = (t, e) => {
  const n = {
    hours: $o(we()),
    minutes: fa(we()),
    seconds: e ? Ki(we()) : 0
  };
  return Object.assign(n, t);
}, Xo = (t, e, n) => [Tt(we(t), { date: 1 }), Tt(we(), { month: e, year: n, date: 1 })], To = (t, e, n) => {
  let r = t ? we(t) : we();
  return (e || e === 0) && (r = ek(r, e)), n && (r = Gr(r, n)), r;
}, pk = (t, e, n, r, o) => {
  if (!r || o && !e || !o && !n) return !1;
  const a = o ? Ar(t, 1) : zi(t, 1), i = [ft(a), Qe(a)];
  return o ? !oN(...i, e) : !rN(...i, n);
}, rN = (t, e, n) => Vt(...Xo(n, t, e)) || mt(...Xo(n, t, e)), oN = (t, e, n) => Kt(...Xo(n, t, e)) || mt(...Xo(n, t, e)), hk = (t, e, n, r, o, a, i) => {
  if (typeof e == "function" && !i) return e(t);
  const s = n ? { locale: n } : void 0;
  return Array.isArray(t) ? `${Mr(t[0], a, s)}${o && !t[1] ? "" : r}${t[1] ? Mr(t[1], a, s) : ""}` : Mr(t, a, s);
}, gi = (t) => {
  if (t) return null;
  throw new Error(kh.prop("partial-range"));
}, Gl = (t, e) => {
  if (e) return t();
  throw new Error(kh.prop("range"));
}, Uf = (t) => Array.isArray(t) ? $i(t[0]) && (t[1] ? $i(t[1]) : !0) : t ? $i(t) : !1, aN = (t, e) => Tt(e ?? we(), {
  hours: +t.hours || 0,
  minutes: +t.minutes || 0,
  seconds: +t.seconds || 0
}), Od = (t, e, n, r) => {
  if (!t) return !0;
  if (r) {
    const o = n === "max" ? al(t, e) : ji(t, e), a = { seconds: 0, milliseconds: 0 };
    return o || Mi(Tt(t, a), Tt(e, a));
  }
  return n === "max" ? t.getTime() <= e.getTime() : t.getTime() >= e.getTime();
}, Td = (t, e, n) => t ? aN(t, e) : we(n ?? e), Lg = (t, e, n, r, o) => {
  if (Array.isArray(r)) {
    const i = Td(t, r[0], e), s = Td(t, r[1], e);
    return Od(r[0], i, n, !!e) && Od(r[1], s, n, !!e) && o;
  }
  const a = Td(t, r, e);
  return Od(r, a, n, !!e) && o;
}, Sd = (t) => Tt(we(), Fa(t)), iN = (t, e) => t instanceof Map ? Array.from(t.values()).filter((n) => Qe(we(n)) === e).map((n) => ft(n)) : [], sN = (t, e, n) => {
  if (t instanceof Map) {
    const r = Array.from(t.values()).filter((o) => Qe(we(o)) === e).map((o) => ft(o));
    return r.length ? r.includes(n) : !0;
  }
  return !0;
}, mk = (t, e, n) => typeof t == "function" ? t({ month: e, year: n }) : !!t.months.find((r) => r.month === e && r.year === n), _h = (t, e) => typeof t == "function" ? t(e) : t.years.includes(e), gk = (t) => Mr(t, "yyyy-MM-dd"), Es = eo({
  menuFocused: !1,
  shiftKeyInMenu: !1
}), vk = () => {
  const t = (n) => {
    Es.menuFocused = n;
  }, e = (n) => {
    Es.shiftKeyInMenu !== n && (Es.shiftKeyInMenu = n);
  };
  return {
    control: A(() => ({ shiftKeyInMenu: Es.shiftKeyInMenu, menuFocused: Es.menuFocused })),
    setMenuFocused: t,
    setShiftKey: e
  };
}, It = eo({
  monthYear: [],
  calendar: [],
  time: [],
  actionRow: [],
  selectionGrid: [],
  timePicker: {
    0: [],
    1: []
  },
  monthPicker: []
}), xd = F(null), Jl = F(!1), Ad = F(!1), Md = F(!1), Id = F(!1), bn = F(0), Wt = F(0), ba = () => {
  const t = A(() => Jl.value ? [...It.selectionGrid, It.actionRow].filter((d) => d.length) : Ad.value ? [
    ...It.timePicker[0],
    ...It.timePicker[1],
    Id.value ? [] : [xd.value],
    It.actionRow
  ].filter((d) => d.length) : Md.value ? [...It.monthPicker, It.actionRow] : [It.monthYear, ...It.calendar, It.time, It.actionRow].filter((d) => d.length)), e = (d) => {
    bn.value = d ? bn.value + 1 : bn.value - 1;
    let f = null;
    t.value[Wt.value] && (f = t.value[Wt.value][bn.value]), !f && t.value[Wt.value + (d ? 1 : -1)] ? (Wt.value = Wt.value + (d ? 1 : -1), bn.value = d ? 0 : t.value[Wt.value].length - 1) : f || (bn.value = d ? bn.value - 1 : bn.value + 1);
  }, n = (d) => {
    Wt.value === 0 && !d || Wt.value === t.value.length && d || (Wt.value = d ? Wt.value + 1 : Wt.value - 1, t.value[Wt.value] ? t.value[Wt.value] && !t.value[Wt.value][bn.value] && bn.value !== 0 && (bn.value = t.value[Wt.value].length - 1) : Wt.value = d ? Wt.value - 1 : Wt.value + 1);
  }, r = (d) => {
    let f = null;
    t.value[Wt.value] && (f = t.value[Wt.value][bn.value]), f ? f.focus({ preventScroll: !Jl.value }) : bn.value = d ? bn.value - 1 : bn.value + 1;
  }, o = () => {
    e(!0), r(!0);
  }, a = () => {
    e(!1), r(!1);
  }, i = () => {
    n(!1), r(!0);
  }, s = () => {
    n(!0), r(!0);
  }, l = (d, f) => {
    It[f] = d;
  }, u = (d, f) => {
    It[f] = d;
  }, c = () => {
    bn.value = 0, Wt.value = 0;
  };
  return {
    buildMatrix: l,
    buildMultiLevelMatrix: u,
    setTimePickerBackRef: (d) => {
      xd.value = d;
    },
    setSelectionGrid: (d) => {
      Jl.value = d, c(), d || (It.selectionGrid = []);
    },
    setTimePicker: (d, f = !1) => {
      Ad.value = d, Id.value = f, c(), d || (It.timePicker[0] = [], It.timePicker[1] = []);
    },
    setTimePickerElements: (d, f = 0) => {
      It.timePicker[f] = d;
    },
    arrowRight: o,
    arrowLeft: a,
    arrowUp: i,
    arrowDown: s,
    clearArrowNav: () => {
      It.monthYear = [], It.calendar = [], It.time = [], It.actionRow = [], It.selectionGrid = [], It.timePicker[0] = [], It.timePicker[1] = [], Jl.value = !1, Ad.value = !1, Id.value = !1, Md.value = !1, c(), xd.value = null;
    },
    setMonthPicker: (d) => {
      Md.value = d, c();
    },
    refSets: It
    // exposed for testing
  };
}, Bg = (t) => ({
  menuAppearTop: "dp-menu-appear-top",
  menuAppearBottom: "dp-menu-appear-bottom",
  open: "dp-slide-down",
  close: "dp-slide-up",
  next: "calendar-next",
  previous: "calendar-prev",
  vNext: "dp-slide-up",
  vPrevious: "dp-slide-down",
  ...t ?? {}
}), lN = (t) => ({
  toggleOverlay: "Toggle overlay",
  menu: "Datepicker menu",
  input: "Datepicker input",
  openTimePicker: "Open time picker",
  closeTimePicker: "Close time Picker",
  incrementValue: (e) => `Increment ${e}`,
  decrementValue: (e) => `Decrement ${e}`,
  openTpOverlay: (e) => `Open ${e} overlay`,
  amPmButton: "Switch AM/PM mode",
  openYearsOverlay: "Open years overlay",
  openMonthsOverlay: "Open months overlay",
  nextMonth: "Next month",
  prevMonth: "Previous month",
  nextYear: "Next year",
  prevYear: "Previous year",
  day: void 0,
  weekDay: void 0,
  clearInput: "Clear value",
  calendarIcon: "Calendar icon",
  timePicker: "Time picker",
  monthPicker: (e) => `Month picker${e ? " overlay" : ""}`,
  yearPicker: (e) => `Year picker${e ? " overlay" : ""}`,
  timeOverlay: (e) => `${e} overlay`,
  ...t ?? {}
}), Fg = (t) => t ? typeof t == "boolean" ? t ? 2 : 0 : +t >= 2 ? +t : 2 : 0, uN = (t) => {
  const e = typeof t == "object" && t, n = {
    static: !0,
    solo: !1
  };
  if (!t) return { ...n, count: Fg(!1) };
  const r = e ? t : {}, o = e ? r.count ?? !0 : t, a = Fg(o);
  return Object.assign(n, r, { count: a });
}, cN = (t, e, n) => t || (typeof n == "string" ? n : e), dN = (t) => typeof t == "boolean" ? t ? Bg({}) : !1 : Bg(t), fN = (t) => {
  const e = {
    enterSubmit: !0,
    tabSubmit: !0,
    openMenu: "open",
    selectOnFocus: !1,
    rangeSeparator: " - "
  };
  return typeof t == "object" ? { ...e, ...t ?? {}, enabled: !0 } : { ...e, enabled: t };
}, pN = (t) => ({
  months: [],
  years: [],
  times: { hours: [], minutes: [], seconds: [] },
  ...t ?? {}
}), hN = (t) => ({
  showSelect: !0,
  showCancel: !0,
  showNow: !1,
  showPreview: !0,
  ...t ?? {}
}), mN = (t) => {
  const e = { input: !1 };
  return typeof t == "object" ? { ...e, ...t ?? {}, enabled: !0 } : {
    enabled: t,
    ...e
  };
}, gN = (t) => ({ allowStopPropagation: !0, closeOnScroll: !1, modeHeight: 255, allowPreventDefault: !1, closeOnClearValue: !0, closeOnAutoApply: !0, noSwipe: !1, keepActionRow: !1, onClickOutside: void 0, tabOutClosesMenu: !0, arrowLeft: void 0, keepViewOnOffsetClick: !1, timeArrowHoldThreshold: 0, shadowDom: !1, mobileBreakpoint: 600, setDateOnMenuClose: !1, ...t ?? {} }), vN = (t) => {
  const e = {
    dates: Array.isArray(t) ? t.map((n) => we(n)) : [],
    years: [],
    months: [],
    quarters: [],
    weeks: [],
    weekdays: [],
    options: { highlightDisabled: !1 }
  };
  return typeof t == "function" ? t : { ...e, ...t ?? {} };
}, yN = (t) => typeof t == "object" ? {
  type: (t == null ? void 0 : t.type) ?? "local",
  hideOnOffsetDates: (t == null ? void 0 : t.hideOnOffsetDates) ?? !1
} : {
  type: t,
  hideOnOffsetDates: !1
}, bN = (t) => {
  const e = {
    noDisabledRange: !1,
    showLastInRange: !0,
    minMaxRawRange: !1,
    partialRange: !0,
    disableTimeRangeValidation: !1,
    maxRange: void 0,
    minRange: void 0,
    autoRange: void 0,
    fixedStart: !1,
    fixedEnd: !1
  };
  return typeof t == "object" ? { enabled: !0, ...e, ...t } : {
    enabled: t,
    ...e
  };
}, kN = (t) => t ? typeof t == "string" ? {
  timezone: t,
  exactMatch: !1,
  dateInTz: void 0,
  emitTimezone: void 0,
  convertModel: !0
} : {
  timezone: t.timezone,
  exactMatch: t.exactMatch ?? !1,
  dateInTz: t.dateInTz ?? void 0,
  emitTimezone: t.emitTimezone ?? void 0,
  convertModel: t.convertModel ?? !0
} : { timezone: void 0, exactMatch: !1, emitTimezone: void 0 }, Dd = (t, e, n) => new Map(
  t.map((r) => {
    const o = yh(r, e, n);
    return [wh(o), o];
  })
), wN = (t, e) => t.length ? new Map(
  t.map((n) => {
    const r = yh(n.date, e);
    return [wh(r), n];
  })
) : null, _N = (t) => {
  var e;
  return {
    minDate: Vf(t.minDate, t.timezone, t.isSpecific),
    maxDate: Vf(t.maxDate, t.timezone, t.isSpecific),
    disabledDates: Cd(t.disabledDates) ? Dd(t.disabledDates, t.timezone, t.isSpecific) : t.disabledDates,
    allowedDates: Cd(t.allowedDates) ? Dd(t.allowedDates, t.timezone, t.isSpecific) : null,
    highlight: typeof t.highlight == "object" && Cd((e = t.highlight) == null ? void 0 : e.dates) ? Dd(t.highlight.dates, t.timezone) : t.highlight,
    markers: wN(t.markers, t.timezone)
  };
}, CN = (t) => typeof t == "boolean" ? { enabled: t, dragSelect: !0, limit: null } : {
  enabled: !!t,
  limit: t.limit ? +t.limit : null,
  dragSelect: t.dragSelect ?? !0
}, EN = (t) => ({
  ...Object.fromEntries(
    Object.keys(t).map((e) => {
      const n = e, r = t[n], o = typeof t[n] == "string" ? { [r]: !0 } : Object.fromEntries(r.map((a) => [a, !0]));
      return [e, o];
    })
  )
}), $t = (t) => {
  const e = () => {
    const _ = t.enableSeconds ? ":ss" : "", T = t.enableMinutes ? ":mm" : "";
    return t.is24 ? `HH${T}${_}` : `hh${T}${_} aa`;
  }, n = () => {
    var _;
    return t.format ? t.format : t.monthPicker ? "MM/yyyy" : t.timePicker ? e() : t.weekPicker ? `${((_ = y.value) == null ? void 0 : _.type) === "iso" ? "RR" : "ww"}-yyyy` : t.yearPicker ? "yyyy" : t.quarterPicker ? "QQQ/yyyy" : t.enableTimePicker ? `MM/dd/yyyy, ${e()}` : "MM/dd/yyyy";
  }, r = (_) => fk(_, t.enableSeconds), o = () => v.value.enabled ? t.startTime && Array.isArray(t.startTime) ? [r(t.startTime[0]), r(t.startTime[1])] : null : t.startTime && !Array.isArray(t.startTime) ? r(t.startTime) : null, a = A(() => uN(t.multiCalendars)), i = A(() => o()), s = A(() => lN(t.ariaLabels)), l = A(() => pN(t.filters)), u = A(() => dN(t.transitions)), c = A(() => hN(t.actionRow)), d = A(
    () => cN(t.previewFormat, t.format, n())
  ), f = A(() => fN(t.textInput)), h = A(() => mN(t.inline)), m = A(() => gN(t.config)), g = A(() => vN(t.highlight)), y = A(() => yN(t.weekNumbers)), b = A(() => kN(t.timezone)), C = A(() => CN(t.multiDates)), k = A(
    () => _N({
      minDate: t.minDate,
      maxDate: t.maxDate,
      disabledDates: t.disabledDates,
      allowedDates: t.allowedDates,
      highlight: g.value,
      markers: t.markers,
      timezone: b.value,
      isSpecific: t.monthPicker || t.yearPicker || t.quarterPicker
    })
  ), v = A(() => bN(t.range)), E = A(() => EN(t.ui));
  return {
    defaultedTransitions: u,
    defaultedMultiCalendars: a,
    defaultedStartTime: i,
    defaultedAriaLabels: s,
    defaultedFilters: l,
    defaultedActionRow: c,
    defaultedPreviewFormat: d,
    defaultedTextInput: f,
    defaultedInline: h,
    defaultedConfig: m,
    defaultedHighlight: g,
    defaultedWeekNumbers: y,
    defaultedRange: v,
    propDates: k,
    defaultedTz: b,
    defaultedMultiDates: C,
    defaultedUI: E,
    getDefaultPattern: n,
    getDefaultStartTime: o
  };
}, ON = (t, e, n) => {
  const r = F(), { defaultedTextInput: o, defaultedRange: a, defaultedTz: i, defaultedMultiDates: s, getDefaultPattern: l } = $t(e), u = F(""), c = Bi(e, "format"), d = Bi(e, "formatLocale");
  Ke(
    r,
    () => {
      typeof e.onInternalModelChange == "function" && t("internal-model-change", r.value, fe(!0));
    },
    { deep: !0 }
  ), Ke(a, (P, se) => {
    P.enabled !== se.enabled && (r.value = null);
  }), Ke(c, () => {
    de();
  });
  const f = (P) => i.value.timezone && i.value.convertModel ? jn(P, i.value.timezone) : P, h = (P) => {
    if (i.value.timezone && i.value.convertModel) {
      const se = KP(i.value.timezone, P);
      return HI(P, se);
    }
    return P;
  }, m = (P, se, ke = !1) => hk(
    P,
    e.format,
    e.formatLocale,
    o.value.rangeSeparator,
    e.modelAuto,
    se ?? l(),
    ke
  ), g = (P) => P ? e.modelType ? J(P) : {
    hours: $o(P),
    minutes: fa(P),
    seconds: e.enableSeconds ? Ki(P) : 0
  } : null, y = (P) => e.modelType ? J(P) : { month: ft(P), year: Qe(P) }, b = (P) => Array.isArray(P) ? s.value.enabled ? P.map((se) => C(se, Gr(we(), se))) : Gl(
    () => [
      Gr(we(), P[0]),
      P[1] ? Gr(we(), P[1]) : gi(a.value.partialRange)
    ],
    a.value.enabled
  ) : Gr(we(), +P), C = (P, se) => (typeof P == "string" || typeof P == "number") && e.modelType ? re(P) : se, k = (P) => Array.isArray(P) ? [
    C(
      P[0],
      na(null, +P[0].hours, +P[0].minutes, P[0].seconds)
    ),
    C(
      P[1],
      na(null, +P[1].hours, +P[1].minutes, P[1].seconds)
    )
  ] : C(P, na(null, P.hours, P.minutes, P.seconds)), v = (P) => {
    const se = Tt(we(), { date: 1 });
    return Array.isArray(P) ? s.value.enabled ? P.map((ke) => C(ke, To(se, +ke.month, +ke.year))) : Gl(
      () => [
        C(P[0], To(se, +P[0].month, +P[0].year)),
        C(
          P[1],
          P[1] ? To(se, +P[1].month, +P[1].year) : gi(a.value.partialRange)
        )
      ],
      a.value.enabled
    ) : C(P, To(se, +P.month, +P.year));
  }, E = (P) => {
    if (Array.isArray(P))
      return P.map((se) => re(se));
    throw new Error(kh.dateArr("multi-dates"));
  }, _ = (P) => {
    if (Array.isArray(P) && a.value.enabled) {
      const se = P[0], ke = P[1];
      return [
        we(Array.isArray(se) ? se[0] : null),
        Array.isArray(ke) && ke.length ? we(ke[0]) : null
      ];
    }
    return we(P[0]);
  }, T = (P) => e.modelAuto ? Array.isArray(P) ? [re(P[0]), re(P[1])] : e.autoApply ? [re(P)] : [re(P), null] : Array.isArray(P) ? Gl(
    () => P[1] ? [
      re(P[0]),
      P[1] ? re(P[1]) : gi(a.value.partialRange)
    ] : [re(P[0])],
    a.value.enabled
  ) : re(P), M = () => {
    Array.isArray(r.value) && a.value.enabled && r.value.length === 1 && r.value.push(gi(a.value.partialRange));
  }, O = () => {
    const P = r.value;
    return [
      J(P[0]),
      P[1] ? J(P[1]) : gi(a.value.partialRange)
    ];
  }, R = () => r.value[1] ? O() : J(an(r.value[0])), N = () => (r.value || []).map((P) => J(P)), z = (P = !1) => (P || M(), e.modelAuto ? R() : s.value.enabled ? N() : Array.isArray(r.value) ? Gl(() => O(), a.value.enabled) : J(an(r.value))), te = (P) => !P || Array.isArray(P) && !P.length ? null : e.timePicker ? k(an(P)) : e.monthPicker ? v(an(P)) : e.yearPicker ? b(an(P)) : s.value.enabled ? E(an(P)) : e.weekPicker ? _(an(P)) : T(an(P)), H = (P) => {
    const se = te(P);
    Uf(an(se)) ? (r.value = an(se), de()) : (r.value = null, u.value = "");
  }, U = () => {
    const P = (se) => Mr(se, o.value.format);
    return `${P(r.value[0])} ${o.value.rangeSeparator} ${r.value[1] ? P(r.value[1]) : ""}`;
  }, W = () => n.value && r.value ? Array.isArray(r.value) ? U() : Mr(r.value, o.value.format) : m(r.value), Q = () => r.value ? s.value.enabled ? r.value.map((P) => m(P)).join("; ") : o.value.enabled && typeof o.value.format == "string" ? W() : m(r.value) : "", de = () => {
    !e.format || typeof e.format == "string" || o.value.enabled && typeof o.value.format == "string" ? u.value = Q() : u.value = e.format(r.value);
  }, re = (P) => {
    if (e.utc) {
      const se = new Date(P);
      return e.utc === "preserve" ? new Date(se.getTime() + se.getTimezoneOffset() * 6e4) : se;
    }
    return e.modelType ? jP.includes(e.modelType) ? f(new Date(P)) : e.modelType === "format" && (typeof e.format == "string" || !e.format) ? f(
      La(P, l(), /* @__PURE__ */ new Date(), { locale: d.value })
    ) : f(
      La(P, e.modelType, /* @__PURE__ */ new Date(), { locale: d.value })
    ) : f(new Date(P));
  }, J = (P) => P ? e.utc ? tN(P, e.utc === "preserve", e.enableSeconds) : e.modelType ? e.modelType === "timestamp" ? +h(P) : e.modelType === "iso" ? h(P).toISOString() : e.modelType === "format" && (typeof e.format == "string" || !e.format) ? m(h(P)) : m(h(P), e.modelType, !0) : h(P) : "", Ce = (P, se = !1, ke = !1) => {
    if (ke) return P;
    if (t("update:model-value", P), i.value.emitTimezone && se) {
      const Le = Array.isArray(P) ? P.map((ne) => jn(an(ne), i.value.emitTimezone)) : jn(an(P), i.value.emitTimezone);
      t("update:model-timezone-value", Le);
    }
  }, ie = (P) => Array.isArray(r.value) ? s.value.enabled ? r.value.map((se) => P(se)) : [
    P(r.value[0]),
    r.value[1] ? P(r.value[1]) : gi(a.value.partialRange)
  ] : P(an(r.value)), ee = () => {
    if (Array.isArray(r.value)) {
      const P = Eo(r.value[0], e.weekStart), se = r.value[1] ? Eo(r.value[1], e.weekStart) : [];
      return [P.map((ke) => we(ke)), se.map((ke) => we(ke))];
    }
    return Eo(r.value, e.weekStart).map((P) => we(P));
  }, D = (P, se) => Ce(an(ie(P)), !1, se), G = (P) => {
    const se = ee();
    return P ? se : t("update:model-value", ee());
  }, fe = (P = !1) => (P || de(), e.monthPicker ? D(y, P) : e.timePicker ? D(g, P) : e.yearPicker ? D(Qe, P) : e.weekPicker ? G(P) : Ce(z(P), !0, P));
  return {
    inputValue: u,
    internalModelValue: r,
    checkBeforeEmit: () => r.value ? a.value.enabled ? a.value.partialRange ? r.value.length >= 1 : r.value.length === 2 : !!r.value : !1,
    parseExternalModelValue: H,
    formatInputValue: de,
    emitModelValue: fe
  };
}, TN = (t, e) => {
  const { defaultedFilters: n, propDates: r } = $t(t), { validateMonthYearInRange: o } = ka(t), a = (c, d) => {
    let f = c;
    return n.value.months.includes(ft(f)) ? (f = d ? Ar(c, 1) : zi(c, 1), a(f, d)) : f;
  }, i = (c, d) => {
    let f = c;
    return n.value.years.includes(Qe(f)) ? (f = d ? ih(c, 1) : rk(c, 1), i(f, d)) : f;
  }, s = (c, d = !1) => {
    const f = Tt(we(), { month: t.month, year: t.year });
    let h = c ? Ar(f, 1) : zi(f, 1);
    t.disableYearSelect && (h = Gr(h, t.year));
    let m = ft(h), g = Qe(h);
    n.value.months.includes(m) && (h = a(h, c), m = ft(h), g = Qe(h)), n.value.years.includes(g) && (h = i(h, c), g = Qe(h)), o(m, g, c, t.preventMinMaxNavigation) && l(m, g, d);
  }, l = (c, d, f) => {
    e("update-month-year", { month: c, year: d, fromNav: f });
  }, u = A(() => (c) => pk(
    Tt(we(), { month: t.month, year: t.year }),
    r.value.maxDate,
    r.value.minDate,
    t.preventMinMaxNavigation,
    c
  ));
  return { handleMonthYearChange: s, isDisabled: u, updateMonthYear: l };
}, Uc = {
  multiCalendars: { type: [Boolean, Number, String, Object], default: void 0 },
  modelValue: { type: [String, Date, Array, Object, Number], default: null },
  modelType: { type: String, default: null },
  position: { type: String, default: "center" },
  dark: { type: Boolean, default: !1 },
  format: {
    type: [String, Function],
    default: () => null
  },
  autoPosition: { type: [Boolean, String], default: !0 },
  altPosition: { type: Function, default: null },
  transitions: { type: [Boolean, Object], default: !0 },
  formatLocale: { type: Object, default: null },
  utc: { type: [Boolean, String], default: !1 },
  ariaLabels: { type: Object, default: () => ({}) },
  offset: { type: [Number, String], default: 10 },
  hideNavigation: { type: Array, default: () => [] },
  timezone: { type: [String, Object], default: null },
  vertical: { type: Boolean, default: !1 },
  disableMonthYearSelect: { type: Boolean, default: !1 },
  disableYearSelect: { type: Boolean, default: !1 },
  dayClass: {
    type: Function,
    default: null
  },
  yearRange: { type: Array, default: () => [1900, 2100] },
  enableTimePicker: { type: Boolean, default: !0 },
  autoApply: { type: Boolean, default: !1 },
  disabledDates: { type: [Array, Function], default: () => [] },
  monthNameFormat: { type: String, default: "short" },
  startDate: { type: [Date, String], default: null },
  startTime: { type: [Object, Array], default: null },
  hideOffsetDates: { type: Boolean, default: !1 },
  noToday: { type: Boolean, default: !1 },
  disabledWeekDays: { type: Array, default: () => [] },
  allowedDates: { type: Array, default: null },
  nowButtonLabel: { type: String, default: "Now" },
  markers: { type: Array, default: () => [] },
  escClose: { type: Boolean, default: !0 },
  spaceConfirm: { type: Boolean, default: !0 },
  monthChangeOnArrows: { type: Boolean, default: !0 },
  presetDates: { type: Array, default: () => [] },
  flow: { type: Array, default: () => [] },
  partialFlow: { type: Boolean, default: !1 },
  preventMinMaxNavigation: { type: Boolean, default: !1 },
  reverseYears: { type: Boolean, default: !1 },
  weekPicker: { type: Boolean, default: !1 },
  filters: { type: Object, default: () => ({}) },
  arrowNavigation: { type: Boolean, default: !1 },
  highlight: {
    type: [Function, Object],
    default: null
  },
  teleport: { type: [Boolean, String, Object], default: null },
  teleportCenter: { type: Boolean, default: !1 },
  locale: { type: String, default: "en-Us" },
  weekNumName: { type: String, default: "W" },
  weekStart: { type: [Number, String], default: 1 },
  weekNumbers: {
    type: [String, Function, Object],
    default: null
  },
  monthChangeOnScroll: { type: [Boolean, String], default: !0 },
  dayNames: {
    type: [Function, Array],
    default: null
  },
  monthPicker: { type: Boolean, default: !1 },
  customProps: { type: Object, default: null },
  yearPicker: { type: Boolean, default: !1 },
  modelAuto: { type: Boolean, default: !1 },
  selectText: { type: String, default: "Select" },
  cancelText: { type: String, default: "Cancel" },
  previewFormat: {
    type: [String, Function],
    default: () => ""
  },
  multiDates: { type: [Object, Boolean], default: !1 },
  ignoreTimeValidation: { type: Boolean, default: !1 },
  minDate: { type: [Date, String], default: null },
  maxDate: { type: [Date, String], default: null },
  minTime: { type: Object, default: null },
  maxTime: { type: Object, default: null },
  name: { type: String, default: null },
  placeholder: { type: String, default: "" },
  hideInputIcon: { type: Boolean, default: !1 },
  clearable: { type: Boolean, default: !0 },
  state: { type: Boolean, default: null },
  required: { type: Boolean, default: !1 },
  autocomplete: { type: String, default: "off" },
  timePicker: { type: Boolean, default: !1 },
  enableSeconds: { type: Boolean, default: !1 },
  is24: { type: Boolean, default: !0 },
  noHoursOverlay: { type: Boolean, default: !1 },
  noMinutesOverlay: { type: Boolean, default: !1 },
  noSecondsOverlay: { type: Boolean, default: !1 },
  hoursGridIncrement: { type: [String, Number], default: 1 },
  minutesGridIncrement: { type: [String, Number], default: 5 },
  secondsGridIncrement: { type: [String, Number], default: 5 },
  hoursIncrement: { type: [Number, String], default: 1 },
  minutesIncrement: { type: [Number, String], default: 1 },
  secondsIncrement: { type: [Number, String], default: 1 },
  range: { type: [Boolean, Object], default: !1 },
  uid: { type: String, default: null },
  disabled: { type: Boolean, default: !1 },
  readonly: { type: Boolean, default: !1 },
  inline: { type: [Boolean, Object], default: !1 },
  textInput: { type: [Boolean, Object], default: !1 },
  sixWeeks: { type: [Boolean, String], default: !1 },
  actionRow: { type: Object, default: () => ({}) },
  focusStartDate: { type: Boolean, default: !1 },
  disabledTimes: { type: [Function, Array], default: void 0 },
  timePickerInline: { type: Boolean, default: !1 },
  calendar: { type: Function, default: null },
  config: { type: Object, default: void 0 },
  quarterPicker: { type: Boolean, default: !1 },
  yearFirst: { type: Boolean, default: !1 },
  loading: { type: Boolean, default: !1 },
  onInternalModelChange: { type: [Function, Object], default: null },
  enableMinutes: { type: Boolean, default: !0 },
  ui: { type: Object, default: () => ({}) }
}, Br = {
  ...Uc,
  shadow: { type: Boolean, default: !1 },
  flowStep: { type: Number, default: 0 },
  internalModelValue: { type: [Date, Array], default: null },
  noOverlayFocus: { type: Boolean, default: !1 },
  collapse: { type: Boolean, default: !1 },
  menuWrapRef: { type: Object, default: null },
  getInputRect: { type: Function, default: () => ({}) },
  isTextInputDate: { type: Boolean, default: !1 },
  isMobile: { type: Boolean, default: void 0 }
}, SN = ["title"], xN = ["disabled"], AN = /* @__PURE__ */ j({
  compatConfig: {
    MODE: 3
  },
  __name: "ActionRow",
  props: {
    menuMount: { type: Boolean, default: !1 },
    calendarWidth: { type: Number, default: 0 },
    ...Br
  },
  emits: ["close-picker", "select-date", "select-now", "invalid-select"],
  setup(t, { emit: e }) {
    const n = e, r = t, {
      defaultedActionRow: o,
      defaultedPreviewFormat: a,
      defaultedMultiCalendars: i,
      defaultedTextInput: s,
      defaultedInline: l,
      defaultedRange: u,
      defaultedMultiDates: c
    } = $t(r), { isTimeValid: d, isMonthValid: f } = ka(r), { buildMatrix: h } = ba(), m = F(null), g = F(null), y = F(!1), b = F({}), C = F(null), k = F(null);
    ze(() => {
      r.arrowNavigation && h([en(m), en(g)], "actionRow"), v(), window.addEventListener("resize", v);
    }), En(() => {
      window.removeEventListener("resize", v);
    });
    const v = () => {
      y.value = !1, setTimeout(() => {
        var H, U;
        const W = (H = C.value) == null ? void 0 : H.getBoundingClientRect(), Q = (U = k.value) == null ? void 0 : U.getBoundingClientRect();
        W && Q && (b.value.maxWidth = `${Q.width - W.width - 20}px`), y.value = !0;
      }, 0);
    }, E = A(() => u.value.enabled && !u.value.partialRange && r.internalModelValue ? r.internalModelValue.length === 2 : !0), _ = A(
      () => !d.value(r.internalModelValue) || !f.value(r.internalModelValue) || !E.value
    ), T = () => {
      const H = a.value;
      return r.timePicker || r.monthPicker, H(an(r.internalModelValue));
    }, M = () => {
      const H = r.internalModelValue;
      return i.value.count > 0 ? `${O(H[0])} - ${O(H[1])}` : [O(H[0]), O(H[1])];
    }, O = (H) => hk(
      H,
      a.value,
      r.formatLocale,
      s.value.rangeSeparator,
      r.modelAuto,
      a.value
    ), R = A(() => !r.internalModelValue || !r.menuMount ? "" : typeof a.value == "string" ? Array.isArray(r.internalModelValue) ? r.internalModelValue.length === 2 && r.internalModelValue[1] ? M() : c.value.enabled ? r.internalModelValue.map((H) => `${O(H)}`) : r.modelAuto ? `${O(r.internalModelValue[0])}` : `${O(r.internalModelValue[0])} -` : O(r.internalModelValue) : T()), N = () => c.value.enabled ? "; " : " - ", z = A(
      () => Array.isArray(R.value) ? R.value.join(N()) : R.value
    ), te = () => {
      d.value(r.internalModelValue) && f.value(r.internalModelValue) && E.value ? n("select-date") : n("invalid-select");
    };
    return (H, U) => (w(), K("div", {
      ref_key: "actionRowRef",
      ref: k,
      class: "dp__action_row"
    }, [
      H.$slots["action-row"] ? $(H.$slots, "action-row", Ye(oe({ key: 0 }, {
        internalModelValue: H.internalModelValue,
        disabled: _.value,
        selectDate: () => H.$emit("select-date"),
        closePicker: () => H.$emit("close-picker")
      }))) : (w(), K(Me, { key: 1 }, [
        p(o).showPreview ? (w(), K("div", {
          key: 0,
          class: "dp__selection_preview",
          title: z.value,
          style: Lt(b.value)
        }, [
          H.$slots["action-preview"] && y.value ? $(H.$slots, "action-preview", {
            key: 0,
            value: H.internalModelValue
          }) : V("", !0),
          !H.$slots["action-preview"] && y.value ? (w(), K(Me, { key: 1 }, [
            We(Se(z.value), 1)
          ], 64)) : V("", !0)
        ], 12, SN)) : V("", !0),
        be("div", {
          ref_key: "actionBtnContainer",
          ref: C,
          class: "dp__action_buttons",
          "data-dp-element": "action-row"
        }, [
          H.$slots["action-buttons"] ? $(H.$slots, "action-buttons", {
            key: 0,
            value: H.internalModelValue
          }) : V("", !0),
          H.$slots["action-buttons"] ? V("", !0) : (w(), K(Me, { key: 1 }, [
            !p(l).enabled && p(o).showCancel ? (w(), K("button", {
              key: 0,
              ref_key: "cancelButtonRef",
              ref: m,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: U[0] || (U[0] = (W) => H.$emit("close-picker")),
              onKeydown: U[1] || (U[1] = (W) => p(Dn)(W, () => H.$emit("close-picker")))
            }, Se(H.cancelText), 545)) : V("", !0),
            p(o).showNow ? (w(), K("button", {
              key: 1,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: U[2] || (U[2] = (W) => H.$emit("select-now")),
              onKeydown: U[3] || (U[3] = (W) => p(Dn)(W, () => H.$emit("select-now")))
            }, Se(H.nowButtonLabel), 33)) : V("", !0),
            p(o).showSelect ? (w(), K("button", {
              key: 2,
              ref_key: "selectButtonRef",
              ref: g,
              type: "button",
              class: "dp__action_button dp__action_select",
              disabled: _.value,
              "data-test-id": "select-button",
              onKeydown: U[4] || (U[4] = (W) => p(Dn)(W, () => te())),
              onClick: te
            }, Se(H.selectText), 41, xN)) : V("", !0)
          ], 64))
        ], 512)
      ], 64))
    ], 512));
  }
}), MN = ["role", "aria-label", "tabindex"], IN = { class: "dp__selection_grid_header" }, DN = ["aria-selected", "aria-disabled", "data-test-id", "onClick", "onKeydown", "onMouseover"], PN = ["aria-label"], $l = /* @__PURE__ */ j({
  __name: "SelectionOverlay",
  props: {
    items: {},
    type: {},
    isLast: { type: Boolean },
    arrowNavigation: { type: Boolean },
    skipButtonRef: { type: Boolean },
    headerRefs: {},
    hideNavigation: {},
    escClose: { type: Boolean },
    useRelative: { type: Boolean },
    height: {},
    textInput: { type: [Boolean, Object] },
    config: {},
    noOverlayFocus: { type: Boolean },
    focusValue: {},
    menuWrapRef: {},
    ariaLabels: {},
    overlayLabel: {}
  },
  emits: ["selected", "toggle", "reset-flow", "hover-value"],
  setup(t, { expose: e, emit: n }) {
    const { setSelectionGrid: r, buildMultiLevelMatrix: o, setMonthPicker: a } = ba(), i = n, s = t, { defaultedAriaLabels: l, defaultedTextInput: u, defaultedConfig: c } = $t(
      s
    ), { hideNavigationButtons: d } = jc(), f = F(!1), h = F(null), m = F(null), g = F([]), y = F(), b = F(null), C = F(0), k = F(null);
    i_(() => {
      h.value = null;
    }), ze(() => {
      nt().then(() => N()), s.noOverlayFocus || E(), v(!0);
    }), En(() => v(!1));
    const v = (ie) => {
      var ee;
      s.arrowNavigation && ((ee = s.headerRefs) != null && ee.length ? a(ie) : r(ie));
    }, E = () => {
      var ie;
      const ee = en(m);
      ee && (u.value.enabled || (h.value ? (ie = h.value) == null || ie.focus({ preventScroll: !0 }) : ee.focus({ preventScroll: !0 })), f.value = ee.clientHeight < ee.scrollHeight);
    }, _ = A(
      () => ({
        dp__overlay: !0,
        "dp--overlay-absolute": !s.useRelative,
        "dp--overlay-relative": s.useRelative
      })
    ), T = A(
      () => s.useRelative ? { height: `${s.height}px`, width: "var(--dp-menu-min-width)" } : void 0
    ), M = A(() => ({
      dp__overlay_col: !0
    })), O = A(
      () => ({
        dp__btn: !0,
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: f.value,
        dp__button_bottom: s.isLast
      })
    ), R = A(() => {
      var ie, ee;
      return {
        dp__overlay_container: !0,
        dp__container_flex: ((ie = s.items) == null ? void 0 : ie.length) <= 6,
        dp__container_block: ((ee = s.items) == null ? void 0 : ee.length) > 6
      };
    });
    Ke(
      () => s.items,
      () => N(!1),
      { deep: !0 }
    );
    const N = (ie = !0) => {
      nt().then(() => {
        const ee = en(h), D = en(m), G = en(b), fe = en(k), P = G ? G.getBoundingClientRect().height : 0;
        D && (D.getBoundingClientRect().height ? C.value = D.getBoundingClientRect().height - P : C.value = c.value.modeHeight - P), ee && fe && ie && (fe.scrollTop = ee.offsetTop - fe.offsetTop - (C.value / 2 - ee.getBoundingClientRect().height) - P);
      });
    }, z = (ie) => {
      ie.disabled || i("selected", ie.value);
    }, te = () => {
      i("toggle"), i("reset-flow");
    }, H = () => {
      s.escClose && te();
    }, U = (ie, ee, D, G) => {
      ie && ((ee.active || ee.value === s.focusValue) && (h.value = ie), s.arrowNavigation && (Array.isArray(g.value[D]) ? g.value[D][G] = ie : g.value[D] = [ie], W()));
    }, W = () => {
      var ie, ee;
      const D = (ie = s.headerRefs) != null && ie.length ? [s.headerRefs].concat(g.value) : g.value.concat([s.skipButtonRef ? [] : [b.value]]);
      o(an(D), (ee = s.headerRefs) != null && ee.length ? "monthPicker" : "selectionGrid");
    }, Q = (ie) => {
      s.arrowNavigation || ta(ie, c.value, !0);
    }, de = (ie) => {
      y.value = ie, i("hover-value", ie);
    }, re = () => {
      if (te(), !s.isLast) {
        const ie = Hf(s.menuWrapRef ?? null, "action-row");
        if (ie) {
          const ee = sk(ie);
          ee == null || ee.focus();
        }
      }
    }, J = (ie) => {
      switch (ie.key) {
        case Dt.esc:
          return H();
        case Dt.arrowLeft:
          return Q(ie);
        case Dt.arrowRight:
          return Q(ie);
        case Dt.arrowUp:
          return Q(ie);
        case Dt.arrowDown:
          return Q(ie);
        default:
          return;
      }
    }, Ce = (ie) => {
      if (ie.key === Dt.enter) return te();
      if (ie.key === Dt.tab) return re();
    };
    return e({ focusGrid: E }), (ie, ee) => {
      var D;
      return w(), K("div", {
        ref_key: "gridWrapRef",
        ref: m,
        class: Ie(_.value),
        style: Lt(T.value),
        role: ie.useRelative ? void 0 : "dialog",
        "aria-label": ie.overlayLabel,
        tabindex: ie.useRelative ? void 0 : "0",
        onKeydown: J,
        onClick: ee[0] || (ee[0] = Xe(() => {
        }, ["prevent"]))
      }, [
        be("div", {
          ref_key: "containerRef",
          ref: k,
          class: Ie(R.value),
          style: Lt({ "--dp-overlay-height": `${C.value}px` }),
          role: "grid"
        }, [
          be("div", IN, [
            $(ie.$slots, "header")
          ]),
          ie.$slots.overlay ? $(ie.$slots, "overlay", { key: 0 }) : (w(!0), K(Me, { key: 1 }, et(ie.items, (G, fe) => (w(), K("div", {
            key: fe,
            class: Ie(["dp__overlay_row", { dp__flex_row: ie.items.length >= 3 }]),
            role: "row"
          }, [
            (w(!0), K(Me, null, et(G, (P, se) => (w(), K("div", {
              key: P.value,
              ref_for: !0,
              ref: (ke) => U(ke, P, fe, se),
              role: "gridcell",
              class: Ie(M.value),
              "aria-selected": P.active || void 0,
              "aria-disabled": P.disabled || void 0,
              tabindex: "0",
              "data-test-id": P.text,
              onClick: Xe((ke) => z(P), ["prevent"]),
              onKeydown: (ke) => p(Dn)(ke, () => z(P), !0),
              onMouseover: (ke) => de(P.value)
            }, [
              be("div", {
                class: Ie(P.className)
              }, [
                ie.$slots.item ? $(ie.$slots, "item", {
                  key: 0,
                  item: P
                }) : V("", !0),
                ie.$slots.item ? V("", !0) : (w(), K(Me, { key: 1 }, [
                  We(Se(P.text), 1)
                ], 64))
              ], 2)
            ], 42, DN))), 128))
          ], 2))), 128))
        ], 6),
        ie.$slots["button-icon"] ? Xr((w(), K("button", {
          key: 0,
          ref_key: "toggleButton",
          ref: b,
          type: "button",
          "aria-label": (D = p(l)) == null ? void 0 : D.toggleOverlay,
          class: Ie(O.value),
          tabindex: "0",
          onClick: te,
          onKeydown: Ce
        }, [
          $(ie.$slots, "button-icon")
        ], 42, PN)), [
          [cu, !p(d)(ie.hideNavigation, ie.type)]
        ]) : V("", !0)
      ], 46, MN);
    };
  }
}), NN = ["data-dp-mobile"], Wc = /* @__PURE__ */ j({
  __name: "InstanceWrap",
  props: {
    multiCalendars: {},
    stretch: { type: Boolean },
    collapse: { type: Boolean },
    isMobile: { type: Boolean }
  },
  setup(t) {
    const e = t, n = A(
      () => e.multiCalendars > 0 ? [...Array(e.multiCalendars).keys()] : [0]
    ), r = A(() => ({
      dp__instance_calendar: e.multiCalendars > 0
    }));
    return (o, a) => (w(), K("div", {
      class: Ie({
        dp__menu_inner: !o.stretch,
        "dp--menu--inner-stretched": o.stretch,
        dp__flex_display: o.multiCalendars > 0,
        "dp--flex-display-collapsed": o.collapse
      }),
      "data-dp-mobile": o.isMobile
    }, [
      (w(!0), K(Me, null, et(n.value, (i, s) => (w(), K("div", {
        key: i,
        class: Ie(r.value)
      }, [
        $(o.$slots, "default", {
          instance: i,
          index: s
        })
      ], 2))), 128))
    ], 10, NN));
  }
}), $N = ["data-dp-element", "aria-label", "aria-disabled"], Rs = /* @__PURE__ */ j({
  compatConfig: {
    MODE: 3
  },
  __name: "ArrowBtn",
  props: {
    ariaLabel: {},
    elName: {},
    disabled: { type: Boolean }
  },
  emits: ["activate", "set-ref"],
  setup(t, { emit: e }) {
    const n = e, r = F(null);
    return ze(() => n("set-ref", r)), (o, a) => (w(), K("button", {
      ref_key: "elRef",
      ref: r,
      type: "button",
      "data-dp-element": o.elName,
      class: "dp__btn dp--arrow-btn-nav",
      tabindex: "0",
      "aria-label": o.ariaLabel,
      "aria-disabled": o.disabled || void 0,
      onClick: a[0] || (a[0] = (i) => o.$emit("activate")),
      onKeydown: a[1] || (a[1] = (i) => p(Dn)(i, () => o.$emit("activate"), !0))
    }, [
      be("span", {
        class: Ie(["dp__inner_nav", { dp__inner_nav_disabled: o.disabled }])
      }, [
        $(o.$slots, "default")
      ], 2)
    ], 40, $N));
  }
}), RN = ["aria-label", "data-test-id"], yk = /* @__PURE__ */ j({
  __name: "YearModePicker",
  props: {
    ...Br,
    showYearPicker: { type: Boolean, default: !1 },
    items: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    isDisabled: { type: Function, default: () => !1 }
  },
  emits: ["toggle-year-picker", "year-select", "handle-year"],
  setup(t, { emit: e }) {
    const n = e, r = t, { showRightIcon: o, showLeftIcon: a } = jc(), { defaultedConfig: i, defaultedMultiCalendars: s, defaultedAriaLabels: l, defaultedTransitions: u, defaultedUI: c } = $t(r), { showTransition: d, transitionName: f } = Rl(u), h = F(!1), m = (b = !1, C) => {
      h.value = !h.value, n("toggle-year-picker", { flow: b, show: C });
    }, g = (b) => {
      h.value = !1, n("year-select", b);
    }, y = (b = !1) => {
      n("handle-year", b);
    };
    return (b, C) => {
      var k, v, E, _, T;
      return w(), K(Me, null, [
        be("div", {
          class: Ie(["dp--year-mode-picker", { "dp--hidden-el": h.value }])
        }, [
          p(a)(p(s), t.instance) ? (w(), I(Rs, {
            key: 0,
            ref: "mpPrevIconRef",
            "aria-label": (k = p(l)) == null ? void 0 : k.prevYear,
            disabled: t.isDisabled(!1),
            class: Ie((v = p(c)) == null ? void 0 : v.navBtnPrev),
            onActivate: C[0] || (C[0] = (M) => y(!1))
          }, {
            default: S(() => [
              b.$slots["arrow-left"] ? $(b.$slots, "arrow-left", { key: 0 }) : V("", !0),
              b.$slots["arrow-left"] ? V("", !0) : (w(), I(p(ph), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : V("", !0),
          be("button", {
            ref: "mpYearButtonRef",
            class: "dp__btn dp--year-select",
            type: "button",
            "aria-label": `${t.year}-${(E = p(l)) == null ? void 0 : E.openYearsOverlay}`,
            "data-test-id": `year-mode-btn-${t.instance}`,
            onClick: C[1] || (C[1] = () => m(!1)),
            onKeydown: C[2] || (C[2] = to(() => m(!1), ["enter"]))
          }, [
            b.$slots.year ? $(b.$slots, "year", {
              key: 0,
              year: t.year
            }) : V("", !0),
            b.$slots.year ? V("", !0) : (w(), K(Me, { key: 1 }, [
              We(Se(t.year), 1)
            ], 64))
          ], 40, RN),
          p(o)(p(s), t.instance) ? (w(), I(Rs, {
            key: 1,
            ref: "mpNextIconRef",
            "aria-label": (_ = p(l)) == null ? void 0 : _.nextYear,
            disabled: t.isDisabled(!0),
            class: Ie((T = p(c)) == null ? void 0 : T.navBtnNext),
            onActivate: C[3] || (C[3] = (M) => y(!0))
          }, {
            default: S(() => [
              b.$slots["arrow-right"] ? $(b.$slots, "arrow-right", { key: 0 }) : V("", !0),
              b.$slots["arrow-right"] ? V("", !0) : (w(), I(p(hh), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : V("", !0)
        ], 2),
        q(ss, {
          name: p(f)(t.showYearPicker),
          css: p(d)
        }, {
          default: S(() => {
            var M, O;
            return [
              t.showYearPicker ? (w(), I($l, {
                key: 0,
                items: t.items,
                "text-input": b.textInput,
                "esc-close": b.escClose,
                config: b.config,
                "is-last": b.autoApply && !p(i).keepActionRow,
                "hide-navigation": b.hideNavigation,
                "aria-labels": b.ariaLabels,
                "overlay-label": (O = (M = p(l)) == null ? void 0 : M.yearPicker) == null ? void 0 : O.call(M, !0),
                type: "year",
                onToggle: m,
                onSelected: C[4] || (C[4] = (R) => g(R))
              }, At({
                "button-icon": S(() => [
                  b.$slots["calendar-icon"] ? $(b.$slots, "calendar-icon", { key: 0 }) : V("", !0),
                  b.$slots["calendar-icon"] ? V("", !0) : (w(), I(p(vs), { key: 1 }))
                ]),
                _: 2
              }, [
                b.$slots["year-overlay-value"] ? {
                  name: "item",
                  fn: S(({ item: R }) => [
                    $(b.$slots, "year-overlay-value", {
                      text: R.text,
                      value: R.value
                    })
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["items", "text-input", "esc-close", "config", "is-last", "hide-navigation", "aria-labels", "overlay-label"])) : V("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ], 64);
    };
  }
}), Ch = (t, e, n) => {
  if (e.value && Array.isArray(e.value))
    if (e.value.some((r) => mt(t, r))) {
      const r = e.value.filter((o) => !mt(o, t));
      e.value = r.length ? r : null;
    } else (n && +n > e.value.length || !n) && e.value.push(t);
  else
    e.value = [t];
}, Eh = (t, e, n) => {
  let r = t.value ? t.value.slice() : [];
  return r.length === 2 && r[1] !== null && (r = []), r.length ? (Vt(e, r[0]) ? r.unshift(e) : r[1] = e, n("range-end", e)) : (r = [e], n("range-start", e)), r;
}, Kc = (t, e, n, r) => {
  t && (t[0] && t[1] && n && e("auto-apply"), t[0] && !t[1] && r && n && e("auto-apply"));
}, bk = (t) => {
  Array.isArray(t.value) && t.value.length <= 2 && t.range ? t.modelValue.value = t.value.map((e) => jn(we(e), t.timezone)) : Array.isArray(t.value) || (t.modelValue.value = jn(we(t.value), t.timezone));
}, kk = (t, e, n, r) => Array.isArray(e.value) && (e.value.length === 2 || e.value.length === 1 && r.value.partialRange) ? r.value.fixedStart && (Kt(t, e.value[0]) || mt(t, e.value[0])) ? [e.value[0], t] : r.value.fixedEnd && (Vt(t, e.value[1]) || mt(t, e.value[1])) ? [t, e.value[1]] : (n("invalid-fixed-range", t), e.value) : [], wk = ({
  multiCalendars: t,
  range: e,
  highlight: n,
  propDates: r,
  calendars: o,
  modelValue: a,
  props: i,
  filters: s,
  year: l,
  month: u,
  emit: c
}) => {
  const d = A(() => bh(i.yearRange, i.locale, i.reverseYears)), f = F([!1]), h = A(() => (R, N) => {
    const z = Tt(Tr(/* @__PURE__ */ new Date()), {
      month: u.value(R),
      year: l.value(R)
    }), te = N ? K0(z) : ol(z);
    return pk(
      te,
      r.value.maxDate,
      r.value.minDate,
      i.preventMinMaxNavigation,
      N
    );
  }), m = () => Array.isArray(a.value) && t.value.solo && a.value[1], g = () => {
    for (let R = 0; R < t.value.count; R++)
      if (R === 0)
        o.value[R] = o.value[0];
      else if (R === t.value.count - 1 && m())
        o.value[R] = {
          month: ft(a.value[1]),
          year: Qe(a.value[1])
        };
      else {
        const N = Tt(we(), o.value[R - 1]);
        o.value[R] = { month: ft(N), year: Qe(ih(N, 1)) };
      }
  }, y = (R) => {
    if (!R) return g();
    const N = Tt(we(), o.value[R]);
    return o.value[0].year = Qe(rk(N, t.value.count - 1)), g();
  }, b = (R, N) => {
    const z = zI(N, R);
    return e.value.showLastInRange && z > 1 ? N : R;
  }, C = (R) => i.focusStartDate || t.value.solo ? R[0] : R[1] ? b(R[0], R[1]) : R[0], k = () => {
    if (a.value) {
      const R = Array.isArray(a.value) ? C(a.value) : a.value;
      o.value[0] = { month: ft(R), year: Qe(R) };
    }
  }, v = () => {
    k(), t.value.count && g();
  };
  Ke(a, (R, N) => {
    i.isTextInputDate && JSON.stringify(R ?? {}) !== JSON.stringify(N ?? {}) && v();
  }), ze(() => {
    v();
  });
  const E = (R, N) => {
    o.value[N].year = R, c("update-month-year", { instance: N, year: R, month: o.value[N].month }), t.value.count && !t.value.solo && y(N);
  }, _ = A(() => (R) => Yi(d.value, (N) => {
    var z;
    const te = l.value(R) === N.value, H = il(
      N.value,
      qi(r.value.minDate),
      qi(r.value.maxDate)
    ) || ((z = s.value.years) == null ? void 0 : z.includes(l.value(R))), U = _h(n.value, N.value);
    return { active: te, disabled: H, highlighted: U };
  })), T = (R, N) => {
    E(R, N), O(N);
  }, M = (R, N = !1) => {
    if (!h.value(R, N)) {
      const z = N ? l.value(R) + 1 : l.value(R) - 1;
      E(z, R);
    }
  }, O = (R, N = !1, z) => {
    N || c("reset-flow"), z !== void 0 ? f.value[R] = z : f.value[R] = !f.value[R], f.value[R] ? c("overlay-toggle", { open: !0, overlay: wn.year }) : (c("overlay-closed"), c("overlay-toggle", { open: !1, overlay: wn.year }));
  };
  return {
    isDisabled: h,
    groupedYears: _,
    showYearPicker: f,
    selectYear: E,
    toggleYearPicker: O,
    handleYearSelect: T,
    handleYear: M
  };
}, LN = (t, e) => {
  const {
    defaultedMultiCalendars: n,
    defaultedAriaLabels: r,
    defaultedTransitions: o,
    defaultedConfig: a,
    defaultedRange: i,
    defaultedHighlight: s,
    propDates: l,
    defaultedTz: u,
    defaultedFilters: c,
    defaultedMultiDates: d
  } = $t(t), f = () => {
    t.isTextInputDate && v(Qe(we(t.startDate)), 0);
  }, { modelValue: h, year: m, month: g, calendars: y } = Ll(t, e, f), b = A(() => ak(t.formatLocale, t.locale, t.monthNameFormat)), C = F(null), { checkMinMaxRange: k } = ka(t), {
    selectYear: v,
    groupedYears: E,
    showYearPicker: _,
    toggleYearPicker: T,
    handleYearSelect: M,
    handleYear: O,
    isDisabled: R
  } = wk({
    modelValue: h,
    multiCalendars: n,
    range: i,
    highlight: s,
    calendars: y,
    year: m,
    propDates: l,
    month: g,
    filters: c,
    props: t,
    emit: e
  });
  ze(() => {
    t.startDate && (h.value && t.focusStartDate || !h.value) && v(Qe(we(t.startDate)), 0);
  });
  const N = (D) => D ? { month: ft(D), year: Qe(D) } : { month: null, year: null }, z = () => h.value ? Array.isArray(h.value) ? h.value.map((D) => N(D)) : N(h.value) : N(), te = (D, G) => {
    const fe = y.value[D], P = z();
    return Array.isArray(P) ? P.some((se) => se.year === (fe == null ? void 0 : fe.year) && se.month === G) : (fe == null ? void 0 : fe.year) === P.year && G === P.month;
  }, H = (D, G, fe) => {
    var P, se;
    const ke = z();
    return Array.isArray(ke) ? m.value(G) === ((P = ke[fe]) == null ? void 0 : P.year) && D === ((se = ke[fe]) == null ? void 0 : se.month) : !1;
  }, U = (D, G) => {
    if (i.value.enabled) {
      const fe = z();
      if (Array.isArray(h.value) && Array.isArray(fe)) {
        const P = H(D, G, 0) || H(D, G, 1), se = To(Tr(we()), D, m.value(G));
        return Hc(h.value, C.value, se) && !P;
      }
      return !1;
    }
    return !1;
  }, W = A(() => (D) => Yi(b.value, (G) => {
    var fe;
    const P = te(D, G.value), se = il(
      G.value,
      uk(m.value(D), l.value.minDate),
      ck(m.value(D), l.value.maxDate)
    ) || iN(l.value.disabledDates, m.value(D)).includes(G.value) || ((fe = c.value.months) == null ? void 0 : fe.includes(G.value)) || !sN(l.value.allowedDates, m.value(D), G.value), ke = U(G.value, D), Le = mk(s.value, G.value, m.value(D));
    return { active: P, disabled: se, isBetween: ke, highlighted: Le };
  })), Q = (D, G) => To(Tr(we()), D, m.value(G)), de = (D, G) => {
    const fe = h.value ? h.value : Tr(/* @__PURE__ */ new Date());
    h.value = To(fe, D, m.value(G)), e("auto-apply"), e("update-flow-step");
  }, re = (D, G) => {
    const fe = Q(D, G);
    i.value.fixedEnd || i.value.fixedStart ? h.value = kk(fe, h, e, i) : h.value ? k(fe, h.value) && (h.value = Eh(h, Q(D, G), e)) : h.value = [Q(D, G)], nt().then(() => {
      Kc(h.value, e, t.autoApply, t.modelAuto);
    });
  }, J = (D, G) => {
    Ch(Q(D, G), h, d.value.limit), e("auto-apply", !0);
  }, Ce = (D, G) => (y.value[G].month = D, ee(G, y.value[G].year, D), d.value.enabled ? J(D, G) : i.value.enabled ? re(D, G) : de(D, G)), ie = (D, G) => {
    v(D, G), ee(G, D, null);
  }, ee = (D, G, fe) => {
    let P = fe;
    if (!P && P !== 0) {
      const se = z();
      P = Array.isArray(se) ? se[D].month : se.month;
    }
    e("update-month-year", { instance: D, year: G, month: P });
  };
  return {
    groupedMonths: W,
    groupedYears: E,
    year: m,
    isDisabled: R,
    defaultedMultiCalendars: n,
    defaultedAriaLabels: r,
    defaultedTransitions: o,
    defaultedConfig: a,
    showYearPicker: _,
    modelValue: h,
    presetDate: (D, G) => {
      bk({
        value: D,
        modelValue: h,
        range: i.value.enabled,
        timezone: G ? void 0 : u.value.timezone
      }), e("auto-apply");
    },
    setHoverDate: (D, G) => {
      C.value = Q(D, G);
    },
    selectMonth: Ce,
    selectYear: ie,
    toggleYearPicker: T,
    handleYearSelect: M,
    handleYear: O,
    getModelMonthYear: z
  };
}, BN = /* @__PURE__ */ j({
  compatConfig: {
    MODE: 3
  },
  __name: "MonthPicker",
  props: {
    ...Br
  },
  emits: [
    "update:internal-model-value",
    "overlay-closed",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year",
    "update-flow-step",
    "mount",
    "invalid-fixed-range",
    "overlay-toggle"
  ],
  setup(t, { expose: e, emit: n }) {
    const r = n, o = uo(), a = Zn(o, "yearMode"), i = t;
    ze(() => {
      i.shadow || r("mount", null);
    });
    const {
      groupedMonths: s,
      groupedYears: l,
      year: u,
      isDisabled: c,
      defaultedMultiCalendars: d,
      defaultedConfig: f,
      showYearPicker: h,
      modelValue: m,
      presetDate: g,
      setHoverDate: y,
      selectMonth: b,
      selectYear: C,
      toggleYearPicker: k,
      handleYearSelect: v,
      handleYear: E,
      getModelMonthYear: _
    } = LN(i, r);
    return e({ getSidebarProps: () => ({
      modelValue: m,
      year: u,
      getModelMonthYear: _,
      selectMonth: b,
      selectYear: C,
      handleYear: E
    }), presetDate: g, toggleYearPicker: (T) => k(0, T) }), (T, M) => (w(), I(Wc, {
      "multi-calendars": p(d).count,
      collapse: T.collapse,
      stretch: "",
      "is-mobile": T.isMobile
    }, {
      default: S(({ instance: O }) => [
        T.$slots["top-extra"] ? $(T.$slots, "top-extra", {
          key: 0,
          value: T.internalModelValue
        }) : V("", !0),
        T.$slots["month-year"] ? $(T.$slots, "month-year", Ye(oe({ key: 1 }, {
          year: p(u),
          months: p(s)(O),
          years: p(l)(O),
          selectMonth: p(b),
          selectYear: p(C),
          instance: O
        }))) : (w(), I($l, {
          key: 2,
          items: p(s)(O),
          "arrow-navigation": T.arrowNavigation,
          "is-last": T.autoApply && !p(f).keepActionRow,
          "esc-close": T.escClose,
          height: p(f).modeHeight,
          config: T.config,
          "no-overlay-focus": !!(T.noOverlayFocus || T.textInput),
          "use-relative": "",
          type: "month",
          onSelected: (R) => p(b)(R, O),
          onHoverValue: (R) => p(y)(R, O)
        }, At({
          header: S(() => [
            q(yk, oe(T.$props, {
              items: p(l)(O),
              instance: O,
              "show-year-picker": p(h)[O],
              year: p(u)(O),
              "is-disabled": (R) => p(c)(O, R),
              onHandleYear: (R) => p(E)(O, R),
              onYearSelect: (R) => p(v)(R, O),
              onToggleYearPicker: (R) => p(k)(O, R == null ? void 0 : R.flow, R == null ? void 0 : R.show)
            }), At({ _: 2 }, [
              et(p(a), (R, N) => ({
                name: R,
                fn: S((z) => [
                  $(T.$slots, R, Ye(ot(z)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          _: 2
        }, [
          T.$slots["month-overlay-value"] ? {
            name: "item",
            fn: S(({ item: R }) => [
              $(T.$slots, "month-overlay-value", {
                text: R.text,
                value: R.value
              })
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["items", "arrow-navigation", "is-last", "esc-close", "height", "config", "no-overlay-focus", "onSelected", "onHoverValue"]))
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse", "is-mobile"]));
  }
}), FN = (t, e) => {
  const n = () => {
    t.isTextInputDate && (c.value = Qe(we(t.startDate)));
  }, { modelValue: r } = Ll(t, e, n), o = F(null), { defaultedHighlight: a, defaultedMultiDates: i, defaultedFilters: s, defaultedRange: l, propDates: u } = $t(t), c = F();
  ze(() => {
    t.startDate && (r.value && t.focusStartDate || !r.value) && (c.value = Qe(we(t.startDate)));
  });
  const d = (g) => Array.isArray(r.value) ? r.value.some((y) => Qe(y) === g) : r.value ? Qe(r.value) === g : !1, f = (g) => l.value.enabled && Array.isArray(r.value) ? Hc(r.value, o.value, m(g)) : !1, h = A(() => Yi(bh(t.yearRange, t.locale, t.reverseYears), (g) => {
    const y = d(g.value), b = il(
      g.value,
      qi(u.value.minDate),
      qi(u.value.maxDate)
    ) || s.value.years.includes(g.value), C = f(g.value) && !y, k = _h(a.value, g.value);
    return { active: y, disabled: b, isBetween: C, highlighted: k };
  })), m = (g) => Gr(Tr(ol(/* @__PURE__ */ new Date())), g);
  return {
    groupedYears: h,
    modelValue: r,
    focusYear: c,
    setHoverValue: (g) => {
      o.value = Gr(Tr(/* @__PURE__ */ new Date()), g);
    },
    selectYear: (g) => {
      var y;
      if (e("update-month-year", { instance: 0, year: g }), i.value.enabled)
        return r.value ? Array.isArray(r.value) && (((y = r.value) == null ? void 0 : y.map((b) => Qe(b))).includes(g) ? r.value = r.value.filter((b) => Qe(b) !== g) : r.value.push(Gr($n(we()), g))) : r.value = [Gr($n(ol(we())), g)], e("auto-apply", !0);
      l.value.enabled ? (r.value = Eh(r, m(g), e), nt().then(() => {
        Kc(r.value, e, t.autoApply, t.modelAuto);
      })) : (r.value = m(g), e("auto-apply"));
    }
  };
}, VN = /* @__PURE__ */ j({
  compatConfig: {
    MODE: 3
  },
  __name: "YearPicker",
  props: {
    ...Br
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year"
  ],
  setup(t, { expose: e, emit: n }) {
    const r = n, o = t, { groupedYears: a, modelValue: i, focusYear: s, selectYear: l, setHoverValue: u } = FN(o, r), { defaultedConfig: c } = $t(o);
    return e({ getSidebarProps: () => ({
      modelValue: i,
      selectYear: l
    }) }), (d, f) => (w(), K("div", null, [
      d.$slots["top-extra"] ? $(d.$slots, "top-extra", {
        key: 0,
        value: d.internalModelValue
      }) : V("", !0),
      d.$slots["month-year"] ? $(d.$slots, "month-year", Ye(oe({ key: 1 }, {
        years: p(a),
        selectYear: p(l)
      }))) : (w(), I($l, {
        key: 2,
        items: p(a),
        "is-last": d.autoApply && !p(c).keepActionRow,
        height: p(c).modeHeight,
        config: d.config,
        "no-overlay-focus": !!(d.noOverlayFocus || d.textInput),
        "focus-value": p(s),
        type: "year",
        "use-relative": "",
        onSelected: p(l),
        onHoverValue: p(u)
      }, At({ _: 2 }, [
        d.$slots["year-overlay-value"] ? {
          name: "item",
          fn: S(({ item: h }) => [
            $(d.$slots, "year-overlay-value", {
              text: h.text,
              value: h.value
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["items", "is-last", "height", "config", "no-overlay-focus", "focus-value", "onSelected", "onHoverValue"]))
    ]));
  }
}), HN = {
  key: 0,
  class: "dp__time_input"
}, UN = ["data-compact", "data-collapsed"], WN = ["data-test-id", "aria-label", "onKeydown", "onClick", "onMousedown"], KN = ["aria-label", "disabled", "data-test-id", "onKeydown", "onClick"], jN = ["data-test-id", "aria-label", "onKeydown", "onClick", "onMousedown"], zN = { key: 0 }, YN = ["aria-label", "data-compact"], qN = /* @__PURE__ */ j({
  compatConfig: {
    MODE: 3
  },
  __name: "TimeInput",
  props: {
    hours: { type: Number, default: 0 },
    minutes: { type: Number, default: 0 },
    seconds: { type: Number, default: 0 },
    closeTimePickerBtn: { type: Object, default: null },
    order: { type: Number, default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: { type: Function, default: () => !1 },
    ...Br
  },
  emits: [
    "set-hours",
    "set-minutes",
    "update:hours",
    "update:minutes",
    "update:seconds",
    "reset-flow",
    "mounted",
    "overlay-closed",
    "overlay-opened",
    "am-pm-change"
  ],
  setup(t, { expose: e, emit: n }) {
    const r = n, o = t, { setTimePickerElements: a, setTimePickerBackRef: i } = ba(), {
      defaultedAriaLabels: s,
      defaultedTransitions: l,
      defaultedFilters: u,
      defaultedConfig: c,
      defaultedRange: d,
      defaultedMultiCalendars: f
    } = $t(o), { transitionName: h, showTransition: m } = Rl(l), g = eo({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), y = F("AM"), b = F(null), C = F([]), k = F(), v = F(!1);
    ze(() => {
      r("mounted");
    });
    const E = (B) => Tt(/* @__PURE__ */ new Date(), {
      hours: B.hours,
      minutes: B.minutes,
      seconds: o.enableSeconds ? B.seconds : 0,
      milliseconds: 0
    }), _ = A(
      () => (B) => re(B, o[B]) || M(B, o[B])
    ), T = A(() => ({ hours: o.hours, minutes: o.minutes, seconds: o.seconds })), M = (B, me) => d.value.enabled && !d.value.disableTimeRangeValidation ? !o.validateTime(B, me) : !1, O = (B, me) => {
      if (d.value.enabled && !d.value.disableTimeRangeValidation) {
        const Ve = me ? +o[`${B}Increment`] : -+o[`${B}Increment`], Ee = o[B] + Ve;
        return !o.validateTime(B, Ee);
      }
      return !1;
    }, R = A(() => (B) => !D(+o[B] + +o[`${B}Increment`], B) || O(B, !0)), N = A(() => (B) => !D(+o[B] - +o[`${B}Increment`], B) || O(B, !1)), z = (B, me) => F0(Tt(we(), B), me), te = (B, me) => UP(Tt(we(), B), me), H = A(
      () => ({
        dp__time_col: !0,
        dp__time_col_block: !o.timePickerInline,
        dp__time_col_reg_block: !o.enableSeconds && o.is24 && !o.timePickerInline,
        dp__time_col_reg_inline: !o.enableSeconds && o.is24 && o.timePickerInline,
        dp__time_col_reg_with_button: !o.enableSeconds && !o.is24,
        dp__time_col_sec: o.enableSeconds && o.is24,
        dp__time_col_sec_with_button: o.enableSeconds && !o.is24
      })
    ), U = A(
      () => o.timePickerInline && d.value.enabled && !f.value.count
    ), W = A(() => {
      const B = [{ type: "hours" }];
      return o.enableMinutes && B.push({ type: "", separator: !0 }, {
        type: "minutes"
      }), o.enableSeconds && B.push({ type: "", separator: !0 }, {
        type: "seconds"
      }), B;
    }), Q = A(() => W.value.filter((B) => !B.separator)), de = A(() => (B) => {
      if (B === "hours") {
        const me = Le(+o.hours);
        return { text: me < 10 ? `0${me}` : `${me}`, value: me };
      }
      return { text: o[B] < 10 ? `0${o[B]}` : `${o[B]}`, value: o[B] };
    }), re = (B, me) => {
      var Ve;
      if (!o.disabledTimesConfig) return !1;
      const Ee = o.disabledTimesConfig(o.order, B === "hours" ? me : void 0);
      return Ee[B] ? !!((Ve = Ee[B]) != null && Ve.includes(me)) : !0;
    }, J = (B, me) => me !== "hours" || y.value === "AM" ? B : B + 12, Ce = (B) => {
      const me = o.is24 ? 24 : 12, Ve = B === "hours" ? me : 60, Ee = +o[`${B}GridIncrement`], st = B === "hours" && !o.is24 ? Ee : 0, L = [];
      for (let x = st; x < Ve; x += Ee)
        L.push({ value: o.is24 ? x : J(x, B), text: x < 10 ? `0${x}` : `${x}` });
      return B === "hours" && !o.is24 && L.unshift({ value: y.value === "PM" ? 12 : 0, text: "12" }), Yi(L, (x) => ({ active: !1, disabled: u.value.times[B].includes(x.value) || !D(x.value, B) || re(B, x.value) || M(B, x.value) }));
    }, ie = (B) => B >= 0 ? B : 59, ee = (B) => B >= 0 ? B : 23, D = (B, me) => {
      const Ve = o.minTime ? E(Ed(o.minTime)) : null, Ee = o.maxTime ? E(Ed(o.maxTime)) : null, st = E(
        Ed(
          T.value,
          me,
          me === "minutes" || me === "seconds" ? ie(B) : ee(B)
        )
      );
      return Ve && Ee ? (al(st, Ee) || Mi(st, Ee)) && (ji(st, Ve) || Mi(st, Ve)) : Ve ? ji(st, Ve) || Mi(st, Ve) : Ee ? al(st, Ee) || Mi(st, Ee) : !0;
    }, G = (B) => o[`no${B[0].toUpperCase() + B.slice(1)}Overlay`], fe = (B) => {
      G(B) || (g[B] = !g[B], g[B] ? (v.value = !0, r("overlay-opened", B)) : (v.value = !1, r("overlay-closed", B)));
    }, P = (B) => B === "hours" ? $o : B === "minutes" ? fa : Ki, se = () => {
      k.value && clearTimeout(k.value);
    }, ke = (B, me = !0, Ve) => {
      const Ee = me ? z : te, st = me ? +o[`${B}Increment`] : -+o[`${B}Increment`];
      D(+o[B] + st, B) && r(
        `update:${B}`,
        P(B)(Ee({ [B]: +o[B] }, { [B]: +o[`${B}Increment`] }))
      ), !(Ve != null && Ve.keyboard) && c.value.timeArrowHoldThreshold && (k.value = setTimeout(() => {
        ke(B, me);
      }, c.value.timeArrowHoldThreshold));
    }, Le = (B) => o.is24 ? B : (B >= 12 ? y.value = "PM" : y.value = "AM", qP(B)), ne = () => {
      y.value === "PM" ? (y.value = "AM", r("update:hours", o.hours - 12)) : (y.value = "PM", r("update:hours", o.hours + 12)), r("am-pm-change", y.value);
    }, ye = (B) => {
      g[B] = !0;
    }, pe = (B, me, Ve) => {
      if (B && o.arrowNavigation) {
        Array.isArray(C.value[me]) ? C.value[me][Ve] = B : C.value[me] = [B];
        const Ee = C.value.reduce(
          (st, L) => L.map((x, Y) => [...st[Y] || [], L[Y]]),
          []
        );
        i(o.closeTimePickerBtn), b.value && (Ee[1] = Ee[1].concat(b.value)), a(Ee, o.order);
      }
    }, Z = (B, me) => (fe(B), r(`update:${B}`, me));
    return e({ openChildCmp: ye }), (B, me) => {
      var Ve;
      return B.disabled ? V("", !0) : (w(), K("div", HN, [
        (w(!0), K(Me, null, et(W.value, (Ee, st) => {
          var L, x, Y;
          return w(), K("div", {
            key: st,
            class: Ie(H.value),
            "data-compact": U.value && !B.enableSeconds,
            "data-collapsed": U.value && B.enableSeconds
          }, [
            Ee.separator ? (w(), K(Me, { key: 0 }, [
              v.value ? V("", !0) : (w(), K(Me, { key: 0 }, [
                We(":")
              ], 64))
            ], 64)) : (w(), K(Me, { key: 1 }, [
              be("button", {
                ref_for: !0,
                ref: (ge) => pe(ge, st, 0),
                type: "button",
                class: Ie({
                  dp__btn: !0,
                  dp__inc_dec_button: !B.timePickerInline,
                  dp__inc_dec_button_inline: B.timePickerInline,
                  dp__tp_inline_btn_top: B.timePickerInline,
                  dp__inc_dec_button_disabled: R.value(Ee.type),
                  "dp--hidden-el": v.value
                }),
                "data-test-id": `${Ee.type}-time-inc-btn-${o.order}`,
                "aria-label": (L = p(s)) == null ? void 0 : L.incrementValue(Ee.type),
                tabindex: "0",
                onKeydown: (ge) => p(Dn)(ge, () => ke(Ee.type, !0, { keyboard: !0 }), !0),
                onClick: (ge) => p(c).timeArrowHoldThreshold ? void 0 : ke(Ee.type, !0),
                onMousedown: (ge) => p(c).timeArrowHoldThreshold ? ke(Ee.type, !0) : void 0,
                onMouseup: se
              }, [
                o.timePickerInline ? (w(), K(Me, { key: 1 }, [
                  B.$slots["tp-inline-arrow-up"] ? $(B.$slots, "tp-inline-arrow-up", { key: 0 }) : (w(), K(Me, { key: 1 }, [
                    me[2] || (me[2] = be("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                    me[3] || (me[3] = be("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
                  ], 64))
                ], 64)) : (w(), K(Me, { key: 0 }, [
                  B.$slots["arrow-up"] ? $(B.$slots, "arrow-up", { key: 0 }) : V("", !0),
                  B.$slots["arrow-up"] ? V("", !0) : (w(), I(p(gh), { key: 1 }))
                ], 64))
              ], 42, WN),
              be("button", {
                ref_for: !0,
                ref: (ge) => pe(ge, st, 1),
                type: "button",
                "aria-label": `${de.value(Ee.type).text}-${(x = p(s)) == null ? void 0 : x.openTpOverlay(Ee.type)}`,
                class: Ie({
                  dp__time_display: !0,
                  dp__time_display_block: !B.timePickerInline,
                  dp__time_display_inline: B.timePickerInline,
                  "dp--time-invalid": _.value(Ee.type),
                  "dp--time-overlay-btn": !_.value(Ee.type),
                  "dp--hidden-el": v.value
                }),
                disabled: G(Ee.type),
                tabindex: "0",
                "data-test-id": `${Ee.type}-toggle-overlay-btn-${o.order}`,
                onKeydown: (ge) => p(Dn)(ge, () => fe(Ee.type), !0),
                onClick: (ge) => fe(Ee.type)
              }, [
                B.$slots[Ee.type] ? $(B.$slots, Ee.type, {
                  key: 0,
                  text: de.value(Ee.type).text,
                  value: de.value(Ee.type).value
                }) : V("", !0),
                B.$slots[Ee.type] ? V("", !0) : (w(), K(Me, { key: 1 }, [
                  We(Se(de.value(Ee.type).text), 1)
                ], 64))
              ], 42, KN),
              be("button", {
                ref_for: !0,
                ref: (ge) => pe(ge, st, 2),
                type: "button",
                class: Ie({
                  dp__btn: !0,
                  dp__inc_dec_button: !B.timePickerInline,
                  dp__inc_dec_button_inline: B.timePickerInline,
                  dp__tp_inline_btn_bottom: B.timePickerInline,
                  dp__inc_dec_button_disabled: N.value(Ee.type),
                  "dp--hidden-el": v.value
                }),
                "data-test-id": `${Ee.type}-time-dec-btn-${o.order}`,
                "aria-label": (Y = p(s)) == null ? void 0 : Y.decrementValue(Ee.type),
                tabindex: "0",
                onKeydown: (ge) => p(Dn)(ge, () => ke(Ee.type, !1, { keyboard: !0 }), !0),
                onClick: (ge) => p(c).timeArrowHoldThreshold ? void 0 : ke(Ee.type, !1),
                onMousedown: (ge) => p(c).timeArrowHoldThreshold ? ke(Ee.type, !1) : void 0,
                onMouseup: se
              }, [
                o.timePickerInline ? (w(), K(Me, { key: 1 }, [
                  B.$slots["tp-inline-arrow-down"] ? $(B.$slots, "tp-inline-arrow-down", { key: 0 }) : (w(), K(Me, { key: 1 }, [
                    me[4] || (me[4] = be("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                    me[5] || (me[5] = be("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
                  ], 64))
                ], 64)) : (w(), K(Me, { key: 0 }, [
                  B.$slots["arrow-down"] ? $(B.$slots, "arrow-down", { key: 0 }) : V("", !0),
                  B.$slots["arrow-down"] ? V("", !0) : (w(), I(p(vh), { key: 1 }))
                ], 64))
              ], 42, jN)
            ], 64))
          ], 10, UN);
        }), 128)),
        B.is24 ? V("", !0) : (w(), K("div", zN, [
          B.$slots["am-pm-button"] ? $(B.$slots, "am-pm-button", {
            key: 0,
            toggle: ne,
            value: y.value
          }) : V("", !0),
          B.$slots["am-pm-button"] ? V("", !0) : (w(), K("button", {
            key: 1,
            ref_key: "amPmButton",
            ref: b,
            type: "button",
            class: "dp__pm_am_button",
            role: "button",
            "aria-label": (Ve = p(s)) == null ? void 0 : Ve.amPmButton,
            tabindex: "0",
            "data-compact": U.value,
            onClick: ne,
            onKeydown: me[0] || (me[0] = (Ee) => p(Dn)(Ee, () => ne(), !0))
          }, Se(y.value), 41, YN))
        ])),
        (w(!0), K(Me, null, et(Q.value, (Ee, st) => (w(), I(ss, {
          key: st,
          name: p(h)(g[Ee.type]),
          css: p(m)
        }, {
          default: S(() => {
            var L, x;
            return [
              g[Ee.type] ? (w(), I($l, {
                key: 0,
                items: Ce(Ee.type),
                "is-last": B.autoApply && !p(c).keepActionRow,
                "esc-close": B.escClose,
                type: Ee.type,
                "text-input": B.textInput,
                config: B.config,
                "arrow-navigation": B.arrowNavigation,
                "aria-labels": B.ariaLabels,
                "overlay-label": (x = (L = p(s)).timeOverlay) == null ? void 0 : x.call(L, Ee.type),
                onSelected: (Y) => Z(Ee.type, Y),
                onToggle: (Y) => fe(Ee.type),
                onResetFlow: me[1] || (me[1] = (Y) => B.$emit("reset-flow"))
              }, At({
                "button-icon": S(() => [
                  B.$slots["clock-icon"] ? $(B.$slots, "clock-icon", { key: 0 }) : V("", !0),
                  B.$slots["clock-icon"] ? V("", !0) : (w(), I(On(B.timePickerInline ? p(vs) : p(mh)), { key: 1 }))
                ]),
                _: 2
              }, [
                B.$slots[`${Ee.type}-overlay-value`] ? {
                  name: "item",
                  fn: S(({ item: Y }) => [
                    $(B.$slots, `${Ee.type}-overlay-value`, {
                      text: Y.text,
                      value: Y.value
                    })
                  ]),
                  key: "0"
                } : void 0,
                B.$slots[`${Ee.type}-overlay-header`] ? {
                  name: "header",
                  fn: S(() => [
                    $(B.$slots, `${Ee.type}-overlay-header`, {
                      toggle: () => fe(Ee.type)
                    })
                  ]),
                  key: "1"
                } : void 0
              ]), 1032, ["items", "is-last", "esc-close", "type", "text-input", "config", "arrow-navigation", "aria-labels", "overlay-label", "onSelected", "onToggle"])) : V("", !0)
            ];
          }),
          _: 2
        }, 1032, ["name", "css"]))), 128))
      ]));
    };
  }
}), GN = ["data-dp-mobile"], JN = ["aria-label", "tabindex"], XN = ["role", "aria-label", "tabindex"], QN = ["aria-label"], _k = /* @__PURE__ */ j({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePicker",
  props: {
    hours: { type: [Number, Array], default: 0 },
    minutes: { type: [Number, Array], default: 0 },
    seconds: { type: [Number, Array], default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: {
      type: Function,
      default: () => !1
    },
    ...Br
  },
  emits: [
    "update:hours",
    "update:minutes",
    "update:seconds",
    "mount",
    "reset-flow",
    "overlay-opened",
    "overlay-closed",
    "am-pm-change"
  ],
  setup(t, { expose: e, emit: n }) {
    const r = n, o = t, { buildMatrix: a, setTimePicker: i } = ba(), s = uo(), { defaultedTransitions: l, defaultedAriaLabels: u, defaultedTextInput: c, defaultedConfig: d, defaultedRange: f } = $t(o), { transitionName: h, showTransition: m } = Rl(l), { hideNavigationButtons: g } = jc(), y = F(null), b = F(null), C = F([]), k = F(null), v = F(!1);
    ze(() => {
      r("mount"), !o.timePicker && o.arrowNavigation ? a([en(y.value)], "time") : i(!0, o.timePicker);
    });
    const E = A(() => f.value.enabled && o.modelAuto ? ik(o.internalModelValue) : !0), _ = F(!1), T = (re) => ({
      hours: Array.isArray(o.hours) ? o.hours[re] : o.hours,
      minutes: Array.isArray(o.minutes) ? o.minutes[re] : o.minutes,
      seconds: Array.isArray(o.seconds) ? o.seconds[re] : o.seconds
    }), M = A(() => {
      const re = [];
      if (f.value.enabled)
        for (let J = 0; J < 2; J++)
          re.push(T(J));
      else
        re.push(T(0));
      return re;
    }), O = (re, J = !1, Ce = "") => {
      J || r("reset-flow"), _.value = re, r(re ? "overlay-opened" : "overlay-closed", wn.time), o.arrowNavigation && i(re), nt(() => {
        Ce !== "" && C.value[0] && C.value[0].openChildCmp(Ce);
      });
    }, R = A(() => ({
      dp__btn: !0,
      dp__button: !0,
      dp__button_bottom: o.autoApply && !d.value.keepActionRow
    })), N = Zn(s, "timePicker"), z = (re, J, Ce) => f.value.enabled ? J === 0 ? [re, M.value[1][Ce]] : [M.value[0][Ce], re] : re, te = (re) => {
      r("update:hours", re);
    }, H = (re) => {
      r("update:minutes", re);
    }, U = (re) => {
      r("update:seconds", re);
    }, W = () => {
      if (k.value && !c.value.enabled && !o.noOverlayFocus) {
        const re = sk(k.value);
        re && re.focus({ preventScroll: !0 });
      }
    }, Q = (re) => {
      v.value = !1, r("overlay-closed", re);
    }, de = (re) => {
      v.value = !0, r("overlay-opened", re);
    };
    return e({ toggleTimePicker: O }), (re, J) => {
      var Ce;
      return w(), K("div", {
        class: "dp--tp-wrap",
        "data-dp-mobile": re.isMobile
      }, [
        !re.timePicker && !re.timePickerInline ? Xr((w(), K("button", {
          key: 0,
          ref_key: "openTimePickerBtn",
          ref: y,
          type: "button",
          class: Ie({ ...R.value, "dp--hidden-el": _.value }),
          "aria-label": (Ce = p(u)) == null ? void 0 : Ce.openTimePicker,
          tabindex: re.noOverlayFocus ? void 0 : 0,
          "data-test-id": "open-time-picker-btn",
          onKeydown: J[0] || (J[0] = (ie) => p(Dn)(ie, () => O(!0))),
          onClick: J[1] || (J[1] = (ie) => O(!0))
        }, [
          re.$slots["clock-icon"] ? $(re.$slots, "clock-icon", { key: 0 }) : V("", !0),
          re.$slots["clock-icon"] ? V("", !0) : (w(), I(p(mh), { key: 1 }))
        ], 42, JN)), [
          [cu, !p(g)(re.hideNavigation, "time")]
        ]) : V("", !0),
        q(ss, {
          name: p(h)(_.value),
          css: p(m) && !re.timePickerInline
        }, {
          default: S(() => {
            var ie, ee;
            return [
              _.value || re.timePicker || re.timePickerInline ? (w(), K("div", {
                key: 0,
                ref_key: "overlayRef",
                ref: k,
                role: re.timePickerInline ? void 0 : "dialog",
                class: Ie({
                  dp__overlay: !re.timePickerInline,
                  "dp--overlay-absolute": !o.timePicker && !re.timePickerInline,
                  "dp--overlay-relative": o.timePicker
                }),
                style: Lt(re.timePicker ? { height: `${p(d).modeHeight}px` } : void 0),
                "aria-label": (ie = p(u)) == null ? void 0 : ie.timePicker,
                tabindex: re.timePickerInline ? void 0 : 0
              }, [
                be("div", {
                  class: Ie(
                    re.timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"
                  ),
                  style: { display: "flex" }
                }, [
                  re.$slots["time-picker-overlay"] ? $(re.$slots, "time-picker-overlay", {
                    key: 0,
                    hours: t.hours,
                    minutes: t.minutes,
                    seconds: t.seconds,
                    setHours: te,
                    setMinutes: H,
                    setSeconds: U
                  }) : V("", !0),
                  re.$slots["time-picker-overlay"] ? V("", !0) : (w(), K("div", {
                    key: 1,
                    class: Ie(re.timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
                  }, [
                    (w(!0), K(Me, null, et(M.value, (D, G) => Xr((w(), I(qN, oe({
                      key: G,
                      ref_for: !0
                    }, {
                      ...re.$props,
                      order: G,
                      hours: D.hours,
                      minutes: D.minutes,
                      seconds: D.seconds,
                      closeTimePickerBtn: b.value,
                      disabledTimesConfig: t.disabledTimesConfig,
                      disabled: G === 0 ? p(f).fixedStart : p(f).fixedEnd
                    }, {
                      ref_for: !0,
                      ref_key: "timeInputRefs",
                      ref: C,
                      "validate-time": (fe, P) => t.validateTime(fe, z(P, G, fe)),
                      "onUpdate:hours": (fe) => te(z(fe, G, "hours")),
                      "onUpdate:minutes": (fe) => H(z(fe, G, "minutes")),
                      "onUpdate:seconds": (fe) => U(z(fe, G, "seconds")),
                      onMounted: W,
                      onOverlayClosed: Q,
                      onOverlayOpened: de,
                      onAmPmChange: J[2] || (J[2] = (fe) => re.$emit("am-pm-change", fe))
                    }), At({ _: 2 }, [
                      et(p(N), (fe, P) => ({
                        name: fe,
                        fn: S((se) => [
                          $(re.$slots, fe, oe({ ref_for: !0 }, se))
                        ])
                      }))
                    ]), 1040, ["validate-time", "onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                      [cu, G === 0 ? !0 : E.value]
                    ])), 128))
                  ], 2)),
                  !re.timePicker && !re.timePickerInline ? Xr((w(), K("button", {
                    key: 2,
                    ref_key: "closeTimePickerBtn",
                    ref: b,
                    type: "button",
                    class: Ie({ ...R.value, "dp--hidden-el": v.value }),
                    "aria-label": (ee = p(u)) == null ? void 0 : ee.closeTimePicker,
                    tabindex: "0",
                    onKeydown: J[3] || (J[3] = (D) => p(Dn)(D, () => O(!1))),
                    onClick: J[4] || (J[4] = (D) => O(!1))
                  }, [
                    re.$slots["calendar-icon"] ? $(re.$slots, "calendar-icon", { key: 0 }) : V("", !0),
                    re.$slots["calendar-icon"] ? V("", !0) : (w(), I(p(vs), { key: 1 }))
                  ], 42, QN)), [
                    [cu, !p(g)(re.hideNavigation, "time")]
                  ]) : V("", !0)
                ], 2)
              ], 14, XN)) : V("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ], 8, GN);
    };
  }
}), Ck = (t, e, n, r) => {
  const { defaultedRange: o } = $t(t), a = (k, v) => Array.isArray(e[k]) ? e[k][v] : e[k], i = (k) => t.enableSeconds ? Array.isArray(e.seconds) ? e.seconds[k] : e.seconds : 0, s = (k, v) => k ? v !== void 0 ? na(k, a("hours", v), a("minutes", v), i(v)) : na(k, e.hours, e.minutes, i()) : nk(we(), i(v)), l = (k, v) => {
    e[k] = v;
  }, u = A(() => t.modelAuto && o.value.enabled ? Array.isArray(n.value) ? n.value.length > 1 : !1 : o.value.enabled), c = (k, v) => {
    const E = Object.fromEntries(
      Object.keys(e).map((_) => _ === k ? [_, v] : [_, e[_]].slice())
    );
    if (u.value && !o.value.disableTimeRangeValidation) {
      const _ = (M) => n.value ? na(
        n.value[M],
        E.hours[M],
        E.minutes[M],
        E.seconds[M]
      ) : null, T = (M) => tk(n.value[M], 0);
      return !(mt(_(0), _(1)) && (ji(_(0), T(1)) || al(_(1), T(0))));
    }
    return !0;
  }, d = (k, v) => {
    c(k, v) && (l(k, v), r && r());
  }, f = (k) => {
    d("hours", k);
  }, h = (k) => {
    d("minutes", k);
  }, m = (k) => {
    d("seconds", k);
  }, g = (k, v, E, _) => {
    v && f(k), !v && !E && h(k), E && m(k), n.value && _(n.value);
  }, y = (k) => {
    if (k) {
      const v = Array.isArray(k), E = v ? [+k[0].hours, +k[1].hours] : +k.hours, _ = v ? [+k[0].minutes, +k[1].minutes] : +k.minutes, T = v ? [+k[0].seconds, +k[1].seconds] : +k.seconds;
      l("hours", E), l("minutes", _), t.enableSeconds && l("seconds", T);
    }
  }, b = (k, v) => {
    const E = {
      hours: Array.isArray(e.hours) ? e.hours[k] : e.hours,
      disabledArr: []
    };
    return (v || v === 0) && (E.hours = v), Array.isArray(t.disabledTimes) && (E.disabledArr = o.value.enabled && Array.isArray(t.disabledTimes[k]) ? t.disabledTimes[k] : t.disabledTimes), E;
  }, C = A(() => (k, v) => {
    var E;
    if (Array.isArray(t.disabledTimes)) {
      const { disabledArr: _, hours: T } = b(k, v), M = _.filter((O) => +O.hours === T);
      return ((E = M[0]) == null ? void 0 : E.minutes) === "*" ? { hours: [T], minutes: void 0, seconds: void 0 } : {
        hours: [],
        minutes: (M == null ? void 0 : M.map((O) => +O.minutes)) ?? [],
        seconds: (M == null ? void 0 : M.map((O) => O.seconds ? +O.seconds : void 0)) ?? []
      };
    }
    return { hours: [], minutes: [], seconds: [] };
  });
  return {
    setTime: l,
    updateHours: f,
    updateMinutes: h,
    updateSeconds: m,
    getSetDateTime: s,
    updateTimeValues: g,
    getSecondsValue: i,
    assignStartTime: y,
    validateTime: c,
    disabledTimesConfig: C
  };
}, ZN = (t, e) => {
  const n = () => {
    t.isTextInputDate && v();
  }, { modelValue: r, time: o } = Ll(t, e, n), { defaultedStartTime: a, defaultedRange: i, defaultedTz: s } = $t(t), { updateTimeValues: l, getSetDateTime: u, setTime: c, assignStartTime: d, disabledTimesConfig: f, validateTime: h } = Ck(t, o, r, m);
  function m() {
    e("update-flow-step");
  }
  const g = (_) => {
    const { hours: T, minutes: M, seconds: O } = _;
    return { hours: +T, minutes: +M, seconds: O ? +O : 0 };
  }, y = () => {
    if (t.startTime) {
      if (Array.isArray(t.startTime)) {
        const T = g(t.startTime[0]), M = g(t.startTime[1]);
        return [Tt(we(), T), Tt(we(), M)];
      }
      const _ = g(t.startTime);
      return Tt(we(), _);
    }
    return i.value.enabled ? [null, null] : null;
  }, b = () => {
    if (i.value.enabled) {
      const [_, T] = y();
      r.value = [
        jn(u(_, 0), s.value.timezone),
        jn(u(T, 1), s.value.timezone)
      ];
    } else
      r.value = jn(u(y()), s.value.timezone);
  }, C = (_) => Array.isArray(_) ? [Fa(we(_[0])), Fa(we(_[1]))] : [Fa(_ ?? we())], k = (_, T, M) => {
    c("hours", _), c("minutes", T), c("seconds", t.enableSeconds ? M : 0);
  }, v = () => {
    const [_, T] = C(r.value);
    return i.value.enabled ? k(
      [_.hours, T.hours],
      [_.minutes, T.minutes],
      [_.seconds, T.seconds]
    ) : k(_.hours, _.minutes, _.seconds);
  };
  ze(() => {
    if (!t.shadow)
      return d(a.value), r.value ? v() : b();
  });
  const E = () => {
    Array.isArray(r.value) ? r.value = r.value.map((_, T) => _ && u(_, T)) : r.value = u(r.value), e("time-update");
  };
  return {
    modelValue: r,
    time: o,
    disabledTimesConfig: f,
    updateTime: (_, T = !0, M = !1) => {
      l(_, T, M, E);
    },
    validateTime: h
  };
}, e$ = /* @__PURE__ */ j({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePickerSolo",
  props: {
    ...Br
  },
  emits: [
    "update:internal-model-value",
    "time-update",
    "am-pm-change",
    "mount",
    "reset-flow",
    "update-flow-step",
    "overlay-toggle"
  ],
  setup(t, { expose: e, emit: n }) {
    const r = n, o = t, a = uo(), i = Zn(a, "timePicker"), s = F(null), { time: l, modelValue: u, disabledTimesConfig: c, updateTime: d, validateTime: f } = ZN(o, r);
    return ze(() => {
      o.shadow || r("mount", null);
    }), e({ getSidebarProps: () => ({
      modelValue: u,
      time: l,
      updateTime: d
    }), toggleTimePicker: (h, m = !1, g = "") => {
      var y;
      (y = s.value) == null || y.toggleTimePicker(h, m, g);
    } }), (h, m) => (w(), I(Wc, {
      "multi-calendars": 0,
      stretch: "",
      "is-mobile": h.isMobile
    }, {
      default: S(() => [
        q(_k, oe({
          ref_key: "tpRef",
          ref: s
        }, h.$props, {
          hours: p(l).hours,
          minutes: p(l).minutes,
          seconds: p(l).seconds,
          "internal-model-value": h.internalModelValue,
          "disabled-times-config": p(c),
          "validate-time": p(f),
          "onUpdate:hours": m[0] || (m[0] = (g) => p(d)(g)),
          "onUpdate:minutes": m[1] || (m[1] = (g) => p(d)(g, !1)),
          "onUpdate:seconds": m[2] || (m[2] = (g) => p(d)(g, !1, !0)),
          onAmPmChange: m[3] || (m[3] = (g) => h.$emit("am-pm-change", g)),
          onResetFlow: m[4] || (m[4] = (g) => h.$emit("reset-flow")),
          onOverlayClosed: m[5] || (m[5] = (g) => h.$emit("overlay-toggle", { open: !1, overlay: g })),
          onOverlayOpened: m[6] || (m[6] = (g) => h.$emit("overlay-toggle", { open: !0, overlay: g }))
        }), At({ _: 2 }, [
          et(p(i), (g, y) => ({
            name: g,
            fn: S((b) => [
              $(h.$slots, g, Ye(ot(b)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"])
      ]),
      _: 3
    }, 8, ["is-mobile"]));
  }
}), t$ = { class: "dp--header-wrap" }, n$ = {
  key: 0,
  class: "dp__month_year_wrap"
}, r$ = { key: 0 }, o$ = { class: "dp__month_year_wrap" }, a$ = ["data-dp-element", "aria-label", "data-test-id", "onClick", "onKeydown"], i$ = /* @__PURE__ */ j({
  compatConfig: {
    MODE: 3
  },
  __name: "DpHeader",
  props: {
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    instance: { type: Number, default: 0 },
    years: { type: Array, default: () => [] },
    months: { type: Array, default: () => [] },
    ...Br
  },
  emits: ["update-month-year", "mount", "reset-flow", "overlay-closed", "overlay-opened"],
  setup(t, { expose: e, emit: n }) {
    const r = n, o = t, {
      defaultedTransitions: a,
      defaultedAriaLabels: i,
      defaultedMultiCalendars: s,
      defaultedFilters: l,
      defaultedConfig: u,
      defaultedHighlight: c,
      propDates: d,
      defaultedUI: f
    } = $t(o), { transitionName: h, showTransition: m } = Rl(a), { buildMatrix: g } = ba(), { handleMonthYearChange: y, isDisabled: b, updateMonthYear: C } = TN(o, r), { showLeftIcon: k, showRightIcon: v } = jc(), E = F(!1), _ = F(!1), T = F(!1), M = F([null, null, null, null]);
    ze(() => {
      r("mount");
    });
    const O = (ee) => ({
      get: () => o[ee],
      set: (D) => {
        const G = ee === _r.month ? _r.year : _r.month;
        r("update-month-year", { [ee]: D, [G]: o[G] }), ee === _r.month ? Q(!0) : de(!0);
      }
    }), R = A(O(_r.month)), N = A(O(_r.year)), z = A(() => (ee) => ({
      month: o.month,
      year: o.year,
      items: ee === _r.month ? o.months : o.years,
      instance: o.instance,
      updateMonthYear: C,
      toggle: ee === _r.month ? Q : de
    })), te = A(() => o.months.find((D) => D.value === o.month) || { text: "", value: 0 }), H = A(() => Yi(o.months, (ee) => {
      const D = o.month === ee.value, G = il(
        ee.value,
        uk(o.year, d.value.minDate),
        ck(o.year, d.value.maxDate)
      ) || l.value.months.includes(ee.value), fe = mk(c.value, ee.value, o.year);
      return { active: D, disabled: G, highlighted: fe };
    })), U = A(() => Yi(o.years, (ee) => {
      const D = o.year === ee.value, G = il(
        ee.value,
        qi(d.value.minDate),
        qi(d.value.maxDate)
      ) || l.value.years.includes(ee.value), fe = _h(c.value, ee.value);
      return { active: D, disabled: G, highlighted: fe };
    })), W = (ee, D, G) => {
      G !== void 0 ? ee.value = G : ee.value = !ee.value, ee.value ? (T.value = !0, r("overlay-opened", D)) : (T.value = !1, r("overlay-closed", D));
    }, Q = (ee = !1, D) => {
      re(ee), W(E, wn.month, D);
    }, de = (ee = !1, D) => {
      re(ee), W(_, wn.year, D);
    }, re = (ee) => {
      ee || r("reset-flow");
    }, J = (ee, D) => {
      o.arrowNavigation && (M.value[D] = en(ee), g(M.value, "monthYear"));
    }, Ce = A(() => {
      var ee, D, G, fe, P, se;
      return [
        {
          type: _r.month,
          index: 1,
          toggle: Q,
          modelValue: R.value,
          updateModelValue: (ke) => R.value = ke,
          text: te.value.text,
          showSelectionGrid: E.value,
          items: H.value,
          ariaLabel: (ee = i.value) == null ? void 0 : ee.openMonthsOverlay,
          overlayLabel: ((G = (D = i.value).monthPicker) == null ? void 0 : G.call(D, !0)) ?? void 0
        },
        {
          type: _r.year,
          index: 2,
          toggle: de,
          modelValue: N.value,
          updateModelValue: (ke) => N.value = ke,
          text: lk(o.year, o.locale),
          showSelectionGrid: _.value,
          items: U.value,
          ariaLabel: (fe = i.value) == null ? void 0 : fe.openYearsOverlay,
          overlayLabel: ((se = (P = i.value).yearPicker) == null ? void 0 : se.call(P, !0)) ?? void 0
        }
      ];
    }), ie = A(() => o.disableYearSelect ? [Ce.value[0]] : o.yearFirst ? [...Ce.value].reverse() : Ce.value);
    return e({
      toggleMonthPicker: Q,
      toggleYearPicker: de,
      handleMonthYearChange: y
    }), (ee, D) => {
      var G, fe, P, se, ke, Le;
      return w(), K("div", t$, [
        ee.$slots["month-year"] ? (w(), K("div", n$, [
          $(ee.$slots, "month-year", Ye(ot({ month: t.month, year: t.year, months: t.months, years: t.years, updateMonthYear: p(C), handleMonthYearChange: p(y), instance: t.instance })))
        ])) : (w(), K(Me, { key: 1 }, [
          ee.$slots["top-extra"] ? (w(), K("div", r$, [
            $(ee.$slots, "top-extra", { value: ee.internalModelValue })
          ])) : V("", !0),
          be("div", o$, [
            p(k)(p(s), t.instance) && !ee.vertical ? (w(), I(Rs, {
              key: 0,
              "aria-label": (G = p(i)) == null ? void 0 : G.prevMonth,
              disabled: p(b)(!1),
              class: Ie((fe = p(f)) == null ? void 0 : fe.navBtnPrev),
              "el-name": "action-prev",
              onActivate: D[0] || (D[0] = (ne) => p(y)(!1, !0)),
              onSetRef: D[1] || (D[1] = (ne) => J(ne, 0))
            }, {
              default: S(() => [
                ee.$slots["arrow-left"] ? $(ee.$slots, "arrow-left", { key: 0 }) : V("", !0),
                ee.$slots["arrow-left"] ? V("", !0) : (w(), I(p(ph), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : V("", !0),
            be("div", {
              class: Ie(["dp__month_year_wrap", {
                dp__year_disable_select: ee.disableYearSelect
              }])
            }, [
              (w(!0), K(Me, null, et(ie.value, (ne, ye) => (w(), K(Me, {
                key: ne.type
              }, [
                be("button", {
                  ref_for: !0,
                  ref: (pe) => J(pe, ye + 1),
                  type: "button",
                  "data-dp-element": `overlay-${ne.type}`,
                  class: Ie(["dp__btn dp__month_year_select", { "dp--hidden-el": T.value }]),
                  "aria-label": `${ne.text}-${ne.ariaLabel}`,
                  "data-test-id": `${ne.type}-toggle-overlay-${t.instance}`,
                  onClick: ne.toggle,
                  onKeydown: (pe) => p(Dn)(pe, () => ne.toggle(), !0)
                }, [
                  ee.$slots[ne.type] ? $(ee.$slots, ne.type, {
                    key: 0,
                    text: ne.text,
                    value: o[ne.type]
                  }) : V("", !0),
                  ee.$slots[ne.type] ? V("", !0) : (w(), K(Me, { key: 1 }, [
                    We(Se(ne.text), 1)
                  ], 64))
                ], 42, a$),
                q(ss, {
                  name: p(h)(ne.showSelectionGrid),
                  css: p(m)
                }, {
                  default: S(() => [
                    ne.showSelectionGrid ? (w(), I($l, {
                      key: 0,
                      items: ne.items,
                      "arrow-navigation": ee.arrowNavigation,
                      "hide-navigation": ee.hideNavigation,
                      "is-last": ee.autoApply && !p(u).keepActionRow,
                      "skip-button-ref": !1,
                      config: ee.config,
                      type: ne.type,
                      "header-refs": [],
                      "esc-close": ee.escClose,
                      "menu-wrap-ref": ee.menuWrapRef,
                      "text-input": ee.textInput,
                      "aria-labels": ee.ariaLabels,
                      "overlay-label": ne.overlayLabel,
                      onSelected: ne.updateModelValue,
                      onToggle: ne.toggle
                    }, At({
                      "button-icon": S(() => [
                        ee.$slots["calendar-icon"] ? $(ee.$slots, "calendar-icon", { key: 0 }) : V("", !0),
                        ee.$slots["calendar-icon"] ? V("", !0) : (w(), I(p(vs), { key: 1 }))
                      ]),
                      _: 2
                    }, [
                      ee.$slots[`${ne.type}-overlay-value`] ? {
                        name: "item",
                        fn: S(({ item: pe }) => [
                          $(ee.$slots, `${ne.type}-overlay-value`, {
                            text: pe.text,
                            value: pe.value
                          })
                        ]),
                        key: "0"
                      } : void 0,
                      ee.$slots[`${ne.type}-overlay`] ? {
                        name: "overlay",
                        fn: S(() => [
                          $(ee.$slots, `${ne.type}-overlay`, oe({ ref_for: !0 }, z.value(ne.type)))
                        ]),
                        key: "1"
                      } : void 0,
                      ee.$slots[`${ne.type}-overlay-header`] ? {
                        name: "header",
                        fn: S(() => [
                          $(ee.$slots, `${ne.type}-overlay-header`, {
                            toggle: ne.toggle
                          })
                        ]),
                        key: "2"
                      } : void 0
                    ]), 1032, ["items", "arrow-navigation", "hide-navigation", "is-last", "config", "type", "esc-close", "menu-wrap-ref", "text-input", "aria-labels", "overlay-label", "onSelected", "onToggle"])) : V("", !0)
                  ]),
                  _: 2
                }, 1032, ["name", "css"])
              ], 64))), 128))
            ], 2),
            p(k)(p(s), t.instance) && ee.vertical ? (w(), I(Rs, {
              key: 1,
              "aria-label": (P = p(i)) == null ? void 0 : P.prevMonth,
              "el-name": "action-prev",
              disabled: p(b)(!1),
              class: Ie((se = p(f)) == null ? void 0 : se.navBtnPrev),
              onActivate: D[2] || (D[2] = (ne) => p(y)(!1, !0))
            }, {
              default: S(() => [
                ee.$slots["arrow-up"] ? $(ee.$slots, "arrow-up", { key: 0 }) : V("", !0),
                ee.$slots["arrow-up"] ? V("", !0) : (w(), I(p(gh), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : V("", !0),
            p(v)(p(s), t.instance) ? (w(), I(Rs, {
              key: 2,
              ref: "rightIcon",
              "el-name": "action-next",
              disabled: p(b)(!0),
              "aria-label": (ke = p(i)) == null ? void 0 : ke.nextMonth,
              class: Ie((Le = p(f)) == null ? void 0 : Le.navBtnNext),
              onActivate: D[3] || (D[3] = (ne) => p(y)(!0, !0)),
              onSetRef: D[4] || (D[4] = (ne) => J(ne, ee.disableYearSelect ? 2 : 3))
            }, {
              default: S(() => [
                ee.$slots[ee.vertical ? "arrow-down" : "arrow-right"] ? $(ee.$slots, ee.vertical ? "arrow-down" : "arrow-right", { key: 0 }) : V("", !0),
                ee.$slots[ee.vertical ? "arrow-down" : "arrow-right"] ? V("", !0) : (w(), I(On(ee.vertical ? p(vh) : p(hh)), { key: 1 }))
              ]),
              _: 3
            }, 8, ["disabled", "aria-label", "class"])) : V("", !0)
          ])
        ], 64))
      ]);
    };
  }
}), s$ = {
  class: "dp__calendar_header",
  role: "row"
}, l$ = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, u$ = ["aria-label"], c$ = {
  key: 0,
  class: "dp__calendar_item dp__week_num",
  role: "gridcell"
}, d$ = { class: "dp__cell_inner" }, f$ = ["id", "aria-pressed", "aria-disabled", "aria-label", "tabindex", "data-test-id", "onClick", "onTouchend", "onKeydown", "onMouseenter", "onMouseleave", "onMousedown"], p$ = /* @__PURE__ */ j({
  compatConfig: {
    MODE: 3
  },
  __name: "DpCalendar",
  props: {
    mappedDates: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    ...Br
  },
  emits: [
    "select-date",
    "set-hover-date",
    "handle-scroll",
    "mount",
    "handle-swipe",
    "handle-space",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(t, { expose: e, emit: n }) {
    const r = n, o = t, { buildMultiLevelMatrix: a } = ba(), {
      defaultedTransitions: i,
      defaultedConfig: s,
      defaultedAriaLabels: l,
      defaultedMultiCalendars: u,
      defaultedWeekNumbers: c,
      defaultedMultiDates: d,
      defaultedUI: f
    } = $t(o), h = F(null), m = F({
      bottom: "",
      left: "",
      transform: ""
    }), g = F([]), y = F(null), b = F(!0), C = F(""), k = F({ startX: 0, endX: 0, startY: 0, endY: 0 }), v = F([]), E = F({ left: "50%" }), _ = F(!1), T = A(() => o.calendar ? o.calendar(o.mappedDates) : o.mappedDates), M = A(() => o.dayNames ? Array.isArray(o.dayNames) ? o.dayNames : o.dayNames(o.locale, +o.weekStart) : YP(o.formatLocale, o.locale, +o.weekStart));
    ze(() => {
      r("mount", { cmp: "calendar", refs: g }), s.value.noSwipe || y.value && (y.value.addEventListener("touchstart", J, { passive: !1 }), y.value.addEventListener("touchend", Ce, { passive: !1 }), y.value.addEventListener("touchmove", ie, { passive: !1 })), o.monthChangeOnScroll && y.value && y.value.addEventListener("wheel", G, { passive: !1 });
    });
    const O = (ne) => ne ? o.vertical ? "vNext" : "next" : o.vertical ? "vPrevious" : "previous", R = (ne, ye) => {
      if (o.transitions) {
        const pe = $n(To(we(), o.month, o.year));
        C.value = Kt($n(To(we(), ne, ye)), pe) ? i.value[O(!0)] : i.value[O(!1)], b.value = !1, nt(() => {
          b.value = !0;
        });
      }
    }, N = A(
      () => ({
        ...f.value.calendar ?? {}
      })
    ), z = A(() => (ne) => {
      const ye = GP(ne);
      return {
        dp__marker_dot: ye.type === "dot",
        dp__marker_line: ye.type === "line"
      };
    }), te = A(() => (ne) => mt(ne, h.value)), H = A(() => ({
      dp__calendar: !0,
      dp__calendar_next: u.value.count > 0 && o.instance !== 0
    })), U = A(() => (ne) => o.hideOffsetDates ? ne.current : !0), W = async (ne, ye) => {
      const { width: pe, height: Z } = ne.getBoundingClientRect();
      h.value = ye.value;
      let B = { left: `${pe / 2}px` }, me = -50;
      if (await nt(), v.value[0]) {
        const { left: Ve, width: Ee } = v.value[0].getBoundingClientRect();
        Ve < 0 && (B = { left: "0" }, me = 0, E.value.left = `${pe / 2}px`), window.innerWidth < Ve + Ee && (B = { right: "0" }, me = 0, E.value.left = `${Ee - pe / 2}px`);
      }
      m.value = {
        bottom: `${Z}px`,
        ...B,
        transform: `translateX(${me}%)`
      };
    }, Q = async (ne, ye, pe) => {
      var Z, B, me;
      const Ve = en(g.value[ye][pe]);
      Ve && ((Z = ne.marker) != null && Z.customPosition && (me = (B = ne.marker) == null ? void 0 : B.tooltip) != null && me.length ? m.value = ne.marker.customPosition(Ve) : await W(Ve, ne), r("tooltip-open", ne.marker));
    }, de = async (ne, ye, pe) => {
      var Z, B;
      if (_.value && d.value.enabled && d.value.dragSelect)
        return r("select-date", ne);
      if (r("set-hover-date", ne), (B = (Z = ne.marker) == null ? void 0 : Z.tooltip) != null && B.length) {
        if (o.hideOffsetDates && !ne.current) return;
        await Q(ne, ye, pe);
      }
    }, re = (ne) => {
      h.value && (h.value = null, m.value = JSON.parse(JSON.stringify({ bottom: "", left: "", transform: "" })), r("tooltip-close", ne.marker));
    }, J = (ne) => {
      k.value.startX = ne.changedTouches[0].screenX, k.value.startY = ne.changedTouches[0].screenY;
    }, Ce = (ne) => {
      k.value.endX = ne.changedTouches[0].screenX, k.value.endY = ne.changedTouches[0].screenY, ee();
    }, ie = (ne) => {
      o.vertical && !o.inline && ne.preventDefault();
    }, ee = () => {
      const ne = o.vertical ? "Y" : "X";
      Math.abs(k.value[`start${ne}`] - k.value[`end${ne}`]) > 10 && r("handle-swipe", k.value[`start${ne}`] > k.value[`end${ne}`] ? "right" : "left");
    }, D = (ne, ye, pe) => {
      ne && (Array.isArray(g.value[ye]) ? g.value[ye][pe] = ne : g.value[ye] = [ne]), o.arrowNavigation && a(g.value, "calendar");
    }, G = (ne) => {
      o.monthChangeOnScroll && (ne.preventDefault(), r("handle-scroll", ne));
    }, fe = (ne) => c.value.type === "local" ? ch(ne.value, { weekStartsOn: +o.weekStart }) : c.value.type === "iso" ? lh(ne.value) : typeof c.value.type == "function" ? c.value.type(ne.value) : "", P = (ne) => {
      const ye = ne[0];
      return c.value.hideOnOffsetDates ? ne.some((pe) => pe.current) ? fe(ye) : "" : fe(ye);
    }, se = (ne, ye, pe = !0) => {
      pe && $g() || !pe && !$g() || (!d.value.enabled || s.value.allowPreventDefault) && (ta(ne, s.value), r("select-date", ye));
    }, ke = (ne) => {
      ta(ne, s.value);
    }, Le = (ne) => {
      d.value.enabled && d.value.dragSelect ? (_.value = !0, r("select-date", ne)) : d.value.enabled && r("select-date", ne);
    };
    return e({ triggerTransition: R }), (ne, ye) => (w(), K("div", {
      class: Ie(H.value)
    }, [
      be("div", {
        ref_key: "calendarWrapRef",
        ref: y,
        class: Ie(N.value),
        role: "grid"
      }, [
        be("div", s$, [
          ne.weekNumbers ? (w(), K("div", l$, Se(ne.weekNumName), 1)) : V("", !0),
          (w(!0), K(Me, null, et(M.value, (pe, Z) => {
            var B, me;
            return w(), K("div", {
              key: Z,
              class: "dp__calendar_header_item",
              role: "gridcell",
              "data-test-id": "calendar-header",
              "aria-label": (me = (B = p(l)) == null ? void 0 : B.weekDay) == null ? void 0 : me.call(B, Z)
            }, [
              ne.$slots["calendar-header"] ? $(ne.$slots, "calendar-header", {
                key: 0,
                day: pe,
                index: Z
              }) : V("", !0),
              ne.$slots["calendar-header"] ? V("", !0) : (w(), K(Me, { key: 1 }, [
                We(Se(pe), 1)
              ], 64))
            ], 8, u$);
          }), 128))
        ]),
        ye[2] || (ye[2] = be("div", { class: "dp__calendar_header_separator" }, null, -1)),
        q(ss, {
          name: C.value,
          css: !!ne.transitions
        }, {
          default: S(() => [
            b.value ? (w(), K("div", {
              key: 0,
              class: "dp__calendar",
              role: "rowgroup",
              onMouseleave: ye[1] || (ye[1] = (pe) => _.value = !1)
            }, [
              (w(!0), K(Me, null, et(T.value, (pe, Z) => (w(), K("div", {
                key: Z,
                class: "dp__calendar_row",
                role: "row"
              }, [
                ne.weekNumbers ? (w(), K("div", c$, [
                  be("div", d$, Se(P(pe.days)), 1)
                ])) : V("", !0),
                (w(!0), K(Me, null, et(pe.days, (B, me) => {
                  var Ve, Ee, st;
                  return w(), K("div", {
                    id: p(gk)(B.value),
                    ref_for: !0,
                    ref: (L) => D(L, Z, me),
                    key: me + Z,
                    role: "gridcell",
                    class: "dp__calendar_item",
                    "aria-pressed": (B.classData.dp__active_date || B.classData.dp__range_start || B.classData.dp__range_start) ?? void 0,
                    "aria-disabled": B.classData.dp__cell_disabled || void 0,
                    "aria-label": (Ee = (Ve = p(l)) == null ? void 0 : Ve.day) == null ? void 0 : Ee.call(Ve, B),
                    tabindex: !B.current && ne.hideOffsetDates ? void 0 : 0,
                    "data-test-id": B.value,
                    onClick: Xe((L) => se(L, B), ["prevent"]),
                    onTouchend: (L) => se(L, B, !1),
                    onKeydown: (L) => p(Dn)(L, () => ne.$emit("select-date", B)),
                    onMouseenter: (L) => de(B, Z, me),
                    onMouseleave: (L) => re(B),
                    onMousedown: (L) => Le(B),
                    onMouseup: ye[0] || (ye[0] = (L) => _.value = !1)
                  }, [
                    be("div", {
                      class: Ie(["dp__cell_inner", B.classData])
                    }, [
                      ne.$slots.day && U.value(B) ? $(ne.$slots, "day", {
                        key: 0,
                        day: +B.text,
                        date: B.value
                      }) : V("", !0),
                      ne.$slots.day ? V("", !0) : (w(), K(Me, { key: 1 }, [
                        We(Se(B.text), 1)
                      ], 64)),
                      B.marker && U.value(B) ? (w(), K(Me, { key: 2 }, [
                        ne.$slots.marker ? $(ne.$slots, "marker", {
                          key: 0,
                          marker: B.marker,
                          day: +B.text,
                          date: B.value
                        }) : (w(), K("div", {
                          key: 1,
                          class: Ie(z.value(B.marker)),
                          style: Lt(B.marker.color ? { backgroundColor: B.marker.color } : {})
                        }, null, 6))
                      ], 64)) : V("", !0),
                      te.value(B.value) ? (w(), K("div", {
                        key: 3,
                        ref_for: !0,
                        ref_key: "activeTooltip",
                        ref: v,
                        class: "dp__marker_tooltip",
                        style: Lt(m.value)
                      }, [
                        (st = B.marker) != null && st.tooltip ? (w(), K("div", {
                          key: 0,
                          class: "dp__tooltip_content",
                          onClick: ke
                        }, [
                          (w(!0), K(Me, null, et(B.marker.tooltip, (L, x) => (w(), K("div", {
                            key: x,
                            class: "dp__tooltip_text"
                          }, [
                            ne.$slots["marker-tooltip"] ? $(ne.$slots, "marker-tooltip", {
                              key: 0,
                              tooltip: L,
                              day: B.value
                            }) : V("", !0),
                            ne.$slots["marker-tooltip"] ? V("", !0) : (w(), K(Me, { key: 1 }, [
                              be("div", {
                                class: "dp__tooltip_mark",
                                style: Lt(L.color ? { backgroundColor: L.color } : {})
                              }, null, 4),
                              be("div", null, Se(L.text), 1)
                            ], 64))
                          ]))), 128)),
                          be("div", {
                            class: "dp__arrow_bottom_tp",
                            style: Lt(E.value)
                          }, null, 4)
                        ])) : V("", !0)
                      ], 4)) : V("", !0)
                    ], 2)
                  ], 40, f$);
                }), 128))
              ]))), 128))
            ], 32)) : V("", !0)
          ]),
          _: 3
        }, 8, ["name", "css"])
      ], 2)
    ], 2));
  }
}), Vg = (t) => Array.isArray(t), h$ = (t, e, n, r) => {
  const o = F([]), a = F(/* @__PURE__ */ new Date()), i = F(), s = () => J(t.isTextInputDate), { modelValue: l, calendars: u, time: c, today: d } = Ll(t, e, s), {
    defaultedMultiCalendars: f,
    defaultedStartTime: h,
    defaultedRange: m,
    defaultedConfig: g,
    defaultedTz: y,
    propDates: b,
    defaultedMultiDates: C
  } = $t(t), { validateMonthYearInRange: k, isDisabled: v, isDateRangeAllowed: E, checkMinMaxRange: _ } = ka(t), { updateTimeValues: T, getSetDateTime: M, setTime: O, assignStartTime: R, validateTime: N, disabledTimesConfig: z } = Ck(t, c, l, r), te = A(
    () => (X) => u.value[X] ? u.value[X].month : 0
  ), H = A(
    () => (X) => u.value[X] ? u.value[X].year : 0
  ), U = (X) => !g.value.keepViewOnOffsetClick || X ? !0 : !i.value, W = (X, he, Ne, le = !1) => {
    var xe, Fe;
    U(le) && (u.value[X] || (u.value[X] = { month: 0, year: 0 }), u.value[X].month = Ng(he) ? (xe = u.value[X]) == null ? void 0 : xe.month : he, u.value[X].year = Ng(Ne) ? (Fe = u.value[X]) == null ? void 0 : Fe.year : Ne);
  }, Q = () => {
    t.autoApply && e("select-date");
  };
  ze(() => {
    t.shadow || (l.value || (ne(), h.value && R(h.value)), J(!0), t.focusStartDate && t.startDate && ne());
  });
  const de = A(() => {
    var X;
    return (X = t.flow) != null && X.length && !t.partialFlow ? t.flowStep === t.flow.length : !0;
  }), re = () => {
    t.autoApply && de.value && e("auto-apply", t.partialFlow ? t.flowStep !== t.flow.length : !1);
  }, J = (X = !1) => {
    if (l.value)
      return Array.isArray(l.value) ? (o.value = l.value, P(X)) : ee(l.value, X);
    if (f.value.count && X && !t.startDate)
      return ie(we(), X);
  }, Ce = () => Array.isArray(l.value) && m.value.enabled ? ft(l.value[0]) === ft(l.value[1] ?? l.value[0]) : !1, ie = (X = /* @__PURE__ */ new Date(), he = !1) => {
    if ((!f.value.count || !f.value.static || he) && W(0, ft(X), Qe(X)), f.value.count && (!l.value || Ce() || !f.value.solo) && (!f.value.solo || he))
      for (let Ne = 1; Ne < f.value.count; Ne++) {
        const le = Tt(we(), { month: te.value(Ne - 1), year: H.value(Ne - 1) }), xe = F0(le, { months: 1 });
        u.value[Ne] = { month: ft(xe), year: Qe(xe) };
      }
  }, ee = (X, he) => {
    ie(X), O("hours", $o(X)), O("minutes", fa(X)), O("seconds", Ki(X)), f.value.count && he && Le();
  }, D = (X) => {
    if (f.value.count) {
      if (f.value.solo) return 0;
      const he = ft(X[0]), Ne = ft(X[1]);
      return Math.abs(Ne - he) < f.value.count ? 0 : 1;
    }
    return 1;
  }, G = (X, he) => {
    X[1] && m.value.showLastInRange ? ie(X[D(X)], he) : ie(X[0], he);
    const Ne = (le, xe) => [
      le(X[0]),
      X[1] ? le(X[1]) : c[xe][1]
    ];
    O("hours", Ne($o, "hours")), O("minutes", Ne(fa, "minutes")), O("seconds", Ne(Ki, "seconds"));
  }, fe = (X, he) => {
    if ((m.value.enabled || t.weekPicker) && !C.value.enabled)
      return G(X, he);
    if (C.value.enabled && he) {
      const Ne = X[X.length - 1];
      return ee(Ne, he);
    }
  }, P = (X) => {
    const he = l.value;
    fe(he, X), f.value.count && f.value.solo && Le();
  }, se = (X, he) => {
    const Ne = Tt(we(), { month: te.value(he), year: H.value(he) }), le = X < 0 ? Ar(Ne, 1) : zi(Ne, 1);
    k(ft(le), Qe(le), X < 0, t.preventMinMaxNavigation) && (W(he, ft(le), Qe(le)), e("update-month-year", { instance: he, month: ft(le), year: Qe(le) }), f.value.count && !f.value.solo && ke(he), n());
  }, ke = (X) => {
    for (let he = X - 1; he >= 0; he--) {
      const Ne = zi(Tt(we(), { month: te.value(he + 1), year: H.value(he + 1) }), 1);
      W(he, ft(Ne), Qe(Ne));
    }
    for (let he = X + 1; he <= f.value.count - 1; he++) {
      const Ne = Ar(Tt(we(), { month: te.value(he - 1), year: H.value(he - 1) }), 1);
      W(he, ft(Ne), Qe(Ne));
    }
  }, Le = () => {
    if (Array.isArray(l.value) && l.value.length === 2) {
      const X = we(
        we(l.value[1] ? l.value[1] : Ar(l.value[0], 1))
      ), [he, Ne] = [ft(l.value[0]), Qe(l.value[0])], [le, xe] = [ft(l.value[1]), Qe(l.value[1])];
      (he !== le || he === le && Ne !== xe) && f.value.solo && W(1, ft(X), Qe(X));
    } else l.value && !Array.isArray(l.value) && (W(0, ft(l.value), Qe(l.value)), ie(we()));
  }, ne = () => {
    t.startDate && (W(0, ft(we(t.startDate)), Qe(we(t.startDate))), f.value.count && ke(0));
  }, ye = (X, he) => {
    if (t.monthChangeOnScroll) {
      const Ne = (/* @__PURE__ */ new Date()).getTime() - a.value.getTime(), le = Math.abs(X.deltaY);
      let xe = 500;
      le > 1 && (xe = 100), le > 100 && (xe = 0), Ne > xe && (a.value = /* @__PURE__ */ new Date(), se(t.monthChangeOnScroll !== "inverse" ? -X.deltaY : X.deltaY, he));
    }
  }, pe = (X, he, Ne = !1) => {
    t.monthChangeOnArrows && t.vertical === Ne && Z(X, he);
  }, Z = (X, he) => {
    se(X === "right" ? -1 : 1, he);
  }, B = (X) => {
    if (b.value.markers)
      return xu(X.value, b.value.markers);
  }, me = (X, he) => {
    switch (t.sixWeeks === !0 ? "append" : t.sixWeeks) {
      case "prepend":
        return [!0, !1];
      case "center":
        return [X == 0, !0];
      case "fair":
        return [X == 0 || he > X, !0];
      case "append":
        return [!1, !1];
      default:
        return [!1, !1];
    }
  }, Ve = (X, he, Ne, le) => {
    if (t.sixWeeks && X.length < 6) {
      const xe = 6 - X.length, Fe = (he.getDay() + 7 - le) % 7, on = 6 - (Ne.getDay() + 7 - le) % 7, [xn, kr] = me(Fe, on);
      for (let ar = 1; ar <= xe; ar++)
        if (kr ? !!(ar % 2) == xn : xn) {
          const Vr = X[0].days[0], Oa = Ee(Or(Vr.value, -7), ft(he));
          X.unshift({ days: Oa });
        } else {
          const Vr = X[X.length - 1], Oa = Vr.days[Vr.days.length - 1], di = Ee(Or(Oa.value, 1), ft(he));
          X.push({ days: di });
        }
    }
    return X;
  }, Ee = (X, he) => {
    const Ne = we(X), le = [];
    for (let xe = 0; xe < 7; xe++) {
      const Fe = Or(Ne, xe), on = ft(Fe) !== he;
      le.push({
        text: t.hideOffsetDates && on ? "" : Fe.getDate(),
        value: Fe,
        current: !on,
        classData: {}
      });
    }
    return le;
  }, st = (X, he) => {
    const Ne = [], le = new Date(he, X), xe = new Date(he, X + 1, 0), Fe = t.weekStart, on = Nr(le, { weekStartsOn: Fe }), xn = (kr) => {
      const ar = Ee(kr, X);
      if (Ne.push({ days: ar }), !Ne[Ne.length - 1].days.some(
        (Vr) => mt($n(Vr.value), $n(xe))
      )) {
        const Vr = Or(kr, 7);
        xn(Vr);
      }
    };
    return xn(on), Ve(Ne, le, xe, Fe);
  }, L = (X) => {
    const he = na(we(X.value), c.hours, c.minutes, ae());
    e("date-update", he), C.value.enabled ? Ch(he, l, C.value.limit) : l.value = he, r(), nt().then(() => {
      re();
    });
  }, x = (X) => m.value.noDisabledRange ? dk(o.value[0], X).some((he) => v(he)) : !1, Y = () => {
    o.value = l.value ? l.value.slice() : [], o.value.length === 2 && !(m.value.fixedStart || m.value.fixedEnd) && (o.value = []);
  }, ge = (X, he) => {
    const Ne = [
      we(X.value),
      Or(we(X.value), +m.value.autoRange)
    ];
    E(Ne) ? (he && Ge(X.value), o.value = Ne) : e("invalid-date", X.value);
  }, Ge = (X) => {
    const he = ft(we(X)), Ne = Qe(we(X));
    if (W(0, he, Ne), f.value.count > 0)
      for (let le = 1; le < f.value.count; le++) {
        const xe = nN(
          Tt(we(X), { year: H.value(le - 1), month: te.value(le - 1) })
        );
        W(le, xe.month, xe.year);
      }
  }, rt = (X) => {
    if (x(X.value) || !_(X.value, l.value, m.value.fixedStart ? 0 : 1))
      return e("invalid-date", X.value);
    o.value = kk(we(X.value), l, e, m);
  }, Te = (X, he) => {
    if (Y(), m.value.autoRange) return ge(X, he);
    if (m.value.fixedStart || m.value.fixedEnd) return rt(X);
    o.value[0] ? _(we(X.value), l.value) && !x(X.value) ? Vt(we(X.value), we(o.value[0])) ? (o.value.unshift(we(X.value)), e("range-end", o.value[0])) : (o.value[1] = we(X.value), e("range-end", o.value[1])) : (t.autoApply && e("auto-apply-invalid", X.value), e("invalid-date", X.value)) : (o.value[0] = we(X.value), e("range-start", o.value[0]));
  }, ae = (X = !0) => t.enableSeconds ? Array.isArray(c.seconds) ? X ? c.seconds[0] : c.seconds[1] : c.seconds : 0, ve = (X) => {
    o.value[X] = na(
      o.value[X],
      c.hours[X],
      c.minutes[X],
      ae(X !== 1)
    );
  }, pt = () => {
    var X, he;
    o.value[0] && o.value[1] && +((X = o.value) == null ? void 0 : X[0]) > +((he = o.value) == null ? void 0 : he[1]) && (o.value.reverse(), e("range-start", o.value[0]), e("range-end", o.value[1]));
  }, Ot = () => {
    o.value.length && (o.value[0] && !o.value[1] ? ve(0) : (ve(0), ve(1), r()), pt(), l.value = o.value.slice(), Kc(o.value, e, t.autoApply, t.modelAuto));
  }, Sn = (X, he = !1) => {
    if (v(X.value) || !X.current && t.hideOffsetDates) return e("invalid-date", X.value);
    if (i.value = JSON.parse(JSON.stringify(X)), !m.value.enabled) return L(X);
    Vg(c.hours) && Vg(c.minutes) && !C.value.enabled && (Te(X, he), Ot());
  }, Fr = (X, he) => {
    var Ne;
    W(X, he.month, he.year, !0), f.value.count && !f.value.solo && ke(X), e("update-month-year", { instance: X, month: he.month, year: he.year }), n(f.value.solo ? X : void 0);
    const le = (Ne = t.flow) != null && Ne.length ? t.flow[t.flowStep] : void 0;
    !he.fromNav && (le === wn.month || le === wn.year) && r();
  }, or = (X, he) => {
    bk({
      value: X,
      modelValue: l,
      range: m.value.enabled,
      timezone: he ? void 0 : y.value.timezone
    }), Q(), t.multiCalendars && nt().then(() => J(!0));
  }, ue = () => {
    const X = yh(we(), y.value);
    !m.value.enabled && !C.value.enabled ? l.value = X : l.value && Array.isArray(l.value) && l.value[0] ? C.value.enabled ? l.value = [...l.value, X] : l.value = Vt(X, l.value[0]) ? [X, l.value[0]] : [l.value[0], X] : l.value = [X], Q();
  }, Re = () => {
    if (Array.isArray(l.value))
      if (C.value.enabled) {
        const X = Ue();
        l.value[l.value.length - 1] = M(X);
      } else
        l.value = l.value.map((X, he) => X && M(X, he));
    else
      l.value = M(l.value);
    e("time-update");
  }, Ue = () => Array.isArray(l.value) && l.value.length ? l.value[l.value.length - 1] : null;
  return {
    calendars: u,
    modelValue: l,
    month: te,
    year: H,
    time: c,
    disabledTimesConfig: z,
    today: d,
    validateTime: N,
    getCalendarDays: st,
    getMarker: B,
    handleScroll: ye,
    handleSwipe: Z,
    handleArrow: pe,
    selectDate: Sn,
    updateMonthYear: Fr,
    presetDate: or,
    selectCurrentDate: ue,
    updateTime: (X, he = !0, Ne = !1) => {
      T(X, he, Ne, Re);
    },
    assignMonthAndYear: ie
  };
}, m$ = { key: 0 }, g$ = /* @__PURE__ */ j({
  __name: "DatePicker",
  props: {
    ...Br
  },
  emits: [
    "tooltip-open",
    "tooltip-close",
    "mount",
    "update:internal-model-value",
    "update-flow-step",
    "reset-flow",
    "auto-apply",
    "focus-menu",
    "select-date",
    "range-start",
    "range-end",
    "invalid-fixed-range",
    "time-update",
    "am-pm-change",
    "time-picker-open",
    "time-picker-close",
    "recalculate-position",
    "update-month-year",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle"
  ],
  setup(t, { expose: e, emit: n }) {
    const r = n, o = t, {
      calendars: a,
      month: i,
      year: s,
      modelValue: l,
      time: u,
      disabledTimesConfig: c,
      today: d,
      validateTime: f,
      getCalendarDays: h,
      getMarker: m,
      handleArrow: g,
      handleScroll: y,
      handleSwipe: b,
      selectDate: C,
      updateMonthYear: k,
      presetDate: v,
      selectCurrentDate: E,
      updateTime: _,
      assignMonthAndYear: T
    } = h$(o, r, Ce, ie), M = uo(), { setHoverDate: O, getDayClassData: R, clearHoverDate: N } = P$(l, o), { defaultedMultiCalendars: z } = $t(o), te = F([]), H = F([]), U = F(null), W = Zn(M, "calendar"), Q = Zn(M, "monthYear"), de = Zn(M, "timePicker"), re = (ye) => {
      o.shadow || r("mount", ye);
    };
    Ke(
      a,
      () => {
        o.shadow || setTimeout(() => {
          r("recalculate-position");
        }, 0);
      },
      { deep: !0 }
    ), Ke(
      z,
      (ye, pe) => {
        ye.count - pe.count > 0 && T();
      },
      { deep: !0 }
    );
    const J = A(() => (ye) => h(i.value(ye), s.value(ye)).map((pe) => ({
      ...pe,
      days: pe.days.map((Z) => (Z.marker = m(Z), Z.classData = R(Z), Z))
    })));
    function Ce(ye) {
      var pe;
      ye || ye === 0 ? (pe = H.value[ye]) == null || pe.triggerTransition(i.value(ye), s.value(ye)) : H.value.forEach((Z, B) => Z.triggerTransition(i.value(B), s.value(B)));
    }
    function ie() {
      r("update-flow-step");
    }
    const ee = (ye, pe = !1) => {
      C(ye, pe), o.spaceConfirm && r("select-date");
    }, D = (ye, pe, Z = 0) => {
      var B;
      (B = te.value[Z]) == null || B.toggleMonthPicker(ye, pe);
    }, G = (ye, pe, Z = 0) => {
      var B;
      (B = te.value[Z]) == null || B.toggleYearPicker(ye, pe);
    }, fe = (ye, pe, Z) => {
      var B;
      (B = U.value) == null || B.toggleTimePicker(ye, pe, Z);
    }, P = (ye, pe) => {
      var Z;
      if (!o.range) {
        const B = l.value ? l.value : d, me = pe ? new Date(pe) : B, Ve = ye ? Nr(me, { weekStartsOn: 1 }) : j0(me, { weekStartsOn: 1 });
        C({
          value: Ve,
          current: ft(me) === i.value(0),
          text: "",
          classData: {}
        }), (Z = document.getElementById(gk(Ve))) == null || Z.focus();
      }
    }, se = (ye) => {
      var pe;
      (pe = te.value[0]) == null || pe.handleMonthYearChange(ye, !0);
    }, ke = (ye) => {
      k(0, { month: i.value(0), year: s.value(0) + (ye ? 1 : -1), fromNav: !0 });
    }, Le = (ye, pe) => {
      ye === wn.time && r(`time-picker-${pe ? "open" : "close"}`), r("overlay-toggle", { open: pe, overlay: ye });
    }, ne = (ye) => {
      r("overlay-toggle", { open: !1, overlay: ye }), r("focus-menu");
    };
    return e({
      clearHoverDate: N,
      presetDate: v,
      selectCurrentDate: E,
      toggleMonthPicker: D,
      toggleYearPicker: G,
      toggleTimePicker: fe,
      handleArrow: g,
      updateMonthYear: k,
      getSidebarProps: () => ({
        modelValue: l,
        month: i,
        year: s,
        time: u,
        updateTime: _,
        updateMonthYear: k,
        selectDate: C,
        presetDate: v
      }),
      changeMonth: se,
      changeYear: ke,
      selectWeekDate: P
    }), (ye, pe) => (w(), K(Me, null, [
      q(Wc, {
        "multi-calendars": p(z).count,
        collapse: ye.collapse,
        "is-mobile": ye.isMobile
      }, {
        default: S(({ instance: Z, index: B }) => [
          ye.disableMonthYearSelect ? V("", !0) : (w(), I(i$, oe({
            key: 0,
            ref: (me) => {
              me && (te.value[B] = me);
            },
            months: p(ak)(ye.formatLocale, ye.locale, ye.monthNameFormat),
            years: p(bh)(ye.yearRange, ye.locale, ye.reverseYears),
            month: p(i)(Z),
            year: p(s)(Z),
            instance: Z
          }, ye.$props, {
            onMount: pe[0] || (pe[0] = (me) => re(p(Ba).header)),
            onResetFlow: pe[1] || (pe[1] = (me) => ye.$emit("reset-flow")),
            onUpdateMonthYear: (me) => p(k)(Z, me),
            onOverlayClosed: ne,
            onOverlayOpened: pe[2] || (pe[2] = (me) => ye.$emit("overlay-toggle", { open: !0, overlay: me }))
          }), At({ _: 2 }, [
            et(p(Q), (me, Ve) => ({
              name: me,
              fn: S((Ee) => [
                $(ye.$slots, me, Ye(ot(Ee)))
              ])
            }))
          ]), 1040, ["months", "years", "month", "year", "instance", "onUpdateMonthYear"])),
          q(p$, oe({
            ref: (me) => {
              me && (H.value[B] = me);
            },
            "mapped-dates": J.value(Z),
            month: p(i)(Z),
            year: p(s)(Z),
            instance: Z
          }, ye.$props, {
            onSelectDate: (me) => p(C)(me, Z !== 1),
            onHandleSpace: (me) => ee(me, Z !== 1),
            onSetHoverDate: pe[3] || (pe[3] = (me) => p(O)(me)),
            onHandleScroll: (me) => p(y)(me, Z),
            onHandleSwipe: (me) => p(b)(me, Z),
            onMount: pe[4] || (pe[4] = (me) => re(p(Ba).calendar)),
            onResetFlow: pe[5] || (pe[5] = (me) => ye.$emit("reset-flow")),
            onTooltipOpen: pe[6] || (pe[6] = (me) => ye.$emit("tooltip-open", me)),
            onTooltipClose: pe[7] || (pe[7] = (me) => ye.$emit("tooltip-close", me))
          }), At({ _: 2 }, [
            et(p(W), (me, Ve) => ({
              name: me,
              fn: S((Ee) => [
                $(ye.$slots, me, Ye(ot({ ...Ee })))
              ])
            }))
          ]), 1040, ["mapped-dates", "month", "year", "instance", "onSelectDate", "onHandleSpace", "onHandleScroll", "onHandleSwipe"])
        ]),
        _: 3
      }, 8, ["multi-calendars", "collapse", "is-mobile"]),
      ye.enableTimePicker ? (w(), K("div", m$, [
        ye.$slots["time-picker"] ? $(ye.$slots, "time-picker", Ye(oe({ key: 0 }, { time: p(u), updateTime: p(_) }))) : (w(), I(_k, oe({
          key: 1,
          ref_key: "timePickerRef",
          ref: U
        }, ye.$props, {
          hours: p(u).hours,
          minutes: p(u).minutes,
          seconds: p(u).seconds,
          "internal-model-value": ye.internalModelValue,
          "disabled-times-config": p(c),
          "validate-time": p(f),
          onMount: pe[8] || (pe[8] = (Z) => re(p(Ba).timePicker)),
          "onUpdate:hours": pe[9] || (pe[9] = (Z) => p(_)(Z)),
          "onUpdate:minutes": pe[10] || (pe[10] = (Z) => p(_)(Z, !1)),
          "onUpdate:seconds": pe[11] || (pe[11] = (Z) => p(_)(Z, !1, !0)),
          onResetFlow: pe[12] || (pe[12] = (Z) => ye.$emit("reset-flow")),
          onOverlayClosed: pe[13] || (pe[13] = (Z) => Le(Z, !1)),
          onOverlayOpened: pe[14] || (pe[14] = (Z) => Le(Z, !0)),
          onAmPmChange: pe[15] || (pe[15] = (Z) => ye.$emit("am-pm-change", Z))
        }), At({ _: 2 }, [
          et(p(de), (Z, B) => ({
            name: Z,
            fn: S((me) => [
              $(ye.$slots, Z, Ye(ot(me)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"]))
      ])) : V("", !0)
    ], 64));
  }
}), v$ = (t, e) => {
  const n = F(), {
    defaultedMultiCalendars: r,
    defaultedConfig: o,
    defaultedHighlight: a,
    defaultedRange: i,
    propDates: s,
    defaultedFilters: l,
    defaultedMultiDates: u
  } = $t(t), { modelValue: c, year: d, month: f, calendars: h } = Ll(t, e), { isDisabled: m } = ka(t), { selectYear: g, groupedYears: y, showYearPicker: b, isDisabled: C, toggleYearPicker: k, handleYearSelect: v, handleYear: E } = wk({
    modelValue: c,
    multiCalendars: r,
    range: i,
    highlight: a,
    calendars: h,
    propDates: s,
    month: f,
    year: d,
    filters: l,
    props: t,
    emit: e
  }), _ = (U, W) => [U, W].map((Q) => Mr(Q, "MMMM", { locale: t.formatLocale })).join("-"), T = A(() => (U) => c.value ? Array.isArray(c.value) ? c.value.some((W) => Ig(U, W)) : Ig(c.value, U) : !1), M = (U) => {
    if (i.value.enabled) {
      if (Array.isArray(c.value)) {
        const W = mt(U, c.value[0]) || mt(U, c.value[1]);
        return Hc(c.value, n.value, U) && !W;
      }
      return !1;
    }
    return !1;
  }, O = (U, W) => U.quarter === Og(W) && U.year === Qe(W), R = (U) => typeof a.value == "function" ? a.value({ quarter: Og(U), year: Qe(U) }) : !!a.value.quarters.find((W) => O(W, U)), N = A(() => (U) => {
    const W = Tt(/* @__PURE__ */ new Date(), { year: d.value(U) });
    return YI({
      start: ol(W),
      end: K0(W)
    }).map((Q) => {
      const de = Pa(Q), re = Tg(Q), J = m(Q), Ce = M(de), ie = R(de);
      return {
        text: _(de, re),
        value: de,
        active: T.value(de),
        highlighted: ie,
        disabled: J,
        isBetween: Ce
      };
    });
  }), z = (U) => {
    Ch(U, c, u.value.limit), e("auto-apply", !0);
  }, te = (U) => {
    c.value = Eh(c, U, e), Kc(c.value, e, t.autoApply, t.modelAuto);
  }, H = (U) => {
    c.value = U, e("auto-apply");
  };
  return {
    defaultedConfig: o,
    defaultedMultiCalendars: r,
    groupedYears: y,
    year: d,
    isDisabled: C,
    quarters: N,
    showYearPicker: b,
    modelValue: c,
    setHoverDate: (U) => {
      n.value = U;
    },
    selectYear: g,
    selectQuarter: (U, W, Q) => {
      if (!Q)
        return h.value[W].month = ft(Tg(U)), u.value.enabled ? z(U) : i.value.enabled ? te(U) : H(U);
    },
    toggleYearPicker: k,
    handleYearSelect: v,
    handleYear: E
  };
}, y$ = { class: "dp--quarter-items" }, b$ = ["data-test-id", "disabled", "onClick", "onMouseover"], k$ = /* @__PURE__ */ j({
  compatConfig: {
    MODE: 3
  },
  __name: "QuarterPicker",
  props: {
    ...Br
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "overlay-closed",
    "auto-apply",
    "range-start",
    "range-end",
    "overlay-toggle",
    "update-month-year"
  ],
  setup(t, { expose: e, emit: n }) {
    const r = n, o = t, a = uo(), i = Zn(a, "yearMode"), {
      defaultedMultiCalendars: s,
      defaultedConfig: l,
      groupedYears: u,
      year: c,
      isDisabled: d,
      quarters: f,
      modelValue: h,
      showYearPicker: m,
      setHoverDate: g,
      selectQuarter: y,
      toggleYearPicker: b,
      handleYearSelect: C,
      handleYear: k
    } = v$(o, r);
    return e({ getSidebarProps: () => ({
      modelValue: h,
      year: c,
      selectQuarter: y,
      handleYearSelect: C,
      handleYear: k
    }) }), (v, E) => (w(), I(Wc, {
      "multi-calendars": p(s).count,
      collapse: v.collapse,
      stretch: "",
      "is-mobile": v.isMobile
    }, {
      default: S(({ instance: _ }) => [
        be("div", {
          class: "dp-quarter-picker-wrap",
          style: Lt({ minHeight: `${p(l).modeHeight}px` })
        }, [
          v.$slots["top-extra"] ? $(v.$slots, "top-extra", {
            key: 0,
            value: v.internalModelValue
          }) : V("", !0),
          be("div", null, [
            q(yk, oe(v.$props, {
              items: p(u)(_),
              instance: _,
              "show-year-picker": p(m)[_],
              year: p(c)(_),
              "is-disabled": (T) => p(d)(_, T),
              onHandleYear: (T) => p(k)(_, T),
              onYearSelect: (T) => p(C)(T, _),
              onToggleYearPicker: (T) => p(b)(_, T == null ? void 0 : T.flow, T == null ? void 0 : T.show)
            }), At({ _: 2 }, [
              et(p(i), (T, M) => ({
                name: T,
                fn: S((O) => [
                  $(v.$slots, T, Ye(ot(O)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          be("div", y$, [
            (w(!0), K(Me, null, et(p(f)(_), (T, M) => (w(), K("div", { key: M }, [
              be("button", {
                type: "button",
                class: Ie(["dp--qr-btn", {
                  "dp--qr-btn-active": T.active,
                  "dp--qr-btn-between": T.isBetween,
                  "dp--qr-btn-disabled": T.disabled,
                  "dp--highlighted": T.highlighted
                }]),
                "data-test-id": T.value,
                disabled: T.disabled,
                onClick: (O) => p(y)(T.value, _, T.disabled),
                onMouseover: (O) => p(g)(T.value)
              }, [
                v.$slots.quarter ? $(v.$slots, "quarter", {
                  key: 0,
                  value: T.value,
                  text: T.text
                }) : (w(), K(Me, { key: 1 }, [
                  We(Se(T.text), 1)
                ], 64))
              ], 42, b$)
            ]))), 128))
          ])
        ], 4)
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse", "is-mobile"]));
  }
}), Ek = (t, e) => {
  const n = F(0);
  ze(() => {
    r(), window.addEventListener("resize", r, { passive: !0 });
  }), En(() => {
    window.removeEventListener("resize", r);
  });
  const r = () => {
    n.value = window.document.documentElement.clientWidth;
  };
  return {
    isMobile: A(
      () => n.value <= t.value.mobileBreakpoint && !e ? !0 : void 0
    )
  };
}, w$ = ["id", "tabindex", "role", "aria-label"], _$ = {
  key: 0,
  class: "dp--menu-load-container"
}, C$ = {
  key: 1,
  class: "dp--menu-header"
}, E$ = ["data-dp-mobile"], O$ = {
  key: 0,
  class: "dp__sidebar_left"
}, T$ = ["data-dp-mobile"], S$ = ["data-test-id", "data-dp-mobile", "onClick", "onKeydown"], x$ = {
  key: 2,
  class: "dp__sidebar_right"
}, A$ = {
  key: 3,
  class: "dp__action_extra"
}, Hg = /* @__PURE__ */ j({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerMenu",
  props: {
    ...Uc,
    shadow: { type: Boolean, default: !1 },
    openOnTop: { type: Boolean, default: !1 },
    internalModelValue: { type: [Date, Array], default: null },
    noOverlayFocus: { type: Boolean, default: !1 },
    collapse: { type: Boolean, default: !1 },
    getInputRect: { type: Function, default: () => ({}) },
    isTextInputDate: { type: Boolean, default: !1 }
  },
  emits: [
    "close-picker",
    "select-date",
    "auto-apply",
    "time-update",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "update:internal-model-value",
    "recalculate-position",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle",
    "menu-blur"
  ],
  setup(t, { expose: e, emit: n }) {
    const r = n, o = t, a = F(null), i = A(() => {
      const { openOnTop: x, ...Y } = o;
      return {
        ...Y,
        isMobile: g.value,
        flowStep: N.value,
        menuWrapRef: a.value
      };
    }), { setMenuFocused: s, setShiftKey: l, control: u } = vk(), c = uo(), { defaultedTextInput: d, defaultedInline: f, defaultedConfig: h, defaultedUI: m } = $t(o), { isMobile: g } = Ek(h, o.shadow), y = F(null), b = F(0), C = F(null), k = F(!1), v = F(null), E = F(!1);
    ze(() => {
      if (!o.shadow) {
        k.value = !0, _(), window.addEventListener("resize", _);
        const x = en(a);
        if (x && !d.value.enabled && !f.value.enabled && (s(!0), de()), x) {
          const Y = (ge) => {
            E.value = !0, h.value.allowPreventDefault && ge.preventDefault(), ta(ge, h.value, !0);
          };
          x.addEventListener("pointerdown", Y), x.addEventListener("mousedown", Y);
        }
      }
      document.addEventListener("mousedown", L);
    }), En(() => {
      window.removeEventListener("resize", _), document.addEventListener("mousedown", L);
    });
    const _ = () => {
      const x = en(C);
      x && (b.value = x.getBoundingClientRect().width);
    }, { arrowRight: T, arrowLeft: M, arrowDown: O, arrowUp: R } = ba(), { flowStep: N, updateFlowStep: z, childMount: te, resetFlow: H, handleFlow: U } = N$(o, r, v), W = A(() => o.monthPicker ? BN : o.yearPicker ? VN : o.timePicker ? e$ : o.quarterPicker ? k$ : g$), Q = A(() => {
      var x;
      if (h.value.arrowLeft) return h.value.arrowLeft;
      const Y = (x = a.value) == null ? void 0 : x.getBoundingClientRect(), ge = o.getInputRect();
      return (ge == null ? void 0 : ge.width) < (b == null ? void 0 : b.value) && (ge == null ? void 0 : ge.left) <= ((Y == null ? void 0 : Y.left) ?? 0) ? `${(ge == null ? void 0 : ge.width) / 2}px` : (ge == null ? void 0 : ge.right) >= ((Y == null ? void 0 : Y.right) ?? 0) && (ge == null ? void 0 : ge.width) < (b == null ? void 0 : b.value) ? `${(b == null ? void 0 : b.value) - (ge == null ? void 0 : ge.width) / 2}px` : "50%";
    }), de = () => {
      const x = en(a);
      x && x.focus({ preventScroll: !0 });
    }, re = A(() => {
      var x;
      return ((x = v.value) == null ? void 0 : x.getSidebarProps()) || {};
    }), J = () => {
      o.openOnTop && r("recalculate-position");
    }, Ce = Zn(c, "action"), ie = A(() => o.monthPicker || o.yearPicker ? Zn(c, "monthYear") : o.timePicker ? Zn(c, "timePicker") : Zn(c, "shared")), ee = A(() => o.openOnTop ? "dp__arrow_bottom" : "dp__arrow_top"), D = A(() => ({
      dp__menu_disabled: o.disabled,
      dp__menu_readonly: o.readonly,
      "dp-menu-loading": o.loading
    })), G = A(
      () => ({
        dp__menu: !0,
        dp__menu_index: !f.value.enabled,
        dp__relative: f.value.enabled,
        ...m.value.menu ?? {}
      })
    ), fe = (x) => {
      ta(x, h.value, !0);
    }, P = () => {
      o.escClose && r("close-picker");
    }, se = (x) => {
      if (o.arrowNavigation) {
        if (x === An.up) return R();
        if (x === An.down) return O();
        if (x === An.left) return M();
        if (x === An.right) return T();
      } else x === An.left || x === An.up ? pe("handleArrow", An.left, 0, x === An.up) : pe("handleArrow", An.right, 0, x === An.down);
    }, ke = (x) => {
      l(x.shiftKey), !o.disableMonthYearSelect && x.code === Dt.tab && x.target.classList.contains("dp__menu") && u.value.shiftKeyInMenu && (x.preventDefault(), ta(x, h.value, !0), r("close-picker"));
    }, Le = () => {
      de(), r("time-picker-close");
    }, ne = (x) => {
      var Y, ge, Ge;
      (Y = v.value) == null || Y.toggleTimePicker(!1, !1), (ge = v.value) == null || ge.toggleMonthPicker(!1, !1, x), (Ge = v.value) == null || Ge.toggleYearPicker(!1, !1, x);
    }, ye = (x, Y = 0) => {
      var ge, Ge, rt;
      return x === "month" ? (ge = v.value) == null ? void 0 : ge.toggleMonthPicker(!1, !0, Y) : x === "year" ? (Ge = v.value) == null ? void 0 : Ge.toggleYearPicker(!1, !0, Y) : x === "time" ? (rt = v.value) == null ? void 0 : rt.toggleTimePicker(!0, !1) : ne(Y);
    }, pe = (x, ...Y) => {
      var ge, Ge;
      (ge = v.value) != null && ge[x] && ((Ge = v.value) == null || Ge[x](...Y));
    }, Z = () => {
      pe("selectCurrentDate");
    }, B = (x, Y) => {
      pe("presetDate", x, Y);
    }, me = () => {
      pe("clearHoverDate");
    }, Ve = (x, Y) => {
      pe("updateMonthYear", x, Y);
    }, Ee = (x, Y) => {
      x.preventDefault(), se(Y);
    }, st = (x) => {
      var Y, ge, Ge;
      if (ke(x), x.key === Dt.home || x.key === Dt.end)
        return pe(
          "selectWeekDate",
          x.key === Dt.home,
          x.target.getAttribute("id")
        );
      switch ((x.key === Dt.pageUp || x.key === Dt.pageDown) && (x.shiftKey ? (pe("changeYear", x.key === Dt.pageUp), (Y = Hf(a.value, "overlay-year")) == null || Y.focus()) : (pe("changeMonth", x.key === Dt.pageUp), (ge = Hf(a.value, x.key === Dt.pageUp ? "action-prev" : "action-next")) == null || ge.focus()), x.target.getAttribute("id") && ((Ge = a.value) == null || Ge.focus({ preventScroll: !0 }))), x.key) {
        case Dt.esc:
          return P();
        case Dt.arrowLeft:
          return Ee(x, An.left);
        case Dt.arrowRight:
          return Ee(x, An.right);
        case Dt.arrowUp:
          return Ee(x, An.up);
        case Dt.arrowDown:
          return Ee(x, An.down);
        default:
          return;
      }
    }, L = (x) => {
      var Y;
      f.value.enabled && !f.value.input && !((Y = a.value) != null && Y.contains(x.target)) && E.value && (E.value = !1, r("menu-blur"));
    };
    return e({
      updateMonthYear: Ve,
      switchView: ye,
      handleFlow: U
    }), (x, Y) => {
      var ge, Ge, rt;
      return w(), K("div", {
        id: x.uid ? `dp-menu-${x.uid}` : void 0,
        ref_key: "dpMenuRef",
        ref: a,
        tabindex: p(f).enabled ? void 0 : "0",
        role: p(f).enabled ? void 0 : "dialog",
        "aria-label": (ge = x.ariaLabels) == null ? void 0 : ge.menu,
        class: Ie(G.value),
        style: Lt({ "--dp-arrow-left": Q.value }),
        onMouseleave: me,
        onClick: fe,
        onKeydown: st
      }, [
        (x.disabled || x.readonly) && p(f).enabled || x.loading ? (w(), K("div", {
          key: 0,
          class: Ie(D.value)
        }, [
          x.loading ? (w(), K("div", _$, Y[19] || (Y[19] = [
            be("span", { class: "dp--menu-loader" }, null, -1)
          ]))) : V("", !0)
        ], 2)) : V("", !0),
        x.$slots["menu-header"] ? (w(), K("div", C$, [
          $(x.$slots, "menu-header")
        ])) : V("", !0),
        !p(f).enabled && !x.teleportCenter ? (w(), K("div", {
          key: 2,
          class: Ie(ee.value)
        }, null, 2)) : V("", !0),
        be("div", {
          ref_key: "innerMenuRef",
          ref: C,
          class: Ie({
            dp__menu_content_wrapper: ((Ge = x.presetDates) == null ? void 0 : Ge.length) || !!x.$slots["left-sidebar"] || !!x.$slots["right-sidebar"],
            "dp--menu-content-wrapper-collapsed": t.collapse && (((rt = x.presetDates) == null ? void 0 : rt.length) || !!x.$slots["left-sidebar"] || !!x.$slots["right-sidebar"])
          }),
          "data-dp-mobile": p(g),
          style: Lt({ "--dp-menu-width": `${b.value}px` })
        }, [
          x.$slots["left-sidebar"] ? (w(), K("div", O$, [
            $(x.$slots, "left-sidebar", Ye(ot(re.value)))
          ])) : V("", !0),
          x.presetDates.length ? (w(), K("div", {
            key: 1,
            class: Ie({ "dp--preset-dates-collapsed": t.collapse, "dp--preset-dates": !0 }),
            "data-dp-mobile": p(g)
          }, [
            (w(!0), K(Me, null, et(x.presetDates, (Te, ae) => (w(), K(Me, { key: ae }, [
              Te.slot ? $(x.$slots, Te.slot, {
                key: 0,
                presetDate: B,
                label: Te.label,
                value: Te.value
              }) : (w(), K("button", {
                key: 1,
                type: "button",
                style: Lt(Te.style || {}),
                class: Ie(["dp__btn dp--preset-range", { "dp--preset-range-collapsed": t.collapse }]),
                "data-test-id": Te.testId ?? void 0,
                "data-dp-mobile": p(g),
                onClick: Xe((ve) => B(Te.value, Te.noTz), ["prevent"]),
                onKeydown: (ve) => p(Dn)(ve, () => B(Te.value, Te.noTz), !0)
              }, Se(Te.label), 47, S$))
            ], 64))), 128))
          ], 10, T$)) : V("", !0),
          be("div", {
            ref_key: "calendarWrapperRef",
            ref: y,
            class: "dp__instance_calendar",
            role: "document"
          }, [
            (w(), I(On(W.value), oe({
              ref_key: "dynCmpRef",
              ref: v
            }, i.value, {
              "flow-step": p(N),
              onMount: p(te),
              onUpdateFlowStep: p(z),
              onResetFlow: p(H),
              onFocusMenu: de,
              onSelectDate: Y[0] || (Y[0] = (Te) => x.$emit("select-date")),
              onDateUpdate: Y[1] || (Y[1] = (Te) => x.$emit("date-update", Te)),
              onTooltipOpen: Y[2] || (Y[2] = (Te) => x.$emit("tooltip-open", Te)),
              onTooltipClose: Y[3] || (Y[3] = (Te) => x.$emit("tooltip-close", Te)),
              onAutoApply: Y[4] || (Y[4] = (Te) => x.$emit("auto-apply", Te)),
              onRangeStart: Y[5] || (Y[5] = (Te) => x.$emit("range-start", Te)),
              onRangeEnd: Y[6] || (Y[6] = (Te) => x.$emit("range-end", Te)),
              onInvalidFixedRange: Y[7] || (Y[7] = (Te) => x.$emit("invalid-fixed-range", Te)),
              onTimeUpdate: Y[8] || (Y[8] = (Te) => x.$emit("time-update")),
              onAmPmChange: Y[9] || (Y[9] = (Te) => x.$emit("am-pm-change", Te)),
              onTimePickerOpen: Y[10] || (Y[10] = (Te) => x.$emit("time-picker-open", Te)),
              onTimePickerClose: Le,
              onRecalculatePosition: J,
              onUpdateMonthYear: Y[11] || (Y[11] = (Te) => x.$emit("update-month-year", Te)),
              onAutoApplyInvalid: Y[12] || (Y[12] = (Te) => x.$emit("auto-apply-invalid", Te)),
              onInvalidDate: Y[13] || (Y[13] = (Te) => x.$emit("invalid-date", Te)),
              onOverlayToggle: Y[14] || (Y[14] = (Te) => x.$emit("overlay-toggle", Te)),
              "onUpdate:internalModelValue": Y[15] || (Y[15] = (Te) => x.$emit("update:internal-model-value", Te))
            }), At({ _: 2 }, [
              et(ie.value, (Te, ae) => ({
                name: Te,
                fn: S((ve) => [
                  $(x.$slots, Te, Ye(ot({ ...ve })))
                ])
              }))
            ]), 1040, ["flow-step", "onMount", "onUpdateFlowStep", "onResetFlow"]))
          ], 512),
          x.$slots["right-sidebar"] ? (w(), K("div", x$, [
            $(x.$slots, "right-sidebar", Ye(ot(re.value)))
          ])) : V("", !0),
          x.$slots["action-extra"] ? (w(), K("div", A$, [
            x.$slots["action-extra"] ? $(x.$slots, "action-extra", {
              key: 0,
              selectCurrentDate: Z
            }) : V("", !0)
          ])) : V("", !0)
        ], 14, E$),
        !x.autoApply || p(h).keepActionRow ? (w(), I(AN, oe({
          key: 3,
          "menu-mount": k.value
        }, i.value, {
          "calendar-width": b.value,
          onClosePicker: Y[16] || (Y[16] = (Te) => x.$emit("close-picker")),
          onSelectDate: Y[17] || (Y[17] = (Te) => x.$emit("select-date")),
          onInvalidSelect: Y[18] || (Y[18] = (Te) => x.$emit("invalid-select")),
          onSelectNow: Z
        }), At({ _: 2 }, [
          et(p(Ce), (Te, ae) => ({
            name: Te,
            fn: S((ve) => [
              $(x.$slots, Te, Ye(ot({ ...ve })))
            ])
          }))
        ]), 1040, ["menu-mount", "calendar-width"])) : V("", !0)
      ], 46, w$);
    };
  }
});
var _i = /* @__PURE__ */ ((t) => (t.center = "center", t.left = "left", t.right = "right", t))(_i || {});
const M$ = ({
  menuRef: t,
  menuRefInner: e,
  inputRef: n,
  pickerWrapperRef: r,
  inline: o,
  emit: a,
  props: i,
  slots: s
}) => {
  const { defaultedConfig: l } = $t(i), u = F({}), c = F(!1), d = F({
    top: "0",
    left: "0"
  }), f = F(!1), h = Bi(i, "teleportCenter");
  Ke(h, () => {
    d.value = JSON.parse(JSON.stringify({})), E();
  });
  const m = (W) => {
    if (i.teleport) {
      const Q = W.getBoundingClientRect();
      return {
        left: Q.left + window.scrollX,
        top: Q.top + window.scrollY
      };
    }
    return { top: 0, left: 0 };
  }, g = (W, Q) => {
    d.value.left = `${W + Q - u.value.width}px`;
  }, y = (W) => {
    d.value.left = `${W}px`;
  }, b = (W, Q) => {
    i.position === _i.left && y(W), i.position === _i.right && g(W, Q), i.position === _i.center && (d.value.left = `${W + Q / 2 - u.value.width / 2}px`);
  }, C = (W) => {
    const { width: Q, height: de } = W.getBoundingClientRect(), { top: re, left: J } = m(W);
    return { top: +re, left: +J, width: Q, height: de };
  }, k = () => {
    d.value.left = "50%", d.value.top = "50%", d.value.transform = "translate(-50%, -50%)", d.value.position = "fixed", delete d.value.opacity;
  }, v = () => {
    const W = en(n);
    d.value = i.altPosition(W);
  }, E = (W = !0) => {
    var Q;
    if (!o.value.enabled) {
      if (h.value) return k();
      if (i.altPosition !== null) return v();
      if (W) {
        const de = i.teleport ? (Q = e.value) == null ? void 0 : Q.$el : t.value;
        de && (u.value = de.getBoundingClientRect()), a("recalculate-position");
      }
      return z();
    }
  }, _ = ({ inputEl: W, left: Q, width: de }) => {
    window.screen.width > 768 && !c.value && b(Q, de), O(W);
  }, T = (W) => {
    const { top: Q, left: de, height: re, width: J } = C(W);
    d.value.top = `${re + Q + +i.offset}px`, f.value = !1, c.value || (d.value.left = `${de + J / 2 - u.value.width / 2}px`), _({ inputEl: W, left: de, width: J });
  }, M = (W) => {
    const { top: Q, left: de, width: re } = C(W);
    d.value.top = `${Q - +i.offset - u.value.height}px`, f.value = !0, _({ inputEl: W, left: de, width: re });
  }, O = (W) => {
    if (i.autoPosition) {
      const { left: Q, width: de } = C(W), { left: re, right: J } = u.value;
      if (!c.value) {
        if (Math.abs(re) !== Math.abs(J)) {
          if (re <= 0)
            return c.value = !0, y(Q);
          if (J >= document.documentElement.clientWidth)
            return c.value = !0, g(Q, de);
        }
        return b(Q, de);
      }
    }
  }, R = () => {
    const W = en(n);
    if (W) {
      if (i.autoPosition === Cr.top) return Cr.top;
      if (i.autoPosition === Cr.bottom) return Cr.bottom;
      const { height: Q } = u.value, { top: de, height: re } = W.getBoundingClientRect(), J = window.innerHeight - de - re, Ce = de;
      return Q <= J ? Cr.bottom : Q > J && Q <= Ce ? Cr.top : J >= Ce ? Cr.bottom : Cr.top;
    }
    return Cr.bottom;
  }, N = (W) => R() === Cr.bottom ? T(W) : M(W), z = () => {
    const W = en(n);
    if (W)
      return i.autoPosition ? N(W) : T(W);
  }, te = function(W) {
    if (W) {
      const Q = W.scrollHeight > W.clientHeight, de = window.getComputedStyle(W).overflowY.indexOf("hidden") !== -1;
      return Q && !de;
    }
    return !0;
  }, H = function(W) {
    return !W || W === document.body || W.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? window : te(W) ? W : H(
      W.assignedSlot && l.value.shadowDom ? W.assignedSlot.parentNode : W.parentNode
    );
  }, U = (W) => {
    if (W)
      switch (i.position) {
        case _i.left:
          return { left: 0, transform: "translateX(0)" };
        case _i.right:
          return { left: `${W.width}px`, transform: "translateX(-100%)" };
        default:
          return { left: `${W.width / 2}px`, transform: "translateX(-50%)" };
      }
    return {};
  };
  return {
    openOnTop: f,
    menuStyle: d,
    xCorrect: c,
    setMenuPosition: E,
    getScrollableParent: H,
    shadowRender: (W, Q) => {
      var de, re, J;
      const Ce = document.createElement("div"), ie = (de = en(n)) == null ? void 0 : de.getBoundingClientRect();
      Ce.setAttribute("id", "dp--temp-container");
      const ee = (re = r.value) != null && re.clientWidth ? r.value : document.body;
      ee.append(Ce);
      const D = U(ie), G = l.value.shadowDom ? Object.keys(s).filter(
        (P) => ["right-sidebar", "left-sidebar", "top-extra", "action-extra"].includes(P)
      ) : Object.keys(s), fe = Kn(
        W,
        {
          ...Q,
          shadow: !0,
          style: { opacity: 0, position: "absolute", ...D }
        },
        Object.fromEntries(G.map((P) => [P, s[P]]))
      );
      ym(fe, Ce), u.value = (J = fe.el) == null ? void 0 : J.getBoundingClientRect(), ym(null, Ce), ee.removeChild(Ce);
    }
  };
}, Uo = [
  { name: "clock-icon", use: ["time", "calendar", "shared"] },
  { name: "arrow-left", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-right", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-up", use: ["time", "calendar", "month-year", "shared"] },
  { name: "arrow-down", use: ["time", "calendar", "month-year", "shared"] },
  { name: "calendar-icon", use: ["month-year", "time", "calendar", "shared", "year-mode"] },
  { name: "day", use: ["calendar", "shared"] },
  { name: "month-overlay-value", use: ["calendar", "month-year", "shared"] },
  { name: "year-overlay-value", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "year-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay-header", use: ["month-year", "shared"] },
  { name: "year-overlay-header", use: ["month-year", "shared"] },
  { name: "hours-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "hours-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "hours", use: ["calendar", "time", "shared"] },
  { name: "minutes", use: ["calendar", "time", "shared"] },
  { name: "month", use: ["calendar", "month-year", "shared"] },
  { name: "year", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "action-buttons", use: ["action"] },
  { name: "action-preview", use: ["action"] },
  { name: "calendar-header", use: ["calendar", "shared"] },
  { name: "marker-tooltip", use: ["calendar", "shared"] },
  { name: "action-extra", use: ["menu"] },
  { name: "time-picker-overlay", use: ["calendar", "time", "shared"] },
  { name: "am-pm-button", use: ["calendar", "time", "shared"] },
  { name: "left-sidebar", use: ["menu"] },
  { name: "right-sidebar", use: ["menu"] },
  { name: "month-year", use: ["month-year", "shared"] },
  { name: "time-picker", use: ["menu", "shared"] },
  { name: "action-row", use: ["action"] },
  { name: "marker", use: ["calendar", "shared"] },
  { name: "quarter", use: ["shared"] },
  { name: "top-extra", use: ["shared", "month-year"] },
  { name: "tp-inline-arrow-up", use: ["shared", "time"] },
  { name: "tp-inline-arrow-down", use: ["shared", "time"] },
  { name: "menu-header", use: ["menu"] }
], I$ = [{ name: "trigger" }, { name: "input-icon" }, { name: "clear-icon" }, { name: "dp-input" }], D$ = {
  all: () => Uo,
  monthYear: () => Uo.filter((t) => t.use.includes("month-year")),
  input: () => I$,
  timePicker: () => Uo.filter((t) => t.use.includes("time")),
  action: () => Uo.filter((t) => t.use.includes("action")),
  calendar: () => Uo.filter((t) => t.use.includes("calendar")),
  menu: () => Uo.filter((t) => t.use.includes("menu")),
  shared: () => Uo.filter((t) => t.use.includes("shared")),
  yearMode: () => Uo.filter((t) => t.use.includes("year-mode"))
}, Zn = (t, e, n) => {
  const r = [];
  return D$[e]().forEach((o) => {
    t[o.name] && r.push(o.name);
  }), n != null && n.length && n.forEach((o) => {
    o.slot && r.push(o.slot);
  }), r;
}, Rl = (t) => {
  const e = A(() => (r) => t.value ? r ? t.value.open : t.value.close : ""), n = A(() => (r) => t.value ? r ? t.value.menuAppearTop : t.value.menuAppearBottom : "");
  return { transitionName: e, showTransition: !!t.value, menuTransition: n };
}, Ll = (t, e, n) => {
  const { defaultedRange: r, defaultedTz: o } = $t(t), a = we(jn(we(), o.value.timezone)), i = F([{ month: ft(a), year: Qe(a) }]), s = (f) => {
    const h = {
      hours: $o(a),
      minutes: fa(a),
      seconds: 0
    };
    return r.value.enabled ? [h[f], h[f]] : h[f];
  }, l = eo({
    hours: s("hours"),
    minutes: s("minutes"),
    seconds: s("seconds")
  });
  Ke(
    r,
    (f, h) => {
      f.enabled !== h.enabled && (l.hours = s("hours"), l.minutes = s("minutes"), l.seconds = s("seconds"));
    },
    { deep: !0 }
  );
  const u = A({
    get: () => t.internalModelValue,
    set: (f) => {
      !t.readonly && !t.disabled && e("update:internal-model-value", f);
    }
  }), c = A(
    () => (f) => i.value[f] ? i.value[f].month : 0
  ), d = A(
    () => (f) => i.value[f] ? i.value[f].year : 0
  );
  return Ke(
    u,
    (f, h) => {
      n && JSON.stringify(f ?? {}) !== JSON.stringify(h ?? {}) && n();
    },
    { deep: !0 }
  ), {
    calendars: i,
    time: l,
    modelValue: u,
    month: c,
    year: d,
    today: a
  };
}, P$ = (t, e) => {
  const {
    defaultedMultiCalendars: n,
    defaultedMultiDates: r,
    defaultedUI: o,
    defaultedHighlight: a,
    defaultedTz: i,
    propDates: s,
    defaultedRange: l
  } = $t(e), { isDisabled: u } = ka(e), c = F(null), d = F(jn(/* @__PURE__ */ new Date(), i.value.timezone)), f = (D) => {
    !D.current && e.hideOffsetDates || (c.value = D.value);
  }, h = () => {
    c.value = null;
  }, m = (D) => Array.isArray(t.value) && l.value.enabled && t.value[0] && c.value ? D ? Kt(c.value, t.value[0]) : Vt(c.value, t.value[0]) : !0, g = (D, G) => {
    const fe = () => t.value ? G ? t.value[0] || null : t.value[1] : null, P = t.value && Array.isArray(t.value) ? fe() : null;
    return mt(we(D.value), P);
  }, y = (D) => {
    const G = Array.isArray(t.value) ? t.value[0] : null;
    return D ? !Vt(c.value ?? null, G) : !0;
  }, b = (D, G = !0) => (l.value.enabled || e.weekPicker) && Array.isArray(t.value) && t.value.length === 2 ? e.hideOffsetDates && !D.current ? !1 : mt(we(D.value), t.value[G ? 0 : 1]) : l.value.enabled ? g(D, G) && y(G) || mt(D.value, Array.isArray(t.value) ? t.value[0] : null) && m(G) : !1, C = (D, G) => {
    if (Array.isArray(t.value) && t.value[0] && t.value.length === 1) {
      const fe = mt(D.value, c.value);
      return G ? Kt(t.value[0], D.value) && fe : Vt(t.value[0], D.value) && fe;
    }
    return !1;
  }, k = (D) => !t.value || e.hideOffsetDates && !D.current ? !1 : l.value.enabled ? e.modelAuto && Array.isArray(t.value) ? mt(D.value, t.value[0] ? t.value[0] : d.value) : !1 : r.value.enabled && Array.isArray(t.value) ? t.value.some((G) => mt(G, D.value)) : mt(D.value, t.value ? t.value : d.value), v = (D) => {
    if (l.value.autoRange || e.weekPicker) {
      if (c.value) {
        if (e.hideOffsetDates && !D.current) return !1;
        const G = Or(c.value, +l.value.autoRange), fe = Eo(we(c.value), e.weekStart);
        return e.weekPicker ? mt(fe[1], we(D.value)) : mt(G, we(D.value));
      }
      return !1;
    }
    return !1;
  }, E = (D) => {
    if (l.value.autoRange || e.weekPicker) {
      if (c.value) {
        const G = Or(c.value, +l.value.autoRange);
        if (e.hideOffsetDates && !D.current) return !1;
        const fe = Eo(we(c.value), e.weekStart);
        return e.weekPicker ? Kt(D.value, fe[0]) && Vt(D.value, fe[1]) : Kt(D.value, c.value) && Vt(D.value, G);
      }
      return !1;
    }
    return !1;
  }, _ = (D) => {
    if (l.value.autoRange || e.weekPicker) {
      if (c.value) {
        if (e.hideOffsetDates && !D.current) return !1;
        const G = Eo(we(c.value), e.weekStart);
        return e.weekPicker ? mt(G[0], D.value) : mt(c.value, D.value);
      }
      return !1;
    }
    return !1;
  }, T = (D) => Hc(t.value, c.value, D.value), M = () => e.modelAuto && Array.isArray(e.internalModelValue) ? !!e.internalModelValue[0] : !1, O = () => e.modelAuto ? ik(e.internalModelValue) : !0, R = (D) => {
    if (e.weekPicker) return !1;
    const G = l.value.enabled ? !b(D) && !b(D, !1) : !0;
    return !u(D.value) && !k(D) && !(!D.current && e.hideOffsetDates) && G;
  }, N = (D) => l.value.enabled ? e.modelAuto ? M() && k(D) : !1 : k(D), z = (D) => a.value ? ZP(D.value, s.value.highlight) : !1, te = (D) => {
    const G = u(D.value);
    return G && (typeof a.value == "function" ? !a.value(D.value, G) : !a.value.options.highlightDisabled);
  }, H = (D) => {
    var G;
    return typeof a.value == "function" ? a.value(D.value) : (G = a.value.weekdays) == null ? void 0 : G.includes(D.value.getDay());
  }, U = (D) => (l.value.enabled || e.weekPicker) && (!(n.value.count > 0) || D.current) && O() && !(!D.current && e.hideOffsetDates) && !k(D) ? T(D) : !1, W = (D) => {
    const { isRangeStart: G, isRangeEnd: fe } = J(D), P = l.value.enabled ? G || fe : !1;
    return {
      dp__cell_offset: !D.current,
      dp__pointer: !e.disabled && !(!D.current && e.hideOffsetDates) && !u(D.value),
      dp__cell_disabled: u(D.value),
      dp__cell_highlight: !te(D) && (z(D) || H(D)) && !N(D) && !P && !_(D) && !(U(D) && e.weekPicker) && !fe,
      dp__cell_highlight_active: !te(D) && (z(D) || H(D)) && N(D),
      dp__today: !e.noToday && mt(D.value, d.value) && D.current,
      "dp--past": Vt(D.value, d.value),
      "dp--future": Kt(D.value, d.value)
    };
  }, Q = (D) => ({
    dp__active_date: N(D),
    dp__date_hover: R(D)
  }), de = (D) => {
    if (t.value && !Array.isArray(t.value)) {
      const G = Eo(t.value, e.weekStart);
      return {
        ...ie(D),
        dp__range_start: mt(G[0], D.value),
        dp__range_end: mt(G[1], D.value),
        dp__range_between_week: Kt(D.value, G[0]) && Vt(D.value, G[1])
      };
    }
    return {
      ...ie(D)
    };
  }, re = (D) => {
    if (t.value && Array.isArray(t.value)) {
      const G = Eo(t.value[0], e.weekStart), fe = t.value[1] ? Eo(t.value[1], e.weekStart) : [];
      return {
        ...ie(D),
        dp__range_start: mt(G[0], D.value) || mt(fe[0], D.value),
        dp__range_end: mt(G[1], D.value) || mt(fe[1], D.value),
        dp__range_between_week: Kt(D.value, G[0]) && Vt(D.value, G[1]) || Kt(D.value, fe[0]) && Vt(D.value, fe[1]),
        dp__range_between: Kt(D.value, G[1]) && Vt(D.value, fe[0])
      };
    }
    return {
      ...ie(D)
    };
  }, J = (D) => {
    const G = n.value.count > 0 ? D.current && b(D) && O() : b(D) && O(), fe = n.value.count > 0 ? D.current && b(D, !1) && O() : b(D, !1) && O();
    return { isRangeStart: G, isRangeEnd: fe };
  }, Ce = (D) => {
    const { isRangeStart: G, isRangeEnd: fe } = J(D);
    return {
      dp__range_start: G,
      dp__range_end: fe,
      dp__range_between: U(D),
      dp__date_hover: mt(D.value, c.value) && !G && !fe && !e.weekPicker,
      dp__date_hover_start: C(D, !0),
      dp__date_hover_end: C(D, !1)
    };
  }, ie = (D) => ({
    ...Ce(D),
    dp__cell_auto_range: E(D),
    dp__cell_auto_range_start: _(D),
    dp__cell_auto_range_end: v(D)
  }), ee = (D) => l.value.enabled ? l.value.autoRange ? ie(D) : e.modelAuto ? { ...Q(D), ...Ce(D) } : e.weekPicker ? re(D) : Ce(D) : e.weekPicker ? de(D) : Q(D);
  return {
    setHoverDate: f,
    clearHoverDate: h,
    getDayClassData: (D) => e.hideOffsetDates && !D.current ? {} : {
      ...W(D),
      ...ee(D),
      [e.dayClass ? e.dayClass(D.value, e.internalModelValue) : ""]: !0,
      ...o.value.calendarCell ?? {}
    }
  };
}, ka = (t) => {
  const { defaultedFilters: e, defaultedRange: n, propDates: r, defaultedMultiDates: o } = $t(t), a = (H) => r.value.disabledDates ? typeof r.value.disabledDates == "function" ? r.value.disabledDates(we(H)) : !!xu(H, r.value.disabledDates) : !1, i = (H) => r.value.maxDate ? t.yearPicker ? Qe(H) > Qe(r.value.maxDate) : Kt(H, r.value.maxDate) : !1, s = (H) => r.value.minDate ? t.yearPicker ? Qe(H) < Qe(r.value.minDate) : Vt(H, r.value.minDate) : !1, l = (H) => {
    const U = i(H), W = s(H), Q = a(H), de = e.value.months.map((ee) => +ee).includes(ft(H)), re = t.disabledWeekDays.length ? t.disabledWeekDays.some((ee) => +ee === VD(H)) : !1, J = h(H), Ce = Qe(H), ie = Ce < +t.yearRange[0] || Ce > +t.yearRange[1];
    return !(U || W || Q || de || ie || re || J);
  }, u = (H, U) => Vt(...Xo(r.value.minDate, H, U)) || mt(...Xo(r.value.minDate, H, U)), c = (H, U) => Kt(...Xo(r.value.maxDate, H, U)) || mt(...Xo(r.value.maxDate, H, U)), d = (H, U, W) => {
    let Q = !1;
    return r.value.maxDate && W && c(H, U) && (Q = !0), r.value.minDate && !W && u(H, U) && (Q = !0), Q;
  }, f = (H, U, W, Q) => {
    let de = !1;
    return Q && (r.value.minDate || r.value.maxDate) ? r.value.minDate && r.value.maxDate ? de = d(H, U, W) : (r.value.minDate && u(H, U) || r.value.maxDate && c(H, U)) && (de = !0) : de = !0, de;
  }, h = (H) => Array.isArray(r.value.allowedDates) && !r.value.allowedDates.length ? !0 : r.value.allowedDates ? !xu(H, r.value.allowedDates) : !1, m = (H) => !l(H), g = (H) => n.value.noDisabledRange ? !W0({ start: H[0], end: H[1] }).some((U) => m(U)) : !0, y = (H) => {
    if (H) {
      const U = Qe(H);
      return U >= +t.yearRange[0] && U <= t.yearRange[1];
    }
    return !0;
  }, b = (H, U) => !!(Array.isArray(H) && H[U] && (n.value.maxRange || n.value.minRange) && y(H[U])), C = (H, U, W = 0) => {
    if (b(U, W) && y(H)) {
      const Q = H0(H, U[W]), de = dk(U[W], H), re = de.length === 1 ? 0 : de.filter((Ce) => m(Ce)).length, J = Math.abs(Q) - (n.value.minMaxRawRange ? 0 : re);
      if (n.value.minRange && n.value.maxRange)
        return J >= +n.value.minRange && J <= +n.value.maxRange;
      if (n.value.minRange) return J >= +n.value.minRange;
      if (n.value.maxRange) return J <= +n.value.maxRange;
    }
    return !0;
  }, k = () => !t.enableTimePicker || t.monthPicker || t.yearPicker || t.ignoreTimeValidation, v = (H) => Array.isArray(H) ? [H[0] ? Sd(H[0]) : null, H[1] ? Sd(H[1]) : null] : Sd(H), E = (H, U, W) => H.find(
    (Q) => +Q.hours === $o(U) && Q.minutes === "*" ? !0 : +Q.minutes === fa(U) && +Q.hours === $o(U)
  ) && W, _ = (H, U, W) => {
    const [Q, de] = H, [re, J] = U;
    return !E(Q, re, W) && !E(de, J, W) && W;
  }, T = (H, U) => {
    const W = Array.isArray(U) ? U : [U];
    return Array.isArray(t.disabledTimes) ? Array.isArray(t.disabledTimes[0]) ? _(t.disabledTimes, W, H) : !W.some((Q) => E(t.disabledTimes, Q, H)) : H;
  }, M = (H, U) => {
    const W = Array.isArray(U) ? [Fa(U[0]), U[1] ? Fa(U[1]) : void 0] : Fa(U), Q = !t.disabledTimes(W);
    return H && Q;
  }, O = (H, U) => t.disabledTimes ? Array.isArray(t.disabledTimes) ? T(U, H) : M(U, H) : U, R = (H) => {
    let U = !0;
    if (!H || k()) return !0;
    const W = !r.value.minDate && !r.value.maxDate ? v(H) : H;
    return (t.maxTime || r.value.maxDate) && (U = Lg(
      t.maxTime,
      r.value.maxDate,
      "max",
      an(W),
      U
    )), (t.minTime || r.value.minDate) && (U = Lg(
      t.minTime,
      r.value.minDate,
      "min",
      an(W),
      U
    )), O(H, U);
  }, N = (H) => {
    if (!t.monthPicker) return !0;
    let U = !0;
    const W = we(Tr(H));
    if (r.value.minDate && r.value.maxDate) {
      const Q = we(Tr(r.value.minDate)), de = we(Tr(r.value.maxDate));
      return Kt(W, Q) && Vt(W, de) || mt(W, Q) || mt(W, de);
    }
    if (r.value.minDate) {
      const Q = we(Tr(r.value.minDate));
      U = Kt(W, Q) || mt(W, Q);
    }
    if (r.value.maxDate) {
      const Q = we(Tr(r.value.maxDate));
      U = Vt(W, Q) || mt(W, Q);
    }
    return U;
  }, z = A(() => (H) => !t.enableTimePicker || t.ignoreTimeValidation ? !0 : R(H)), te = A(() => (H) => t.monthPicker ? Array.isArray(H) && (n.value.enabled || o.value.enabled) ? !H.filter((U) => !N(U)).length : N(H) : !0);
  return {
    isDisabled: m,
    validateDate: l,
    validateMonthYearInRange: f,
    isDateRangeAllowed: g,
    checkMinMaxRange: C,
    isValidTime: R,
    isTimeValid: z,
    isMonthValid: te
  };
}, jc = () => {
  const t = A(() => (r, o) => r == null ? void 0 : r.includes(o)), e = A(() => (r, o) => r.count ? r.solo ? !0 : o === 0 : !0), n = A(() => (r, o) => r.count ? r.solo ? !0 : o === r.count - 1 : !0);
  return { hideNavigationButtons: t, showLeftIcon: e, showRightIcon: n };
}, N$ = (t, e, n) => {
  const r = F(0), o = eo({
    [Ba.timePicker]: !t.enableTimePicker || t.timePicker || t.monthPicker,
    [Ba.calendar]: !1,
    [Ba.header]: !1
  }), a = A(() => t.monthPicker || t.timePicker), i = (d) => {
    var f;
    if ((f = t.flow) != null && f.length) {
      if (!d && a.value) return c();
      o[d] = !0, Object.keys(o).filter((h) => !o[h]).length || c();
    }
  }, s = () => {
    var d, f;
    (d = t.flow) != null && d.length && r.value !== -1 && (r.value += 1, e("flow-step", r.value), c()), ((f = t.flow) == null ? void 0 : f.length) === r.value && nt().then(() => l());
  }, l = () => {
    r.value = -1;
  }, u = (d, f, ...h) => {
    var m, g;
    t.flow[r.value] === d && n.value && ((g = (m = n.value)[f]) == null || g.call(m, ...h));
  }, c = (d = 0) => {
    d && (r.value += d), u(wn.month, "toggleMonthPicker", !0), u(wn.year, "toggleYearPicker", !0), u(wn.calendar, "toggleTimePicker", !1, !0), u(wn.time, "toggleTimePicker", !0, !0);
    const f = t.flow[r.value];
    (f === wn.hours || f === wn.minutes || f === wn.seconds) && u(f, "toggleTimePicker", !0, !0, f);
  };
  return { childMount: i, updateFlowStep: s, resetFlow: l, handleFlow: c, flowStep: r };
}, $$ = {
  key: 1,
  class: "dp__input_wrap"
}, R$ = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "aria-label", "aria-disabled", "aria-invalid"], L$ = {
  key: 2,
  class: "dp--clear-btn"
}, B$ = ["aria-label"], F$ = /* @__PURE__ */ j({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 },
    inputValue: { type: String, default: "" },
    ...Uc
  },
  emits: [
    "clear",
    "open",
    "update:input-value",
    "set-input-date",
    "close",
    "select-date",
    "set-empty-date",
    "toggle",
    "focus-prev",
    "focus",
    "blur",
    "real-blur",
    "text-input"
  ],
  setup(t, { expose: e, emit: n }) {
    const r = n, o = t, {
      defaultedTextInput: a,
      defaultedAriaLabels: i,
      defaultedInline: s,
      defaultedConfig: l,
      defaultedRange: u,
      defaultedMultiDates: c,
      defaultedUI: d,
      getDefaultPattern: f,
      getDefaultStartTime: h
    } = $t(o), { checkMinMaxRange: m } = ka(o), g = F(), y = F(null), b = F(!1), C = F(!1), k = A(
      () => ({
        dp__pointer: !o.disabled && !o.readonly && !a.value.enabled,
        dp__disabled: o.disabled,
        dp__input_readonly: !a.value.enabled,
        dp__input: !0,
        dp__input_icon_pad: !o.hideInputIcon,
        dp__input_valid: typeof o.state == "boolean" ? o.state : !1,
        dp__input_invalid: typeof o.state == "boolean" ? !o.state : !1,
        dp__input_focus: b.value || o.isMenuOpen,
        dp__input_reg: !a.value.enabled,
        ...d.value.input ?? {}
      })
    ), v = () => {
      r("set-input-date", null), o.clearable && o.autoApply && (r("set-empty-date"), g.value = null);
    }, E = (J) => {
      const Ce = h();
      return eN(
        J,
        a.value.format ?? f(),
        Ce ?? fk({}, o.enableSeconds),
        o.inputValue,
        C.value,
        o.formatLocale
      );
    }, _ = (J) => {
      const { rangeSeparator: Ce } = a.value, [ie, ee] = J.split(`${Ce}`);
      if (ie) {
        const D = E(ie.trim()), G = ee ? E(ee.trim()) : null;
        if (ji(D, G)) return;
        const fe = D && G ? [D, G] : [D];
        m(G, fe, 0) && (g.value = D ? fe : null);
      }
    }, T = () => {
      C.value = !0;
    }, M = (J) => {
      if (u.value.enabled)
        _(J);
      else if (c.value.enabled) {
        const Ce = J.split(";");
        g.value = Ce.map((ie) => E(ie.trim())).filter((ie) => ie);
      } else
        g.value = E(J);
    }, O = (J) => {
      var Ce;
      const ie = typeof J == "string" ? J : (Ce = J.target) == null ? void 0 : Ce.value;
      ie !== "" ? (a.value.openMenu && !o.isMenuOpen && r("open"), M(ie), r("set-input-date", g.value)) : v(), C.value = !1, r("update:input-value", ie), r("text-input", J, g.value);
    }, R = (J) => {
      a.value.enabled ? (M(J.target.value), a.value.enterSubmit && Uf(g.value) && o.inputValue !== "" ? (r("set-input-date", g.value, !0), g.value = null) : a.value.enterSubmit && o.inputValue === "" && (g.value = null, r("clear"))) : te(J);
    }, N = (J, Ce) => {
      a.value.enabled && a.value.tabSubmit && !Ce && M(J.target.value), a.value.tabSubmit && Uf(g.value) && o.inputValue !== "" ? (r("set-input-date", g.value, !0, !0), g.value = null) : a.value.tabSubmit && o.inputValue === "" && (g.value = null, r("clear", !0));
    }, z = () => {
      b.value = !0, r("focus"), nt().then(() => {
        var J;
        a.value.enabled && a.value.selectOnFocus && ((J = y.value) == null || J.select());
      });
    }, te = (J) => {
      if (ta(J, l.value, !0), a.value.enabled && a.value.openMenu && !s.value.input) {
        if (a.value.openMenu === "open" && !o.isMenuOpen) return r("open");
        if (a.value.openMenu === "toggle") return r("toggle");
      } else a.value.enabled || r("toggle");
    }, H = () => {
      r("real-blur"), b.value = !1, (!o.isMenuOpen || s.value.enabled && s.value.input) && r("blur"), o.autoApply && a.value.enabled && g.value && !o.isMenuOpen && (r("set-input-date", g.value), r("select-date"), g.value = null);
    }, U = (J) => {
      ta(J, l.value, !0), r("clear");
    }, W = (J) => {
      if (J.key === "Tab" && N(J), J.key === "Enter" && R(J), !a.value.enabled) {
        if (J.code === "Tab") return;
        J.preventDefault();
      }
    }, Q = () => {
      var J;
      (J = y.value) == null || J.focus({ preventScroll: !0 });
    }, de = (J) => {
      g.value = J;
    }, re = (J) => {
      J.key === Dt.tab && N(J, !0);
    };
    return e({
      focusInput: Q,
      setParsedDate: de
    }), (J, Ce) => {
      var ie, ee, D;
      return w(), K("div", { onClick: te }, [
        J.$slots.trigger && !J.$slots["dp-input"] && !p(s).enabled ? $(J.$slots, "trigger", { key: 0 }) : V("", !0),
        !J.$slots.trigger && (!p(s).enabled || p(s).input) ? (w(), K("div", $$, [
          J.$slots["dp-input"] && !J.$slots.trigger && (!p(s).enabled || p(s).enabled && p(s).input) ? $(J.$slots, "dp-input", {
            key: 0,
            value: t.inputValue,
            isMenuOpen: t.isMenuOpen,
            onInput: O,
            onEnter: R,
            onTab: N,
            onClear: U,
            onBlur: H,
            onKeypress: W,
            onPaste: T,
            onFocus: z,
            openMenu: () => J.$emit("open"),
            closeMenu: () => J.$emit("close"),
            toggleMenu: () => J.$emit("toggle")
          }) : V("", !0),
          J.$slots["dp-input"] ? V("", !0) : (w(), K("input", {
            key: 1,
            id: J.uid ? `dp-input-${J.uid}` : void 0,
            ref_key: "inputRef",
            ref: y,
            "data-test-id": "dp-input",
            name: J.name,
            class: Ie(k.value),
            inputmode: p(a).enabled ? "text" : "none",
            placeholder: J.placeholder,
            disabled: J.disabled,
            readonly: J.readonly,
            required: J.required,
            value: t.inputValue,
            autocomplete: J.autocomplete,
            "aria-label": (ie = p(i)) == null ? void 0 : ie.input,
            "aria-disabled": J.disabled || void 0,
            "aria-invalid": J.state === !1 ? !0 : void 0,
            onInput: O,
            onBlur: H,
            onFocus: z,
            onKeypress: W,
            onKeydown: Ce[0] || (Ce[0] = (G) => W(G)),
            onPaste: T
          }, null, 42, R$)),
          be("div", {
            onClick: Ce[3] || (Ce[3] = (G) => r("toggle"))
          }, [
            J.$slots["input-icon"] && !J.hideInputIcon ? (w(), K("span", {
              key: 0,
              class: "dp__input_icon",
              onClick: Ce[1] || (Ce[1] = (G) => r("toggle"))
            }, [
              $(J.$slots, "input-icon")
            ])) : V("", !0),
            !J.$slots["input-icon"] && !J.hideInputIcon && !J.$slots["dp-input"] ? (w(), I(p(vs), {
              key: 1,
              "aria-label": (ee = p(i)) == null ? void 0 : ee.calendarIcon,
              class: "dp__input_icon dp__input_icons",
              onClick: Ce[2] || (Ce[2] = (G) => r("toggle"))
            }, null, 8, ["aria-label"])) : V("", !0)
          ]),
          J.$slots["clear-icon"] && t.inputValue && J.clearable && !J.disabled && !J.readonly ? (w(), K("span", L$, [
            $(J.$slots, "clear-icon", { clear: U })
          ])) : V("", !0),
          J.clearable && !J.$slots["clear-icon"] && t.inputValue && !J.disabled && !J.readonly ? (w(), K("button", {
            key: 3,
            "aria-label": (D = p(i)) == null ? void 0 : D.clearInput,
            class: "dp--clear-btn",
            type: "button",
            onKeydown: Ce[4] || (Ce[4] = (G) => p(Dn)(G, () => U(G), !0, re)),
            onClick: Ce[5] || (Ce[5] = Xe((G) => U(G), ["prevent"]))
          }, [
            q(p(ok), {
              class: "dp__input_icons",
              "data-test-id": "clear-icon"
            })
          ], 40, B$)) : V("", !0)
        ])) : V("", !0)
      ]);
    };
  }
}), V$ = typeof window < "u" ? window : void 0, Pd = () => {
}, H$ = (t) => bc() ? (kc(t), !0) : !1, U$ = (t, e, n, r) => {
  if (!t) return Pd;
  let o = Pd;
  const a = Ke(
    () => p(t),
    (s) => {
      o(), s && (s.addEventListener(e, n, r), o = () => {
        s.removeEventListener(e, n, r), o = Pd;
      });
    },
    { immediate: !0, flush: "post" }
  ), i = () => {
    a(), o();
  };
  return H$(i), i;
}, W$ = (t, e, n, r = {}) => {
  const { window: o = V$, event: a = "pointerdown" } = r;
  return o ? U$(o, a, (i) => {
    const s = en(t), l = en(e);
    !s || !l || s === i.target || i.composedPath().includes(s) || i.composedPath().includes(l) || n(i);
  }, { passive: !0 }) : void 0;
}, K$ = ["data-dp-mobile"], j$ = /* @__PURE__ */ j({
  compatConfig: {
    MODE: 3
  },
  __name: "VueDatePicker",
  props: {
    ...Uc
  },
  emits: [
    "update:model-value",
    "update:model-timezone-value",
    "text-submit",
    "closed",
    "cleared",
    "open",
    "focus",
    "blur",
    "internal-model-change",
    "recalculate-position",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "date-update",
    "invalid-date",
    "overlay-toggle",
    "text-input"
  ],
  setup(t, { expose: e, emit: n }) {
    const r = n, o = t, a = uo(), i = F(!1), s = Bi(o, "modelValue"), l = Bi(o, "timezone"), u = F(null), c = F(null), d = F(null), f = F(!1), h = F(null), m = F(!1), g = F(!1), y = F(!1), b = F(!1), { setMenuFocused: C, setShiftKey: k } = vk(), { clearArrowNav: v } = ba(), { validateDate: E, isValidTime: _ } = ka(o), {
      defaultedTransitions: T,
      defaultedTextInput: M,
      defaultedInline: O,
      defaultedConfig: R,
      defaultedRange: N,
      defaultedMultiDates: z
    } = $t(o), { menuTransition: te, showTransition: H } = Rl(T), { isMobile: U } = Ek(R);
    ze(() => {
      fe(o.modelValue), nt().then(() => {
        if (!O.value.enabled) {
          const le = ie(h.value);
          le == null || le.addEventListener("scroll", me), window == null || window.addEventListener("resize", Ve);
        }
      }), O.value.enabled && (i.value = !0), window == null || window.addEventListener("keyup", Ee), window == null || window.addEventListener("keydown", st);
    }), En(() => {
      if (!O.value.enabled) {
        const le = ie(h.value);
        le == null || le.removeEventListener("scroll", me), window == null || window.removeEventListener("resize", Ve);
      }
      window == null || window.removeEventListener("keyup", Ee), window == null || window.removeEventListener("keydown", st);
    });
    const W = Zn(a, "all", o.presetDates), Q = Zn(a, "input");
    Ke(
      [s, l],
      () => {
        fe(s.value);
      },
      { deep: !0 }
    );
    const { openOnTop: de, menuStyle: re, xCorrect: J, setMenuPosition: Ce, getScrollableParent: ie, shadowRender: ee } = M$({
      menuRef: u,
      menuRefInner: c,
      inputRef: d,
      pickerWrapperRef: h,
      inline: O,
      emit: r,
      props: o,
      slots: a
    }), {
      inputValue: D,
      internalModelValue: G,
      parseExternalModelValue: fe,
      emitModelValue: P,
      formatInputValue: se,
      checkBeforeEmit: ke
    } = ON(r, o, f), Le = A(
      () => ({
        dp__main: !0,
        dp__theme_dark: o.dark,
        dp__theme_light: !o.dark,
        dp__flex_display: O.value.enabled,
        "dp--flex-display-collapsed": y.value,
        dp__flex_display_with_input: O.value.input
      })
    ), ne = A(() => o.dark ? "dp__theme_dark" : "dp__theme_light"), ye = A(() => o.teleport ? {
      to: typeof o.teleport == "boolean" ? "body" : o.teleport,
      disabled: !o.teleport || O.value.enabled
    } : {}), pe = A(() => ({ class: "dp__outer_menu_wrap" })), Z = A(() => O.value.enabled && (o.timePicker || o.monthPicker || o.yearPicker || o.quarterPicker)), B = () => {
      var le, xe;
      return ((xe = (le = d.value) == null ? void 0 : le.$el) == null ? void 0 : xe.getBoundingClientRect()) ?? { width: 0, left: 0, right: 0 };
    }, me = () => {
      i.value && (R.value.closeOnScroll ? ve() : Ce());
    }, Ve = () => {
      var le;
      i.value && Ce();
      const xe = ((le = c.value) == null ? void 0 : le.$el.getBoundingClientRect().width) ?? 0;
      y.value = document.body.offsetWidth <= xe;
    }, Ee = (le) => {
      le.key === "Tab" && !O.value.enabled && !o.teleport && R.value.tabOutClosesMenu && (h.value.contains(document.activeElement) || ve()), g.value = le.shiftKey;
    }, st = (le) => {
      g.value = le.shiftKey;
    }, L = () => {
      !o.disabled && !o.readonly && (ee(Hg, o), Ce(!1), i.value = !0, i.value && r("open"), i.value || ae(), fe(o.modelValue));
    }, x = () => {
      var le;
      D.value = "", ae(), (le = d.value) == null || le.setParsedDate(null), r("update:model-value", null), r("update:model-timezone-value", null), r("cleared"), R.value.closeOnClearValue && ve();
    }, Y = () => {
      const le = G.value;
      return !le || !Array.isArray(le) && E(le) ? !0 : Array.isArray(le) ? z.value.enabled || le.length === 2 && E(le[0]) && E(le[1]) ? !0 : N.value.partialRange && !o.timePicker ? E(le[0]) : !1 : !1;
    }, ge = () => {
      ke() && Y() ? (P(), ve()) : r("invalid-select", G.value);
    }, Ge = (le) => {
      rt(), P(), R.value.closeOnAutoApply && !le && ve();
    }, rt = () => {
      d.value && M.value.enabled && d.value.setParsedDate(G.value);
    }, Te = (le = !1) => {
      o.autoApply && _(G.value) && Y() && (N.value.enabled && Array.isArray(G.value) ? (N.value.partialRange || G.value.length === 2) && Ge(le) : Ge(le));
    }, ae = () => {
      M.value.enabled || (G.value = null);
    }, ve = (le = !1) => {
      le && G.value && R.value.setDateOnMenuClose && ge(), O.value.enabled || (i.value && (i.value = !1, J.value = !1, C(!1), k(!1), v(), r("closed"), D.value && fe(s.value)), ae(), r("blur"));
    }, pt = (le, xe, Fe = !1) => {
      if (!le) {
        G.value = null;
        return;
      }
      const on = Array.isArray(le) ? !le.some((kr) => !E(kr)) : E(le), xn = _(le);
      on && xn ? (b.value = !0, G.value = le, xe && (m.value = Fe, ge(), r("text-submit")), nt().then(() => {
        b.value = !1;
      })) : r("invalid-date", le);
    }, Ot = () => {
      o.autoApply && _(G.value) && P(), rt();
    }, Sn = () => i.value ? ve() : L(), Fr = (le) => {
      G.value = le;
    }, or = () => {
      M.value.enabled && (f.value = !0, se()), r("focus");
    }, ue = () => {
      if (M.value.enabled && (f.value = !1, fe(o.modelValue), m.value)) {
        const le = QP(h.value, g.value);
        le == null || le.focus();
      }
      r("blur");
    }, Re = (le) => {
      c.value && c.value.updateMonthYear(0, {
        month: Pg(le.month),
        year: Pg(le.year)
      });
    }, Ue = (le) => {
      fe(le ?? o.modelValue);
    }, X = (le, xe) => {
      var Fe;
      (Fe = c.value) == null || Fe.switchView(le, xe);
    }, he = (le) => R.value.onClickOutside ? R.value.onClickOutside(le) : ve(!0), Ne = (le = 0) => {
      var xe;
      (xe = c.value) == null || xe.handleFlow(le);
    };
    return W$(u, d, () => he(Y)), e({
      closeMenu: ve,
      selectDate: ge,
      clearValue: x,
      openMenu: L,
      onScroll: me,
      formatInputValue: se,
      // exposed for testing purposes
      updateInternalModelValue: Fr,
      // modify internal modelValue
      setMonthYear: Re,
      parseModel: Ue,
      switchView: X,
      toggleMenu: Sn,
      handleFlow: Ne,
      dpWrapMenuRef: u
    }), (le, xe) => (w(), K("div", {
      ref_key: "pickerWrapperRef",
      ref: h,
      class: Ie(Le.value),
      "data-datepicker-instance": "",
      "data-dp-mobile": p(U)
    }, [
      q(F$, oe({
        ref_key: "inputRef",
        ref: d,
        "input-value": p(D),
        "onUpdate:inputValue": xe[0] || (xe[0] = (Fe) => bt(D) ? D.value = Fe : null),
        "is-menu-open": i.value
      }, le.$props, {
        onClear: x,
        onOpen: L,
        onSetInputDate: pt,
        onSetEmptyDate: p(P),
        onSelectDate: ge,
        onToggle: Sn,
        onClose: ve,
        onFocus: or,
        onBlur: ue,
        onRealBlur: xe[1] || (xe[1] = (Fe) => f.value = !1),
        onTextInput: xe[2] || (xe[2] = (Fe) => le.$emit("text-input", Fe))
      }), At({ _: 2 }, [
        et(p(Q), (Fe, on) => ({
          name: Fe,
          fn: S((xn) => [
            $(le.$slots, Fe, Ye(ot(xn)))
          ])
        }))
      ]), 1040, ["input-value", "is-menu-open", "onSetEmptyDate"]),
      (w(), I(On(le.teleport ? wc : "div"), Ye(ot(ye.value)), {
        default: S(() => [
          q(ss, {
            name: p(te)(p(de)),
            css: p(H) && !p(O).enabled
          }, {
            default: S(() => [
              i.value ? (w(), K("div", oe({
                key: 0,
                ref_key: "dpWrapMenuRef",
                ref: u
              }, pe.value, {
                class: { "dp--menu-wrapper": !p(O).enabled },
                style: p(O).enabled ? void 0 : p(re)
              }), [
                q(Hg, oe({
                  ref_key: "dpMenuRef",
                  ref: c
                }, le.$props, {
                  "internal-model-value": p(G),
                  "onUpdate:internalModelValue": xe[3] || (xe[3] = (Fe) => bt(G) ? G.value = Fe : null),
                  class: { [ne.value]: !0, "dp--menu-wrapper": le.teleport },
                  "open-on-top": p(de),
                  "no-overlay-focus": Z.value,
                  collapse: y.value,
                  "get-input-rect": B,
                  "is-text-input-date": b.value,
                  onClosePicker: ve,
                  onSelectDate: ge,
                  onAutoApply: Te,
                  onTimeUpdate: Ot,
                  onFlowStep: xe[4] || (xe[4] = (Fe) => le.$emit("flow-step", Fe)),
                  onUpdateMonthYear: xe[5] || (xe[5] = (Fe) => le.$emit("update-month-year", Fe)),
                  onInvalidSelect: xe[6] || (xe[6] = (Fe) => le.$emit("invalid-select", p(G))),
                  onAutoApplyInvalid: xe[7] || (xe[7] = (Fe) => le.$emit("invalid-select", Fe)),
                  onInvalidFixedRange: xe[8] || (xe[8] = (Fe) => le.$emit("invalid-fixed-range", Fe)),
                  onRecalculatePosition: p(Ce),
                  onTooltipOpen: xe[9] || (xe[9] = (Fe) => le.$emit("tooltip-open", Fe)),
                  onTooltipClose: xe[10] || (xe[10] = (Fe) => le.$emit("tooltip-close", Fe)),
                  onTimePickerOpen: xe[11] || (xe[11] = (Fe) => le.$emit("time-picker-open", Fe)),
                  onTimePickerClose: xe[12] || (xe[12] = (Fe) => le.$emit("time-picker-close", Fe)),
                  onAmPmChange: xe[13] || (xe[13] = (Fe) => le.$emit("am-pm-change", Fe)),
                  onRangeStart: xe[14] || (xe[14] = (Fe) => le.$emit("range-start", Fe)),
                  onRangeEnd: xe[15] || (xe[15] = (Fe) => le.$emit("range-end", Fe)),
                  onDateUpdate: xe[16] || (xe[16] = (Fe) => le.$emit("date-update", Fe)),
                  onInvalidDate: xe[17] || (xe[17] = (Fe) => le.$emit("invalid-date", Fe)),
                  onOverlayToggle: xe[18] || (xe[18] = (Fe) => le.$emit("overlay-toggle", Fe)),
                  onMenuBlur: xe[19] || (xe[19] = (Fe) => le.$emit("blur"))
                }), At({ _: 2 }, [
                  et(p(W), (Fe, on) => ({
                    name: Fe,
                    fn: S((xn) => [
                      $(le.$slots, Fe, Ye(ot({ ...xn })))
                    ])
                  }))
                ]), 1040, ["internal-model-value", "class", "open-on-top", "no-overlay-focus", "collapse", "is-text-input-date", "onRecalculatePosition"])
              ], 16)) : V("", !0)
            ]),
            _: 3
          }, 8, ["name", "css"])
        ]),
        _: 3
      }, 16))
    ], 10, K$));
  }
}), zc = /* @__PURE__ */ (() => {
  const t = j$;
  return t.install = (e) => {
    e.component("Vue3DatePicker", t);
  }, t;
})(), z$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zc
}, Symbol.toStringTag, { value: "Module" }));
Object.entries(z$).forEach(([t, e]) => {
  t !== "default" && (zc[t] = e);
});
const b8 = /* @__PURE__ */ j({
  __name: "KDateInput",
  props: /* @__PURE__ */ it({
    min: {},
    max: {},
    id: {},
    label: {},
    labelSrOnly: { type: [Boolean, String] },
    required: { type: [Boolean, String] },
    disabled: { type: [Boolean, String] },
    marginless: { type: [Boolean, String] },
    emptyValue: {},
    defaultValue: {},
    description: {},
    errors: {},
    variant: {},
    tooltip: {},
    tooltipProps: {},
    prependIcon: { default: "fal fa-calendar" },
    appendIcon: {},
    clearable: { type: [Boolean, String], default: !0 },
    displayFormat: {},
    acceptedFormats: {},
    modelFormat: {},
    locale: {},
    withTime: { type: [Boolean, String] },
    inline: { type: [Boolean, String] },
    side: {}
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ it(["blur"], ["update:modelValue"]),
  setup(t, { emit: e }) {
    const { t: n, locale: r } = Mt(), o = t, a = ut(t, "modelValue"), i = rr(a, o.defaultValue), s = e, l = A(
      () => o.displayFormat || (ce(o.withTime) ? "d.M.yyyy HH:mm" : "d.M.yyyy")
    ), u = A(
      () => o.modelFormat || (ce(o.withTime) ? "yyyy-MM-dd'T'HH:mm:ss" : "yyyy-MM-dd")
    ), c = A(() => {
      if (o.acceptedFormats && o.acceptedFormats.length)
        return o.acceptedFormats;
      const _ = ["yyyy-M-d", "d.M.yyyy", "ddMMyyyy", "d/M/yyyy", "d-M-yyyy"];
      return ce(o.withTime) && _.push(
        "yyyy-MM-dd'T'HH:mm:ss",
        "yyyy-M-d HH:mm",
        "d.M.yyyy HH:mm",
        "ddMMyyyyHHmm",
        "ddMMyyyy HHmm",
        "d/M/yyyy HH:mm",
        "d-M-yyyy HH:mm"
      ), _;
    }), d = (_) => {
      if (!_) return;
      if (sh(_)) return _;
      if (_d(_, u.value)) return La(_, u.value, /* @__PURE__ */ new Date());
      if (_d(_, l.value)) return La(_, l.value, /* @__PURE__ */ new Date());
      const T = c.value.find((M) => _d(_, M));
      if (T) return La(_, T, /* @__PURE__ */ new Date());
    }, f = (_) => {
      const T = d(_);
      if (T)
        return Mr(T, u.value);
    }, h = A({
      get: () => f(i.value),
      set: (_) => i.value = _
    }), m = A(() => ({
      enterSubmit: !0,
      tabSubmit: !1,
      // Jotta tabillä pääsee datepickeriin sisälle.
      openMenu: "open",
      selectOnFocus: !0,
      format: c.value
    })), g = fn(o), y = A(() => `dp-input-${g.value}`), b = yn(y, o), C = ho(o), k = A(() => ({
      [`k-date-${o.side}`]: !!o.side,
      [`k-date-${o.variant}`]: !!o.variant && o.variant !== "default",
      "k-date-error": C.value || o.variant === "error"
    })), v = () => {
      var T;
      const _ = document.getElementById(y.value);
      _ && ((T = _.tagName) == null ? void 0 : T.toLowerCase()) === "input" && b.value && _.setAttribute("aria-describedby", b.value);
    }, E = (_) => _ ? o.side === "top" ? { transform: `translateY(-${_.getBoundingClientRect().height + 315}px)` } : { transform: "translateY(15px)" } : { transform: "none" };
    return ze(v), Ke(b, v), (_, T) => (w(), I(yr, oe(_.$props, {
      input: h.value,
      "onUpdate:input": T[4] || (T[4] = (M) => h.value = M),
      "description-id": p(b),
      "input-id": y.value,
      "prepend-icon": void 0,
      "append-icon": h.value ? void 0 : _.appendIcon,
      clearable: !1
    }), {
      default: S(() => [
        q(p(zc), {
          modelValue: h.value,
          "onUpdate:modelValue": T[1] || (T[1] = (M) => h.value = M),
          uid: p(g),
          "model-type": u.value,
          locale: _.locale || p(r) || "fi-FI",
          format: l.value,
          "cancel-text": p(n)("k-cancel"),
          "select-text": p(n)("k-select"),
          "auto-apply": "",
          "enable-time-picker": p(ce)(_.withTime),
          "time-picker-inline": "",
          "text-input": m.value,
          placeholder: _.$attrs.placeholder,
          teleport: !p(ce)(_.inline),
          "alt-position": p(ce)(_.inline) ? E : void 0,
          "auto-position": _.side ? _.side : !0,
          "aria-describedby": p(b),
          disabled: p(ce)(_.disabled),
          "hide-input-icon": !o.prependIcon,
          "min-date": _.min,
          "max-date": _.max,
          class: Ie(k.value),
          onBlur: T[2] || (T[2] = () => s("blur"))
        }, At({
          "clear-icon": S(({ clear: M }) => [
            p(ce)(_.clearable) ? (w(), I(Pl, {
              key: 0,
              input: h.value,
              "onUpdate:input": T[0] || (T[0] = (O) => h.value = O),
              onClear: M
            }, null, 8, ["input", "onClear"])) : V("", !0)
          ]),
          _: 2
        }, [
          o.prependIcon ? {
            name: "input-icon",
            fn: S(() => [
              q(ht, {
                icon: o.prependIcon
              }, null, 8, ["icon"])
            ]),
            key: "0"
          } : void 0,
          o.prependIcon ? {
            name: "calendar-icon",
            fn: S(() => [
              q(ht, {
                icon: o.prependIcon
              }, null, 8, ["icon"])
            ]),
            key: "1"
          } : void 0
        ]), 1032, ["modelValue", "uid", "model-type", "locale", "format", "cancel-text", "select-text", "enable-time-picker", "text-input", "placeholder", "teleport", "alt-position", "auto-position", "aria-describedby", "disabled", "hide-input-icon", "min-date", "max-date", "class"]),
        Xr(be("input", oe(_.$attrs, {
          type: "hidden",
          "onUpdate:modelValue": T[3] || (T[3] = (M) => h.value = M),
          tabindex: "-1",
          "aria-hidden": "true"
        }), null, 16), [
          [Cl, h.value]
        ])
      ]),
      _: 1
    }, 16, ["input", "description-id", "input-id", "append-icon"]));
  }
}), k8 = /* @__PURE__ */ j({
  __name: "KYearInput",
  props: /* @__PURE__ */ it({
    locale: {},
    min: {},
    max: {},
    inline: { type: [Boolean, String] },
    side: {},
    id: {},
    label: {},
    labelSrOnly: { type: [Boolean, String] },
    required: { type: [Boolean, String] },
    disabled: { type: [Boolean, String] },
    marginless: { type: [Boolean, String] },
    emptyValue: {},
    defaultValue: {},
    description: {},
    errors: {},
    variant: {},
    tooltip: {},
    tooltipProps: {},
    prependIcon: {},
    appendIcon: {},
    clearable: { type: [Boolean, String], default: !0 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ it(["blur"], ["update:modelValue"]),
  setup(t, { emit: e }) {
    const { t: n, locale: r } = Mt(), o = t, a = e, i = A(() => ({
      enterSubmit: !0,
      tabSubmit: !1,
      // Jotta tabillä pääsee datepickeriin sisälle.
      openMenu: "open",
      selectOnFocus: !0
    })), s = ut(t, "modelValue"), l = rr(s, o.defaultValue), u = fn(o), c = A(() => `dp-input-${u.value}`), d = yn(c, o), f = ho(o), h = A(() => {
      const b = (/* @__PURE__ */ new Date()).getFullYear();
      return [o.min || b - 100, o.max || b + 100];
    }), m = A(() => ({
      [`k-year-${o.side}`]: !!o.side,
      [`k-year-${o.variant}`]: !!o.variant && o.variant !== "default",
      "k-year-error": f.value || o.variant === "error"
    })), g = () => {
      var C;
      const b = document.getElementById(c.value);
      b && ((C = b.tagName) == null ? void 0 : C.toLowerCase()) === "input" && d.value && b.setAttribute("aria-describedby", d.value);
    }, y = (b) => b ? o.side === "top" ? { transform: `translateY(-${b.getBoundingClientRect().height + 315}px)` } : { transform: "translateY(15px)" } : { transform: "none" };
    return ze(g), Ke(d, g), (b, C) => (w(), I(yr, oe(b.$props, {
      input: p(l),
      "onUpdate:input": C[4] || (C[4] = (k) => bt(l) ? l.value = k : null),
      "description-id": p(d),
      "input-id": c.value,
      "append-icon": p(l) ? void 0 : b.appendIcon,
      "prepend-icon": void 0,
      clearable: !1
    }), {
      default: S(() => [
        q(p(zc), {
          modelValue: p(l),
          "onUpdate:modelValue": C[1] || (C[1] = (k) => bt(l) ? l.value = k : null),
          "year-picker": "",
          uid: p(u),
          locale: b.locale || p(r) || "fi-FI",
          "cancel-text": p(n)("k-cancel"),
          "select-text": p(n)("k-select"),
          "auto-apply": "",
          "hide-input-icon": "",
          "text-input": i.value,
          placeholder: b.$attrs.placeholder,
          teleport: !p(ce)(b.inline),
          "alt-position": p(ce)(b.inline) ? y : void 0,
          "auto-position": b.side ? b.side : !0,
          "aria-describedby": p(d),
          disabled: p(ce)(b.disabled),
          "year-range": h.value,
          class: Ie(m.value),
          "start-date": /* @__PURE__ */ new Date(),
          onBlur: C[2] || (C[2] = () => a("blur"))
        }, At({
          "clear-icon": S(({ clear: k }) => [
            p(ce)(b.clearable) ? (w(), I(Pl, {
              key: 0,
              input: p(l),
              "onUpdate:input": C[0] || (C[0] = (v) => bt(l) ? l.value = v : null),
              onClear: k
            }, null, 8, ["input", "onClear"])) : V("", !0)
          ]),
          "year-overlay-value": S(({ value: k, text: v }) => [
            be("span", {
              class: Ie({ "dp-current-year": k === (/* @__PURE__ */ new Date()).getFullYear() })
            }, Se(v), 3)
          ]),
          _: 2
        }, [
          o.prependIcon ? {
            name: "input-icon",
            fn: S(() => [
              q(ht, {
                icon: o.prependIcon
              }, null, 8, ["icon"])
            ]),
            key: "0"
          } : void 0,
          o.prependIcon ? {
            name: "calendar-icon",
            fn: S(() => [
              q(ht, {
                icon: o.prependIcon
              }, null, 8, ["icon"])
            ]),
            key: "1"
          } : void 0
        ]), 1032, ["modelValue", "uid", "locale", "cancel-text", "select-text", "text-input", "placeholder", "teleport", "alt-position", "auto-position", "aria-describedby", "disabled", "year-range", "class", "start-date"]),
        Xr(be("input", oe(b.$attrs, {
          type: "hidden",
          "onUpdate:modelValue": C[3] || (C[3] = (k) => bt(l) ? l.value = k : null),
          tabindex: "-1",
          "aria-hidden": "true"
        }), null, 16), [
          [Cl, p(l)]
        ])
      ]),
      _: 1
    }, 16, ["input", "description-id", "input-id", "append-icon"]));
  }
}), Y$ = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "KDropdown",
  props: /* @__PURE__ */ it({
    id: {},
    text: {},
    icon: { default: "fas fa-chevron-down" },
    defaultTriggerProps: {},
    variant: { default: "primary" },
    tooltip: {},
    disabled: { type: Boolean },
    prependIcon: {},
    appendIcon: {},
    align: { default: "start" }
  }, {
    open: { type: Boolean, default: !1 },
    openModifiers: {}
  }),
  emits: ["update:open"],
  setup(t) {
    const e = t, n = ut(t, "open"), r = e.id || "k-dropdown-" + Op();
    return (o, a) => (w(), I(p(jx), {
      open: n.value,
      "onUpdate:open": a[0] || (a[0] = (i) => n.value = i)
    }, {
      default: S(() => [
        q(p(Zx), { "as-child": "" }, {
          default: S(() => [
            $(o.$slots, "trigger", {}, () => [
              o.$slots.trigger ? V("", !0) : (w(), I(zt, {
                key: 0,
                variant: o.variant,
                tooltip: o.tooltip,
                disabled: o.disabled,
                icon: o.text ? void 0 : o.icon,
                "append-icon": o.appendIcon ? o.appendIcon : o.text ? o.icon : void 0,
                "prepend-icon": o.prependIcon,
                "v-bind": o.defaultTriggerProps,
                "aria-controls": n.value ? `${p(r)}-content` : "",
                id: p(r),
                text: o.text
              }, null, 8, ["variant", "tooltip", "disabled", "icon", "append-icon", "prepend-icon", "v-bind", "aria-controls", "id", "text"]))
            ])
          ]),
          _: 3
        }),
        q(p(y0), null, {
          default: S(() => [
            q(p(zx), {
              align: o.align,
              "side-offset": 4,
              class: "k-dropdown-content",
              id: `${p(r)}-content`,
              "aria-labelledby": p(r)
            }, {
              default: S(() => [
                $(o.$slots, "default"),
                q(p(Wx), { class: "k-dropdown-arrow" })
              ]),
              _: 3
            }, 8, ["align", "id", "aria-labelledby"])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["open"]));
  }
}), q$ = { class: "k-dropdown-item-icon-wrapper" }, G$ = {
  key: 0,
  class: "k-dropdown-item-text"
}, J$ = { class: "k-dropdown-item-icon-wrapper" }, X$ = ["id", "aria-controls"], Q$ = { class: "k-dropdown-item-icon-wrapper" }, Z$ = {
  key: 0,
  class: "k-dropdown-item-text"
}, eR = { class: "k-dropdown-item-icon-wrapper" }, tR = /* @__PURE__ */ j({
  __name: "KDropdownItem",
  props: /* @__PURE__ */ it({
    id: {},
    icon: {},
    text: {},
    href: {},
    target: {},
    noTargetIcon: { type: [Boolean, String] },
    disabled: { type: [Boolean, String] }
  }, {
    open: { type: Boolean, default: !1 },
    openModifiers: {}
  }),
  emits: ["update:open"],
  setup(t) {
    const e = ut(t, "open"), r = t.href ? "a" : "span";
    return (o, a) => o.$slots.default ? (w(), I(p(Jx), {
      key: 1,
      open: e.value,
      "onUpdate:open": a[0] || (a[0] = (i) => e.value = i)
    }, {
      default: S(() => [
        q(p(Qx), { "as-child": "" }, {
          default: S(() => [
            be("span", {
              class: "k-dropdown-item",
              id: o.id,
              "aria-controls": e.value ? `${o.id}-content` : ""
            }, [
              be("div", Q$, [
                $(o.$slots, "prepend", {}, () => [
                  !o.$slots.prepend && o.icon ? (w(), I(ht, {
                    key: 0,
                    icon: o.icon
                  }, null, 8, ["icon"])) : V("", !0)
                ], !0)
              ]),
              $(o.$slots, "text", {}, () => [
                o.$slots.text ? V("", !0) : (w(), K("span", Z$, Se(o.text), 1))
              ], !0),
              be("div", eR, [
                $(o.$slots, "append", {}, () => [
                  o.$slots.append ? V("", !0) : (w(), I(ht, {
                    key: 0,
                    icon: "fas fa-chevron-right"
                  }))
                ], !0)
              ])
            ], 8, X$)
          ]),
          _: 3
        }),
        q(p(y0), null, {
          default: S(() => [
            q(p(Xx), {
              class: "k-dropdown-content",
              id: `${o.id}-content`,
              "aria-labelledby": o.id
            }, {
              default: S(() => [
                $(o.$slots, "default", {}, void 0, !0)
              ]),
              _: 3
            }, 8, ["id", "aria-labelledby"])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["open"])) : (w(), I(p(Yx), {
      key: 0,
      "as-child": "",
      disabled: p(ce)(o.disabled),
      id: o.id
    }, {
      default: S(() => [
        (w(), I(On(p(r)), {
          href: o.href,
          target: o.target,
          class: "k-dropdown-item",
          disabled: p(ce)(o.disabled)
        }, {
          default: S(() => [
            be("div", q$, [
              $(o.$slots, "prepend", {}, () => [
                !o.$slots.prepend && o.icon ? (w(), I(ht, {
                  key: 0,
                  icon: o.icon
                }, null, 8, ["icon"])) : V("", !0)
              ], !0)
            ]),
            $(o.$slots, "text", {}, () => [
              o.$slots.text ? V("", !0) : (w(), K("span", G$, Se(o.text), 1))
            ], !0),
            be("div", J$, [
              $(o.$slots, "append", {}, () => [
                o.href && o.target === "_blank" && !p(ce)(o.noTargetIcon) ? (w(), I(ht, {
                  key: 0,
                  icon: "fal fa-arrow-up-right-from-square"
                })) : V("", !0)
              ], !0)
            ])
          ]),
          _: 3
        }, 8, ["href", "target", "disabled"]))
      ]),
      _: 3
    }, 8, ["disabled", "id"]));
  }
}), Os = /* @__PURE__ */ ya(tR, [["__scopeId", "data-v-ef759b25"]]), nR = /* @__PURE__ */ j({
  __name: "KDropdownSeparator",
  setup(t) {
    return (e, n) => (w(), I(p(Gx), { class: "k-dropdown-separator" }));
  }
}), w8 = /* @__PURE__ */ ya(nR, [["__scopeId", "data-v-d74a4242"]]), rR = { key: 0 }, oR = /* @__PURE__ */ j({
  __name: "KDropdownLabel",
  props: {
    text: {}
  },
  setup(t) {
    return (e, n) => (w(), I(p(qx), { class: "k-dropdown-label" }, {
      default: S(() => [
        $(e.$slots, "default", {}, () => [
          e.$slots.default ? V("", !0) : (w(), K("span", rR, Se(e.text), 1))
        ], !0)
      ]),
      _: 3
    }));
  }
}), _8 = /* @__PURE__ */ ya(oR, [["__scopeId", "data-v-910ad385"]]), aR = { class: "k-badge-container" }, iR = {
  key: 1,
  class: "k-badge-count"
}, sR = {
  key: 2,
  class: "k-badge-text"
}, lR = {
  key: 3,
  class: "k-badge-empty"
}, C8 = /* @__PURE__ */ j({
  __name: "KBadge",
  props: {
    text: {},
    count: {},
    icon: {},
    variant: { default: "primary" },
    color: {},
    backgroundColor: {},
    size: { default: "0.75x" },
    visible: { type: [Boolean, String], default: !0 },
    shape: { default: "circle" }
  },
  setup(t) {
    const e = t, n = A(() => ({
      color: e.color,
      backgroundColor: e.backgroundColor,
      borderColor: e.backgroundColor
    })), r = A(() => {
      var o;
      return {
        "k-badge": !0,
        [`k-badge-${e.variant}`]: e.variant !== "primary",
        [`k-badge-${e.shape}`]: e.shape !== "circle",
        [`k-badge-${(o = e.size) == null ? void 0 : o.replace(".", "_")}`]: e.size !== "1x"
      };
    });
    return (o, a) => (w(), K("div", aR, [
      $(o.$slots, "default"),
      p(ce)(o.visible) ? (w(), K("div", {
        key: 0,
        class: Ie(r.value),
        style: Lt(n.value)
      }, [
        o.icon ? (w(), I(ht, {
          key: 0,
          icon: o.icon,
          class: "k-badge-icon"
        }, null, 8, ["icon"])) : V("", !0),
        o.count ? (w(), K("div", iR, Se(o.count), 1)) : V("", !0),
        o.text ? (w(), K("div", sR, Se(o.text), 1)) : V("", !0),
        !o.icon && !o.count && !o.text ? (w(), K("div", lR, " ")) : V("", !0)
      ], 6)) : V("", !0)
    ]));
  }
}), uR = ["disabled"], cR = { class: "k-listbox-item-checkbox" }, dR = { class: "k-listbox-item-text" }, Ok = /* @__PURE__ */ j({
  __name: "KListboxItem",
  props: {
    disabled: { type: [Boolean, String] },
    value: {},
    text: {},
    tooltip: {},
    selected: { type: Boolean }
  },
  emits: ["select"],
  setup(t) {
    const e = t;
    return (n, r) => {
      var o;
      return w(), K("div", {
        class: "k-listbox-item-wrapper",
        disabled: p(ce)(e.disabled)
      }, [
        q(p(r0), {
          class: "k-listbox-item",
          onSelect: r[0] || (r[0] = (a) => n.$emit("select")),
          value: ((o = n.value) == null ? void 0 : o.toString()) || p(Ai),
          disabled: p(ce)(e.disabled)
        }, {
          default: S(() => [
            be("span", cR, [
              q(p(a0), { class: "k-listbox-item-checkbox-indicator" }, {
                default: S(() => [
                  q(ht, { icon: "fas fa-check" })
                ]),
                _: 1
              })
            ]),
            be("span", dR, Se(n.text), 1)
          ]),
          _: 1
        }, 8, ["value", "disabled"])
      ], 8, uR);
    };
  }
}), fR = /* @__PURE__ */ j({
  __name: "KListboxItemGroup",
  props: {
    disabled: { type: [Boolean, String] },
    identifier: {},
    label: {},
    items: {}
  },
  emits: ["itemSelect"],
  setup(t) {
    return (e, n) => (w(), I(p(e0), { class: "k-listbox-item-group" }, {
      default: S(() => [
        q(p(sA), { class: "k-listbox-item-group-label" }, {
          default: S(() => [
            We(Se(e.label), 1)
          ]),
          _: 1
        }),
        (w(!0), K(Me, null, et(e.items, (r, o) => (w(), I(Ok, oe({ ref_for: !0 }, r, {
          class: "k-listbox-item-in-group",
          onSelect: (a) => e.$emit("itemSelect", r),
          key: o,
          disabled: e.disabled
        }), null, 16, ["onSelect", "disabled"]))), 128))
      ]),
      _: 1
    }));
  }
}), pR = {
  key: 0,
  class: "k-listbox-no-results"
}, E8 = /* @__PURE__ */ j({
  __name: "KListbox",
  props: /* @__PURE__ */ it({
    items: {},
    resize: { default: "vertical" },
    searchable: { type: Boolean, default: !1 },
    id: {},
    label: {},
    labelSrOnly: { type: [Boolean, String] },
    required: { type: [Boolean, String] },
    disabled: { type: [Boolean, String] },
    marginless: { type: [Boolean, String] },
    emptyValue: {},
    defaultValue: {},
    description: {},
    errors: {},
    variant: {},
    tooltip: {},
    tooltipProps: {},
    prependIcon: {},
    appendIcon: {},
    clearable: { type: [Boolean, String], default: !0 }
  }, {
    modelValue: { default: [] },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, n = ut(t, "modelValue"), r = fn(e), o = yn(r, e), a = Fo(e), i = A(() => ({
      "k-listbox": !0,
      [`k-listbox-resize-${e.resize}`]: !0,
      "k-listbox-content-search": e.searchable,
      ...a.value
    })), { t: s } = Mt(), l = oh("Shift"), u = F(""), c = F(e.items || []), d = F(), f = A(() => EM(c.value)), h = () => {
      const b = u.value, C = e.items || [];
      u.value ? c.value = ah(C, b) : c.value = C;
    }, m = (b) => {
      var k, v, E;
      const C = (k = f.value) == null ? void 0 : k.indexOf(b);
      if (!(C === void 0 || !f.value)) {
        if (d.value === void 0) {
          d.value = C;
          return;
        }
        if (l.value) {
          const _ = !n.value.includes(((v = b.value) == null ? void 0 : v.toString()) ?? ""), T = Math.min(C, d.value), M = Math.max(C, d.value);
          for (let O = T; O <= M; O++) {
            if (O === C) continue;
            const R = f.value[O], N = (E = R.value) == null ? void 0 : E.toString();
            if (!N) continue;
            const z = n.value.includes(N);
            _ && !z && !R.disabled ? n.value.push(N) : !_ && z && n.value.splice(n.value.indexOf(N), 1);
          }
        }
        d.value = C;
      }
    };
    Ke(u, () => {
      h();
    }), Ke(
      () => e.items,
      () => c.value = e.items ?? []
    );
    const g = A(() => ce(e.clearable) && Array.isArray(n.value) && n.value.length > 0), y = () => n.value = [];
    return (b, C) => (w(), I(yr, oe(b.$props, {
      input: n.value,
      "onUpdate:input": C[3] || (C[3] = (k) => n.value = k),
      "description-id": p(o),
      "input-id": p(r),
      onClear: y,
      clearable: g.value,
      disabled: p(ce)(e.disabled),
      class: "k-listbox-common-input"
    }), {
      default: S(() => [
        q(p(Gb), {
          disabled: p(ce)(e.disabled),
          multiple: !0,
          modelValue: n.value,
          "onUpdate:modelValue": C[2] || (C[2] = (k) => n.value = k),
          class: "k-listbox-root"
        }, {
          default: S(() => [
            e.searchable ? (w(), I(nh, {
              key: 0,
              modelValue: u.value,
              "onUpdate:modelValue": C[0] || (C[0] = (k) => u.value = k),
              id: `${p(r)}-search`,
              clearable: "",
              class: "k-listbox-search",
              "prepend-icon": "far fa-search",
              placeholder: p(s)("k-search"),
              label: p(s)("k-search"),
              autocomplete: "off",
              "label-sr-only": "",
              disabled: p(ce)(e.disabled),
              marginless: ""
            }, null, 8, ["modelValue", "id", "placeholder", "label", "disabled"])) : V("", !0),
            q(p(Xb), {
              class: Ie(i.value),
              disabled: p(ce)(e.disabled)
            }, {
              default: S(() => {
                var k;
                return [
                  (w(!0), K(Me, null, et(c.value, (v, E) => (w(), K(Me, null, [
                    "items" in v ? (w(), I(fR, oe({
                      onItemSelect: C[1] || (C[1] = (_) => m(_)),
                      key: v.identifier || E.toString(),
                      ref_for: !0
                    }, v, {
                      disabled: e.disabled
                    }), null, 16, ["disabled"])) : V("", !0),
                    "value" in v ? (w(), I(Ok, oe({
                      onSelect: () => m(v),
                      key: v.value || E.toString(),
                      ref_for: !0
                    }, v, {
                      disabled: e.disabled || v.disabled
                    }), null, 16, ["onSelect", "disabled"])) : V("", !0)
                  ], 64))), 256)),
                  e.searchable && ((k = c.value) == null ? void 0 : k.length) === 0 ? (w(), K("span", pR, Se(p(s)("k-no-results")), 1)) : V("", !0)
                ];
              }),
              _: 1
            }, 8, ["class", "disabled"])
          ]),
          _: 1
        }, 8, ["disabled", "modelValue"])
      ]),
      _: 1
    }, 16, ["input", "description-id", "input-id", "clearable", "disabled"]));
  }
}), hR = /* @__PURE__ */ j({
  __name: "KFileIcon",
  props: {
    fileName: {},
    weigth: { default: "fal" },
    icon: {},
    size: {}
  },
  setup(t) {
    const e = t, n = A(() => tI(e.fileName, e.weigth));
    return (r, o) => (w(), I(ht, oe({ class: "k-file-icon" }, e, {
      icon: e.icon || n.value
    }), {
      default: S(() => [
        $(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["icon"]));
  }
}), mR = ["title"], gR = ["name", "value"], vR = ["name", "value"], yR = ["name", "value"], bR = ["name", "value"], kR = /* @__PURE__ */ j({
  __name: "KFileInputList",
  props: {
    files: {},
    name: {},
    nameFormat: {},
    native: { type: Boolean },
    target: {}
  },
  emits: ["remove"],
  setup(t, { emit: e }) {
    const { t: n } = Mt(), r = t, o = e, a = (i, s) => {
      if (r.nameFormat && r.name)
        return r.nameFormat.replace("{name}", r.name || "").replace("{index}", i.toString()).replace("{property}", s);
    };
    return (i, s) => i.files && i.files.length ? (w(), K("ul", {
      key: 0,
      class: "k-file-list",
      onDragover: s[4] || (s[4] = Xe(() => {
      }, ["prevent"])),
      onDrop: s[5] || (s[5] = Xe(() => {
      }, ["prevent"]))
    }, [
      (w(!0), K(Me, null, et(i.files, (l, u) => (w(), K("li", {
        class: "k-file",
        key: u,
        onClick: s[1] || (s[1] = Xe(() => {
        }, ["stop"])),
        onDragover: s[2] || (s[2] = Xe(() => {
        }, ["prevent"])),
        onDrop: s[3] || (s[3] = Xe(() => {
        }, ["prevent"]))
      }, [
        q(hR, {
          "file-name": l.name
        }, null, 8, ["file-name"]),
        l.href ? (w(), I($p, {
          key: 0,
          class: "k-file-name",
          title: l.name,
          text: l.name,
          href: l.href,
          target: i.target,
          onClick: s[0] || (s[0] = Xe(() => {
          }, ["stop"]))
        }, null, 8, ["title", "text", "href", "target"])) : (w(), K("span", {
          key: 1,
          class: "k-file-name",
          title: l.name
        }, Se(l.name), 9, mR)),
        !i.native || l.id ? (w(), I(zt, {
          key: 2,
          onClick: Xe(() => o("remove", u), ["stop"]),
          variant: "text",
          icon: "fal fa-times",
          "aria-label": p(n)("k-remove-file")
        }, null, 8, ["onClick", "aria-label"])) : V("", !0),
        l.uploadProgress !== void 0 && l.uploadProgress >= 0 && l.uploadProgress <= 100 ? (w(), K("div", {
          key: 3,
          class: "k-file-upload-progress",
          style: Lt({ width: `${l.uploadProgress}%` })
        }, null, 4)) : V("", !0),
        i.name ? (w(), K(Me, { key: 4 }, [
          be("input", {
            type: "hidden",
            name: a(u, "Id"),
            value: l.id
          }, null, 8, gR),
          be("input", {
            type: "hidden",
            name: a(u, "Name"),
            value: l.name
          }, null, 8, vR),
          be("input", {
            type: "hidden",
            name: a(u, "Href"),
            value: l.href
          }, null, 8, yR),
          be("input", {
            type: "hidden",
            name: a(u, "UploadProgress"),
            value: l.uploadProgress
          }, null, 8, bR)
        ], 64)) : V("", !0)
      ], 32))), 128))
    ], 32)) : V("", !0);
  }
}), wR = ["aria-label", "disabled"], _R = ["disabled", "id", "aria-describedby", "name", "multiple"], CR = { class: "k-file-input-guide" }, O8 = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "KFileInput",
  props: /* @__PURE__ */ it({
    multiple: { type: [Boolean, String] },
    native: { type: [Boolean, String] },
    name: {},
    nativeInputNameFormat: { default: "{name}.NewFiles" },
    existingInputNameFormat: { default: "{name}.ExistingFiles[{index}].{property}" },
    size: { default: "sm" },
    target: {},
    id: {},
    label: {},
    labelSrOnly: { type: [Boolean, String] },
    required: { type: [Boolean, String] },
    disabled: { type: [Boolean, String] },
    marginless: { type: [Boolean, String] },
    emptyValue: {},
    defaultValue: {},
    description: {},
    errors: {},
    variant: {},
    tooltip: {},
    tooltipProps: {},
    prependIcon: {},
    appendIcon: {},
    clearable: { type: [Boolean, String] }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ it(["file-added", "file-removed"], ["update:modelValue"]),
  setup(t, { emit: e }) {
    const n = t, r = e, o = ut(t, "modelValue"), a = rr(o, n.defaultValue), { t: i } = Mt(), s = F(), l = F(), u = fn(n), c = F(!1), d = yn(u, n), f = Fo(n), h = A(() => ({
      ...f.value,
      "k-file-input": !0,
      [`k-file-input-${n.size}`]: n.size !== "sm",
      "k-file-input-dragging": c.value
    })), m = A(() => ce(n.multiple) ? i("k-select-files") : i("k-select-file")), g = (E) => {
      var M;
      const _ = E.filter((O) => !!O).map((O) => ({ file: O, name: O.name })), T = [];
      _.length && (ce(n.native) && (T.push(...a.value || []), a.value = (M = a.value) == null ? void 0 : M.filter((O) => !!O.id)), a.value && ce(n.multiple) ? a.value = [...a.value, ..._] : (T.push(...a.value || []), a.value = _), T.forEach((O) => {
        r("file-removed", O);
      }), a.value.slice(-_.length).forEach((O) => {
        r("file-added", O);
      }));
    }, y = (E) => {
      const _ = E.target;
      _ != null && _.files && g([..._.files]), _ && !ce(n.native) && (_.files = null, _.value = ""), c.value = !1;
    }, b = () => {
      c.value = !0;
    }, C = () => {
      c.value = !1;
    }, k = (E) => {
      var _;
      (E.code.toLowerCase() === "enter" || E.code.toLowerCase() === "space") && ((_ = l == null ? void 0 : l.value) == null || _.click(), E.preventDefault());
    }, v = (E) => {
      var _;
      a.value && a.value.length > E && r("file-removed", a.value[E]), a.value = (_ = a.value) == null ? void 0 : _.filter((T, M) => M !== E);
    };
    return (E, _) => (w(), I(yr, oe(E.$props, {
      input: p(a),
      "onUpdate:input": _[2] || (_[2] = (T) => bt(a) ? a.value = T : null),
      "description-id": p(d),
      "prepend-icon": void 0,
      "input-id": p(u)
    }), {
      default: S(() => [
        be("button", {
          ref_key: "button",
          ref: s,
          class: Ie(h.value),
          type: "button",
          "aria-label": E.label,
          onDrop: _[1] || (_[1] = //@ts-ignore
          (...T) => E.onDrop && E.onDrop(...T)),
          onDrag: b,
          onDragstart: b,
          onDragenter: b,
          onDragover: b,
          onDragleave: Xe(C, ["prevent", "stop"]),
          onDragend: C,
          disabled: p(ce)(E.disabled),
          onKeydown: k
        }, [
          be("input", oe({
            ref_key: "input",
            ref: l,
            type: "file"
          }, E.$attrs, {
            disabled: p(ce)(E.disabled),
            id: p(u),
            "aria-describedby": p(d),
            name: E.name && E.nativeInputNameFormat ? E.nativeInputNameFormat.replace("{name}", E.name) : E.name,
            autocomplete: "off",
            class: "k-native-file-input",
            multiple: p(ce)(E.multiple),
            "aria-hidden": !0,
            tabindex: -1,
            onChange: y,
            onClick: _[0] || (_[0] = () => {
              var T;
              return (T = s.value) == null ? void 0 : T.focus();
            }),
            title: ""
          }), null, 16, _R),
          be("span", CR, [
            q(ht, {
              icon: E.prependIcon || "fal fa-upload",
              class: "k-file-input-icon"
            }, null, 8, ["icon"]),
            We(" " + Se(m.value), 1)
          ]),
          q(kR, {
            files: p(a),
            name: E.name,
            "name-format": E.existingInputNameFormat,
            native: p(ce)(E.native),
            onRemove: v,
            target: E.target
          }, null, 8, ["files", "name", "name-format", "native", "target"])
        ], 42, wR)
      ]),
      _: 1
    }, 16, ["input", "description-id", "input-id"]));
  }
}), ER = /* @__PURE__ */ j({
  __name: "KTextLimiter",
  props: {
    text: {},
    rows: {}
  },
  setup(t) {
    const e = t, n = F(!1), r = F(null), o = F(!1), a = A(
      () => e.rows && !n.value ? {
        "max-height": `${e.rows * 1.4}em`,
        "-webkit-line-clamp": e.rows
      } : {}
    ), i = () => {
      if (!r.value || !e.rows) return o.value = !1;
      o.value = r.value.scrollHeight > r.value.clientHeight;
    };
    return Ke(
      () => [e.text, e.rows],
      () => nt(i),
      { immediate: !0 }
    ), ze(() => {
      window.addEventListener("resize", i);
    }), En(() => {
      window.removeEventListener("resize", i);
    }), (s, l) => (w(), K(Me, null, [
      be("div", {
        class: "k-text-limiter-content",
        ref_key: "contentRef",
        ref: r,
        style: Lt(a.value)
      }, [
        $(s.$slots, "default", {}, () => [
          We(Se(s.text), 1)
        ])
      ], 4),
      o.value ? (w(), I(zt, {
        key: 0,
        variant: "text",
        class: "k-text-limiter-show-more",
        type: "button",
        onClick: l[0] || (l[0] = () => n.value = !n.value)
      }, {
        default: S(() => [
          We(Se(n.value ? s.$t("k-show-less") : s.$t("k-show-more")), 1)
        ]),
        _: 1
      })) : V("", !0)
    ], 64));
  }
}), OR = ["id", "aria-labelledby", "aria-describedby"], TR = {
  key: 1,
  class: "k-readonly-text-wrapper"
}, SR = {
  key: 0,
  class: "k-readonly-copy-btn"
}, T8 = /* @__PURE__ */ j({
  inheritAttrs: !1,
  __name: "KReadOnly",
  props: /* @__PURE__ */ it({
    text: {},
    rows: {},
    showCopyButton: { type: Boolean },
    id: {},
    label: {},
    labelSrOnly: { type: [Boolean, String] },
    required: { type: [Boolean, String] },
    disabled: { type: [Boolean, String] },
    marginless: { type: [Boolean, String] },
    emptyValue: {},
    defaultValue: {},
    description: {},
    errors: {},
    variant: {},
    tooltip: {},
    tooltipProps: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, n = ut(t, "modelValue"), r = rr(n, e.defaultValue), o = fn(e), a = A(() => o.value + "-label"), i = yn(o, e), s = ho(e), l = A(() => ({
      "k-readonly": !0,
      [`k-readonly-${e.variant}`]: !!e.variant && e.variant !== "default",
      "k-readonly-error": s.value || e.variant === "error",
      "k-readonly-disabled": ce(e.disabled)
    })), { copy: u, isSupported: c } = KM(), d = F(!1), f = () => {
      const m = r.value ?? e.text ?? "";
      c.value && m && (u(m), d.value = !0);
    }, h = () => {
      setTimeout(() => {
        d.value = !1;
      }, 500);
    };
    return (m, g) => (w(), I(li, { marginless: m.marginless }, {
      default: S(() => [
        q(va, oe({ as: "div" }, e, { id: a.value }), null, 16, ["id"]),
        be("div", oe(m.$attrs, {
          class: l.value,
          id: p(o),
          "aria-labelledby": a.value,
          "aria-describedby": p(i)
        }), [
          $(m.$slots, "default", {}, () => [
            m.rows ? (w(), I(ER, {
              key: 0,
              rows: m.rows,
              text: m.text
            }, null, 8, ["rows", "text"])) : (w(), K("span", TR, [
              We(Se(p(r) || m.text) + " ", 1),
              m.showCopyButton && (p(r) || m.text) ? (w(), K("span", SR, [
                q(Hn, {
                  open: d.value,
                  text: m.$t(d.value ? "k-copied" : "k-copy")
                }, {
                  trigger: S(() => [
                    q(zt, {
                      type: "button",
                      variant: "text",
                      icon: d.value ? "fas fa-check" : "far fa-copy",
                      "aria-label": m.$t(d.value ? "k-copied" : "k-copy"),
                      onClick: Xe(f, ["stop"]),
                      disabled: !p(c) || !(p(r) || m.text),
                      onMouseleave: h,
                      onFocusout: h
                    }, null, 8, ["icon", "aria-label", "disabled"])
                  ]),
                  _: 1
                }, 8, ["open", "text"])
              ])) : V("", !0)
            ]))
          ])
        ], 16, OR),
        q(si, oe(e, { "description-id": p(i) }), null, 16, ["description-id"])
      ]),
      _: 3
    }, 8, ["marginless"]));
  }
}), xR = { class: "k-range" }, AR = { class: "k-range-start" }, MR = { class: "k-range-separator" }, IR = { class: "k-range-end" }, S8 = /* @__PURE__ */ j({
  __name: "KRange",
  props: {
    id: {},
    label: {},
    labelSrOnly: { type: [Boolean, String] },
    required: { type: [Boolean, String] },
    disabled: { type: [Boolean, String] },
    marginless: { type: [Boolean, String] },
    emptyValue: {},
    defaultValue: {},
    description: {},
    errors: {},
    variant: {},
    tooltip: {},
    tooltipProps: {}
  },
  setup(t) {
    const e = t, n = fn(e), r = yn(n, e);
    return (o, a) => (w(), I(li, {
      as: "fieldset",
      marginless: o.marginless,
      "aria-describedby": p(r)
    }, {
      default: S(() => [
        o.label ? (w(), I(va, oe({ key: 0 }, e, {
          "input-id": p(n),
          as: "legend"
        }), null, 16, ["input-id"])) : V("", !0),
        be("div", xR, [
          be("div", AR, [
            $(o.$slots, "start", Ye(ot({ ...o.$props, id: p(n), descriptionId: p(r) })))
          ]),
          be("div", MR, [
            q(ht, { icon: "fal fa-minus" })
          ]),
          be("div", IR, [
            $(o.$slots, "end", Ye(ot({ ...o.$props, id: p(n), descriptionId: p(r) })))
          ])
        ]),
        q(si, oe(e, { "description-id": p(r) }), null, 16, ["description-id"])
      ]),
      _: 3
    }, 8, ["marginless", "aria-describedby"]));
  }
}), DR = { class: "k-accordion-content-container" }, Ug = /* @__PURE__ */ j({
  __name: "KAccordionItem",
  props: {
    title: {},
    id: {}
  },
  setup(t) {
    const n = t.id || Op();
    return (r, o) => (w(), I(p(RT), {
      class: "k-accordion-item",
      id: p(n),
      value: p(n)
    }, {
      default: S(() => [
        q(p(UT), { class: "k-accordion-header" }, {
          default: S(() => [
            q(p(KT), { class: "k-accordion-trigger" }, {
              default: S(() => [
                be("span", null, Se(r.title), 1),
                q(ht, {
                  size: "0.9x",
                  class: "k-accordion-icon",
                  icon: "fas fa-chevron-down"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        q(p(HT), { class: "k-accordion-content" }, {
          default: S(() => [
            be("div", DR, [
              $(r.$slots, "default")
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["id", "value"]));
  }
}), x8 = /* @__PURE__ */ j({
  __name: "KAccordion",
  props: /* @__PURE__ */ it({
    id: {},
    title: {},
    collapsible: { type: Boolean, default: !0 },
    variant: { default: "default" },
    density: { default: "compact" },
    openable: {}
  }, {
    modelValue: { type: [String, Array, Boolean], default: void 0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = ut(t, "modelValue"), n = t, r = n.id || Op(), o = `${r}-item`, a = A({
      get: () => typeof e.value == "boolean" ? e.value ? o : "" : e.value ? e.value : n.openable === "single" ? "" : [],
      set: (l) => {
        if (typeof e.value == "string" && !l) {
          e.value = "";
          return;
        }
        if (typeof e.value == "boolean") {
          e.value = !!l;
          return;
        }
        e.value = l;
      }
    }), i = A(() => {
      var c;
      const l = uo(), u = (c = l.default) == null ? void 0 : c.call(l);
      return u ? u.some((d) => d.type === Ug) : !1;
    }), s = A(() => ({
      "k-accordion": !0,
      [`k-accordion-${n.variant}`]: n.variant !== "default",
      [`k-accordion-${n.density}`]: n.density !== "compact"
    }));
    return (l, u) => (w(), I(p(IT), {
      id: p(r),
      class: Ie(s.value),
      collapsible: l.collapsible,
      modelValue: a.value,
      "onUpdate:modelValue": u[0] || (u[0] = (c) => a.value = c)
    }, {
      default: S(() => [
        i.value ? $(l.$slots, "default", { key: 0 }) : (w(), I(Ug, {
          key: 1,
          title: l.title,
          id: o
        }, {
          default: S(() => [
            $(l.$slots, "default")
          ]),
          _: 3
        }, 8, ["title"]))
      ]),
      _: 3
    }, 8, ["id", "class", "collapsible", "modelValue"]));
  }
});
function pn(t) {
  this.content = t;
}
pn.prototype = {
  constructor: pn,
  find: function(t) {
    for (var e = 0; e < this.content.length; e += 2)
      if (this.content[e] === t) return e;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(t) {
    var e = this.find(t);
    return e == -1 ? void 0 : this.content[e + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(t, e, n) {
    var r = n && n != t ? this.remove(n) : this, o = r.find(t), a = r.content.slice();
    return o == -1 ? a.push(n || t, e) : (a[o + 1] = e, n && (a[o] = n)), new pn(a);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(t) {
    var e = this.find(t);
    if (e == -1) return this;
    var n = this.content.slice();
    return n.splice(e, 2), new pn(n);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(t, e) {
    return new pn([t, e].concat(this.remove(t).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(t, e) {
    var n = this.remove(t).content.slice();
    return n.push(t, e), new pn(n);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(t, e, n) {
    var r = this.remove(e), o = r.content.slice(), a = r.find(t);
    return o.splice(a == -1 ? o.length : a, 0, e, n), new pn(o);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(t) {
    for (var e = 0; e < this.content.length; e += 2)
      t(this.content[e], this.content[e + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(t) {
    return t = pn.from(t), t.size ? new pn(t.content.concat(this.subtract(t).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(t) {
    return t = pn.from(t), t.size ? new pn(this.subtract(t).content.concat(t.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(t) {
    var e = this;
    t = pn.from(t);
    for (var n = 0; n < t.content.length; n += 2)
      e = e.remove(t.content[n]);
    return e;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var t = {};
    return this.forEach(function(e, n) {
      t[e] = n;
    }), t;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
pn.from = function(t) {
  if (t instanceof pn) return t;
  var e = [];
  if (t) for (var n in t) e.push(n, t[n]);
  return new pn(e);
};
function Tk(t, e, n) {
  for (let r = 0; ; r++) {
    if (r == t.childCount || r == e.childCount)
      return t.childCount == e.childCount ? null : n;
    let o = t.child(r), a = e.child(r);
    if (o == a) {
      n += o.nodeSize;
      continue;
    }
    if (!o.sameMarkup(a))
      return n;
    if (o.isText && o.text != a.text) {
      for (let i = 0; o.text[i] == a.text[i]; i++)
        n++;
      return n;
    }
    if (o.content.size || a.content.size) {
      let i = Tk(o.content, a.content, n + 1);
      if (i != null)
        return i;
    }
    n += o.nodeSize;
  }
}
function Sk(t, e, n, r) {
  for (let o = t.childCount, a = e.childCount; ; ) {
    if (o == 0 || a == 0)
      return o == a ? null : { a: n, b: r };
    let i = t.child(--o), s = e.child(--a), l = i.nodeSize;
    if (i == s) {
      n -= l, r -= l;
      continue;
    }
    if (!i.sameMarkup(s))
      return { a: n, b: r };
    if (i.isText && i.text != s.text) {
      let u = 0, c = Math.min(i.text.length, s.text.length);
      for (; u < c && i.text[i.text.length - u - 1] == s.text[s.text.length - u - 1]; )
        u++, n--, r--;
      return { a: n, b: r };
    }
    if (i.content.size || s.content.size) {
      let u = Sk(i.content, s.content, n - 1, r - 1);
      if (u)
        return u;
    }
    n -= l, r -= l;
  }
}
class _e {
  /**
  @internal
  */
  constructor(e, n) {
    if (this.content = e, this.size = n || 0, n == null)
      for (let r = 0; r < e.length; r++)
        this.size += e[r].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(e, n, r, o = 0, a) {
    for (let i = 0, s = 0; s < n; i++) {
      let l = this.content[i], u = s + l.nodeSize;
      if (u > e && r(l, o + s, a || null, i) !== !1 && l.content.size) {
        let c = s + 1;
        l.nodesBetween(Math.max(0, e - c), Math.min(l.content.size, n - c), r, o + c);
      }
      s = u;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(e) {
    this.nodesBetween(0, this.size, e);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(e, n, r, o) {
    let a = "", i = !0;
    return this.nodesBetween(e, n, (s, l) => {
      let u = s.isText ? s.text.slice(Math.max(e, l) - l, n - l) : s.isLeaf ? o ? typeof o == "function" ? o(s) : o : s.type.spec.leafText ? s.type.spec.leafText(s) : "" : "";
      s.isBlock && (s.isLeaf && u || s.isTextblock) && r && (i ? i = !1 : a += r), a += u;
    }, 0), a;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(e) {
    if (!e.size)
      return this;
    if (!this.size)
      return e;
    let n = this.lastChild, r = e.firstChild, o = this.content.slice(), a = 0;
    for (n.isText && n.sameMarkup(r) && (o[o.length - 1] = n.withText(n.text + r.text), a = 1); a < e.content.length; a++)
      o.push(e.content[a]);
    return new _e(o, this.size + e.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(e, n = this.size) {
    if (e == 0 && n == this.size)
      return this;
    let r = [], o = 0;
    if (n > e)
      for (let a = 0, i = 0; i < n; a++) {
        let s = this.content[a], l = i + s.nodeSize;
        l > e && ((i < e || l > n) && (s.isText ? s = s.cut(Math.max(0, e - i), Math.min(s.text.length, n - i)) : s = s.cut(Math.max(0, e - i - 1), Math.min(s.content.size, n - i - 1))), r.push(s), o += s.nodeSize), i = l;
      }
    return new _e(r, o);
  }
  /**
  @internal
  */
  cutByIndex(e, n) {
    return e == n ? _e.empty : e == 0 && n == this.content.length ? this : new _e(this.content.slice(e, n));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(e, n) {
    let r = this.content[e];
    if (r == n)
      return this;
    let o = this.content.slice(), a = this.size + n.nodeSize - r.nodeSize;
    return o[e] = n, new _e(o, a);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(e) {
    return new _e([e].concat(this.content), this.size + e.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(e) {
    return new _e(this.content.concat(e), this.size + e.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(e) {
    if (this.content.length != e.content.length)
      return !1;
    for (let n = 0; n < this.content.length; n++)
      if (!this.content[n].eq(e.content[n]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(e) {
    let n = this.content[e];
    if (!n)
      throw new RangeError("Index " + e + " out of range for " + this);
    return n;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content[e] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    for (let n = 0, r = 0; n < this.content.length; n++) {
      let o = this.content[n];
      e(o, r, n), r += o.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(e, n = 0) {
    return Tk(this, e, n);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(e, n = this.size, r = e.size) {
    return Sk(this, e, n, r);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(e, n = -1) {
    if (e == 0)
      return Xl(0, e);
    if (e == this.size)
      return Xl(this.content.length, e);
    if (e > this.size || e < 0)
      throw new RangeError(`Position ${e} outside of fragment (${this})`);
    for (let r = 0, o = 0; ; r++) {
      let a = this.child(r), i = o + a.nodeSize;
      if (i >= e)
        return i == e || n > 0 ? Xl(r + 1, i) : Xl(r, o);
      o = i;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((e) => e.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(e, n) {
    if (!n)
      return _e.empty;
    if (!Array.isArray(n))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new _e(n.map(e.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(e) {
    if (!e.length)
      return _e.empty;
    let n, r = 0;
    for (let o = 0; o < e.length; o++) {
      let a = e[o];
      r += a.nodeSize, o && a.isText && e[o - 1].sameMarkup(a) ? (n || (n = e.slice(0, o)), n[n.length - 1] = a.withText(n[n.length - 1].text + a.text)) : n && n.push(a);
    }
    return new _e(n || e, r);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(e) {
    if (!e)
      return _e.empty;
    if (e instanceof _e)
      return e;
    if (Array.isArray(e))
      return this.fromArray(e);
    if (e.attrs)
      return new _e([e], e.nodeSize);
    throw new RangeError("Can not convert " + e + " to a Fragment" + (e.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
_e.empty = new _e([], 0);
const Nd = { index: 0, offset: 0 };
function Xl(t, e) {
  return Nd.index = t, Nd.offset = e, Nd;
}
function Au(t, e) {
  if (t === e)
    return !0;
  if (!(t && typeof t == "object") || !(e && typeof e == "object"))
    return !1;
  let n = Array.isArray(t);
  if (Array.isArray(e) != n)
    return !1;
  if (n) {
    if (t.length != e.length)
      return !1;
    for (let r = 0; r < t.length; r++)
      if (!Au(t[r], e[r]))
        return !1;
  } else {
    for (let r in t)
      if (!(r in e) || !Au(t[r], e[r]))
        return !1;
    for (let r in e)
      if (!(r in t))
        return !1;
  }
  return !0;
}
let St = class Wf {
  /**
  @internal
  */
  constructor(e, n) {
    this.type = e, this.attrs = n;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(e) {
    let n, r = !1;
    for (let o = 0; o < e.length; o++) {
      let a = e[o];
      if (this.eq(a))
        return e;
      if (this.type.excludes(a.type))
        n || (n = e.slice(0, o));
      else {
        if (a.type.excludes(this.type))
          return e;
        !r && a.type.rank > this.type.rank && (n || (n = e.slice(0, o)), n.push(this), r = !0), n && n.push(a);
      }
    }
    return n || (n = e.slice()), r || n.push(this), n;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(e) {
    for (let n = 0; n < e.length; n++)
      if (this.eq(e[n]))
        return e.slice(0, n).concat(e.slice(n + 1));
    return e;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(e) {
    for (let n = 0; n < e.length; n++)
      if (this.eq(e[n]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(e) {
    return this == e || this.type == e.type && Au(this.attrs, e.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let n in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return e;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(e, n) {
    if (!n)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let r = e.marks[n.type];
    if (!r)
      throw new RangeError(`There is no mark type ${n.type} in this schema`);
    let o = r.create(n.attrs);
    return r.checkAttrs(o.attrs), o;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(e, n) {
    if (e == n)
      return !0;
    if (e.length != n.length)
      return !1;
    for (let r = 0; r < e.length; r++)
      if (!e[r].eq(n[r]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(e) {
    if (!e || Array.isArray(e) && e.length == 0)
      return Wf.none;
    if (e instanceof Wf)
      return [e];
    let n = e.slice();
    return n.sort((r, o) => r.type.rank - o.type.rank), n;
  }
};
St.none = [];
class Mu extends Error {
}
class Pe {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(e, n, r) {
    this.content = e, this.openStart = n, this.openEnd = r;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(e, n) {
    let r = Ak(this.content, e + this.openStart, n);
    return r && new Pe(r, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(e, n) {
    return new Pe(xk(this.content, e + this.openStart, n + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(e) {
    return this.content.eq(e.content) && this.openStart == e.openStart && this.openEnd == e.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let e = { content: this.content.toJSON() };
    return this.openStart > 0 && (e.openStart = this.openStart), this.openEnd > 0 && (e.openEnd = this.openEnd), e;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(e, n) {
    if (!n)
      return Pe.empty;
    let r = n.openStart || 0, o = n.openEnd || 0;
    if (typeof r != "number" || typeof o != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new Pe(_e.fromJSON(e, n.content), r, o);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(e, n = !0) {
    let r = 0, o = 0;
    for (let a = e.firstChild; a && !a.isLeaf && (n || !a.type.spec.isolating); a = a.firstChild)
      r++;
    for (let a = e.lastChild; a && !a.isLeaf && (n || !a.type.spec.isolating); a = a.lastChild)
      o++;
    return new Pe(e, r, o);
  }
}
Pe.empty = new Pe(_e.empty, 0, 0);
function xk(t, e, n) {
  let { index: r, offset: o } = t.findIndex(e), a = t.maybeChild(r), { index: i, offset: s } = t.findIndex(n);
  if (o == e || a.isText) {
    if (s != n && !t.child(i).isText)
      throw new RangeError("Removing non-flat range");
    return t.cut(0, e).append(t.cut(n));
  }
  if (r != i)
    throw new RangeError("Removing non-flat range");
  return t.replaceChild(r, a.copy(xk(a.content, e - o - 1, n - o - 1)));
}
function Ak(t, e, n, r) {
  let { index: o, offset: a } = t.findIndex(e), i = t.maybeChild(o);
  if (a == e || i.isText)
    return t.cut(0, e).append(n).append(t.cut(e));
  let s = Ak(i.content, e - a - 1, n);
  return s && t.replaceChild(o, i.copy(s));
}
function PR(t, e, n) {
  if (n.openStart > t.depth)
    throw new Mu("Inserted content deeper than insertion position");
  if (t.depth - n.openStart != e.depth - n.openEnd)
    throw new Mu("Inconsistent open depths");
  return Mk(t, e, n, 0);
}
function Mk(t, e, n, r) {
  let o = t.index(r), a = t.node(r);
  if (o == e.index(r) && r < t.depth - n.openStart) {
    let i = Mk(t, e, n, r + 1);
    return a.copy(a.content.replaceChild(o, i));
  } else if (n.content.size)
    if (!n.openStart && !n.openEnd && t.depth == r && e.depth == r) {
      let i = t.parent, s = i.content;
      return Ha(i, s.cut(0, t.parentOffset).append(n.content).append(s.cut(e.parentOffset)));
    } else {
      let { start: i, end: s } = NR(n, t);
      return Ha(a, Dk(t, i, s, e, r));
    }
  else return Ha(a, Iu(t, e, r));
}
function Ik(t, e) {
  if (!e.type.compatibleContent(t.type))
    throw new Mu("Cannot join " + e.type.name + " onto " + t.type.name);
}
function Kf(t, e, n) {
  let r = t.node(n);
  return Ik(r, e.node(n)), r;
}
function Va(t, e) {
  let n = e.length - 1;
  n >= 0 && t.isText && t.sameMarkup(e[n]) ? e[n] = t.withText(e[n].text + t.text) : e.push(t);
}
function Ls(t, e, n, r) {
  let o = (e || t).node(n), a = 0, i = e ? e.index(n) : o.childCount;
  t && (a = t.index(n), t.depth > n ? a++ : t.textOffset && (Va(t.nodeAfter, r), a++));
  for (let s = a; s < i; s++)
    Va(o.child(s), r);
  e && e.depth == n && e.textOffset && Va(e.nodeBefore, r);
}
function Ha(t, e) {
  return t.type.checkContent(e), t.copy(e);
}
function Dk(t, e, n, r, o) {
  let a = t.depth > o && Kf(t, e, o + 1), i = r.depth > o && Kf(n, r, o + 1), s = [];
  return Ls(null, t, o, s), a && i && e.index(o) == n.index(o) ? (Ik(a, i), Va(Ha(a, Dk(t, e, n, r, o + 1)), s)) : (a && Va(Ha(a, Iu(t, e, o + 1)), s), Ls(e, n, o, s), i && Va(Ha(i, Iu(n, r, o + 1)), s)), Ls(r, null, o, s), new _e(s);
}
function Iu(t, e, n) {
  let r = [];
  if (Ls(null, t, n, r), t.depth > n) {
    let o = Kf(t, e, n + 1);
    Va(Ha(o, Iu(t, e, n + 1)), r);
  }
  return Ls(e, null, n, r), new _e(r);
}
function NR(t, e) {
  let n = e.depth - t.openStart, o = e.node(n).copy(t.content);
  for (let a = n - 1; a >= 0; a--)
    o = e.node(a).copy(_e.from(o));
  return {
    start: o.resolveNoCache(t.openStart + n),
    end: o.resolveNoCache(o.content.size - t.openEnd - n)
  };
}
class sl {
  /**
  @internal
  */
  constructor(e, n, r) {
    this.pos = e, this.path = n, this.parentOffset = r, this.depth = n.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(e) {
    return e == null ? this.depth : e < 0 ? this.depth + e : e;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(e) {
    return this.path[this.resolveDepth(e) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(e) {
    return this.path[this.resolveDepth(e) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(e) {
    return e = this.resolveDepth(e), this.index(e) + (e == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(e) {
    return e = this.resolveDepth(e), e == 0 ? 0 : this.path[e * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(e) {
    return e = this.resolveDepth(e), this.start(e) + this.node(e).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position before the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position after the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1] + this.path[e * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let e = this.parent, n = this.index(this.depth);
    if (n == e.childCount)
      return null;
    let r = this.pos - this.path[this.path.length - 1], o = e.child(n);
    return r ? e.child(n).cut(r) : o;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let e = this.index(this.depth), n = this.pos - this.path[this.path.length - 1];
    return n ? this.parent.child(e).cut(0, n) : e == 0 ? null : this.parent.child(e - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(e, n) {
    n = this.resolveDepth(n);
    let r = this.path[n * 3], o = n == 0 ? 0 : this.path[n * 3 - 1] + 1;
    for (let a = 0; a < e; a++)
      o += r.child(a).nodeSize;
    return o;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let e = this.parent, n = this.index();
    if (e.content.size == 0)
      return St.none;
    if (this.textOffset)
      return e.child(n).marks;
    let r = e.maybeChild(n - 1), o = e.maybeChild(n);
    if (!r) {
      let s = r;
      r = o, o = s;
    }
    let a = r.marks;
    for (var i = 0; i < a.length; i++)
      a[i].type.spec.inclusive === !1 && (!o || !a[i].isInSet(o.marks)) && (a = a[i--].removeFromSet(a));
    return a;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(e) {
    let n = this.parent.maybeChild(this.index());
    if (!n || !n.isInline)
      return null;
    let r = n.marks, o = e.parent.maybeChild(e.index());
    for (var a = 0; a < r.length; a++)
      r[a].type.spec.inclusive === !1 && (!o || !r[a].isInSet(o.marks)) && (r = r[a--].removeFromSet(r));
    return r;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(e) {
    for (let n = this.depth; n > 0; n--)
      if (this.start(n) <= e && this.end(n) >= e)
        return n;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(e = this, n) {
    if (e.pos < this.pos)
      return e.blockRange(this);
    for (let r = this.depth - (this.parent.inlineContent || this.pos == e.pos ? 1 : 0); r >= 0; r--)
      if (e.pos <= this.end(r) && (!n || n(this.node(r))))
        return new Du(this, e, r);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(e) {
    return this.pos - this.parentOffset == e.pos - e.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(e) {
    return e.pos > this.pos ? e : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(e) {
    return e.pos < this.pos ? e : this;
  }
  /**
  @internal
  */
  toString() {
    let e = "";
    for (let n = 1; n <= this.depth; n++)
      e += (e ? "/" : "") + this.node(n).type.name + "_" + this.index(n - 1);
    return e + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(e, n) {
    if (!(n >= 0 && n <= e.content.size))
      throw new RangeError("Position " + n + " out of range");
    let r = [], o = 0, a = n;
    for (let i = e; ; ) {
      let { index: s, offset: l } = i.content.findIndex(a), u = a - l;
      if (r.push(i, s, o + l), !u || (i = i.child(s), i.isText))
        break;
      a = u - 1, o += l + 1;
    }
    return new sl(n, r, a);
  }
  /**
  @internal
  */
  static resolveCached(e, n) {
    let r = Wg.get(e);
    if (r)
      for (let a = 0; a < r.elts.length; a++) {
        let i = r.elts[a];
        if (i.pos == n)
          return i;
      }
    else
      Wg.set(e, r = new $R());
    let o = r.elts[r.i] = sl.resolve(e, n);
    return r.i = (r.i + 1) % RR, o;
  }
}
class $R {
  constructor() {
    this.elts = [], this.i = 0;
  }
}
const RR = 12, Wg = /* @__PURE__ */ new WeakMap();
class Du {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(e, n, r) {
    this.$from = e, this.$to = n, this.depth = r;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const LR = /* @__PURE__ */ Object.create(null);
let ra = class jf {
  /**
  @internal
  */
  constructor(e, n, r, o = St.none) {
    this.type = e, this.attrs = n, this.marks = o, this.content = r || _e.empty;
  }
  /**
  The array of this node's child nodes.
  */
  get children() {
    return this.content.content;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(e) {
    return this.content.child(e);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content.maybeChild(e);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    this.content.forEach(e);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(e, n, r, o = 0) {
    this.content.nodesBetween(e, n, r, o, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(e) {
    this.nodesBetween(0, this.content.size, e);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
  */
  textBetween(e, n, r, o) {
    return this.content.textBetween(e, n, r, o);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(e) {
    return this == e || this.sameMarkup(e) && this.content.eq(e.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(e) {
    return this.hasMarkup(e.type, e.attrs, e.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(e, n, r) {
    return this.type == e && Au(this.attrs, n || e.defaultAttrs || LR) && St.sameSet(this.marks, r || St.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(e = null) {
    return e == this.content ? this : new jf(this.type, this.attrs, e, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(e) {
    return e == this.marks ? this : new jf(this.type, this.attrs, this.content, e);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(e, n = this.content.size) {
    return e == 0 && n == this.content.size ? this : this.copy(this.content.cut(e, n));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(e, n = this.content.size, r = !1) {
    if (e == n)
      return Pe.empty;
    let o = this.resolve(e), a = this.resolve(n), i = r ? 0 : o.sharedDepth(n), s = o.start(i), u = o.node(i).content.cut(o.pos - s, a.pos - s);
    return new Pe(u, o.depth - i, a.depth - i);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(e, n, r) {
    return PR(this.resolve(e), this.resolve(n), r);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(e) {
    for (let n = this; ; ) {
      let { index: r, offset: o } = n.content.findIndex(e);
      if (n = n.maybeChild(r), !n)
        return null;
      if (o == e || n.isText)
        return n;
      e -= o + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(e) {
    let { index: n, offset: r } = this.content.findIndex(e);
    return { node: this.content.maybeChild(n), index: n, offset: r };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(e) {
    if (e == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: n, offset: r } = this.content.findIndex(e);
    if (r < e)
      return { node: this.content.child(n), index: n, offset: r };
    let o = this.content.child(n - 1);
    return { node: o, index: n - 1, offset: r - o.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(e) {
    return sl.resolveCached(this, e);
  }
  /**
  @internal
  */
  resolveNoCache(e) {
    return sl.resolve(this, e);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(e, n, r) {
    let o = !1;
    return n > e && this.nodesBetween(e, n, (a) => (r.isInSet(a.marks) && (o = !0), !o)), o;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let e = this.type.name;
    return this.content.size && (e += "(" + this.content.toStringInner() + ")"), Pk(this.marks, e);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(e) {
    let n = this.type.contentMatch.matchFragment(this.content, 0, e);
    if (!n)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return n;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(e, n, r = _e.empty, o = 0, a = r.childCount) {
    let i = this.contentMatchAt(e).matchFragment(r, o, a), s = i && i.matchFragment(this.content, n);
    if (!s || !s.validEnd)
      return !1;
    for (let l = o; l < a; l++)
      if (!this.type.allowsMarks(r.child(l).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(e, n, r, o) {
    if (o && !this.type.allowsMarks(o))
      return !1;
    let a = this.contentMatchAt(e).matchType(r), i = a && a.matchFragment(this.content, n);
    return i ? i.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(e) {
    return e.content.size ? this.canReplace(this.childCount, this.childCount, e.content) : this.type.compatibleContent(e.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
    let e = St.none;
    for (let n = 0; n < this.marks.length; n++) {
      let r = this.marks[n];
      r.type.checkAttrs(r.attrs), e = r.addToSet(e);
    }
    if (!St.sameSet(e, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((n) => n.type.name)}`);
    this.content.forEach((n) => n.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let n in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return this.content.size && (e.content = this.content.toJSON()), this.marks.length && (e.marks = this.marks.map((n) => n.toJSON())), e;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(e, n) {
    if (!n)
      throw new RangeError("Invalid input for Node.fromJSON");
    let r;
    if (n.marks) {
      if (!Array.isArray(n.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      r = n.marks.map(e.markFromJSON);
    }
    if (n.type == "text") {
      if (typeof n.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return e.text(n.text, r);
    }
    let o = _e.fromJSON(e, n.content), a = e.nodeType(n.type).create(n.attrs, o, r);
    return a.type.checkAttrs(a.attrs), a;
  }
};
ra.prototype.text = void 0;
class Pu extends ra {
  /**
  @internal
  */
  constructor(e, n, r, o) {
    if (super(e, n, null, o), !r)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = r;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : Pk(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(e, n) {
    return this.text.slice(e, n);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(e) {
    return e == this.marks ? this : new Pu(this.type, this.attrs, this.text, e);
  }
  withText(e) {
    return e == this.text ? this : new Pu(this.type, this.attrs, e, this.marks);
  }
  cut(e = 0, n = this.text.length) {
    return e == 0 && n == this.text.length ? this : this.withText(this.text.slice(e, n));
  }
  eq(e) {
    return this.sameMarkup(e) && this.text == e.text;
  }
  toJSON() {
    let e = super.toJSON();
    return e.text = this.text, e;
  }
}
function Pk(t, e) {
  for (let n = t.length - 1; n >= 0; n--)
    e = t[n].type.name + "(" + e + ")";
  return e;
}
class Xa {
  /**
  @internal
  */
  constructor(e) {
    this.validEnd = e, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(e, n) {
    let r = new BR(e, n);
    if (r.next == null)
      return Xa.empty;
    let o = Nk(r);
    r.next && r.err("Unexpected trailing text");
    let a = jR(KR(o));
    return zR(a, r), a;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(e) {
    for (let n = 0; n < this.next.length; n++)
      if (this.next[n].type == e)
        return this.next[n].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(e, n = 0, r = e.childCount) {
    let o = this;
    for (let a = n; o && a < r; a++)
      o = o.matchType(e.child(a).type);
    return o;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let e = 0; e < this.next.length; e++) {
      let { type: n } = this.next[e];
      if (!(n.isText || n.hasRequiredAttrs()))
        return n;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(e) {
    for (let n = 0; n < this.next.length; n++)
      for (let r = 0; r < e.next.length; r++)
        if (this.next[n].type == e.next[r].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(e, n = !1, r = 0) {
    let o = [this];
    function a(i, s) {
      let l = i.matchFragment(e, r);
      if (l && (!n || l.validEnd))
        return _e.from(s.map((u) => u.createAndFill()));
      for (let u = 0; u < i.next.length; u++) {
        let { type: c, next: d } = i.next[u];
        if (!(c.isText || c.hasRequiredAttrs()) && o.indexOf(d) == -1) {
          o.push(d);
          let f = a(d, s.concat(c));
          if (f)
            return f;
        }
      }
      return null;
    }
    return a(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(e) {
    for (let r = 0; r < this.wrapCache.length; r += 2)
      if (this.wrapCache[r] == e)
        return this.wrapCache[r + 1];
    let n = this.computeWrapping(e);
    return this.wrapCache.push(e, n), n;
  }
  /**
  @internal
  */
  computeWrapping(e) {
    let n = /* @__PURE__ */ Object.create(null), r = [{ match: this, type: null, via: null }];
    for (; r.length; ) {
      let o = r.shift(), a = o.match;
      if (a.matchType(e)) {
        let i = [];
        for (let s = o; s.type; s = s.via)
          i.push(s.type);
        return i.reverse();
      }
      for (let i = 0; i < a.next.length; i++) {
        let { type: s, next: l } = a.next[i];
        !s.isLeaf && !s.hasRequiredAttrs() && !(s.name in n) && (!o.type || l.validEnd) && (r.push({ match: s.contentMatch, type: s, via: o }), n[s.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(e) {
    if (e >= this.next.length)
      throw new RangeError(`There's no ${e}th edge in this content match`);
    return this.next[e];
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    function n(r) {
      e.push(r);
      for (let o = 0; o < r.next.length; o++)
        e.indexOf(r.next[o].next) == -1 && n(r.next[o].next);
    }
    return n(this), e.map((r, o) => {
      let a = o + (r.validEnd ? "*" : " ") + " ";
      for (let i = 0; i < r.next.length; i++)
        a += (i ? ", " : "") + r.next[i].type.name + "->" + e.indexOf(r.next[i].next);
      return a;
    }).join(`
`);
  }
}
Xa.empty = new Xa(!0);
class BR {
  constructor(e, n) {
    this.string = e, this.nodeTypes = n, this.inline = null, this.pos = 0, this.tokens = e.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(e) {
    return this.next == e && (this.pos++ || !0);
  }
  err(e) {
    throw new SyntaxError(e + " (in content expression '" + this.string + "')");
  }
}
function Nk(t) {
  let e = [];
  do
    e.push(FR(t));
  while (t.eat("|"));
  return e.length == 1 ? e[0] : { type: "choice", exprs: e };
}
function FR(t) {
  let e = [];
  do
    e.push(VR(t));
  while (t.next && t.next != ")" && t.next != "|");
  return e.length == 1 ? e[0] : { type: "seq", exprs: e };
}
function VR(t) {
  let e = WR(t);
  for (; ; )
    if (t.eat("+"))
      e = { type: "plus", expr: e };
    else if (t.eat("*"))
      e = { type: "star", expr: e };
    else if (t.eat("?"))
      e = { type: "opt", expr: e };
    else if (t.eat("{"))
      e = HR(t, e);
    else
      break;
  return e;
}
function Kg(t) {
  /\D/.test(t.next) && t.err("Expected number, got '" + t.next + "'");
  let e = Number(t.next);
  return t.pos++, e;
}
function HR(t, e) {
  let n = Kg(t), r = n;
  return t.eat(",") && (t.next != "}" ? r = Kg(t) : r = -1), t.eat("}") || t.err("Unclosed braced range"), { type: "range", min: n, max: r, expr: e };
}
function UR(t, e) {
  let n = t.nodeTypes, r = n[e];
  if (r)
    return [r];
  let o = [];
  for (let a in n) {
    let i = n[a];
    i.isInGroup(e) && o.push(i);
  }
  return o.length == 0 && t.err("No node type or group '" + e + "' found"), o;
}
function WR(t) {
  if (t.eat("(")) {
    let e = Nk(t);
    return t.eat(")") || t.err("Missing closing paren"), e;
  } else if (/\W/.test(t.next))
    t.err("Unexpected token '" + t.next + "'");
  else {
    let e = UR(t, t.next).map((n) => (t.inline == null ? t.inline = n.isInline : t.inline != n.isInline && t.err("Mixing inline and block content"), { type: "name", value: n }));
    return t.pos++, e.length == 1 ? e[0] : { type: "choice", exprs: e };
  }
}
function KR(t) {
  let e = [[]];
  return o(a(t, 0), n()), e;
  function n() {
    return e.push([]) - 1;
  }
  function r(i, s, l) {
    let u = { term: l, to: s };
    return e[i].push(u), u;
  }
  function o(i, s) {
    i.forEach((l) => l.to = s);
  }
  function a(i, s) {
    if (i.type == "choice")
      return i.exprs.reduce((l, u) => l.concat(a(u, s)), []);
    if (i.type == "seq")
      for (let l = 0; ; l++) {
        let u = a(i.exprs[l], s);
        if (l == i.exprs.length - 1)
          return u;
        o(u, s = n());
      }
    else if (i.type == "star") {
      let l = n();
      return r(s, l), o(a(i.expr, l), l), [r(l)];
    } else if (i.type == "plus") {
      let l = n();
      return o(a(i.expr, s), l), o(a(i.expr, l), l), [r(l)];
    } else {
      if (i.type == "opt")
        return [r(s)].concat(a(i.expr, s));
      if (i.type == "range") {
        let l = s;
        for (let u = 0; u < i.min; u++) {
          let c = n();
          o(a(i.expr, l), c), l = c;
        }
        if (i.max == -1)
          o(a(i.expr, l), l);
        else
          for (let u = i.min; u < i.max; u++) {
            let c = n();
            r(l, c), o(a(i.expr, l), c), l = c;
          }
        return [r(l)];
      } else {
        if (i.type == "name")
          return [r(s, void 0, i.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function $k(t, e) {
  return e - t;
}
function jg(t, e) {
  let n = [];
  return r(e), n.sort($k);
  function r(o) {
    let a = t[o];
    if (a.length == 1 && !a[0].term)
      return r(a[0].to);
    n.push(o);
    for (let i = 0; i < a.length; i++) {
      let { term: s, to: l } = a[i];
      !s && n.indexOf(l) == -1 && r(l);
    }
  }
}
function jR(t) {
  let e = /* @__PURE__ */ Object.create(null);
  return n(jg(t, 0));
  function n(r) {
    let o = [];
    r.forEach((i) => {
      t[i].forEach(({ term: s, to: l }) => {
        if (!s)
          return;
        let u;
        for (let c = 0; c < o.length; c++)
          o[c][0] == s && (u = o[c][1]);
        jg(t, l).forEach((c) => {
          u || o.push([s, u = []]), u.indexOf(c) == -1 && u.push(c);
        });
      });
    });
    let a = e[r.join(",")] = new Xa(r.indexOf(t.length - 1) > -1);
    for (let i = 0; i < o.length; i++) {
      let s = o[i][1].sort($k);
      a.next.push({ type: o[i][0], next: e[s.join(",")] || n(s) });
    }
    return a;
  }
}
function zR(t, e) {
  for (let n = 0, r = [t]; n < r.length; n++) {
    let o = r[n], a = !o.validEnd, i = [];
    for (let s = 0; s < o.next.length; s++) {
      let { type: l, next: u } = o.next[s];
      i.push(l.name), a && !(l.isText || l.hasRequiredAttrs()) && (a = !1), r.indexOf(u) == -1 && r.push(u);
    }
    a && e.err("Only non-generatable nodes (" + i.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function Rk(t) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let n in t) {
    let r = t[n];
    if (!r.hasDefault)
      return null;
    e[n] = r.default;
  }
  return e;
}
function Lk(t, e) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let r in t) {
    let o = e && e[r];
    if (o === void 0) {
      let a = t[r];
      if (a.hasDefault)
        o = a.default;
      else
        throw new RangeError("No value supplied for attribute " + r);
    }
    n[r] = o;
  }
  return n;
}
function Bk(t, e, n, r) {
  for (let o in e)
    if (!(o in t))
      throw new RangeError(`Unsupported attribute ${o} for ${n} of type ${o}`);
  for (let o in t) {
    let a = t[o];
    a.validate && a.validate(e[o]);
  }
}
function Fk(t, e) {
  let n = /* @__PURE__ */ Object.create(null);
  if (e)
    for (let r in e)
      n[r] = new qR(t, r, e[r]);
  return n;
}
let zg = class Vk {
  /**
  @internal
  */
  constructor(e, n, r) {
    this.name = e, this.schema = n, this.spec = r, this.markSet = null, this.groups = r.group ? r.group.split(" ") : [], this.attrs = Fk(e, r.attrs), this.defaultAttrs = Rk(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(r.inline || e == "text"), this.isText = e == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == Xa.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(e) {
    return this.groups.indexOf(e) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let e in this.attrs)
      if (this.attrs[e].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(e) {
    return this == e || this.contentMatch.compatible(e.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(e) {
    return !e && this.defaultAttrs ? this.defaultAttrs : Lk(this.attrs, e);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(e = null, n, r) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new ra(this, this.computeAttrs(e), _e.from(n), St.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(e = null, n, r) {
    return n = _e.from(n), this.checkContent(n), new ra(this, this.computeAttrs(e), n, St.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(e = null, n, r) {
    if (e = this.computeAttrs(e), n = _e.from(n), n.size) {
      let i = this.contentMatch.fillBefore(n);
      if (!i)
        return null;
      n = i.append(n);
    }
    let o = this.contentMatch.matchFragment(n), a = o && o.fillBefore(_e.empty, !0);
    return a ? new ra(this, e, n.append(a), St.setFrom(r)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(e) {
    let n = this.contentMatch.matchFragment(e);
    if (!n || !n.validEnd)
      return !1;
    for (let r = 0; r < e.childCount; r++)
      if (!this.allowsMarks(e.child(r).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(e) {
    if (!this.validContent(e))
      throw new RangeError(`Invalid content for node ${this.name}: ${e.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(e) {
    Bk(this.attrs, e, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(e) {
    return this.markSet == null || this.markSet.indexOf(e) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(e) {
    if (this.markSet == null)
      return !0;
    for (let n = 0; n < e.length; n++)
      if (!this.allowsMarkType(e[n].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(e) {
    if (this.markSet == null)
      return e;
    let n;
    for (let r = 0; r < e.length; r++)
      this.allowsMarkType(e[r].type) ? n && n.push(e[r]) : n || (n = e.slice(0, r));
    return n ? n.length ? n : St.none : e;
  }
  /**
  @internal
  */
  static compile(e, n) {
    let r = /* @__PURE__ */ Object.create(null);
    e.forEach((a, i) => r[a] = new Vk(a, n, i));
    let o = n.spec.topNode || "doc";
    if (!r[o])
      throw new RangeError("Schema is missing its top node type ('" + o + "')");
    if (!r.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let a in r.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return r;
  }
};
function YR(t, e, n) {
  let r = n.split("|");
  return (o) => {
    let a = o === null ? "null" : typeof o;
    if (r.indexOf(a) < 0)
      throw new RangeError(`Expected value of type ${r} for attribute ${e} on type ${t}, got ${a}`);
  };
}
class qR {
  constructor(e, n, r) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(r, "default"), this.default = r.default, this.validate = typeof r.validate == "string" ? YR(e, n, r.validate) : r.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class Yc {
  /**
  @internal
  */
  constructor(e, n, r, o) {
    this.name = e, this.rank = n, this.schema = r, this.spec = o, this.attrs = Fk(e, o.attrs), this.excluded = null;
    let a = Rk(this.attrs);
    this.instance = a ? new St(this, a) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(e = null) {
    return !e && this.instance ? this.instance : new St(this, Lk(this.attrs, e));
  }
  /**
  @internal
  */
  static compile(e, n) {
    let r = /* @__PURE__ */ Object.create(null), o = 0;
    return e.forEach((a, i) => r[a] = new Yc(a, o++, n, i)), r;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(e) {
    for (var n = 0; n < e.length; n++)
      e[n].type == this && (e = e.slice(0, n).concat(e.slice(n + 1)), n--);
    return e;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(e) {
    for (let n = 0; n < e.length; n++)
      if (e[n].type == this)
        return e[n];
  }
  /**
  @internal
  */
  checkAttrs(e) {
    Bk(this.attrs, e, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(e) {
    return this.excluded.indexOf(e) > -1;
  }
}
class Hk {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(e) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let n = this.spec = {};
    for (let o in e)
      n[o] = e[o];
    n.nodes = pn.from(e.nodes), n.marks = pn.from(e.marks || {}), this.nodes = zg.compile(this.spec.nodes, this), this.marks = Yc.compile(this.spec.marks, this);
    let r = /* @__PURE__ */ Object.create(null);
    for (let o in this.nodes) {
      if (o in this.marks)
        throw new RangeError(o + " can not be both a node and a mark");
      let a = this.nodes[o], i = a.spec.content || "", s = a.spec.marks;
      if (a.contentMatch = r[i] || (r[i] = Xa.parse(i, this.nodes)), a.inlineContent = a.contentMatch.inlineContent, a.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!a.isInline || !a.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = a;
      }
      a.markSet = s == "_" ? null : s ? Yg(this, s.split(" ")) : s == "" || !a.inlineContent ? [] : null;
    }
    for (let o in this.marks) {
      let a = this.marks[o], i = a.spec.excludes;
      a.excluded = i == null ? [a] : i == "" ? [] : Yg(this, i.split(" "));
    }
    this.nodeFromJSON = this.nodeFromJSON.bind(this), this.markFromJSON = this.markFromJSON.bind(this), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(e, n = null, r, o) {
    if (typeof e == "string")
      e = this.nodeType(e);
    else if (e instanceof zg) {
      if (e.schema != this)
        throw new RangeError("Node type from different schema used (" + e.name + ")");
    } else throw new RangeError("Invalid node type: " + e);
    return e.createChecked(n, r, o);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(e, n) {
    let r = this.nodes.text;
    return new Pu(r, r.defaultAttrs, e, St.setFrom(n));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(e, n) {
    return typeof e == "string" && (e = this.marks[e]), e.create(n);
  }
  /**
  Deserialize a node from its JSON representation. This method is
  bound.
  */
  nodeFromJSON(e) {
    return ra.fromJSON(this, e);
  }
  /**
  Deserialize a mark from its JSON representation. This method is
  bound.
  */
  markFromJSON(e) {
    return St.fromJSON(this, e);
  }
  /**
  @internal
  */
  nodeType(e) {
    let n = this.nodes[e];
    if (!n)
      throw new RangeError("Unknown node type: " + e);
    return n;
  }
}
function Yg(t, e) {
  let n = [];
  for (let r = 0; r < e.length; r++) {
    let o = e[r], a = t.marks[o], i = a;
    if (a)
      n.push(a);
    else
      for (let s in t.marks) {
        let l = t.marks[s];
        (o == "_" || l.spec.group && l.spec.group.split(" ").indexOf(o) > -1) && n.push(i = l);
      }
    if (!i)
      throw new SyntaxError("Unknown mark type: '" + e[r] + "'");
  }
  return n;
}
function GR(t) {
  return t.tag != null;
}
function JR(t) {
  return t.style != null;
}
class oa {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(e, n) {
    this.schema = e, this.rules = n, this.tags = [], this.styles = [];
    let r = this.matchedStyles = [];
    n.forEach((o) => {
      if (GR(o))
        this.tags.push(o);
      else if (JR(o)) {
        let a = /[^=]*/.exec(o.style)[0];
        r.indexOf(a) < 0 && r.push(a), this.styles.push(o);
      }
    }), this.normalizeLists = !this.tags.some((o) => {
      if (!/^(ul|ol)\b/.test(o.tag) || !o.node)
        return !1;
      let a = e.nodes[o.node];
      return a.contentMatch.matchType(a);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(e, n = {}) {
    let r = new Gg(this, n, !1);
    return r.addAll(e, St.none, n.from, n.to), r.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(e, n = {}) {
    let r = new Gg(this, n, !0);
    return r.addAll(e, St.none, n.from, n.to), Pe.maxOpen(r.finish());
  }
  /**
  @internal
  */
  matchTag(e, n, r) {
    for (let o = r ? this.tags.indexOf(r) + 1 : 0; o < this.tags.length; o++) {
      let a = this.tags[o];
      if (ZR(e, a.tag) && (a.namespace === void 0 || e.namespaceURI == a.namespace) && (!a.context || n.matchesContext(a.context))) {
        if (a.getAttrs) {
          let i = a.getAttrs(e);
          if (i === !1)
            continue;
          a.attrs = i || void 0;
        }
        return a;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(e, n, r, o) {
    for (let a = o ? this.styles.indexOf(o) + 1 : 0; a < this.styles.length; a++) {
      let i = this.styles[a], s = i.style;
      if (!(s.indexOf(e) != 0 || i.context && !r.matchesContext(i.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      s.length > e.length && (s.charCodeAt(e.length) != 61 || s.slice(e.length + 1) != n))) {
        if (i.getAttrs) {
          let l = i.getAttrs(n);
          if (l === !1)
            continue;
          i.attrs = l || void 0;
        }
        return i;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(e) {
    let n = [];
    function r(o) {
      let a = o.priority == null ? 50 : o.priority, i = 0;
      for (; i < n.length; i++) {
        let s = n[i];
        if ((s.priority == null ? 50 : s.priority) < a)
          break;
      }
      n.splice(i, 0, o);
    }
    for (let o in e.marks) {
      let a = e.marks[o].spec.parseDOM;
      a && a.forEach((i) => {
        r(i = Jg(i)), i.mark || i.ignore || i.clearMark || (i.mark = o);
      });
    }
    for (let o in e.nodes) {
      let a = e.nodes[o].spec.parseDOM;
      a && a.forEach((i) => {
        r(i = Jg(i)), i.node || i.ignore || i.mark || (i.node = o);
      });
    }
    return n;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
  */
  static fromSchema(e) {
    return e.cached.domParser || (e.cached.domParser = new oa(e, oa.schemaRules(e)));
  }
}
const Uk = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, XR = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, Wk = { ol: !0, ul: !0 }, ll = 1, zf = 2, fu = 4;
function qg(t, e, n) {
  return e != null ? (e ? ll : 0) | (e === "full" ? zf : 0) : t && t.whitespace == "pre" ? ll | zf : n & -5;
}
class Ql {
  constructor(e, n, r, o, a, i) {
    this.type = e, this.attrs = n, this.marks = r, this.solid = o, this.options = i, this.content = [], this.activeMarks = St.none, this.match = a || (i & fu ? null : e.contentMatch);
  }
  findWrapping(e) {
    if (!this.match) {
      if (!this.type)
        return [];
      let n = this.type.contentMatch.fillBefore(_e.from(e));
      if (n)
        this.match = this.type.contentMatch.matchFragment(n);
      else {
        let r = this.type.contentMatch, o;
        return (o = r.findWrapping(e.type)) ? (this.match = r, o) : null;
      }
    }
    return this.match.findWrapping(e.type);
  }
  finish(e) {
    if (!(this.options & ll)) {
      let r = this.content[this.content.length - 1], o;
      if (r && r.isText && (o = /[ \t\r\n\u000c]+$/.exec(r.text))) {
        let a = r;
        r.text.length == o[0].length ? this.content.pop() : this.content[this.content.length - 1] = a.withText(a.text.slice(0, a.text.length - o[0].length));
      }
    }
    let n = _e.from(this.content);
    return !e && this.match && (n = n.append(this.match.fillBefore(_e.empty, !0))), this.type ? this.type.create(this.attrs, n, this.marks) : n;
  }
  inlineContext(e) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : e.parentNode && !Uk.hasOwnProperty(e.parentNode.nodeName.toLowerCase());
  }
}
class Gg {
  constructor(e, n, r) {
    this.parser = e, this.options = n, this.isOpen = r, this.open = 0, this.localPreserveWS = !1;
    let o = n.topNode, a, i = qg(null, n.preserveWhitespace, 0) | (r ? fu : 0);
    o ? a = new Ql(o.type, o.attrs, St.none, !0, n.topMatch || o.type.contentMatch, i) : r ? a = new Ql(null, null, St.none, !0, null, i) : a = new Ql(e.schema.topNodeType, null, St.none, !0, null, i), this.nodes = [a], this.find = n.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(e, n) {
    e.nodeType == 3 ? this.addTextNode(e, n) : e.nodeType == 1 && this.addElement(e, n);
  }
  addTextNode(e, n) {
    let r = e.nodeValue, o = this.top, a = o.options & zf ? "full" : this.localPreserveWS || (o.options & ll) > 0;
    if (a === "full" || o.inlineContext(e) || /[^ \t\r\n\u000c]/.test(r)) {
      if (a)
        a !== "full" ? r = r.replace(/\r?\n|\r/g, " ") : r = r.replace(/\r\n?/g, `
`);
      else if (r = r.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(r) && this.open == this.nodes.length - 1) {
        let i = o.content[o.content.length - 1], s = e.previousSibling;
        (!i || s && s.nodeName == "BR" || i.isText && /[ \t\r\n\u000c]$/.test(i.text)) && (r = r.slice(1));
      }
      r && this.insertNode(this.parser.schema.text(r), n, !/\S/.test(r)), this.findInText(e);
    } else
      this.findInside(e);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(e, n, r) {
    let o = this.localPreserveWS, a = this.top;
    (e.tagName == "PRE" || /pre/.test(e.style && e.style.whiteSpace)) && (this.localPreserveWS = !0);
    let i = e.nodeName.toLowerCase(), s;
    Wk.hasOwnProperty(i) && this.parser.normalizeLists && QR(e);
    let l = this.options.ruleFromNode && this.options.ruleFromNode(e) || (s = this.parser.matchTag(e, this, r));
    e: if (l ? l.ignore : XR.hasOwnProperty(i))
      this.findInside(e), this.ignoreFallback(e, n);
    else if (!l || l.skip || l.closeParent) {
      l && l.closeParent ? this.open = Math.max(0, this.open - 1) : l && l.skip.nodeType && (e = l.skip);
      let u, c = this.needsBlock;
      if (Uk.hasOwnProperty(i))
        a.content.length && a.content[0].isInline && this.open && (this.open--, a = this.top), u = !0, a.type || (this.needsBlock = !0);
      else if (!e.firstChild) {
        this.leafFallback(e, n);
        break e;
      }
      let d = l && l.skip ? n : this.readStyles(e, n);
      d && this.addAll(e, d), u && this.sync(a), this.needsBlock = c;
    } else {
      let u = this.readStyles(e, n);
      u && this.addElementByRule(e, l, u, l.consuming === !1 ? s : void 0);
    }
    this.localPreserveWS = o;
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(e, n) {
    e.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(e.ownerDocument.createTextNode(`
`), n);
  }
  // Called for ignored nodes
  ignoreFallback(e, n) {
    e.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), n, !0);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(e, n) {
    let r = e.style;
    if (r && r.length)
      for (let o = 0; o < this.parser.matchedStyles.length; o++) {
        let a = this.parser.matchedStyles[o], i = r.getPropertyValue(a);
        if (i)
          for (let s = void 0; ; ) {
            let l = this.parser.matchStyle(a, i, this, s);
            if (!l)
              break;
            if (l.ignore)
              return null;
            if (l.clearMark ? n = n.filter((u) => !l.clearMark(u)) : n = n.concat(this.parser.schema.marks[l.mark].create(l.attrs)), l.consuming === !1)
              s = l;
            else
              break;
          }
      }
    return n;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(e, n, r, o) {
    let a, i;
    if (n.node)
      if (i = this.parser.schema.nodes[n.node], i.isLeaf)
        this.insertNode(i.create(n.attrs), r, e.nodeName == "BR") || this.leafFallback(e, r);
      else {
        let l = this.enter(i, n.attrs || null, r, n.preserveWhitespace);
        l && (a = !0, r = l);
      }
    else {
      let l = this.parser.schema.marks[n.mark];
      r = r.concat(l.create(n.attrs));
    }
    let s = this.top;
    if (i && i.isLeaf)
      this.findInside(e);
    else if (o)
      this.addElement(e, r, o);
    else if (n.getContent)
      this.findInside(e), n.getContent(e, this.parser.schema).forEach((l) => this.insertNode(l, r, !1));
    else {
      let l = e;
      typeof n.contentElement == "string" ? l = e.querySelector(n.contentElement) : typeof n.contentElement == "function" ? l = n.contentElement(e) : n.contentElement && (l = n.contentElement), this.findAround(e, l, !0), this.addAll(l, r), this.findAround(e, l, !1);
    }
    a && this.sync(s) && this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(e, n, r, o) {
    let a = r || 0;
    for (let i = r ? e.childNodes[r] : e.firstChild, s = o == null ? null : e.childNodes[o]; i != s; i = i.nextSibling, ++a)
      this.findAtPoint(e, a), this.addDOM(i, n);
    this.findAtPoint(e, a);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(e, n, r) {
    let o, a;
    for (let i = this.open, s = 0; i >= 0; i--) {
      let l = this.nodes[i], u = l.findWrapping(e);
      if (u && (!o || o.length > u.length + s) && (o = u, a = l, !u.length))
        break;
      if (l.solid) {
        if (r)
          break;
        s += 2;
      }
    }
    if (!o)
      return null;
    this.sync(a);
    for (let i = 0; i < o.length; i++)
      n = this.enterInner(o[i], null, n, !1);
    return n;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(e, n, r) {
    if (e.isInline && this.needsBlock && !this.top.type) {
      let a = this.textblockFromContext();
      a && (n = this.enterInner(a, null, n));
    }
    let o = this.findPlace(e, n, r);
    if (o) {
      this.closeExtra();
      let a = this.top;
      a.match && (a.match = a.match.matchType(e.type));
      let i = St.none;
      for (let s of o.concat(e.marks))
        (a.type ? a.type.allowsMarkType(s.type) : Xg(s.type, e.type)) && (i = s.addToSet(i));
      return a.content.push(e.mark(i)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(e, n, r, o) {
    let a = this.findPlace(e.create(n), r, !1);
    return a && (a = this.enterInner(e, n, r, !0, o)), a;
  }
  // Open a node of the given type
  enterInner(e, n, r, o = !1, a) {
    this.closeExtra();
    let i = this.top;
    i.match = i.match && i.match.matchType(e);
    let s = qg(e, a, i.options);
    i.options & fu && i.content.length == 0 && (s |= fu);
    let l = St.none;
    return r = r.filter((u) => (i.type ? i.type.allowsMarkType(u.type) : Xg(u.type, e)) ? (l = u.addToSet(l), !1) : !0), this.nodes.push(new Ql(e, n, l, o, null, s)), this.open++, r;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(e = !1) {
    let n = this.nodes.length - 1;
    if (n > this.open) {
      for (; n > this.open; n--)
        this.nodes[n - 1].content.push(this.nodes[n].finish(e));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
  }
  sync(e) {
    for (let n = this.open; n >= 0; n--) {
      if (this.nodes[n] == e)
        return this.open = n, !0;
      this.localPreserveWS && (this.nodes[n].options |= ll);
    }
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let e = 0;
    for (let n = this.open; n >= 0; n--) {
      let r = this.nodes[n].content;
      for (let o = r.length - 1; o >= 0; o--)
        e += r[o].nodeSize;
      n && e++;
    }
    return e;
  }
  findAtPoint(e, n) {
    if (this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].node == e && this.find[r].offset == n && (this.find[r].pos = this.currentPos);
  }
  findInside(e) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].pos == null && e.nodeType == 1 && e.contains(this.find[n].node) && (this.find[n].pos = this.currentPos);
  }
  findAround(e, n, r) {
    if (e != n && this.find)
      for (let o = 0; o < this.find.length; o++)
        this.find[o].pos == null && e.nodeType == 1 && e.contains(this.find[o].node) && n.compareDocumentPosition(this.find[o].node) & (r ? 2 : 4) && (this.find[o].pos = this.currentPos);
  }
  findInText(e) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].node == e && (this.find[n].pos = this.currentPos - (e.nodeValue.length - this.find[n].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(e) {
    if (e.indexOf("|") > -1)
      return e.split(/\s*\|\s*/).some(this.matchesContext, this);
    let n = e.split("/"), r = this.options.context, o = !this.isOpen && (!r || r.parent.type == this.nodes[0].type), a = -(r ? r.depth + 1 : 0) + (o ? 0 : 1), i = (s, l) => {
      for (; s >= 0; s--) {
        let u = n[s];
        if (u == "") {
          if (s == n.length - 1 || s == 0)
            continue;
          for (; l >= a; l--)
            if (i(s - 1, l))
              return !0;
          return !1;
        } else {
          let c = l > 0 || l == 0 && o ? this.nodes[l].type : r && l >= a ? r.node(l - a).type : null;
          if (!c || c.name != u && !c.isInGroup(u))
            return !1;
          l--;
        }
      }
      return !0;
    };
    return i(n.length - 1, this.open);
  }
  textblockFromContext() {
    let e = this.options.context;
    if (e)
      for (let n = e.depth; n >= 0; n--) {
        let r = e.node(n).contentMatchAt(e.indexAfter(n)).defaultType;
        if (r && r.isTextblock && r.defaultAttrs)
          return r;
      }
    for (let n in this.parser.schema.nodes) {
      let r = this.parser.schema.nodes[n];
      if (r.isTextblock && r.defaultAttrs)
        return r;
    }
  }
}
function QR(t) {
  for (let e = t.firstChild, n = null; e; e = e.nextSibling) {
    let r = e.nodeType == 1 ? e.nodeName.toLowerCase() : null;
    r && Wk.hasOwnProperty(r) && n ? (n.appendChild(e), e = n) : r == "li" ? n = e : r && (n = null);
  }
}
function ZR(t, e) {
  return (t.matches || t.msMatchesSelector || t.webkitMatchesSelector || t.mozMatchesSelector).call(t, e);
}
function Jg(t) {
  let e = {};
  for (let n in t)
    e[n] = t[n];
  return e;
}
function Xg(t, e) {
  let n = e.schema.nodes;
  for (let r in n) {
    let o = n[r];
    if (!o.allowsMarkType(t))
      continue;
    let a = [], i = (s) => {
      a.push(s);
      for (let l = 0; l < s.edgeCount; l++) {
        let { type: u, next: c } = s.edge(l);
        if (u == e || a.indexOf(c) < 0 && i(c))
          return !0;
      }
    };
    if (i(o.contentMatch))
      return !0;
  }
}
class ci {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(e, n) {
    this.nodes = e, this.marks = n;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(e, n = {}, r) {
    r || (r = $d(n).createDocumentFragment());
    let o = r, a = [];
    return e.forEach((i) => {
      if (a.length || i.marks.length) {
        let s = 0, l = 0;
        for (; s < a.length && l < i.marks.length; ) {
          let u = i.marks[l];
          if (!this.marks[u.type.name]) {
            l++;
            continue;
          }
          if (!u.eq(a[s][0]) || u.type.spec.spanning === !1)
            break;
          s++, l++;
        }
        for (; s < a.length; )
          o = a.pop()[1];
        for (; l < i.marks.length; ) {
          let u = i.marks[l++], c = this.serializeMark(u, i.isInline, n);
          c && (a.push([u, o]), o.appendChild(c.dom), o = c.contentDOM || c.dom);
        }
      }
      o.appendChild(this.serializeNodeInner(i, n));
    }), r;
  }
  /**
  @internal
  */
  serializeNodeInner(e, n) {
    let { dom: r, contentDOM: o } = pu($d(n), this.nodes[e.type.name](e), null, e.attrs);
    if (o) {
      if (e.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(e.content, n, o);
    }
    return r;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(e, n = {}) {
    let r = this.serializeNodeInner(e, n);
    for (let o = e.marks.length - 1; o >= 0; o--) {
      let a = this.serializeMark(e.marks[o], e.isInline, n);
      a && ((a.contentDOM || a.dom).appendChild(r), r = a.dom);
    }
    return r;
  }
  /**
  @internal
  */
  serializeMark(e, n, r = {}) {
    let o = this.marks[e.type.name];
    return o && pu($d(r), o(e, n), null, e.attrs);
  }
  static renderSpec(e, n, r = null, o) {
    return pu(e, n, r, o);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(e) {
    return e.cached.domSerializer || (e.cached.domSerializer = new ci(this.nodesFromSchema(e), this.marksFromSchema(e)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(e) {
    let n = Qg(e.nodes);
    return n.text || (n.text = (r) => r.text), n;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(e) {
    return Qg(e.marks);
  }
}
function Qg(t) {
  let e = {};
  for (let n in t) {
    let r = t[n].spec.toDOM;
    r && (e[n] = r);
  }
  return e;
}
function $d(t) {
  return t.document || window.document;
}
const Zg = /* @__PURE__ */ new WeakMap();
function eL(t) {
  let e = Zg.get(t);
  return e === void 0 && Zg.set(t, e = tL(t)), e;
}
function tL(t) {
  let e = null;
  function n(r) {
    if (r && typeof r == "object")
      if (Array.isArray(r))
        if (typeof r[0] == "string")
          e || (e = []), e.push(r);
        else
          for (let o = 0; o < r.length; o++)
            n(r[o]);
      else
        for (let o in r)
          n(r[o]);
  }
  return n(t), e;
}
function pu(t, e, n, r) {
  if (typeof e == "string")
    return { dom: t.createTextNode(e) };
  if (e.nodeType != null)
    return { dom: e };
  if (e.dom && e.dom.nodeType != null)
    return e;
  let o = e[0], a;
  if (typeof o != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (r && (a = eL(r)) && a.indexOf(e) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let i = o.indexOf(" ");
  i > 0 && (n = o.slice(0, i), o = o.slice(i + 1));
  let s, l = n ? t.createElementNS(n, o) : t.createElement(o), u = e[1], c = 1;
  if (u && typeof u == "object" && u.nodeType == null && !Array.isArray(u)) {
    c = 2;
    for (let d in u)
      if (u[d] != null) {
        let f = d.indexOf(" ");
        f > 0 ? l.setAttributeNS(d.slice(0, f), d.slice(f + 1), u[d]) : l.setAttribute(d, u[d]);
      }
  }
  for (let d = c; d < e.length; d++) {
    let f = e[d];
    if (f === 0) {
      if (d < e.length - 1 || d > c)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom: l, contentDOM: l };
    } else {
      let { dom: h, contentDOM: m } = pu(t, f, n, r);
      if (l.appendChild(h), m) {
        if (s)
          throw new RangeError("Multiple content holes");
        s = m;
      }
    }
  }
  return { dom: l, contentDOM: s };
}
const Kk = 65535, jk = Math.pow(2, 16);
function nL(t, e) {
  return t + e * jk;
}
function ev(t) {
  return t & Kk;
}
function rL(t) {
  return (t - (t & Kk)) / jk;
}
const zk = 1, Yk = 2, hu = 4, qk = 8;
class Yf {
  /**
  @internal
  */
  constructor(e, n, r) {
    this.pos = e, this.delInfo = n, this.recover = r;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & qk) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (zk | hu)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (Yk | hu)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & hu) > 0;
  }
}
class Jn {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(e, n = !1) {
    if (this.ranges = e, this.inverted = n, !e.length && Jn.empty)
      return Jn.empty;
  }
  /**
  @internal
  */
  recover(e) {
    let n = 0, r = ev(e);
    if (!this.inverted)
      for (let o = 0; o < r; o++)
        n += this.ranges[o * 3 + 2] - this.ranges[o * 3 + 1];
    return this.ranges[r * 3] + n + rL(e);
  }
  mapResult(e, n = 1) {
    return this._map(e, n, !1);
  }
  map(e, n = 1) {
    return this._map(e, n, !0);
  }
  /**
  @internal
  */
  _map(e, n, r) {
    let o = 0, a = this.inverted ? 2 : 1, i = this.inverted ? 1 : 2;
    for (let s = 0; s < this.ranges.length; s += 3) {
      let l = this.ranges[s] - (this.inverted ? o : 0);
      if (l > e)
        break;
      let u = this.ranges[s + a], c = this.ranges[s + i], d = l + u;
      if (e <= d) {
        let f = u ? e == l ? -1 : e == d ? 1 : n : n, h = l + o + (f < 0 ? 0 : c);
        if (r)
          return h;
        let m = e == (n < 0 ? l : d) ? null : nL(s / 3, e - l), g = e == l ? Yk : e == d ? zk : hu;
        return (n < 0 ? e != l : e != d) && (g |= qk), new Yf(h, g, m);
      }
      o += c - u;
    }
    return r ? e + o : new Yf(e + o, 0, null);
  }
  /**
  @internal
  */
  touches(e, n) {
    let r = 0, o = ev(n), a = this.inverted ? 2 : 1, i = this.inverted ? 1 : 2;
    for (let s = 0; s < this.ranges.length; s += 3) {
      let l = this.ranges[s] - (this.inverted ? r : 0);
      if (l > e)
        break;
      let u = this.ranges[s + a], c = l + u;
      if (e <= c && s == o * 3)
        return !0;
      r += this.ranges[s + i] - u;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(e) {
    let n = this.inverted ? 2 : 1, r = this.inverted ? 1 : 2;
    for (let o = 0, a = 0; o < this.ranges.length; o += 3) {
      let i = this.ranges[o], s = i - (this.inverted ? a : 0), l = i + (this.inverted ? 0 : a), u = this.ranges[o + n], c = this.ranges[o + r];
      e(s, s + u, l, l + c), a += c - u;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new Jn(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(e) {
    return e == 0 ? Jn.empty : new Jn(e < 0 ? [0, -e, 0] : [0, 0, e]);
  }
}
Jn.empty = new Jn([]);
class ul {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(e, n, r = 0, o = e ? e.length : 0) {
    this.mirror = n, this.from = r, this.to = o, this._maps = e || [], this.ownData = !(e || n);
  }
  /**
  The step maps in this mapping.
  */
  get maps() {
    return this._maps;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(e = 0, n = this.maps.length) {
    return new ul(this._maps, this.mirror, e, n);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(e, n) {
    this.ownData || (this._maps = this._maps.slice(), this.mirror = this.mirror && this.mirror.slice(), this.ownData = !0), this.to = this._maps.push(e), n != null && this.setMirror(this._maps.length - 1, n);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(e) {
    for (let n = 0, r = this._maps.length; n < e._maps.length; n++) {
      let o = e.getMirror(n);
      this.appendMap(e._maps[n], o != null && o < n ? r + o : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(e) {
    if (this.mirror) {
      for (let n = 0; n < this.mirror.length; n++)
        if (this.mirror[n] == e)
          return this.mirror[n + (n % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(e, n) {
    this.mirror || (this.mirror = []), this.mirror.push(e, n);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(e) {
    for (let n = e.maps.length - 1, r = this._maps.length + e._maps.length; n >= 0; n--) {
      let o = e.getMirror(n);
      this.appendMap(e._maps[n].invert(), o != null && o > n ? r - o - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let e = new ul();
    return e.appendMappingInverted(this), e;
  }
  /**
  Map a position through this mapping.
  */
  map(e, n = 1) {
    if (this.mirror)
      return this._map(e, n, !0);
    for (let r = this.from; r < this.to; r++)
      e = this._maps[r].map(e, n);
    return e;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(e, n = 1) {
    return this._map(e, n, !1);
  }
  /**
  @internal
  */
  _map(e, n, r) {
    let o = 0;
    for (let a = this.from; a < this.to; a++) {
      let i = this._maps[a], s = i.mapResult(e, n);
      if (s.recover != null) {
        let l = this.getMirror(a);
        if (l != null && l > a && l < this.to) {
          a = l, e = this._maps[l].recover(s.recover);
          continue;
        }
      }
      o |= s.delInfo, e = s.pos;
    }
    return r ? e : new Yf(e, o, null);
  }
}
const Rd = /* @__PURE__ */ Object.create(null);
class Tn {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return Jn.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(e) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(e, n) {
    if (!n || !n.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let r = Rd[n.stepType];
    if (!r)
      throw new RangeError(`No step type ${n.stepType} defined`);
    return r.fromJSON(e, n);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(e, n) {
    if (e in Rd)
      throw new RangeError("Duplicate use of step JSON ID " + e);
    return Rd[e] = n, n.prototype.jsonID = e, n;
  }
}
class Jt {
  /**
  @internal
  */
  constructor(e, n) {
    this.doc = e, this.failed = n;
  }
  /**
  Create a successful step result.
  */
  static ok(e) {
    return new Jt(e, null);
  }
  /**
  Create a failed step result.
  */
  static fail(e) {
    return new Jt(null, e);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(e, n, r, o) {
    try {
      return Jt.ok(e.replace(n, r, o));
    } catch (a) {
      if (a instanceof Mu)
        return Jt.fail(a.message);
      throw a;
    }
  }
}
function Oh(t, e, n) {
  let r = [];
  for (let o = 0; o < t.childCount; o++) {
    let a = t.child(o);
    a.content.size && (a = a.copy(Oh(a.content, e, a))), a.isInline && (a = e(a, n, o)), r.push(a);
  }
  return _e.fromArray(r);
}
class Qo extends Tn {
  /**
  Create a mark step.
  */
  constructor(e, n, r) {
    super(), this.from = e, this.to = n, this.mark = r;
  }
  apply(e) {
    let n = e.slice(this.from, this.to), r = e.resolve(this.from), o = r.node(r.sharedDepth(this.to)), a = new Pe(Oh(n.content, (i, s) => !i.isAtom || !s.type.allowsMarkType(this.mark.type) ? i : i.mark(this.mark.addToSet(i.marks)), o), n.openStart, n.openEnd);
    return Jt.fromReplace(e, this.from, this.to, a);
  }
  invert() {
    return new Jr(this.from, this.to, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return n.deleted && r.deleted || n.pos >= r.pos ? null : new Qo(n.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof Qo && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new Qo(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new Qo(n.from, n.to, e.markFromJSON(n.mark));
  }
}
Tn.jsonID("addMark", Qo);
class Jr extends Tn {
  /**
  Create a mark-removing step.
  */
  constructor(e, n, r) {
    super(), this.from = e, this.to = n, this.mark = r;
  }
  apply(e) {
    let n = e.slice(this.from, this.to), r = new Pe(Oh(n.content, (o) => o.mark(this.mark.removeFromSet(o.marks)), e), n.openStart, n.openEnd);
    return Jt.fromReplace(e, this.from, this.to, r);
  }
  invert() {
    return new Qo(this.from, this.to, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return n.deleted && r.deleted || n.pos >= r.pos ? null : new Jr(n.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof Jr && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new Jr(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new Jr(n.from, n.to, e.markFromJSON(n.mark));
  }
}
Tn.jsonID("removeMark", Jr);
class Zo extends Tn {
  /**
  Create a node mark step.
  */
  constructor(e, n) {
    super(), this.pos = e, this.mark = n;
  }
  apply(e) {
    let n = e.nodeAt(this.pos);
    if (!n)
      return Jt.fail("No node at mark step's position");
    let r = n.type.create(n.attrs, null, this.mark.addToSet(n.marks));
    return Jt.fromReplace(e, this.pos, this.pos + 1, new Pe(_e.from(r), 0, n.isLeaf ? 0 : 1));
  }
  invert(e) {
    let n = e.nodeAt(this.pos);
    if (n) {
      let r = this.mark.addToSet(n.marks);
      if (r.length == n.marks.length) {
        for (let o = 0; o < n.marks.length; o++)
          if (!n.marks[o].isInSet(r))
            return new Zo(this.pos, n.marks[o]);
        return new Zo(this.pos, this.mark);
      }
    }
    return new Qa(this.pos, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new Zo(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new Zo(n.pos, e.markFromJSON(n.mark));
  }
}
Tn.jsonID("addNodeMark", Zo);
class Qa extends Tn {
  /**
  Create a mark-removing step.
  */
  constructor(e, n) {
    super(), this.pos = e, this.mark = n;
  }
  apply(e) {
    let n = e.nodeAt(this.pos);
    if (!n)
      return Jt.fail("No node at mark step's position");
    let r = n.type.create(n.attrs, null, this.mark.removeFromSet(n.marks));
    return Jt.fromReplace(e, this.pos, this.pos + 1, new Pe(_e.from(r), 0, n.isLeaf ? 0 : 1));
  }
  invert(e) {
    let n = e.nodeAt(this.pos);
    return !n || !this.mark.isInSet(n.marks) ? this : new Zo(this.pos, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new Qa(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new Qa(n.pos, e.markFromJSON(n.mark));
  }
}
Tn.jsonID("removeNodeMark", Qa);
class ln extends Tn {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(e, n, r, o = !1) {
    super(), this.from = e, this.to = n, this.slice = r, this.structure = o;
  }
  apply(e) {
    return this.structure && qf(e, this.from, this.to) ? Jt.fail("Structure replace would overwrite content") : Jt.fromReplace(e, this.from, this.to, this.slice);
  }
  getMap() {
    return new Jn([this.from, this.to - this.from, this.slice.size]);
  }
  invert(e) {
    return new ln(this.from, this.from + this.slice.size, e.slice(this.from, this.to));
  }
  map(e) {
    let n = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return n.deletedAcross && r.deletedAcross ? null : new ln(n.pos, Math.max(n.pos, r.pos), this.slice, this.structure);
  }
  merge(e) {
    if (!(e instanceof ln) || e.structure || this.structure)
      return null;
    if (this.from + this.slice.size == e.from && !this.slice.openEnd && !e.slice.openStart) {
      let n = this.slice.size + e.slice.size == 0 ? Pe.empty : new Pe(this.slice.content.append(e.slice.content), this.slice.openStart, e.slice.openEnd);
      return new ln(this.from, this.to + (e.to - e.from), n, this.structure);
    } else if (e.to == this.from && !this.slice.openStart && !e.slice.openEnd) {
      let n = this.slice.size + e.slice.size == 0 ? Pe.empty : new Pe(e.slice.content.append(this.slice.content), e.slice.openStart, this.slice.openEnd);
      return new ln(e.from, this.to, n, this.structure);
    } else
      return null;
  }
  toJSON() {
    let e = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new ln(n.from, n.to, Pe.fromJSON(e, n.slice), !!n.structure);
  }
}
Tn.jsonID("replace", ln);
class un extends Tn {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(e, n, r, o, a, i, s = !1) {
    super(), this.from = e, this.to = n, this.gapFrom = r, this.gapTo = o, this.slice = a, this.insert = i, this.structure = s;
  }
  apply(e) {
    if (this.structure && (qf(e, this.from, this.gapFrom) || qf(e, this.gapTo, this.to)))
      return Jt.fail("Structure gap-replace would overwrite content");
    let n = e.slice(this.gapFrom, this.gapTo);
    if (n.openStart || n.openEnd)
      return Jt.fail("Gap is not a flat range");
    let r = this.slice.insertAt(this.insert, n.content);
    return r ? Jt.fromReplace(e, this.from, this.to, r) : Jt.fail("Content does not fit in gap");
  }
  getMap() {
    return new Jn([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(e) {
    let n = this.gapTo - this.gapFrom;
    return new un(this.from, this.from + this.slice.size + n, this.from + this.insert, this.from + this.insert + n, e.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(e) {
    let n = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1), o = this.from == this.gapFrom ? n.pos : e.map(this.gapFrom, -1), a = this.to == this.gapTo ? r.pos : e.map(this.gapTo, 1);
    return n.deletedAcross && r.deletedAcross || o < n.pos || a > r.pos ? null : new un(n.pos, r.pos, o, a, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let e = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number" || typeof n.gapFrom != "number" || typeof n.gapTo != "number" || typeof n.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new un(n.from, n.to, n.gapFrom, n.gapTo, Pe.fromJSON(e, n.slice), n.insert, !!n.structure);
  }
}
Tn.jsonID("replaceAround", un);
function qf(t, e, n) {
  let r = t.resolve(e), o = n - e, a = r.depth;
  for (; o > 0 && a > 0 && r.indexAfter(a) == r.node(a).childCount; )
    a--, o--;
  if (o > 0) {
    let i = r.node(a).maybeChild(r.indexAfter(a));
    for (; o > 0; ) {
      if (!i || i.isLeaf)
        return !0;
      i = i.firstChild, o--;
    }
  }
  return !1;
}
function oL(t, e, n, r) {
  let o = [], a = [], i, s;
  t.doc.nodesBetween(e, n, (l, u, c) => {
    if (!l.isInline)
      return;
    let d = l.marks;
    if (!r.isInSet(d) && c.type.allowsMarkType(r.type)) {
      let f = Math.max(u, e), h = Math.min(u + l.nodeSize, n), m = r.addToSet(d);
      for (let g = 0; g < d.length; g++)
        d[g].isInSet(m) || (i && i.to == f && i.mark.eq(d[g]) ? i.to = h : o.push(i = new Jr(f, h, d[g])));
      s && s.to == f ? s.to = h : a.push(s = new Qo(f, h, r));
    }
  }), o.forEach((l) => t.step(l)), a.forEach((l) => t.step(l));
}
function aL(t, e, n, r) {
  let o = [], a = 0;
  t.doc.nodesBetween(e, n, (i, s) => {
    if (!i.isInline)
      return;
    a++;
    let l = null;
    if (r instanceof Yc) {
      let u = i.marks, c;
      for (; c = r.isInSet(u); )
        (l || (l = [])).push(c), u = c.removeFromSet(u);
    } else r ? r.isInSet(i.marks) && (l = [r]) : l = i.marks;
    if (l && l.length) {
      let u = Math.min(s + i.nodeSize, n);
      for (let c = 0; c < l.length; c++) {
        let d = l[c], f;
        for (let h = 0; h < o.length; h++) {
          let m = o[h];
          m.step == a - 1 && d.eq(o[h].style) && (f = m);
        }
        f ? (f.to = u, f.step = a) : o.push({ style: d, from: Math.max(s, e), to: u, step: a });
      }
    }
  }), o.forEach((i) => t.step(new Jr(i.from, i.to, i.style)));
}
function Th(t, e, n, r = n.contentMatch, o = !0) {
  let a = t.doc.nodeAt(e), i = [], s = e + 1;
  for (let l = 0; l < a.childCount; l++) {
    let u = a.child(l), c = s + u.nodeSize, d = r.matchType(u.type);
    if (!d)
      i.push(new ln(s, c, Pe.empty));
    else {
      r = d;
      for (let f = 0; f < u.marks.length; f++)
        n.allowsMarkType(u.marks[f].type) || t.step(new Jr(s, c, u.marks[f]));
      if (o && u.isText && n.whitespace != "pre") {
        let f, h = /\r?\n|\r/g, m;
        for (; f = h.exec(u.text); )
          m || (m = new Pe(_e.from(n.schema.text(" ", n.allowedMarks(u.marks))), 0, 0)), i.push(new ln(s + f.index, s + f.index + f[0].length, m));
      }
    }
    s = c;
  }
  if (!r.validEnd) {
    let l = r.fillBefore(_e.empty, !0);
    t.replace(s, s, new Pe(l, 0, 0));
  }
  for (let l = i.length - 1; l >= 0; l--)
    t.step(i[l]);
}
function iL(t, e, n) {
  return (e == 0 || t.canReplace(e, t.childCount)) && (n == t.childCount || t.canReplace(0, n));
}
function ys(t) {
  let n = t.parent.content.cutByIndex(t.startIndex, t.endIndex);
  for (let r = t.depth; ; --r) {
    let o = t.$from.node(r), a = t.$from.index(r), i = t.$to.indexAfter(r);
    if (r < t.depth && o.canReplace(a, i, n))
      return r;
    if (r == 0 || o.type.spec.isolating || !iL(o, a, i))
      break;
  }
  return null;
}
function sL(t, e, n) {
  let { $from: r, $to: o, depth: a } = e, i = r.before(a + 1), s = o.after(a + 1), l = i, u = s, c = _e.empty, d = 0;
  for (let m = a, g = !1; m > n; m--)
    g || r.index(m) > 0 ? (g = !0, c = _e.from(r.node(m).copy(c)), d++) : l--;
  let f = _e.empty, h = 0;
  for (let m = a, g = !1; m > n; m--)
    g || o.after(m + 1) < o.end(m) ? (g = !0, f = _e.from(o.node(m).copy(f)), h++) : u++;
  t.step(new un(l, u, i, s, new Pe(c.append(f), d, h), c.size - d, !0));
}
function Sh(t, e, n = null, r = t) {
  let o = lL(t, e), a = o && uL(r, e);
  return a ? o.map(tv).concat({ type: e, attrs: n }).concat(a.map(tv)) : null;
}
function tv(t) {
  return { type: t, attrs: null };
}
function lL(t, e) {
  let { parent: n, startIndex: r, endIndex: o } = t, a = n.contentMatchAt(r).findWrapping(e);
  if (!a)
    return null;
  let i = a.length ? a[0] : e;
  return n.canReplaceWith(r, o, i) ? a : null;
}
function uL(t, e) {
  let { parent: n, startIndex: r, endIndex: o } = t, a = n.child(r), i = e.contentMatch.findWrapping(a.type);
  if (!i)
    return null;
  let l = (i.length ? i[i.length - 1] : e).contentMatch;
  for (let u = r; l && u < o; u++)
    l = l.matchType(n.child(u).type);
  return !l || !l.validEnd ? null : i;
}
function cL(t, e, n) {
  let r = _e.empty;
  for (let i = n.length - 1; i >= 0; i--) {
    if (r.size) {
      let s = n[i].type.contentMatch.matchFragment(r);
      if (!s || !s.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    r = _e.from(n[i].type.create(n[i].attrs, r));
  }
  let o = e.start, a = e.end;
  t.step(new un(o, a, o, a, new Pe(r, 0, 0), n.length, !0));
}
function dL(t, e, n, r, o) {
  if (!r.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let a = t.steps.length;
  t.doc.nodesBetween(e, n, (i, s) => {
    let l = typeof o == "function" ? o(i) : o;
    if (i.isTextblock && !i.hasMarkup(r, l) && fL(t.doc, t.mapping.slice(a).map(s), r)) {
      let u = null;
      if (r.schema.linebreakReplacement) {
        let h = r.whitespace == "pre", m = !!r.contentMatch.matchType(r.schema.linebreakReplacement);
        h && !m ? u = !1 : !h && m && (u = !0);
      }
      u === !1 && Jk(t, i, s, a), Th(t, t.mapping.slice(a).map(s, 1), r, void 0, u === null);
      let c = t.mapping.slice(a), d = c.map(s, 1), f = c.map(s + i.nodeSize, 1);
      return t.step(new un(d, f, d + 1, f - 1, new Pe(_e.from(r.create(l, null, i.marks)), 0, 0), 1, !0)), u === !0 && Gk(t, i, s, a), !1;
    }
  });
}
function Gk(t, e, n, r) {
  e.forEach((o, a) => {
    if (o.isText) {
      let i, s = /\r?\n|\r/g;
      for (; i = s.exec(o.text); ) {
        let l = t.mapping.slice(r).map(n + 1 + a + i.index);
        t.replaceWith(l, l + 1, e.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function Jk(t, e, n, r) {
  e.forEach((o, a) => {
    if (o.type == o.type.schema.linebreakReplacement) {
      let i = t.mapping.slice(r).map(n + 1 + a);
      t.replaceWith(i, i + 1, e.type.schema.text(`
`));
    }
  });
}
function fL(t, e, n) {
  let r = t.resolve(e), o = r.index();
  return r.parent.canReplaceWith(o, o + 1, n);
}
function pL(t, e, n, r, o) {
  let a = t.doc.nodeAt(e);
  if (!a)
    throw new RangeError("No node at given position");
  n || (n = a.type);
  let i = n.create(r, null, o || a.marks);
  if (a.isLeaf)
    return t.replaceWith(e, e + a.nodeSize, i);
  if (!n.validContent(a.content))
    throw new RangeError("Invalid content for node type " + n.name);
  t.step(new un(e, e + a.nodeSize, e + 1, e + a.nodeSize - 1, new Pe(_e.from(i), 0, 0), 1, !0));
}
function Mo(t, e, n = 1, r) {
  let o = t.resolve(e), a = o.depth - n, i = r && r[r.length - 1] || o.parent;
  if (a < 0 || o.parent.type.spec.isolating || !o.parent.canReplace(o.index(), o.parent.childCount) || !i.type.validContent(o.parent.content.cutByIndex(o.index(), o.parent.childCount)))
    return !1;
  for (let u = o.depth - 1, c = n - 2; u > a; u--, c--) {
    let d = o.node(u), f = o.index(u);
    if (d.type.spec.isolating)
      return !1;
    let h = d.content.cutByIndex(f, d.childCount), m = r && r[c + 1];
    m && (h = h.replaceChild(0, m.type.create(m.attrs)));
    let g = r && r[c] || d;
    if (!d.canReplace(f + 1, d.childCount) || !g.type.validContent(h))
      return !1;
  }
  let s = o.indexAfter(a), l = r && r[0];
  return o.node(a).canReplaceWith(s, s, l ? l.type : o.node(a + 1).type);
}
function hL(t, e, n = 1, r) {
  let o = t.doc.resolve(e), a = _e.empty, i = _e.empty;
  for (let s = o.depth, l = o.depth - n, u = n - 1; s > l; s--, u--) {
    a = _e.from(o.node(s).copy(a));
    let c = r && r[u];
    i = _e.from(c ? c.type.create(c.attrs, i) : o.node(s).copy(i));
  }
  t.step(new ln(e, e, new Pe(a.append(i), n, n), !0));
}
function wa(t, e) {
  let n = t.resolve(e), r = n.index();
  return Xk(n.nodeBefore, n.nodeAfter) && n.parent.canReplace(r, r + 1);
}
function mL(t, e) {
  e.content.size || t.type.compatibleContent(e.type);
  let n = t.contentMatchAt(t.childCount), { linebreakReplacement: r } = t.type.schema;
  for (let o = 0; o < e.childCount; o++) {
    let a = e.child(o), i = a.type == r ? t.type.schema.nodes.text : a.type;
    if (n = n.matchType(i), !n || !t.type.allowsMarks(a.marks))
      return !1;
  }
  return n.validEnd;
}
function Xk(t, e) {
  return !!(t && e && !t.isLeaf && mL(t, e));
}
function qc(t, e, n = -1) {
  let r = t.resolve(e);
  for (let o = r.depth; ; o--) {
    let a, i, s = r.index(o);
    if (o == r.depth ? (a = r.nodeBefore, i = r.nodeAfter) : n > 0 ? (a = r.node(o + 1), s++, i = r.node(o).maybeChild(s)) : (a = r.node(o).maybeChild(s - 1), i = r.node(o + 1)), a && !a.isTextblock && Xk(a, i) && r.node(o).canReplace(s, s + 1))
      return e;
    if (o == 0)
      break;
    e = n < 0 ? r.before(o) : r.after(o);
  }
}
function gL(t, e, n) {
  let r = null, { linebreakReplacement: o } = t.doc.type.schema, a = t.doc.resolve(e - n), i = a.node().type;
  if (o && i.inlineContent) {
    let c = i.whitespace == "pre", d = !!i.contentMatch.matchType(o);
    c && !d ? r = !1 : !c && d && (r = !0);
  }
  let s = t.steps.length;
  if (r === !1) {
    let c = t.doc.resolve(e + n);
    Jk(t, c.node(), c.before(), s);
  }
  i.inlineContent && Th(t, e + n - 1, i, a.node().contentMatchAt(a.index()), r == null);
  let l = t.mapping.slice(s), u = l.map(e - n);
  if (t.step(new ln(u, l.map(e + n, -1), Pe.empty, !0)), r === !0) {
    let c = t.doc.resolve(u);
    Gk(t, c.node(), c.before(), t.steps.length);
  }
  return t;
}
function vL(t, e, n) {
  let r = t.resolve(e);
  if (r.parent.canReplaceWith(r.index(), r.index(), n))
    return e;
  if (r.parentOffset == 0)
    for (let o = r.depth - 1; o >= 0; o--) {
      let a = r.index(o);
      if (r.node(o).canReplaceWith(a, a, n))
        return r.before(o + 1);
      if (a > 0)
        return null;
    }
  if (r.parentOffset == r.parent.content.size)
    for (let o = r.depth - 1; o >= 0; o--) {
      let a = r.indexAfter(o);
      if (r.node(o).canReplaceWith(a, a, n))
        return r.after(o + 1);
      if (a < r.node(o).childCount)
        return null;
    }
  return null;
}
function Qk(t, e, n) {
  let r = t.resolve(e);
  if (!n.content.size)
    return e;
  let o = n.content;
  for (let a = 0; a < n.openStart; a++)
    o = o.firstChild.content;
  for (let a = 1; a <= (n.openStart == 0 && n.size ? 2 : 1); a++)
    for (let i = r.depth; i >= 0; i--) {
      let s = i == r.depth ? 0 : r.pos <= (r.start(i + 1) + r.end(i + 1)) / 2 ? -1 : 1, l = r.index(i) + (s > 0 ? 1 : 0), u = r.node(i), c = !1;
      if (a == 1)
        c = u.canReplace(l, l, o);
      else {
        let d = u.contentMatchAt(l).findWrapping(o.firstChild.type);
        c = d && u.canReplaceWith(l, l, d[0]);
      }
      if (c)
        return s == 0 ? r.pos : s < 0 ? r.before(i + 1) : r.after(i + 1);
    }
  return null;
}
function Gc(t, e, n = e, r = Pe.empty) {
  if (e == n && !r.size)
    return null;
  let o = t.resolve(e), a = t.resolve(n);
  return Zk(o, a, r) ? new ln(e, n, r) : new yL(o, a, r).fit();
}
function Zk(t, e, n) {
  return !n.openStart && !n.openEnd && t.start() == e.start() && t.parent.canReplace(t.index(), e.index(), n.content);
}
class yL {
  constructor(e, n, r) {
    this.$from = e, this.$to = n, this.unplaced = r, this.frontier = [], this.placed = _e.empty;
    for (let o = 0; o <= e.depth; o++) {
      let a = e.node(o);
      this.frontier.push({
        type: a.type,
        match: a.contentMatchAt(e.indexAfter(o))
      });
    }
    for (let o = e.depth; o > 0; o--)
      this.placed = _e.from(e.node(o).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let u = this.findFittable();
      u ? this.placeNodes(u) : this.openMore() || this.dropNode();
    }
    let e = this.mustMoveInline(), n = this.placed.size - this.depth - this.$from.depth, r = this.$from, o = this.close(e < 0 ? this.$to : r.doc.resolve(e));
    if (!o)
      return null;
    let a = this.placed, i = r.depth, s = o.depth;
    for (; i && s && a.childCount == 1; )
      a = a.firstChild.content, i--, s--;
    let l = new Pe(a, i, s);
    return e > -1 ? new un(r.pos, e, this.$to.pos, this.$to.end(), l, n) : l.size || r.pos != this.$to.pos ? new ln(r.pos, o.pos, l) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let e = this.unplaced.openStart;
    for (let n = this.unplaced.content, r = 0, o = this.unplaced.openEnd; r < e; r++) {
      let a = n.firstChild;
      if (n.childCount > 1 && (o = 0), a.type.spec.isolating && o <= r) {
        e = r;
        break;
      }
      n = a.content;
    }
    for (let n = 1; n <= 2; n++)
      for (let r = n == 1 ? e : this.unplaced.openStart; r >= 0; r--) {
        let o, a = null;
        r ? (a = Ld(this.unplaced.content, r - 1).firstChild, o = a.content) : o = this.unplaced.content;
        let i = o.firstChild;
        for (let s = this.depth; s >= 0; s--) {
          let { type: l, match: u } = this.frontier[s], c, d = null;
          if (n == 1 && (i ? u.matchType(i.type) || (d = u.fillBefore(_e.from(i), !1)) : a && l.compatibleContent(a.type)))
            return { sliceDepth: r, frontierDepth: s, parent: a, inject: d };
          if (n == 2 && i && (c = u.findWrapping(i.type)))
            return { sliceDepth: r, frontierDepth: s, parent: a, wrap: c };
          if (a && u.matchType(a.type))
            break;
        }
      }
  }
  openMore() {
    let { content: e, openStart: n, openEnd: r } = this.unplaced, o = Ld(e, n);
    return !o.childCount || o.firstChild.isLeaf ? !1 : (this.unplaced = new Pe(e, n + 1, Math.max(r, o.size + n >= e.size - r ? n + 1 : 0)), !0);
  }
  dropNode() {
    let { content: e, openStart: n, openEnd: r } = this.unplaced, o = Ld(e, n);
    if (o.childCount <= 1 && n > 0) {
      let a = e.size - n <= n + o.size;
      this.unplaced = new Pe(Ms(e, n - 1, 1), n - 1, a ? n - 1 : r);
    } else
      this.unplaced = new Pe(Ms(e, n, 1), n, r);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: e, frontierDepth: n, parent: r, inject: o, wrap: a }) {
    for (; this.depth > n; )
      this.closeFrontierNode();
    if (a)
      for (let g = 0; g < a.length; g++)
        this.openFrontierNode(a[g]);
    let i = this.unplaced, s = r ? r.content : i.content, l = i.openStart - e, u = 0, c = [], { match: d, type: f } = this.frontier[n];
    if (o) {
      for (let g = 0; g < o.childCount; g++)
        c.push(o.child(g));
      d = d.matchFragment(o);
    }
    let h = s.size + e - (i.content.size - i.openEnd);
    for (; u < s.childCount; ) {
      let g = s.child(u), y = d.matchType(g.type);
      if (!y)
        break;
      u++, (u > 1 || l == 0 || g.content.size) && (d = y, c.push(ew(g.mark(f.allowedMarks(g.marks)), u == 1 ? l : 0, u == s.childCount ? h : -1)));
    }
    let m = u == s.childCount;
    m || (h = -1), this.placed = Is(this.placed, n, _e.from(c)), this.frontier[n].match = d, m && h < 0 && r && r.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let g = 0, y = s; g < h; g++) {
      let b = y.lastChild;
      this.frontier.push({ type: b.type, match: b.contentMatchAt(b.childCount) }), y = b.content;
    }
    this.unplaced = m ? e == 0 ? Pe.empty : new Pe(Ms(i.content, e - 1, 1), e - 1, h < 0 ? i.openEnd : e - 1) : new Pe(Ms(i.content, e, u), i.openStart, i.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let e = this.frontier[this.depth], n;
    if (!e.type.isTextblock || !Bd(this.$to, this.$to.depth, e.type, e.match, !1) || this.$to.depth == this.depth && (n = this.findCloseLevel(this.$to)) && n.depth == this.depth)
      return -1;
    let { depth: r } = this.$to, o = this.$to.after(r);
    for (; r > 1 && o == this.$to.end(--r); )
      ++o;
    return o;
  }
  findCloseLevel(e) {
    e: for (let n = Math.min(this.depth, e.depth); n >= 0; n--) {
      let { match: r, type: o } = this.frontier[n], a = n < e.depth && e.end(n + 1) == e.pos + (e.depth - (n + 1)), i = Bd(e, n, o, r, a);
      if (i) {
        for (let s = n - 1; s >= 0; s--) {
          let { match: l, type: u } = this.frontier[s], c = Bd(e, s, u, l, !0);
          if (!c || c.childCount)
            continue e;
        }
        return { depth: n, fit: i, move: a ? e.doc.resolve(e.after(n + 1)) : e };
      }
    }
  }
  close(e) {
    let n = this.findCloseLevel(e);
    if (!n)
      return null;
    for (; this.depth > n.depth; )
      this.closeFrontierNode();
    n.fit.childCount && (this.placed = Is(this.placed, n.depth, n.fit)), e = n.move;
    for (let r = n.depth + 1; r <= e.depth; r++) {
      let o = e.node(r), a = o.type.contentMatch.fillBefore(o.content, !0, e.index(r));
      this.openFrontierNode(o.type, o.attrs, a);
    }
    return e;
  }
  openFrontierNode(e, n = null, r) {
    let o = this.frontier[this.depth];
    o.match = o.match.matchType(e), this.placed = Is(this.placed, this.depth, _e.from(e.create(n, r))), this.frontier.push({ type: e, match: e.contentMatch });
  }
  closeFrontierNode() {
    let n = this.frontier.pop().match.fillBefore(_e.empty, !0);
    n.childCount && (this.placed = Is(this.placed, this.frontier.length, n));
  }
}
function Ms(t, e, n) {
  return e == 0 ? t.cutByIndex(n, t.childCount) : t.replaceChild(0, t.firstChild.copy(Ms(t.firstChild.content, e - 1, n)));
}
function Is(t, e, n) {
  return e == 0 ? t.append(n) : t.replaceChild(t.childCount - 1, t.lastChild.copy(Is(t.lastChild.content, e - 1, n)));
}
function Ld(t, e) {
  for (let n = 0; n < e; n++)
    t = t.firstChild.content;
  return t;
}
function ew(t, e, n) {
  if (e <= 0)
    return t;
  let r = t.content;
  return e > 1 && (r = r.replaceChild(0, ew(r.firstChild, e - 1, r.childCount == 1 ? n - 1 : 0))), e > 0 && (r = t.type.contentMatch.fillBefore(r).append(r), n <= 0 && (r = r.append(t.type.contentMatch.matchFragment(r).fillBefore(_e.empty, !0)))), t.copy(r);
}
function Bd(t, e, n, r, o) {
  let a = t.node(e), i = o ? t.indexAfter(e) : t.index(e);
  if (i == a.childCount && !n.compatibleContent(a.type))
    return null;
  let s = r.fillBefore(a.content, !0, i);
  return s && !bL(n, a.content, i) ? s : null;
}
function bL(t, e, n) {
  for (let r = n; r < e.childCount; r++)
    if (!t.allowsMarks(e.child(r).marks))
      return !0;
  return !1;
}
function kL(t) {
  return t.spec.defining || t.spec.definingForContent;
}
function wL(t, e, n, r) {
  if (!r.size)
    return t.deleteRange(e, n);
  let o = t.doc.resolve(e), a = t.doc.resolve(n);
  if (Zk(o, a, r))
    return t.step(new ln(e, n, r));
  let i = nw(o, t.doc.resolve(n));
  i[i.length - 1] == 0 && i.pop();
  let s = -(o.depth + 1);
  i.unshift(s);
  for (let f = o.depth, h = o.pos - 1; f > 0; f--, h--) {
    let m = o.node(f).type.spec;
    if (m.defining || m.definingAsContext || m.isolating)
      break;
    i.indexOf(f) > -1 ? s = f : o.before(f) == h && i.splice(1, 0, -f);
  }
  let l = i.indexOf(s), u = [], c = r.openStart;
  for (let f = r.content, h = 0; ; h++) {
    let m = f.firstChild;
    if (u.push(m), h == r.openStart)
      break;
    f = m.content;
  }
  for (let f = c - 1; f >= 0; f--) {
    let h = u[f], m = kL(h.type);
    if (m && !h.sameMarkup(o.node(Math.abs(s) - 1)))
      c = f;
    else if (m || !h.type.isTextblock)
      break;
  }
  for (let f = r.openStart; f >= 0; f--) {
    let h = (f + c + 1) % (r.openStart + 1), m = u[h];
    if (m)
      for (let g = 0; g < i.length; g++) {
        let y = i[(g + l) % i.length], b = !0;
        y < 0 && (b = !1, y = -y);
        let C = o.node(y - 1), k = o.index(y - 1);
        if (C.canReplaceWith(k, k, m.type, m.marks))
          return t.replace(o.before(y), b ? a.after(y) : n, new Pe(tw(r.content, 0, r.openStart, h), h, r.openEnd));
      }
  }
  let d = t.steps.length;
  for (let f = i.length - 1; f >= 0 && (t.replace(e, n, r), !(t.steps.length > d)); f--) {
    let h = i[f];
    h < 0 || (e = o.before(h), n = a.after(h));
  }
}
function tw(t, e, n, r, o) {
  if (e < n) {
    let a = t.firstChild;
    t = t.replaceChild(0, a.copy(tw(a.content, e + 1, n, r, a)));
  }
  if (e > r) {
    let a = o.contentMatchAt(0), i = a.fillBefore(t).append(t);
    t = i.append(a.matchFragment(i).fillBefore(_e.empty, !0));
  }
  return t;
}
function _L(t, e, n, r) {
  if (!r.isInline && e == n && t.doc.resolve(e).parent.content.size) {
    let o = vL(t.doc, e, r.type);
    o != null && (e = n = o);
  }
  t.replaceRange(e, n, new Pe(_e.from(r), 0, 0));
}
function CL(t, e, n) {
  let r = t.doc.resolve(e), o = t.doc.resolve(n), a = nw(r, o);
  for (let i = 0; i < a.length; i++) {
    let s = a[i], l = i == a.length - 1;
    if (l && s == 0 || r.node(s).type.contentMatch.validEnd)
      return t.delete(r.start(s), o.end(s));
    if (s > 0 && (l || r.node(s - 1).canReplace(r.index(s - 1), o.indexAfter(s - 1))))
      return t.delete(r.before(s), o.after(s));
  }
  for (let i = 1; i <= r.depth && i <= o.depth; i++)
    if (e - r.start(i) == r.depth - i && n > r.end(i) && o.end(i) - n != o.depth - i && r.start(i - 1) == o.start(i - 1) && r.node(i - 1).canReplace(r.index(i - 1), o.index(i - 1)))
      return t.delete(r.before(i), n);
  t.delete(e, n);
}
function nw(t, e) {
  let n = [], r = Math.min(t.depth, e.depth);
  for (let o = r; o >= 0; o--) {
    let a = t.start(o);
    if (a < t.pos - (t.depth - o) || e.end(o) > e.pos + (e.depth - o) || t.node(o).type.spec.isolating || e.node(o).type.spec.isolating)
      break;
    (a == e.start(o) || o == t.depth && o == e.depth && t.parent.inlineContent && e.parent.inlineContent && o && e.start(o - 1) == a - 1) && n.push(o);
  }
  return n;
}
class Ri extends Tn {
  /**
  Construct an attribute step.
  */
  constructor(e, n, r) {
    super(), this.pos = e, this.attr = n, this.value = r;
  }
  apply(e) {
    let n = e.nodeAt(this.pos);
    if (!n)
      return Jt.fail("No node at attribute step's position");
    let r = /* @__PURE__ */ Object.create(null);
    for (let a in n.attrs)
      r[a] = n.attrs[a];
    r[this.attr] = this.value;
    let o = n.type.create(r, null, n.marks);
    return Jt.fromReplace(e, this.pos, this.pos + 1, new Pe(_e.from(o), 0, n.isLeaf ? 0 : 1));
  }
  getMap() {
    return Jn.empty;
  }
  invert(e) {
    return new Ri(this.pos, this.attr, e.nodeAt(this.pos).attrs[this.attr]);
  }
  map(e) {
    let n = e.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new Ri(n.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(e, n) {
    if (typeof n.pos != "number" || typeof n.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new Ri(n.pos, n.attr, n.value);
  }
}
Tn.jsonID("attr", Ri);
class cl extends Tn {
  /**
  Construct an attribute step.
  */
  constructor(e, n) {
    super(), this.attr = e, this.value = n;
  }
  apply(e) {
    let n = /* @__PURE__ */ Object.create(null);
    for (let o in e.attrs)
      n[o] = e.attrs[o];
    n[this.attr] = this.value;
    let r = e.type.create(n, e.content, e.marks);
    return Jt.ok(r);
  }
  getMap() {
    return Jn.empty;
  }
  invert(e) {
    return new cl(this.attr, e.attrs[this.attr]);
  }
  map(e) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(e, n) {
    if (typeof n.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new cl(n.attr, n.value);
  }
}
Tn.jsonID("docAttr", cl);
let Gi = class extends Error {
};
Gi = function t(e) {
  let n = Error.call(this, e);
  return n.__proto__ = t.prototype, n;
};
Gi.prototype = Object.create(Error.prototype);
Gi.prototype.constructor = Gi;
Gi.prototype.name = "TransformError";
class rw {
  /**
  Create a transform that starts with the given document.
  */
  constructor(e) {
    this.doc = e, this.steps = [], this.docs = [], this.mapping = new ul();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(e) {
    let n = this.maybeStep(e);
    if (n.failed)
      throw new Gi(n.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(e) {
    let n = e.apply(this.doc);
    return n.failed || this.addStep(e, n.doc), n;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  @internal
  */
  addStep(e, n) {
    this.docs.push(this.doc), this.steps.push(e), this.mapping.appendMap(e.getMap()), this.doc = n;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(e, n = e, r = Pe.empty) {
    let o = Gc(this.doc, e, n, r);
    return o && this.step(o), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(e, n, r) {
    return this.replace(e, n, new Pe(_e.from(r), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(e, n) {
    return this.replace(e, n, Pe.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(e, n) {
    return this.replaceWith(e, e, n);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(e, n, r) {
    return wL(this, e, n, r), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(e, n, r) {
    return _L(this, e, n, r), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(e, n) {
    return CL(this, e, n), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(e, n) {
    return sL(this, e, n), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(e, n = 1) {
    return gL(this, e, n), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(e, n) {
    return cL(this, e, n), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(e, n = e, r, o = null) {
    return dL(this, e, n, r, o), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(e, n, r = null, o) {
    return pL(this, e, n, r, o), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(e, n, r) {
    return this.step(new Ri(e, n, r)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(e, n) {
    return this.step(new cl(e, n)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(e, n) {
    return this.step(new Zo(e, n)), this;
  }
  /**
  Remove a mark (or all marks of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(e, n) {
    let r = this.doc.nodeAt(e);
    if (!r)
      throw new RangeError("No node at position " + e);
    if (n instanceof St)
      n.isInSet(r.marks) && this.step(new Qa(e, n));
    else {
      let o = r.marks, a, i = [];
      for (; a = n.isInSet(o); )
        i.push(new Qa(e, a)), o = a.removeFromSet(o);
      for (let s = i.length - 1; s >= 0; s--)
        this.step(i[s]);
    }
    return this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split (with the outermost nodes coming first).
  */
  split(e, n = 1, r) {
    return hL(this, e, n, r), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(e, n, r) {
    return oL(this, e, n, r), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(e, n, r) {
    return aL(this, e, n, r), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(e, n, r) {
    return Th(this, e, n, r), this;
  }
}
const Fd = /* @__PURE__ */ Object.create(null);
class at {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(e, n, r) {
    this.$anchor = e, this.$head = n, this.ranges = r || [new EL(e.min(n), e.max(n))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let e = this.ranges;
    for (let n = 0; n < e.length; n++)
      if (e[n].$from.pos != e[n].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(e, n = Pe.empty) {
    let r = n.content.lastChild, o = null;
    for (let s = 0; s < n.openEnd; s++)
      o = r, r = r.lastChild;
    let a = e.steps.length, i = this.ranges;
    for (let s = 0; s < i.length; s++) {
      let { $from: l, $to: u } = i[s], c = e.mapping.slice(a);
      e.replaceRange(c.map(l.pos), c.map(u.pos), s ? Pe.empty : n), s == 0 && ov(e, a, (r ? r.isInline : o && o.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(e, n) {
    let r = e.steps.length, o = this.ranges;
    for (let a = 0; a < o.length; a++) {
      let { $from: i, $to: s } = o[a], l = e.mapping.slice(r), u = l.map(i.pos), c = l.map(s.pos);
      a ? e.deleteRange(u, c) : (e.replaceRangeWith(u, c, n), ov(e, r, n.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(e, n, r = !1) {
    let o = e.parent.inlineContent ? new tt(e) : Ci(e.node(0), e.parent, e.pos, e.index(), n, r);
    if (o)
      return o;
    for (let a = e.depth - 1; a >= 0; a--) {
      let i = n < 0 ? Ci(e.node(0), e.node(a), e.before(a + 1), e.index(a), n, r) : Ci(e.node(0), e.node(a), e.after(a + 1), e.index(a) + 1, n, r);
      if (i)
        return i;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(e, n = 1) {
    return this.findFrom(e, n) || this.findFrom(e, -n) || new tr(e.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(e) {
    return Ci(e, e, 0, 0, 1) || new tr(e);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(e) {
    return Ci(e, e, e.content.size, e.childCount, -1) || new tr(e);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(e, n) {
    if (!n || !n.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let r = Fd[n.type];
    if (!r)
      throw new RangeError(`No selection type ${n.type} defined`);
    return r.fromJSON(e, n);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(e, n) {
    if (e in Fd)
      throw new RangeError("Duplicate use of selection JSON ID " + e);
    return Fd[e] = n, n.prototype.jsonID = e, n;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return tt.between(this.$anchor, this.$head).getBookmark();
  }
}
at.prototype.visible = !0;
class EL {
  /**
  Create a range.
  */
  constructor(e, n) {
    this.$from = e, this.$to = n;
  }
}
let nv = !1;
function rv(t) {
  !nv && !t.parent.inlineContent && (nv = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + t.parent.type.name + ")"));
}
class tt extends at {
  /**
  Construct a text selection between the given points.
  */
  constructor(e, n = e) {
    rv(e), rv(n), super(e, n);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(e, n) {
    let r = e.resolve(n.map(this.head));
    if (!r.parent.inlineContent)
      return at.near(r);
    let o = e.resolve(n.map(this.anchor));
    return new tt(o.parent.inlineContent ? o : r, r);
  }
  replace(e, n = Pe.empty) {
    if (super.replace(e, n), n == Pe.empty) {
      let r = this.$from.marksAcross(this.$to);
      r && e.ensureMarks(r);
    }
  }
  eq(e) {
    return e instanceof tt && e.anchor == this.anchor && e.head == this.head;
  }
  getBookmark() {
    return new Jc(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.anchor != "number" || typeof n.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new tt(e.resolve(n.anchor), e.resolve(n.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(e, n, r = n) {
    let o = e.resolve(n);
    return new this(o, r == n ? o : e.resolve(r));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(e, n, r) {
    let o = e.pos - n.pos;
    if ((!r || o) && (r = o >= 0 ? 1 : -1), !n.parent.inlineContent) {
      let a = at.findFrom(n, r, !0) || at.findFrom(n, -r, !0);
      if (a)
        n = a.$head;
      else
        return at.near(n, r);
    }
    return e.parent.inlineContent || (o == 0 ? e = n : (e = (at.findFrom(e, -r, !0) || at.findFrom(e, r, !0)).$anchor, e.pos < n.pos != o < 0 && (e = n))), new tt(e, n);
  }
}
at.jsonID("text", tt);
class Jc {
  constructor(e, n) {
    this.anchor = e, this.head = n;
  }
  map(e) {
    return new Jc(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    return tt.between(e.resolve(this.anchor), e.resolve(this.head));
  }
}
class je extends at {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(e) {
    let n = e.nodeAfter, r = e.node(0).resolve(e.pos + n.nodeSize);
    super(e, r), this.node = n;
  }
  map(e, n) {
    let { deleted: r, pos: o } = n.mapResult(this.anchor), a = e.resolve(o);
    return r ? at.near(a) : new je(a);
  }
  content() {
    return new Pe(_e.from(this.node), 0, 0);
  }
  eq(e) {
    return e instanceof je && e.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new xh(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new je(e.resolve(n.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(e, n) {
    return new je(e.resolve(n));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(e) {
    return !e.isText && e.type.spec.selectable !== !1;
  }
}
je.prototype.visible = !1;
at.jsonID("node", je);
class xh {
  constructor(e) {
    this.anchor = e;
  }
  map(e) {
    let { deleted: n, pos: r } = e.mapResult(this.anchor);
    return n ? new Jc(r, r) : new xh(r);
  }
  resolve(e) {
    let n = e.resolve(this.anchor), r = n.nodeAfter;
    return r && je.isSelectable(r) ? new je(n) : at.near(n);
  }
}
class tr extends at {
  /**
  Create an all-selection over the given document.
  */
  constructor(e) {
    super(e.resolve(0), e.resolve(e.content.size));
  }
  replace(e, n = Pe.empty) {
    if (n == Pe.empty) {
      e.delete(0, e.doc.content.size);
      let r = at.atStart(e.doc);
      r.eq(e.selection) || e.setSelection(r);
    } else
      super.replace(e, n);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(e) {
    return new tr(e);
  }
  map(e) {
    return new tr(e);
  }
  eq(e) {
    return e instanceof tr;
  }
  getBookmark() {
    return OL;
  }
}
at.jsonID("all", tr);
const OL = {
  map() {
    return this;
  },
  resolve(t) {
    return new tr(t);
  }
};
function Ci(t, e, n, r, o, a = !1) {
  if (e.inlineContent)
    return tt.create(t, n);
  for (let i = r - (o > 0 ? 0 : 1); o > 0 ? i < e.childCount : i >= 0; i += o) {
    let s = e.child(i);
    if (s.isAtom) {
      if (!a && je.isSelectable(s))
        return je.create(t, n - (o < 0 ? s.nodeSize : 0));
    } else {
      let l = Ci(t, s, n + o, o < 0 ? s.childCount : 0, o, a);
      if (l)
        return l;
    }
    n += s.nodeSize * o;
  }
  return null;
}
function ov(t, e, n) {
  let r = t.steps.length - 1;
  if (r < e)
    return;
  let o = t.steps[r];
  if (!(o instanceof ln || o instanceof un))
    return;
  let a = t.mapping.maps[r], i;
  a.forEach((s, l, u, c) => {
    i == null && (i = c);
  }), t.setSelection(at.near(t.doc.resolve(i), n));
}
const av = 1, iv = 2, sv = 4;
class TL extends rw {
  /**
  @internal
  */
  constructor(e) {
    super(e.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = e.selection, this.storedMarks = e.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(e) {
    if (e.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = e, this.curSelectionFor = this.steps.length, this.updated = (this.updated | av) & -3, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & av) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(e) {
    return this.storedMarks = e, this.updated |= iv, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(e) {
    return St.sameSet(this.storedMarks || this.selection.$from.marks(), e) || this.setStoredMarks(e), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(e) {
    return this.ensureMarks(e.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(e) {
    return this.ensureMarks(e.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & iv) > 0;
  }
  /**
  @internal
  */
  addStep(e, n) {
    super.addStep(e, n), this.updated = this.updated & -3, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(e) {
    return this.time = e, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(e) {
    return this.selection.replace(this, e), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(e, n = !0) {
    let r = this.selection;
    return n && (e = e.mark(this.storedMarks || (r.empty ? r.$from.marks() : r.$from.marksAcross(r.$to) || St.none))), r.replaceWith(this, e), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(e, n, r) {
    let o = this.doc.type.schema;
    if (n == null)
      return e ? this.replaceSelectionWith(o.text(e), !0) : this.deleteSelection();
    {
      if (r == null && (r = n), r = r ?? n, !e)
        return this.deleteRange(n, r);
      let a = this.storedMarks;
      if (!a) {
        let i = this.doc.resolve(n);
        a = r == n ? i.marks() : i.marksAcross(this.doc.resolve(r));
      }
      return this.replaceRangeWith(n, r, o.text(e, a)), this.selection.empty || this.setSelection(at.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(e, n) {
    return this.meta[typeof e == "string" ? e : e.key] = n, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(e) {
    return this.meta[typeof e == "string" ? e : e.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let e in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= sv, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & sv) > 0;
  }
}
function lv(t, e) {
  return !e || !t ? t : t.bind(e);
}
class Ds {
  constructor(e, n, r) {
    this.name = e, this.init = lv(n.init, r), this.apply = lv(n.apply, r);
  }
}
const SL = [
  new Ds("doc", {
    init(t) {
      return t.doc || t.schema.topNodeType.createAndFill();
    },
    apply(t) {
      return t.doc;
    }
  }),
  new Ds("selection", {
    init(t, e) {
      return t.selection || at.atStart(e.doc);
    },
    apply(t) {
      return t.selection;
    }
  }),
  new Ds("storedMarks", {
    init(t) {
      return t.storedMarks || null;
    },
    apply(t, e, n, r) {
      return r.selection.$cursor ? t.storedMarks : null;
    }
  }),
  new Ds("scrollToSelection", {
    init() {
      return 0;
    },
    apply(t, e) {
      return t.scrolledIntoView ? e + 1 : e;
    }
  })
];
class Vd {
  constructor(e, n) {
    this.schema = e, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = SL.slice(), n && n.forEach((r) => {
      if (this.pluginsByKey[r.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + r.key + ")");
      this.plugins.push(r), this.pluginsByKey[r.key] = r, r.spec.state && this.fields.push(new Ds(r.key, r.spec.state, r));
    });
  }
}
class Ii {
  /**
  @internal
  */
  constructor(e) {
    this.config = e;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(e) {
    return this.applyTransaction(e).state;
  }
  /**
  @internal
  */
  filterTransaction(e, n = -1) {
    for (let r = 0; r < this.config.plugins.length; r++)
      if (r != n) {
        let o = this.config.plugins[r];
        if (o.spec.filterTransaction && !o.spec.filterTransaction.call(o, e, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(e) {
    if (!this.filterTransaction(e))
      return { state: this, transactions: [] };
    let n = [e], r = this.applyInner(e), o = null;
    for (; ; ) {
      let a = !1;
      for (let i = 0; i < this.config.plugins.length; i++) {
        let s = this.config.plugins[i];
        if (s.spec.appendTransaction) {
          let l = o ? o[i].n : 0, u = o ? o[i].state : this, c = l < n.length && s.spec.appendTransaction.call(s, l ? n.slice(l) : n, u, r);
          if (c && r.filterTransaction(c, i)) {
            if (c.setMeta("appendedTransaction", e), !o) {
              o = [];
              for (let d = 0; d < this.config.plugins.length; d++)
                o.push(d < i ? { state: r, n: n.length } : { state: this, n: 0 });
            }
            n.push(c), r = r.applyInner(c), a = !0;
          }
          o && (o[i] = { state: r, n: n.length });
        }
      }
      if (!a)
        return { state: r, transactions: n };
    }
  }
  /**
  @internal
  */
  applyInner(e) {
    if (!e.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let n = new Ii(this.config), r = this.config.fields;
    for (let o = 0; o < r.length; o++) {
      let a = r[o];
      n[a.name] = a.apply(e, this[a.name], this, n);
    }
    return n;
  }
  /**
  Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new TL(this);
  }
  /**
  Create a new state.
  */
  static create(e) {
    let n = new Vd(e.doc ? e.doc.type.schema : e.schema, e.plugins), r = new Ii(n);
    for (let o = 0; o < n.fields.length; o++)
      r[n.fields[o].name] = n.fields[o].init(e, r);
    return r;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(e) {
    let n = new Vd(this.schema, e.plugins), r = n.fields, o = new Ii(n);
    for (let a = 0; a < r.length; a++) {
      let i = r[a].name;
      o[i] = this.hasOwnProperty(i) ? this[i] : r[a].init(e, o);
    }
    return o;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(e) {
    let n = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (n.storedMarks = this.storedMarks.map((r) => r.toJSON())), e && typeof e == "object")
      for (let r in e) {
        if (r == "doc" || r == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let o = e[r], a = o.spec.state;
        a && a.toJSON && (n[r] = a.toJSON.call(o, this[o.key]));
      }
    return n;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(e, n, r) {
    if (!n)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!e.schema)
      throw new RangeError("Required config field 'schema' missing");
    let o = new Vd(e.schema, e.plugins), a = new Ii(o);
    return o.fields.forEach((i) => {
      if (i.name == "doc")
        a.doc = ra.fromJSON(e.schema, n.doc);
      else if (i.name == "selection")
        a.selection = at.fromJSON(a.doc, n.selection);
      else if (i.name == "storedMarks")
        n.storedMarks && (a.storedMarks = n.storedMarks.map(e.schema.markFromJSON));
      else {
        if (r)
          for (let s in r) {
            let l = r[s], u = l.spec.state;
            if (l.key == i.name && u && u.fromJSON && Object.prototype.hasOwnProperty.call(n, s)) {
              a[i.name] = u.fromJSON.call(l, e, n[s], a);
              return;
            }
          }
        a[i.name] = i.init(e, a);
      }
    }), a;
  }
}
function ow(t, e, n) {
  for (let r in t) {
    let o = t[r];
    o instanceof Function ? o = o.bind(e) : r == "handleDOMEvents" && (o = ow(o, e, {})), n[r] = o;
  }
  return n;
}
class rn {
  /**
  Create a plugin.
  */
  constructor(e) {
    this.spec = e, this.props = {}, e.props && ow(e.props, this, this.props), this.key = e.key ? e.key.key : aw("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const Hd = /* @__PURE__ */ Object.create(null);
function aw(t) {
  return t in Hd ? t + "$" + ++Hd[t] : (Hd[t] = 0, t + "$");
}
class Fn {
  /**
  Create a plugin key.
  */
  constructor(e = "key") {
    this.key = aw(e);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(e) {
    return e.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const hn = function(t) {
  for (var e = 0; ; e++)
    if (t = t.previousSibling, !t)
      return e;
}, Ji = function(t) {
  let e = t.assignedSlot || t.parentNode;
  return e && e.nodeType == 11 ? e.host : e;
};
let Gf = null;
const _o = function(t, e, n) {
  let r = Gf || (Gf = document.createRange());
  return r.setEnd(t, n ?? t.nodeValue.length), r.setStart(t, e || 0), r;
}, xL = function() {
  Gf = null;
}, Za = function(t, e, n, r) {
  return n && (uv(t, e, n, r, -1) || uv(t, e, n, r, 1));
}, AL = /^(img|br|input|textarea|hr)$/i;
function uv(t, e, n, r, o) {
  for (; ; ) {
    if (t == n && e == r)
      return !0;
    if (e == (o < 0 ? 0 : cr(t))) {
      let a = t.parentNode;
      if (!a || a.nodeType != 1 || Bl(t) || AL.test(t.nodeName) || t.contentEditable == "false")
        return !1;
      e = hn(t) + (o < 0 ? 0 : 1), t = a;
    } else if (t.nodeType == 1) {
      if (t = t.childNodes[e + (o < 0 ? -1 : 0)], t.contentEditable == "false")
        return !1;
      e = o < 0 ? cr(t) : 0;
    } else
      return !1;
  }
}
function cr(t) {
  return t.nodeType == 3 ? t.nodeValue.length : t.childNodes.length;
}
function ML(t, e) {
  for (; ; ) {
    if (t.nodeType == 3 && e)
      return t;
    if (t.nodeType == 1 && e > 0) {
      if (t.contentEditable == "false")
        return null;
      t = t.childNodes[e - 1], e = cr(t);
    } else if (t.parentNode && !Bl(t))
      e = hn(t), t = t.parentNode;
    else
      return null;
  }
}
function IL(t, e) {
  for (; ; ) {
    if (t.nodeType == 3 && e < t.nodeValue.length)
      return t;
    if (t.nodeType == 1 && e < t.childNodes.length) {
      if (t.contentEditable == "false")
        return null;
      t = t.childNodes[e], e = 0;
    } else if (t.parentNode && !Bl(t))
      e = hn(t) + 1, t = t.parentNode;
    else
      return null;
  }
}
function DL(t, e, n) {
  for (let r = e == 0, o = e == cr(t); r || o; ) {
    if (t == n)
      return !0;
    let a = hn(t);
    if (t = t.parentNode, !t)
      return !1;
    r = r && a == 0, o = o && a == cr(t);
  }
}
function Bl(t) {
  let e;
  for (let n = t; n && !(e = n.pmViewDesc); n = n.parentNode)
    ;
  return e && e.node && e.node.isBlock && (e.dom == t || e.contentDOM == t);
}
const Xc = function(t) {
  return t.focusNode && Za(t.focusNode, t.focusOffset, t.anchorNode, t.anchorOffset);
};
function Ia(t, e) {
  let n = document.createEvent("Event");
  return n.initEvent("keydown", !0, !0), n.keyCode = t, n.key = n.code = e, n;
}
function PL(t) {
  let e = t.activeElement;
  for (; e && e.shadowRoot; )
    e = e.shadowRoot.activeElement;
  return e;
}
function NL(t, e, n) {
  if (t.caretPositionFromPoint)
    try {
      let r = t.caretPositionFromPoint(e, n);
      if (r)
        return { node: r.offsetNode, offset: Math.min(cr(r.offsetNode), r.offset) };
    } catch {
    }
  if (t.caretRangeFromPoint) {
    let r = t.caretRangeFromPoint(e, n);
    if (r)
      return { node: r.startContainer, offset: Math.min(cr(r.startContainer), r.startOffset) };
  }
}
const ao = typeof navigator < "u" ? navigator : null, cv = typeof document < "u" ? document : null, _a = ao && ao.userAgent || "", Jf = /Edge\/(\d+)/.exec(_a), iw = /MSIE \d/.exec(_a), Xf = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(_a), zn = !!(iw || Xf || Jf), aa = iw ? document.documentMode : Xf ? +Xf[1] : Jf ? +Jf[1] : 0, $r = !zn && /gecko\/(\d+)/i.test(_a);
$r && +(/Firefox\/(\d+)/.exec(_a) || [0, 0])[1];
const Qf = !zn && /Chrome\/(\d+)/.exec(_a), _n = !!Qf, sw = Qf ? +Qf[1] : 0, Rn = !zn && !!ao && /Apple Computer/.test(ao.vendor), Xi = Rn && (/Mobile\/\w+/.test(_a) || !!ao && ao.maxTouchPoints > 2), lr = Xi || (ao ? /Mac/.test(ao.platform) : !1), $L = ao ? /Win/.test(ao.platform) : !1, So = /Android \d/.test(_a), Fl = !!cv && "webkitFontSmoothing" in cv.documentElement.style, RL = Fl ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function LL(t) {
  let e = t.defaultView && t.defaultView.visualViewport;
  return e ? {
    left: 0,
    right: e.width,
    top: 0,
    bottom: e.height
  } : {
    left: 0,
    right: t.documentElement.clientWidth,
    top: 0,
    bottom: t.documentElement.clientHeight
  };
}
function yo(t, e) {
  return typeof t == "number" ? t : t[e];
}
function BL(t) {
  let e = t.getBoundingClientRect(), n = e.width / t.offsetWidth || 1, r = e.height / t.offsetHeight || 1;
  return {
    left: e.left,
    right: e.left + t.clientWidth * n,
    top: e.top,
    bottom: e.top + t.clientHeight * r
  };
}
function dv(t, e, n) {
  let r = t.someProp("scrollThreshold") || 0, o = t.someProp("scrollMargin") || 5, a = t.dom.ownerDocument;
  for (let i = n || t.dom; i; ) {
    if (i.nodeType != 1) {
      i = Ji(i);
      continue;
    }
    let s = i, l = s == a.body, u = l ? LL(a) : BL(s), c = 0, d = 0;
    if (e.top < u.top + yo(r, "top") ? d = -(u.top - e.top + yo(o, "top")) : e.bottom > u.bottom - yo(r, "bottom") && (d = e.bottom - e.top > u.bottom - u.top ? e.top + yo(o, "top") - u.top : e.bottom - u.bottom + yo(o, "bottom")), e.left < u.left + yo(r, "left") ? c = -(u.left - e.left + yo(o, "left")) : e.right > u.right - yo(r, "right") && (c = e.right - u.right + yo(o, "right")), c || d)
      if (l)
        a.defaultView.scrollBy(c, d);
      else {
        let h = s.scrollLeft, m = s.scrollTop;
        d && (s.scrollTop += d), c && (s.scrollLeft += c);
        let g = s.scrollLeft - h, y = s.scrollTop - m;
        e = { left: e.left - g, top: e.top - y, right: e.right - g, bottom: e.bottom - y };
      }
    let f = l ? "fixed" : getComputedStyle(i).position;
    if (/^(fixed|sticky)$/.test(f))
      break;
    i = f == "absolute" ? i.offsetParent : Ji(i);
  }
}
function FL(t) {
  let e = t.dom.getBoundingClientRect(), n = Math.max(0, e.top), r, o;
  for (let a = (e.left + e.right) / 2, i = n + 1; i < Math.min(innerHeight, e.bottom); i += 5) {
    let s = t.root.elementFromPoint(a, i);
    if (!s || s == t.dom || !t.dom.contains(s))
      continue;
    let l = s.getBoundingClientRect();
    if (l.top >= n - 20) {
      r = s, o = l.top;
      break;
    }
  }
  return { refDOM: r, refTop: o, stack: lw(t.dom) };
}
function lw(t) {
  let e = [], n = t.ownerDocument;
  for (let r = t; r && (e.push({ dom: r, top: r.scrollTop, left: r.scrollLeft }), t != n); r = Ji(r))
    ;
  return e;
}
function VL({ refDOM: t, refTop: e, stack: n }) {
  let r = t ? t.getBoundingClientRect().top : 0;
  uw(n, r == 0 ? 0 : r - e);
}
function uw(t, e) {
  for (let n = 0; n < t.length; n++) {
    let { dom: r, top: o, left: a } = t[n];
    r.scrollTop != o + e && (r.scrollTop = o + e), r.scrollLeft != a && (r.scrollLeft = a);
  }
}
let vi = null;
function HL(t) {
  if (t.setActive)
    return t.setActive();
  if (vi)
    return t.focus(vi);
  let e = lw(t);
  t.focus(vi == null ? {
    get preventScroll() {
      return vi = { preventScroll: !0 }, !0;
    }
  } : void 0), vi || (vi = !1, uw(e, 0));
}
function cw(t, e) {
  let n, r = 2e8, o, a = 0, i = e.top, s = e.top, l, u;
  for (let c = t.firstChild, d = 0; c; c = c.nextSibling, d++) {
    let f;
    if (c.nodeType == 1)
      f = c.getClientRects();
    else if (c.nodeType == 3)
      f = _o(c).getClientRects();
    else
      continue;
    for (let h = 0; h < f.length; h++) {
      let m = f[h];
      if (m.top <= i && m.bottom >= s) {
        i = Math.max(m.bottom, i), s = Math.min(m.top, s);
        let g = m.left > e.left ? m.left - e.left : m.right < e.left ? e.left - m.right : 0;
        if (g < r) {
          n = c, r = g, o = g && n.nodeType == 3 ? {
            left: m.right < e.left ? m.right : m.left,
            top: e.top
          } : e, c.nodeType == 1 && g && (a = d + (e.left >= (m.left + m.right) / 2 ? 1 : 0));
          continue;
        }
      } else m.top > e.top && !l && m.left <= e.left && m.right >= e.left && (l = c, u = { left: Math.max(m.left, Math.min(m.right, e.left)), top: m.top });
      !n && (e.left >= m.right && e.top >= m.top || e.left >= m.left && e.top >= m.bottom) && (a = d + 1);
    }
  }
  return !n && l && (n = l, o = u, r = 0), n && n.nodeType == 3 ? UL(n, o) : !n || r && n.nodeType == 1 ? { node: t, offset: a } : cw(n, o);
}
function UL(t, e) {
  let n = t.nodeValue.length, r = document.createRange();
  for (let o = 0; o < n; o++) {
    r.setEnd(t, o + 1), r.setStart(t, o);
    let a = jo(r, 1);
    if (a.top != a.bottom && Ah(e, a))
      return { node: t, offset: o + (e.left >= (a.left + a.right) / 2 ? 1 : 0) };
  }
  return { node: t, offset: 0 };
}
function Ah(t, e) {
  return t.left >= e.left - 1 && t.left <= e.right + 1 && t.top >= e.top - 1 && t.top <= e.bottom + 1;
}
function WL(t, e) {
  let n = t.parentNode;
  return n && /^li$/i.test(n.nodeName) && e.left < t.getBoundingClientRect().left ? n : t;
}
function KL(t, e, n) {
  let { node: r, offset: o } = cw(e, n), a = -1;
  if (r.nodeType == 1 && !r.firstChild) {
    let i = r.getBoundingClientRect();
    a = i.left != i.right && n.left > (i.left + i.right) / 2 ? 1 : -1;
  }
  return t.docView.posFromDOM(r, o, a);
}
function jL(t, e, n, r) {
  let o = -1;
  for (let a = e, i = !1; a != t.dom; ) {
    let s = t.docView.nearestDesc(a, !0), l;
    if (!s)
      return null;
    if (s.dom.nodeType == 1 && (s.node.isBlock && s.parent || !s.contentDOM) && // Ignore elements with zero-size bounding rectangles
    ((l = s.dom.getBoundingClientRect()).width || l.height) && (s.node.isBlock && s.parent && (!i && l.left > r.left || l.top > r.top ? o = s.posBefore : (!i && l.right < r.left || l.bottom < r.top) && (o = s.posAfter), i = !0), !s.contentDOM && o < 0 && !s.node.isText))
      return (s.node.isBlock ? r.top < (l.top + l.bottom) / 2 : r.left < (l.left + l.right) / 2) ? s.posBefore : s.posAfter;
    a = s.dom.parentNode;
  }
  return o > -1 ? o : t.docView.posFromDOM(e, n, -1);
}
function dw(t, e, n) {
  let r = t.childNodes.length;
  if (r && n.top < n.bottom)
    for (let o = Math.max(0, Math.min(r - 1, Math.floor(r * (e.top - n.top) / (n.bottom - n.top)) - 2)), a = o; ; ) {
      let i = t.childNodes[a];
      if (i.nodeType == 1) {
        let s = i.getClientRects();
        for (let l = 0; l < s.length; l++) {
          let u = s[l];
          if (Ah(e, u))
            return dw(i, e, u);
        }
      }
      if ((a = (a + 1) % r) == o)
        break;
    }
  return t;
}
function zL(t, e) {
  let n = t.dom.ownerDocument, r, o = 0, a = NL(n, e.left, e.top);
  a && ({ node: r, offset: o } = a);
  let i = (t.root.elementFromPoint ? t.root : n).elementFromPoint(e.left, e.top), s;
  if (!i || !t.dom.contains(i.nodeType != 1 ? i.parentNode : i)) {
    let u = t.dom.getBoundingClientRect();
    if (!Ah(e, u) || (i = dw(t.dom, e, u), !i))
      return null;
  }
  if (Rn)
    for (let u = i; r && u; u = Ji(u))
      u.draggable && (r = void 0);
  if (i = WL(i, e), r) {
    if ($r && r.nodeType == 1 && (o = Math.min(o, r.childNodes.length), o < r.childNodes.length)) {
      let c = r.childNodes[o], d;
      c.nodeName == "IMG" && (d = c.getBoundingClientRect()).right <= e.left && d.bottom > e.top && o++;
    }
    let u;
    Fl && o && r.nodeType == 1 && (u = r.childNodes[o - 1]).nodeType == 1 && u.contentEditable == "false" && u.getBoundingClientRect().top >= e.top && o--, r == t.dom && o == r.childNodes.length - 1 && r.lastChild.nodeType == 1 && e.top > r.lastChild.getBoundingClientRect().bottom ? s = t.state.doc.content.size : (o == 0 || r.nodeType != 1 || r.childNodes[o - 1].nodeName != "BR") && (s = jL(t, r, o, e));
  }
  s == null && (s = KL(t, i, e));
  let l = t.docView.nearestDesc(i, !0);
  return { pos: s, inside: l ? l.posAtStart - l.border : -1 };
}
function fv(t) {
  return t.top < t.bottom || t.left < t.right;
}
function jo(t, e) {
  let n = t.getClientRects();
  if (n.length) {
    let r = n[e < 0 ? 0 : n.length - 1];
    if (fv(r))
      return r;
  }
  return Array.prototype.find.call(n, fv) || t.getBoundingClientRect();
}
const YL = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function fw(t, e, n) {
  let { node: r, offset: o, atom: a } = t.docView.domFromPos(e, n < 0 ? -1 : 1), i = Fl || $r;
  if (r.nodeType == 3)
    if (i && (YL.test(r.nodeValue) || (n < 0 ? !o : o == r.nodeValue.length))) {
      let l = jo(_o(r, o, o), n);
      if ($r && o && /\s/.test(r.nodeValue[o - 1]) && o < r.nodeValue.length) {
        let u = jo(_o(r, o - 1, o - 1), -1);
        if (u.top == l.top) {
          let c = jo(_o(r, o, o + 1), -1);
          if (c.top != l.top)
            return Ts(c, c.left < u.left);
        }
      }
      return l;
    } else {
      let l = o, u = o, c = n < 0 ? 1 : -1;
      return n < 0 && !o ? (u++, c = -1) : n >= 0 && o == r.nodeValue.length ? (l--, c = 1) : n < 0 ? l-- : u++, Ts(jo(_o(r, l, u), c), c < 0);
    }
  if (!t.state.doc.resolve(e - (a || 0)).parent.inlineContent) {
    if (a == null && o && (n < 0 || o == cr(r))) {
      let l = r.childNodes[o - 1];
      if (l.nodeType == 1)
        return Ud(l.getBoundingClientRect(), !1);
    }
    if (a == null && o < cr(r)) {
      let l = r.childNodes[o];
      if (l.nodeType == 1)
        return Ud(l.getBoundingClientRect(), !0);
    }
    return Ud(r.getBoundingClientRect(), n >= 0);
  }
  if (a == null && o && (n < 0 || o == cr(r))) {
    let l = r.childNodes[o - 1], u = l.nodeType == 3 ? _o(l, cr(l) - (i ? 0 : 1)) : l.nodeType == 1 && (l.nodeName != "BR" || !l.nextSibling) ? l : null;
    if (u)
      return Ts(jo(u, 1), !1);
  }
  if (a == null && o < cr(r)) {
    let l = r.childNodes[o];
    for (; l.pmViewDesc && l.pmViewDesc.ignoreForCoords; )
      l = l.nextSibling;
    let u = l ? l.nodeType == 3 ? _o(l, 0, i ? 0 : 1) : l.nodeType == 1 ? l : null : null;
    if (u)
      return Ts(jo(u, -1), !0);
  }
  return Ts(jo(r.nodeType == 3 ? _o(r) : r, -n), n >= 0);
}
function Ts(t, e) {
  if (t.width == 0)
    return t;
  let n = e ? t.left : t.right;
  return { top: t.top, bottom: t.bottom, left: n, right: n };
}
function Ud(t, e) {
  if (t.height == 0)
    return t;
  let n = e ? t.top : t.bottom;
  return { top: n, bottom: n, left: t.left, right: t.right };
}
function pw(t, e, n) {
  let r = t.state, o = t.root.activeElement;
  r != e && t.updateState(e), o != t.dom && t.focus();
  try {
    return n();
  } finally {
    r != e && t.updateState(r), o != t.dom && o && o.focus();
  }
}
function qL(t, e, n) {
  let r = e.selection, o = n == "up" ? r.$from : r.$to;
  return pw(t, e, () => {
    let { node: a } = t.docView.domFromPos(o.pos, n == "up" ? -1 : 1);
    for (; ; ) {
      let s = t.docView.nearestDesc(a, !0);
      if (!s)
        break;
      if (s.node.isBlock) {
        a = s.contentDOM || s.dom;
        break;
      }
      a = s.dom.parentNode;
    }
    let i = fw(t, o.pos, 1);
    for (let s = a.firstChild; s; s = s.nextSibling) {
      let l;
      if (s.nodeType == 1)
        l = s.getClientRects();
      else if (s.nodeType == 3)
        l = _o(s, 0, s.nodeValue.length).getClientRects();
      else
        continue;
      for (let u = 0; u < l.length; u++) {
        let c = l[u];
        if (c.bottom > c.top + 1 && (n == "up" ? i.top - c.top > (c.bottom - i.top) * 2 : c.bottom - i.bottom > (i.bottom - c.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const GL = /[\u0590-\u08ac]/;
function JL(t, e, n) {
  let { $head: r } = e.selection;
  if (!r.parent.isTextblock)
    return !1;
  let o = r.parentOffset, a = !o, i = o == r.parent.content.size, s = t.domSelection();
  return s ? !GL.test(r.parent.textContent) || !s.modify ? n == "left" || n == "backward" ? a : i : pw(t, e, () => {
    let { focusNode: l, focusOffset: u, anchorNode: c, anchorOffset: d } = t.domSelectionRange(), f = s.caretBidiLevel;
    s.modify("move", n, "character");
    let h = r.depth ? t.docView.domAfterPos(r.before()) : t.dom, { focusNode: m, focusOffset: g } = t.domSelectionRange(), y = m && !h.contains(m.nodeType == 1 ? m : m.parentNode) || l == m && u == g;
    try {
      s.collapse(c, d), l && (l != c || u != d) && s.extend && s.extend(l, u);
    } catch {
    }
    return f != null && (s.caretBidiLevel = f), y;
  }) : r.pos == r.start() || r.pos == r.end();
}
let pv = null, hv = null, mv = !1;
function XL(t, e, n) {
  return pv == e && hv == n ? mv : (pv = e, hv = n, mv = n == "up" || n == "down" ? qL(t, e, n) : JL(t, e, n));
}
const pr = 0, gv = 1, Na = 2, io = 3;
class Vl {
  constructor(e, n, r, o) {
    this.parent = e, this.children = n, this.dom = r, this.contentDOM = o, this.dirty = pr, r.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(e) {
    return !1;
  }
  matchesMark(e) {
    return !1;
  }
  matchesNode(e, n, r) {
    return !1;
  }
  matchesHack(e) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(e) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let e = 0;
    for (let n = 0; n < this.children.length; n++)
      e += this.children[n].size;
    return e;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let e = 0; e < this.children.length; e++)
      this.children[e].destroy();
  }
  posBeforeChild(e) {
    for (let n = 0, r = this.posAtStart; ; n++) {
      let o = this.children[n];
      if (o == e)
        return r;
      r += o.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(e, n, r) {
    if (this.contentDOM && this.contentDOM.contains(e.nodeType == 1 ? e : e.parentNode))
      if (r < 0) {
        let a, i;
        if (e == this.contentDOM)
          a = e.childNodes[n - 1];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          a = e.previousSibling;
        }
        for (; a && !((i = a.pmViewDesc) && i.parent == this); )
          a = a.previousSibling;
        return a ? this.posBeforeChild(i) + i.size : this.posAtStart;
      } else {
        let a, i;
        if (e == this.contentDOM)
          a = e.childNodes[n];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          a = e.nextSibling;
        }
        for (; a && !((i = a.pmViewDesc) && i.parent == this); )
          a = a.nextSibling;
        return a ? this.posBeforeChild(i) : this.posAtEnd;
      }
    let o;
    if (e == this.dom && this.contentDOM)
      o = n > hn(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      o = e.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (n == 0)
        for (let a = e; ; a = a.parentNode) {
          if (a == this.dom) {
            o = !1;
            break;
          }
          if (a.previousSibling)
            break;
        }
      if (o == null && n == e.childNodes.length)
        for (let a = e; ; a = a.parentNode) {
          if (a == this.dom) {
            o = !0;
            break;
          }
          if (a.nextSibling)
            break;
        }
    }
    return o ?? r > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(e, n = !1) {
    for (let r = !0, o = e; o; o = o.parentNode) {
      let a = this.getDesc(o), i;
      if (a && (!n || a.node))
        if (r && (i = a.nodeDOM) && !(i.nodeType == 1 ? i.contains(e.nodeType == 1 ? e : e.parentNode) : i == e))
          r = !1;
        else
          return a;
    }
  }
  getDesc(e) {
    let n = e.pmViewDesc;
    for (let r = n; r; r = r.parent)
      if (r == this)
        return n;
  }
  posFromDOM(e, n, r) {
    for (let o = e; o; o = o.parentNode) {
      let a = this.getDesc(o);
      if (a)
        return a.localPosFromDOM(e, n, r);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(e) {
    for (let n = 0, r = 0; n < this.children.length; n++) {
      let o = this.children[n], a = r + o.size;
      if (r == e && a != r) {
        for (; !o.border && o.children.length; )
          for (let i = 0; i < o.children.length; i++) {
            let s = o.children[i];
            if (s.size) {
              o = s;
              break;
            }
          }
        return o;
      }
      if (e < a)
        return o.descAt(e - r - o.border);
      r = a;
    }
  }
  domFromPos(e, n) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: e + 1 };
    let r = 0, o = 0;
    for (let a = 0; r < this.children.length; r++) {
      let i = this.children[r], s = a + i.size;
      if (s > e || i instanceof mw) {
        o = e - a;
        break;
      }
      a = s;
    }
    if (o)
      return this.children[r].domFromPos(o - this.children[r].border, n);
    for (let a; r && !(a = this.children[r - 1]).size && a instanceof hw && a.side >= 0; r--)
      ;
    if (n <= 0) {
      let a, i = !0;
      for (; a = r ? this.children[r - 1] : null, !(!a || a.dom.parentNode == this.contentDOM); r--, i = !1)
        ;
      return a && n && i && !a.border && !a.domAtom ? a.domFromPos(a.size, n) : { node: this.contentDOM, offset: a ? hn(a.dom) + 1 : 0 };
    } else {
      let a, i = !0;
      for (; a = r < this.children.length ? this.children[r] : null, !(!a || a.dom.parentNode == this.contentDOM); r++, i = !1)
        ;
      return a && i && !a.border && !a.domAtom ? a.domFromPos(0, n) : { node: this.contentDOM, offset: a ? hn(a.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(e, n, r = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: e, to: n, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let o = -1, a = -1;
    for (let i = r, s = 0; ; s++) {
      let l = this.children[s], u = i + l.size;
      if (o == -1 && e <= u) {
        let c = i + l.border;
        if (e >= c && n <= u - l.border && l.node && l.contentDOM && this.contentDOM.contains(l.contentDOM))
          return l.parseRange(e, n, c);
        e = i;
        for (let d = s; d > 0; d--) {
          let f = this.children[d - 1];
          if (f.size && f.dom.parentNode == this.contentDOM && !f.emptyChildAt(1)) {
            o = hn(f.dom) + 1;
            break;
          }
          e -= f.size;
        }
        o == -1 && (o = 0);
      }
      if (o > -1 && (u > n || s == this.children.length - 1)) {
        n = u;
        for (let c = s + 1; c < this.children.length; c++) {
          let d = this.children[c];
          if (d.size && d.dom.parentNode == this.contentDOM && !d.emptyChildAt(-1)) {
            a = hn(d.dom);
            break;
          }
          n += d.size;
        }
        a == -1 && (a = this.contentDOM.childNodes.length);
        break;
      }
      i = u;
    }
    return { node: this.contentDOM, from: e, to: n, fromOffset: o, toOffset: a };
  }
  emptyChildAt(e) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let n = this.children[e < 0 ? 0 : this.children.length - 1];
    return n.size == 0 || n.emptyChildAt(e);
  }
  domAfterPos(e) {
    let { node: n, offset: r } = this.domFromPos(e, 0);
    if (n.nodeType != 1 || r == n.childNodes.length)
      throw new RangeError("No node after pos " + e);
    return n.childNodes[r];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(e, n, r, o = !1) {
    let a = Math.min(e, n), i = Math.max(e, n);
    for (let h = 0, m = 0; h < this.children.length; h++) {
      let g = this.children[h], y = m + g.size;
      if (a > m && i < y)
        return g.setSelection(e - m - g.border, n - m - g.border, r, o);
      m = y;
    }
    let s = this.domFromPos(e, e ? -1 : 1), l = n == e ? s : this.domFromPos(n, n ? -1 : 1), u = r.root.getSelection(), c = r.domSelectionRange(), d = !1;
    if (($r || Rn) && e == n) {
      let { node: h, offset: m } = s;
      if (h.nodeType == 3) {
        if (d = !!(m && h.nodeValue[m - 1] == `
`), d && m == h.nodeValue.length)
          for (let g = h, y; g; g = g.parentNode) {
            if (y = g.nextSibling) {
              y.nodeName == "BR" && (s = l = { node: y.parentNode, offset: hn(y) + 1 });
              break;
            }
            let b = g.pmViewDesc;
            if (b && b.node && b.node.isBlock)
              break;
          }
      } else {
        let g = h.childNodes[m - 1];
        d = g && (g.nodeName == "BR" || g.contentEditable == "false");
      }
    }
    if ($r && c.focusNode && c.focusNode != l.node && c.focusNode.nodeType == 1) {
      let h = c.focusNode.childNodes[c.focusOffset];
      h && h.contentEditable == "false" && (o = !0);
    }
    if (!(o || d && Rn) && Za(s.node, s.offset, c.anchorNode, c.anchorOffset) && Za(l.node, l.offset, c.focusNode, c.focusOffset))
      return;
    let f = !1;
    if ((u.extend || e == n) && !d) {
      u.collapse(s.node, s.offset);
      try {
        e != n && u.extend(l.node, l.offset), f = !0;
      } catch {
      }
    }
    if (!f) {
      if (e > n) {
        let m = s;
        s = l, l = m;
      }
      let h = document.createRange();
      h.setEnd(l.node, l.offset), h.setStart(s.node, s.offset), u.removeAllRanges(), u.addRange(h);
    }
  }
  ignoreMutation(e) {
    return !this.contentDOM && e.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(e, n) {
    for (let r = 0, o = 0; o < this.children.length; o++) {
      let a = this.children[o], i = r + a.size;
      if (r == i ? e <= i && n >= r : e < i && n > r) {
        let s = r + a.border, l = i - a.border;
        if (e >= s && n <= l) {
          this.dirty = e == r || n == i ? Na : gv, e == s && n == l && (a.contentLost || a.dom.parentNode != this.contentDOM) ? a.dirty = io : a.markDirty(e - s, n - s);
          return;
        } else
          a.dirty = a.dom == a.contentDOM && a.dom.parentNode == this.contentDOM && !a.children.length ? Na : io;
      }
      r = i;
    }
    this.dirty = Na;
  }
  markParentsDirty() {
    let e = 1;
    for (let n = this.parent; n; n = n.parent, e++) {
      let r = e == 1 ? Na : gv;
      n.dirty < r && (n.dirty = r);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
  isText(e) {
    return !1;
  }
}
class hw extends Vl {
  constructor(e, n, r, o) {
    let a, i = n.type.toDOM;
    if (typeof i == "function" && (i = i(r, () => {
      if (!a)
        return o;
      if (a.parent)
        return a.parent.posBeforeChild(a);
    })), !n.type.spec.raw) {
      if (i.nodeType != 1) {
        let s = document.createElement("span");
        s.appendChild(i), i = s;
      }
      i.contentEditable = "false", i.classList.add("ProseMirror-widget");
    }
    super(e, [], i, null), this.widget = n, this.widget = n, a = this;
  }
  matchesWidget(e) {
    return this.dirty == pr && e.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(e) {
    let n = this.widget.spec.stopEvent;
    return n ? n(e) : !1;
  }
  ignoreMutation(e) {
    return e.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get side() {
    return this.widget.type.side;
  }
}
class QL extends Vl {
  constructor(e, n, r, o) {
    super(e, [], n, null), this.textDOM = r, this.text = o;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(e, n) {
    return e != this.textDOM ? this.posAtStart + (n ? this.size : 0) : this.posAtStart + n;
  }
  domFromPos(e) {
    return { node: this.textDOM, offset: e };
  }
  ignoreMutation(e) {
    return e.type === "characterData" && e.target.nodeValue == e.oldValue;
  }
}
class ei extends Vl {
  constructor(e, n, r, o, a) {
    super(e, [], r, o), this.mark = n, this.spec = a;
  }
  static create(e, n, r, o) {
    let a = o.nodeViews[n.type.name], i = a && a(n, o, r);
    return (!i || !i.dom) && (i = ci.renderSpec(document, n.type.spec.toDOM(n, r), null, n.attrs)), new ei(e, n, i.dom, i.contentDOM || i.dom, i);
  }
  parseRule() {
    return this.dirty & io || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(e) {
    return this.dirty != io && this.mark.eq(e);
  }
  markDirty(e, n) {
    if (super.markDirty(e, n), this.dirty != pr) {
      let r = this.parent;
      for (; !r.node; )
        r = r.parent;
      r.dirty < this.dirty && (r.dirty = this.dirty), this.dirty = pr;
    }
  }
  slice(e, n, r) {
    let o = ei.create(this.parent, this.mark, !0, r), a = this.children, i = this.size;
    n < i && (a = ep(a, n, i, r)), e > 0 && (a = ep(a, 0, e, r));
    for (let s = 0; s < a.length; s++)
      a[s].parent = o;
    return o.children = a, o;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
}
class ia extends Vl {
  constructor(e, n, r, o, a, i, s, l, u) {
    super(e, [], a, i), this.node = n, this.outerDeco = r, this.innerDeco = o, this.nodeDOM = s;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(e, n, r, o, a, i) {
    let s = a.nodeViews[n.type.name], l, u = s && s(n, a, () => {
      if (!l)
        return i;
      if (l.parent)
        return l.parent.posBeforeChild(l);
    }, r, o), c = u && u.dom, d = u && u.contentDOM;
    if (n.isText) {
      if (!c)
        c = document.createTextNode(n.text);
      else if (c.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else c || ({ dom: c, contentDOM: d } = ci.renderSpec(document, n.type.spec.toDOM(n), null, n.attrs));
    !d && !n.isText && c.nodeName != "BR" && (c.hasAttribute("contenteditable") || (c.contentEditable = "false"), n.type.spec.draggable && (c.draggable = !0));
    let f = c;
    return c = yw(c, r, n), u ? l = new ZL(e, n, r, o, c, d || null, f, u, a, i + 1) : n.isText ? new Qc(e, n, r, o, c, f, a) : new ia(e, n, r, o, c, d || null, f, a, i + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let e = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (e.preserveWhitespace = "full"), !this.contentDOM)
      e.getContent = () => this.node.content;
    else if (!this.contentLost)
      e.contentElement = this.contentDOM;
    else {
      for (let n = this.children.length - 1; n >= 0; n--) {
        let r = this.children[n];
        if (this.dom.contains(r.dom.parentNode)) {
          e.contentElement = r.dom.parentNode;
          break;
        }
      }
      e.contentElement || (e.getContent = () => _e.empty);
    }
    return e;
  }
  matchesNode(e, n, r) {
    return this.dirty == pr && e.eq(this.node) && Nu(n, this.outerDeco) && r.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(e, n) {
    let r = this.node.inlineContent, o = n, a = e.composing ? this.localCompositionInfo(e, n) : null, i = a && a.pos > -1 ? a : null, s = a && a.pos < 0, l = new tB(this, i && i.node, e);
    oB(this.node, this.innerDeco, (u, c, d) => {
      u.spec.marks ? l.syncToMarks(u.spec.marks, r, e) : u.type.side >= 0 && !d && l.syncToMarks(c == this.node.childCount ? St.none : this.node.child(c).marks, r, e), l.placeWidget(u, e, o);
    }, (u, c, d, f) => {
      l.syncToMarks(u.marks, r, e);
      let h;
      l.findNodeMatch(u, c, d, f) || s && e.state.selection.from > o && e.state.selection.to < o + u.nodeSize && (h = l.findIndexWithChild(a.node)) > -1 && l.updateNodeAt(u, c, d, h, e) || l.updateNextNode(u, c, d, e, f, o) || l.addNode(u, c, d, e, o), o += u.nodeSize;
    }), l.syncToMarks([], r, e), this.node.isTextblock && l.addTextblockHacks(), l.destroyRest(), (l.changed || this.dirty == Na) && (i && this.protectLocalComposition(e, i), gw(this.contentDOM, this.children, e), Xi && aB(this.dom));
  }
  localCompositionInfo(e, n) {
    let { from: r, to: o } = e.state.selection;
    if (!(e.state.selection instanceof tt) || r < n || o > n + this.node.content.size)
      return null;
    let a = e.input.compositionNode;
    if (!a || !this.dom.contains(a.parentNode))
      return null;
    if (this.node.inlineContent) {
      let i = a.nodeValue, s = iB(this.node.content, i, r - n, o - n);
      return s < 0 ? null : { node: a, pos: s, text: i };
    } else
      return { node: a, pos: -1, text: "" };
  }
  protectLocalComposition(e, { node: n, pos: r, text: o }) {
    if (this.getDesc(n))
      return;
    let a = n;
    for (; a.parentNode != this.contentDOM; a = a.parentNode) {
      for (; a.previousSibling; )
        a.parentNode.removeChild(a.previousSibling);
      for (; a.nextSibling; )
        a.parentNode.removeChild(a.nextSibling);
      a.pmViewDesc && (a.pmViewDesc = void 0);
    }
    let i = new QL(this, a, n, o);
    e.input.compositionNodes.push(i), this.children = ep(this.children, r, r + o.length, e, i);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(e, n, r, o) {
    return this.dirty == io || !e.sameMarkup(this.node) ? !1 : (this.updateInner(e, n, r, o), !0);
  }
  updateInner(e, n, r, o) {
    this.updateOuterDeco(n), this.node = e, this.innerDeco = r, this.contentDOM && this.updateChildren(o, this.posAtStart), this.dirty = pr;
  }
  updateOuterDeco(e) {
    if (Nu(e, this.outerDeco))
      return;
    let n = this.nodeDOM.nodeType != 1, r = this.dom;
    this.dom = vw(this.dom, this.nodeDOM, Zf(this.outerDeco, this.node, n), Zf(e, this.node, n)), this.dom != r && (r.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = e;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.dom.draggable = !0);
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.dom.removeAttribute("draggable"));
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function vv(t, e, n, r, o) {
  yw(r, e, t);
  let a = new ia(void 0, t, e, n, r, r, r, o, 0);
  return a.contentDOM && a.updateChildren(o, 0), a;
}
class Qc extends ia {
  constructor(e, n, r, o, a, i, s) {
    super(e, n, r, o, a, null, i, s, 0);
  }
  parseRule() {
    let e = this.nodeDOM.parentNode;
    for (; e && e != this.dom && !e.pmIsDeco; )
      e = e.parentNode;
    return { skip: e || !0 };
  }
  update(e, n, r, o) {
    return this.dirty == io || this.dirty != pr && !this.inParent() || !e.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(n), (this.dirty != pr || e.text != this.node.text) && e.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = e.text, o.trackWrites == this.nodeDOM && (o.trackWrites = null)), this.node = e, this.dirty = pr, !0);
  }
  inParent() {
    let e = this.parent.contentDOM;
    for (let n = this.nodeDOM; n; n = n.parentNode)
      if (n == e)
        return !0;
    return !1;
  }
  domFromPos(e) {
    return { node: this.nodeDOM, offset: e };
  }
  localPosFromDOM(e, n, r) {
    return e == this.nodeDOM ? this.posAtStart + Math.min(n, this.node.text.length) : super.localPosFromDOM(e, n, r);
  }
  ignoreMutation(e) {
    return e.type != "characterData" && e.type != "selection";
  }
  slice(e, n, r) {
    let o = this.node.cut(e, n), a = document.createTextNode(o.text);
    return new Qc(this.parent, o, this.outerDeco, this.innerDeco, a, a, r);
  }
  markDirty(e, n) {
    super.markDirty(e, n), this.dom != this.nodeDOM && (e == 0 || n == this.nodeDOM.nodeValue.length) && (this.dirty = io);
  }
  get domAtom() {
    return !1;
  }
  isText(e) {
    return this.node.text == e;
  }
}
class mw extends Vl {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(e) {
    return this.dirty == pr && this.dom.nodeName == e;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class ZL extends ia {
  constructor(e, n, r, o, a, i, s, l, u, c) {
    super(e, n, r, o, a, i, s, u, c), this.spec = l;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(e, n, r, o) {
    if (this.dirty == io)
      return !1;
    if (this.spec.update && (this.node.type == e.type || this.spec.multiType)) {
      let a = this.spec.update(e, n, r);
      return a && this.updateInner(e, n, r, o), a;
    } else return !this.contentDOM && !e.isLeaf ? !1 : super.update(e, n, r, o);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(e, n, r, o) {
    this.spec.setSelection ? this.spec.setSelection(e, n, r.root) : super.setSelection(e, n, r, o);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(e) {
    return this.spec.stopEvent ? this.spec.stopEvent(e) : !1;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
}
function gw(t, e, n) {
  let r = t.firstChild, o = !1;
  for (let a = 0; a < e.length; a++) {
    let i = e[a], s = i.dom;
    if (s.parentNode == t) {
      for (; s != r; )
        r = yv(r), o = !0;
      r = r.nextSibling;
    } else
      o = !0, t.insertBefore(s, r);
    if (i instanceof ei) {
      let l = r ? r.previousSibling : t.lastChild;
      gw(i.contentDOM, i.children, n), r = l ? l.nextSibling : t.firstChild;
    }
  }
  for (; r; )
    r = yv(r), o = !0;
  o && n.trackWrites == t && (n.trackWrites = null);
}
const Bs = function(t) {
  t && (this.nodeName = t);
};
Bs.prototype = /* @__PURE__ */ Object.create(null);
const $a = [new Bs()];
function Zf(t, e, n) {
  if (t.length == 0)
    return $a;
  let r = n ? $a[0] : new Bs(), o = [r];
  for (let a = 0; a < t.length; a++) {
    let i = t[a].type.attrs;
    if (i) {
      i.nodeName && o.push(r = new Bs(i.nodeName));
      for (let s in i) {
        let l = i[s];
        l != null && (n && o.length == 1 && o.push(r = new Bs(e.isInline ? "span" : "div")), s == "class" ? r.class = (r.class ? r.class + " " : "") + l : s == "style" ? r.style = (r.style ? r.style + ";" : "") + l : s != "nodeName" && (r[s] = l));
      }
    }
  }
  return o;
}
function vw(t, e, n, r) {
  if (n == $a && r == $a)
    return e;
  let o = e;
  for (let a = 0; a < r.length; a++) {
    let i = r[a], s = n[a];
    if (a) {
      let l;
      s && s.nodeName == i.nodeName && o != t && (l = o.parentNode) && l.nodeName.toLowerCase() == i.nodeName || (l = document.createElement(i.nodeName), l.pmIsDeco = !0, l.appendChild(o), s = $a[0]), o = l;
    }
    eB(o, s || $a[0], i);
  }
  return o;
}
function eB(t, e, n) {
  for (let r in e)
    r != "class" && r != "style" && r != "nodeName" && !(r in n) && t.removeAttribute(r);
  for (let r in n)
    r != "class" && r != "style" && r != "nodeName" && n[r] != e[r] && t.setAttribute(r, n[r]);
  if (e.class != n.class) {
    let r = e.class ? e.class.split(" ").filter(Boolean) : [], o = n.class ? n.class.split(" ").filter(Boolean) : [];
    for (let a = 0; a < r.length; a++)
      o.indexOf(r[a]) == -1 && t.classList.remove(r[a]);
    for (let a = 0; a < o.length; a++)
      r.indexOf(o[a]) == -1 && t.classList.add(o[a]);
    t.classList.length == 0 && t.removeAttribute("class");
  }
  if (e.style != n.style) {
    if (e.style) {
      let r = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, o;
      for (; o = r.exec(e.style); )
        t.style.removeProperty(o[1]);
    }
    n.style && (t.style.cssText += n.style);
  }
}
function yw(t, e, n) {
  return vw(t, t, $a, Zf(e, n, t.nodeType != 1));
}
function Nu(t, e) {
  if (t.length != e.length)
    return !1;
  for (let n = 0; n < t.length; n++)
    if (!t[n].type.eq(e[n].type))
      return !1;
  return !0;
}
function yv(t) {
  let e = t.nextSibling;
  return t.parentNode.removeChild(t), e;
}
class tB {
  constructor(e, n, r) {
    this.lock = n, this.view = r, this.index = 0, this.stack = [], this.changed = !1, this.top = e, this.preMatch = nB(e.node.content, e);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(e, n) {
    if (e != n) {
      for (let r = e; r < n; r++)
        this.top.children[r].destroy();
      this.top.children.splice(e, n - e), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(e, n, r) {
    let o = 0, a = this.stack.length >> 1, i = Math.min(a, e.length);
    for (; o < i && (o == a - 1 ? this.top : this.stack[o + 1 << 1]).matchesMark(e[o]) && e[o].type.spec.spanning !== !1; )
      o++;
    for (; o < a; )
      this.destroyRest(), this.top.dirty = pr, this.index = this.stack.pop(), this.top = this.stack.pop(), a--;
    for (; a < e.length; ) {
      this.stack.push(this.top, this.index + 1);
      let s = -1;
      for (let l = this.index; l < Math.min(this.index + 3, this.top.children.length); l++) {
        let u = this.top.children[l];
        if (u.matchesMark(e[a]) && !this.isLocked(u.dom)) {
          s = l;
          break;
        }
      }
      if (s > -1)
        s > this.index && (this.changed = !0, this.destroyBetween(this.index, s)), this.top = this.top.children[this.index];
      else {
        let l = ei.create(this.top, e[a], n, r);
        this.top.children.splice(this.index, 0, l), this.top = l, this.changed = !0;
      }
      this.index = 0, a++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(e, n, r, o) {
    let a = -1, i;
    if (o >= this.preMatch.index && (i = this.preMatch.matches[o - this.preMatch.index]).parent == this.top && i.matchesNode(e, n, r))
      a = this.top.children.indexOf(i, this.index);
    else
      for (let s = this.index, l = Math.min(this.top.children.length, s + 5); s < l; s++) {
        let u = this.top.children[s];
        if (u.matchesNode(e, n, r) && !this.preMatch.matched.has(u)) {
          a = s;
          break;
        }
      }
    return a < 0 ? !1 : (this.destroyBetween(this.index, a), this.index++, !0);
  }
  updateNodeAt(e, n, r, o, a) {
    let i = this.top.children[o];
    return i.dirty == io && i.dom == i.contentDOM && (i.dirty = Na), i.update(e, n, r, a) ? (this.destroyBetween(this.index, o), this.index++, !0) : !1;
  }
  findIndexWithChild(e) {
    for (; ; ) {
      let n = e.parentNode;
      if (!n)
        return -1;
      if (n == this.top.contentDOM) {
        let r = e.pmViewDesc;
        if (r) {
          for (let o = this.index; o < this.top.children.length; o++)
            if (this.top.children[o] == r)
              return o;
        }
        return -1;
      }
      e = n;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(e, n, r, o, a, i) {
    for (let s = this.index; s < this.top.children.length; s++) {
      let l = this.top.children[s];
      if (l instanceof ia) {
        let u = this.preMatch.matched.get(l);
        if (u != null && u != a)
          return !1;
        let c = l.dom, d, f = this.isLocked(c) && !(e.isText && l.node && l.node.isText && l.nodeDOM.nodeValue == e.text && l.dirty != io && Nu(n, l.outerDeco));
        if (!f && l.update(e, n, r, o))
          return this.destroyBetween(this.index, s), l.dom != c && (this.changed = !0), this.index++, !0;
        if (!f && (d = this.recreateWrapper(l, e, n, r, o, i)))
          return this.destroyBetween(this.index, s), this.top.children[this.index] = d, d.contentDOM && (d.dirty = Na, d.updateChildren(o, i + 1), d.dirty = pr), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(e, n, r, o, a, i) {
    if (e.dirty || n.isAtom || !e.children.length || !e.node.content.eq(n.content) || !Nu(r, e.outerDeco) || !o.eq(e.innerDeco))
      return null;
    let s = ia.create(this.top, n, r, o, a, i);
    if (s.contentDOM) {
      s.children = e.children, e.children = [];
      for (let l of s.children)
        l.parent = s;
    }
    return e.destroy(), s;
  }
  // Insert the node as a newly created node desc.
  addNode(e, n, r, o, a) {
    let i = ia.create(this.top, e, n, r, o, a);
    i.contentDOM && i.updateChildren(o, a + 1), this.top.children.splice(this.index++, 0, i), this.changed = !0;
  }
  placeWidget(e, n, r) {
    let o = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (o && o.matchesWidget(e) && (e == o.widget || !o.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let a = new hw(this.top, e, n, r);
      this.top.children.splice(this.index++, 0, a), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let e = this.top.children[this.index - 1], n = this.top;
    for (; e instanceof ei; )
      n = e, e = n.children[n.children.length - 1];
    (!e || // Empty textblock
    !(e instanceof Qc) || /\n$/.test(e.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(e.node.text)) && ((Rn || _n) && e && e.dom.contentEditable == "false" && this.addHackNode("IMG", n), this.addHackNode("BR", this.top));
  }
  addHackNode(e, n) {
    if (n == this.top && this.index < n.children.length && n.children[this.index].matchesHack(e))
      this.index++;
    else {
      let r = document.createElement(e);
      e == "IMG" && (r.className = "ProseMirror-separator", r.alt = ""), e == "BR" && (r.className = "ProseMirror-trailingBreak");
      let o = new mw(this.top, [], r, null);
      n != this.top ? n.children.push(o) : n.children.splice(this.index++, 0, o), this.changed = !0;
    }
  }
  isLocked(e) {
    return this.lock && (e == this.lock || e.nodeType == 1 && e.contains(this.lock.parentNode));
  }
}
function nB(t, e) {
  let n = e, r = n.children.length, o = t.childCount, a = /* @__PURE__ */ new Map(), i = [];
  e: for (; o > 0; ) {
    let s;
    for (; ; )
      if (r) {
        let u = n.children[r - 1];
        if (u instanceof ei)
          n = u, r = u.children.length;
        else {
          s = u, r--;
          break;
        }
      } else {
        if (n == e)
          break e;
        r = n.parent.children.indexOf(n), n = n.parent;
      }
    let l = s.node;
    if (l) {
      if (l != t.child(o - 1))
        break;
      --o, a.set(s, o), i.push(s);
    }
  }
  return { index: o, matched: a, matches: i.reverse() };
}
function rB(t, e) {
  return t.type.side - e.type.side;
}
function oB(t, e, n, r) {
  let o = e.locals(t), a = 0;
  if (o.length == 0) {
    for (let u = 0; u < t.childCount; u++) {
      let c = t.child(u);
      r(c, o, e.forChild(a, c), u), a += c.nodeSize;
    }
    return;
  }
  let i = 0, s = [], l = null;
  for (let u = 0; ; ) {
    let c, d;
    for (; i < o.length && o[i].to == a; ) {
      let y = o[i++];
      y.widget && (c ? (d || (d = [c])).push(y) : c = y);
    }
    if (c)
      if (d) {
        d.sort(rB);
        for (let y = 0; y < d.length; y++)
          n(d[y], u, !!l);
      } else
        n(c, u, !!l);
    let f, h;
    if (l)
      h = -1, f = l, l = null;
    else if (u < t.childCount)
      h = u, f = t.child(u++);
    else
      break;
    for (let y = 0; y < s.length; y++)
      s[y].to <= a && s.splice(y--, 1);
    for (; i < o.length && o[i].from <= a && o[i].to > a; )
      s.push(o[i++]);
    let m = a + f.nodeSize;
    if (f.isText) {
      let y = m;
      i < o.length && o[i].from < y && (y = o[i].from);
      for (let b = 0; b < s.length; b++)
        s[b].to < y && (y = s[b].to);
      y < m && (l = f.cut(y - a), f = f.cut(0, y - a), m = y, h = -1);
    } else
      for (; i < o.length && o[i].to < m; )
        i++;
    let g = f.isInline && !f.isLeaf ? s.filter((y) => !y.inline) : s.slice();
    r(f, g, e.forChild(a, f), h), a = m;
  }
}
function aB(t) {
  if (t.nodeName == "UL" || t.nodeName == "OL") {
    let e = t.style.cssText;
    t.style.cssText = e + "; list-style: square !important", window.getComputedStyle(t).listStyle, t.style.cssText = e;
  }
}
function iB(t, e, n, r) {
  for (let o = 0, a = 0; o < t.childCount && a <= r; ) {
    let i = t.child(o++), s = a;
    if (a += i.nodeSize, !i.isText)
      continue;
    let l = i.text;
    for (; o < t.childCount; ) {
      let u = t.child(o++);
      if (a += u.nodeSize, !u.isText)
        break;
      l += u.text;
    }
    if (a >= n) {
      if (a >= r && l.slice(r - e.length - s, r - s) == e)
        return r - e.length;
      let u = s < r ? l.lastIndexOf(e, r - s - 1) : -1;
      if (u >= 0 && u + e.length + s >= n)
        return s + u;
      if (n == r && l.length >= r + e.length - s && l.slice(r - s, r - s + e.length) == e)
        return r;
    }
  }
  return -1;
}
function ep(t, e, n, r, o) {
  let a = [];
  for (let i = 0, s = 0; i < t.length; i++) {
    let l = t[i], u = s, c = s += l.size;
    u >= n || c <= e ? a.push(l) : (u < e && a.push(l.slice(0, e - u, r)), o && (a.push(o), o = void 0), c > n && a.push(l.slice(n - u, l.size, r)));
  }
  return a;
}
function Mh(t, e = null) {
  let n = t.domSelectionRange(), r = t.state.doc;
  if (!n.focusNode)
    return null;
  let o = t.docView.nearestDesc(n.focusNode), a = o && o.size == 0, i = t.docView.posFromDOM(n.focusNode, n.focusOffset, 1);
  if (i < 0)
    return null;
  let s = r.resolve(i), l, u;
  if (Xc(n)) {
    for (l = i; o && !o.node; )
      o = o.parent;
    let d = o.node;
    if (o && d.isAtom && je.isSelectable(d) && o.parent && !(d.isInline && DL(n.focusNode, n.focusOffset, o.dom))) {
      let f = o.posBefore;
      u = new je(i == f ? s : r.resolve(f));
    }
  } else {
    if (n instanceof t.dom.ownerDocument.defaultView.Selection && n.rangeCount > 1) {
      let d = i, f = i;
      for (let h = 0; h < n.rangeCount; h++) {
        let m = n.getRangeAt(h);
        d = Math.min(d, t.docView.posFromDOM(m.startContainer, m.startOffset, 1)), f = Math.max(f, t.docView.posFromDOM(m.endContainer, m.endOffset, -1));
      }
      if (d < 0)
        return null;
      [l, i] = f == t.state.selection.anchor ? [f, d] : [d, f], s = r.resolve(i);
    } else
      l = t.docView.posFromDOM(n.anchorNode, n.anchorOffset, 1);
    if (l < 0)
      return null;
  }
  let c = r.resolve(l);
  if (!u) {
    let d = e == "pointer" || t.state.selection.head < s.pos && !a ? 1 : -1;
    u = Ih(t, c, s, d);
  }
  return u;
}
function bw(t) {
  return t.editable ? t.hasFocus() : ww(t) && document.activeElement && document.activeElement.contains(t.dom);
}
function Io(t, e = !1) {
  let n = t.state.selection;
  if (kw(t, n), !!bw(t)) {
    if (!e && t.input.mouseDown && t.input.mouseDown.allowDefault && _n) {
      let r = t.domSelectionRange(), o = t.domObserver.currentSelection;
      if (r.anchorNode && o.anchorNode && Za(r.anchorNode, r.anchorOffset, o.anchorNode, o.anchorOffset)) {
        t.input.mouseDown.delayedSelectionSync = !0, t.domObserver.setCurSelection();
        return;
      }
    }
    if (t.domObserver.disconnectSelection(), t.cursorWrapper)
      lB(t);
    else {
      let { anchor: r, head: o } = n, a, i;
      bv && !(n instanceof tt) && (n.$from.parent.inlineContent || (a = kv(t, n.from)), !n.empty && !n.$from.parent.inlineContent && (i = kv(t, n.to))), t.docView.setSelection(r, o, t, e), bv && (a && wv(a), i && wv(i)), n.visible ? t.dom.classList.remove("ProseMirror-hideselection") : (t.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && sB(t));
    }
    t.domObserver.setCurSelection(), t.domObserver.connectSelection();
  }
}
const bv = Rn || _n && sw < 63;
function kv(t, e) {
  let { node: n, offset: r } = t.docView.domFromPos(e, 0), o = r < n.childNodes.length ? n.childNodes[r] : null, a = r ? n.childNodes[r - 1] : null;
  if (Rn && o && o.contentEditable == "false")
    return Wd(o);
  if ((!o || o.contentEditable == "false") && (!a || a.contentEditable == "false")) {
    if (o)
      return Wd(o);
    if (a)
      return Wd(a);
  }
}
function Wd(t) {
  return t.contentEditable = "true", Rn && t.draggable && (t.draggable = !1, t.wasDraggable = !0), t;
}
function wv(t) {
  t.contentEditable = "false", t.wasDraggable && (t.draggable = !0, t.wasDraggable = null);
}
function sB(t) {
  let e = t.dom.ownerDocument;
  e.removeEventListener("selectionchange", t.input.hideSelectionGuard);
  let n = t.domSelectionRange(), r = n.anchorNode, o = n.anchorOffset;
  e.addEventListener("selectionchange", t.input.hideSelectionGuard = () => {
    (n.anchorNode != r || n.anchorOffset != o) && (e.removeEventListener("selectionchange", t.input.hideSelectionGuard), setTimeout(() => {
      (!bw(t) || t.state.selection.visible) && t.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function lB(t) {
  let e = t.domSelection(), n = document.createRange();
  if (!e)
    return;
  let r = t.cursorWrapper.dom, o = r.nodeName == "IMG";
  o ? n.setStart(r.parentNode, hn(r) + 1) : n.setStart(r, 0), n.collapse(!0), e.removeAllRanges(), e.addRange(n), !o && !t.state.selection.visible && zn && aa <= 11 && (r.disabled = !0, r.disabled = !1);
}
function kw(t, e) {
  if (e instanceof je) {
    let n = t.docView.descAt(e.from);
    n != t.lastSelectedViewDesc && (_v(t), n && n.selectNode(), t.lastSelectedViewDesc = n);
  } else
    _v(t);
}
function _v(t) {
  t.lastSelectedViewDesc && (t.lastSelectedViewDesc.parent && t.lastSelectedViewDesc.deselectNode(), t.lastSelectedViewDesc = void 0);
}
function Ih(t, e, n, r) {
  return t.someProp("createSelectionBetween", (o) => o(t, e, n)) || tt.between(e, n, r);
}
function Cv(t) {
  return t.editable && !t.hasFocus() ? !1 : ww(t);
}
function ww(t) {
  let e = t.domSelectionRange();
  if (!e.anchorNode)
    return !1;
  try {
    return t.dom.contains(e.anchorNode.nodeType == 3 ? e.anchorNode.parentNode : e.anchorNode) && (t.editable || t.dom.contains(e.focusNode.nodeType == 3 ? e.focusNode.parentNode : e.focusNode));
  } catch {
    return !1;
  }
}
function uB(t) {
  let e = t.docView.domFromPos(t.state.selection.anchor, 0), n = t.domSelectionRange();
  return Za(e.node, e.offset, n.anchorNode, n.anchorOffset);
}
function tp(t, e) {
  let { $anchor: n, $head: r } = t.selection, o = e > 0 ? n.max(r) : n.min(r), a = o.parent.inlineContent ? o.depth ? t.doc.resolve(e > 0 ? o.after() : o.before()) : null : o;
  return a && at.findFrom(a, e);
}
function zo(t, e) {
  return t.dispatch(t.state.tr.setSelection(e).scrollIntoView()), !0;
}
function Ev(t, e, n) {
  let r = t.state.selection;
  if (r instanceof tt)
    if (n.indexOf("s") > -1) {
      let { $head: o } = r, a = o.textOffset ? null : e < 0 ? o.nodeBefore : o.nodeAfter;
      if (!a || a.isText || !a.isLeaf)
        return !1;
      let i = t.state.doc.resolve(o.pos + a.nodeSize * (e < 0 ? -1 : 1));
      return zo(t, new tt(r.$anchor, i));
    } else if (r.empty) {
      if (t.endOfTextblock(e > 0 ? "forward" : "backward")) {
        let o = tp(t.state, e);
        return o && o instanceof je ? zo(t, o) : !1;
      } else if (!(lr && n.indexOf("m") > -1)) {
        let o = r.$head, a = o.textOffset ? null : e < 0 ? o.nodeBefore : o.nodeAfter, i;
        if (!a || a.isText)
          return !1;
        let s = e < 0 ? o.pos - a.nodeSize : o.pos;
        return a.isAtom || (i = t.docView.descAt(s)) && !i.contentDOM ? je.isSelectable(a) ? zo(t, new je(e < 0 ? t.state.doc.resolve(o.pos - a.nodeSize) : o)) : Fl ? zo(t, new tt(t.state.doc.resolve(e < 0 ? s : s + a.nodeSize))) : !1 : !1;
      }
    } else return !1;
  else {
    if (r instanceof je && r.node.isInline)
      return zo(t, new tt(e > 0 ? r.$to : r.$from));
    {
      let o = tp(t.state, e);
      return o ? zo(t, o) : !1;
    }
  }
}
function $u(t) {
  return t.nodeType == 3 ? t.nodeValue.length : t.childNodes.length;
}
function Fs(t, e) {
  let n = t.pmViewDesc;
  return n && n.size == 0 && (e < 0 || t.nextSibling || t.nodeName != "BR");
}
function yi(t, e) {
  return e < 0 ? cB(t) : dB(t);
}
function cB(t) {
  let e = t.domSelectionRange(), n = e.focusNode, r = e.focusOffset;
  if (!n)
    return;
  let o, a, i = !1;
  for ($r && n.nodeType == 1 && r < $u(n) && Fs(n.childNodes[r], -1) && (i = !0); ; )
    if (r > 0) {
      if (n.nodeType != 1)
        break;
      {
        let s = n.childNodes[r - 1];
        if (Fs(s, -1))
          o = n, a = --r;
        else if (s.nodeType == 3)
          n = s, r = n.nodeValue.length;
        else
          break;
      }
    } else {
      if (_w(n))
        break;
      {
        let s = n.previousSibling;
        for (; s && Fs(s, -1); )
          o = n.parentNode, a = hn(s), s = s.previousSibling;
        if (s)
          n = s, r = $u(n);
        else {
          if (n = n.parentNode, n == t.dom)
            break;
          r = 0;
        }
      }
    }
  i ? np(t, n, r) : o && np(t, o, a);
}
function dB(t) {
  let e = t.domSelectionRange(), n = e.focusNode, r = e.focusOffset;
  if (!n)
    return;
  let o = $u(n), a, i;
  for (; ; )
    if (r < o) {
      if (n.nodeType != 1)
        break;
      let s = n.childNodes[r];
      if (Fs(s, 1))
        a = n, i = ++r;
      else
        break;
    } else {
      if (_w(n))
        break;
      {
        let s = n.nextSibling;
        for (; s && Fs(s, 1); )
          a = s.parentNode, i = hn(s) + 1, s = s.nextSibling;
        if (s)
          n = s, r = 0, o = $u(n);
        else {
          if (n = n.parentNode, n == t.dom)
            break;
          r = o = 0;
        }
      }
    }
  a && np(t, a, i);
}
function _w(t) {
  let e = t.pmViewDesc;
  return e && e.node && e.node.isBlock;
}
function fB(t, e) {
  for (; t && e == t.childNodes.length && !Bl(t); )
    e = hn(t) + 1, t = t.parentNode;
  for (; t && e < t.childNodes.length; ) {
    let n = t.childNodes[e];
    if (n.nodeType == 3)
      return n;
    if (n.nodeType == 1 && n.contentEditable == "false")
      break;
    t = n, e = 0;
  }
}
function pB(t, e) {
  for (; t && !e && !Bl(t); )
    e = hn(t), t = t.parentNode;
  for (; t && e; ) {
    let n = t.childNodes[e - 1];
    if (n.nodeType == 3)
      return n;
    if (n.nodeType == 1 && n.contentEditable == "false")
      break;
    t = n, e = t.childNodes.length;
  }
}
function np(t, e, n) {
  if (e.nodeType != 3) {
    let a, i;
    (i = fB(e, n)) ? (e = i, n = 0) : (a = pB(e, n)) && (e = a, n = a.nodeValue.length);
  }
  let r = t.domSelection();
  if (!r)
    return;
  if (Xc(r)) {
    let a = document.createRange();
    a.setEnd(e, n), a.setStart(e, n), r.removeAllRanges(), r.addRange(a);
  } else r.extend && r.extend(e, n);
  t.domObserver.setCurSelection();
  let { state: o } = t;
  setTimeout(() => {
    t.state == o && Io(t);
  }, 50);
}
function Ov(t, e) {
  let n = t.state.doc.resolve(e);
  if (!(_n || $L) && n.parent.inlineContent) {
    let o = t.coordsAtPos(e);
    if (e > n.start()) {
      let a = t.coordsAtPos(e - 1), i = (a.top + a.bottom) / 2;
      if (i > o.top && i < o.bottom && Math.abs(a.left - o.left) > 1)
        return a.left < o.left ? "ltr" : "rtl";
    }
    if (e < n.end()) {
      let a = t.coordsAtPos(e + 1), i = (a.top + a.bottom) / 2;
      if (i > o.top && i < o.bottom && Math.abs(a.left - o.left) > 1)
        return a.left > o.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(t.dom).direction == "rtl" ? "rtl" : "ltr";
}
function Tv(t, e, n) {
  let r = t.state.selection;
  if (r instanceof tt && !r.empty || n.indexOf("s") > -1 || lr && n.indexOf("m") > -1)
    return !1;
  let { $from: o, $to: a } = r;
  if (!o.parent.inlineContent || t.endOfTextblock(e < 0 ? "up" : "down")) {
    let i = tp(t.state, e);
    if (i && i instanceof je)
      return zo(t, i);
  }
  if (!o.parent.inlineContent) {
    let i = e < 0 ? o : a, s = r instanceof tr ? at.near(i, e) : at.findFrom(i, e);
    return s ? zo(t, s) : !1;
  }
  return !1;
}
function Sv(t, e) {
  if (!(t.state.selection instanceof tt))
    return !0;
  let { $head: n, $anchor: r, empty: o } = t.state.selection;
  if (!n.sameParent(r))
    return !0;
  if (!o)
    return !1;
  if (t.endOfTextblock(e > 0 ? "forward" : "backward"))
    return !0;
  let a = !n.textOffset && (e < 0 ? n.nodeBefore : n.nodeAfter);
  if (a && !a.isText) {
    let i = t.state.tr;
    return e < 0 ? i.delete(n.pos - a.nodeSize, n.pos) : i.delete(n.pos, n.pos + a.nodeSize), t.dispatch(i), !0;
  }
  return !1;
}
function xv(t, e, n) {
  t.domObserver.stop(), e.contentEditable = n, t.domObserver.start();
}
function hB(t) {
  if (!Rn || t.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: e, focusOffset: n } = t.domSelectionRange();
  if (e && e.nodeType == 1 && n == 0 && e.firstChild && e.firstChild.contentEditable == "false") {
    let r = e.firstChild;
    xv(t, r, "true"), setTimeout(() => xv(t, r, "false"), 20);
  }
  return !1;
}
function mB(t) {
  let e = "";
  return t.ctrlKey && (e += "c"), t.metaKey && (e += "m"), t.altKey && (e += "a"), t.shiftKey && (e += "s"), e;
}
function gB(t, e) {
  let n = e.keyCode, r = mB(e);
  if (n == 8 || lr && n == 72 && r == "c")
    return Sv(t, -1) || yi(t, -1);
  if (n == 46 && !e.shiftKey || lr && n == 68 && r == "c")
    return Sv(t, 1) || yi(t, 1);
  if (n == 13 || n == 27)
    return !0;
  if (n == 37 || lr && n == 66 && r == "c") {
    let o = n == 37 ? Ov(t, t.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return Ev(t, o, r) || yi(t, o);
  } else if (n == 39 || lr && n == 70 && r == "c") {
    let o = n == 39 ? Ov(t, t.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return Ev(t, o, r) || yi(t, o);
  } else {
    if (n == 38 || lr && n == 80 && r == "c")
      return Tv(t, -1, r) || yi(t, -1);
    if (n == 40 || lr && n == 78 && r == "c")
      return hB(t) || Tv(t, 1, r) || yi(t, 1);
    if (r == (lr ? "m" : "c") && (n == 66 || n == 73 || n == 89 || n == 90))
      return !0;
  }
  return !1;
}
function Dh(t, e) {
  t.someProp("transformCopied", (h) => {
    e = h(e, t);
  });
  let n = [], { content: r, openStart: o, openEnd: a } = e;
  for (; o > 1 && a > 1 && r.childCount == 1 && r.firstChild.childCount == 1; ) {
    o--, a--;
    let h = r.firstChild;
    n.push(h.type.name, h.attrs != h.type.defaultAttrs ? h.attrs : null), r = h.content;
  }
  let i = t.someProp("clipboardSerializer") || ci.fromSchema(t.state.schema), s = xw(), l = s.createElement("div");
  l.appendChild(i.serializeFragment(r, { document: s }));
  let u = l.firstChild, c, d = 0;
  for (; u && u.nodeType == 1 && (c = Sw[u.nodeName.toLowerCase()]); ) {
    for (let h = c.length - 1; h >= 0; h--) {
      let m = s.createElement(c[h]);
      for (; l.firstChild; )
        m.appendChild(l.firstChild);
      l.appendChild(m), d++;
    }
    u = l.firstChild;
  }
  u && u.nodeType == 1 && u.setAttribute("data-pm-slice", `${o} ${a}${d ? ` -${d}` : ""} ${JSON.stringify(n)}`);
  let f = t.someProp("clipboardTextSerializer", (h) => h(e, t)) || e.content.textBetween(0, e.content.size, `

`);
  return { dom: l, text: f, slice: e };
}
function Cw(t, e, n, r, o) {
  let a = o.parent.type.spec.code, i, s;
  if (!n && !e)
    return null;
  let l = e && (r || a || !n);
  if (l) {
    if (t.someProp("transformPastedText", (f) => {
      e = f(e, a || r, t);
    }), a)
      return e ? new Pe(_e.from(t.state.schema.text(e.replace(/\r\n?/g, `
`))), 0, 0) : Pe.empty;
    let d = t.someProp("clipboardTextParser", (f) => f(e, o, r, t));
    if (d)
      s = d;
    else {
      let f = o.marks(), { schema: h } = t.state, m = ci.fromSchema(h);
      i = document.createElement("div"), e.split(/(?:\r\n?|\n)+/).forEach((g) => {
        let y = i.appendChild(document.createElement("p"));
        g && y.appendChild(m.serializeNode(h.text(g, f)));
      });
    }
  } else
    t.someProp("transformPastedHTML", (d) => {
      n = d(n, t);
    }), i = kB(n), Fl && wB(i);
  let u = i && i.querySelector("[data-pm-slice]"), c = u && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(u.getAttribute("data-pm-slice") || "");
  if (c && c[3])
    for (let d = +c[3]; d > 0; d--) {
      let f = i.firstChild;
      for (; f && f.nodeType != 1; )
        f = f.nextSibling;
      if (!f)
        break;
      i = f;
    }
  if (s || (s = (t.someProp("clipboardParser") || t.someProp("domParser") || oa.fromSchema(t.state.schema)).parseSlice(i, {
    preserveWhitespace: !!(l || c),
    context: o,
    ruleFromNode(f) {
      return f.nodeName == "BR" && !f.nextSibling && f.parentNode && !vB.test(f.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), c)
    s = _B(Av(s, +c[1], +c[2]), c[4]);
  else if (s = Pe.maxOpen(yB(s.content, o), !0), s.openStart || s.openEnd) {
    let d = 0, f = 0;
    for (let h = s.content.firstChild; d < s.openStart && !h.type.spec.isolating; d++, h = h.firstChild)
      ;
    for (let h = s.content.lastChild; f < s.openEnd && !h.type.spec.isolating; f++, h = h.lastChild)
      ;
    s = Av(s, d, f);
  }
  return t.someProp("transformPasted", (d) => {
    s = d(s, t);
  }), s;
}
const vB = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function yB(t, e) {
  if (t.childCount < 2)
    return t;
  for (let n = e.depth; n >= 0; n--) {
    let o = e.node(n).contentMatchAt(e.index(n)), a, i = [];
    if (t.forEach((s) => {
      if (!i)
        return;
      let l = o.findWrapping(s.type), u;
      if (!l)
        return i = null;
      if (u = i.length && a.length && Ow(l, a, s, i[i.length - 1], 0))
        i[i.length - 1] = u;
      else {
        i.length && (i[i.length - 1] = Tw(i[i.length - 1], a.length));
        let c = Ew(s, l);
        i.push(c), o = o.matchType(c.type), a = l;
      }
    }), i)
      return _e.from(i);
  }
  return t;
}
function Ew(t, e, n = 0) {
  for (let r = e.length - 1; r >= n; r--)
    t = e[r].create(null, _e.from(t));
  return t;
}
function Ow(t, e, n, r, o) {
  if (o < t.length && o < e.length && t[o] == e[o]) {
    let a = Ow(t, e, n, r.lastChild, o + 1);
    if (a)
      return r.copy(r.content.replaceChild(r.childCount - 1, a));
    if (r.contentMatchAt(r.childCount).matchType(o == t.length - 1 ? n.type : t[o + 1]))
      return r.copy(r.content.append(_e.from(Ew(n, t, o + 1))));
  }
}
function Tw(t, e) {
  if (e == 0)
    return t;
  let n = t.content.replaceChild(t.childCount - 1, Tw(t.lastChild, e - 1)), r = t.contentMatchAt(t.childCount).fillBefore(_e.empty, !0);
  return t.copy(n.append(r));
}
function rp(t, e, n, r, o, a) {
  let i = e < 0 ? t.firstChild : t.lastChild, s = i.content;
  return t.childCount > 1 && (a = 0), o < r - 1 && (s = rp(s, e, n, r, o + 1, a)), o >= n && (s = e < 0 ? i.contentMatchAt(0).fillBefore(s, a <= o).append(s) : s.append(i.contentMatchAt(i.childCount).fillBefore(_e.empty, !0))), t.replaceChild(e < 0 ? 0 : t.childCount - 1, i.copy(s));
}
function Av(t, e, n) {
  return e < t.openStart && (t = new Pe(rp(t.content, -1, e, t.openStart, 0, t.openEnd), e, t.openEnd)), n < t.openEnd && (t = new Pe(rp(t.content, 1, n, t.openEnd, 0, 0), t.openStart, n)), t;
}
const Sw = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let Mv = null;
function xw() {
  return Mv || (Mv = document.implementation.createHTMLDocument("title"));
}
let Kd = null;
function bB(t) {
  let e = window.trustedTypes;
  return e ? (Kd || (Kd = e.defaultPolicy || e.createPolicy("ProseMirrorClipboard", { createHTML: (n) => n })), Kd.createHTML(t)) : t;
}
function kB(t) {
  let e = /^(\s*<meta [^>]*>)*/.exec(t);
  e && (t = t.slice(e[0].length));
  let n = xw().createElement("div"), r = /<([a-z][^>\s]+)/i.exec(t), o;
  if ((o = r && Sw[r[1].toLowerCase()]) && (t = o.map((a) => "<" + a + ">").join("") + t + o.map((a) => "</" + a + ">").reverse().join("")), n.innerHTML = bB(t), o)
    for (let a = 0; a < o.length; a++)
      n = n.querySelector(o[a]) || n;
  return n;
}
function wB(t) {
  let e = t.querySelectorAll(_n ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let n = 0; n < e.length; n++) {
    let r = e[n];
    r.childNodes.length == 1 && r.textContent == " " && r.parentNode && r.parentNode.replaceChild(t.ownerDocument.createTextNode(" "), r);
  }
}
function _B(t, e) {
  if (!t.size)
    return t;
  let n = t.content.firstChild.type.schema, r;
  try {
    r = JSON.parse(e);
  } catch {
    return t;
  }
  let { content: o, openStart: a, openEnd: i } = t;
  for (let s = r.length - 2; s >= 0; s -= 2) {
    let l = n.nodes[r[s]];
    if (!l || l.hasRequiredAttrs())
      break;
    o = _e.from(l.create(r[s + 1], o)), a++, i++;
  }
  return new Pe(o, a, i);
}
const Ln = {}, Bn = {}, CB = { touchstart: !0, touchmove: !0 };
class EB {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "" }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastChromeDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function OB(t) {
  for (let e in Ln) {
    let n = Ln[e];
    t.dom.addEventListener(e, t.input.eventHandlers[e] = (r) => {
      SB(t, r) && !Ph(t, r) && (t.editable || !(r.type in Bn)) && n(t, r);
    }, CB[e] ? { passive: !0 } : void 0);
  }
  Rn && t.dom.addEventListener("input", () => null), op(t);
}
function ea(t, e) {
  t.input.lastSelectionOrigin = e, t.input.lastSelectionTime = Date.now();
}
function TB(t) {
  t.domObserver.stop();
  for (let e in t.input.eventHandlers)
    t.dom.removeEventListener(e, t.input.eventHandlers[e]);
  clearTimeout(t.input.composingTimeout), clearTimeout(t.input.lastIOSEnterFallbackTimeout);
}
function op(t) {
  t.someProp("handleDOMEvents", (e) => {
    for (let n in e)
      t.input.eventHandlers[n] || t.dom.addEventListener(n, t.input.eventHandlers[n] = (r) => Ph(t, r));
  });
}
function Ph(t, e) {
  return t.someProp("handleDOMEvents", (n) => {
    let r = n[e.type];
    return r ? r(t, e) || e.defaultPrevented : !1;
  });
}
function SB(t, e) {
  if (!e.bubbles)
    return !0;
  if (e.defaultPrevented)
    return !1;
  for (let n = e.target; n != t.dom; n = n.parentNode)
    if (!n || n.nodeType == 11 || n.pmViewDesc && n.pmViewDesc.stopEvent(e))
      return !1;
  return !0;
}
function xB(t, e) {
  !Ph(t, e) && Ln[e.type] && (t.editable || !(e.type in Bn)) && Ln[e.type](t, e);
}
Bn.keydown = (t, e) => {
  let n = e;
  if (t.input.shiftKey = n.keyCode == 16 || n.shiftKey, !Mw(t, n) && (t.input.lastKeyCode = n.keyCode, t.input.lastKeyCodeTime = Date.now(), !(So && _n && n.keyCode == 13)))
    if (n.keyCode != 229 && t.domObserver.forceFlush(), Xi && n.keyCode == 13 && !n.ctrlKey && !n.altKey && !n.metaKey) {
      let r = Date.now();
      t.input.lastIOSEnter = r, t.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        t.input.lastIOSEnter == r && (t.someProp("handleKeyDown", (o) => o(t, Ia(13, "Enter"))), t.input.lastIOSEnter = 0);
      }, 200);
    } else t.someProp("handleKeyDown", (r) => r(t, n)) || gB(t, n) ? n.preventDefault() : ea(t, "key");
};
Bn.keyup = (t, e) => {
  e.keyCode == 16 && (t.input.shiftKey = !1);
};
Bn.keypress = (t, e) => {
  let n = e;
  if (Mw(t, n) || !n.charCode || n.ctrlKey && !n.altKey || lr && n.metaKey)
    return;
  if (t.someProp("handleKeyPress", (o) => o(t, n))) {
    n.preventDefault();
    return;
  }
  let r = t.state.selection;
  if (!(r instanceof tt) || !r.$from.sameParent(r.$to)) {
    let o = String.fromCharCode(n.charCode);
    !/[\r\n]/.test(o) && !t.someProp("handleTextInput", (a) => a(t, r.$from.pos, r.$to.pos, o)) && t.dispatch(t.state.tr.insertText(o).scrollIntoView()), n.preventDefault();
  }
};
function Zc(t) {
  return { left: t.clientX, top: t.clientY };
}
function AB(t, e) {
  let n = e.x - t.clientX, r = e.y - t.clientY;
  return n * n + r * r < 100;
}
function Nh(t, e, n, r, o) {
  if (r == -1)
    return !1;
  let a = t.state.doc.resolve(r);
  for (let i = a.depth + 1; i > 0; i--)
    if (t.someProp(e, (s) => i > a.depth ? s(t, n, a.nodeAfter, a.before(i), o, !0) : s(t, n, a.node(i), a.before(i), o, !1)))
      return !0;
  return !1;
}
function Li(t, e, n) {
  if (t.focused || t.focus(), t.state.selection.eq(e))
    return;
  let r = t.state.tr.setSelection(e);
  r.setMeta("pointer", !0), t.dispatch(r);
}
function MB(t, e) {
  if (e == -1)
    return !1;
  let n = t.state.doc.resolve(e), r = n.nodeAfter;
  return r && r.isAtom && je.isSelectable(r) ? (Li(t, new je(n)), !0) : !1;
}
function IB(t, e) {
  if (e == -1)
    return !1;
  let n = t.state.selection, r, o;
  n instanceof je && (r = n.node);
  let a = t.state.doc.resolve(e);
  for (let i = a.depth + 1; i > 0; i--) {
    let s = i > a.depth ? a.nodeAfter : a.node(i);
    if (je.isSelectable(s)) {
      r && n.$from.depth > 0 && i >= n.$from.depth && a.before(n.$from.depth + 1) == n.$from.pos ? o = a.before(n.$from.depth) : o = a.before(i);
      break;
    }
  }
  return o != null ? (Li(t, je.create(t.state.doc, o)), !0) : !1;
}
function DB(t, e, n, r, o) {
  return Nh(t, "handleClickOn", e, n, r) || t.someProp("handleClick", (a) => a(t, e, r)) || (o ? IB(t, n) : MB(t, n));
}
function PB(t, e, n, r) {
  return Nh(t, "handleDoubleClickOn", e, n, r) || t.someProp("handleDoubleClick", (o) => o(t, e, r));
}
function NB(t, e, n, r) {
  return Nh(t, "handleTripleClickOn", e, n, r) || t.someProp("handleTripleClick", (o) => o(t, e, r)) || $B(t, n, r);
}
function $B(t, e, n) {
  if (n.button != 0)
    return !1;
  let r = t.state.doc;
  if (e == -1)
    return r.inlineContent ? (Li(t, tt.create(r, 0, r.content.size)), !0) : !1;
  let o = r.resolve(e);
  for (let a = o.depth + 1; a > 0; a--) {
    let i = a > o.depth ? o.nodeAfter : o.node(a), s = o.before(a);
    if (i.inlineContent)
      Li(t, tt.create(r, s + 1, s + 1 + i.content.size));
    else if (je.isSelectable(i))
      Li(t, je.create(r, s));
    else
      continue;
    return !0;
  }
}
function $h(t) {
  return Ru(t);
}
const Aw = lr ? "metaKey" : "ctrlKey";
Ln.mousedown = (t, e) => {
  let n = e;
  t.input.shiftKey = n.shiftKey;
  let r = $h(t), o = Date.now(), a = "singleClick";
  o - t.input.lastClick.time < 500 && AB(n, t.input.lastClick) && !n[Aw] && (t.input.lastClick.type == "singleClick" ? a = "doubleClick" : t.input.lastClick.type == "doubleClick" && (a = "tripleClick")), t.input.lastClick = { time: o, x: n.clientX, y: n.clientY, type: a };
  let i = t.posAtCoords(Zc(n));
  i && (a == "singleClick" ? (t.input.mouseDown && t.input.mouseDown.done(), t.input.mouseDown = new RB(t, i, n, !!r)) : (a == "doubleClick" ? PB : NB)(t, i.pos, i.inside, n) ? n.preventDefault() : ea(t, "pointer"));
};
class RB {
  constructor(e, n, r, o) {
    this.view = e, this.pos = n, this.event = r, this.flushed = o, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = e.state.doc, this.selectNode = !!r[Aw], this.allowDefault = r.shiftKey;
    let a, i;
    if (n.inside > -1)
      a = e.state.doc.nodeAt(n.inside), i = n.inside;
    else {
      let c = e.state.doc.resolve(n.pos);
      a = c.parent, i = c.depth ? c.before() : 0;
    }
    const s = o ? null : r.target, l = s ? e.docView.nearestDesc(s, !0) : null;
    this.target = l && l.dom.nodeType == 1 ? l.dom : null;
    let { selection: u } = e.state;
    (r.button == 0 && a.type.spec.draggable && a.type.spec.selectable !== !1 || u instanceof je && u.from <= i && u.to > i) && (this.mightDrag = {
      node: a,
      pos: i,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && $r && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), e.root.addEventListener("mouseup", this.up = this.up.bind(this)), e.root.addEventListener("mousemove", this.move = this.move.bind(this)), ea(e, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => Io(this.view)), this.view.input.mouseDown = null;
  }
  up(e) {
    if (this.done(), !this.view.dom.contains(e.target))
      return;
    let n = this.pos;
    this.view.state.doc != this.startDoc && (n = this.view.posAtCoords(Zc(e))), this.updateAllowDefault(e), this.allowDefault || !n ? ea(this.view, "pointer") : DB(this.view, n.pos, n.inside, e, this.selectNode) ? e.preventDefault() : e.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    Rn && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    _n && !this.view.state.selection.visible && Math.min(Math.abs(n.pos - this.view.state.selection.from), Math.abs(n.pos - this.view.state.selection.to)) <= 2) ? (Li(this.view, at.near(this.view.state.doc.resolve(n.pos))), e.preventDefault()) : ea(this.view, "pointer");
  }
  move(e) {
    this.updateAllowDefault(e), ea(this.view, "pointer"), e.buttons == 0 && this.done();
  }
  updateAllowDefault(e) {
    !this.allowDefault && (Math.abs(this.event.x - e.clientX) > 4 || Math.abs(this.event.y - e.clientY) > 4) && (this.allowDefault = !0);
  }
}
Ln.touchstart = (t) => {
  t.input.lastTouch = Date.now(), $h(t), ea(t, "pointer");
};
Ln.touchmove = (t) => {
  t.input.lastTouch = Date.now(), ea(t, "pointer");
};
Ln.contextmenu = (t) => $h(t);
function Mw(t, e) {
  return t.composing ? !0 : Rn && Math.abs(e.timeStamp - t.input.compositionEndedAt) < 500 ? (t.input.compositionEndedAt = -2e8, !0) : !1;
}
const LB = So ? 5e3 : -1;
Bn.compositionstart = Bn.compositionupdate = (t) => {
  if (!t.composing) {
    t.domObserver.flush();
    let { state: e } = t, n = e.selection.$to;
    if (e.selection instanceof tt && (e.storedMarks || !n.textOffset && n.parentOffset && n.nodeBefore.marks.some((r) => r.type.spec.inclusive === !1)))
      t.markCursor = t.state.storedMarks || n.marks(), Ru(t, !0), t.markCursor = null;
    else if (Ru(t, !e.selection.empty), $r && e.selection.empty && n.parentOffset && !n.textOffset && n.nodeBefore.marks.length) {
      let r = t.domSelectionRange();
      for (let o = r.focusNode, a = r.focusOffset; o && o.nodeType == 1 && a != 0; ) {
        let i = a < 0 ? o.lastChild : o.childNodes[a - 1];
        if (!i)
          break;
        if (i.nodeType == 3) {
          let s = t.domSelection();
          s && s.collapse(i, i.nodeValue.length);
          break;
        } else
          o = i, a = -1;
      }
    }
    t.input.composing = !0;
  }
  Iw(t, LB);
};
Bn.compositionend = (t, e) => {
  t.composing && (t.input.composing = !1, t.input.compositionEndedAt = e.timeStamp, t.input.compositionPendingChanges = t.domObserver.pendingRecords().length ? t.input.compositionID : 0, t.input.compositionNode = null, t.input.compositionPendingChanges && Promise.resolve().then(() => t.domObserver.flush()), t.input.compositionID++, Iw(t, 20));
};
function Iw(t, e) {
  clearTimeout(t.input.composingTimeout), e > -1 && (t.input.composingTimeout = setTimeout(() => Ru(t), e));
}
function Dw(t) {
  for (t.composing && (t.input.composing = !1, t.input.compositionEndedAt = FB()); t.input.compositionNodes.length > 0; )
    t.input.compositionNodes.pop().markParentsDirty();
}
function BB(t) {
  let e = t.domSelectionRange();
  if (!e.focusNode)
    return null;
  let n = ML(e.focusNode, e.focusOffset), r = IL(e.focusNode, e.focusOffset);
  if (n && r && n != r) {
    let o = r.pmViewDesc, a = t.domObserver.lastChangedTextNode;
    if (n == a || r == a)
      return a;
    if (!o || !o.isText(r.nodeValue))
      return r;
    if (t.input.compositionNode == r) {
      let i = n.pmViewDesc;
      if (!(!i || !i.isText(n.nodeValue)))
        return r;
    }
  }
  return n || r;
}
function FB() {
  let t = document.createEvent("Event");
  return t.initEvent("event", !0, !0), t.timeStamp;
}
function Ru(t, e = !1) {
  if (!(So && t.domObserver.flushingSoon >= 0)) {
    if (t.domObserver.forceFlush(), Dw(t), e || t.docView && t.docView.dirty) {
      let n = Mh(t);
      return n && !n.eq(t.state.selection) ? t.dispatch(t.state.tr.setSelection(n)) : (t.markCursor || e) && !t.state.selection.empty ? t.dispatch(t.state.tr.deleteSelection()) : t.updateState(t.state), !0;
    }
    return !1;
  }
}
function VB(t, e) {
  if (!t.dom.parentNode)
    return;
  let n = t.dom.parentNode.appendChild(document.createElement("div"));
  n.appendChild(e), n.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let r = getSelection(), o = document.createRange();
  o.selectNodeContents(e), t.dom.blur(), r.removeAllRanges(), r.addRange(o), setTimeout(() => {
    n.parentNode && n.parentNode.removeChild(n), t.focus();
  }, 50);
}
const dl = zn && aa < 15 || Xi && RL < 604;
Ln.copy = Bn.cut = (t, e) => {
  let n = e, r = t.state.selection, o = n.type == "cut";
  if (r.empty)
    return;
  let a = dl ? null : n.clipboardData, i = r.content(), { dom: s, text: l } = Dh(t, i);
  a ? (n.preventDefault(), a.clearData(), a.setData("text/html", s.innerHTML), a.setData("text/plain", l)) : VB(t, s), o && t.dispatch(t.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function HB(t) {
  return t.openStart == 0 && t.openEnd == 0 && t.content.childCount == 1 ? t.content.firstChild : null;
}
function UB(t, e) {
  if (!t.dom.parentNode)
    return;
  let n = t.input.shiftKey || t.state.selection.$from.parent.type.spec.code, r = t.dom.parentNode.appendChild(document.createElement(n ? "textarea" : "div"));
  n || (r.contentEditable = "true"), r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.focus();
  let o = t.input.shiftKey && t.input.lastKeyCode != 45;
  setTimeout(() => {
    t.focus(), r.parentNode && r.parentNode.removeChild(r), n ? fl(t, r.value, null, o, e) : fl(t, r.textContent, r.innerHTML, o, e);
  }, 50);
}
function fl(t, e, n, r, o) {
  let a = Cw(t, e, n, r, t.state.selection.$from);
  if (t.someProp("handlePaste", (l) => l(t, o, a || Pe.empty)))
    return !0;
  if (!a)
    return !1;
  let i = HB(a), s = i ? t.state.tr.replaceSelectionWith(i, r) : t.state.tr.replaceSelection(a);
  return t.dispatch(s.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function Pw(t) {
  let e = t.getData("text/plain") || t.getData("Text");
  if (e)
    return e;
  let n = t.getData("text/uri-list");
  return n ? n.replace(/\r?\n/g, " ") : "";
}
Bn.paste = (t, e) => {
  let n = e;
  if (t.composing && !So)
    return;
  let r = dl ? null : n.clipboardData, o = t.input.shiftKey && t.input.lastKeyCode != 45;
  r && fl(t, Pw(r), r.getData("text/html"), o, n) ? n.preventDefault() : UB(t, n);
};
class Nw {
  constructor(e, n, r) {
    this.slice = e, this.move = n, this.node = r;
  }
}
const WB = lr ? "altKey" : "ctrlKey";
function $w(t, e) {
  let n = t.someProp("dragCopies", (r) => !r(e));
  return n ?? !e[WB];
}
Ln.dragstart = (t, e) => {
  let n = e, r = t.input.mouseDown;
  if (r && r.done(), !n.dataTransfer)
    return;
  let o = t.state.selection, a = o.empty ? null : t.posAtCoords(Zc(n)), i;
  if (!(a && a.pos >= o.from && a.pos <= (o instanceof je ? o.to - 1 : o.to))) {
    if (r && r.mightDrag)
      i = je.create(t.state.doc, r.mightDrag.pos);
    else if (n.target && n.target.nodeType == 1) {
      let d = t.docView.nearestDesc(n.target, !0);
      d && d.node.type.spec.draggable && d != t.docView && (i = je.create(t.state.doc, d.posBefore));
    }
  }
  let s = (i || t.state.selection).content(), { dom: l, text: u, slice: c } = Dh(t, s);
  (!n.dataTransfer.files.length || !_n || sw > 120) && n.dataTransfer.clearData(), n.dataTransfer.setData(dl ? "Text" : "text/html", l.innerHTML), n.dataTransfer.effectAllowed = "copyMove", dl || n.dataTransfer.setData("text/plain", u), t.dragging = new Nw(c, $w(t, n), i);
};
Ln.dragend = (t) => {
  let e = t.dragging;
  window.setTimeout(() => {
    t.dragging == e && (t.dragging = null);
  }, 50);
};
Bn.dragover = Bn.dragenter = (t, e) => e.preventDefault();
Bn.drop = (t, e) => {
  let n = e, r = t.dragging;
  if (t.dragging = null, !n.dataTransfer)
    return;
  let o = t.posAtCoords(Zc(n));
  if (!o)
    return;
  let a = t.state.doc.resolve(o.pos), i = r && r.slice;
  i ? t.someProp("transformPasted", (m) => {
    i = m(i, t);
  }) : i = Cw(t, Pw(n.dataTransfer), dl ? null : n.dataTransfer.getData("text/html"), !1, a);
  let s = !!(r && $w(t, n));
  if (t.someProp("handleDrop", (m) => m(t, n, i || Pe.empty, s))) {
    n.preventDefault();
    return;
  }
  if (!i)
    return;
  n.preventDefault();
  let l = i ? Qk(t.state.doc, a.pos, i) : a.pos;
  l == null && (l = a.pos);
  let u = t.state.tr;
  if (s) {
    let { node: m } = r;
    m ? m.replace(u) : u.deleteSelection();
  }
  let c = u.mapping.map(l), d = i.openStart == 0 && i.openEnd == 0 && i.content.childCount == 1, f = u.doc;
  if (d ? u.replaceRangeWith(c, c, i.content.firstChild) : u.replaceRange(c, c, i), u.doc.eq(f))
    return;
  let h = u.doc.resolve(c);
  if (d && je.isSelectable(i.content.firstChild) && h.nodeAfter && h.nodeAfter.sameMarkup(i.content.firstChild))
    u.setSelection(new je(h));
  else {
    let m = u.mapping.map(l);
    u.mapping.maps[u.mapping.maps.length - 1].forEach((g, y, b, C) => m = C), u.setSelection(Ih(t, h, u.doc.resolve(m)));
  }
  t.focus(), t.dispatch(u.setMeta("uiEvent", "drop"));
};
Ln.focus = (t) => {
  t.input.lastFocus = Date.now(), t.focused || (t.domObserver.stop(), t.dom.classList.add("ProseMirror-focused"), t.domObserver.start(), t.focused = !0, setTimeout(() => {
    t.docView && t.hasFocus() && !t.domObserver.currentSelection.eq(t.domSelectionRange()) && Io(t);
  }, 20));
};
Ln.blur = (t, e) => {
  let n = e;
  t.focused && (t.domObserver.stop(), t.dom.classList.remove("ProseMirror-focused"), t.domObserver.start(), n.relatedTarget && t.dom.contains(n.relatedTarget) && t.domObserver.currentSelection.clear(), t.focused = !1);
};
Ln.beforeinput = (t, e) => {
  if (_n && So && e.inputType == "deleteContentBackward") {
    t.domObserver.flushSoon();
    let { domChangeCount: r } = t.input;
    setTimeout(() => {
      if (t.input.domChangeCount != r || (t.dom.blur(), t.focus(), t.someProp("handleKeyDown", (a) => a(t, Ia(8, "Backspace")))))
        return;
      let { $cursor: o } = t.state.selection;
      o && o.pos > 0 && t.dispatch(t.state.tr.delete(o.pos - 1, o.pos).scrollIntoView());
    }, 50);
  }
};
for (let t in Bn)
  Ln[t] = Bn[t];
function pl(t, e) {
  if (t == e)
    return !0;
  for (let n in t)
    if (t[n] !== e[n])
      return !1;
  for (let n in e)
    if (!(n in t))
      return !1;
  return !0;
}
class Lu {
  constructor(e, n) {
    this.toDOM = e, this.spec = n || Ua, this.side = this.spec.side || 0;
  }
  map(e, n, r, o) {
    let { pos: a, deleted: i } = e.mapResult(n.from + o, this.side < 0 ? -1 : 1);
    return i ? null : new dr(a - r, a - r, this);
  }
  valid() {
    return !0;
  }
  eq(e) {
    return this == e || e instanceof Lu && (this.spec.key && this.spec.key == e.spec.key || this.toDOM == e.toDOM && pl(this.spec, e.spec));
  }
  destroy(e) {
    this.spec.destroy && this.spec.destroy(e);
  }
}
class sa {
  constructor(e, n) {
    this.attrs = e, this.spec = n || Ua;
  }
  map(e, n, r, o) {
    let a = e.map(n.from + o, this.spec.inclusiveStart ? -1 : 1) - r, i = e.map(n.to + o, this.spec.inclusiveEnd ? 1 : -1) - r;
    return a >= i ? null : new dr(a, i, this);
  }
  valid(e, n) {
    return n.from < n.to;
  }
  eq(e) {
    return this == e || e instanceof sa && pl(this.attrs, e.attrs) && pl(this.spec, e.spec);
  }
  static is(e) {
    return e.type instanceof sa;
  }
  destroy() {
  }
}
class Rh {
  constructor(e, n) {
    this.attrs = e, this.spec = n || Ua;
  }
  map(e, n, r, o) {
    let a = e.mapResult(n.from + o, 1);
    if (a.deleted)
      return null;
    let i = e.mapResult(n.to + o, -1);
    return i.deleted || i.pos <= a.pos ? null : new dr(a.pos - r, i.pos - r, this);
  }
  valid(e, n) {
    let { index: r, offset: o } = e.content.findIndex(n.from), a;
    return o == n.from && !(a = e.child(r)).isText && o + a.nodeSize == n.to;
  }
  eq(e) {
    return this == e || e instanceof Rh && pl(this.attrs, e.attrs) && pl(this.spec, e.spec);
  }
  destroy() {
  }
}
class dr {
  /**
  @internal
  */
  constructor(e, n, r) {
    this.from = e, this.to = n, this.type = r;
  }
  /**
  @internal
  */
  copy(e, n) {
    return new dr(e, n, this.type);
  }
  /**
  @internal
  */
  eq(e, n = 0) {
    return this.type.eq(e.type) && this.from + n == e.from && this.to + n == e.to;
  }
  /**
  @internal
  */
  map(e, n, r) {
    return this.type.map(e, this, n, r);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(e, n, r) {
    return new dr(e, e, new Lu(n, r));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(e, n, r, o) {
    return new dr(e, n, new sa(r, o));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(e, n, r, o) {
    return new dr(e, n, new Rh(r, o));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof sa;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof Lu;
  }
}
const Ei = [], Ua = {};
class Qt {
  /**
  @internal
  */
  constructor(e, n) {
    this.local = e.length ? e : Ei, this.children = n.length ? n : Ei;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(e, n) {
    return n.length ? Bu(n, e, 0, Ua) : kn;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(e, n, r) {
    let o = [];
    return this.findInner(e ?? 0, n ?? 1e9, o, 0, r), o;
  }
  findInner(e, n, r, o, a) {
    for (let i = 0; i < this.local.length; i++) {
      let s = this.local[i];
      s.from <= n && s.to >= e && (!a || a(s.spec)) && r.push(s.copy(s.from + o, s.to + o));
    }
    for (let i = 0; i < this.children.length; i += 3)
      if (this.children[i] < n && this.children[i + 1] > e) {
        let s = this.children[i] + 1;
        this.children[i + 2].findInner(e - s, n - s, r, o + s, a);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(e, n, r) {
    return this == kn || e.maps.length == 0 ? this : this.mapInner(e, n, 0, 0, r || Ua);
  }
  /**
  @internal
  */
  mapInner(e, n, r, o, a) {
    let i;
    for (let s = 0; s < this.local.length; s++) {
      let l = this.local[s].map(e, r, o);
      l && l.type.valid(n, l) ? (i || (i = [])).push(l) : a.onRemove && a.onRemove(this.local[s].spec);
    }
    return this.children.length ? KB(this.children, i || [], e, n, r, o, a) : i ? new Qt(i.sort(Wa), Ei) : kn;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(e, n) {
    return n.length ? this == kn ? Qt.create(e, n) : this.addInner(e, n, 0) : this;
  }
  addInner(e, n, r) {
    let o, a = 0;
    e.forEach((s, l) => {
      let u = l + r, c;
      if (c = Lw(n, s, u)) {
        for (o || (o = this.children.slice()); a < o.length && o[a] < l; )
          a += 3;
        o[a] == l ? o[a + 2] = o[a + 2].addInner(s, c, u + 1) : o.splice(a, 0, l, l + s.nodeSize, Bu(c, s, u + 1, Ua)), a += 3;
      }
    });
    let i = Rw(a ? Bw(n) : n, -r);
    for (let s = 0; s < i.length; s++)
      i[s].type.valid(e, i[s]) || i.splice(s--, 1);
    return new Qt(i.length ? this.local.concat(i).sort(Wa) : this.local, o || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(e) {
    return e.length == 0 || this == kn ? this : this.removeInner(e, 0);
  }
  removeInner(e, n) {
    let r = this.children, o = this.local;
    for (let a = 0; a < r.length; a += 3) {
      let i, s = r[a] + n, l = r[a + 1] + n;
      for (let c = 0, d; c < e.length; c++)
        (d = e[c]) && d.from > s && d.to < l && (e[c] = null, (i || (i = [])).push(d));
      if (!i)
        continue;
      r == this.children && (r = this.children.slice());
      let u = r[a + 2].removeInner(i, s + 1);
      u != kn ? r[a + 2] = u : (r.splice(a, 3), a -= 3);
    }
    if (o.length) {
      for (let a = 0, i; a < e.length; a++)
        if (i = e[a])
          for (let s = 0; s < o.length; s++)
            o[s].eq(i, n) && (o == this.local && (o = this.local.slice()), o.splice(s--, 1));
    }
    return r == this.children && o == this.local ? this : o.length || r.length ? new Qt(o, r) : kn;
  }
  forChild(e, n) {
    if (this == kn)
      return this;
    if (n.isLeaf)
      return Qt.empty;
    let r, o;
    for (let s = 0; s < this.children.length; s += 3)
      if (this.children[s] >= e) {
        this.children[s] == e && (r = this.children[s + 2]);
        break;
      }
    let a = e + 1, i = a + n.content.size;
    for (let s = 0; s < this.local.length; s++) {
      let l = this.local[s];
      if (l.from < i && l.to > a && l.type instanceof sa) {
        let u = Math.max(a, l.from) - a, c = Math.min(i, l.to) - a;
        u < c && (o || (o = [])).push(l.copy(u, c));
      }
    }
    if (o) {
      let s = new Qt(o.sort(Wa), Ei);
      return r ? new Go([s, r]) : s;
    }
    return r || kn;
  }
  /**
  @internal
  */
  eq(e) {
    if (this == e)
      return !0;
    if (!(e instanceof Qt) || this.local.length != e.local.length || this.children.length != e.children.length)
      return !1;
    for (let n = 0; n < this.local.length; n++)
      if (!this.local[n].eq(e.local[n]))
        return !1;
    for (let n = 0; n < this.children.length; n += 3)
      if (this.children[n] != e.children[n] || this.children[n + 1] != e.children[n + 1] || !this.children[n + 2].eq(e.children[n + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(e) {
    return Lh(this.localsInner(e));
  }
  /**
  @internal
  */
  localsInner(e) {
    if (this == kn)
      return Ei;
    if (e.inlineContent || !this.local.some(sa.is))
      return this.local;
    let n = [];
    for (let r = 0; r < this.local.length; r++)
      this.local[r].type instanceof sa || n.push(this.local[r]);
    return n;
  }
  forEachSet(e) {
    e(this);
  }
}
Qt.empty = new Qt([], []);
Qt.removeOverlap = Lh;
const kn = Qt.empty;
class Go {
  constructor(e) {
    this.members = e;
  }
  map(e, n) {
    const r = this.members.map((o) => o.map(e, n, Ua));
    return Go.from(r);
  }
  forChild(e, n) {
    if (n.isLeaf)
      return Qt.empty;
    let r = [];
    for (let o = 0; o < this.members.length; o++) {
      let a = this.members[o].forChild(e, n);
      a != kn && (a instanceof Go ? r = r.concat(a.members) : r.push(a));
    }
    return Go.from(r);
  }
  eq(e) {
    if (!(e instanceof Go) || e.members.length != this.members.length)
      return !1;
    for (let n = 0; n < this.members.length; n++)
      if (!this.members[n].eq(e.members[n]))
        return !1;
    return !0;
  }
  locals(e) {
    let n, r = !0;
    for (let o = 0; o < this.members.length; o++) {
      let a = this.members[o].localsInner(e);
      if (a.length)
        if (!n)
          n = a;
        else {
          r && (n = n.slice(), r = !1);
          for (let i = 0; i < a.length; i++)
            n.push(a[i]);
        }
    }
    return n ? Lh(r ? n : n.sort(Wa)) : Ei;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(e) {
    switch (e.length) {
      case 0:
        return kn;
      case 1:
        return e[0];
      default:
        return new Go(e.every((n) => n instanceof Qt) ? e : e.reduce((n, r) => n.concat(r instanceof Qt ? r : r.members), []));
    }
  }
  forEachSet(e) {
    for (let n = 0; n < this.members.length; n++)
      this.members[n].forEachSet(e);
  }
}
function KB(t, e, n, r, o, a, i) {
  let s = t.slice();
  for (let u = 0, c = a; u < n.maps.length; u++) {
    let d = 0;
    n.maps[u].forEach((f, h, m, g) => {
      let y = g - m - (h - f);
      for (let b = 0; b < s.length; b += 3) {
        let C = s[b + 1];
        if (C < 0 || f > C + c - d)
          continue;
        let k = s[b] + c - d;
        h >= k ? s[b + 1] = f <= k ? -2 : -1 : f >= c && y && (s[b] += y, s[b + 1] += y);
      }
      d += y;
    }), c = n.maps[u].map(c, -1);
  }
  let l = !1;
  for (let u = 0; u < s.length; u += 3)
    if (s[u + 1] < 0) {
      if (s[u + 1] == -2) {
        l = !0, s[u + 1] = -1;
        continue;
      }
      let c = n.map(t[u] + a), d = c - o;
      if (d < 0 || d >= r.content.size) {
        l = !0;
        continue;
      }
      let f = n.map(t[u + 1] + a, -1), h = f - o, { index: m, offset: g } = r.content.findIndex(d), y = r.maybeChild(m);
      if (y && g == d && g + y.nodeSize == h) {
        let b = s[u + 2].mapInner(n, y, c + 1, t[u] + a + 1, i);
        b != kn ? (s[u] = d, s[u + 1] = h, s[u + 2] = b) : (s[u + 1] = -2, l = !0);
      } else
        l = !0;
    }
  if (l) {
    let u = jB(s, t, e, n, o, a, i), c = Bu(u, r, 0, i);
    e = c.local;
    for (let d = 0; d < s.length; d += 3)
      s[d + 1] < 0 && (s.splice(d, 3), d -= 3);
    for (let d = 0, f = 0; d < c.children.length; d += 3) {
      let h = c.children[d];
      for (; f < s.length && s[f] < h; )
        f += 3;
      s.splice(f, 0, c.children[d], c.children[d + 1], c.children[d + 2]);
    }
  }
  return new Qt(e.sort(Wa), s);
}
function Rw(t, e) {
  if (!e || !t.length)
    return t;
  let n = [];
  for (let r = 0; r < t.length; r++) {
    let o = t[r];
    n.push(new dr(o.from + e, o.to + e, o.type));
  }
  return n;
}
function jB(t, e, n, r, o, a, i) {
  function s(l, u) {
    for (let c = 0; c < l.local.length; c++) {
      let d = l.local[c].map(r, o, u);
      d ? n.push(d) : i.onRemove && i.onRemove(l.local[c].spec);
    }
    for (let c = 0; c < l.children.length; c += 3)
      s(l.children[c + 2], l.children[c] + u + 1);
  }
  for (let l = 0; l < t.length; l += 3)
    t[l + 1] == -1 && s(t[l + 2], e[l] + a + 1);
  return n;
}
function Lw(t, e, n) {
  if (e.isLeaf)
    return null;
  let r = n + e.nodeSize, o = null;
  for (let a = 0, i; a < t.length; a++)
    (i = t[a]) && i.from > n && i.to < r && ((o || (o = [])).push(i), t[a] = null);
  return o;
}
function Bw(t) {
  let e = [];
  for (let n = 0; n < t.length; n++)
    t[n] != null && e.push(t[n]);
  return e;
}
function Bu(t, e, n, r) {
  let o = [], a = !1;
  e.forEach((s, l) => {
    let u = Lw(t, s, l + n);
    if (u) {
      a = !0;
      let c = Bu(u, s, n + l + 1, r);
      c != kn && o.push(l, l + s.nodeSize, c);
    }
  });
  let i = Rw(a ? Bw(t) : t, -n).sort(Wa);
  for (let s = 0; s < i.length; s++)
    i[s].type.valid(e, i[s]) || (r.onRemove && r.onRemove(i[s].spec), i.splice(s--, 1));
  return i.length || o.length ? new Qt(i, o) : kn;
}
function Wa(t, e) {
  return t.from - e.from || t.to - e.to;
}
function Lh(t) {
  let e = t;
  for (let n = 0; n < e.length - 1; n++) {
    let r = e[n];
    if (r.from != r.to)
      for (let o = n + 1; o < e.length; o++) {
        let a = e[o];
        if (a.from == r.from) {
          a.to != r.to && (e == t && (e = t.slice()), e[o] = a.copy(a.from, r.to), Iv(e, o + 1, a.copy(r.to, a.to)));
          continue;
        } else {
          a.from < r.to && (e == t && (e = t.slice()), e[n] = r.copy(r.from, a.from), Iv(e, o, r.copy(a.from, r.to)));
          break;
        }
      }
  }
  return e;
}
function Iv(t, e, n) {
  for (; e < t.length && Wa(n, t[e]) > 0; )
    e++;
  t.splice(e, 0, n);
}
function jd(t) {
  let e = [];
  return t.someProp("decorations", (n) => {
    let r = n(t.state);
    r && r != kn && e.push(r);
  }), t.cursorWrapper && e.push(Qt.create(t.state.doc, [t.cursorWrapper.deco])), Go.from(e);
}
const zB = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, YB = zn && aa <= 11;
class qB {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(e) {
    this.anchorNode = e.anchorNode, this.anchorOffset = e.anchorOffset, this.focusNode = e.focusNode, this.focusOffset = e.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(e) {
    return e.anchorNode == this.anchorNode && e.anchorOffset == this.anchorOffset && e.focusNode == this.focusNode && e.focusOffset == this.focusOffset;
  }
}
class GB {
  constructor(e, n) {
    this.view = e, this.handleDOMChange = n, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new qB(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.lastChangedTextNode = null, this.observer = window.MutationObserver && new window.MutationObserver((r) => {
      for (let o = 0; o < r.length; o++)
        this.queue.push(r[o]);
      zn && aa <= 11 && r.some((o) => o.type == "childList" && o.removedNodes.length || o.type == "characterData" && o.oldValue.length > o.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), YB && (this.onCharData = (r) => {
      this.queue.push({ target: r.target, type: "characterData", oldValue: r.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, zB)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let e = this.observer.takeRecords();
      if (e.length) {
        for (let n = 0; n < e.length; n++)
          this.queue.push(e[n]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (Cv(this.view)) {
      if (this.suppressingSelectionUpdates)
        return Io(this.view);
      if (zn && aa <= 11 && !this.view.state.selection.empty) {
        let e = this.view.domSelectionRange();
        if (e.focusNode && Za(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(e) {
    if (!e.focusNode)
      return !0;
    let n = /* @__PURE__ */ new Set(), r;
    for (let a = e.focusNode; a; a = Ji(a))
      n.add(a);
    for (let a = e.anchorNode; a; a = Ji(a))
      if (n.has(a)) {
        r = a;
        break;
      }
    let o = r && this.view.docView.nearestDesc(r);
    if (o && o.ignoreMutation({
      type: "selection",
      target: r.nodeType == 3 ? r.parentNode : r
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let e of this.observer.takeRecords())
        this.queue.push(e);
    return this.queue;
  }
  flush() {
    let { view: e } = this;
    if (!e.docView || this.flushingSoon > -1)
      return;
    let n = this.pendingRecords();
    n.length && (this.queue = []);
    let r = e.domSelectionRange(), o = !this.suppressingSelectionUpdates && !this.currentSelection.eq(r) && Cv(e) && !this.ignoreSelectionChange(r), a = -1, i = -1, s = !1, l = [];
    if (e.editable)
      for (let c = 0; c < n.length; c++) {
        let d = this.registerMutation(n[c], l);
        d && (a = a < 0 ? d.from : Math.min(d.from, a), i = i < 0 ? d.to : Math.max(d.to, i), d.typeOver && (s = !0));
      }
    if ($r && l.length) {
      let c = l.filter((d) => d.nodeName == "BR");
      if (c.length == 2) {
        let [d, f] = c;
        d.parentNode && d.parentNode.parentNode == f.parentNode ? f.remove() : d.remove();
      } else {
        let { focusNode: d } = this.currentSelection;
        for (let f of c) {
          let h = f.parentNode;
          h && h.nodeName == "LI" && (!d || QB(e, d) != h) && f.remove();
        }
      }
    }
    let u = null;
    a < 0 && o && e.input.lastFocus > Date.now() - 200 && Math.max(e.input.lastTouch, e.input.lastClick.time) < Date.now() - 300 && Xc(r) && (u = Mh(e)) && u.eq(at.near(e.state.doc.resolve(0), 1)) ? (e.input.lastFocus = 0, Io(e), this.currentSelection.set(r), e.scrollToSelection()) : (a > -1 || o) && (a > -1 && (e.docView.markDirty(a, i), JB(e)), this.handleDOMChange(a, i, s, l), e.docView && e.docView.dirty ? e.updateState(e.state) : this.currentSelection.eq(r) || Io(e), this.currentSelection.set(r));
  }
  registerMutation(e, n) {
    if (n.indexOf(e.target) > -1)
      return null;
    let r = this.view.docView.nearestDesc(e.target);
    if (e.type == "attributes" && (r == this.view.docView || e.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    e.attributeName == "style" && !e.oldValue && !e.target.getAttribute("style")) || !r || r.ignoreMutation(e))
      return null;
    if (e.type == "childList") {
      for (let c = 0; c < e.addedNodes.length; c++) {
        let d = e.addedNodes[c];
        n.push(d), d.nodeType == 3 && (this.lastChangedTextNode = d);
      }
      if (r.contentDOM && r.contentDOM != r.dom && !r.contentDOM.contains(e.target))
        return { from: r.posBefore, to: r.posAfter };
      let o = e.previousSibling, a = e.nextSibling;
      if (zn && aa <= 11 && e.addedNodes.length)
        for (let c = 0; c < e.addedNodes.length; c++) {
          let { previousSibling: d, nextSibling: f } = e.addedNodes[c];
          (!d || Array.prototype.indexOf.call(e.addedNodes, d) < 0) && (o = d), (!f || Array.prototype.indexOf.call(e.addedNodes, f) < 0) && (a = f);
        }
      let i = o && o.parentNode == e.target ? hn(o) + 1 : 0, s = r.localPosFromDOM(e.target, i, -1), l = a && a.parentNode == e.target ? hn(a) : e.target.childNodes.length, u = r.localPosFromDOM(e.target, l, 1);
      return { from: s, to: u };
    } else return e.type == "attributes" ? { from: r.posAtStart - r.border, to: r.posAtEnd + r.border } : (this.lastChangedTextNode = e.target, {
      from: r.posAtStart,
      to: r.posAtEnd,
      // An event was generated for a text change that didn't change
      // any text. Mark the dom change to fall back to assuming the
      // selection was typed over with an identical value if it can't
      // find another change.
      typeOver: e.target.nodeValue == e.oldValue
    });
  }
}
let Dv = /* @__PURE__ */ new WeakMap(), Pv = !1;
function JB(t) {
  if (!Dv.has(t) && (Dv.set(t, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(t.dom).whiteSpace) !== -1)) {
    if (t.requiresGeckoHackNode = $r, Pv)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), Pv = !0;
  }
}
function Nv(t, e) {
  let n = e.startContainer, r = e.startOffset, o = e.endContainer, a = e.endOffset, i = t.domAtPos(t.state.selection.anchor);
  return Za(i.node, i.offset, o, a) && ([n, r, o, a] = [o, a, n, r]), { anchorNode: n, anchorOffset: r, focusNode: o, focusOffset: a };
}
function XB(t, e) {
  if (e.getComposedRanges) {
    let o = e.getComposedRanges(t.root)[0];
    if (o)
      return Nv(t, o);
  }
  let n;
  function r(o) {
    o.preventDefault(), o.stopImmediatePropagation(), n = o.getTargetRanges()[0];
  }
  return t.dom.addEventListener("beforeinput", r, !0), document.execCommand("indent"), t.dom.removeEventListener("beforeinput", r, !0), n ? Nv(t, n) : null;
}
function QB(t, e) {
  for (let n = e.parentNode; n && n != t.dom; n = n.parentNode) {
    let r = t.docView.nearestDesc(n, !0);
    if (r && r.node.isBlock)
      return n;
  }
  return null;
}
function ZB(t, e, n) {
  let { node: r, fromOffset: o, toOffset: a, from: i, to: s } = t.docView.parseRange(e, n), l = t.domSelectionRange(), u, c = l.anchorNode;
  if (c && t.dom.contains(c.nodeType == 1 ? c : c.parentNode) && (u = [{ node: c, offset: l.anchorOffset }], Xc(l) || u.push({ node: l.focusNode, offset: l.focusOffset })), _n && t.input.lastKeyCode === 8)
    for (let y = a; y > o; y--) {
      let b = r.childNodes[y - 1], C = b.pmViewDesc;
      if (b.nodeName == "BR" && !C) {
        a = y;
        break;
      }
      if (!C || C.size)
        break;
    }
  let d = t.state.doc, f = t.someProp("domParser") || oa.fromSchema(t.state.schema), h = d.resolve(i), m = null, g = f.parse(r, {
    topNode: h.parent,
    topMatch: h.parent.contentMatchAt(h.index()),
    topOpen: !0,
    from: o,
    to: a,
    preserveWhitespace: h.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: u,
    ruleFromNode: eF,
    context: h
  });
  if (u && u[0].pos != null) {
    let y = u[0].pos, b = u[1] && u[1].pos;
    b == null && (b = y), m = { anchor: y + i, head: b + i };
  }
  return { doc: g, sel: m, from: i, to: s };
}
function eF(t) {
  let e = t.pmViewDesc;
  if (e)
    return e.parseRule();
  if (t.nodeName == "BR" && t.parentNode) {
    if (Rn && /^(ul|ol)$/i.test(t.parentNode.nodeName)) {
      let n = document.createElement("div");
      return n.appendChild(document.createElement("li")), { skip: n };
    } else if (t.parentNode.lastChild == t || Rn && /^(tr|table)$/i.test(t.parentNode.nodeName))
      return { ignore: !0 };
  } else if (t.nodeName == "IMG" && t.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const tF = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function nF(t, e, n, r, o) {
  let a = t.input.compositionPendingChanges || (t.composing ? t.input.compositionID : 0);
  if (t.input.compositionPendingChanges = 0, e < 0) {
    let O = t.input.lastSelectionTime > Date.now() - 50 ? t.input.lastSelectionOrigin : null, R = Mh(t, O);
    if (R && !t.state.selection.eq(R)) {
      if (_n && So && t.input.lastKeyCode === 13 && Date.now() - 100 < t.input.lastKeyCodeTime && t.someProp("handleKeyDown", (z) => z(t, Ia(13, "Enter"))))
        return;
      let N = t.state.tr.setSelection(R);
      O == "pointer" ? N.setMeta("pointer", !0) : O == "key" && N.scrollIntoView(), a && N.setMeta("composition", a), t.dispatch(N);
    }
    return;
  }
  let i = t.state.doc.resolve(e), s = i.sharedDepth(n);
  e = i.before(s + 1), n = t.state.doc.resolve(n).after(s + 1);
  let l = t.state.selection, u = ZB(t, e, n), c = t.state.doc, d = c.slice(u.from, u.to), f, h;
  t.input.lastKeyCode === 8 && Date.now() - 100 < t.input.lastKeyCodeTime ? (f = t.state.selection.to, h = "end") : (f = t.state.selection.from, h = "start"), t.input.lastKeyCode = null;
  let m = aF(d.content, u.doc.content, u.from, f, h);
  if (m && t.input.domChangeCount++, (Xi && t.input.lastIOSEnter > Date.now() - 225 || So) && o.some((O) => O.nodeType == 1 && !tF.test(O.nodeName)) && (!m || m.endA >= m.endB) && t.someProp("handleKeyDown", (O) => O(t, Ia(13, "Enter")))) {
    t.input.lastIOSEnter = 0;
    return;
  }
  if (!m)
    if (r && l instanceof tt && !l.empty && l.$head.sameParent(l.$anchor) && !t.composing && !(u.sel && u.sel.anchor != u.sel.head))
      m = { start: l.from, endA: l.to, endB: l.to };
    else {
      if (u.sel) {
        let O = $v(t, t.state.doc, u.sel);
        if (O && !O.eq(t.state.selection)) {
          let R = t.state.tr.setSelection(O);
          a && R.setMeta("composition", a), t.dispatch(R);
        }
      }
      return;
    }
  t.state.selection.from < t.state.selection.to && m.start == m.endB && t.state.selection instanceof tt && (m.start > t.state.selection.from && m.start <= t.state.selection.from + 2 && t.state.selection.from >= u.from ? m.start = t.state.selection.from : m.endA < t.state.selection.to && m.endA >= t.state.selection.to - 2 && t.state.selection.to <= u.to && (m.endB += t.state.selection.to - m.endA, m.endA = t.state.selection.to)), zn && aa <= 11 && m.endB == m.start + 1 && m.endA == m.start && m.start > u.from && u.doc.textBetween(m.start - u.from - 1, m.start - u.from + 1) == "  " && (m.start--, m.endA--, m.endB--);
  let g = u.doc.resolveNoCache(m.start - u.from), y = u.doc.resolveNoCache(m.endB - u.from), b = c.resolve(m.start), C = g.sameParent(y) && g.parent.inlineContent && b.end() >= m.endA, k;
  if ((Xi && t.input.lastIOSEnter > Date.now() - 225 && (!C || o.some((O) => O.nodeName == "DIV" || O.nodeName == "P")) || !C && g.pos < u.doc.content.size && (!g.sameParent(y) || !g.parent.inlineContent) && !/\S/.test(u.doc.textBetween(g.pos, y.pos, "", "")) && (k = at.findFrom(u.doc.resolve(g.pos + 1), 1, !0)) && k.head > g.pos) && t.someProp("handleKeyDown", (O) => O(t, Ia(13, "Enter")))) {
    t.input.lastIOSEnter = 0;
    return;
  }
  if (t.state.selection.anchor > m.start && oF(c, m.start, m.endA, g, y) && t.someProp("handleKeyDown", (O) => O(t, Ia(8, "Backspace")))) {
    So && _n && t.domObserver.suppressSelectionUpdates();
    return;
  }
  _n && m.endB == m.start && (t.input.lastChromeDelete = Date.now()), So && !C && g.start() != y.start() && y.parentOffset == 0 && g.depth == y.depth && u.sel && u.sel.anchor == u.sel.head && u.sel.head == m.endA && (m.endB -= 2, y = u.doc.resolveNoCache(m.endB - u.from), setTimeout(() => {
    t.someProp("handleKeyDown", function(O) {
      return O(t, Ia(13, "Enter"));
    });
  }, 20));
  let v = m.start, E = m.endA, _, T, M;
  if (C) {
    if (g.pos == y.pos)
      zn && aa <= 11 && g.parentOffset == 0 && (t.domObserver.suppressSelectionUpdates(), setTimeout(() => Io(t), 20)), _ = t.state.tr.delete(v, E), T = c.resolve(m.start).marksAcross(c.resolve(m.endA));
    else if (
      // Adding or removing a mark
      m.endA == m.endB && (M = rF(g.parent.content.cut(g.parentOffset, y.parentOffset), b.parent.content.cut(b.parentOffset, m.endA - b.start())))
    )
      _ = t.state.tr, M.type == "add" ? _.addMark(v, E, M.mark) : _.removeMark(v, E, M.mark);
    else if (g.parent.child(g.index()).isText && g.index() == y.index() - (y.textOffset ? 0 : 1)) {
      let O = g.parent.textBetween(g.parentOffset, y.parentOffset);
      if (t.someProp("handleTextInput", (R) => R(t, v, E, O)))
        return;
      _ = t.state.tr.insertText(O, v, E);
    }
  }
  if (_ || (_ = t.state.tr.replace(v, E, u.doc.slice(m.start - u.from, m.endB - u.from))), u.sel) {
    let O = $v(t, _.doc, u.sel);
    O && !(_n && t.composing && O.empty && (m.start != m.endB || t.input.lastChromeDelete < Date.now() - 100) && (O.head == v || O.head == _.mapping.map(E) - 1) || zn && O.empty && O.head == v) && _.setSelection(O);
  }
  T && _.ensureMarks(T), a && _.setMeta("composition", a), t.dispatch(_.scrollIntoView());
}
function $v(t, e, n) {
  return Math.max(n.anchor, n.head) > e.content.size ? null : Ih(t, e.resolve(n.anchor), e.resolve(n.head));
}
function rF(t, e) {
  let n = t.firstChild.marks, r = e.firstChild.marks, o = n, a = r, i, s, l;
  for (let c = 0; c < r.length; c++)
    o = r[c].removeFromSet(o);
  for (let c = 0; c < n.length; c++)
    a = n[c].removeFromSet(a);
  if (o.length == 1 && a.length == 0)
    s = o[0], i = "add", l = (c) => c.mark(s.addToSet(c.marks));
  else if (o.length == 0 && a.length == 1)
    s = a[0], i = "remove", l = (c) => c.mark(s.removeFromSet(c.marks));
  else
    return null;
  let u = [];
  for (let c = 0; c < e.childCount; c++)
    u.push(l(e.child(c)));
  if (_e.from(u).eq(t))
    return { mark: s, type: i };
}
function oF(t, e, n, r, o) {
  if (
    // The content must have shrunk
    n - e <= o.pos - r.pos || // newEnd must point directly at or after the end of the block that newStart points into
    zd(r, !0, !1) < o.pos
  )
    return !1;
  let a = t.resolve(e);
  if (!r.parent.isTextblock) {
    let s = a.nodeAfter;
    return s != null && n == e + s.nodeSize;
  }
  if (a.parentOffset < a.parent.content.size || !a.parent.isTextblock)
    return !1;
  let i = t.resolve(zd(a, !0, !0));
  return !i.parent.isTextblock || i.pos > n || zd(i, !0, !1) < n ? !1 : r.parent.content.cut(r.parentOffset).eq(i.parent.content);
}
function zd(t, e, n) {
  let r = t.depth, o = e ? t.end() : t.pos;
  for (; r > 0 && (e || t.indexAfter(r) == t.node(r).childCount); )
    r--, o++, e = !1;
  if (n) {
    let a = t.node(r).maybeChild(t.indexAfter(r));
    for (; a && !a.isLeaf; )
      a = a.firstChild, o++;
  }
  return o;
}
function aF(t, e, n, r, o) {
  let a = t.findDiffStart(e, n);
  if (a == null)
    return null;
  let { a: i, b: s } = t.findDiffEnd(e, n + t.size, n + e.size);
  if (o == "end") {
    let l = Math.max(0, a - Math.min(i, s));
    r -= i + l - a;
  }
  if (i < a && t.size < e.size) {
    let l = r <= a && r >= i ? a - r : 0;
    a -= l, a && a < e.size && Rv(e.textBetween(a - 1, a + 1)) && (a += l ? 1 : -1), s = a + (s - i), i = a;
  } else if (s < a) {
    let l = r <= a && r >= s ? a - r : 0;
    a -= l, a && a < t.size && Rv(t.textBetween(a - 1, a + 1)) && (a += l ? 1 : -1), i = a + (i - s), s = a;
  }
  return { start: a, endA: i, endB: s };
}
function Rv(t) {
  if (t.length != 2)
    return !1;
  let e = t.charCodeAt(0), n = t.charCodeAt(1);
  return e >= 56320 && e <= 57343 && n >= 55296 && n <= 56319;
}
class iF {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(e, n) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new EB(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = n, this.state = n.state, this.directPlugins = n.plugins || [], this.directPlugins.forEach(Hv), this.dispatch = this.dispatch.bind(this), this.dom = e && e.mount || document.createElement("div"), e && (e.appendChild ? e.appendChild(this.dom) : typeof e == "function" ? e(this.dom) : e.mount && (this.mounted = !0)), this.editable = Fv(this), Bv(this), this.nodeViews = Vv(this), this.docView = vv(this.state.doc, Lv(this), jd(this), this.dom, this), this.domObserver = new GB(this, (r, o, a, i) => nF(this, r, o, a, i)), this.domObserver.start(), OB(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let e = this._props;
      this._props = {};
      for (let n in e)
        this._props[n] = e[n];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(e) {
    e.handleDOMEvents != this._props.handleDOMEvents && op(this);
    let n = this._props;
    this._props = e, e.plugins && (e.plugins.forEach(Hv), this.directPlugins = e.plugins), this.updateStateInner(e.state, n);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(e) {
    let n = {};
    for (let r in this._props)
      n[r] = this._props[r];
    n.state = this.state;
    for (let r in e)
      n[r] = e[r];
    this.update(n);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(e) {
    this.updateStateInner(e, this._props);
  }
  updateStateInner(e, n) {
    var r;
    let o = this.state, a = !1, i = !1;
    e.storedMarks && this.composing && (Dw(this), i = !0), this.state = e;
    let s = o.plugins != e.plugins || this._props.plugins != n.plugins;
    if (s || this._props.plugins != n.plugins || this._props.nodeViews != n.nodeViews) {
      let h = Vv(this);
      lF(h, this.nodeViews) && (this.nodeViews = h, a = !0);
    }
    (s || n.handleDOMEvents != this._props.handleDOMEvents) && op(this), this.editable = Fv(this), Bv(this);
    let l = jd(this), u = Lv(this), c = o.plugins != e.plugins && !o.doc.eq(e.doc) ? "reset" : e.scrollToSelection > o.scrollToSelection ? "to selection" : "preserve", d = a || !this.docView.matchesNode(e.doc, u, l);
    (d || !e.selection.eq(o.selection)) && (i = !0);
    let f = c == "preserve" && i && this.dom.style.overflowAnchor == null && FL(this);
    if (i) {
      this.domObserver.stop();
      let h = d && (zn || _n) && !this.composing && !o.selection.empty && !e.selection.empty && sF(o.selection, e.selection);
      if (d) {
        let m = _n ? this.trackWrites = this.domSelectionRange().focusNode : null;
        this.composing && (this.input.compositionNode = BB(this)), (a || !this.docView.update(e.doc, u, l, this)) && (this.docView.updateOuterDeco(u), this.docView.destroy(), this.docView = vv(e.doc, u, l, this.dom, this)), m && !this.trackWrites && (h = !0);
      }
      h || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && uB(this)) ? Io(this, h) : (kw(this, e.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(o), !((r = this.dragging) === null || r === void 0) && r.node && !o.doc.eq(e.doc) && this.updateDraggedNode(this.dragging, o), c == "reset" ? this.dom.scrollTop = 0 : c == "to selection" ? this.scrollToSelection() : f && VL(f);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let e = this.domSelectionRange().focusNode;
    if (!(!e || !this.dom.contains(e.nodeType == 1 ? e : e.parentNode))) {
      if (!this.someProp("handleScrollToSelection", (n) => n(this))) if (this.state.selection instanceof je) {
        let n = this.docView.domAfterPos(this.state.selection.from);
        n.nodeType == 1 && dv(this, n.getBoundingClientRect(), e);
      } else
        dv(this, this.coordsAtPos(this.state.selection.head, 1), e);
    }
  }
  destroyPluginViews() {
    let e;
    for (; e = this.pluginViews.pop(); )
      e.destroy && e.destroy();
  }
  updatePluginViews(e) {
    if (!e || e.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let n = 0; n < this.directPlugins.length; n++) {
        let r = this.directPlugins[n];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
      for (let n = 0; n < this.state.plugins.length; n++) {
        let r = this.state.plugins[n];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
    } else
      for (let n = 0; n < this.pluginViews.length; n++) {
        let r = this.pluginViews[n];
        r.update && r.update(this, e);
      }
  }
  updateDraggedNode(e, n) {
    let r = e.node, o = -1;
    if (this.state.doc.nodeAt(r.from) == r.node)
      o = r.from;
    else {
      let a = r.from + (this.state.doc.content.size - n.doc.content.size);
      (a > 0 && this.state.doc.nodeAt(a)) == r.node && (o = a);
    }
    this.dragging = new Nw(e.slice, e.move, o < 0 ? void 0 : je.create(this.state.doc, o));
  }
  someProp(e, n) {
    let r = this._props && this._props[e], o;
    if (r != null && (o = n ? n(r) : r))
      return o;
    for (let i = 0; i < this.directPlugins.length; i++) {
      let s = this.directPlugins[i].props[e];
      if (s != null && (o = n ? n(s) : s))
        return o;
    }
    let a = this.state.plugins;
    if (a)
      for (let i = 0; i < a.length; i++) {
        let s = a[i].props[e];
        if (s != null && (o = n ? n(s) : s))
          return o;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (zn) {
      let e = this.root.activeElement;
      if (e == this.dom)
        return !0;
      if (!e || !this.dom.contains(e))
        return !1;
      for (; e && this.dom != e && this.dom.contains(e); ) {
        if (e.contentEditable == "false")
          return !1;
        e = e.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && HL(this.dom), Io(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let e = this._root;
    if (e == null) {
      for (let n = this.dom.parentNode; n; n = n.parentNode)
        if (n.nodeType == 9 || n.nodeType == 11 && n.host)
          return n.getSelection || (Object.getPrototypeOf(n).getSelection = () => n.ownerDocument.getSelection()), this._root = n;
    }
    return e || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(e) {
    return zL(this, e);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(e, n = 1) {
    return fw(this, e, n);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(e, n = 0) {
    return this.docView.domFromPos(e, n);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(e) {
    let n = this.docView.descAt(e);
    return n ? n.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(e, n, r = -1) {
    let o = this.docView.posFromDOM(e, n, r);
    if (o == null)
      throw new RangeError("DOM position not inside the editor");
    return o;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(e, n) {
    return XL(this, n || this.state, e);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(e, n) {
    return fl(this, "", e, !1, n || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(e, n) {
    return fl(this, e, null, !0, n || new ClipboardEvent("paste"));
  }
  /**
  Serialize the given slice as it would be if it was copied from
  this editor. Returns a DOM element that contains a
  representation of the slice as its children, a textual
  representation, and the transformed slice (which can be
  different from the given input due to hooks like
  [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
  */
  serializeForClipboard(e) {
    return Dh(this, e);
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (TB(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], jd(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, xL());
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(e) {
    return xB(this, e);
  }
  /**
  Dispatch a transaction. Will call
  [`dispatchTransaction`](https://prosemirror.net/docs/ref/#view.DirectEditorProps.dispatchTransaction)
  when given, and otherwise defaults to applying the transaction to
  the current state and calling
  [`updateState`](https://prosemirror.net/docs/ref/#view.EditorView.updateState) with the result.
  This method is bound to the view instance, so that it can be
  easily passed around.
  */
  dispatch(e) {
    let n = this._props.dispatchTransaction;
    n ? n.call(this, e) : this.updateState(this.state.apply(e));
  }
  /**
  @internal
  */
  domSelectionRange() {
    let e = this.domSelection();
    return e ? Rn && this.root.nodeType === 11 && PL(this.dom.ownerDocument) == this.dom && XB(this, e) || e : { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
function Lv(t) {
  let e = /* @__PURE__ */ Object.create(null);
  return e.class = "ProseMirror", e.contenteditable = String(t.editable), t.someProp("attributes", (n) => {
    if (typeof n == "function" && (n = n(t.state)), n)
      for (let r in n)
        r == "class" ? e.class += " " + n[r] : r == "style" ? e.style = (e.style ? e.style + ";" : "") + n[r] : !e[r] && r != "contenteditable" && r != "nodeName" && (e[r] = String(n[r]));
  }), e.translate || (e.translate = "no"), [dr.node(0, t.state.doc.content.size, e)];
}
function Bv(t) {
  if (t.markCursor) {
    let e = document.createElement("img");
    e.className = "ProseMirror-separator", e.setAttribute("mark-placeholder", "true"), e.setAttribute("alt", ""), t.cursorWrapper = { dom: e, deco: dr.widget(t.state.selection.from, e, { raw: !0, marks: t.markCursor }) };
  } else
    t.cursorWrapper = null;
}
function Fv(t) {
  return !t.someProp("editable", (e) => e(t.state) === !1);
}
function sF(t, e) {
  let n = Math.min(t.$anchor.sharedDepth(t.head), e.$anchor.sharedDepth(e.head));
  return t.$anchor.start(n) != e.$anchor.start(n);
}
function Vv(t) {
  let e = /* @__PURE__ */ Object.create(null);
  function n(r) {
    for (let o in r)
      Object.prototype.hasOwnProperty.call(e, o) || (e[o] = r[o]);
  }
  return t.someProp("nodeViews", n), t.someProp("markViews", n), e;
}
function lF(t, e) {
  let n = 0, r = 0;
  for (let o in t) {
    if (t[o] != e[o])
      return !0;
    n++;
  }
  for (let o in e)
    r++;
  return n != r;
}
function Hv(t) {
  if (t.spec.state || t.spec.filterTransaction || t.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var pa = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, Fu = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, uF = typeof navigator < "u" && /Mac/.test(navigator.platform), cF = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var mn = 0; mn < 10; mn++) pa[48 + mn] = pa[96 + mn] = String(mn);
for (var mn = 1; mn <= 24; mn++) pa[mn + 111] = "F" + mn;
for (var mn = 65; mn <= 90; mn++)
  pa[mn] = String.fromCharCode(mn + 32), Fu[mn] = String.fromCharCode(mn);
for (var Yd in pa) Fu.hasOwnProperty(Yd) || (Fu[Yd] = pa[Yd]);
function dF(t) {
  var e = uF && t.metaKey && t.shiftKey && !t.ctrlKey && !t.altKey || cF && t.shiftKey && t.key && t.key.length == 1 || t.key == "Unidentified", n = !e && t.key || (t.shiftKey ? Fu : pa)[t.keyCode] || t.key || "Unidentified";
  return n == "Esc" && (n = "Escape"), n == "Del" && (n = "Delete"), n == "Left" && (n = "ArrowLeft"), n == "Up" && (n = "ArrowUp"), n == "Right" && (n = "ArrowRight"), n == "Down" && (n = "ArrowDown"), n;
}
const fF = typeof navigator < "u" && /Mac|iP(hone|[oa]d)/.test(navigator.platform), pF = typeof navigator < "u" && /Win/.test(navigator.platform);
function hF(t) {
  let e = t.split(/-(?!$)/), n = e[e.length - 1];
  n == "Space" && (n = " ");
  let r, o, a, i;
  for (let s = 0; s < e.length - 1; s++) {
    let l = e[s];
    if (/^(cmd|meta|m)$/i.test(l))
      i = !0;
    else if (/^a(lt)?$/i.test(l))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      o = !0;
    else if (/^s(hift)?$/i.test(l))
      a = !0;
    else if (/^mod$/i.test(l))
      fF ? i = !0 : o = !0;
    else
      throw new Error("Unrecognized modifier name: " + l);
  }
  return r && (n = "Alt-" + n), o && (n = "Ctrl-" + n), i && (n = "Meta-" + n), a && (n = "Shift-" + n), n;
}
function mF(t) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let n in t)
    e[hF(n)] = t[n];
  return e;
}
function qd(t, e, n = !0) {
  return e.altKey && (t = "Alt-" + t), e.ctrlKey && (t = "Ctrl-" + t), e.metaKey && (t = "Meta-" + t), n && e.shiftKey && (t = "Shift-" + t), t;
}
function gF(t) {
  return new rn({ props: { handleKeyDown: Fw(t) } });
}
function Fw(t) {
  let e = mF(t);
  return function(n, r) {
    let o = dF(r), a, i = e[qd(o, r)];
    if (i && i(n.state, n.dispatch, n))
      return !0;
    if (o.length == 1 && o != " ") {
      if (r.shiftKey) {
        let s = e[qd(o, r, !1)];
        if (s && s(n.state, n.dispatch, n))
          return !0;
      }
      if ((r.altKey || r.metaKey || r.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
      !(pF && r.ctrlKey && r.altKey) && (a = pa[r.keyCode]) && a != o) {
        let s = e[qd(a, r)];
        if (s && s(n.state, n.dispatch, n))
          return !0;
      }
    }
    return !1;
  };
}
const Bh = (t, e) => t.selection.empty ? !1 : (e && e(t.tr.deleteSelection().scrollIntoView()), !0);
function Vw(t, e) {
  let { $cursor: n } = t.selection;
  return !n || (e ? !e.endOfTextblock("backward", t) : n.parentOffset > 0) ? null : n;
}
const Hw = (t, e, n) => {
  let r = Vw(t, n);
  if (!r)
    return !1;
  let o = Fh(r);
  if (!o) {
    let i = r.blockRange(), s = i && ys(i);
    return s == null ? !1 : (e && e(t.tr.lift(i, s).scrollIntoView()), !0);
  }
  let a = o.nodeBefore;
  if (Jw(t, o, e, -1))
    return !0;
  if (r.parent.content.size == 0 && (Qi(a, "end") || je.isSelectable(a)))
    for (let i = r.depth; ; i--) {
      let s = Gc(t.doc, r.before(i), r.after(i), Pe.empty);
      if (s && s.slice.size < s.to - s.from) {
        if (e) {
          let l = t.tr.step(s);
          l.setSelection(Qi(a, "end") ? at.findFrom(l.doc.resolve(l.mapping.map(o.pos, -1)), -1) : je.create(l.doc, o.pos - a.nodeSize)), e(l.scrollIntoView());
        }
        return !0;
      }
      if (i == 1 || r.node(i - 1).childCount > 1)
        break;
    }
  return a.isAtom && o.depth == r.depth - 1 ? (e && e(t.tr.delete(o.pos - a.nodeSize, o.pos).scrollIntoView()), !0) : !1;
}, vF = (t, e, n) => {
  let r = Vw(t, n);
  if (!r)
    return !1;
  let o = Fh(r);
  return o ? Uw(t, o, e) : !1;
}, yF = (t, e, n) => {
  let r = Kw(t, n);
  if (!r)
    return !1;
  let o = Vh(r);
  return o ? Uw(t, o, e) : !1;
};
function Uw(t, e, n) {
  let r = e.nodeBefore, o = r, a = e.pos - 1;
  for (; !o.isTextblock; a--) {
    if (o.type.spec.isolating)
      return !1;
    let c = o.lastChild;
    if (!c)
      return !1;
    o = c;
  }
  let i = e.nodeAfter, s = i, l = e.pos + 1;
  for (; !s.isTextblock; l++) {
    if (s.type.spec.isolating)
      return !1;
    let c = s.firstChild;
    if (!c)
      return !1;
    s = c;
  }
  let u = Gc(t.doc, a, l, Pe.empty);
  if (!u || u.from != a || u instanceof ln && u.slice.size >= l - a)
    return !1;
  if (n) {
    let c = t.tr.step(u);
    c.setSelection(tt.create(c.doc, a)), n(c.scrollIntoView());
  }
  return !0;
}
function Qi(t, e, n = !1) {
  for (let r = t; r; r = e == "start" ? r.firstChild : r.lastChild) {
    if (r.isTextblock)
      return !0;
    if (n && r.childCount != 1)
      return !1;
  }
  return !1;
}
const Ww = (t, e, n) => {
  let { $head: r, empty: o } = t.selection, a = r;
  if (!o)
    return !1;
  if (r.parent.isTextblock) {
    if (n ? !n.endOfTextblock("backward", t) : r.parentOffset > 0)
      return !1;
    a = Fh(r);
  }
  let i = a && a.nodeBefore;
  return !i || !je.isSelectable(i) ? !1 : (e && e(t.tr.setSelection(je.create(t.doc, a.pos - i.nodeSize)).scrollIntoView()), !0);
};
function Fh(t) {
  if (!t.parent.type.spec.isolating)
    for (let e = t.depth - 1; e >= 0; e--) {
      if (t.index(e) > 0)
        return t.doc.resolve(t.before(e + 1));
      if (t.node(e).type.spec.isolating)
        break;
    }
  return null;
}
function Kw(t, e) {
  let { $cursor: n } = t.selection;
  return !n || (e ? !e.endOfTextblock("forward", t) : n.parentOffset < n.parent.content.size) ? null : n;
}
const jw = (t, e, n) => {
  let r = Kw(t, n);
  if (!r)
    return !1;
  let o = Vh(r);
  if (!o)
    return !1;
  let a = o.nodeAfter;
  if (Jw(t, o, e, 1))
    return !0;
  if (r.parent.content.size == 0 && (Qi(a, "start") || je.isSelectable(a))) {
    let i = Gc(t.doc, r.before(), r.after(), Pe.empty);
    if (i && i.slice.size < i.to - i.from) {
      if (e) {
        let s = t.tr.step(i);
        s.setSelection(Qi(a, "start") ? at.findFrom(s.doc.resolve(s.mapping.map(o.pos)), 1) : je.create(s.doc, s.mapping.map(o.pos))), e(s.scrollIntoView());
      }
      return !0;
    }
  }
  return a.isAtom && o.depth == r.depth - 1 ? (e && e(t.tr.delete(o.pos, o.pos + a.nodeSize).scrollIntoView()), !0) : !1;
}, zw = (t, e, n) => {
  let { $head: r, empty: o } = t.selection, a = r;
  if (!o)
    return !1;
  if (r.parent.isTextblock) {
    if (n ? !n.endOfTextblock("forward", t) : r.parentOffset < r.parent.content.size)
      return !1;
    a = Vh(r);
  }
  let i = a && a.nodeAfter;
  return !i || !je.isSelectable(i) ? !1 : (e && e(t.tr.setSelection(je.create(t.doc, a.pos)).scrollIntoView()), !0);
};
function Vh(t) {
  if (!t.parent.type.spec.isolating)
    for (let e = t.depth - 1; e >= 0; e--) {
      let n = t.node(e);
      if (t.index(e) + 1 < n.childCount)
        return t.doc.resolve(t.after(e + 1));
      if (n.type.spec.isolating)
        break;
    }
  return null;
}
const bF = (t, e) => {
  let n = t.selection, r = n instanceof je, o;
  if (r) {
    if (n.node.isTextblock || !wa(t.doc, n.from))
      return !1;
    o = n.from;
  } else if (o = qc(t.doc, n.from, -1), o == null)
    return !1;
  if (e) {
    let a = t.tr.join(o);
    r && a.setSelection(je.create(a.doc, o - t.doc.resolve(o).nodeBefore.nodeSize)), e(a.scrollIntoView());
  }
  return !0;
}, kF = (t, e) => {
  let n = t.selection, r;
  if (n instanceof je) {
    if (n.node.isTextblock || !wa(t.doc, n.to))
      return !1;
    r = n.to;
  } else if (r = qc(t.doc, n.to, 1), r == null)
    return !1;
  return e && e(t.tr.join(r).scrollIntoView()), !0;
}, wF = (t, e) => {
  let { $from: n, $to: r } = t.selection, o = n.blockRange(r), a = o && ys(o);
  return a == null ? !1 : (e && e(t.tr.lift(o, a).scrollIntoView()), !0);
}, Yw = (t, e) => {
  let { $head: n, $anchor: r } = t.selection;
  return !n.parent.type.spec.code || !n.sameParent(r) ? !1 : (e && e(t.tr.insertText(`
`).scrollIntoView()), !0);
};
function Hh(t) {
  for (let e = 0; e < t.edgeCount; e++) {
    let { type: n } = t.edge(e);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
const _F = (t, e) => {
  let { $head: n, $anchor: r } = t.selection;
  if (!n.parent.type.spec.code || !n.sameParent(r))
    return !1;
  let o = n.node(-1), a = n.indexAfter(-1), i = Hh(o.contentMatchAt(a));
  if (!i || !o.canReplaceWith(a, a, i))
    return !1;
  if (e) {
    let s = n.after(), l = t.tr.replaceWith(s, s, i.createAndFill());
    l.setSelection(at.near(l.doc.resolve(s), 1)), e(l.scrollIntoView());
  }
  return !0;
}, qw = (t, e) => {
  let n = t.selection, { $from: r, $to: o } = n;
  if (n instanceof tr || r.parent.inlineContent || o.parent.inlineContent)
    return !1;
  let a = Hh(o.parent.contentMatchAt(o.indexAfter()));
  if (!a || !a.isTextblock)
    return !1;
  if (e) {
    let i = (!r.parentOffset && o.index() < o.parent.childCount ? r : o).pos, s = t.tr.insert(i, a.createAndFill());
    s.setSelection(tt.create(s.doc, i + 1)), e(s.scrollIntoView());
  }
  return !0;
}, Gw = (t, e) => {
  let { $cursor: n } = t.selection;
  if (!n || n.parent.content.size)
    return !1;
  if (n.depth > 1 && n.after() != n.end(-1)) {
    let a = n.before();
    if (Mo(t.doc, a))
      return e && e(t.tr.split(a).scrollIntoView()), !0;
  }
  let r = n.blockRange(), o = r && ys(r);
  return o == null ? !1 : (e && e(t.tr.lift(r, o).scrollIntoView()), !0);
};
function CF(t) {
  return (e, n) => {
    let { $from: r, $to: o } = e.selection;
    if (e.selection instanceof je && e.selection.node.isBlock)
      return !r.parentOffset || !Mo(e.doc, r.pos) ? !1 : (n && n(e.tr.split(r.pos).scrollIntoView()), !0);
    if (!r.depth)
      return !1;
    let a = [], i, s, l = !1, u = !1;
    for (let h = r.depth; ; h--)
      if (r.node(h).isBlock) {
        l = r.end(h) == r.pos + (r.depth - h), u = r.start(h) == r.pos - (r.depth - h), s = Hh(r.node(h - 1).contentMatchAt(r.indexAfter(h - 1))), a.unshift(l && s ? { type: s } : null), i = h;
        break;
      } else {
        if (h == 1)
          return !1;
        a.unshift(null);
      }
    let c = e.tr;
    (e.selection instanceof tt || e.selection instanceof tr) && c.deleteSelection();
    let d = c.mapping.map(r.pos), f = Mo(c.doc, d, a.length, a);
    if (f || (a[0] = s ? { type: s } : null, f = Mo(c.doc, d, a.length, a)), !f)
      return !1;
    if (c.split(d, a.length, a), !l && u && r.node(i).type != s) {
      let h = c.mapping.map(r.before(i)), m = c.doc.resolve(h);
      s && r.node(i - 1).canReplaceWith(m.index(), m.index() + 1, s) && c.setNodeMarkup(c.mapping.map(r.before(i)), s);
    }
    return n && n(c.scrollIntoView()), !0;
  };
}
const EF = CF(), OF = (t, e) => {
  let { $from: n, to: r } = t.selection, o, a = n.sharedDepth(r);
  return a == 0 ? !1 : (o = n.before(a), e && e(t.tr.setSelection(je.create(t.doc, o))), !0);
};
function TF(t, e, n) {
  let r = e.nodeBefore, o = e.nodeAfter, a = e.index();
  return !r || !o || !r.type.compatibleContent(o.type) ? !1 : !r.content.size && e.parent.canReplace(a - 1, a) ? (n && n(t.tr.delete(e.pos - r.nodeSize, e.pos).scrollIntoView()), !0) : !e.parent.canReplace(a, a + 1) || !(o.isTextblock || wa(t.doc, e.pos)) ? !1 : (n && n(t.tr.join(e.pos).scrollIntoView()), !0);
}
function Jw(t, e, n, r) {
  let o = e.nodeBefore, a = e.nodeAfter, i, s, l = o.type.spec.isolating || a.type.spec.isolating;
  if (!l && TF(t, e, n))
    return !0;
  let u = !l && e.parent.canReplace(e.index(), e.index() + 1);
  if (u && (i = (s = o.contentMatchAt(o.childCount)).findWrapping(a.type)) && s.matchType(i[0] || a.type).validEnd) {
    if (n) {
      let h = e.pos + a.nodeSize, m = _e.empty;
      for (let b = i.length - 1; b >= 0; b--)
        m = _e.from(i[b].create(null, m));
      m = _e.from(o.copy(m));
      let g = t.tr.step(new un(e.pos - 1, h, e.pos, h, new Pe(m, 1, 0), i.length, !0)), y = g.doc.resolve(h + 2 * i.length);
      y.nodeAfter && y.nodeAfter.type == o.type && wa(g.doc, y.pos) && g.join(y.pos), n(g.scrollIntoView());
    }
    return !0;
  }
  let c = a.type.spec.isolating || r > 0 && l ? null : at.findFrom(e, 1), d = c && c.$from.blockRange(c.$to), f = d && ys(d);
  if (f != null && f >= e.depth)
    return n && n(t.tr.lift(d, f).scrollIntoView()), !0;
  if (u && Qi(a, "start", !0) && Qi(o, "end")) {
    let h = o, m = [];
    for (; m.push(h), !h.isTextblock; )
      h = h.lastChild;
    let g = a, y = 1;
    for (; !g.isTextblock; g = g.firstChild)
      y++;
    if (h.canReplace(h.childCount, h.childCount, g.content)) {
      if (n) {
        let b = _e.empty;
        for (let k = m.length - 1; k >= 0; k--)
          b = _e.from(m[k].copy(b));
        let C = t.tr.step(new un(e.pos - m.length, e.pos + a.nodeSize, e.pos + y, e.pos + a.nodeSize - y, new Pe(b, m.length, 0), 0, !0));
        n(C.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function Xw(t) {
  return function(e, n) {
    let r = e.selection, o = t < 0 ? r.$from : r.$to, a = o.depth;
    for (; o.node(a).isInline; ) {
      if (!a)
        return !1;
      a--;
    }
    return o.node(a).isTextblock ? (n && n(e.tr.setSelection(tt.create(e.doc, t < 0 ? o.start(a) : o.end(a)))), !0) : !1;
  };
}
const SF = Xw(-1), xF = Xw(1);
function AF(t, e = null) {
  return function(n, r) {
    let { $from: o, $to: a } = n.selection, i = o.blockRange(a), s = i && Sh(i, t, e);
    return s ? (r && r(n.tr.wrap(i, s).scrollIntoView()), !0) : !1;
  };
}
function Uv(t, e = null) {
  return function(n, r) {
    let o = !1;
    for (let a = 0; a < n.selection.ranges.length && !o; a++) {
      let { $from: { pos: i }, $to: { pos: s } } = n.selection.ranges[a];
      n.doc.nodesBetween(i, s, (l, u) => {
        if (o)
          return !1;
        if (!(!l.isTextblock || l.hasMarkup(t, e)))
          if (l.type == t)
            o = !0;
          else {
            let c = n.doc.resolve(u), d = c.index();
            o = c.parent.canReplaceWith(d, d + 1, t);
          }
      });
    }
    if (!o)
      return !1;
    if (r) {
      let a = n.tr;
      for (let i = 0; i < n.selection.ranges.length; i++) {
        let { $from: { pos: s }, $to: { pos: l } } = n.selection.ranges[i];
        a.setBlockType(s, l, t, e);
      }
      r(a.scrollIntoView());
    }
    return !0;
  };
}
function Uh(...t) {
  return function(e, n, r) {
    for (let o = 0; o < t.length; o++)
      if (t[o](e, n, r))
        return !0;
    return !1;
  };
}
Uh(Bh, Hw, Ww);
Uh(Bh, jw, zw);
Uh(Yw, qw, Gw, EF);
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function MF(t, e = null) {
  return function(n, r) {
    let { $from: o, $to: a } = n.selection, i = o.blockRange(a);
    if (!i)
      return !1;
    let s = r ? n.tr : null;
    return IF(s, i, t, e) ? (r && r(s.scrollIntoView()), !0) : !1;
  };
}
function IF(t, e, n, r = null) {
  let o = !1, a = e, i = e.$from.doc;
  if (e.depth >= 2 && e.$from.node(e.depth - 1).type.compatibleContent(n) && e.startIndex == 0) {
    if (e.$from.index(e.depth - 1) == 0)
      return !1;
    let l = i.resolve(e.start - 2);
    a = new Du(l, l, e.depth), e.endIndex < e.parent.childCount && (e = new Du(e.$from, i.resolve(e.$to.end(e.depth)), e.depth)), o = !0;
  }
  let s = Sh(a, n, r, e);
  return s ? (t && DF(t, e, s, o, n), !0) : !1;
}
function DF(t, e, n, r, o) {
  let a = _e.empty;
  for (let c = n.length - 1; c >= 0; c--)
    a = _e.from(n[c].type.create(n[c].attrs, a));
  t.step(new un(e.start - (r ? 2 : 0), e.end, e.start, e.end, new Pe(a, 0, 0), n.length, !0));
  let i = 0;
  for (let c = 0; c < n.length; c++)
    n[c].type == o && (i = c + 1);
  let s = n.length - i, l = e.start + n.length - (r ? 2 : 0), u = e.parent;
  for (let c = e.startIndex, d = e.endIndex, f = !0; c < d; c++, f = !1)
    !f && Mo(t.doc, l, s) && (t.split(l, s), l += 2 * s), l += u.child(c).nodeSize;
  return t;
}
function PF(t) {
  return function(e, n) {
    let { $from: r, $to: o } = e.selection, a = r.blockRange(o, (i) => i.childCount > 0 && i.firstChild.type == t);
    return a ? n ? r.node(a.depth - 1).type == t ? NF(e, n, t, a) : $F(e, n, a) : !0 : !1;
  };
}
function NF(t, e, n, r) {
  let o = t.tr, a = r.end, i = r.$to.end(r.depth);
  a < i && (o.step(new un(a - 1, i, a, i, new Pe(_e.from(n.create(null, r.parent.copy())), 1, 0), 1, !0)), r = new Du(o.doc.resolve(r.$from.pos), o.doc.resolve(i), r.depth));
  const s = ys(r);
  if (s == null)
    return !1;
  o.lift(r, s);
  let l = o.doc.resolve(o.mapping.map(a, -1) - 1);
  return wa(o.doc, l.pos) && l.nodeBefore.type == l.nodeAfter.type && o.join(l.pos), e(o.scrollIntoView()), !0;
}
function $F(t, e, n) {
  let r = t.tr, o = n.parent;
  for (let h = n.end, m = n.endIndex - 1, g = n.startIndex; m > g; m--)
    h -= o.child(m).nodeSize, r.delete(h - 1, h + 1);
  let a = r.doc.resolve(n.start), i = a.nodeAfter;
  if (r.mapping.map(n.end) != n.start + a.nodeAfter.nodeSize)
    return !1;
  let s = n.startIndex == 0, l = n.endIndex == o.childCount, u = a.node(-1), c = a.index(-1);
  if (!u.canReplace(c + (s ? 0 : 1), c + 1, i.content.append(l ? _e.empty : _e.from(o))))
    return !1;
  let d = a.pos, f = d + i.nodeSize;
  return r.step(new un(d - (s ? 1 : 0), f + (l ? 1 : 0), d + 1, f - 1, new Pe((s ? _e.empty : _e.from(o.copy(_e.empty))).append(l ? _e.empty : _e.from(o.copy(_e.empty))), s ? 0 : 1, l ? 0 : 1), s ? 0 : 1)), e(r.scrollIntoView()), !0;
}
function RF(t) {
  return function(e, n) {
    let { $from: r, $to: o } = e.selection, a = r.blockRange(o, (u) => u.childCount > 0 && u.firstChild.type == t);
    if (!a)
      return !1;
    let i = a.startIndex;
    if (i == 0)
      return !1;
    let s = a.parent, l = s.child(i - 1);
    if (l.type != t)
      return !1;
    if (n) {
      let u = l.lastChild && l.lastChild.type == s.type, c = _e.from(u ? t.create() : null), d = new Pe(_e.from(t.create(null, _e.from(s.type.create(null, c)))), u ? 3 : 1, 0), f = a.start, h = a.end;
      n(e.tr.step(new un(f - (u ? 3 : 1), h, f, h, d, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
function ed(t) {
  const { state: e, transaction: n } = t;
  let { selection: r } = n, { doc: o } = n, { storedMarks: a } = n;
  return {
    ...e,
    apply: e.apply.bind(e),
    applyTransaction: e.applyTransaction.bind(e),
    plugins: e.plugins,
    schema: e.schema,
    reconfigure: e.reconfigure.bind(e),
    toJSON: e.toJSON.bind(e),
    get storedMarks() {
      return a;
    },
    get selection() {
      return r;
    },
    get doc() {
      return o;
    },
    get tr() {
      return r = n.selection, o = n.doc, a = n.storedMarks, n;
    }
  };
}
class td {
  constructor(e) {
    this.editor = e.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = e.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: e, editor: n, state: r } = this, { view: o } = n, { tr: a } = r, i = this.buildProps(a);
    return Object.fromEntries(Object.entries(e).map(([s, l]) => [s, (...c) => {
      const d = l(...c)(i);
      return !a.getMeta("preventDispatch") && !this.hasCustomState && o.dispatch(a), d;
    }]));
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(e, n = !0) {
    const { rawCommands: r, editor: o, state: a } = this, { view: i } = o, s = [], l = !!e, u = e || a.tr, c = () => (!l && n && !u.getMeta("preventDispatch") && !this.hasCustomState && i.dispatch(u), s.every((f) => f === !0)), d = {
      ...Object.fromEntries(Object.entries(r).map(([f, h]) => [f, (...g) => {
        const y = this.buildProps(u, n), b = h(...g)(y);
        return s.push(b), d;
      }])),
      run: c
    };
    return d;
  }
  createCan(e) {
    const { rawCommands: n, state: r } = this, o = !1, a = e || r.tr, i = this.buildProps(a, o);
    return {
      ...Object.fromEntries(Object.entries(n).map(([l, u]) => [l, (...c) => u(...c)({ ...i, dispatch: void 0 })])),
      chain: () => this.createChain(a, o)
    };
  }
  buildProps(e, n = !0) {
    const { rawCommands: r, editor: o, state: a } = this, { view: i } = o, s = {
      tr: e,
      editor: o,
      view: i,
      state: ed({
        state: a,
        transaction: e
      }),
      dispatch: n ? () => {
      } : void 0,
      chain: () => this.createChain(e, n),
      can: () => this.createCan(e),
      get commands() {
        return Object.fromEntries(Object.entries(r).map(([l, u]) => [l, (...c) => u(...c)(s)]));
      }
    };
    return s;
  }
}
class LF {
  constructor() {
    this.callbacks = {};
  }
  on(e, n) {
    return this.callbacks[e] || (this.callbacks[e] = []), this.callbacks[e].push(n), this;
  }
  emit(e, ...n) {
    const r = this.callbacks[e];
    return r && r.forEach((o) => o.apply(this, n)), this;
  }
  off(e, n) {
    const r = this.callbacks[e];
    return r && (n ? this.callbacks[e] = r.filter((o) => o !== n) : delete this.callbacks[e]), this;
  }
  once(e, n) {
    const r = (...o) => {
      this.off(e, r), n.apply(this, o);
    };
    return this.on(e, r);
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}
function Be(t, e, n) {
  return t.config[e] === void 0 && t.parent ? Be(t.parent, e, n) : typeof t.config[e] == "function" ? t.config[e].bind({
    ...n,
    parent: t.parent ? Be(t.parent, e, n) : null
  }) : t.config[e];
}
function nd(t) {
  const e = t.filter((o) => o.type === "extension"), n = t.filter((o) => o.type === "node"), r = t.filter((o) => o.type === "mark");
  return {
    baseExtensions: e,
    nodeExtensions: n,
    markExtensions: r
  };
}
function Qw(t) {
  const e = [], { nodeExtensions: n, markExtensions: r } = nd(t), o = [...n, ...r], a = {
    default: null,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  };
  return t.forEach((i) => {
    const s = {
      name: i.name,
      options: i.options,
      storage: i.storage,
      extensions: o
    }, l = Be(i, "addGlobalAttributes", s);
    if (!l)
      return;
    l().forEach((c) => {
      c.types.forEach((d) => {
        Object.entries(c.attributes).forEach(([f, h]) => {
          e.push({
            type: d,
            name: f,
            attribute: {
              ...a,
              ...h
            }
          });
        });
      });
    });
  }), o.forEach((i) => {
    const s = {
      name: i.name,
      options: i.options,
      storage: i.storage
    }, l = Be(i, "addAttributes", s);
    if (!l)
      return;
    const u = l();
    Object.entries(u).forEach(([c, d]) => {
      const f = {
        ...a,
        ...d
      };
      typeof (f == null ? void 0 : f.default) == "function" && (f.default = f.default()), f != null && f.isRequired && (f == null ? void 0 : f.default) === void 0 && delete f.default, e.push({
        type: i.name,
        name: c,
        attribute: f
      });
    });
  }), e;
}
function dn(t, e) {
  if (typeof t == "string") {
    if (!e.nodes[t])
      throw Error(`There is no node type named '${t}'. Maybe you forgot to add the extension?`);
    return e.nodes[t];
  }
  return t;
}
function nn(...t) {
  return t.filter((e) => !!e).reduce((e, n) => {
    const r = { ...e };
    return Object.entries(n).forEach(([o, a]) => {
      if (!r[o]) {
        r[o] = a;
        return;
      }
      if (o === "class") {
        const s = a ? String(a).split(" ") : [], l = r[o] ? r[o].split(" ") : [], u = s.filter((c) => !l.includes(c));
        r[o] = [...l, ...u].join(" ");
      } else if (o === "style") {
        const s = a ? a.split(";").map((c) => c.trim()).filter(Boolean) : [], l = r[o] ? r[o].split(";").map((c) => c.trim()).filter(Boolean) : [], u = /* @__PURE__ */ new Map();
        l.forEach((c) => {
          const [d, f] = c.split(":").map((h) => h.trim());
          u.set(d, f);
        }), s.forEach((c) => {
          const [d, f] = c.split(":").map((h) => h.trim());
          u.set(d, f);
        }), r[o] = Array.from(u.entries()).map(([c, d]) => `${c}: ${d}`).join("; ");
      } else
        r[o] = a;
    }), r;
  }, {});
}
function ap(t, e) {
  return e.filter((n) => n.type === t.type.name).filter((n) => n.attribute.rendered).map((n) => n.attribute.renderHTML ? n.attribute.renderHTML(t.attrs) || {} : {
    [n.name]: t.attrs[n.name]
  }).reduce((n, r) => nn(n, r), {});
}
function Zw(t) {
  return typeof t == "function";
}
function ct(t, e = void 0, ...n) {
  return Zw(t) ? e ? t.bind(e)(...n) : t(...n) : t;
}
function BF(t = {}) {
  return Object.keys(t).length === 0 && t.constructor === Object;
}
function FF(t) {
  return typeof t != "string" ? t : t.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(t) : t === "true" ? !0 : t === "false" ? !1 : t;
}
function Wv(t, e) {
  return "style" in t ? t : {
    ...t,
    getAttrs: (n) => {
      const r = t.getAttrs ? t.getAttrs(n) : t.attrs;
      if (r === !1)
        return !1;
      const o = e.reduce((a, i) => {
        const s = i.attribute.parseHTML ? i.attribute.parseHTML(n) : FF(n.getAttribute(i.name));
        return s == null ? a : {
          ...a,
          [i.name]: s
        };
      }, {});
      return { ...r, ...o };
    }
  };
}
function Kv(t) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(t).filter(([e, n]) => e === "attrs" && BF(n) ? !1 : n != null)
  );
}
function VF(t, e) {
  var n;
  const r = Qw(t), { nodeExtensions: o, markExtensions: a } = nd(t), i = (n = o.find((u) => Be(u, "topNode"))) === null || n === void 0 ? void 0 : n.name, s = Object.fromEntries(o.map((u) => {
    const c = r.filter((b) => b.type === u.name), d = {
      name: u.name,
      options: u.options,
      storage: u.storage,
      editor: e
    }, f = t.reduce((b, C) => {
      const k = Be(C, "extendNodeSchema", d);
      return {
        ...b,
        ...k ? k(u) : {}
      };
    }, {}), h = Kv({
      ...f,
      content: ct(Be(u, "content", d)),
      marks: ct(Be(u, "marks", d)),
      group: ct(Be(u, "group", d)),
      inline: ct(Be(u, "inline", d)),
      atom: ct(Be(u, "atom", d)),
      selectable: ct(Be(u, "selectable", d)),
      draggable: ct(Be(u, "draggable", d)),
      code: ct(Be(u, "code", d)),
      whitespace: ct(Be(u, "whitespace", d)),
      linebreakReplacement: ct(Be(u, "linebreakReplacement", d)),
      defining: ct(Be(u, "defining", d)),
      isolating: ct(Be(u, "isolating", d)),
      attrs: Object.fromEntries(c.map((b) => {
        var C;
        return [b.name, { default: (C = b == null ? void 0 : b.attribute) === null || C === void 0 ? void 0 : C.default }];
      }))
    }), m = ct(Be(u, "parseHTML", d));
    m && (h.parseDOM = m.map((b) => Wv(b, c)));
    const g = Be(u, "renderHTML", d);
    g && (h.toDOM = (b) => g({
      node: b,
      HTMLAttributes: ap(b, c)
    }));
    const y = Be(u, "renderText", d);
    return y && (h.toText = y), [u.name, h];
  })), l = Object.fromEntries(a.map((u) => {
    const c = r.filter((y) => y.type === u.name), d = {
      name: u.name,
      options: u.options,
      storage: u.storage,
      editor: e
    }, f = t.reduce((y, b) => {
      const C = Be(b, "extendMarkSchema", d);
      return {
        ...y,
        ...C ? C(u) : {}
      };
    }, {}), h = Kv({
      ...f,
      inclusive: ct(Be(u, "inclusive", d)),
      excludes: ct(Be(u, "excludes", d)),
      group: ct(Be(u, "group", d)),
      spanning: ct(Be(u, "spanning", d)),
      code: ct(Be(u, "code", d)),
      attrs: Object.fromEntries(c.map((y) => {
        var b;
        return [y.name, { default: (b = y == null ? void 0 : y.attribute) === null || b === void 0 ? void 0 : b.default }];
      }))
    }), m = ct(Be(u, "parseHTML", d));
    m && (h.parseDOM = m.map((y) => Wv(y, c)));
    const g = Be(u, "renderHTML", d);
    return g && (h.toDOM = (y) => g({
      mark: y,
      HTMLAttributes: ap(y, c)
    })), [u.name, h];
  }));
  return new Hk({
    topNode: i,
    nodes: s,
    marks: l
  });
}
function Gd(t, e) {
  return e.nodes[t] || e.marks[t] || null;
}
function jv(t, e) {
  return Array.isArray(e) ? e.some((n) => (typeof n == "string" ? n : n.name) === t.name) : e;
}
function Wh(t, e) {
  const n = ci.fromSchema(e).serializeFragment(t), o = document.implementation.createHTMLDocument().createElement("div");
  return o.appendChild(n), o.innerHTML;
}
const HF = (t, e = 500) => {
  let n = "";
  const r = t.parentOffset;
  return t.parent.nodesBetween(Math.max(0, r - e), r, (o, a, i, s) => {
    var l, u;
    const c = ((u = (l = o.type.spec).toText) === null || u === void 0 ? void 0 : u.call(l, {
      node: o,
      pos: a,
      parent: i,
      index: s
    })) || o.textContent || "%leaf%";
    n += o.isAtom && !o.isText ? c : c.slice(0, Math.max(0, r - a));
  }), n;
};
function Kh(t) {
  return Object.prototype.toString.call(t) === "[object RegExp]";
}
class rd {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
const UF = (t, e) => {
  if (Kh(e))
    return e.exec(t);
  const n = e(t);
  if (!n)
    return null;
  const r = [n.text];
  return r.index = n.index, r.input = t, r.data = n.data, n.replaceWith && (n.text.includes(n.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), r.push(n.replaceWith)), r;
};
function Zl(t) {
  var e;
  const { editor: n, from: r, to: o, text: a, rules: i, plugin: s } = t, { view: l } = n;
  if (l.composing)
    return !1;
  const u = l.state.doc.resolve(r);
  if (
    // check for code node
    u.parent.type.spec.code || !((e = u.nodeBefore || u.nodeAfter) === null || e === void 0) && e.marks.find((f) => f.type.spec.code)
  )
    return !1;
  let c = !1;
  const d = HF(u) + a;
  return i.forEach((f) => {
    if (c)
      return;
    const h = UF(d, f.find);
    if (!h)
      return;
    const m = l.state.tr, g = ed({
      state: l.state,
      transaction: m
    }), y = {
      from: r - (h[0].length - a.length),
      to: o
    }, { commands: b, chain: C, can: k } = new td({
      editor: n,
      state: g
    });
    f.handler({
      state: g,
      range: y,
      match: h,
      commands: b,
      chain: C,
      can: k
    }) === null || !m.steps.length || (m.setMeta(s, {
      transform: m,
      from: r,
      to: o,
      text: a
    }), l.dispatch(m), c = !0);
  }), c;
}
function WF(t) {
  const { editor: e, rules: n } = t, r = new rn({
    state: {
      init() {
        return null;
      },
      apply(o, a, i) {
        const s = o.getMeta(r);
        if (s)
          return s;
        const l = o.getMeta("applyInputRules");
        return !!l && setTimeout(() => {
          let { text: c } = l;
          typeof c == "string" ? c = c : c = Wh(_e.from(c), i.schema);
          const { from: d } = l, f = d + c.length;
          Zl({
            editor: e,
            from: d,
            to: f,
            text: c,
            rules: n,
            plugin: r
          });
        }), o.selectionSet || o.docChanged ? null : a;
      }
    },
    props: {
      handleTextInput(o, a, i, s) {
        return Zl({
          editor: e,
          from: a,
          to: i,
          text: s,
          rules: n,
          plugin: r
        });
      },
      handleDOMEvents: {
        compositionend: (o) => (setTimeout(() => {
          const { $cursor: a } = o.state.selection;
          a && Zl({
            editor: e,
            from: a.pos,
            to: a.pos,
            text: "",
            rules: n,
            plugin: r
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(o, a) {
        if (a.key !== "Enter")
          return !1;
        const { $cursor: i } = o.state.selection;
        return i ? Zl({
          editor: e,
          from: i.pos,
          to: i.pos,
          text: `
`,
          rules: n,
          plugin: r
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return r;
}
function KF(t) {
  return Object.prototype.toString.call(t).slice(8, -1);
}
function eu(t) {
  return KF(t) !== "Object" ? !1 : t.constructor === Object && Object.getPrototypeOf(t) === Object.prototype;
}
function od(t, e) {
  const n = { ...t };
  return eu(t) && eu(e) && Object.keys(e).forEach((r) => {
    eu(e[r]) && eu(t[r]) ? n[r] = od(t[r], e[r]) : n[r] = e[r];
  }), n;
}
class so {
  constructor(e = {}) {
    this.type = "mark", this.name = "mark", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = ct(Be(this, "addOptions", {
      name: this.name
    }))), this.storage = ct(Be(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new so(e);
  }
  configure(e = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => od(this.options, e)
    });
    return n.name = this.name, n.parent = this.parent, n;
  }
  extend(e = {}) {
    const n = new so(e);
    return n.parent = this, this.child = n, n.name = e.name ? e.name : n.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = ct(Be(n, "addOptions", {
      name: n.name
    })), n.storage = ct(Be(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
  static handleExit({ editor: e, mark: n }) {
    const { tr: r } = e.state, o = e.state.selection.$from;
    if (o.pos === o.end()) {
      const i = o.marks();
      if (!!!i.find((u) => (u == null ? void 0 : u.type.name) === n.name))
        return !1;
      const l = i.find((u) => (u == null ? void 0 : u.type.name) === n.name);
      return l && r.removeStoredMark(l), r.insertText(" ", o.pos), e.view.dispatch(r), !0;
    }
    return !1;
  }
}
function jF(t) {
  return typeof t == "number";
}
class zF {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
const YF = (t, e, n) => {
  if (Kh(e))
    return [...t.matchAll(e)];
  const r = e(t, n);
  return r ? r.map((o) => {
    const a = [o.text];
    return a.index = o.index, a.input = t, a.data = o.data, o.replaceWith && (o.text.includes(o.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), a.push(o.replaceWith)), a;
  }) : [];
};
function qF(t) {
  const { editor: e, state: n, from: r, to: o, rule: a, pasteEvent: i, dropEvent: s } = t, { commands: l, chain: u, can: c } = new td({
    editor: e,
    state: n
  }), d = [];
  return n.doc.nodesBetween(r, o, (h, m) => {
    if (!h.isTextblock || h.type.spec.code)
      return;
    const g = Math.max(r, m), y = Math.min(o, m + h.content.size), b = h.textBetween(g - m, y - m, void 0, "￼");
    YF(b, a.find, i).forEach((k) => {
      if (k.index === void 0)
        return;
      const v = g + k.index + 1, E = v + k[0].length, _ = {
        from: n.tr.mapping.map(v),
        to: n.tr.mapping.map(E)
      }, T = a.handler({
        state: n,
        range: _,
        match: k,
        commands: l,
        chain: u,
        can: c,
        pasteEvent: i,
        dropEvent: s
      });
      d.push(T);
    });
  }), d.every((h) => h !== null);
}
let tu = null;
const GF = (t) => {
  var e;
  const n = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (e = n.clipboardData) === null || e === void 0 || e.setData("text/html", t), n;
};
function JF(t) {
  const { editor: e, rules: n } = t;
  let r = null, o = !1, a = !1, i = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, s;
  try {
    s = typeof DragEvent < "u" ? new DragEvent("drop") : null;
  } catch {
    s = null;
  }
  const l = ({ state: c, from: d, to: f, rule: h, pasteEvt: m }) => {
    const g = c.tr, y = ed({
      state: c,
      transaction: g
    });
    if (!(!qF({
      editor: e,
      state: y,
      from: Math.max(d - 1, 0),
      to: f.b - 1,
      rule: h,
      pasteEvent: m,
      dropEvent: s
    }) || !g.steps.length)) {
      try {
        s = typeof DragEvent < "u" ? new DragEvent("drop") : null;
      } catch {
        s = null;
      }
      return i = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, g;
    }
  };
  return n.map((c) => new rn({
    // we register a global drag handler to track the current drag source element
    view(d) {
      const f = (m) => {
        var g;
        r = !((g = d.dom.parentElement) === null || g === void 0) && g.contains(m.target) ? d.dom.parentElement : null, r && (tu = e);
      }, h = () => {
        tu && (tu = null);
      };
      return window.addEventListener("dragstart", f), window.addEventListener("dragend", h), {
        destroy() {
          window.removeEventListener("dragstart", f), window.removeEventListener("dragend", h);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (d, f) => {
          if (a = r === d.dom.parentElement, s = f, !a) {
            const h = tu;
            h && setTimeout(() => {
              const m = h.state.selection;
              m && h.commands.deleteRange({ from: m.from, to: m.to });
            }, 10);
          }
          return !1;
        },
        paste: (d, f) => {
          var h;
          const m = (h = f.clipboardData) === null || h === void 0 ? void 0 : h.getData("text/html");
          return i = f, o = !!(m != null && m.includes("data-pm-slice")), !1;
        }
      }
    },
    appendTransaction: (d, f, h) => {
      const m = d[0], g = m.getMeta("uiEvent") === "paste" && !o, y = m.getMeta("uiEvent") === "drop" && !a, b = m.getMeta("applyPasteRules"), C = !!b;
      if (!g && !y && !C)
        return;
      if (C) {
        let { text: E } = b;
        typeof E == "string" ? E = E : E = Wh(_e.from(E), h.schema);
        const { from: _ } = b, T = _ + E.length, M = GF(E);
        return l({
          rule: c,
          state: h,
          from: _,
          to: { b: T },
          pasteEvt: M
        });
      }
      const k = f.doc.content.findDiffStart(h.doc.content), v = f.doc.content.findDiffEnd(h.doc.content);
      if (!(!jF(k) || !v || k === v.b))
        return l({
          rule: c,
          state: h,
          from: k,
          to: v,
          pasteEvt: i
        });
    }
  }));
}
function XF(t) {
  const e = t.filter((n, r) => t.indexOf(n) !== r);
  return Array.from(new Set(e));
}
class Di {
  constructor(e, n) {
    this.splittableMarks = [], this.editor = n, this.extensions = Di.resolve(e), this.schema = VF(this.extensions, n), this.setupExtensions();
  }
  /**
   * Returns a flattened and sorted extension list while
   * also checking for duplicated extensions and warns the user.
   * @param extensions An array of Tiptap extensions
   * @returns An flattened and sorted array of Tiptap extensions
   */
  static resolve(e) {
    const n = Di.sort(Di.flatten(e)), r = XF(n.map((o) => o.name));
    return r.length && console.warn(`[tiptap warn]: Duplicate extension names found: [${r.map((o) => `'${o}'`).join(", ")}]. This can lead to issues.`), n;
  }
  /**
   * Create a flattened array of extensions by traversing the `addExtensions` field.
   * @param extensions An array of Tiptap extensions
   * @returns A flattened array of Tiptap extensions
   */
  static flatten(e) {
    return e.map((n) => {
      const r = {
        name: n.name,
        options: n.options,
        storage: n.storage
      }, o = Be(n, "addExtensions", r);
      return o ? [n, ...this.flatten(o())] : n;
    }).flat(10);
  }
  /**
   * Sort extensions by priority.
   * @param extensions An array of Tiptap extensions
   * @returns A sorted array of Tiptap extensions by priority
   */
  static sort(e) {
    return e.sort((r, o) => {
      const a = Be(r, "priority") || 100, i = Be(o, "priority") || 100;
      return a > i ? -1 : a < i ? 1 : 0;
    });
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((e, n) => {
      const r = {
        name: n.name,
        options: n.options,
        storage: n.storage,
        editor: this.editor,
        type: Gd(n.name, this.schema)
      }, o = Be(n, "addCommands", r);
      return o ? {
        ...e,
        ...o()
      } : e;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: e } = this, n = Di.sort([...this.extensions].reverse()), r = [], o = [], a = n.map((i) => {
      const s = {
        name: i.name,
        options: i.options,
        storage: i.storage,
        editor: e,
        type: Gd(i.name, this.schema)
      }, l = [], u = Be(i, "addKeyboardShortcuts", s);
      let c = {};
      if (i.type === "mark" && Be(i, "exitable", s) && (c.ArrowRight = () => so.handleExit({ editor: e, mark: i })), u) {
        const g = Object.fromEntries(Object.entries(u()).map(([y, b]) => [y, () => b({ editor: e })]));
        c = { ...c, ...g };
      }
      const d = gF(c);
      l.push(d);
      const f = Be(i, "addInputRules", s);
      jv(i, e.options.enableInputRules) && f && r.push(...f());
      const h = Be(i, "addPasteRules", s);
      jv(i, e.options.enablePasteRules) && h && o.push(...h());
      const m = Be(i, "addProseMirrorPlugins", s);
      if (m) {
        const g = m();
        l.push(...g);
      }
      return l;
    }).flat();
    return [
      WF({
        editor: e,
        rules: r
      }),
      ...JF({
        editor: e,
        rules: o
      }),
      ...a
    ];
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return Qw(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: e } = this, { nodeExtensions: n } = nd(this.extensions);
    return Object.fromEntries(n.filter((r) => !!Be(r, "addNodeView")).map((r) => {
      const o = this.attributes.filter((l) => l.type === r.name), a = {
        name: r.name,
        options: r.options,
        storage: r.storage,
        editor: e,
        type: dn(r.name, this.schema)
      }, i = Be(r, "addNodeView", a);
      if (!i)
        return [];
      const s = (l, u, c, d, f) => {
        const h = ap(l, o);
        return i()({
          // pass-through
          node: l,
          view: u,
          getPos: c,
          decorations: d,
          innerDecorations: f,
          // tiptap-specific
          editor: e,
          extension: r,
          HTMLAttributes: h
        });
      };
      return [r.name, s];
    }));
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    this.extensions.forEach((e) => {
      var n;
      this.editor.extensionStorage[e.name] = e.storage;
      const r = {
        name: e.name,
        options: e.options,
        storage: e.storage,
        editor: this.editor,
        type: Gd(e.name, this.schema)
      };
      e.type === "mark" && (!((n = ct(Be(e, "keepOnSplit", r))) !== null && n !== void 0) || n) && this.splittableMarks.push(e.name);
      const o = Be(e, "onBeforeCreate", r), a = Be(e, "onCreate", r), i = Be(e, "onUpdate", r), s = Be(e, "onSelectionUpdate", r), l = Be(e, "onTransaction", r), u = Be(e, "onFocus", r), c = Be(e, "onBlur", r), d = Be(e, "onDestroy", r);
      o && this.editor.on("beforeCreate", o), a && this.editor.on("create", a), i && this.editor.on("update", i), s && this.editor.on("selectionUpdate", s), l && this.editor.on("transaction", l), u && this.editor.on("focus", u), c && this.editor.on("blur", c), d && this.editor.on("destroy", d);
    });
  }
}
class vn {
  constructor(e = {}) {
    this.type = "extension", this.name = "extension", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = ct(Be(this, "addOptions", {
      name: this.name
    }))), this.storage = ct(Be(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new vn(e);
  }
  configure(e = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => od(this.options, e)
    });
    return n.name = this.name, n.parent = this.parent, n;
  }
  extend(e = {}) {
    const n = new vn({ ...this.config, ...e });
    return n.parent = this, this.child = n, n.name = e.name ? e.name : n.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = ct(Be(n, "addOptions", {
      name: n.name
    })), n.storage = ct(Be(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
}
function e1(t, e, n) {
  const { from: r, to: o } = e, { blockSeparator: a = `

`, textSerializers: i = {} } = n || {};
  let s = "";
  return t.nodesBetween(r, o, (l, u, c, d) => {
    var f;
    l.isBlock && u > r && (s += a);
    const h = i == null ? void 0 : i[l.type.name];
    if (h)
      return c && (s += h({
        node: l,
        pos: u,
        parent: c,
        index: d,
        range: e
      })), !1;
    l.isText && (s += (f = l == null ? void 0 : l.text) === null || f === void 0 ? void 0 : f.slice(Math.max(r, u) - u, o - u));
  }), s;
}
function jh(t) {
  return Object.fromEntries(Object.entries(t.nodes).filter(([, e]) => e.spec.toText).map(([e, n]) => [e, n.spec.toText]));
}
const QF = vn.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new rn({
        key: new Fn("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: t } = this, { state: e, schema: n } = t, { doc: r, selection: o } = e, { ranges: a } = o, i = Math.min(...a.map((c) => c.$from.pos)), s = Math.max(...a.map((c) => c.$to.pos)), l = jh(n);
            return e1(r, { from: i, to: s }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: l
            });
          }
        }
      })
    ];
  }
}), ZF = () => ({ editor: t, view: e }) => (requestAnimationFrame(() => {
  var n;
  t.isDestroyed || (e.dom.blur(), (n = window == null ? void 0 : window.getSelection()) === null || n === void 0 || n.removeAllRanges());
}), !0), e2 = (t = !1) => ({ commands: e }) => e.setContent("", t), t2 = () => ({ state: t, tr: e, dispatch: n }) => {
  const { selection: r } = e, { ranges: o } = r;
  return n && o.forEach(({ $from: a, $to: i }) => {
    t.doc.nodesBetween(a.pos, i.pos, (s, l) => {
      if (s.type.isText)
        return;
      const { doc: u, mapping: c } = e, d = u.resolve(c.map(l)), f = u.resolve(c.map(l + s.nodeSize)), h = d.blockRange(f);
      if (!h)
        return;
      const m = ys(h);
      if (s.type.isTextblock) {
        const { defaultType: g } = d.parent.contentMatchAt(d.index());
        e.setNodeMarkup(h.start, g);
      }
      (m || m === 0) && e.lift(h, m);
    });
  }), !0;
}, n2 = (t) => (e) => t(e), r2 = () => ({ state: t, dispatch: e }) => qw(t, e), o2 = (t, e) => ({ editor: n, tr: r }) => {
  const { state: o } = n, a = o.doc.slice(t.from, t.to);
  r.deleteRange(t.from, t.to);
  const i = r.mapping.map(e);
  return r.insert(i, a.content), r.setSelection(new tt(r.doc.resolve(i - 1))), !0;
}, a2 = () => ({ tr: t, dispatch: e }) => {
  const { selection: n } = t, r = n.$anchor.node();
  if (r.content.size > 0)
    return !1;
  const o = t.selection.$anchor;
  for (let a = o.depth; a > 0; a -= 1)
    if (o.node(a).type === r.type) {
      if (e) {
        const s = o.before(a), l = o.after(a);
        t.delete(s, l).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, i2 = (t) => ({ tr: e, state: n, dispatch: r }) => {
  const o = dn(t, n.schema), a = e.selection.$anchor;
  for (let i = a.depth; i > 0; i -= 1)
    if (a.node(i).type === o) {
      if (r) {
        const l = a.before(i), u = a.after(i);
        e.delete(l, u).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, s2 = (t) => ({ tr: e, dispatch: n }) => {
  const { from: r, to: o } = t;
  return n && e.delete(r, o), !0;
}, l2 = () => ({ state: t, dispatch: e }) => Bh(t, e), u2 = () => ({ commands: t }) => t.keyboardShortcut("Enter"), c2 = () => ({ state: t, dispatch: e }) => _F(t, e);
function Vu(t, e, n = { strict: !0 }) {
  const r = Object.keys(e);
  return r.length ? r.every((o) => n.strict ? e[o] === t[o] : Kh(e[o]) ? e[o].test(t[o]) : e[o] === t[o]) : !0;
}
function t1(t, e, n = {}) {
  return t.find((r) => r.type === e && Vu(
    // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(n).map((o) => [o, r.attrs[o]])),
    n
  ));
}
function zv(t, e, n = {}) {
  return !!t1(t, e, n);
}
function zh(t, e, n) {
  var r;
  if (!t || !e)
    return;
  let o = t.parent.childAfter(t.parentOffset);
  if ((!o.node || !o.node.marks.some((c) => c.type === e)) && (o = t.parent.childBefore(t.parentOffset)), !o.node || !o.node.marks.some((c) => c.type === e) || (n = n || ((r = o.node.marks[0]) === null || r === void 0 ? void 0 : r.attrs), !t1([...o.node.marks], e, n)))
    return;
  let i = o.index, s = t.start() + o.offset, l = i + 1, u = s + o.node.nodeSize;
  for (; i > 0 && zv([...t.parent.child(i - 1).marks], e, n); )
    i -= 1, s -= t.parent.child(i).nodeSize;
  for (; l < t.parent.childCount && zv([...t.parent.child(l).marks], e, n); )
    u += t.parent.child(l).nodeSize, l += 1;
  return {
    from: s,
    to: u
  };
}
function Ca(t, e) {
  if (typeof t == "string") {
    if (!e.marks[t])
      throw Error(`There is no mark type named '${t}'. Maybe you forgot to add the extension?`);
    return e.marks[t];
  }
  return t;
}
const d2 = (t, e = {}) => ({ tr: n, state: r, dispatch: o }) => {
  const a = Ca(t, r.schema), { doc: i, selection: s } = n, { $from: l, from: u, to: c } = s;
  if (o) {
    const d = zh(l, a, e);
    if (d && d.from <= u && d.to >= c) {
      const f = tt.create(i, d.from, d.to);
      n.setSelection(f);
    }
  }
  return !0;
}, f2 = (t) => (e) => {
  const n = typeof t == "function" ? t(e) : t;
  for (let r = 0; r < n.length; r += 1)
    if (n[r](e))
      return !0;
  return !1;
};
function Yh(t) {
  return t instanceof tt;
}
function xo(t = 0, e = 0, n = 0) {
  return Math.min(Math.max(t, e), n);
}
function n1(t, e = null) {
  if (!e)
    return null;
  const n = at.atStart(t), r = at.atEnd(t);
  if (e === "start" || e === !0)
    return n;
  if (e === "end")
    return r;
  const o = n.from, a = r.to;
  return e === "all" ? tt.create(t, xo(0, o, a), xo(t.content.size, o, a)) : tt.create(t, xo(e, o, a), xo(e, o, a));
}
function p2() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
function qh() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
const h2 = (t = null, e = {}) => ({ editor: n, view: r, tr: o, dispatch: a }) => {
  e = {
    scrollIntoView: !0,
    ...e
  };
  const i = () => {
    (qh() || p2()) && r.dom.focus(), requestAnimationFrame(() => {
      n.isDestroyed || (r.focus(), e != null && e.scrollIntoView && n.commands.scrollIntoView());
    });
  };
  if (r.hasFocus() && t === null || t === !1)
    return !0;
  if (a && t === null && !Yh(n.state.selection))
    return i(), !0;
  const s = n1(o.doc, t) || n.state.selection, l = n.state.selection.eq(s);
  return a && (l || o.setSelection(s), l && o.storedMarks && o.setStoredMarks(o.storedMarks), i()), !0;
}, m2 = (t, e) => (n) => t.every((r, o) => e(r, { ...n, index: o })), g2 = (t, e) => ({ tr: n, commands: r }) => r.insertContentAt({ from: n.selection.from, to: n.selection.to }, t, e), r1 = (t) => {
  const e = t.childNodes;
  for (let n = e.length - 1; n >= 0; n -= 1) {
    const r = e[n];
    r.nodeType === 3 && r.nodeValue && /^(\n\s\s|\n)$/.test(r.nodeValue) ? t.removeChild(r) : r.nodeType === 1 && r1(r);
  }
  return t;
};
function nu(t) {
  const e = `<body>${t}</body>`, n = new window.DOMParser().parseFromString(e, "text/html").body;
  return r1(n);
}
function Hu(t, e, n) {
  if (t instanceof ra || t instanceof _e)
    return t;
  n = {
    slice: !0,
    parseOptions: {},
    ...n
  };
  const r = typeof t == "object" && t !== null, o = typeof t == "string";
  if (r)
    try {
      if (Array.isArray(t) && t.length > 0)
        return _e.fromArray(t.map((s) => e.nodeFromJSON(s)));
      const i = e.nodeFromJSON(t);
      return n.errorOnInvalidContent && i.check(), i;
    } catch (a) {
      if (n.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: a });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", t, "Error:", a), Hu("", e, n);
    }
  if (o) {
    if (n.errorOnInvalidContent) {
      let i = !1, s = "";
      const l = new Hk({
        topNode: e.spec.topNode,
        marks: e.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: e.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (u) => (i = !0, s = typeof u == "string" ? u : u.outerHTML, null)
              }
            ]
          }
        })
      });
      if (n.slice ? oa.fromSchema(l).parseSlice(nu(t), n.parseOptions) : oa.fromSchema(l).parse(nu(t), n.parseOptions), n.errorOnInvalidContent && i)
        throw new Error("[tiptap error]: Invalid HTML content", { cause: new Error(`Invalid element found: ${s}`) });
    }
    const a = oa.fromSchema(e);
    return n.slice ? a.parseSlice(nu(t), n.parseOptions).content : a.parse(nu(t), n.parseOptions);
  }
  return Hu("", e, n);
}
function v2(t, e, n) {
  const r = t.steps.length - 1;
  if (r < e)
    return;
  const o = t.steps[r];
  if (!(o instanceof ln || o instanceof un))
    return;
  const a = t.mapping.maps[r];
  let i = 0;
  a.forEach((s, l, u, c) => {
    i === 0 && (i = c);
  }), t.setSelection(at.near(t.doc.resolve(i), n));
}
const y2 = (t) => !("type" in t), b2 = (t, e, n) => ({ tr: r, dispatch: o, editor: a }) => {
  var i;
  if (o) {
    n = {
      parseOptions: a.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...n
    };
    let s;
    try {
      s = Hu(e, a.schema, {
        parseOptions: {
          preserveWhitespace: "full",
          ...n.parseOptions
        },
        errorOnInvalidContent: (i = n.errorOnInvalidContent) !== null && i !== void 0 ? i : a.options.enableContentCheck
      });
    } catch (m) {
      return a.emit("contentError", {
        editor: a,
        error: m,
        disableCollaboration: () => {
          a.storage.collaboration && (a.storage.collaboration.isDisabled = !0);
        }
      }), !1;
    }
    let { from: l, to: u } = typeof t == "number" ? { from: t, to: t } : { from: t.from, to: t.to }, c = !0, d = !0;
    if ((y2(s) ? s : [s]).forEach((m) => {
      m.check(), c = c ? m.isText && m.marks.length === 0 : !1, d = d ? m.isBlock : !1;
    }), l === u && d) {
      const { parent: m } = r.doc.resolve(l);
      m.isTextblock && !m.type.spec.code && !m.childCount && (l -= 1, u += 1);
    }
    let h;
    if (c) {
      if (Array.isArray(e))
        h = e.map((m) => m.text || "").join("");
      else if (e instanceof _e) {
        let m = "";
        e.forEach((g) => {
          g.text && (m += g.text);
        }), h = m;
      } else typeof e == "object" && e && e.text ? h = e.text : h = e;
      r.insertText(h, l, u);
    } else
      h = s, r.replaceWith(l, u, h);
    n.updateSelection && v2(r, r.steps.length - 1, -1), n.applyInputRules && r.setMeta("applyInputRules", { from: l, text: h }), n.applyPasteRules && r.setMeta("applyPasteRules", { from: l, text: h });
  }
  return !0;
}, k2 = () => ({ state: t, dispatch: e }) => bF(t, e), w2 = () => ({ state: t, dispatch: e }) => kF(t, e), _2 = () => ({ state: t, dispatch: e }) => Hw(t, e), C2 = () => ({ state: t, dispatch: e }) => jw(t, e), E2 = () => ({ state: t, dispatch: e, tr: n }) => {
  try {
    const r = qc(t.doc, t.selection.$from.pos, -1);
    return r == null ? !1 : (n.join(r, 2), e && e(n), !0);
  } catch {
    return !1;
  }
}, O2 = () => ({ state: t, dispatch: e, tr: n }) => {
  try {
    const r = qc(t.doc, t.selection.$from.pos, 1);
    return r == null ? !1 : (n.join(r, 2), e && e(n), !0);
  } catch {
    return !1;
  }
}, T2 = () => ({ state: t, dispatch: e }) => vF(t, e), S2 = () => ({ state: t, dispatch: e }) => yF(t, e);
function o1() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function x2(t) {
  const e = t.split(/-(?!$)/);
  let n = e[e.length - 1];
  n === "Space" && (n = " ");
  let r, o, a, i;
  for (let s = 0; s < e.length - 1; s += 1) {
    const l = e[s];
    if (/^(cmd|meta|m)$/i.test(l))
      i = !0;
    else if (/^a(lt)?$/i.test(l))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      o = !0;
    else if (/^s(hift)?$/i.test(l))
      a = !0;
    else if (/^mod$/i.test(l))
      qh() || o1() ? i = !0 : o = !0;
    else
      throw new Error(`Unrecognized modifier name: ${l}`);
  }
  return r && (n = `Alt-${n}`), o && (n = `Ctrl-${n}`), i && (n = `Meta-${n}`), a && (n = `Shift-${n}`), n;
}
const A2 = (t) => ({ editor: e, view: n, tr: r, dispatch: o }) => {
  const a = x2(t).split(/-(?!$)/), i = a.find((u) => !["Alt", "Ctrl", "Meta", "Shift"].includes(u)), s = new KeyboardEvent("keydown", {
    key: i === "Space" ? " " : i,
    altKey: a.includes("Alt"),
    ctrlKey: a.includes("Ctrl"),
    metaKey: a.includes("Meta"),
    shiftKey: a.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), l = e.captureTransaction(() => {
    n.someProp("handleKeyDown", (u) => u(n, s));
  });
  return l == null || l.steps.forEach((u) => {
    const c = u.map(r.mapping);
    c && o && r.maybeStep(c);
  }), !0;
};
function hl(t, e, n = {}) {
  const { from: r, to: o, empty: a } = t.selection, i = e ? dn(e, t.schema) : null, s = [];
  t.doc.nodesBetween(r, o, (d, f) => {
    if (d.isText)
      return;
    const h = Math.max(r, f), m = Math.min(o, f + d.nodeSize);
    s.push({
      node: d,
      from: h,
      to: m
    });
  });
  const l = o - r, u = s.filter((d) => i ? i.name === d.node.type.name : !0).filter((d) => Vu(d.node.attrs, n, { strict: !1 }));
  return a ? !!u.length : u.reduce((d, f) => d + f.to - f.from, 0) >= l;
}
const M2 = (t, e = {}) => ({ state: n, dispatch: r }) => {
  const o = dn(t, n.schema);
  return hl(n, o, e) ? wF(n, r) : !1;
}, I2 = () => ({ state: t, dispatch: e }) => Gw(t, e), D2 = (t) => ({ state: e, dispatch: n }) => {
  const r = dn(t, e.schema);
  return PF(r)(e, n);
}, P2 = () => ({ state: t, dispatch: e }) => Yw(t, e);
function ad(t, e) {
  return e.nodes[t] ? "node" : e.marks[t] ? "mark" : null;
}
function Yv(t, e) {
  const n = typeof e == "string" ? [e] : e;
  return Object.keys(t).reduce((r, o) => (n.includes(o) || (r[o] = t[o]), r), {});
}
const N2 = (t, e) => ({ tr: n, state: r, dispatch: o }) => {
  let a = null, i = null;
  const s = ad(typeof t == "string" ? t : t.name, r.schema);
  return s ? (s === "node" && (a = dn(t, r.schema)), s === "mark" && (i = Ca(t, r.schema)), o && n.selection.ranges.forEach((l) => {
    r.doc.nodesBetween(l.$from.pos, l.$to.pos, (u, c) => {
      a && a === u.type && n.setNodeMarkup(c, void 0, Yv(u.attrs, e)), i && u.marks.length && u.marks.forEach((d) => {
        i === d.type && n.addMark(c, c + u.nodeSize, i.create(Yv(d.attrs, e)));
      });
    });
  }), !0) : !1;
}, $2 = () => ({ tr: t, dispatch: e }) => (e && t.scrollIntoView(), !0), R2 = () => ({ tr: t, dispatch: e }) => {
  if (e) {
    const n = new tr(t.doc);
    t.setSelection(n);
  }
  return !0;
}, L2 = () => ({ state: t, dispatch: e }) => Ww(t, e), B2 = () => ({ state: t, dispatch: e }) => zw(t, e), F2 = () => ({ state: t, dispatch: e }) => OF(t, e), V2 = () => ({ state: t, dispatch: e }) => xF(t, e), H2 = () => ({ state: t, dispatch: e }) => SF(t, e);
function ip(t, e, n = {}, r = {}) {
  return Hu(t, e, {
    slice: !1,
    parseOptions: n,
    errorOnInvalidContent: r.errorOnInvalidContent
  });
}
const U2 = (t, e = !1, n = {}, r = {}) => ({ editor: o, tr: a, dispatch: i, commands: s }) => {
  var l, u;
  const { doc: c } = a;
  if (n.preserveWhitespace !== "full") {
    const d = ip(t, o.schema, n, {
      errorOnInvalidContent: (l = r.errorOnInvalidContent) !== null && l !== void 0 ? l : o.options.enableContentCheck
    });
    return i && a.replaceWith(0, c.content.size, d).setMeta("preventUpdate", !e), !0;
  }
  return i && a.setMeta("preventUpdate", !e), s.insertContentAt({ from: 0, to: c.content.size }, t, {
    parseOptions: n,
    errorOnInvalidContent: (u = r.errorOnInvalidContent) !== null && u !== void 0 ? u : o.options.enableContentCheck
  });
};
function a1(t, e) {
  const n = Ca(e, t.schema), { from: r, to: o, empty: a } = t.selection, i = [];
  a ? (t.storedMarks && i.push(...t.storedMarks), i.push(...t.selection.$head.marks())) : t.doc.nodesBetween(r, o, (l) => {
    i.push(...l.marks);
  });
  const s = i.find((l) => l.type.name === n.name);
  return s ? { ...s.attrs } : {};
}
function W2(t, e) {
  const n = new rw(t);
  return e.forEach((r) => {
    r.steps.forEach((o) => {
      n.step(o);
    });
  }), n;
}
function K2(t) {
  for (let e = 0; e < t.edgeCount; e += 1) {
    const { type: n } = t.edge(e);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
function j2(t, e, n) {
  const r = [];
  return t.nodesBetween(e.from, e.to, (o, a) => {
    n(o) && r.push({
      node: o,
      pos: a
    });
  }), r;
}
function z2(t, e) {
  for (let n = t.depth; n > 0; n -= 1) {
    const r = t.node(n);
    if (e(r))
      return {
        pos: n > 0 ? t.before(n) : 0,
        start: t.start(n),
        depth: n,
        node: r
      };
  }
}
function Gh(t) {
  return (e) => z2(e.$from, t);
}
function i1(t, e) {
  const n = {
    from: 0,
    to: t.content.size
  };
  return e1(t, n, e);
}
function Y2(t, e) {
  const n = dn(e, t.schema), { from: r, to: o } = t.selection, a = [];
  t.doc.nodesBetween(r, o, (s) => {
    a.push(s);
  });
  const i = a.reverse().find((s) => s.type.name === n.name);
  return i ? { ...i.attrs } : {};
}
function s1(t, e) {
  const n = ad(typeof e == "string" ? e : e.name, t.schema);
  return n === "node" ? Y2(t, e) : n === "mark" ? a1(t, e) : {};
}
function q2(t, e = JSON.stringify) {
  const n = {};
  return t.filter((r) => {
    const o = e(r);
    return Object.prototype.hasOwnProperty.call(n, o) ? !1 : n[o] = !0;
  });
}
function G2(t) {
  const e = q2(t);
  return e.length === 1 ? e : e.filter((n, r) => !e.filter((a, i) => i !== r).some((a) => n.oldRange.from >= a.oldRange.from && n.oldRange.to <= a.oldRange.to && n.newRange.from >= a.newRange.from && n.newRange.to <= a.newRange.to));
}
function J2(t) {
  const { mapping: e, steps: n } = t, r = [];
  return e.maps.forEach((o, a) => {
    const i = [];
    if (o.ranges.length)
      o.forEach((s, l) => {
        i.push({ from: s, to: l });
      });
    else {
      const { from: s, to: l } = n[a];
      if (s === void 0 || l === void 0)
        return;
      i.push({ from: s, to: l });
    }
    i.forEach(({ from: s, to: l }) => {
      const u = e.slice(a).map(s, -1), c = e.slice(a).map(l), d = e.invert().map(u, -1), f = e.invert().map(c);
      r.push({
        oldRange: {
          from: d,
          to: f
        },
        newRange: {
          from: u,
          to: c
        }
      });
    });
  }), G2(r);
}
function Jh(t, e, n) {
  const r = [];
  return t === e ? n.resolve(t).marks().forEach((o) => {
    const a = n.resolve(t), i = zh(a, o.type);
    i && r.push({
      mark: o,
      ...i
    });
  }) : n.nodesBetween(t, e, (o, a) => {
    !o || (o == null ? void 0 : o.nodeSize) === void 0 || r.push(...o.marks.map((i) => ({
      from: a,
      to: a + o.nodeSize,
      mark: i
    })));
  }), r;
}
function mu(t, e, n) {
  return Object.fromEntries(Object.entries(n).filter(([r]) => {
    const o = t.find((a) => a.type === e && a.name === r);
    return o ? o.attribute.keepOnSplit : !1;
  }));
}
function sp(t, e, n = {}) {
  const { empty: r, ranges: o } = t.selection, a = e ? Ca(e, t.schema) : null;
  if (r)
    return !!(t.storedMarks || t.selection.$from.marks()).filter((d) => a ? a.name === d.type.name : !0).find((d) => Vu(d.attrs, n, { strict: !1 }));
  let i = 0;
  const s = [];
  if (o.forEach(({ $from: d, $to: f }) => {
    const h = d.pos, m = f.pos;
    t.doc.nodesBetween(h, m, (g, y) => {
      if (!g.isText && !g.marks.length)
        return;
      const b = Math.max(h, y), C = Math.min(m, y + g.nodeSize), k = C - b;
      i += k, s.push(...g.marks.map((v) => ({
        mark: v,
        from: b,
        to: C
      })));
    });
  }), i === 0)
    return !1;
  const l = s.filter((d) => a ? a.name === d.mark.type.name : !0).filter((d) => Vu(d.mark.attrs, n, { strict: !1 })).reduce((d, f) => d + f.to - f.from, 0), u = s.filter((d) => a ? d.mark.type !== a && d.mark.type.excludes(a) : !0).reduce((d, f) => d + f.to - f.from, 0);
  return (l > 0 ? l + u : l) >= i;
}
function X2(t, e, n = {}) {
  if (!e)
    return hl(t, null, n) || sp(t, null, n);
  const r = ad(e, t.schema);
  return r === "node" ? hl(t, e, n) : r === "mark" ? sp(t, e, n) : !1;
}
function qv(t, e) {
  const { nodeExtensions: n } = nd(e), r = n.find((i) => i.name === t);
  if (!r)
    return !1;
  const o = {
    name: r.name,
    options: r.options,
    storage: r.storage
  }, a = ct(Be(r, "group", o));
  return typeof a != "string" ? !1 : a.split(" ").includes("list");
}
function Xh(t, { checkChildren: e = !0, ignoreWhitespace: n = !1 } = {}) {
  var r;
  if (n) {
    if (t.type.name === "hardBreak")
      return !0;
    if (t.isText)
      return /^\s*$/m.test((r = t.text) !== null && r !== void 0 ? r : "");
  }
  if (t.isText)
    return !t.text;
  if (t.isAtom || t.isLeaf)
    return !1;
  if (t.content.childCount === 0)
    return !0;
  if (e) {
    let o = !0;
    return t.content.forEach((a) => {
      o !== !1 && (Xh(a, { ignoreWhitespace: n, checkChildren: e }) || (o = !1));
    }), o;
  }
  return !1;
}
function l1(t) {
  return t instanceof je;
}
function u1(t, e, n) {
  const o = t.state.doc.content.size, a = xo(e, 0, o), i = xo(n, 0, o), s = t.coordsAtPos(a), l = t.coordsAtPos(i, -1), u = Math.min(s.top, l.top), c = Math.max(s.bottom, l.bottom), d = Math.min(s.left, l.left), f = Math.max(s.right, l.right), h = f - d, m = c - u, b = {
    top: u,
    bottom: c,
    left: d,
    right: f,
    width: h,
    height: m,
    x: d,
    y: u
  };
  return {
    ...b,
    toJSON: () => b
  };
}
function Q2(t, e, n) {
  var r;
  const { selection: o } = e;
  let a = null;
  if (Yh(o) && (a = o.$cursor), a) {
    const s = (r = t.storedMarks) !== null && r !== void 0 ? r : a.marks();
    return !!n.isInSet(s) || !s.some((l) => l.type.excludes(n));
  }
  const { ranges: i } = o;
  return i.some(({ $from: s, $to: l }) => {
    let u = s.depth === 0 ? t.doc.inlineContent && t.doc.type.allowsMarkType(n) : !1;
    return t.doc.nodesBetween(s.pos, l.pos, (c, d, f) => {
      if (u)
        return !1;
      if (c.isInline) {
        const h = !f || f.type.allowsMarkType(n), m = !!n.isInSet(c.marks) || !c.marks.some((g) => g.type.excludes(n));
        u = h && m;
      }
      return !u;
    }), u;
  });
}
const Z2 = (t, e = {}) => ({ tr: n, state: r, dispatch: o }) => {
  const { selection: a } = n, { empty: i, ranges: s } = a, l = Ca(t, r.schema);
  if (o)
    if (i) {
      const u = a1(r, l);
      n.addStoredMark(l.create({
        ...u,
        ...e
      }));
    } else
      s.forEach((u) => {
        const c = u.$from.pos, d = u.$to.pos;
        r.doc.nodesBetween(c, d, (f, h) => {
          const m = Math.max(h, c), g = Math.min(h + f.nodeSize, d);
          f.marks.find((b) => b.type === l) ? f.marks.forEach((b) => {
            l === b.type && n.addMark(m, g, l.create({
              ...b.attrs,
              ...e
            }));
          }) : n.addMark(m, g, l.create(e));
        });
      });
  return Q2(r, n, l);
}, eV = (t, e) => ({ tr: n }) => (n.setMeta(t, e), !0), tV = (t, e = {}) => ({ state: n, dispatch: r, chain: o }) => {
  const a = dn(t, n.schema);
  let i;
  return n.selection.$anchor.sameParent(n.selection.$head) && (i = n.selection.$anchor.parent.attrs), a.isTextblock ? o().command(({ commands: s }) => Uv(a, { ...i, ...e })(n) ? !0 : s.clearNodes()).command(({ state: s }) => Uv(a, { ...i, ...e })(s, r)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, nV = (t) => ({ tr: e, dispatch: n }) => {
  if (n) {
    const { doc: r } = e, o = xo(t, 0, r.content.size), a = je.create(r, o);
    e.setSelection(a);
  }
  return !0;
}, rV = (t) => ({ tr: e, dispatch: n }) => {
  if (n) {
    const { doc: r } = e, { from: o, to: a } = typeof t == "number" ? { from: t, to: t } : t, i = tt.atStart(r).from, s = tt.atEnd(r).to, l = xo(o, i, s), u = xo(a, i, s), c = tt.create(r, l, u);
    e.setSelection(c);
  }
  return !0;
}, oV = (t) => ({ state: e, dispatch: n }) => {
  const r = dn(t, e.schema);
  return RF(r)(e, n);
};
function Gv(t, e) {
  const n = t.storedMarks || t.selection.$to.parentOffset && t.selection.$from.marks();
  if (n) {
    const r = n.filter((o) => e == null ? void 0 : e.includes(o.type.name));
    t.tr.ensureMarks(r);
  }
}
const aV = ({ keepMarks: t = !0 } = {}) => ({ tr: e, state: n, dispatch: r, editor: o }) => {
  const { selection: a, doc: i } = e, { $from: s, $to: l } = a, u = o.extensionManager.attributes, c = mu(u, s.node().type.name, s.node().attrs);
  if (a instanceof je && a.node.isBlock)
    return !s.parentOffset || !Mo(i, s.pos) ? !1 : (r && (t && Gv(n, o.extensionManager.splittableMarks), e.split(s.pos).scrollIntoView()), !0);
  if (!s.parent.isBlock)
    return !1;
  const d = l.parentOffset === l.parent.content.size, f = s.depth === 0 ? void 0 : K2(s.node(-1).contentMatchAt(s.indexAfter(-1)));
  let h = d && f ? [
    {
      type: f,
      attrs: c
    }
  ] : void 0, m = Mo(e.doc, e.mapping.map(s.pos), 1, h);
  if (!h && !m && Mo(e.doc, e.mapping.map(s.pos), 1, f ? [{ type: f }] : void 0) && (m = !0, h = f ? [
    {
      type: f,
      attrs: c
    }
  ] : void 0), r) {
    if (m && (a instanceof tt && e.deleteSelection(), e.split(e.mapping.map(s.pos), 1, h), f && !d && !s.parentOffset && s.parent.type !== f)) {
      const g = e.mapping.map(s.before()), y = e.doc.resolve(g);
      s.node(-1).canReplaceWith(y.index(), y.index() + 1, f) && e.setNodeMarkup(e.mapping.map(s.before()), f);
    }
    t && Gv(n, o.extensionManager.splittableMarks), e.scrollIntoView();
  }
  return m;
}, iV = (t, e = {}) => ({ tr: n, state: r, dispatch: o, editor: a }) => {
  var i;
  const s = dn(t, r.schema), { $from: l, $to: u } = r.selection, c = r.selection.node;
  if (c && c.isBlock || l.depth < 2 || !l.sameParent(u))
    return !1;
  const d = l.node(-1);
  if (d.type !== s)
    return !1;
  const f = a.extensionManager.attributes;
  if (l.parent.content.size === 0 && l.node(-1).childCount === l.indexAfter(-1)) {
    if (l.depth === 2 || l.node(-3).type !== s || l.index(-2) !== l.node(-2).childCount - 1)
      return !1;
    if (o) {
      let b = _e.empty;
      const C = l.index(-1) ? 1 : l.index(-2) ? 2 : 3;
      for (let M = l.depth - C; M >= l.depth - 3; M -= 1)
        b = _e.from(l.node(M).copy(b));
      const k = l.indexAfter(-1) < l.node(-2).childCount ? 1 : l.indexAfter(-2) < l.node(-3).childCount ? 2 : 3, v = {
        ...mu(f, l.node().type.name, l.node().attrs),
        ...e
      }, E = ((i = s.contentMatch.defaultType) === null || i === void 0 ? void 0 : i.createAndFill(v)) || void 0;
      b = b.append(_e.from(s.createAndFill(null, E) || void 0));
      const _ = l.before(l.depth - (C - 1));
      n.replace(_, l.after(-k), new Pe(b, 4 - C, 0));
      let T = -1;
      n.doc.nodesBetween(_, n.doc.content.size, (M, O) => {
        if (T > -1)
          return !1;
        M.isTextblock && M.content.size === 0 && (T = O + 1);
      }), T > -1 && n.setSelection(tt.near(n.doc.resolve(T))), n.scrollIntoView();
    }
    return !0;
  }
  const h = u.pos === l.end() ? d.contentMatchAt(0).defaultType : null, m = {
    ...mu(f, d.type.name, d.attrs),
    ...e
  }, g = {
    ...mu(f, l.node().type.name, l.node().attrs),
    ...e
  };
  n.delete(l.pos, u.pos);
  const y = h ? [
    { type: s, attrs: m },
    { type: h, attrs: g }
  ] : [{ type: s, attrs: m }];
  if (!Mo(n.doc, l.pos, 2))
    return !1;
  if (o) {
    const { selection: b, storedMarks: C } = r, { splittableMarks: k } = a.extensionManager, v = C || b.$to.parentOffset && b.$from.marks();
    if (n.split(l.pos, 2, y).scrollIntoView(), !v || !o)
      return !0;
    const E = v.filter((_) => k.includes(_.type.name));
    n.ensureMarks(E);
  }
  return !0;
}, Jd = (t, e) => {
  const n = Gh((i) => i.type === e)(t.selection);
  if (!n)
    return !0;
  const r = t.doc.resolve(Math.max(0, n.pos - 1)).before(n.depth);
  if (r === void 0)
    return !0;
  const o = t.doc.nodeAt(r);
  return n.node.type === (o == null ? void 0 : o.type) && wa(t.doc, n.pos) && t.join(n.pos), !0;
}, Xd = (t, e) => {
  const n = Gh((i) => i.type === e)(t.selection);
  if (!n)
    return !0;
  const r = t.doc.resolve(n.start).after(n.depth);
  if (r === void 0)
    return !0;
  const o = t.doc.nodeAt(r);
  return n.node.type === (o == null ? void 0 : o.type) && wa(t.doc, r) && t.join(r), !0;
}, sV = (t, e, n, r = {}) => ({ editor: o, tr: a, state: i, dispatch: s, chain: l, commands: u, can: c }) => {
  const { extensions: d, splittableMarks: f } = o.extensionManager, h = dn(t, i.schema), m = dn(e, i.schema), { selection: g, storedMarks: y } = i, { $from: b, $to: C } = g, k = b.blockRange(C), v = y || g.$to.parentOffset && g.$from.marks();
  if (!k)
    return !1;
  const E = Gh((_) => qv(_.type.name, d))(g);
  if (k.depth >= 1 && E && k.depth - E.depth <= 1) {
    if (E.node.type === h)
      return u.liftListItem(m);
    if (qv(E.node.type.name, d) && h.validContent(E.node.content) && s)
      return l().command(() => (a.setNodeMarkup(E.pos, h), !0)).command(() => Jd(a, h)).command(() => Xd(a, h)).run();
  }
  return !n || !v || !s ? l().command(() => c().wrapInList(h, r) ? !0 : u.clearNodes()).wrapInList(h, r).command(() => Jd(a, h)).command(() => Xd(a, h)).run() : l().command(() => {
    const _ = c().wrapInList(h, r), T = v.filter((M) => f.includes(M.type.name));
    return a.ensureMarks(T), _ ? !0 : u.clearNodes();
  }).wrapInList(h, r).command(() => Jd(a, h)).command(() => Xd(a, h)).run();
}, lV = (t, e = {}, n = {}) => ({ state: r, commands: o }) => {
  const { extendEmptyMarkRange: a = !1 } = n, i = Ca(t, r.schema);
  return sp(r, i, e) ? o.unsetMark(i, { extendEmptyMarkRange: a }) : o.setMark(i, e);
}, uV = (t, e, n = {}) => ({ state: r, commands: o }) => {
  const a = dn(t, r.schema), i = dn(e, r.schema), s = hl(r, a, n);
  let l;
  return r.selection.$anchor.sameParent(r.selection.$head) && (l = r.selection.$anchor.parent.attrs), s ? o.setNode(i, l) : o.setNode(a, { ...l, ...n });
}, cV = (t, e = {}) => ({ state: n, commands: r }) => {
  const o = dn(t, n.schema);
  return hl(n, o, e) ? r.lift(o) : r.wrapIn(o, e);
}, dV = () => ({ state: t, dispatch: e }) => {
  const n = t.plugins;
  for (let r = 0; r < n.length; r += 1) {
    const o = n[r];
    let a;
    if (o.spec.isInputRules && (a = o.getState(t))) {
      if (e) {
        const i = t.tr, s = a.transform;
        for (let l = s.steps.length - 1; l >= 0; l -= 1)
          i.step(s.steps[l].invert(s.docs[l]));
        if (a.text) {
          const l = i.doc.resolve(a.from).marks();
          i.replaceWith(a.from, a.to, t.schema.text(a.text, l));
        } else
          i.delete(a.from, a.to);
      }
      return !0;
    }
  }
  return !1;
}, fV = () => ({ tr: t, dispatch: e }) => {
  const { selection: n } = t, { empty: r, ranges: o } = n;
  return r || e && o.forEach((a) => {
    t.removeMark(a.$from.pos, a.$to.pos);
  }), !0;
}, pV = (t, e = {}) => ({ tr: n, state: r, dispatch: o }) => {
  var a;
  const { extendEmptyMarkRange: i = !1 } = e, { selection: s } = n, l = Ca(t, r.schema), { $from: u, empty: c, ranges: d } = s;
  if (!o)
    return !0;
  if (c && i) {
    let { from: f, to: h } = s;
    const m = (a = u.marks().find((y) => y.type === l)) === null || a === void 0 ? void 0 : a.attrs, g = zh(u, l, m);
    g && (f = g.from, h = g.to), n.removeMark(f, h, l);
  } else
    d.forEach((f) => {
      n.removeMark(f.$from.pos, f.$to.pos, l);
    });
  return n.removeStoredMark(l), !0;
}, hV = (t, e = {}) => ({ tr: n, state: r, dispatch: o }) => {
  let a = null, i = null;
  const s = ad(typeof t == "string" ? t : t.name, r.schema);
  return s ? (s === "node" && (a = dn(t, r.schema)), s === "mark" && (i = Ca(t, r.schema)), o && n.selection.ranges.forEach((l) => {
    const u = l.$from.pos, c = l.$to.pos;
    let d, f, h, m;
    n.selection.empty ? r.doc.nodesBetween(u, c, (g, y) => {
      a && a === g.type && (h = Math.max(y, u), m = Math.min(y + g.nodeSize, c), d = y, f = g);
    }) : r.doc.nodesBetween(u, c, (g, y) => {
      y < u && a && a === g.type && (h = Math.max(y, u), m = Math.min(y + g.nodeSize, c), d = y, f = g), y >= u && y <= c && (a && a === g.type && n.setNodeMarkup(y, void 0, {
        ...g.attrs,
        ...e
      }), i && g.marks.length && g.marks.forEach((b) => {
        if (i === b.type) {
          const C = Math.max(y, u), k = Math.min(y + g.nodeSize, c);
          n.addMark(C, k, i.create({
            ...b.attrs,
            ...e
          }));
        }
      }));
    }), f && (d !== void 0 && n.setNodeMarkup(d, void 0, {
      ...f.attrs,
      ...e
    }), i && f.marks.length && f.marks.forEach((g) => {
      i === g.type && n.addMark(h, m, i.create({
        ...g.attrs,
        ...e
      }));
    }));
  }), !0) : !1;
}, mV = (t, e = {}) => ({ state: n, dispatch: r }) => {
  const o = dn(t, n.schema);
  return AF(o, e)(n, r);
}, gV = (t, e = {}) => ({ state: n, dispatch: r }) => {
  const o = dn(t, n.schema);
  return MF(o, e)(n, r);
};
var vV = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blur: ZF,
  clearContent: e2,
  clearNodes: t2,
  command: n2,
  createParagraphNear: r2,
  cut: o2,
  deleteCurrentNode: a2,
  deleteNode: i2,
  deleteRange: s2,
  deleteSelection: l2,
  enter: u2,
  exitCode: c2,
  extendMarkRange: d2,
  first: f2,
  focus: h2,
  forEach: m2,
  insertContent: g2,
  insertContentAt: b2,
  joinBackward: _2,
  joinDown: w2,
  joinForward: C2,
  joinItemBackward: E2,
  joinItemForward: O2,
  joinTextblockBackward: T2,
  joinTextblockForward: S2,
  joinUp: k2,
  keyboardShortcut: A2,
  lift: M2,
  liftEmptyBlock: I2,
  liftListItem: D2,
  newlineInCode: P2,
  resetAttributes: N2,
  scrollIntoView: $2,
  selectAll: R2,
  selectNodeBackward: L2,
  selectNodeForward: B2,
  selectParentNode: F2,
  selectTextblockEnd: V2,
  selectTextblockStart: H2,
  setContent: U2,
  setMark: Z2,
  setMeta: eV,
  setNode: tV,
  setNodeSelection: nV,
  setTextSelection: rV,
  sinkListItem: oV,
  splitBlock: aV,
  splitListItem: iV,
  toggleList: sV,
  toggleMark: lV,
  toggleNode: uV,
  toggleWrap: cV,
  undoInputRule: dV,
  unsetAllMarks: fV,
  unsetMark: pV,
  updateAttributes: hV,
  wrapIn: mV,
  wrapInList: gV
});
const yV = vn.create({
  name: "commands",
  addCommands() {
    return {
      ...vV
    };
  }
}), bV = vn.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new rn({
        key: new Fn("tiptapDrop"),
        props: {
          handleDrop: (t, e, n, r) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: e,
              slice: n,
              moved: r
            });
          }
        }
      })
    ];
  }
}), kV = vn.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new rn({
        key: new Fn("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), wV = new Fn("focusEvents"), _V = vn.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: t } = this;
    return [
      new rn({
        key: wV,
        props: {
          handleDOMEvents: {
            focus: (e, n) => {
              t.isFocused = !0;
              const r = t.state.tr.setMeta("focus", { event: n }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            },
            blur: (e, n) => {
              t.isFocused = !1;
              const r = t.state.tr.setMeta("blur", { event: n }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            }
          }
        }
      })
    ];
  }
}), CV = vn.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const t = () => this.editor.commands.first(({ commands: i }) => [
      () => i.undoInputRule(),
      // maybe convert first text block node to default node
      () => i.command(({ tr: s }) => {
        const { selection: l, doc: u } = s, { empty: c, $anchor: d } = l, { pos: f, parent: h } = d, m = d.parent.isTextblock && f > 0 ? s.doc.resolve(f - 1) : d, g = m.parent.type.spec.isolating, y = d.pos - d.parentOffset, b = g && m.parent.childCount === 1 ? y === d.pos : at.atStart(u).from === f;
        return !c || !h.type.isTextblock || h.textContent.length || !b || b && d.parent.type.name === "paragraph" ? !1 : i.clearNodes();
      }),
      () => i.deleteSelection(),
      () => i.joinBackward(),
      () => i.selectNodeBackward()
    ]), e = () => this.editor.commands.first(({ commands: i }) => [
      () => i.deleteSelection(),
      () => i.deleteCurrentNode(),
      () => i.joinForward(),
      () => i.selectNodeForward()
    ]), r = {
      Enter: () => this.editor.commands.first(({ commands: i }) => [
        () => i.newlineInCode(),
        () => i.createParagraphNear(),
        () => i.liftEmptyBlock(),
        () => i.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: t,
      "Mod-Backspace": t,
      "Shift-Backspace": t,
      Delete: e,
      "Mod-Delete": e,
      "Mod-a": () => this.editor.commands.selectAll()
    }, o = {
      ...r
    }, a = {
      ...r,
      "Ctrl-h": t,
      "Alt-Backspace": t,
      "Ctrl-d": e,
      "Ctrl-Alt-Backspace": e,
      "Alt-Delete": e,
      "Alt-d": e,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return qh() || o1() ? a : o;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new rn({
        key: new Fn("clearDocument"),
        appendTransaction: (t, e, n) => {
          if (t.some((g) => g.getMeta("composition")))
            return;
          const r = t.some((g) => g.docChanged) && !e.doc.eq(n.doc), o = t.some((g) => g.getMeta("preventClearDocument"));
          if (!r || o)
            return;
          const { empty: a, from: i, to: s } = e.selection, l = at.atStart(e.doc).from, u = at.atEnd(e.doc).to;
          if (a || !(i === l && s === u) || !Xh(n.doc))
            return;
          const f = n.tr, h = ed({
            state: n,
            transaction: f
          }), { commands: m } = new td({
            editor: this.editor,
            state: h
          });
          if (m.clearNodes(), !!f.steps.length)
            return f;
        }
      })
    ];
  }
}), EV = vn.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new rn({
        key: new Fn("tiptapPaste"),
        props: {
          handlePaste: (t, e, n) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: e,
              slice: n
            });
          }
        }
      })
    ];
  }
}), OV = vn.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new rn({
        key: new Fn("tabindex"),
        props: {
          attributes: () => this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
});
class Da {
  get name() {
    return this.node.type.name;
  }
  constructor(e, n, r = !1, o = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = r, this.resolvedPos = e, this.editor = n, this.currentNode = o;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var e;
    return (e = this.actualDepth) !== null && e !== void 0 ? e : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(e) {
    let n = this.from, r = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      n = this.from + 1, r = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: n, to: r }, e);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const e = this.resolvedPos.start(this.resolvedPos.depth - 1), n = this.resolvedPos.doc.resolve(e);
    return new Da(n, this.editor);
  }
  get before() {
    let e = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.from - 3)), new Da(e, this.editor);
  }
  get after() {
    let e = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.to + 3)), new Da(e, this.editor);
  }
  get children() {
    const e = [];
    return this.node.content.forEach((n, r) => {
      const o = n.isBlock && !n.isTextblock, a = n.isAtom && !n.isText, i = this.pos + r + (a ? 0 : 1), s = this.resolvedPos.doc.resolve(i);
      if (!o && s.depth <= this.depth)
        return;
      const l = new Da(s, this.editor, o, o ? n : null);
      o && (l.actualDepth = this.depth + 1), e.push(new Da(s, this.editor, o, o ? n : null));
    }), e;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const e = this.children;
    return e[e.length - 1] || null;
  }
  closest(e, n = {}) {
    let r = null, o = this.parent;
    for (; o && !r; ) {
      if (o.node.type.name === e)
        if (Object.keys(n).length > 0) {
          const a = o.node.attrs, i = Object.keys(n);
          for (let s = 0; s < i.length; s += 1) {
            const l = i[s];
            if (a[l] !== n[l])
              break;
          }
        } else
          r = o;
      o = o.parent;
    }
    return r;
  }
  querySelector(e, n = {}) {
    return this.querySelectorAll(e, n, !0)[0] || null;
  }
  querySelectorAll(e, n = {}, r = !1) {
    let o = [];
    if (!this.children || this.children.length === 0)
      return o;
    const a = Object.keys(n);
    return this.children.forEach((i) => {
      r && o.length > 0 || (i.node.type.name === e && a.every((l) => n[l] === i.node.attrs[l]) && o.push(i), !(r && o.length > 0) && (o = o.concat(i.querySelectorAll(e, n, r))));
    }), o;
  }
  setAttribute(e) {
    const { tr: n } = this.editor.state;
    n.setNodeMarkup(this.from, void 0, {
      ...this.node.attrs,
      ...e
    }), this.editor.view.dispatch(n);
  }
}
const TV = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;
function SV(t, e, n) {
  const r = document.querySelector("style[data-tiptap-style]");
  if (r !== null)
    return r;
  const o = document.createElement("style");
  return e && o.setAttribute("nonce", e), o.setAttribute("data-tiptap-style", ""), o.innerHTML = t, document.getElementsByTagName("head")[0].appendChild(o), o;
}
let xV = class extends LF {
  constructor(e = {}) {
    super(), this.isFocused = !1, this.isInitialized = !1, this.extensionStorage = {}, this.options = {
      element: document.createElement("div"),
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      enableContentCheck: !1,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null,
      onContentError: ({ error: n }) => {
        throw n;
      },
      onPaste: () => null,
      onDrop: () => null
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.setOptions(e), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.on("contentError", this.options.onContentError), this.createView(), this.injectCSS(), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), this.on("drop", ({ event: n, slice: r, moved: o }) => this.options.onDrop(n, r, o)), this.on("paste", ({ event: n, slice: r }) => this.options.onPaste(n, r)), window.setTimeout(() => {
      this.isDestroyed || (this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }), this.isInitialized = !0);
    }, 0);
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && document && (this.css = SV(TV, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(e = {}) {
    this.options = {
      ...this.options,
      ...e
    }, !(!this.view || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(e, n = !0) {
    this.setOptions({ editable: e }), n && this.emit("update", { editor: this, transaction: this.state.tr });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.view.state;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   * @returns The new editor state
   */
  registerPlugin(e, n) {
    const r = Zw(n) ? n(e, [...this.state.plugins]) : [...this.state.plugins, e], o = this.state.reconfigure({ plugins: r });
    return this.view.updateState(o), o;
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKeyToRemove The plugins name
   * @returns The new editor state or undefined if the editor is destroyed
   */
  unregisterPlugin(e) {
    if (this.isDestroyed)
      return;
    const n = this.state.plugins;
    let r = n;
    if ([].concat(e).forEach((a) => {
      const i = typeof a == "string" ? `${a}$` : a.key;
      r = r.filter((s) => !s.key.startsWith(i));
    }), n.length === r.length)
      return;
    const o = this.state.reconfigure({
      plugins: r
    });
    return this.view.updateState(o), o;
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var e, n;
    const o = [...this.options.enableCoreExtensions ? [
      kV,
      QF.configure({
        blockSeparator: (n = (e = this.options.coreExtensionOptions) === null || e === void 0 ? void 0 : e.clipboardTextSerializer) === null || n === void 0 ? void 0 : n.blockSeparator
      }),
      yV,
      _V,
      CV,
      OV,
      bV,
      EV
    ].filter((a) => typeof this.options.enableCoreExtensions == "object" ? this.options.enableCoreExtensions[a.name] !== !1 : !0) : [], ...this.options.extensions].filter((a) => ["extension", "node", "mark"].includes(a == null ? void 0 : a.type));
    this.extensionManager = new Di(o, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new td({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView() {
    var e;
    let n;
    try {
      n = ip(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: this.options.enableContentCheck });
    } catch (i) {
      if (!(i instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(i.message))
        throw i;
      this.emit("contentError", {
        editor: this,
        error: i,
        disableCollaboration: () => {
          this.storage.collaboration && (this.storage.collaboration.isDisabled = !0), this.options.extensions = this.options.extensions.filter((s) => s.name !== "collaboration"), this.createExtensionManager();
        }
      }), n = ip(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: !1 });
    }
    const r = n1(n, this.options.autofocus);
    this.view = new iF(this.options.element, {
      ...this.options.editorProps,
      attributes: {
        // add `role="textbox"` to the editor element
        role: "textbox",
        ...(e = this.options.editorProps) === null || e === void 0 ? void 0 : e.attributes
      },
      dispatchTransaction: this.dispatchTransaction.bind(this),
      state: Ii.create({
        doc: n,
        selection: r || void 0
      })
    });
    const o = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(o), this.createNodeViews(), this.prependClass();
    const a = this.view.dom;
    a.editor = this;
  }
  /**
   * Creates all node views.
   */
  createNodeViews() {
    this.view.isDestroyed || this.view.setProps({
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `tiptap ${this.view.dom.className}`;
  }
  captureTransaction(e) {
    this.isCapturingTransaction = !0, e(), this.isCapturingTransaction = !1;
    const n = this.capturedTransaction;
    return this.capturedTransaction = null, n;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(e) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = e;
        return;
      }
      e.steps.forEach((i) => {
        var s;
        return (s = this.capturedTransaction) === null || s === void 0 ? void 0 : s.step(i);
      });
      return;
    }
    const n = this.state.apply(e), r = !this.state.selection.eq(n.selection);
    this.emit("beforeTransaction", {
      editor: this,
      transaction: e,
      nextState: n
    }), this.view.updateState(n), this.emit("transaction", {
      editor: this,
      transaction: e
    }), r && this.emit("selectionUpdate", {
      editor: this,
      transaction: e
    });
    const o = e.getMeta("focus"), a = e.getMeta("blur");
    o && this.emit("focus", {
      editor: this,
      event: o.event,
      transaction: e
    }), a && this.emit("blur", {
      editor: this,
      event: a.event,
      transaction: e
    }), !(!e.docChanged || e.getMeta("preventUpdate")) && this.emit("update", {
      editor: this,
      transaction: e
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(e) {
    return s1(this.state, e);
  }
  isActive(e, n) {
    const r = typeof e == "string" ? e : null, o = typeof e == "string" ? n : e;
    return X2(this.state, r, o);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return Wh(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(e) {
    const { blockSeparator: n = `

`, textSerializers: r = {} } = e || {};
    return i1(this.state.doc, {
      blockSeparator: n,
      textSerializers: {
        ...jh(this.schema),
        ...r
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return Xh(this.state.doc);
  }
  /**
   * Get the number of characters for the current document.
   *
   * @deprecated
   */
  getCharacterCount() {
    return console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.'), this.state.doc.content.size - 2;
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    if (this.emit("destroy"), this.view) {
      const e = this.view.dom;
      e && e.editor && delete e.editor, this.view.destroy();
    }
    this.removeAllListeners();
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var e;
    return !(!((e = this.view) === null || e === void 0) && e.docView);
  }
  $node(e, n) {
    var r;
    return ((r = this.$doc) === null || r === void 0 ? void 0 : r.querySelector(e, n)) || null;
  }
  $nodes(e, n) {
    var r;
    return ((r = this.$doc) === null || r === void 0 ? void 0 : r.querySelectorAll(e, n)) || null;
  }
  $pos(e) {
    const n = this.state.doc.resolve(e);
    return new Da(n, this);
  }
  get $doc() {
    return this.$pos(0);
  }
};
function Zi(t) {
  return new rd({
    find: t.find,
    handler: ({ state: e, range: n, match: r }) => {
      const o = ct(t.getAttributes, void 0, r);
      if (o === !1 || o === null)
        return null;
      const { tr: a } = e, i = r[r.length - 1], s = r[0];
      if (i) {
        const l = s.search(/\S/), u = n.from + s.indexOf(i), c = u + i.length;
        if (Jh(n.from, n.to, e.doc).filter((h) => h.mark.type.excluded.find((g) => g === t.type && g !== h.mark.type)).filter((h) => h.to > u).length)
          return null;
        c < n.to && a.delete(c, n.to), u > n.from && a.delete(n.from + l, u);
        const f = n.from + l + i.length;
        a.addMark(n.from + l, f, t.type.create(o || {})), a.removeStoredMark(t.type);
      }
    }
  });
}
function c1(t) {
  return new rd({
    find: t.find,
    handler: ({ state: e, range: n, match: r }) => {
      const o = ct(t.getAttributes, void 0, r) || {}, { tr: a } = e, i = n.from;
      let s = n.to;
      const l = t.type.create(o);
      if (r[1]) {
        const u = r[0].lastIndexOf(r[1]);
        let c = i + u;
        c > s ? c = s : s = c + r[1].length;
        const d = r[0][r[0].length - 1];
        a.insertText(d, i + r[0].length - 1), a.replaceWith(c, s, l);
      } else if (r[0]) {
        const u = t.type.isInline ? i : i - 1;
        a.insert(u, t.type.create(o)).delete(a.mapping.map(i), a.mapping.map(s));
      }
      a.scrollIntoView();
    }
  });
}
function lp(t) {
  return new rd({
    find: t.find,
    handler: ({ state: e, range: n, match: r }) => {
      const o = e.doc.resolve(n.from), a = ct(t.getAttributes, void 0, r) || {};
      if (!o.node(-1).canReplaceWith(o.index(-1), o.indexAfter(-1), t.type))
        return null;
      e.tr.delete(n.from, n.to).setBlockType(n.from, n.from, t.type, a);
    }
  });
}
function ml(t) {
  return new rd({
    find: t.find,
    handler: ({ state: e, range: n, match: r, chain: o }) => {
      const a = ct(t.getAttributes, void 0, r) || {}, i = e.tr.delete(n.from, n.to), l = i.doc.resolve(n.from).blockRange(), u = l && Sh(l, t.type, a);
      if (!u)
        return null;
      if (i.wrap(l, u), t.keepMarks && t.editor) {
        const { selection: d, storedMarks: f } = e, { splittableMarks: h } = t.editor.extensionManager, m = f || d.$to.parentOffset && d.$from.marks();
        if (m) {
          const g = m.filter((y) => h.includes(y.type.name));
          i.ensureMarks(g);
        }
      }
      if (t.keepAttributes) {
        const d = t.type.name === "bulletList" || t.type.name === "orderedList" ? "listItem" : "taskList";
        o().updateAttributes(d, a).run();
      }
      const c = i.doc.resolve(n.from - 1).nodeBefore;
      c && c.type === t.type && wa(i.doc, n.from - 1) && (!t.joinPredicate || t.joinPredicate(r, c)) && i.join(n.from - 1);
    }
  });
}
let br = class up {
  constructor(e = {}) {
    this.type = "node", this.name = "node", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = ct(Be(this, "addOptions", {
      name: this.name
    }))), this.storage = ct(Be(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new up(e);
  }
  configure(e = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => od(this.options, e)
    });
    return n.name = this.name, n.parent = this.parent, n;
  }
  extend(e = {}) {
    const n = new up(e);
    return n.parent = this, this.child = n, n.name = e.name ? e.name : n.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = ct(Be(n, "addOptions", {
      name: n.name
    })), n.storage = ct(Be(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
};
function ti(t) {
  return new zF({
    find: t.find,
    handler: ({ state: e, range: n, match: r, pasteEvent: o }) => {
      const a = ct(t.getAttributes, void 0, r, o);
      if (a === !1 || a === null)
        return null;
      const { tr: i } = e, s = r[r.length - 1], l = r[0];
      let u = n.to;
      if (s) {
        const c = l.search(/\S/), d = n.from + l.indexOf(s), f = d + s.length;
        if (Jh(n.from, n.to, e.doc).filter((m) => m.mark.type.excluded.find((y) => y === t.type && y !== m.mark.type)).filter((m) => m.to > d).length)
          return null;
        f < n.to && i.delete(f, n.to), d > n.from && i.delete(n.from + c, d), u = n.from + c + s.length, i.addMark(n.from + c, u, t.type.create(a || {})), i.removeStoredMark(t.type);
      }
    }
  });
}
var Yn = "top", mr = "bottom", gr = "right", qn = "left", Qh = "auto", Hl = [Yn, mr, gr, qn], es = "start", gl = "end", AV = "clippingParents", d1 = "viewport", Ss = "popper", MV = "reference", Jv = /* @__PURE__ */ Hl.reduce(function(t, e) {
  return t.concat([e + "-" + es, e + "-" + gl]);
}, []), f1 = /* @__PURE__ */ [].concat(Hl, [Qh]).reduce(function(t, e) {
  return t.concat([e, e + "-" + es, e + "-" + gl]);
}, []), IV = "beforeRead", DV = "read", PV = "afterRead", NV = "beforeMain", $V = "main", RV = "afterMain", LV = "beforeWrite", BV = "write", FV = "afterWrite", VV = [IV, DV, PV, NV, $V, RV, LV, BV, FV];
function lo(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function nr(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function ni(t) {
  var e = nr(t).Element;
  return t instanceof e || t instanceof Element;
}
function hr(t) {
  var e = nr(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function Zh(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = nr(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function HV(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(n) {
    var r = e.styles[n] || {}, o = e.attributes[n] || {}, a = e.elements[n];
    !hr(a) || !lo(a) || (Object.assign(a.style, r), Object.keys(o).forEach(function(i) {
      var s = o[i];
      s === !1 ? a.removeAttribute(i) : a.setAttribute(i, s === !0 ? "" : s);
    }));
  });
}
function UV(t) {
  var e = t.state, n = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, n.popper), e.styles = n, e.elements.arrow && Object.assign(e.elements.arrow.style, n.arrow), function() {
    Object.keys(e.elements).forEach(function(r) {
      var o = e.elements[r], a = e.attributes[r] || {}, i = Object.keys(e.styles.hasOwnProperty(r) ? e.styles[r] : n[r]), s = i.reduce(function(l, u) {
        return l[u] = "", l;
      }, {});
      !hr(o) || !lo(o) || (Object.assign(o.style, s), Object.keys(a).forEach(function(l) {
        o.removeAttribute(l);
      }));
    });
  };
}
const p1 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: HV,
  effect: UV,
  requires: ["computeStyles"]
};
function Zr(t) {
  return t.split("-")[0];
}
var Ka = Math.max, Uu = Math.min, ts = Math.round;
function cp() {
  var t = navigator.userAgentData;
  return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function h1() {
  return !/^((?!chrome|android).)*safari/i.test(cp());
}
function ns(t, e, n) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  var r = t.getBoundingClientRect(), o = 1, a = 1;
  e && hr(t) && (o = t.offsetWidth > 0 && ts(r.width) / t.offsetWidth || 1, a = t.offsetHeight > 0 && ts(r.height) / t.offsetHeight || 1);
  var i = ni(t) ? nr(t) : window, s = i.visualViewport, l = !h1() && n, u = (r.left + (l && s ? s.offsetLeft : 0)) / o, c = (r.top + (l && s ? s.offsetTop : 0)) / a, d = r.width / o, f = r.height / a;
  return {
    width: d,
    height: f,
    top: c,
    right: u + d,
    bottom: c + f,
    left: u,
    x: u,
    y: c
  };
}
function em(t) {
  var e = ns(t), n = t.offsetWidth, r = t.offsetHeight;
  return Math.abs(e.width - n) <= 1 && (n = e.width), Math.abs(e.height - r) <= 1 && (r = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: n,
    height: r
  };
}
function m1(t, e) {
  var n = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (n && Zh(n)) {
    var r = e;
    do {
      if (r && t.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function Ro(t) {
  return nr(t).getComputedStyle(t);
}
function WV(t) {
  return ["table", "td", "th"].indexOf(lo(t)) >= 0;
}
function Ea(t) {
  return ((ni(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function id(t) {
  return lo(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (Zh(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Ea(t)
  );
}
function Xv(t) {
  return !hr(t) || // https://github.com/popperjs/popper-core/issues/837
  Ro(t).position === "fixed" ? null : t.offsetParent;
}
function KV(t) {
  var e = /firefox/i.test(cp()), n = /Trident/i.test(cp());
  if (n && hr(t)) {
    var r = Ro(t);
    if (r.position === "fixed")
      return null;
  }
  var o = id(t);
  for (Zh(o) && (o = o.host); hr(o) && ["html", "body"].indexOf(lo(o)) < 0; ) {
    var a = Ro(o);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || e && a.willChange === "filter" || e && a.filter && a.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function Ul(t) {
  for (var e = nr(t), n = Xv(t); n && WV(n) && Ro(n).position === "static"; )
    n = Xv(n);
  return n && (lo(n) === "html" || lo(n) === "body" && Ro(n).position === "static") ? e : n || KV(t) || e;
}
function tm(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function Vs(t, e, n) {
  return Ka(t, Uu(e, n));
}
function jV(t, e, n) {
  var r = Vs(t, e, n);
  return r > n ? n : r;
}
function g1() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function v1(t) {
  return Object.assign({}, g1(), t);
}
function y1(t, e) {
  return e.reduce(function(n, r) {
    return n[r] = t, n;
  }, {});
}
var zV = function(e, n) {
  return e = typeof e == "function" ? e(Object.assign({}, n.rects, {
    placement: n.placement
  })) : e, v1(typeof e != "number" ? e : y1(e, Hl));
};
function YV(t) {
  var e, n = t.state, r = t.name, o = t.options, a = n.elements.arrow, i = n.modifiersData.popperOffsets, s = Zr(n.placement), l = tm(s), u = [qn, gr].indexOf(s) >= 0, c = u ? "height" : "width";
  if (!(!a || !i)) {
    var d = zV(o.padding, n), f = em(a), h = l === "y" ? Yn : qn, m = l === "y" ? mr : gr, g = n.rects.reference[c] + n.rects.reference[l] - i[l] - n.rects.popper[c], y = i[l] - n.rects.reference[l], b = Ul(a), C = b ? l === "y" ? b.clientHeight || 0 : b.clientWidth || 0 : 0, k = g / 2 - y / 2, v = d[h], E = C - f[c] - d[m], _ = C / 2 - f[c] / 2 + k, T = Vs(v, _, E), M = l;
    n.modifiersData[r] = (e = {}, e[M] = T, e.centerOffset = T - _, e);
  }
}
function qV(t) {
  var e = t.state, n = t.options, r = n.element, o = r === void 0 ? "[data-popper-arrow]" : r;
  o != null && (typeof o == "string" && (o = e.elements.popper.querySelector(o), !o) || m1(e.elements.popper, o) && (e.elements.arrow = o));
}
const GV = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: YV,
  effect: qV,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function rs(t) {
  return t.split("-")[1];
}
var JV = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function XV(t, e) {
  var n = t.x, r = t.y, o = e.devicePixelRatio || 1;
  return {
    x: ts(n * o) / o || 0,
    y: ts(r * o) / o || 0
  };
}
function Qv(t) {
  var e, n = t.popper, r = t.popperRect, o = t.placement, a = t.variation, i = t.offsets, s = t.position, l = t.gpuAcceleration, u = t.adaptive, c = t.roundOffsets, d = t.isFixed, f = i.x, h = f === void 0 ? 0 : f, m = i.y, g = m === void 0 ? 0 : m, y = typeof c == "function" ? c({
    x: h,
    y: g
  }) : {
    x: h,
    y: g
  };
  h = y.x, g = y.y;
  var b = i.hasOwnProperty("x"), C = i.hasOwnProperty("y"), k = qn, v = Yn, E = window;
  if (u) {
    var _ = Ul(n), T = "clientHeight", M = "clientWidth";
    if (_ === nr(n) && (_ = Ea(n), Ro(_).position !== "static" && s === "absolute" && (T = "scrollHeight", M = "scrollWidth")), _ = _, o === Yn || (o === qn || o === gr) && a === gl) {
      v = mr;
      var O = d && _ === E && E.visualViewport ? E.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        _[T]
      );
      g -= O - r.height, g *= l ? 1 : -1;
    }
    if (o === qn || (o === Yn || o === mr) && a === gl) {
      k = gr;
      var R = d && _ === E && E.visualViewport ? E.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        _[M]
      );
      h -= R - r.width, h *= l ? 1 : -1;
    }
  }
  var N = Object.assign({
    position: s
  }, u && JV), z = c === !0 ? XV({
    x: h,
    y: g
  }, nr(n)) : {
    x: h,
    y: g
  };
  if (h = z.x, g = z.y, l) {
    var te;
    return Object.assign({}, N, (te = {}, te[v] = C ? "0" : "", te[k] = b ? "0" : "", te.transform = (E.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + g + "px)" : "translate3d(" + h + "px, " + g + "px, 0)", te));
  }
  return Object.assign({}, N, (e = {}, e[v] = C ? g + "px" : "", e[k] = b ? h + "px" : "", e.transform = "", e));
}
function QV(t) {
  var e = t.state, n = t.options, r = n.gpuAcceleration, o = r === void 0 ? !0 : r, a = n.adaptive, i = a === void 0 ? !0 : a, s = n.roundOffsets, l = s === void 0 ? !0 : s, u = {
    placement: Zr(e.placement),
    variation: rs(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: o,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, Qv(Object.assign({}, u, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: i,
    roundOffsets: l
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, Qv(Object.assign({}, u, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const ZV = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: QV,
  data: {}
};
var ru = {
  passive: !0
};
function e3(t) {
  var e = t.state, n = t.instance, r = t.options, o = r.scroll, a = o === void 0 ? !0 : o, i = r.resize, s = i === void 0 ? !0 : i, l = nr(e.elements.popper), u = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return a && u.forEach(function(c) {
    c.addEventListener("scroll", n.update, ru);
  }), s && l.addEventListener("resize", n.update, ru), function() {
    a && u.forEach(function(c) {
      c.removeEventListener("scroll", n.update, ru);
    }), s && l.removeEventListener("resize", n.update, ru);
  };
}
const t3 = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: e3,
  data: {}
};
var n3 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function gu(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return n3[e];
  });
}
var r3 = {
  start: "end",
  end: "start"
};
function Zv(t) {
  return t.replace(/start|end/g, function(e) {
    return r3[e];
  });
}
function nm(t) {
  var e = nr(t), n = e.pageXOffset, r = e.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function rm(t) {
  return ns(Ea(t)).left + nm(t).scrollLeft;
}
function o3(t, e) {
  var n = nr(t), r = Ea(t), o = n.visualViewport, a = r.clientWidth, i = r.clientHeight, s = 0, l = 0;
  if (o) {
    a = o.width, i = o.height;
    var u = h1();
    (u || !u && e === "fixed") && (s = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: a,
    height: i,
    x: s + rm(t),
    y: l
  };
}
function a3(t) {
  var e, n = Ea(t), r = nm(t), o = (e = t.ownerDocument) == null ? void 0 : e.body, a = Ka(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), i = Ka(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), s = -r.scrollLeft + rm(t), l = -r.scrollTop;
  return Ro(o || n).direction === "rtl" && (s += Ka(n.clientWidth, o ? o.clientWidth : 0) - a), {
    width: a,
    height: i,
    x: s,
    y: l
  };
}
function om(t) {
  var e = Ro(t), n = e.overflow, r = e.overflowX, o = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function b1(t) {
  return ["html", "body", "#document"].indexOf(lo(t)) >= 0 ? t.ownerDocument.body : hr(t) && om(t) ? t : b1(id(t));
}
function Hs(t, e) {
  var n;
  e === void 0 && (e = []);
  var r = b1(t), o = r === ((n = t.ownerDocument) == null ? void 0 : n.body), a = nr(r), i = o ? [a].concat(a.visualViewport || [], om(r) ? r : []) : r, s = e.concat(i);
  return o ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(Hs(id(i)))
  );
}
function dp(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function i3(t, e) {
  var n = ns(t, !1, e === "fixed");
  return n.top = n.top + t.clientTop, n.left = n.left + t.clientLeft, n.bottom = n.top + t.clientHeight, n.right = n.left + t.clientWidth, n.width = t.clientWidth, n.height = t.clientHeight, n.x = n.left, n.y = n.top, n;
}
function ey(t, e, n) {
  return e === d1 ? dp(o3(t, n)) : ni(e) ? i3(e, n) : dp(a3(Ea(t)));
}
function s3(t) {
  var e = Hs(id(t)), n = ["absolute", "fixed"].indexOf(Ro(t).position) >= 0, r = n && hr(t) ? Ul(t) : t;
  return ni(r) ? e.filter(function(o) {
    return ni(o) && m1(o, r) && lo(o) !== "body";
  }) : [];
}
function l3(t, e, n, r) {
  var o = e === "clippingParents" ? s3(t) : [].concat(e), a = [].concat(o, [n]), i = a[0], s = a.reduce(function(l, u) {
    var c = ey(t, u, r);
    return l.top = Ka(c.top, l.top), l.right = Uu(c.right, l.right), l.bottom = Uu(c.bottom, l.bottom), l.left = Ka(c.left, l.left), l;
  }, ey(t, i, r));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function k1(t) {
  var e = t.reference, n = t.element, r = t.placement, o = r ? Zr(r) : null, a = r ? rs(r) : null, i = e.x + e.width / 2 - n.width / 2, s = e.y + e.height / 2 - n.height / 2, l;
  switch (o) {
    case Yn:
      l = {
        x: i,
        y: e.y - n.height
      };
      break;
    case mr:
      l = {
        x: i,
        y: e.y + e.height
      };
      break;
    case gr:
      l = {
        x: e.x + e.width,
        y: s
      };
      break;
    case qn:
      l = {
        x: e.x - n.width,
        y: s
      };
      break;
    default:
      l = {
        x: e.x,
        y: e.y
      };
  }
  var u = o ? tm(o) : null;
  if (u != null) {
    var c = u === "y" ? "height" : "width";
    switch (a) {
      case es:
        l[u] = l[u] - (e[c] / 2 - n[c] / 2);
        break;
      case gl:
        l[u] = l[u] + (e[c] / 2 - n[c] / 2);
        break;
    }
  }
  return l;
}
function vl(t, e) {
  e === void 0 && (e = {});
  var n = e, r = n.placement, o = r === void 0 ? t.placement : r, a = n.strategy, i = a === void 0 ? t.strategy : a, s = n.boundary, l = s === void 0 ? AV : s, u = n.rootBoundary, c = u === void 0 ? d1 : u, d = n.elementContext, f = d === void 0 ? Ss : d, h = n.altBoundary, m = h === void 0 ? !1 : h, g = n.padding, y = g === void 0 ? 0 : g, b = v1(typeof y != "number" ? y : y1(y, Hl)), C = f === Ss ? MV : Ss, k = t.rects.popper, v = t.elements[m ? C : f], E = l3(ni(v) ? v : v.contextElement || Ea(t.elements.popper), l, c, i), _ = ns(t.elements.reference), T = k1({
    reference: _,
    element: k,
    placement: o
  }), M = dp(Object.assign({}, k, T)), O = f === Ss ? M : _, R = {
    top: E.top - O.top + b.top,
    bottom: O.bottom - E.bottom + b.bottom,
    left: E.left - O.left + b.left,
    right: O.right - E.right + b.right
  }, N = t.modifiersData.offset;
  if (f === Ss && N) {
    var z = N[o];
    Object.keys(R).forEach(function(te) {
      var H = [gr, mr].indexOf(te) >= 0 ? 1 : -1, U = [Yn, mr].indexOf(te) >= 0 ? "y" : "x";
      R[te] += z[U] * H;
    });
  }
  return R;
}
function u3(t, e) {
  e === void 0 && (e = {});
  var n = e, r = n.placement, o = n.boundary, a = n.rootBoundary, i = n.padding, s = n.flipVariations, l = n.allowedAutoPlacements, u = l === void 0 ? f1 : l, c = rs(r), d = c ? s ? Jv : Jv.filter(function(m) {
    return rs(m) === c;
  }) : Hl, f = d.filter(function(m) {
    return u.indexOf(m) >= 0;
  });
  f.length === 0 && (f = d);
  var h = f.reduce(function(m, g) {
    return m[g] = vl(t, {
      placement: g,
      boundary: o,
      rootBoundary: a,
      padding: i
    })[Zr(g)], m;
  }, {});
  return Object.keys(h).sort(function(m, g) {
    return h[m] - h[g];
  });
}
function c3(t) {
  if (Zr(t) === Qh)
    return [];
  var e = gu(t);
  return [Zv(t), e, Zv(e)];
}
function d3(t) {
  var e = t.state, n = t.options, r = t.name;
  if (!e.modifiersData[r]._skip) {
    for (var o = n.mainAxis, a = o === void 0 ? !0 : o, i = n.altAxis, s = i === void 0 ? !0 : i, l = n.fallbackPlacements, u = n.padding, c = n.boundary, d = n.rootBoundary, f = n.altBoundary, h = n.flipVariations, m = h === void 0 ? !0 : h, g = n.allowedAutoPlacements, y = e.options.placement, b = Zr(y), C = b === y, k = l || (C || !m ? [gu(y)] : c3(y)), v = [y].concat(k).reduce(function(D, G) {
      return D.concat(Zr(G) === Qh ? u3(e, {
        placement: G,
        boundary: c,
        rootBoundary: d,
        padding: u,
        flipVariations: m,
        allowedAutoPlacements: g
      }) : G);
    }, []), E = e.rects.reference, _ = e.rects.popper, T = /* @__PURE__ */ new Map(), M = !0, O = v[0], R = 0; R < v.length; R++) {
      var N = v[R], z = Zr(N), te = rs(N) === es, H = [Yn, mr].indexOf(z) >= 0, U = H ? "width" : "height", W = vl(e, {
        placement: N,
        boundary: c,
        rootBoundary: d,
        altBoundary: f,
        padding: u
      }), Q = H ? te ? gr : qn : te ? mr : Yn;
      E[U] > _[U] && (Q = gu(Q));
      var de = gu(Q), re = [];
      if (a && re.push(W[z] <= 0), s && re.push(W[Q] <= 0, W[de] <= 0), re.every(function(D) {
        return D;
      })) {
        O = N, M = !1;
        break;
      }
      T.set(N, re);
    }
    if (M)
      for (var J = m ? 3 : 1, Ce = function(G) {
        var fe = v.find(function(P) {
          var se = T.get(P);
          if (se)
            return se.slice(0, G).every(function(ke) {
              return ke;
            });
        });
        if (fe)
          return O = fe, "break";
      }, ie = J; ie > 0; ie--) {
        var ee = Ce(ie);
        if (ee === "break") break;
      }
    e.placement !== O && (e.modifiersData[r]._skip = !0, e.placement = O, e.reset = !0);
  }
}
const f3 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: d3,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function ty(t, e, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - n.y,
    right: t.right - e.width + n.x,
    bottom: t.bottom - e.height + n.y,
    left: t.left - e.width - n.x
  };
}
function ny(t) {
  return [Yn, gr, mr, qn].some(function(e) {
    return t[e] >= 0;
  });
}
function p3(t) {
  var e = t.state, n = t.name, r = e.rects.reference, o = e.rects.popper, a = e.modifiersData.preventOverflow, i = vl(e, {
    elementContext: "reference"
  }), s = vl(e, {
    altBoundary: !0
  }), l = ty(i, r), u = ty(s, o, a), c = ny(l), d = ny(u);
  e.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: u,
    isReferenceHidden: c,
    hasPopperEscaped: d
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": c,
    "data-popper-escaped": d
  });
}
const h3 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: p3
};
function m3(t, e, n) {
  var r = Zr(t), o = [qn, Yn].indexOf(r) >= 0 ? -1 : 1, a = typeof n == "function" ? n(Object.assign({}, e, {
    placement: t
  })) : n, i = a[0], s = a[1];
  return i = i || 0, s = (s || 0) * o, [qn, gr].indexOf(r) >= 0 ? {
    x: s,
    y: i
  } : {
    x: i,
    y: s
  };
}
function g3(t) {
  var e = t.state, n = t.options, r = t.name, o = n.offset, a = o === void 0 ? [0, 0] : o, i = f1.reduce(function(c, d) {
    return c[d] = m3(d, e.rects, a), c;
  }, {}), s = i[e.placement], l = s.x, u = s.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += l, e.modifiersData.popperOffsets.y += u), e.modifiersData[r] = i;
}
const v3 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: g3
};
function y3(t) {
  var e = t.state, n = t.name;
  e.modifiersData[n] = k1({
    reference: e.rects.reference,
    element: e.rects.popper,
    placement: e.placement
  });
}
const b3 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: y3,
  data: {}
};
function k3(t) {
  return t === "x" ? "y" : "x";
}
function w3(t) {
  var e = t.state, n = t.options, r = t.name, o = n.mainAxis, a = o === void 0 ? !0 : o, i = n.altAxis, s = i === void 0 ? !1 : i, l = n.boundary, u = n.rootBoundary, c = n.altBoundary, d = n.padding, f = n.tether, h = f === void 0 ? !0 : f, m = n.tetherOffset, g = m === void 0 ? 0 : m, y = vl(e, {
    boundary: l,
    rootBoundary: u,
    padding: d,
    altBoundary: c
  }), b = Zr(e.placement), C = rs(e.placement), k = !C, v = tm(b), E = k3(v), _ = e.modifiersData.popperOffsets, T = e.rects.reference, M = e.rects.popper, O = typeof g == "function" ? g(Object.assign({}, e.rects, {
    placement: e.placement
  })) : g, R = typeof O == "number" ? {
    mainAxis: O,
    altAxis: O
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, O), N = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, z = {
    x: 0,
    y: 0
  };
  if (_) {
    if (a) {
      var te, H = v === "y" ? Yn : qn, U = v === "y" ? mr : gr, W = v === "y" ? "height" : "width", Q = _[v], de = Q + y[H], re = Q - y[U], J = h ? -M[W] / 2 : 0, Ce = C === es ? T[W] : M[W], ie = C === es ? -M[W] : -T[W], ee = e.elements.arrow, D = h && ee ? em(ee) : {
        width: 0,
        height: 0
      }, G = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : g1(), fe = G[H], P = G[U], se = Vs(0, T[W], D[W]), ke = k ? T[W] / 2 - J - se - fe - R.mainAxis : Ce - se - fe - R.mainAxis, Le = k ? -T[W] / 2 + J + se + P + R.mainAxis : ie + se + P + R.mainAxis, ne = e.elements.arrow && Ul(e.elements.arrow), ye = ne ? v === "y" ? ne.clientTop || 0 : ne.clientLeft || 0 : 0, pe = (te = N == null ? void 0 : N[v]) != null ? te : 0, Z = Q + ke - pe - ye, B = Q + Le - pe, me = Vs(h ? Uu(de, Z) : de, Q, h ? Ka(re, B) : re);
      _[v] = me, z[v] = me - Q;
    }
    if (s) {
      var Ve, Ee = v === "x" ? Yn : qn, st = v === "x" ? mr : gr, L = _[E], x = E === "y" ? "height" : "width", Y = L + y[Ee], ge = L - y[st], Ge = [Yn, qn].indexOf(b) !== -1, rt = (Ve = N == null ? void 0 : N[E]) != null ? Ve : 0, Te = Ge ? Y : L - T[x] - M[x] - rt + R.altAxis, ae = Ge ? L + T[x] + M[x] - rt - R.altAxis : ge, ve = h && Ge ? jV(Te, L, ae) : Vs(h ? Te : Y, L, h ? ae : ge);
      _[E] = ve, z[E] = ve - L;
    }
    e.modifiersData[r] = z;
  }
}
const _3 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: w3,
  requiresIfExists: ["offset"]
};
function C3(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function E3(t) {
  return t === nr(t) || !hr(t) ? nm(t) : C3(t);
}
function O3(t) {
  var e = t.getBoundingClientRect(), n = ts(e.width) / t.offsetWidth || 1, r = ts(e.height) / t.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function T3(t, e, n) {
  n === void 0 && (n = !1);
  var r = hr(e), o = hr(e) && O3(e), a = Ea(e), i = ns(t, o, n), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((lo(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  om(a)) && (s = E3(e)), hr(e) ? (l = ns(e, !0), l.x += e.clientLeft, l.y += e.clientTop) : a && (l.x = rm(a))), {
    x: i.left + s.scrollLeft - l.x,
    y: i.top + s.scrollTop - l.y,
    width: i.width,
    height: i.height
  };
}
function S3(t) {
  var e = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  t.forEach(function(a) {
    e.set(a.name, a);
  });
  function o(a) {
    n.add(a.name);
    var i = [].concat(a.requires || [], a.requiresIfExists || []);
    i.forEach(function(s) {
      if (!n.has(s)) {
        var l = e.get(s);
        l && o(l);
      }
    }), r.push(a);
  }
  return t.forEach(function(a) {
    n.has(a.name) || o(a);
  }), r;
}
function x3(t) {
  var e = S3(t);
  return VV.reduce(function(n, r) {
    return n.concat(e.filter(function(o) {
      return o.phase === r;
    }));
  }, []);
}
function A3(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(n) {
      Promise.resolve().then(function() {
        e = void 0, n(t());
      });
    })), e;
  };
}
function M3(t) {
  var e = t.reduce(function(n, r) {
    var o = n[r.name];
    return n[r.name] = o ? Object.assign({}, o, r, {
      options: Object.assign({}, o.options, r.options),
      data: Object.assign({}, o.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(e).map(function(n) {
    return e[n];
  });
}
var ry = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function oy() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return !e.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function I3(t) {
  t === void 0 && (t = {});
  var e = t, n = e.defaultModifiers, r = n === void 0 ? [] : n, o = e.defaultOptions, a = o === void 0 ? ry : o;
  return function(s, l, u) {
    u === void 0 && (u = a);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, ry, a),
      modifiersData: {},
      elements: {
        reference: s,
        popper: l
      },
      attributes: {},
      styles: {}
    }, d = [], f = !1, h = {
      state: c,
      setOptions: function(b) {
        var C = typeof b == "function" ? b(c.options) : b;
        g(), c.options = Object.assign({}, a, c.options, C), c.scrollParents = {
          reference: ni(s) ? Hs(s) : s.contextElement ? Hs(s.contextElement) : [],
          popper: Hs(l)
        };
        var k = x3(M3([].concat(r, c.options.modifiers)));
        return c.orderedModifiers = k.filter(function(v) {
          return v.enabled;
        }), m(), h.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!f) {
          var b = c.elements, C = b.reference, k = b.popper;
          if (oy(C, k)) {
            c.rects = {
              reference: T3(C, Ul(k), c.options.strategy === "fixed"),
              popper: em(k)
            }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(R) {
              return c.modifiersData[R.name] = Object.assign({}, R.data);
            });
            for (var v = 0; v < c.orderedModifiers.length; v++) {
              if (c.reset === !0) {
                c.reset = !1, v = -1;
                continue;
              }
              var E = c.orderedModifiers[v], _ = E.fn, T = E.options, M = T === void 0 ? {} : T, O = E.name;
              typeof _ == "function" && (c = _({
                state: c,
                options: M,
                name: O,
                instance: h
              }) || c);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: A3(function() {
        return new Promise(function(y) {
          h.forceUpdate(), y(c);
        });
      }),
      destroy: function() {
        g(), f = !0;
      }
    };
    if (!oy(s, l))
      return h;
    h.setOptions(u).then(function(y) {
      !f && u.onFirstUpdate && u.onFirstUpdate(y);
    });
    function m() {
      c.orderedModifiers.forEach(function(y) {
        var b = y.name, C = y.options, k = C === void 0 ? {} : C, v = y.effect;
        if (typeof v == "function") {
          var E = v({
            state: c,
            name: b,
            instance: h,
            options: k
          }), _ = function() {
          };
          d.push(E || _);
        }
      });
    }
    function g() {
      d.forEach(function(y) {
        return y();
      }), d = [];
    }
    return h;
  };
}
var D3 = [t3, b3, ZV, p1, v3, f3, _3, GV, h3], P3 = /* @__PURE__ */ I3({
  defaultModifiers: D3
}), N3 = "tippy-box", w1 = "tippy-content", $3 = "tippy-backdrop", _1 = "tippy-arrow", C1 = "tippy-svg-arrow", Ma = {
  passive: !0,
  capture: !0
}, E1 = function() {
  return document.body;
};
function R3(t, e) {
  return {}.hasOwnProperty.call(t, e);
}
function Qd(t, e, n) {
  if (Array.isArray(t)) {
    var r = t[e];
    return r ?? (Array.isArray(n) ? n[e] : n);
  }
  return t;
}
function am(t, e) {
  var n = {}.toString.call(t);
  return n.indexOf("[object") === 0 && n.indexOf(e + "]") > -1;
}
function O1(t, e) {
  return typeof t == "function" ? t.apply(void 0, e) : t;
}
function ay(t, e) {
  if (e === 0)
    return t;
  var n;
  return function(r) {
    clearTimeout(n), n = setTimeout(function() {
      t(r);
    }, e);
  };
}
function L3(t, e) {
  var n = Object.assign({}, t);
  return e.forEach(function(r) {
    delete n[r];
  }), n;
}
function B3(t) {
  return t.split(/\s+/).filter(Boolean);
}
function Oi(t) {
  return [].concat(t);
}
function iy(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function F3(t) {
  return t.filter(function(e, n) {
    return t.indexOf(e) === n;
  });
}
function V3(t) {
  return t.split("-")[0];
}
function Wu(t) {
  return [].slice.call(t);
}
function sy(t) {
  return Object.keys(t).reduce(function(e, n) {
    return t[n] !== void 0 && (e[n] = t[n]), e;
  }, {});
}
function Us() {
  return document.createElement("div");
}
function yl(t) {
  return ["Element", "Fragment"].some(function(e) {
    return am(t, e);
  });
}
function H3(t) {
  return am(t, "NodeList");
}
function U3(t) {
  return am(t, "MouseEvent");
}
function W3(t) {
  return !!(t && t._tippy && t._tippy.reference === t);
}
function K3(t) {
  return yl(t) ? [t] : H3(t) ? Wu(t) : Array.isArray(t) ? t : Wu(document.querySelectorAll(t));
}
function Zd(t, e) {
  t.forEach(function(n) {
    n && (n.style.transitionDuration = e + "ms");
  });
}
function ly(t, e) {
  t.forEach(function(n) {
    n && n.setAttribute("data-state", e);
  });
}
function j3(t) {
  var e, n = Oi(t), r = n[0];
  return r != null && (e = r.ownerDocument) != null && e.body ? r.ownerDocument : document;
}
function z3(t, e) {
  var n = e.clientX, r = e.clientY;
  return t.every(function(o) {
    var a = o.popperRect, i = o.popperState, s = o.props, l = s.interactiveBorder, u = V3(i.placement), c = i.modifiersData.offset;
    if (!c)
      return !0;
    var d = u === "bottom" ? c.top.y : 0, f = u === "top" ? c.bottom.y : 0, h = u === "right" ? c.left.x : 0, m = u === "left" ? c.right.x : 0, g = a.top - r + d > l, y = r - a.bottom - f > l, b = a.left - n + h > l, C = n - a.right - m > l;
    return g || y || b || C;
  });
}
function ef(t, e, n) {
  var r = e + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(o) {
    t[r](o, n);
  });
}
function uy(t, e) {
  for (var n = e; n; ) {
    var r;
    if (t.contains(n))
      return !0;
    n = n.getRootNode == null || (r = n.getRootNode()) == null ? void 0 : r.host;
  }
  return !1;
}
var Kr = {
  isTouch: !1
}, cy = 0;
function Y3() {
  Kr.isTouch || (Kr.isTouch = !0, window.performance && document.addEventListener("mousemove", T1));
}
function T1() {
  var t = performance.now();
  t - cy < 20 && (Kr.isTouch = !1, document.removeEventListener("mousemove", T1)), cy = t;
}
function q3() {
  var t = document.activeElement;
  if (W3(t)) {
    var e = t._tippy;
    t.blur && !e.state.isVisible && t.blur();
  }
}
function G3() {
  document.addEventListener("touchstart", Y3, Ma), window.addEventListener("blur", q3);
}
var J3 = typeof window < "u" && typeof document < "u", X3 = J3 ? (
  // @ts-ignore
  !!window.msCrypto
) : !1;
function bi(t) {
  var e = t === "destroy" ? "n already-" : " ";
  return [t + "() was called on a" + e + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function dy(t) {
  var e = /[ \t]{2,}/g, n = /^[ \t]*/gm;
  return t.replace(e, " ").replace(n, "").trim();
}
function Q3(t) {
  return dy(`
  %ctippy.js

  %c` + dy(t) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function S1(t) {
  return [
    Q3(t),
    // title
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    // message
    "line-height: 1.5",
    // footer
    "color: #a6a095;"
  ];
}
var bl;
process.env.NODE_ENV !== "production" && Z3();
function Z3() {
  bl = /* @__PURE__ */ new Set();
}
function Co(t, e) {
  if (t && !bl.has(e)) {
    var n;
    bl.add(e), (n = console).warn.apply(n, S1(e));
  }
}
function fp(t, e) {
  if (t && !bl.has(e)) {
    var n;
    bl.add(e), (n = console).error.apply(n, S1(e));
  }
}
function eH(t) {
  var e = !t, n = Object.prototype.toString.call(t) === "[object Object]" && !t.addEventListener;
  fp(e, ["tippy() was passed", "`" + String(t) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), fp(n, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var x1 = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, tH = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, Xn = Object.assign({
  appendTo: E1,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, x1, tH), nH = Object.keys(Xn), rH = function(e) {
  process.env.NODE_ENV !== "production" && M1(e, []);
  var n = Object.keys(e);
  n.forEach(function(r) {
    Xn[r] = e[r];
  });
};
function A1(t) {
  var e = t.plugins || [], n = e.reduce(function(r, o) {
    var a = o.name, i = o.defaultValue;
    if (a) {
      var s;
      r[a] = t[a] !== void 0 ? t[a] : (s = Xn[a]) != null ? s : i;
    }
    return r;
  }, {});
  return Object.assign({}, t, n);
}
function oH(t, e) {
  var n = e ? Object.keys(A1(Object.assign({}, Xn, {
    plugins: e
  }))) : nH, r = n.reduce(function(o, a) {
    var i = (t.getAttribute("data-tippy-" + a) || "").trim();
    if (!i)
      return o;
    if (a === "content")
      o[a] = i;
    else
      try {
        o[a] = JSON.parse(i);
      } catch {
        o[a] = i;
      }
    return o;
  }, {});
  return r;
}
function fy(t, e) {
  var n = Object.assign({}, e, {
    content: O1(e.content, [t])
  }, e.ignoreAttributes ? {} : oH(t, e.plugins));
  return n.aria = Object.assign({}, Xn.aria, n.aria), n.aria = {
    expanded: n.aria.expanded === "auto" ? e.interactive : n.aria.expanded,
    content: n.aria.content === "auto" ? e.interactive ? null : "describedby" : n.aria.content
  }, n;
}
function M1(t, e) {
  t === void 0 && (t = {}), e === void 0 && (e = []);
  var n = Object.keys(t);
  n.forEach(function(r) {
    var o = L3(Xn, Object.keys(x1)), a = !R3(o, r);
    a && (a = e.filter(function(i) {
      return i.name === r;
    }).length === 0), Co(a, ["`" + r + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var aH = function() {
  return "innerHTML";
};
function pp(t, e) {
  t[aH()] = e;
}
function py(t) {
  var e = Us();
  return t === !0 ? e.className = _1 : (e.className = C1, yl(t) ? e.appendChild(t) : pp(e, t)), e;
}
function hy(t, e) {
  yl(e.content) ? (pp(t, ""), t.appendChild(e.content)) : typeof e.content != "function" && (e.allowHTML ? pp(t, e.content) : t.textContent = e.content);
}
function hp(t) {
  var e = t.firstElementChild, n = Wu(e.children);
  return {
    box: e,
    content: n.find(function(r) {
      return r.classList.contains(w1);
    }),
    arrow: n.find(function(r) {
      return r.classList.contains(_1) || r.classList.contains(C1);
    }),
    backdrop: n.find(function(r) {
      return r.classList.contains($3);
    })
  };
}
function I1(t) {
  var e = Us(), n = Us();
  n.className = N3, n.setAttribute("data-state", "hidden"), n.setAttribute("tabindex", "-1");
  var r = Us();
  r.className = w1, r.setAttribute("data-state", "hidden"), hy(r, t.props), e.appendChild(n), n.appendChild(r), o(t.props, t.props);
  function o(a, i) {
    var s = hp(e), l = s.box, u = s.content, c = s.arrow;
    i.theme ? l.setAttribute("data-theme", i.theme) : l.removeAttribute("data-theme"), typeof i.animation == "string" ? l.setAttribute("data-animation", i.animation) : l.removeAttribute("data-animation"), i.inertia ? l.setAttribute("data-inertia", "") : l.removeAttribute("data-inertia"), l.style.maxWidth = typeof i.maxWidth == "number" ? i.maxWidth + "px" : i.maxWidth, i.role ? l.setAttribute("role", i.role) : l.removeAttribute("role"), (a.content !== i.content || a.allowHTML !== i.allowHTML) && hy(u, t.props), i.arrow ? c ? a.arrow !== i.arrow && (l.removeChild(c), l.appendChild(py(i.arrow))) : l.appendChild(py(i.arrow)) : c && l.removeChild(c);
  }
  return {
    popper: e,
    onUpdate: o
  };
}
I1.$$tippy = !0;
var iH = 1, ou = [], tf = [];
function sH(t, e) {
  var n = fy(t, Object.assign({}, Xn, A1(sy(e)))), r, o, a, i = !1, s = !1, l = !1, u = !1, c, d, f, h = [], m = ay(Z, n.interactiveDebounce), g, y = iH++, b = null, C = F3(n.plugins), k = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, v = {
    // properties
    id: y,
    reference: t,
    popper: Us(),
    popperInstance: b,
    props: n,
    state: k,
    plugins: C,
    // methods
    clearDelayTimeouts: Te,
    setProps: ae,
    setContent: ve,
    show: pt,
    hide: Ot,
    hideWithInteractivity: Sn,
    enable: Ge,
    disable: rt,
    unmount: Fr,
    destroy: or
  };
  if (!n.render)
    return process.env.NODE_ENV !== "production" && fp(!0, "render() function has not been supplied."), v;
  var E = n.render(v), _ = E.popper, T = E.onUpdate;
  _.setAttribute("data-tippy-root", ""), _.id = "tippy-" + v.id, v.popper = _, t._tippy = v, _._tippy = v;
  var M = C.map(function(ue) {
    return ue.fn(v);
  }), O = t.hasAttribute("aria-expanded");
  return ne(), J(), Q(), de("onCreate", [v]), n.showOnCreate && Y(), _.addEventListener("mouseenter", function() {
    v.props.interactive && v.state.isVisible && v.clearDelayTimeouts();
  }), _.addEventListener("mouseleave", function() {
    v.props.interactive && v.props.trigger.indexOf("mouseenter") >= 0 && H().addEventListener("mousemove", m);
  }), v;
  function R() {
    var ue = v.props.touch;
    return Array.isArray(ue) ? ue : [ue, 0];
  }
  function N() {
    return R()[0] === "hold";
  }
  function z() {
    var ue;
    return !!((ue = v.props.render) != null && ue.$$tippy);
  }
  function te() {
    return g || t;
  }
  function H() {
    var ue = te().parentNode;
    return ue ? j3(ue) : document;
  }
  function U() {
    return hp(_);
  }
  function W(ue) {
    return v.state.isMounted && !v.state.isVisible || Kr.isTouch || c && c.type === "focus" ? 0 : Qd(v.props.delay, ue ? 0 : 1, Xn.delay);
  }
  function Q(ue) {
    ue === void 0 && (ue = !1), _.style.pointerEvents = v.props.interactive && !ue ? "" : "none", _.style.zIndex = "" + v.props.zIndex;
  }
  function de(ue, Re, Ue) {
    if (Ue === void 0 && (Ue = !0), M.forEach(function(he) {
      he[ue] && he[ue].apply(he, Re);
    }), Ue) {
      var X;
      (X = v.props)[ue].apply(X, Re);
    }
  }
  function re() {
    var ue = v.props.aria;
    if (ue.content) {
      var Re = "aria-" + ue.content, Ue = _.id, X = Oi(v.props.triggerTarget || t);
      X.forEach(function(he) {
        var Ne = he.getAttribute(Re);
        if (v.state.isVisible)
          he.setAttribute(Re, Ne ? Ne + " " + Ue : Ue);
        else {
          var le = Ne && Ne.replace(Ue, "").trim();
          le ? he.setAttribute(Re, le) : he.removeAttribute(Re);
        }
      });
    }
  }
  function J() {
    if (!(O || !v.props.aria.expanded)) {
      var ue = Oi(v.props.triggerTarget || t);
      ue.forEach(function(Re) {
        v.props.interactive ? Re.setAttribute("aria-expanded", v.state.isVisible && Re === te() ? "true" : "false") : Re.removeAttribute("aria-expanded");
      });
    }
  }
  function Ce() {
    H().removeEventListener("mousemove", m), ou = ou.filter(function(ue) {
      return ue !== m;
    });
  }
  function ie(ue) {
    if (!(Kr.isTouch && (l || ue.type === "mousedown"))) {
      var Re = ue.composedPath && ue.composedPath()[0] || ue.target;
      if (!(v.props.interactive && uy(_, Re))) {
        if (Oi(v.props.triggerTarget || t).some(function(Ue) {
          return uy(Ue, Re);
        })) {
          if (Kr.isTouch || v.state.isVisible && v.props.trigger.indexOf("click") >= 0)
            return;
        } else
          de("onClickOutside", [v, ue]);
        v.props.hideOnClick === !0 && (v.clearDelayTimeouts(), v.hide(), s = !0, setTimeout(function() {
          s = !1;
        }), v.state.isMounted || fe());
      }
    }
  }
  function ee() {
    l = !0;
  }
  function D() {
    l = !1;
  }
  function G() {
    var ue = H();
    ue.addEventListener("mousedown", ie, !0), ue.addEventListener("touchend", ie, Ma), ue.addEventListener("touchstart", D, Ma), ue.addEventListener("touchmove", ee, Ma);
  }
  function fe() {
    var ue = H();
    ue.removeEventListener("mousedown", ie, !0), ue.removeEventListener("touchend", ie, Ma), ue.removeEventListener("touchstart", D, Ma), ue.removeEventListener("touchmove", ee, Ma);
  }
  function P(ue, Re) {
    ke(ue, function() {
      !v.state.isVisible && _.parentNode && _.parentNode.contains(_) && Re();
    });
  }
  function se(ue, Re) {
    ke(ue, Re);
  }
  function ke(ue, Re) {
    var Ue = U().box;
    function X(he) {
      he.target === Ue && (ef(Ue, "remove", X), Re());
    }
    if (ue === 0)
      return Re();
    ef(Ue, "remove", d), ef(Ue, "add", X), d = X;
  }
  function Le(ue, Re, Ue) {
    Ue === void 0 && (Ue = !1);
    var X = Oi(v.props.triggerTarget || t);
    X.forEach(function(he) {
      he.addEventListener(ue, Re, Ue), h.push({
        node: he,
        eventType: ue,
        handler: Re,
        options: Ue
      });
    });
  }
  function ne() {
    N() && (Le("touchstart", pe, {
      passive: !0
    }), Le("touchend", B, {
      passive: !0
    })), B3(v.props.trigger).forEach(function(ue) {
      if (ue !== "manual")
        switch (Le(ue, pe), ue) {
          case "mouseenter":
            Le("mouseleave", B);
            break;
          case "focus":
            Le(X3 ? "focusout" : "blur", me);
            break;
          case "focusin":
            Le("focusout", me);
            break;
        }
    });
  }
  function ye() {
    h.forEach(function(ue) {
      var Re = ue.node, Ue = ue.eventType, X = ue.handler, he = ue.options;
      Re.removeEventListener(Ue, X, he);
    }), h = [];
  }
  function pe(ue) {
    var Re, Ue = !1;
    if (!(!v.state.isEnabled || Ve(ue) || s)) {
      var X = ((Re = c) == null ? void 0 : Re.type) === "focus";
      c = ue, g = ue.currentTarget, J(), !v.state.isVisible && U3(ue) && ou.forEach(function(he) {
        return he(ue);
      }), ue.type === "click" && (v.props.trigger.indexOf("mouseenter") < 0 || i) && v.props.hideOnClick !== !1 && v.state.isVisible ? Ue = !0 : Y(ue), ue.type === "click" && (i = !Ue), Ue && !X && ge(ue);
    }
  }
  function Z(ue) {
    var Re = ue.target, Ue = te().contains(Re) || _.contains(Re);
    if (!(ue.type === "mousemove" && Ue)) {
      var X = x().concat(_).map(function(he) {
        var Ne, le = he._tippy, xe = (Ne = le.popperInstance) == null ? void 0 : Ne.state;
        return xe ? {
          popperRect: he.getBoundingClientRect(),
          popperState: xe,
          props: n
        } : null;
      }).filter(Boolean);
      z3(X, ue) && (Ce(), ge(ue));
    }
  }
  function B(ue) {
    var Re = Ve(ue) || v.props.trigger.indexOf("click") >= 0 && i;
    if (!Re) {
      if (v.props.interactive) {
        v.hideWithInteractivity(ue);
        return;
      }
      ge(ue);
    }
  }
  function me(ue) {
    v.props.trigger.indexOf("focusin") < 0 && ue.target !== te() || v.props.interactive && ue.relatedTarget && _.contains(ue.relatedTarget) || ge(ue);
  }
  function Ve(ue) {
    return Kr.isTouch ? N() !== ue.type.indexOf("touch") >= 0 : !1;
  }
  function Ee() {
    st();
    var ue = v.props, Re = ue.popperOptions, Ue = ue.placement, X = ue.offset, he = ue.getReferenceClientRect, Ne = ue.moveTransition, le = z() ? hp(_).arrow : null, xe = he ? {
      getBoundingClientRect: he,
      contextElement: he.contextElement || te()
    } : t, Fe = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(kr) {
        var ar = kr.state;
        if (z()) {
          var Vr = U(), Oa = Vr.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(di) {
            di === "placement" ? Oa.setAttribute("data-placement", ar.placement) : ar.attributes.popper["data-popper-" + di] ? Oa.setAttribute("data-" + di, "") : Oa.removeAttribute("data-" + di);
          }), ar.attributes.popper = {};
        }
      }
    }, on = [{
      name: "offset",
      options: {
        offset: X
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !Ne
      }
    }, Fe];
    z() && le && on.push({
      name: "arrow",
      options: {
        element: le,
        padding: 3
      }
    }), on.push.apply(on, (Re == null ? void 0 : Re.modifiers) || []), v.popperInstance = P3(xe, _, Object.assign({}, Re, {
      placement: Ue,
      onFirstUpdate: f,
      modifiers: on
    }));
  }
  function st() {
    v.popperInstance && (v.popperInstance.destroy(), v.popperInstance = null);
  }
  function L() {
    var ue = v.props.appendTo, Re, Ue = te();
    v.props.interactive && ue === E1 || ue === "parent" ? Re = Ue.parentNode : Re = O1(ue, [Ue]), Re.contains(_) || Re.appendChild(_), v.state.isMounted = !0, Ee(), process.env.NODE_ENV !== "production" && Co(v.props.interactive && ue === Xn.appendTo && Ue.nextElementSibling !== _, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function x() {
    return Wu(_.querySelectorAll("[data-tippy-root]"));
  }
  function Y(ue) {
    v.clearDelayTimeouts(), ue && de("onTrigger", [v, ue]), G();
    var Re = W(!0), Ue = R(), X = Ue[0], he = Ue[1];
    Kr.isTouch && X === "hold" && he && (Re = he), Re ? r = setTimeout(function() {
      v.show();
    }, Re) : v.show();
  }
  function ge(ue) {
    if (v.clearDelayTimeouts(), de("onUntrigger", [v, ue]), !v.state.isVisible) {
      fe();
      return;
    }
    if (!(v.props.trigger.indexOf("mouseenter") >= 0 && v.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(ue.type) >= 0 && i)) {
      var Re = W(!1);
      Re ? o = setTimeout(function() {
        v.state.isVisible && v.hide();
      }, Re) : a = requestAnimationFrame(function() {
        v.hide();
      });
    }
  }
  function Ge() {
    v.state.isEnabled = !0;
  }
  function rt() {
    v.hide(), v.state.isEnabled = !1;
  }
  function Te() {
    clearTimeout(r), clearTimeout(o), cancelAnimationFrame(a);
  }
  function ae(ue) {
    if (process.env.NODE_ENV !== "production" && Co(v.state.isDestroyed, bi("setProps")), !v.state.isDestroyed) {
      de("onBeforeUpdate", [v, ue]), ye();
      var Re = v.props, Ue = fy(t, Object.assign({}, Re, sy(ue), {
        ignoreAttributes: !0
      }));
      v.props = Ue, ne(), Re.interactiveDebounce !== Ue.interactiveDebounce && (Ce(), m = ay(Z, Ue.interactiveDebounce)), Re.triggerTarget && !Ue.triggerTarget ? Oi(Re.triggerTarget).forEach(function(X) {
        X.removeAttribute("aria-expanded");
      }) : Ue.triggerTarget && t.removeAttribute("aria-expanded"), J(), Q(), T && T(Re, Ue), v.popperInstance && (Ee(), x().forEach(function(X) {
        requestAnimationFrame(X._tippy.popperInstance.forceUpdate);
      })), de("onAfterUpdate", [v, ue]);
    }
  }
  function ve(ue) {
    v.setProps({
      content: ue
    });
  }
  function pt() {
    process.env.NODE_ENV !== "production" && Co(v.state.isDestroyed, bi("show"));
    var ue = v.state.isVisible, Re = v.state.isDestroyed, Ue = !v.state.isEnabled, X = Kr.isTouch && !v.props.touch, he = Qd(v.props.duration, 0, Xn.duration);
    if (!(ue || Re || Ue || X) && !te().hasAttribute("disabled") && (de("onShow", [v], !1), v.props.onShow(v) !== !1)) {
      if (v.state.isVisible = !0, z() && (_.style.visibility = "visible"), Q(), G(), v.state.isMounted || (_.style.transition = "none"), z()) {
        var Ne = U(), le = Ne.box, xe = Ne.content;
        Zd([le, xe], 0);
      }
      f = function() {
        var on;
        if (!(!v.state.isVisible || u)) {
          if (u = !0, _.offsetHeight, _.style.transition = v.props.moveTransition, z() && v.props.animation) {
            var xn = U(), kr = xn.box, ar = xn.content;
            Zd([kr, ar], he), ly([kr, ar], "visible");
          }
          re(), J(), iy(tf, v), (on = v.popperInstance) == null || on.forceUpdate(), de("onMount", [v]), v.props.animation && z() && se(he, function() {
            v.state.isShown = !0, de("onShown", [v]);
          });
        }
      }, L();
    }
  }
  function Ot() {
    process.env.NODE_ENV !== "production" && Co(v.state.isDestroyed, bi("hide"));
    var ue = !v.state.isVisible, Re = v.state.isDestroyed, Ue = !v.state.isEnabled, X = Qd(v.props.duration, 1, Xn.duration);
    if (!(ue || Re || Ue) && (de("onHide", [v], !1), v.props.onHide(v) !== !1)) {
      if (v.state.isVisible = !1, v.state.isShown = !1, u = !1, i = !1, z() && (_.style.visibility = "hidden"), Ce(), fe(), Q(!0), z()) {
        var he = U(), Ne = he.box, le = he.content;
        v.props.animation && (Zd([Ne, le], X), ly([Ne, le], "hidden"));
      }
      re(), J(), v.props.animation ? z() && P(X, v.unmount) : v.unmount();
    }
  }
  function Sn(ue) {
    process.env.NODE_ENV !== "production" && Co(v.state.isDestroyed, bi("hideWithInteractivity")), H().addEventListener("mousemove", m), iy(ou, m), m(ue);
  }
  function Fr() {
    process.env.NODE_ENV !== "production" && Co(v.state.isDestroyed, bi("unmount")), v.state.isVisible && v.hide(), v.state.isMounted && (st(), x().forEach(function(ue) {
      ue._tippy.unmount();
    }), _.parentNode && _.parentNode.removeChild(_), tf = tf.filter(function(ue) {
      return ue !== v;
    }), v.state.isMounted = !1, de("onHidden", [v]));
  }
  function or() {
    process.env.NODE_ENV !== "production" && Co(v.state.isDestroyed, bi("destroy")), !v.state.isDestroyed && (v.clearDelayTimeouts(), v.unmount(), ye(), delete t._tippy, v.state.isDestroyed = !0, de("onDestroy", [v]));
  }
}
function bs(t, e) {
  e === void 0 && (e = {});
  var n = Xn.plugins.concat(e.plugins || []);
  process.env.NODE_ENV !== "production" && (eH(t), M1(e, n)), G3();
  var r = Object.assign({}, e, {
    plugins: n
  }), o = K3(t);
  if (process.env.NODE_ENV !== "production") {
    var a = yl(r.content), i = o.length > 1;
    Co(a && i, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var s = o.reduce(function(l, u) {
    var c = u && sH(u, r);
    return c && l.push(c), l;
  }, []);
  return yl(t) ? s[0] : s;
}
bs.defaultProps = Xn;
bs.setDefaultProps = rH;
bs.currentInput = Kr;
Object.assign({}, p1, {
  effect: function(e) {
    var n = e.state, r = {
      popper: {
        position: n.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(n.elements.popper.style, r.popper), n.styles = r, n.elements.arrow && Object.assign(n.elements.arrow.style, r.arrow);
  }
});
bs.setDefaultProps({
  render: I1
});
class lH {
  constructor({ editor: e, element: n, view: r, tippyOptions: o = {}, updateDelay: a = 250, shouldShow: i }) {
    this.preventHide = !1, this.shouldShow = ({ view: s, state: l, from: u, to: c }) => {
      const { doc: d, selection: f } = l, { empty: h } = f, m = !d.textBetween(u, c).length && Yh(l.selection), g = this.element.contains(document.activeElement);
      return !(!(s.hasFocus() || g) || h || m || !this.editor.isEditable);
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.dragstartHandler = () => {
      this.hide();
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: s }) => {
      var l;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      s != null && s.relatedTarget && (!((l = this.element.parentNode) === null || l === void 0) && l.contains(s.relatedTarget)) || (s == null ? void 0 : s.relatedTarget) !== this.editor.view.dom && this.hide();
    }, this.tippyBlurHandler = (s) => {
      this.blurHandler({ event: s });
    }, this.handleDebouncedUpdate = (s, l) => {
      const u = !(l != null && l.selection.eq(s.state.selection)), c = !(l != null && l.doc.eq(s.state.doc));
      !u && !c || (this.updateDebounceTimer && clearTimeout(this.updateDebounceTimer), this.updateDebounceTimer = window.setTimeout(() => {
        this.updateHandler(s, u, c, l);
      }, this.updateDelay));
    }, this.updateHandler = (s, l, u, c) => {
      var d, f, h;
      const { state: m, composing: g } = s, { selection: y } = m;
      if (g || !l && !u)
        return;
      this.createTooltip();
      const { ranges: C } = y, k = Math.min(...C.map((_) => _.$from.pos)), v = Math.max(...C.map((_) => _.$to.pos));
      if (!((d = this.shouldShow) === null || d === void 0 ? void 0 : d.call(this, {
        editor: this.editor,
        element: this.element,
        view: s,
        state: m,
        oldState: c,
        from: k,
        to: v
      }))) {
        this.hide();
        return;
      }
      (f = this.tippy) === null || f === void 0 || f.setProps({
        getReferenceClientRect: ((h = this.tippyOptions) === null || h === void 0 ? void 0 : h.getReferenceClientRect) || (() => {
          if (l1(m.selection)) {
            let _ = s.nodeDOM(k);
            if (_) {
              const T = _.dataset.nodeViewWrapper ? _ : _.querySelector("[data-node-view-wrapper]");
              if (T && (_ = T.firstChild), _)
                return _.getBoundingClientRect();
            }
          }
          return u1(s, k, v);
        })
      }), this.show();
    }, this.editor = e, this.element = n, this.view = r, this.updateDelay = a, i && (this.shouldShow = i), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.addEventListener("dragstart", this.dragstartHandler), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.tippyOptions = o, this.element.remove(), this.element.style.visibility = "visible";
  }
  createTooltip() {
    const { element: e } = this.editor.options, n = !!e.parentElement;
    this.tippy || !n || (this.tippy = bs(e, {
      duration: 0,
      getReferenceClientRect: null,
      content: this.element,
      interactive: !0,
      trigger: "manual",
      placement: "top",
      hideOnClick: "toggle",
      ...this.tippyOptions
    }), this.tippy.popper.firstChild && this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler));
  }
  update(e, n) {
    const { state: r } = e, o = r.selection.from !== r.selection.to;
    if (this.updateDelay > 0 && o) {
      this.handleDebouncedUpdate(e, n);
      return;
    }
    const a = !(n != null && n.selection.eq(e.state.selection)), i = !(n != null && n.doc.eq(e.state.doc));
    this.updateHandler(e, a, i, n);
  }
  show() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.show();
  }
  hide() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.hide();
  }
  destroy() {
    var e, n;
    !((e = this.tippy) === null || e === void 0) && e.popper.firstChild && this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler), (n = this.tippy) === null || n === void 0 || n.destroy(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.removeEventListener("dragstart", this.dragstartHandler), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler);
  }
}
const D1 = (t) => new rn({
  key: typeof t.pluginKey == "string" ? new Fn(t.pluginKey) : t.pluginKey,
  view: (e) => new lH({ view: e, ...t })
});
vn.create({
  name: "bubbleMenu",
  addOptions() {
    return {
      element: null,
      tippyOptions: {},
      pluginKey: "bubbleMenu",
      updateDelay: void 0,
      shouldShow: null
    };
  },
  addProseMirrorPlugins() {
    return this.options.element ? [
      D1({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        tippyOptions: this.options.tippyOptions,
        updateDelay: this.options.updateDelay,
        shouldShow: this.options.shouldShow
      })
    ] : [];
  }
});
class uH {
  getTextContent(e) {
    return i1(e, { textSerializers: jh(this.editor.schema) });
  }
  constructor({ editor: e, element: n, view: r, tippyOptions: o = {}, shouldShow: a }) {
    this.preventHide = !1, this.shouldShow = ({ view: i, state: s }) => {
      const { selection: l } = s, { $anchor: u, empty: c } = l, d = u.depth === 1, f = u.parent.isTextblock && !u.parent.type.spec.code && !u.parent.textContent && u.parent.childCount === 0 && !this.getTextContent(u.parent);
      return !(!i.hasFocus() || !c || !d || !f || !this.editor.isEditable);
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: i }) => {
      var s;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      i != null && i.relatedTarget && (!((s = this.element.parentNode) === null || s === void 0) && s.contains(i.relatedTarget)) || (i == null ? void 0 : i.relatedTarget) !== this.editor.view.dom && this.hide();
    }, this.tippyBlurHandler = (i) => {
      this.blurHandler({ event: i });
    }, this.editor = e, this.element = n, this.view = r, a && (this.shouldShow = a), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.tippyOptions = o, this.element.remove(), this.element.style.visibility = "visible";
  }
  createTooltip() {
    const { element: e } = this.editor.options, n = !!e.parentElement;
    this.tippy || !n || (this.tippy = bs(e, {
      duration: 0,
      getReferenceClientRect: null,
      content: this.element,
      interactive: !0,
      trigger: "manual",
      placement: "right",
      hideOnClick: "toggle",
      ...this.tippyOptions
    }), this.tippy.popper.firstChild && this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler));
  }
  update(e, n) {
    var r, o, a;
    const { state: i } = e, { doc: s, selection: l } = i, { from: u, to: c } = l;
    if (n && n.doc.eq(s) && n.selection.eq(l))
      return;
    if (this.createTooltip(), !((r = this.shouldShow) === null || r === void 0 ? void 0 : r.call(this, {
      editor: this.editor,
      view: e,
      state: i,
      oldState: n
    }))) {
      this.hide();
      return;
    }
    (o = this.tippy) === null || o === void 0 || o.setProps({
      getReferenceClientRect: ((a = this.tippyOptions) === null || a === void 0 ? void 0 : a.getReferenceClientRect) || (() => u1(e, u, c))
    }), this.show();
  }
  show() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.show();
  }
  hide() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.hide();
  }
  destroy() {
    var e, n;
    !((e = this.tippy) === null || e === void 0) && e.popper.firstChild && this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler), (n = this.tippy) === null || n === void 0 || n.destroy(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler);
  }
}
const P1 = (t) => new rn({
  key: typeof t.pluginKey == "string" ? new Fn(t.pluginKey) : t.pluginKey,
  view: (e) => new uH({ view: e, ...t })
});
vn.create({
  name: "floatingMenu",
  addOptions() {
    return {
      element: null,
      tippyOptions: {},
      pluginKey: "floatingMenu",
      shouldShow: null
    };
  },
  addProseMirrorPlugins() {
    return this.options.element ? [
      P1({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        tippyOptions: this.options.tippyOptions,
        shouldShow: this.options.shouldShow
      })
    ] : [];
  }
});
j({
  name: "BubbleMenu",
  props: {
    pluginKey: {
      type: [String, Object],
      default: "bubbleMenu"
    },
    editor: {
      type: Object,
      required: !0
    },
    updateDelay: {
      type: Number,
      default: void 0
    },
    tippyOptions: {
      type: Object,
      default: () => ({})
    },
    shouldShow: {
      type: Function,
      default: null
    }
  },
  setup(t, { slots: e }) {
    const n = F(null);
    return ze(() => {
      const { updateDelay: r, editor: o, pluginKey: a, shouldShow: i, tippyOptions: s } = t;
      o.registerPlugin(D1({
        updateDelay: r,
        editor: o,
        element: n.value,
        pluginKey: a,
        shouldShow: i,
        tippyOptions: s
      }));
    }), is(() => {
      const { pluginKey: r, editor: o } = t;
      o.unregisterPlugin(r);
    }), () => {
      var r;
      return Kn("div", { ref: n }, (r = e.default) === null || r === void 0 ? void 0 : r.call(e));
    };
  }
});
function my(t) {
  return My((e, n) => ({
    get() {
      return e(), t;
    },
    set(r) {
      t = r, requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          n();
        });
      });
    }
  }));
}
class cH extends xV {
  constructor(e = {}) {
    return super(e), this.contentComponent = null, this.appContext = null, this.reactiveState = my(this.view.state), this.reactiveExtensionStorage = my(this.extensionStorage), this.on("beforeTransaction", ({ nextState: n }) => {
      this.reactiveState.value = n, this.reactiveExtensionStorage.value = this.extensionStorage;
    }), Py(this);
  }
  get state() {
    return this.reactiveState ? this.reactiveState.value : this.view.state;
  }
  get storage() {
    return this.reactiveExtensionStorage ? this.reactiveExtensionStorage.value : super.storage;
  }
  /**
   * Register a ProseMirror plugin.
   */
  registerPlugin(e, n) {
    const r = super.registerPlugin(e, n);
    return this.reactiveState && (this.reactiveState.value = r), r;
  }
  /**
   * Unregister a ProseMirror plugin.
   */
  unregisterPlugin(e) {
    const n = super.unregisterPlugin(e);
    return this.reactiveState && n && (this.reactiveState.value = n), n;
  }
}
const dH = j({
  name: "EditorContent",
  props: {
    editor: {
      default: null,
      type: Object
    }
  },
  setup(t) {
    const e = F(), n = Cn();
    return Nn(() => {
      const r = t.editor;
      r && r.options.element && e.value && nt(() => {
        if (!e.value || !r.options.element.firstChild)
          return;
        const o = p(e.value);
        e.value.append(...r.options.element.childNodes), r.contentComponent = n.ctx._, n && (r.appContext = {
          ...n.appContext,
          // Vue internally uses prototype chain to forward/shadow injects across the entire component chain
          // so don't use object spread operator or 'Object.assign' and just set `provides` as is on editor's appContext
          // @ts-expect-error forward instance's 'provides' into appContext
          provides: n.provides
        }), r.setOptions({
          element: o
        }), r.createNodeViews();
      });
    }), is(() => {
      const r = t.editor;
      r && (r.contentComponent = null, r.appContext = null);
    }), { rootEl: e };
  },
  render() {
    return Kn("div", {
      ref: (t) => {
        this.rootEl = t;
      }
    });
  }
});
j({
  name: "FloatingMenu",
  props: {
    pluginKey: {
      // TODO: TypeScript breaks :(
      // type: [String, Object as PropType<Exclude<FloatingMenuPluginProps['pluginKey'], string>>],
      type: null,
      default: "floatingMenu"
    },
    editor: {
      type: Object,
      required: !0
    },
    tippyOptions: {
      type: Object,
      default: () => ({})
    },
    shouldShow: {
      type: Function,
      default: null
    }
  },
  setup(t, { slots: e }) {
    const n = F(null);
    return ze(() => {
      const { pluginKey: r, editor: o, tippyOptions: a, shouldShow: i } = t;
      o.registerPlugin(P1({
        pluginKey: r,
        editor: o,
        element: n.value,
        tippyOptions: a,
        shouldShow: i
      }));
    }), is(() => {
      const { pluginKey: r, editor: o } = t;
      o.unregisterPlugin(r);
    }), () => {
      var r;
      return Kn("div", { ref: n }, (r = e.default) === null || r === void 0 ? void 0 : r.call(e));
    };
  }
});
j({
  name: "NodeViewContent",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  render() {
    return Kn(this.as, {
      style: {
        whiteSpace: "pre-wrap"
      },
      "data-node-view-content": ""
    });
  }
});
j({
  name: "NodeViewWrapper",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  inject: ["onDragStart", "decorationClasses"],
  render() {
    var t, e;
    return Kn(this.as, {
      // @ts-ignore
      class: this.decorationClasses,
      style: {
        whiteSpace: "normal"
      },
      "data-node-view-wrapper": "",
      // @ts-ignore (https://github.com/vuejs/vue-next/issues/3031)
      onDragstart: this.onDragStart
    }, (e = (t = this.$slots).default) === null || e === void 0 ? void 0 : e.call(t));
  }
});
const fH = (t = {}) => {
  const e = ri();
  return ze(() => {
    e.value = new cH(t);
  }), is(() => {
    var n, r, o;
    const a = (n = e.value) === null || n === void 0 ? void 0 : n.options.element, i = a == null ? void 0 : a.cloneNode(!0);
    (r = a == null ? void 0 : a.parentNode) === null || r === void 0 || r.replaceChild(i, a), (o = e.value) === null || o === void 0 || o.destroy();
  }), e;
}, pH = /^\s*>\s$/, hH = br.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [
      { tag: "blockquote" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["blockquote", nn(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: t }) => t.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: t }) => t.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: t }) => t.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      ml({
        find: pH,
        type: this.type
      })
    ];
  }
}), mH = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, gH = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, vH = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, yH = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, bH = so.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (t) => t.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (t) => t.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (t) => /^(bold(er)?|[5-9]\d{2,})$/.test(t) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["strong", nn(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setBold: () => ({ commands: t }) => t.setMark(this.name),
      toggleBold: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetBold: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      Zi({
        find: mH,
        type: this.type
      }),
      Zi({
        find: vH,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      ti({
        find: gH,
        type: this.type
      }),
      ti({
        find: yH,
        type: this.type
      })
    ];
  }
}), kH = "listItem", gy = "textStyle", vy = /^\s*([-+*])\s$/, wH = br.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      { tag: "ul" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["ul", nn(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: t, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(kH, this.editor.getAttributes(gy)).run() : t.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let t = ml({
      find: vy,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (t = ml({
      find: vy,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(gy),
      editor: this.editor
    })), [
      t
    ];
  }
}), _H = /(^|[^`])`([^`]+)`(?!`)/, CH = /(^|[^`])`([^`]+)`(?!`)/g, EH = so.create({
  name: "code",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [
      { tag: "code" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["code", nn(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setCode: () => ({ commands: t }) => t.setMark(this.name),
      toggleCode: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetCode: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleCode()
    };
  },
  addInputRules() {
    return [
      Zi({
        find: _H,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      ti({
        find: CH,
        type: this.type
      })
    ];
  }
}), OH = /^```([a-z]+)?[\s\n]$/, TH = /^~~~([a-z]+)?[\s\n]$/, SH = br.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      defaultLanguage: null,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: this.options.defaultLanguage,
        parseHTML: (t) => {
          var e;
          const { languageClassPrefix: n } = this.options, a = [...((e = t.firstElementChild) === null || e === void 0 ? void 0 : e.classList) || []].filter((i) => i.startsWith(n)).map((i) => i.replace(n, ""))[0];
          return a || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    return [
      "pre",
      nn(this.options.HTMLAttributes, e),
      [
        "code",
        {
          class: t.attrs.language ? this.options.languageClassPrefix + t.attrs.language : null
        },
        0
      ]
    ];
  },
  addCommands() {
    return {
      setCodeBlock: (t) => ({ commands: e }) => e.setNode(this.name, t),
      toggleCodeBlock: (t) => ({ commands: e }) => e.toggleNode(this.name, "paragraph", t)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: t, $anchor: e } = this.editor.state.selection, n = e.pos === 1;
        return !t || e.parent.type.name !== this.name ? !1 : n || !e.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // exit node on triple enter
      Enter: ({ editor: t }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: e } = t, { selection: n } = e, { $from: r, empty: o } = n;
        if (!o || r.parent.type !== this.type)
          return !1;
        const a = r.parentOffset === r.parent.nodeSize - 2, i = r.parent.textContent.endsWith(`

`);
        return !a || !i ? !1 : t.chain().command(({ tr: s }) => (s.delete(r.pos - 2, r.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: t }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: e } = t, { selection: n, doc: r } = e, { $from: o, empty: a } = n;
        if (!a || o.parent.type !== this.type || !(o.parentOffset === o.parent.nodeSize - 2))
          return !1;
        const s = o.after();
        return s === void 0 ? !1 : r.nodeAt(s) ? t.commands.command(({ tr: u }) => (u.setSelection(at.near(r.resolve(s))), !0)) : t.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      lp({
        find: OH,
        type: this.type,
        getAttributes: (t) => ({
          language: t[1]
        })
      }),
      lp({
        find: TH,
        type: this.type,
        getAttributes: (t) => ({
          language: t[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new rn({
        key: new Fn("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (t, e) => {
            if (!e.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const n = e.clipboardData.getData("text/plain"), r = e.clipboardData.getData("vscode-editor-data"), o = r ? JSON.parse(r) : void 0, a = o == null ? void 0 : o.mode;
            if (!n || !a)
              return !1;
            const { tr: i, schema: s } = t.state, l = s.text(n.replace(/\r\n?/g, `
`));
            return i.replaceSelectionWith(this.type.create({ language: a }, l)), i.selection.$from.parent.type !== this.type && i.setSelection(tt.near(i.doc.resolve(Math.max(0, i.selection.from - 2)))), i.setMeta("paste", !0), t.dispatch(i), !0;
          }
        }
      })
    ];
  }
}), xH = br.create({
  name: "doc",
  topNode: !0,
  content: "block+"
});
function AH(t = {}) {
  return new rn({
    view(e) {
      return new MH(e, t);
    }
  });
}
class MH {
  constructor(e, n) {
    var r;
    this.editorView = e, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (r = n.width) !== null && r !== void 0 ? r : 1, this.color = n.color === !1 ? void 0 : n.color || "black", this.class = n.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((o) => {
      let a = (i) => {
        this[o](i);
      };
      return e.dom.addEventListener(o, a), { name: o, handler: a };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: e, handler: n }) => this.editorView.dom.removeEventListener(e, n));
  }
  update(e, n) {
    this.cursorPos != null && n.doc != e.state.doc && (this.cursorPos > e.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(e) {
    e != this.cursorPos && (this.cursorPos = e, e == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let e = this.editorView.state.doc.resolve(this.cursorPos), n = !e.parent.inlineContent, r, o = this.editorView.dom, a = o.getBoundingClientRect(), i = a.width / o.offsetWidth, s = a.height / o.offsetHeight;
    if (n) {
      let d = e.nodeBefore, f = e.nodeAfter;
      if (d || f) {
        let h = this.editorView.nodeDOM(this.cursorPos - (d ? d.nodeSize : 0));
        if (h) {
          let m = h.getBoundingClientRect(), g = d ? m.bottom : m.top;
          d && f && (g = (g + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2);
          let y = this.width / 2 * s;
          r = { left: m.left, right: m.right, top: g - y, bottom: g + y };
        }
      }
    }
    if (!r) {
      let d = this.editorView.coordsAtPos(this.cursorPos), f = this.width / 2 * i;
      r = { left: d.left - f, right: d.left + f, top: d.top, bottom: d.bottom };
    }
    let l = this.editorView.dom.offsetParent;
    this.element || (this.element = l.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", n), this.element.classList.toggle("prosemirror-dropcursor-inline", !n);
    let u, c;
    if (!l || l == document.body && getComputedStyle(l).position == "static")
      u = -pageXOffset, c = -pageYOffset;
    else {
      let d = l.getBoundingClientRect(), f = d.width / l.offsetWidth, h = d.height / l.offsetHeight;
      u = d.left - l.scrollLeft * f, c = d.top - l.scrollTop * h;
    }
    this.element.style.left = (r.left - u) / i + "px", this.element.style.top = (r.top - c) / s + "px", this.element.style.width = (r.right - r.left) / i + "px", this.element.style.height = (r.bottom - r.top) / s + "px";
  }
  scheduleRemoval(e) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), e);
  }
  dragover(e) {
    if (!this.editorView.editable)
      return;
    let n = this.editorView.posAtCoords({ left: e.clientX, top: e.clientY }), r = n && n.inside >= 0 && this.editorView.state.doc.nodeAt(n.inside), o = r && r.type.spec.disableDropCursor, a = typeof o == "function" ? o(this.editorView, n, e) : o;
    if (n && !a) {
      let i = n.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let s = Qk(this.editorView.state.doc, i, this.editorView.dragging.slice);
        s != null && (i = s);
      }
      this.setCursor(i), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(e) {
    this.editorView.dom.contains(e.relatedTarget) || this.setCursor(null);
  }
}
const IH = vn.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      AH(this.options)
    ];
  }
});
class Ht extends at {
  /**
  Create a gap cursor.
  */
  constructor(e) {
    super(e, e);
  }
  map(e, n) {
    let r = e.resolve(n.map(this.head));
    return Ht.valid(r) ? new Ht(r) : at.near(r);
  }
  content() {
    return Pe.empty;
  }
  eq(e) {
    return e instanceof Ht && e.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new Ht(e.resolve(n.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new im(this.anchor);
  }
  /**
  @internal
  */
  static valid(e) {
    let n = e.parent;
    if (n.isTextblock || !DH(e) || !PH(e))
      return !1;
    let r = n.type.spec.allowGapCursor;
    if (r != null)
      return r;
    let o = n.contentMatchAt(e.index()).defaultType;
    return o && o.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(e, n, r = !1) {
    e: for (; ; ) {
      if (!r && Ht.valid(e))
        return e;
      let o = e.pos, a = null;
      for (let i = e.depth; ; i--) {
        let s = e.node(i);
        if (n > 0 ? e.indexAfter(i) < s.childCount : e.index(i) > 0) {
          a = s.child(n > 0 ? e.indexAfter(i) : e.index(i) - 1);
          break;
        } else if (i == 0)
          return null;
        o += n;
        let l = e.doc.resolve(o);
        if (Ht.valid(l))
          return l;
      }
      for (; ; ) {
        let i = n > 0 ? a.firstChild : a.lastChild;
        if (!i) {
          if (a.isAtom && !a.isText && !je.isSelectable(a)) {
            e = e.doc.resolve(o + a.nodeSize * n), r = !1;
            continue e;
          }
          break;
        }
        a = i, o += n;
        let s = e.doc.resolve(o);
        if (Ht.valid(s))
          return s;
      }
      return null;
    }
  }
}
Ht.prototype.visible = !1;
Ht.findFrom = Ht.findGapCursorFrom;
at.jsonID("gapcursor", Ht);
class im {
  constructor(e) {
    this.pos = e;
  }
  map(e) {
    return new im(e.map(this.pos));
  }
  resolve(e) {
    let n = e.resolve(this.pos);
    return Ht.valid(n) ? new Ht(n) : at.near(n);
  }
}
function DH(t) {
  for (let e = t.depth; e >= 0; e--) {
    let n = t.index(e), r = t.node(e);
    if (n == 0) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let o = r.child(n - 1); ; o = o.lastChild) {
      if (o.childCount == 0 && !o.inlineContent || o.isAtom || o.type.spec.isolating)
        return !0;
      if (o.inlineContent)
        return !1;
    }
  }
  return !0;
}
function PH(t) {
  for (let e = t.depth; e >= 0; e--) {
    let n = t.indexAfter(e), r = t.node(e);
    if (n == r.childCount) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let o = r.child(n); ; o = o.firstChild) {
      if (o.childCount == 0 && !o.inlineContent || o.isAtom || o.type.spec.isolating)
        return !0;
      if (o.inlineContent)
        return !1;
    }
  }
  return !0;
}
function NH() {
  return new rn({
    props: {
      decorations: BH,
      createSelectionBetween(t, e, n) {
        return e.pos == n.pos && Ht.valid(n) ? new Ht(n) : null;
      },
      handleClick: RH,
      handleKeyDown: $H,
      handleDOMEvents: { beforeinput: LH }
    }
  });
}
const $H = Fw({
  ArrowLeft: au("horiz", -1),
  ArrowRight: au("horiz", 1),
  ArrowUp: au("vert", -1),
  ArrowDown: au("vert", 1)
});
function au(t, e) {
  const n = t == "vert" ? e > 0 ? "down" : "up" : e > 0 ? "right" : "left";
  return function(r, o, a) {
    let i = r.selection, s = e > 0 ? i.$to : i.$from, l = i.empty;
    if (i instanceof tt) {
      if (!a.endOfTextblock(n) || s.depth == 0)
        return !1;
      l = !1, s = r.doc.resolve(e > 0 ? s.after() : s.before());
    }
    let u = Ht.findGapCursorFrom(s, e, l);
    return u ? (o && o(r.tr.setSelection(new Ht(u))), !0) : !1;
  };
}
function RH(t, e, n) {
  if (!t || !t.editable)
    return !1;
  let r = t.state.doc.resolve(e);
  if (!Ht.valid(r))
    return !1;
  let o = t.posAtCoords({ left: n.clientX, top: n.clientY });
  return o && o.inside > -1 && je.isSelectable(t.state.doc.nodeAt(o.inside)) ? !1 : (t.dispatch(t.state.tr.setSelection(new Ht(r))), !0);
}
function LH(t, e) {
  if (e.inputType != "insertCompositionText" || !(t.state.selection instanceof Ht))
    return !1;
  let { $from: n } = t.state.selection, r = n.parent.contentMatchAt(n.index()).findWrapping(t.state.schema.nodes.text);
  if (!r)
    return !1;
  let o = _e.empty;
  for (let i = r.length - 1; i >= 0; i--)
    o = _e.from(r[i].createAndFill(null, o));
  let a = t.state.tr.replace(n.pos, n.pos, new Pe(o, 0, 0));
  return a.setSelection(tt.near(a.doc.resolve(n.pos + 1))), t.dispatch(a), !1;
}
function BH(t) {
  if (!(t.selection instanceof Ht))
    return null;
  let e = document.createElement("div");
  return e.className = "ProseMirror-gapcursor", Qt.create(t.doc, [dr.widget(t.selection.head, e, { key: "gapcursor" })]);
}
const FH = vn.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [
      NH()
    ];
  },
  extendNodeSchema(t) {
    var e;
    const n = {
      name: t.name,
      options: t.options,
      storage: t.storage
    };
    return {
      allowGapCursor: (e = ct(Be(t, "allowGapCursor", n))) !== null && e !== void 0 ? e : null
    };
  }
}), VH = br.create({
  name: "hardBreak",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  parseHTML() {
    return [
      { tag: "br" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["br", nn(this.options.HTMLAttributes, t)];
  },
  renderText() {
    return `
`;
  },
  addCommands() {
    return {
      setHardBreak: () => ({ commands: t, chain: e, state: n, editor: r }) => t.first([
        () => t.exitCode(),
        () => t.command(() => {
          const { selection: o, storedMarks: a } = n;
          if (o.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: i } = this.options, { splittableMarks: s } = r.extensionManager, l = a || o.$to.parentOffset && o.$from.marks();
          return e().insertContent({ type: this.name }).command(({ tr: u, dispatch: c }) => {
            if (c && l && i) {
              const d = l.filter((f) => s.includes(f.type.name));
              u.ensureMarks(d);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), HH = br.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((t) => ({
      tag: `h${t}`,
      attrs: { level: t }
    }));
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    return [`h${this.options.levels.includes(t.attrs.level) ? t.attrs.level : this.options.levels[0]}`, nn(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setHeading: (t) => ({ commands: e }) => this.options.levels.includes(t.level) ? e.setNode(this.name, t) : !1,
      toggleHeading: (t) => ({ commands: e }) => this.options.levels.includes(t.level) ? e.toggleNode(this.name, "paragraph", t) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce((t, e) => ({
      ...t,
      [`Mod-Alt-${e}`]: () => this.editor.commands.toggleHeading({ level: e })
    }), {});
  },
  addInputRules() {
    return this.options.levels.map((t) => lp({
      find: new RegExp(`^(#{${Math.min(...this.options.levels)},${t}})\\s$`),
      type: this.type,
      getAttributes: {
        level: t
      }
    }));
  }
});
var Ku = 200, cn = function() {
};
cn.prototype.append = function(e) {
  return e.length ? (e = cn.from(e), !this.length && e || e.length < Ku && this.leafAppend(e) || this.length < Ku && e.leafPrepend(this) || this.appendInner(e)) : this;
};
cn.prototype.prepend = function(e) {
  return e.length ? cn.from(e).append(this) : this;
};
cn.prototype.appendInner = function(e) {
  return new UH(this, e);
};
cn.prototype.slice = function(e, n) {
  return e === void 0 && (e = 0), n === void 0 && (n = this.length), e >= n ? cn.empty : this.sliceInner(Math.max(0, e), Math.min(this.length, n));
};
cn.prototype.get = function(e) {
  if (!(e < 0 || e >= this.length))
    return this.getInner(e);
};
cn.prototype.forEach = function(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = this.length), n <= r ? this.forEachInner(e, n, r, 0) : this.forEachInvertedInner(e, n, r, 0);
};
cn.prototype.map = function(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = this.length);
  var o = [];
  return this.forEach(function(a, i) {
    return o.push(e(a, i));
  }, n, r), o;
};
cn.from = function(e) {
  return e instanceof cn ? e : e && e.length ? new N1(e) : cn.empty;
};
var N1 = /* @__PURE__ */ function(t) {
  function e(r) {
    t.call(this), this.values = r;
  }
  t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
  var n = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return e.prototype.flatten = function() {
    return this.values;
  }, e.prototype.sliceInner = function(o, a) {
    return o == 0 && a == this.length ? this : new e(this.values.slice(o, a));
  }, e.prototype.getInner = function(o) {
    return this.values[o];
  }, e.prototype.forEachInner = function(o, a, i, s) {
    for (var l = a; l < i; l++)
      if (o(this.values[l], s + l) === !1)
        return !1;
  }, e.prototype.forEachInvertedInner = function(o, a, i, s) {
    for (var l = a - 1; l >= i; l--)
      if (o(this.values[l], s + l) === !1)
        return !1;
  }, e.prototype.leafAppend = function(o) {
    if (this.length + o.length <= Ku)
      return new e(this.values.concat(o.flatten()));
  }, e.prototype.leafPrepend = function(o) {
    if (this.length + o.length <= Ku)
      return new e(o.flatten().concat(this.values));
  }, n.length.get = function() {
    return this.values.length;
  }, n.depth.get = function() {
    return 0;
  }, Object.defineProperties(e.prototype, n), e;
}(cn);
cn.empty = new N1([]);
var UH = /* @__PURE__ */ function(t) {
  function e(n, r) {
    t.call(this), this.left = n, this.right = r, this.length = n.length + r.length, this.depth = Math.max(n.depth, r.depth) + 1;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, e.prototype.getInner = function(r) {
    return r < this.left.length ? this.left.get(r) : this.right.get(r - this.left.length);
  }, e.prototype.forEachInner = function(r, o, a, i) {
    var s = this.left.length;
    if (o < s && this.left.forEachInner(r, o, Math.min(a, s), i) === !1 || a > s && this.right.forEachInner(r, Math.max(o - s, 0), Math.min(this.length, a) - s, i + s) === !1)
      return !1;
  }, e.prototype.forEachInvertedInner = function(r, o, a, i) {
    var s = this.left.length;
    if (o > s && this.right.forEachInvertedInner(r, o - s, Math.max(a, s) - s, i + s) === !1 || a < s && this.left.forEachInvertedInner(r, Math.min(o, s), a, i) === !1)
      return !1;
  }, e.prototype.sliceInner = function(r, o) {
    if (r == 0 && o == this.length)
      return this;
    var a = this.left.length;
    return o <= a ? this.left.slice(r, o) : r >= a ? this.right.slice(r - a, o - a) : this.left.slice(r, a).append(this.right.slice(0, o - a));
  }, e.prototype.leafAppend = function(r) {
    var o = this.right.leafAppend(r);
    if (o)
      return new e(this.left, o);
  }, e.prototype.leafPrepend = function(r) {
    var o = this.left.leafPrepend(r);
    if (o)
      return new e(o, this.right);
  }, e.prototype.appendInner = function(r) {
    return this.left.depth >= Math.max(this.right.depth, r.depth) + 1 ? new e(this.left, new e(this.right, r)) : new e(this, r);
  }, e;
}(cn);
const WH = 500;
class Sr {
  constructor(e, n) {
    this.items = e, this.eventCount = n;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(e, n) {
    if (this.eventCount == 0)
      return null;
    let r = this.items.length;
    for (; ; r--)
      if (this.items.get(r - 1).selection) {
        --r;
        break;
      }
    let o, a;
    n && (o = this.remapping(r, this.items.length), a = o.maps.length);
    let i = e.tr, s, l, u = [], c = [];
    return this.items.forEach((d, f) => {
      if (!d.step) {
        o || (o = this.remapping(r, f + 1), a = o.maps.length), a--, c.push(d);
        return;
      }
      if (o) {
        c.push(new Hr(d.map));
        let h = d.step.map(o.slice(a)), m;
        h && i.maybeStep(h).doc && (m = i.mapping.maps[i.mapping.maps.length - 1], u.push(new Hr(m, void 0, void 0, u.length + c.length))), a--, m && o.appendMap(m, a);
      } else
        i.maybeStep(d.step);
      if (d.selection)
        return s = o ? d.selection.map(o.slice(a)) : d.selection, l = new Sr(this.items.slice(0, r).append(c.reverse().concat(u)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: l, transform: i, selection: s };
  }
  // Create a new branch with the given transform added.
  addTransform(e, n, r, o) {
    let a = [], i = this.eventCount, s = this.items, l = !o && s.length ? s.get(s.length - 1) : null;
    for (let c = 0; c < e.steps.length; c++) {
      let d = e.steps[c].invert(e.docs[c]), f = new Hr(e.mapping.maps[c], d, n), h;
      (h = l && l.merge(f)) && (f = h, c ? a.pop() : s = s.slice(0, s.length - 1)), a.push(f), n && (i++, n = void 0), o || (l = f);
    }
    let u = i - r.depth;
    return u > jH && (s = KH(s, u), i -= u), new Sr(s.append(a), i);
  }
  remapping(e, n) {
    let r = new ul();
    return this.items.forEach((o, a) => {
      let i = o.mirrorOffset != null && a - o.mirrorOffset >= e ? r.maps.length - o.mirrorOffset : void 0;
      r.appendMap(o.map, i);
    }, e, n), r;
  }
  addMaps(e) {
    return this.eventCount == 0 ? this : new Sr(this.items.append(e.map((n) => new Hr(n))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(e, n) {
    if (!this.eventCount)
      return this;
    let r = [], o = Math.max(0, this.items.length - n), a = e.mapping, i = e.steps.length, s = this.eventCount;
    this.items.forEach((f) => {
      f.selection && s--;
    }, o);
    let l = n;
    this.items.forEach((f) => {
      let h = a.getMirror(--l);
      if (h == null)
        return;
      i = Math.min(i, h);
      let m = a.maps[h];
      if (f.step) {
        let g = e.steps[h].invert(e.docs[h]), y = f.selection && f.selection.map(a.slice(l + 1, h));
        y && s++, r.push(new Hr(m, g, y));
      } else
        r.push(new Hr(m));
    }, o);
    let u = [];
    for (let f = n; f < i; f++)
      u.push(new Hr(a.maps[f]));
    let c = this.items.slice(0, o).append(u).append(r), d = new Sr(c, s);
    return d.emptyItemCount() > WH && (d = d.compress(this.items.length - r.length)), d;
  }
  emptyItemCount() {
    let e = 0;
    return this.items.forEach((n) => {
      n.step || e++;
    }), e;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(e = this.items.length) {
    let n = this.remapping(0, e), r = n.maps.length, o = [], a = 0;
    return this.items.forEach((i, s) => {
      if (s >= e)
        o.push(i), i.selection && a++;
      else if (i.step) {
        let l = i.step.map(n.slice(r)), u = l && l.getMap();
        if (r--, u && n.appendMap(u, r), l) {
          let c = i.selection && i.selection.map(n.slice(r));
          c && a++;
          let d = new Hr(u.invert(), l, c), f, h = o.length - 1;
          (f = o.length && o[h].merge(d)) ? o[h] = f : o.push(d);
        }
      } else i.map && r--;
    }, this.items.length, 0), new Sr(cn.from(o.reverse()), a);
  }
}
Sr.empty = new Sr(cn.empty, 0);
function KH(t, e) {
  let n;
  return t.forEach((r, o) => {
    if (r.selection && e-- == 0)
      return n = o, !1;
  }), t.slice(n);
}
class Hr {
  constructor(e, n, r, o) {
    this.map = e, this.step = n, this.selection = r, this.mirrorOffset = o;
  }
  merge(e) {
    if (this.step && e.step && !e.selection) {
      let n = e.step.merge(this.step);
      if (n)
        return new Hr(n.getMap().invert(), n, this.selection);
    }
  }
}
class Yo {
  constructor(e, n, r, o, a) {
    this.done = e, this.undone = n, this.prevRanges = r, this.prevTime = o, this.prevComposition = a;
  }
}
const jH = 20;
function zH(t, e, n, r) {
  let o = n.getMeta(ja), a;
  if (o)
    return o.historyState;
  n.getMeta(GH) && (t = new Yo(t.done, t.undone, null, 0, -1));
  let i = n.getMeta("appendedTransaction");
  if (n.steps.length == 0)
    return t;
  if (i && i.getMeta(ja))
    return i.getMeta(ja).redo ? new Yo(t.done.addTransform(n, void 0, r, vu(e)), t.undone, yy(n.mapping.maps), t.prevTime, t.prevComposition) : new Yo(t.done, t.undone.addTransform(n, void 0, r, vu(e)), null, t.prevTime, t.prevComposition);
  if (n.getMeta("addToHistory") !== !1 && !(i && i.getMeta("addToHistory") === !1)) {
    let s = n.getMeta("composition"), l = t.prevTime == 0 || !i && t.prevComposition != s && (t.prevTime < (n.time || 0) - r.newGroupDelay || !YH(n, t.prevRanges)), u = i ? nf(t.prevRanges, n.mapping) : yy(n.mapping.maps);
    return new Yo(t.done.addTransform(n, l ? e.selection.getBookmark() : void 0, r, vu(e)), Sr.empty, u, n.time, s ?? t.prevComposition);
  } else return (a = n.getMeta("rebased")) ? new Yo(t.done.rebased(n, a), t.undone.rebased(n, a), nf(t.prevRanges, n.mapping), t.prevTime, t.prevComposition) : new Yo(t.done.addMaps(n.mapping.maps), t.undone.addMaps(n.mapping.maps), nf(t.prevRanges, n.mapping), t.prevTime, t.prevComposition);
}
function YH(t, e) {
  if (!e)
    return !1;
  if (!t.docChanged)
    return !0;
  let n = !1;
  return t.mapping.maps[0].forEach((r, o) => {
    for (let a = 0; a < e.length; a += 2)
      r <= e[a + 1] && o >= e[a] && (n = !0);
  }), n;
}
function yy(t) {
  let e = [];
  for (let n = t.length - 1; n >= 0 && e.length == 0; n--)
    t[n].forEach((r, o, a, i) => e.push(a, i));
  return e;
}
function nf(t, e) {
  if (!t)
    return null;
  let n = [];
  for (let r = 0; r < t.length; r += 2) {
    let o = e.map(t[r], 1), a = e.map(t[r + 1], -1);
    o <= a && n.push(o, a);
  }
  return n;
}
function qH(t, e, n) {
  let r = vu(e), o = ja.get(e).spec.config, a = (n ? t.undone : t.done).popEvent(e, r);
  if (!a)
    return null;
  let i = a.selection.resolve(a.transform.doc), s = (n ? t.done : t.undone).addTransform(a.transform, e.selection.getBookmark(), o, r), l = new Yo(n ? s : a.remaining, n ? a.remaining : s, null, 0, -1);
  return a.transform.setSelection(i).setMeta(ja, { redo: n, historyState: l });
}
let rf = !1, by = null;
function vu(t) {
  let e = t.plugins;
  if (by != e) {
    rf = !1, by = e;
    for (let n = 0; n < e.length; n++)
      if (e[n].spec.historyPreserveItems) {
        rf = !0;
        break;
      }
  }
  return rf;
}
const ja = new Fn("history"), GH = new Fn("closeHistory");
function JH(t = {}) {
  return t = {
    depth: t.depth || 100,
    newGroupDelay: t.newGroupDelay || 500
  }, new rn({
    key: ja,
    state: {
      init() {
        return new Yo(Sr.empty, Sr.empty, null, 0, -1);
      },
      apply(e, n, r) {
        return zH(n, r, e, t);
      }
    },
    config: t,
    props: {
      handleDOMEvents: {
        beforeinput(e, n) {
          let r = n.inputType, o = r == "historyUndo" ? R1 : r == "historyRedo" ? L1 : null;
          return o ? (n.preventDefault(), o(e.state, e.dispatch)) : !1;
        }
      }
    }
  });
}
function $1(t, e) {
  return (n, r) => {
    let o = ja.getState(n);
    if (!o || (t ? o.undone : o.done).eventCount == 0)
      return !1;
    if (r) {
      let a = qH(o, n, t);
      a && r(e ? a.scrollIntoView() : a);
    }
    return !0;
  };
}
const R1 = $1(!1, !0), L1 = $1(!0, !0), XH = vn.create({
  name: "history",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: t, dispatch: e }) => R1(t, e),
      redo: () => ({ state: t, dispatch: e }) => L1(t, e)
    };
  },
  addProseMirrorPlugins() {
    return [
      JH(this.options)
    ];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
}), QH = br.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["hr", nn(this.options.HTMLAttributes, t)];
  },
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain: t, state: e }) => {
        const { selection: n } = e, { $from: r, $to: o } = n, a = t();
        return r.parentOffset === 0 ? a.insertContentAt({
          from: Math.max(r.pos - 1, 0),
          to: o.pos
        }, {
          type: this.name
        }) : l1(n) ? a.insertContentAt(o.pos, {
          type: this.name
        }) : a.insertContent({ type: this.name }), a.command(({ tr: i, dispatch: s }) => {
          var l;
          if (s) {
            const { $to: u } = i.selection, c = u.end();
            if (u.nodeAfter)
              u.nodeAfter.isTextblock ? i.setSelection(tt.create(i.doc, u.pos + 1)) : u.nodeAfter.isBlock ? i.setSelection(je.create(i.doc, u.pos)) : i.setSelection(tt.create(i.doc, u.pos));
            else {
              const d = (l = u.parent.type.contentMatch.defaultType) === null || l === void 0 ? void 0 : l.create();
              d && (i.insert(c, d), i.setSelection(tt.create(i.doc, c + 1)));
            }
            i.scrollIntoView();
          }
          return !0;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      c1({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
}), ZH = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, eU = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, tU = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, nU = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, rU = so.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (t) => t.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (t) => t.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["em", nn(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: t }) => t.setMark(this.name),
      toggleItalic: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetItalic: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      Zi({
        find: ZH,
        type: this.type
      }),
      Zi({
        find: tU,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      ti({
        find: eU,
        type: this.type
      }),
      ti({
        find: nU,
        type: this.type
      })
    ];
  }
}), oU = br.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["li", nn(this.options.HTMLAttributes, t), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), aU = "listItem", ky = "textStyle", wy = /^(\d+)\.\s$/, iU = br.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (t) => t.hasAttribute("start") ? parseInt(t.getAttribute("start") || "", 10) : 1
      },
      type: {
        default: null,
        parseHTML: (t) => t.getAttribute("type")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    const { start: e, ...n } = t;
    return e === 1 ? ["ol", nn(this.options.HTMLAttributes, n), 0] : ["ol", nn(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: t, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(aU, this.editor.getAttributes(ky)).run() : t.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let t = ml({
      find: wy,
      type: this.type,
      getAttributes: (e) => ({ start: +e[1] }),
      joinPredicate: (e, n) => n.childCount + n.attrs.start === +e[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (t = ml({
      find: wy,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (e) => ({ start: +e[1], ...this.editor.getAttributes(ky) }),
      joinPredicate: (e, n) => n.childCount + n.attrs.start === +e[1],
      editor: this.editor
    })), [
      t
    ];
  }
}), sU = br.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [
      { tag: "p" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["p", nn(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: t }) => t.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), lU = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, uU = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, cU = so.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (t) => t.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["s", nn(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setStrike: () => ({ commands: t }) => t.setMark(this.name),
      toggleStrike: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetStrike: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      Zi({
        find: lU,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      ti({
        find: uU,
        type: this.type
      })
    ];
  }
}), dU = br.create({
  name: "text",
  group: "inline"
}), fU = vn.create({
  name: "starterKit",
  addExtensions() {
    const t = [];
    return this.options.bold !== !1 && t.push(bH.configure(this.options.bold)), this.options.blockquote !== !1 && t.push(hH.configure(this.options.blockquote)), this.options.bulletList !== !1 && t.push(wH.configure(this.options.bulletList)), this.options.code !== !1 && t.push(EH.configure(this.options.code)), this.options.codeBlock !== !1 && t.push(SH.configure(this.options.codeBlock)), this.options.document !== !1 && t.push(xH.configure(this.options.document)), this.options.dropcursor !== !1 && t.push(IH.configure(this.options.dropcursor)), this.options.gapcursor !== !1 && t.push(FH.configure(this.options.gapcursor)), this.options.hardBreak !== !1 && t.push(VH.configure(this.options.hardBreak)), this.options.heading !== !1 && t.push(HH.configure(this.options.heading)), this.options.history !== !1 && t.push(XH.configure(this.options.history)), this.options.horizontalRule !== !1 && t.push(QH.configure(this.options.horizontalRule)), this.options.italic !== !1 && t.push(rU.configure(this.options.italic)), this.options.listItem !== !1 && t.push(oU.configure(this.options.listItem)), this.options.orderedList !== !1 && t.push(iU.configure(this.options.orderedList)), this.options.paragraph !== !1 && t.push(sU.configure(this.options.paragraph)), this.options.strike !== !1 && t.push(cU.configure(this.options.strike)), this.options.text !== !1 && t.push(dU.configure(this.options.text)), t;
  }
}), pU = /* @__PURE__ */ j({
  __name: "KToggle",
  props: /* @__PURE__ */ it({
    icon: {},
    disabled: { type: [Boolean, String] },
    shadow: { type: [Boolean, String] }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, n = ut(t, "modelValue"), r = A(() => ({
      "k-toggle": !0,
      "k-toggle-pressed": n.value,
      "k-disabled": ce(e.disabled),
      "k-toggle-shadow": ce(e.shadow)
    }));
    return (o, a) => (w(), I(p(zA), {
      disabled: p(ce)(o.disabled),
      class: Ie(r.value),
      modelValue: n.value,
      "onUpdate:modelValue": a[0] || (a[0] = (i) => n.value = i),
      "v-bind": e
    }, {
      default: S(() => [
        o.icon ? (w(), I(ht, {
          key: 0,
          icon: o.icon
        }, null, 8, ["icon"])) : V("", !0)
      ]),
      _: 1
    }, 8, ["disabled", "class", "modelValue"]));
  }
}), iu = /* @__PURE__ */ ya(pU, [["__scopeId", "data-v-2fcd6774"]]), hU = { key: 1 }, B1 = /* @__PURE__ */ j({
  __name: "KPopover",
  props: /* @__PURE__ */ it({
    text: {},
    title: {},
    side: { default: "top" },
    headingLevel: { default: 4 },
    fluid: { type: [Boolean, String] },
    modal: { type: [Boolean, String] },
    closeButton: { type: [Boolean, String], default: !0 },
    inputAutofocus: { type: [Boolean, String], default: !0 }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, n = ut(t, "modelValue"), r = F(null);
    Ke(n, (a) => {
      a && e.inputAutofocus && nt(() => {
        if (r.value) {
          const i = r.value.querySelectorAll(
            "input:not([disabled]), button:not([disabled]), select:not([disabled]), textarea:not([disabled])"
          );
          i.length > 0 && i[0].focus();
        }
      });
    });
    const o = A(() => ({
      "k-popover-content": !0,
      "k-popover-content-fluid": ce(e.fluid)
    }));
    return (a, i) => (w(), I(p(Nx), {
      modal: p(ce)(a.modal),
      open: n.value,
      "onUpdate:open": i[0] || (i[0] = (s) => n.value = s)
    }, {
      default: S(() => [
        q(p(Hx), { "as-child": "" }, {
          default: S(() => [
            $(a.$slots, "trigger", {}, () => [
              a.$slots.trigger ? V("", !0) : (w(), I(zt, {
                key: 0,
                icon: "fas fa-sliders"
              }))
            ])
          ]),
          _: 3
        }),
        q(p(Lx), null, {
          default: S(() => [
            q(p(Vx), {
              class: "k-popover-content-wrapper",
              "side-offset": 5,
              side: e.side
            }, {
              default: S(() => [
                p(ce)(a.modal) ? (w(), I(wc, {
                  key: 0,
                  to: "body"
                }, [
                  i[1] || (i[1] = be("div", { class: "k-popover-backdrop" }, null, -1))
                ])) : V("", !0),
                p(ce)(a.closeButton) ? (w(), I(p(Rx), {
                  key: 1,
                  "as-child": "",
                  class: "k-popover-content-close"
                }, {
                  default: S(() => [
                    q(zt, {
                      icon: "fas fa-close",
                      variant: "link"
                    })
                  ]),
                  _: 1
                })) : V("", !0),
                q(p($x), { class: "k-popover-arrow" }),
                be("div", {
                  class: Ie(o.value),
                  ref_key: "contentRef",
                  ref: r
                }, [
                  $(a.$slots, "content", {}, () => [
                    e.title && !a.$slots.content ? (w(), I(qr, {
                      key: 0,
                      level: e.headingLevel
                    }, {
                      default: S(() => [
                        We(Se(e.title), 1)
                      ]),
                      _: 1
                    }, 8, ["level"])) : V("", !0),
                    e.text && !a.$slots.content ? (w(), K("p", hU, Se(e.text), 1)) : V("", !0)
                  ])
                ], 2)
              ]),
              _: 3
            }, 8, ["side"])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["modal", "open"]));
  }
}), mU = /* @__PURE__ */ j({
  __name: "KHtmlEditorLinkButton",
  props: {
    editor: {}
  },
  setup(t) {
    var u;
    const { t: e } = Mt(), n = t, r = F(((u = n.editor) == null ? void 0 : u.getAttributes("link").href) ?? "https://"), o = F(!1), a = F([]), i = A(() => {
      var c;
      return (c = n.editor) == null ? void 0 : c.isActive("link");
    }), s = () => {
      a.value = [];
      try {
        return new URL(r.value), !0;
      } catch {
        return a.value = [e("k-html-editor.link-button.invalid-url")], !1;
      }
    }, l = () => {
      var d, f;
      if (r.value === null) return;
      if (r.value === "") {
        (d = n.editor) == null || d.chain().focus().extendMarkRange("link").unsetLink().run();
        return;
      }
      s() && ((f = n.editor) == null || f.chain().focus().extendMarkRange("link").setLink({ href: r.value }).run(), o.value = !1);
    };
    return (c, d) => (w(), I(B1, {
      class: "k-html-editor-link-button",
      modelValue: o.value,
      "onUpdate:modelValue": d[1] || (d[1] = (f) => o.value = f)
    }, {
      trigger: S(() => [
        q(zt, {
          icon: "fas fa-link",
          disabled: i.value,
          variant: "link"
        }, null, 8, ["disabled"])
      ]),
      content: S(() => [
        q(qr, { level: 4 }, {
          default: S(() => [
            We(Se(p(e)("k-html-editor.link-button.add-link")), 1)
          ]),
          _: 1
        }),
        q(nh, {
          class: "k-html-editor-link-button-text-input",
          label: p(e)("k-html-editor.link-button.url"),
          title: p(e)("k-html-editor.link-button.url"),
          modelValue: r.value,
          "onUpdate:modelValue": d[0] || (d[0] = (f) => r.value = f),
          errors: a.value
        }, null, 8, ["label", "title", "modelValue", "errors"]),
        q(zt, {
          "prepend-icon": "fas fa-check",
          text: p(e)("k-html-editor.link-button.confirm"),
          onClick: Xe(l, ["prevent"])
        }, null, 8, ["text"])
      ]),
      _: 1
    }, 8, ["modelValue"]));
  }
}), gU = /* @__PURE__ */ j({
  __name: "KHtmlEditorImageButton",
  props: {
    editor: {}
  },
  setup(t) {
    const { t: e } = Mt(), n = t, r = F("https://"), o = F(!1), a = F([]), i = () => {
      a.value = [];
      try {
        return new URL(r.value), !0;
      } catch {
        return a.value = [e("k-html-editor.image-button.invalid-url")], !1;
      }
    }, s = () => {
      var u;
      r.value === null || r.value === "" || !i() || ((u = n.editor) == null || u.chain().focus().setImage({ src: r.value }).run(), o.value = !1);
    };
    return (l, u) => (w(), I(B1, {
      modelValue: o.value,
      "onUpdate:modelValue": u[1] || (u[1] = (c) => o.value = c)
    }, {
      trigger: S(() => [
        q(zt, {
          "prepend-icon": "fas fa-image",
          text: p(e)("k-html-editor.image-button.add-image"),
          variant: "link"
        }, null, 8, ["text"])
      ]),
      content: S(() => [
        q(qr, { level: 4 }, {
          default: S(() => [
            We(Se(p(e)("k-html-editor.image-button.add-image")), 1)
          ]),
          _: 1
        }),
        q(nh, {
          class: "k-html-editor-image-button-text-input",
          label: p(e)("k-html-editor.image-button.url"),
          title: p(e)("k-html-editor.image-button.url"),
          modelValue: r.value,
          "onUpdate:modelValue": u[0] || (u[0] = (c) => r.value = c),
          errors: a.value
        }, null, 8, ["label", "title", "modelValue", "errors"]),
        q(zt, {
          "prepend-icon": "fas fa-check",
          text: p(e)("k-html-editor.image-button.confirm"),
          onClick: Xe(s, ["prevent"])
        }, null, 8, ["text"])
      ]),
      _: 1
    }, 8, ["modelValue"]));
  }
}), vU = {
  key: 11,
  class: "k-html-editor-toolbar-spacer"
}, yU = /* @__PURE__ */ j({
  __name: "KHtmlEditorToolbarTool",
  props: {
    tool: {},
    editor: {},
    disabled: { type: Boolean }
  },
  setup(t) {
    const e = t, { t: n } = Mt(), r = [1, 2, 3, 4], o = [
      { text: n("k-html-editor.text-styles.heading1"), value: "1" },
      { text: n("k-html-editor.text-styles.heading2"), value: "2" },
      { text: n("k-html-editor.text-styles.heading3"), value: "3" },
      { text: n("k-html-editor.text-styles.heading4"), value: "4" }
    ], a = A(() => {
      var c, d;
      for (const f of r)
        if ((c = e.editor) != null && c.isActive("heading", { level: f }))
          return (d = o.find((h) => h.value === f.toString())) == null ? void 0 : d.text;
      return n("k-html-editor.text-styles.paragraph");
    }), i = A(() => {
      var c;
      return (c = e.editor) == null ? void 0 : c.isActive("bold");
    }), s = A(() => {
      var c;
      return (c = e.editor) == null ? void 0 : c.isActive("italic");
    }), l = A(() => {
      var c;
      return (c = e.editor) == null ? void 0 : c.isActive("underline");
    }), u = A(() => {
      var c;
      return (c = e.editor) == null ? void 0 : c.isActive("strike");
    });
    return (c, d) => (w(), K(Me, null, [
      c.tool === "textStyles" ? (w(), I(Y$, {
        key: 0,
        class: "k-html-editor-toolbar-text-dropdown"
      }, {
        trigger: S(() => [
          q(zt, {
            class: "k-html-editor-toolbar-text-dropdown",
            variant: "text",
            text: a.value,
            "append-icon": "fas fa-chevron-down"
          }, null, 8, ["text"])
        ]),
        default: S(() => [
          q(Os, {
            text: p(n)("k-html-editor.text-styles.paragraph"),
            onClick: d[0] || (d[0] = Xe(() => {
              var f;
              return (f = c.editor) == null ? void 0 : f.chain().focus().setParagraph().run();
            }, ["prevent"]))
          }, {
            text: S(() => [
              be("p", null, Se(p(n)("k-html-editor.text-styles.paragraph")), 1)
            ]),
            _: 1
          }, 8, ["text"]),
          q(Os, {
            text: p(n)("k-html-editor.text-styles.heading1"),
            onClick: d[1] || (d[1] = Xe(() => {
              var f;
              return (f = c.editor) == null ? void 0 : f.chain().focus().toggleHeading({ level: 1 }).run();
            }, ["prevent"]))
          }, {
            text: S(() => [
              q(qr, { level: 2 }, {
                default: S(() => [
                  We(Se(p(n)("k-html-editor.text-styles.heading1")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["text"]),
          q(Os, {
            text: p(n)("k-html-editor.text-styles.heading2"),
            onClick: d[2] || (d[2] = Xe(() => {
              var f;
              return (f = c.editor) == null ? void 0 : f.chain().focus().toggleHeading({ level: 2 }).run();
            }, ["prevent"]))
          }, {
            text: S(() => [
              q(qr, { level: 2 }, {
                default: S(() => [
                  We(Se(p(n)("k-html-editor.text-styles.heading2")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["text"]),
          q(Os, {
            text: p(n)("k-html-editor.text-styles.heading3"),
            onClick: d[3] || (d[3] = Xe(() => {
              var f;
              return (f = c.editor) == null ? void 0 : f.chain().focus().toggleHeading({ level: 3 }).run();
            }, ["prevent"]))
          }, {
            text: S(() => [
              q(qr, { level: 3 }, {
                default: S(() => [
                  We(Se(p(n)("k-html-editor.text-styles.heading3")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["text"]),
          q(Os, {
            text: p(n)("k-html-editor.text-styles.heading4"),
            onClick: d[4] || (d[4] = Xe(() => {
              var f;
              return (f = c.editor) == null ? void 0 : f.chain().focus().toggleHeading({ level: 4 }).run();
            }, ["prevent"]))
          }, {
            text: S(() => [
              q(qr, { level: 4 }, {
                default: S(() => [
                  We(Se(p(n)("k-html-editor.text-styles.heading4")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["text"])
        ]),
        _: 1
      })) : V("", !0),
      c.tool === "bold" ? (w(), I(Hn, {
        key: 1,
        text: p(n)("k-html-editor.bold")
      }, {
        trigger: S(() => [
          q(iu, {
            icon: "fas fa-bold",
            modelValue: i.value,
            "onUpdate:modelValue": d[5] || (d[5] = (f) => i.value = f),
            onClick: d[6] || (d[6] = Xe(() => {
              var f;
              return (f = c.editor) == null ? void 0 : f.chain().focus().toggleBold().run();
            }, ["prevent"]))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["text"])) : V("", !0),
      c.tool === "italic" ? (w(), I(Hn, {
        key: 2,
        text: p(n)("k-html-editor.italic")
      }, {
        trigger: S(() => [
          q(iu, {
            icon: "fas fa-italic",
            modelValue: s.value,
            "onUpdate:modelValue": d[7] || (d[7] = (f) => s.value = f),
            onClick: d[8] || (d[8] = Xe(() => {
              var f;
              return (f = c.editor) == null ? void 0 : f.chain().focus().toggleItalic().run();
            }, ["prevent"]))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["text"])) : V("", !0),
      c.tool === "underline" ? (w(), I(Hn, {
        key: 3,
        text: p(n)("k-html-editor.underline")
      }, {
        trigger: S(() => [
          q(iu, {
            icon: "fas fa-underline",
            modelValue: l.value,
            "onUpdate:modelValue": d[9] || (d[9] = (f) => l.value = f),
            onClick: d[10] || (d[10] = Xe(() => {
              var f;
              return (f = c.editor) == null ? void 0 : f.chain().focus().toggleUnderline().run();
            }, ["prevent"]))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["text"])) : V("", !0),
      c.tool === "strike" ? (w(), I(Hn, {
        key: 4,
        text: p(n)("k-html-editor.strike")
      }, {
        trigger: S(() => [
          q(iu, {
            icon: "fas fa-strikethrough",
            modelValue: u.value,
            "onUpdate:modelValue": d[11] || (d[11] = (f) => u.value = f),
            onClick: d[12] || (d[12] = Xe(() => {
              var f;
              return (f = c.editor) == null ? void 0 : f.chain().focus().toggleStrike().run();
            }, ["prevent"]))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["text"])) : V("", !0),
      c.tool === "link" ? (w(), I(Hn, {
        key: 5,
        text: p(n)("k-html-editor.link")
      }, {
        trigger: S(() => [
          be("span", null, [
            q(mU, { editor: c.editor }, null, 8, ["editor"])
          ])
        ]),
        _: 1
      }, 8, ["text"])) : V("", !0),
      c.tool === "bulletList" ? (w(), I(Hn, {
        key: 6,
        text: p(n)("k-html-editor.bulletList")
      }, {
        trigger: S(() => [
          q(zt, {
            icon: "fas fa-list-ul",
            variant: "link",
            onClick: d[13] || (d[13] = Xe(() => {
              var f;
              return (f = c.editor) == null ? void 0 : f.chain().focus().toggleBulletList().run();
            }, ["prevent"]))
          })
        ]),
        _: 1
      }, 8, ["text"])) : V("", !0),
      c.tool === "orderedList" ? (w(), I(Hn, {
        key: 7,
        text: p(n)("k-html-editor.orderedList")
      }, {
        trigger: S(() => [
          q(zt, {
            icon: "fas fa-list-ol",
            variant: "link",
            onClick: d[14] || (d[14] = Xe(() => {
              var f;
              return (f = c.editor) == null ? void 0 : f.chain().focus().toggleOrderedList().run();
            }, ["prevent"]))
          })
        ]),
        _: 1
      }, 8, ["text"])) : V("", !0),
      c.tool === "undo" ? (w(), I(Hn, {
        key: 8,
        text: p(n)("k-html-editor.undo")
      }, {
        trigger: S(() => [
          q(zt, {
            icon: "fas fa-undo",
            variant: "link",
            onClick: d[15] || (d[15] = Xe(() => {
              var f;
              return (f = c.editor) == null ? void 0 : f.chain().focus().undo().run();
            }, ["prevent"]))
          })
        ]),
        _: 1
      }, 8, ["text"])) : V("", !0),
      c.tool === "redo" ? (w(), I(Hn, {
        key: 9,
        text: p(n)("k-html-editor.redo")
      }, {
        trigger: S(() => [
          q(zt, {
            icon: "fas fa-redo",
            variant: "link",
            onClick: d[16] || (d[16] = Xe(() => {
              var f;
              return (f = c.editor) == null ? void 0 : f.chain().focus().redo().run();
            }, ["prevent"]))
          })
        ]),
        _: 1
      }, 8, ["text"])) : V("", !0),
      c.tool === "image" ? (w(), I(Hn, {
        key: 10,
        text: p(n)("k-html-editor.add-image")
      }, {
        trigger: S(() => [
          q(gU, { editor: c.editor }, null, 8, ["editor"])
        ]),
        _: 1
      }, 8, ["text"])) : V("", !0),
      c.tool === "separator" ? (w(), K("span", vU)) : V("", !0)
    ], 64));
  }
}), bU = /* @__PURE__ */ ya(yU, [["__scopeId", "data-v-1e7b86f4"]]), kU = [
  "textStyles",
  "separator",
  "bold",
  "italic",
  "underline",
  "strike",
  "separator",
  "link",
  "separator",
  "bulletList",
  "orderedList"
], M8 = [
  "textStyles",
  "separator",
  "bold",
  "italic",
  "underline",
  "strike",
  "separator",
  "link",
  "bulletList",
  "orderedList",
  "separator",
  "undo",
  "redo",
  "separator",
  "image"
], I8 = ["textStyles", "separator", "bold", "italic", "underline"], wU = /* @__PURE__ */ j({
  __name: "KHtmlEditorToolbar",
  props: {
    editor: {},
    tools: { default: () => kU },
    disabled: { type: Boolean }
  },
  setup(t) {
    const e = t, n = A(() => ({
      "k-html-editor-toolbar": !0,
      "k-html-editor-toolbar-disabled": e.disabled
    })), r = A(() => e.tools || []);
    return (o, a) => (w(), K("span", {
      class: Ie(n.value)
    }, [
      (w(!0), K(Me, null, et(r.value, (i, s) => (w(), I(bU, {
        key: s,
        tool: i,
        editor: o.editor,
        disabled: o.disabled
      }, null, 8, ["tool", "editor", "disabled"]))), 128))
    ], 2));
  }
}), _U = /* @__PURE__ */ ya(wU, [["__scopeId", "data-v-00548013"]]), CU = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3nd0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0america6xi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", EU = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", as = (t, e) => {
  for (const n in e)
    t[n] = e[n];
  return t;
}, mp = "numeric", gp = "ascii", vp = "alpha", Ws = "asciinumeric", Ps = "alphanumeric", yp = "domain", F1 = "emoji", OU = "scheme", TU = "slashscheme", of = "whitespace";
function SU(t, e) {
  return t in e || (e[t] = []), e[t];
}
function Ra(t, e, n) {
  e[mp] && (e[Ws] = !0, e[Ps] = !0), e[gp] && (e[Ws] = !0, e[vp] = !0), e[Ws] && (e[Ps] = !0), e[vp] && (e[Ps] = !0), e[Ps] && (e[yp] = !0), e[F1] && (e[yp] = !0);
  for (const r in e) {
    const o = SU(r, n);
    o.indexOf(t) < 0 && o.push(t);
  }
}
function xU(t, e) {
  const n = {};
  for (const r in e)
    e[r].indexOf(t) >= 0 && (n[r] = !0);
  return n;
}
function Un(t = null) {
  this.j = {}, this.jr = [], this.jd = null, this.t = t;
}
Un.groups = {};
Un.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(t) {
    const e = this, n = e.j[t];
    if (n)
      return n;
    for (let r = 0; r < e.jr.length; r++) {
      const o = e.jr[r][0], a = e.jr[r][1];
      if (a && o.test(t))
        return a;
    }
    return e.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(t, e = !1) {
    return e ? t in this.j : !!this.go(t);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(t, e, n, r) {
    for (let o = 0; o < t.length; o++)
      this.tt(t[o], e, n, r);
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(t, e, n, r) {
    r = r || Un.groups;
    let o;
    return e && e.j ? o = e : (o = new Un(e), n && r && Ra(e, n, r)), this.jr.push([t, o]), o;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(t, e, n, r) {
    let o = this;
    const a = t.length;
    if (!a)
      return o;
    for (let i = 0; i < a - 1; i++)
      o = o.tt(t[i]);
    return o.tt(t[a - 1], e, n, r);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(t, e, n, r) {
    r = r || Un.groups;
    const o = this;
    if (e && e.j)
      return o.j[t] = e, e;
    const a = e;
    let i, s = o.go(t);
    if (s ? (i = new Un(), as(i.j, s.j), i.jr.push.apply(i.jr, s.jr), i.jd = s.jd, i.t = s.t) : i = new Un(), a) {
      if (r)
        if (i.t && typeof i.t == "string") {
          const l = as(xU(i.t, r), n);
          Ra(a, l, r);
        } else n && Ra(a, n, r);
      i.t = a;
    }
    return o.j[t] = i, i;
  }
};
const lt = (t, e, n, r, o) => t.ta(e, n, r, o), Ft = (t, e, n, r, o) => t.tr(e, n, r, o), _y = (t, e, n, r, o) => t.ts(e, n, r, o), Oe = (t, e, n, r, o) => t.tt(e, n, r, o), wo = "WORD", bp = "UWORD", V1 = "ASCIINUMERICAL", H1 = "ALPHANUMERICAL", kl = "LOCALHOST", kp = "TLD", wp = "UTLD", yu = "SCHEME", Ti = "SLASH_SCHEME", sm = "NUM", _p = "WS", lm = "NL", Ks = "OPENBRACE", js = "CLOSEBRACE", ju = "OPENBRACKET", zu = "CLOSEBRACKET", Yu = "OPENPAREN", qu = "CLOSEPAREN", Gu = "OPENANGLEBRACKET", Ju = "CLOSEANGLEBRACKET", Xu = "FULLWIDTHLEFTPAREN", Qu = "FULLWIDTHRIGHTPAREN", Zu = "LEFTCORNERBRACKET", ec = "RIGHTCORNERBRACKET", tc = "LEFTWHITECORNERBRACKET", nc = "RIGHTWHITECORNERBRACKET", rc = "FULLWIDTHLESSTHAN", oc = "FULLWIDTHGREATERTHAN", ac = "AMPERSAND", ic = "APOSTROPHE", sc = "ASTERISK", qo = "AT", lc = "BACKSLASH", uc = "BACKTICK", cc = "CARET", Jo = "COLON", um = "COMMA", dc = "DOLLAR", Ur = "DOT", fc = "EQUALS", cm = "EXCLAMATION", sr = "HYPHEN", zs = "PERCENT", pc = "PIPE", hc = "PLUS", mc = "POUND", Ys = "QUERY", dm = "QUOTE", U1 = "FULLWIDTHMIDDLEDOT", fm = "SEMI", Wr = "SLASH", qs = "TILDE", gc = "UNDERSCORE", W1 = "EMOJI", vc = "SYM";
var K1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ALPHANUMERICAL: H1,
  AMPERSAND: ac,
  APOSTROPHE: ic,
  ASCIINUMERICAL: V1,
  ASTERISK: sc,
  AT: qo,
  BACKSLASH: lc,
  BACKTICK: uc,
  CARET: cc,
  CLOSEANGLEBRACKET: Ju,
  CLOSEBRACE: js,
  CLOSEBRACKET: zu,
  CLOSEPAREN: qu,
  COLON: Jo,
  COMMA: um,
  DOLLAR: dc,
  DOT: Ur,
  EMOJI: W1,
  EQUALS: fc,
  EXCLAMATION: cm,
  FULLWIDTHGREATERTHAN: oc,
  FULLWIDTHLEFTPAREN: Xu,
  FULLWIDTHLESSTHAN: rc,
  FULLWIDTHMIDDLEDOT: U1,
  FULLWIDTHRIGHTPAREN: Qu,
  HYPHEN: sr,
  LEFTCORNERBRACKET: Zu,
  LEFTWHITECORNERBRACKET: tc,
  LOCALHOST: kl,
  NL: lm,
  NUM: sm,
  OPENANGLEBRACKET: Gu,
  OPENBRACE: Ks,
  OPENBRACKET: ju,
  OPENPAREN: Yu,
  PERCENT: zs,
  PIPE: pc,
  PLUS: hc,
  POUND: mc,
  QUERY: Ys,
  QUOTE: dm,
  RIGHTCORNERBRACKET: ec,
  RIGHTWHITECORNERBRACKET: nc,
  SCHEME: yu,
  SEMI: fm,
  SLASH: Wr,
  SLASH_SCHEME: Ti,
  SYM: vc,
  TILDE: qs,
  TLD: kp,
  UNDERSCORE: gc,
  UTLD: wp,
  UWORD: bp,
  WORD: wo,
  WS: _p
});
const bo = /[a-z]/, xs = new RegExp("\\p{L}", "u"), af = new RegExp("\\p{Emoji}", "u"), ko = /\d/, sf = /\s/, Cy = "\r", lf = `
`, AU = "️", MU = "‍", uf = "￼";
let su = null, lu = null;
function IU(t = []) {
  const e = {};
  Un.groups = e;
  const n = new Un();
  su == null && (su = Ey(CU)), lu == null && (lu = Ey(EU)), Oe(n, "'", ic), Oe(n, "{", Ks), Oe(n, "}", js), Oe(n, "[", ju), Oe(n, "]", zu), Oe(n, "(", Yu), Oe(n, ")", qu), Oe(n, "<", Gu), Oe(n, ">", Ju), Oe(n, "（", Xu), Oe(n, "）", Qu), Oe(n, "「", Zu), Oe(n, "」", ec), Oe(n, "『", tc), Oe(n, "』", nc), Oe(n, "＜", rc), Oe(n, "＞", oc), Oe(n, "&", ac), Oe(n, "*", sc), Oe(n, "@", qo), Oe(n, "`", uc), Oe(n, "^", cc), Oe(n, ":", Jo), Oe(n, ",", um), Oe(n, "$", dc), Oe(n, ".", Ur), Oe(n, "=", fc), Oe(n, "!", cm), Oe(n, "-", sr), Oe(n, "%", zs), Oe(n, "|", pc), Oe(n, "+", hc), Oe(n, "#", mc), Oe(n, "?", Ys), Oe(n, '"', dm), Oe(n, "/", Wr), Oe(n, ";", fm), Oe(n, "~", qs), Oe(n, "_", gc), Oe(n, "\\", lc), Oe(n, "・", U1);
  const r = Ft(n, ko, sm, {
    [mp]: !0
  });
  Ft(r, ko, r);
  const o = Ft(r, bo, V1, {
    [Ws]: !0
  }), a = Ft(r, xs, H1, {
    [Ps]: !0
  }), i = Ft(n, bo, wo, {
    [gp]: !0
  });
  Ft(i, ko, o), Ft(i, bo, i), Ft(o, ko, o), Ft(o, bo, o);
  const s = Ft(n, xs, bp, {
    [vp]: !0
  });
  Ft(s, bo), Ft(s, ko, a), Ft(s, xs, s), Ft(a, ko, a), Ft(a, bo), Ft(a, xs, a);
  const l = Oe(n, lf, lm, {
    [of]: !0
  }), u = Oe(n, Cy, _p, {
    [of]: !0
  }), c = Ft(n, sf, _p, {
    [of]: !0
  });
  Oe(n, uf, c), Oe(u, lf, l), Oe(u, uf, c), Ft(u, sf, c), Oe(c, Cy), Oe(c, lf), Ft(c, sf, c), Oe(c, uf, c);
  const d = Ft(n, af, W1, {
    [F1]: !0
  });
  Oe(d, "#"), Ft(d, af, d), Oe(d, AU, d);
  const f = Oe(d, MU);
  Oe(f, "#"), Ft(f, af, d);
  const h = [[bo, i], [ko, o]], m = [[bo, null], [xs, s], [ko, a]];
  for (let g = 0; g < su.length; g++)
    Wo(n, su[g], kp, wo, h);
  for (let g = 0; g < lu.length; g++)
    Wo(n, lu[g], wp, bp, m);
  Ra(kp, {
    tld: !0,
    ascii: !0
  }, e), Ra(wp, {
    utld: !0,
    alpha: !0
  }, e), Wo(n, "file", yu, wo, h), Wo(n, "mailto", yu, wo, h), Wo(n, "http", Ti, wo, h), Wo(n, "https", Ti, wo, h), Wo(n, "ftp", Ti, wo, h), Wo(n, "ftps", Ti, wo, h), Ra(yu, {
    scheme: !0,
    ascii: !0
  }, e), Ra(Ti, {
    slashscheme: !0,
    ascii: !0
  }, e), t = t.sort((g, y) => g[0] > y[0] ? 1 : -1);
  for (let g = 0; g < t.length; g++) {
    const y = t[g][0], C = t[g][1] ? {
      [OU]: !0
    } : {
      [TU]: !0
    };
    y.indexOf("-") >= 0 ? C[yp] = !0 : bo.test(y) ? ko.test(y) ? C[Ws] = !0 : C[gp] = !0 : C[mp] = !0, _y(n, y, y, C);
  }
  return _y(n, "localhost", kl, {
    ascii: !0
  }), n.jd = new Un(vc), {
    start: n,
    tokens: as({
      groups: e
    }, K1)
  };
}
function j1(t, e) {
  const n = DU(e.replace(/[A-Z]/g, (s) => s.toLowerCase())), r = n.length, o = [];
  let a = 0, i = 0;
  for (; i < r; ) {
    let s = t, l = null, u = 0, c = null, d = -1, f = -1;
    for (; i < r && (l = s.go(n[i])); )
      s = l, s.accepts() ? (d = 0, f = 0, c = s) : d >= 0 && (d += n[i].length, f++), u += n[i].length, a += n[i].length, i++;
    a -= d, i -= f, u -= d, o.push({
      t: c.t,
      // token type/name
      v: e.slice(a - u, a),
      // string value
      s: a - u,
      // start index
      e: a
      // end index (excluding)
    });
  }
  return o;
}
function DU(t) {
  const e = [], n = t.length;
  let r = 0;
  for (; r < n; ) {
    let o = t.charCodeAt(r), a, i = o < 55296 || o > 56319 || r + 1 === n || (a = t.charCodeAt(r + 1)) < 56320 || a > 57343 ? t[r] : t.slice(r, r + 2);
    e.push(i), r += i.length;
  }
  return e;
}
function Wo(t, e, n, r, o) {
  let a;
  const i = e.length;
  for (let s = 0; s < i - 1; s++) {
    const l = e[s];
    t.j[l] ? a = t.j[l] : (a = new Un(r), a.jr = o.slice(), t.j[l] = a), t = a;
  }
  return a = new Un(n), a.jr = o.slice(), t.j[e[i - 1]] = a, a;
}
function Ey(t) {
  const e = [], n = [];
  let r = 0, o = "0123456789";
  for (; r < t.length; ) {
    let a = 0;
    for (; o.indexOf(t[r + a]) >= 0; )
      a++;
    if (a > 0) {
      e.push(n.join(""));
      for (let i = parseInt(t.substring(r, r + a), 10); i > 0; i--)
        n.pop();
      r += a;
    } else
      n.push(t[r]), r++;
  }
  return e;
}
const wl = {
  defaultProtocol: "http",
  events: null,
  format: Oy,
  formatHref: Oy,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function pm(t, e = null) {
  let n = as({}, wl);
  t && (n = as(n, t instanceof pm ? t.o : t));
  const r = n.ignoreTags, o = [];
  for (let a = 0; a < r.length; a++)
    o.push(r[a].toUpperCase());
  this.o = n, e && (this.defaultRender = e), this.ignoreTags = o;
}
pm.prototype = {
  o: wl,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(t) {
    return t;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(t) {
    return this.get("validate", t.toString(), t);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(t, e, n) {
    const r = e != null;
    let o = this.o[t];
    return o && (typeof o == "object" ? (o = n.t in o ? o[n.t] : wl[t], typeof o == "function" && r && (o = o(e, n))) : typeof o == "function" && r && (o = o(e, n.t, n)), o);
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(t, e, n) {
    let r = this.o[t];
    return typeof r == "function" && e != null && (r = r(e, n.t, n)), r;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(t) {
    const e = t.render(this);
    return (this.get("render", null, t) || this.defaultRender)(e, t.t, t);
  }
};
function Oy(t) {
  return t;
}
function z1(t, e) {
  this.t = "token", this.v = t, this.tk = e;
}
z1.prototype = {
  isLink: !1,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */
  toHref(t) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(t) {
    const e = this.toString(), n = t.get("truncate", e, this), r = t.get("format", e, this);
    return n && r.length > n ? r.substring(0, n) + "…" : r;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(t) {
    return t.get("formatHref", this.toHref(t.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(t = wl.defaultProtocol) {
    return {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(t),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(t) {
    return {
      type: this.t,
      value: this.toFormattedString(t),
      isLink: this.isLink,
      href: this.toFormattedHref(t),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(t) {
    return t.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(t) {
    const e = this, n = this.toHref(t.get("defaultProtocol")), r = t.get("formatHref", n, this), o = t.get("tagName", n, e), a = this.toFormattedString(t), i = {}, s = t.get("className", n, e), l = t.get("target", n, e), u = t.get("rel", n, e), c = t.getObj("attributes", n, e), d = t.getObj("events", n, e);
    return i.href = r, s && (i.class = s), l && (i.target = l), u && (i.rel = u), c && as(i, c), {
      tagName: o,
      attributes: i,
      content: a,
      eventListeners: d
    };
  }
};
function sd(t, e) {
  class n extends z1 {
    constructor(o, a) {
      super(o, a), this.t = t;
    }
  }
  for (const r in e)
    n.prototype[r] = e[r];
  return n.t = t, n;
}
const Ty = sd("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), Sy = sd("text"), PU = sd("nl"), uu = sd("url", {
  isLink: !0,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(t = wl.defaultProtocol) {
    return this.hasProtocol() ? this.v : `${t}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const t = this.tk;
    return t.length >= 2 && t[0].t !== kl && t[1].t === Jo;
  }
}), ir = (t) => new Un(t);
function NU({
  groups: t
}) {
  const e = t.domain.concat([ac, sc, qo, lc, uc, cc, dc, fc, sr, sm, zs, pc, hc, mc, Wr, vc, qs, gc]), n = [ic, Jo, um, Ur, cm, zs, Ys, dm, fm, Gu, Ju, Ks, js, zu, ju, Yu, qu, Xu, Qu, Zu, ec, tc, nc, rc, oc], r = [ac, ic, sc, lc, uc, cc, dc, fc, sr, Ks, js, zs, pc, hc, mc, Ys, Wr, vc, qs, gc], o = ir(), a = Oe(o, qs);
  lt(a, r, a), lt(a, t.domain, a);
  const i = ir(), s = ir(), l = ir();
  lt(o, t.domain, i), lt(o, t.scheme, s), lt(o, t.slashscheme, l), lt(i, r, a), lt(i, t.domain, i);
  const u = Oe(i, qo);
  Oe(a, qo, u), Oe(s, qo, u), Oe(l, qo, u);
  const c = Oe(a, Ur);
  lt(c, r, a), lt(c, t.domain, a);
  const d = ir();
  lt(u, t.domain, d), lt(d, t.domain, d);
  const f = Oe(d, Ur);
  lt(f, t.domain, d);
  const h = ir(Ty);
  lt(f, t.tld, h), lt(f, t.utld, h), Oe(u, kl, h);
  const m = Oe(d, sr);
  Oe(m, sr, m), lt(m, t.domain, d), lt(h, t.domain, d), Oe(h, Ur, f), Oe(h, sr, m);
  const g = Oe(h, Jo);
  lt(g, t.numeric, Ty);
  const y = Oe(i, sr), b = Oe(i, Ur);
  Oe(y, sr, y), lt(y, t.domain, i), lt(b, r, a), lt(b, t.domain, i);
  const C = ir(uu);
  lt(b, t.tld, C), lt(b, t.utld, C), lt(C, t.domain, i), lt(C, r, a), Oe(C, Ur, b), Oe(C, sr, y), Oe(C, qo, u);
  const k = Oe(C, Jo), v = ir(uu);
  lt(k, t.numeric, v);
  const E = ir(uu), _ = ir();
  lt(E, e, E), lt(E, n, _), lt(_, e, E), lt(_, n, _), Oe(C, Wr, E), Oe(v, Wr, E);
  const T = Oe(s, Jo), M = Oe(l, Jo), O = Oe(M, Wr), R = Oe(O, Wr);
  lt(s, t.domain, i), Oe(s, Ur, b), Oe(s, sr, y), lt(l, t.domain, i), Oe(l, Ur, b), Oe(l, sr, y), lt(T, t.domain, E), Oe(T, Wr, E), Oe(T, Ys, E), lt(R, t.domain, E), lt(R, e, E), Oe(R, Wr, E);
  const N = [
    [Ks, js],
    // {}
    [ju, zu],
    // []
    [Yu, qu],
    // ()
    [Gu, Ju],
    // <>
    [Xu, Qu],
    // （）
    [Zu, ec],
    // 「」
    [tc, nc],
    // 『』
    [rc, oc]
    // ＜＞
  ];
  for (let z = 0; z < N.length; z++) {
    const [te, H] = N[z], U = Oe(E, te);
    Oe(_, te, U), Oe(U, H, E);
    const W = ir(uu);
    lt(U, e, W);
    const Q = ir();
    lt(U, n), lt(W, e, W), lt(W, n, Q), lt(Q, e, W), lt(Q, n, Q), Oe(W, H, E), Oe(Q, H, E);
  }
  return Oe(o, kl, C), Oe(o, lm, PU), {
    start: o,
    tokens: K1
  };
}
function $U(t, e, n) {
  let r = n.length, o = 0, a = [], i = [];
  for (; o < r; ) {
    let s = t, l = null, u = null, c = 0, d = null, f = -1;
    for (; o < r && !(l = s.go(n[o].t)); )
      i.push(n[o++]);
    for (; o < r && (u = l || s.go(n[o].t)); )
      l = null, s = u, s.accepts() ? (f = 0, d = s) : f >= 0 && f++, o++, c++;
    if (f < 0)
      o -= c, o < r && (i.push(n[o]), o++);
    else {
      i.length > 0 && (a.push(cf(Sy, e, i)), i = []), o -= f, c -= f;
      const h = d.t, m = n.slice(o - c, o);
      a.push(cf(h, e, m));
    }
  }
  return i.length > 0 && a.push(cf(Sy, e, i)), a;
}
function cf(t, e, n) {
  const r = n[0].s, o = n[n.length - 1].e, a = e.slice(r, o);
  return new t(a, n);
}
const RU = typeof console < "u" && console && console.warn || (() => {
}), LU = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.", Pt = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function BU() {
  return Un.groups = {}, Pt.scanner = null, Pt.parser = null, Pt.tokenQueue = [], Pt.pluginQueue = [], Pt.customSchemes = [], Pt.initialized = !1, Pt;
}
function xy(t, e = !1) {
  if (Pt.initialized && RU(`linkifyjs: already initialized - will not register custom scheme "${t}" ${LU}`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(t))
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  Pt.customSchemes.push([t, e]);
}
function FU() {
  Pt.scanner = IU(Pt.customSchemes);
  for (let t = 0; t < Pt.tokenQueue.length; t++)
    Pt.tokenQueue[t][1]({
      scanner: Pt.scanner
    });
  Pt.parser = NU(Pt.scanner.tokens);
  for (let t = 0; t < Pt.pluginQueue.length; t++)
    Pt.pluginQueue[t][1]({
      scanner: Pt.scanner,
      parser: Pt.parser
    });
  return Pt.initialized = !0, Pt;
}
function hm(t) {
  return Pt.initialized || FU(), $U(Pt.parser.start, t, j1(Pt.scanner.start, t));
}
hm.scan = j1;
function Y1(t, e = null, n = null) {
  if (e && typeof e == "object") {
    if (n)
      throw Error(`linkifyjs: Invalid link type ${e}; must be a string`);
    n = e, e = null;
  }
  const r = new pm(n), o = hm(t), a = [];
  for (let i = 0; i < o.length; i++) {
    const s = o[i];
    s.isLink && (!e || s.t === e) && r.check(s) && a.push(s.toFormattedObject(r));
  }
  return a;
}
function VU(t) {
  return t.length === 1 ? t[0].isLink : t.length === 3 && t[1].isLink ? ["()", "[]"].includes(t[0].value + t[2].value) : !1;
}
function HU(t) {
  return new rn({
    key: new Fn("autolink"),
    appendTransaction: (e, n, r) => {
      const o = e.some((u) => u.docChanged) && !n.doc.eq(r.doc), a = e.some((u) => u.getMeta("preventAutolink"));
      if (!o || a)
        return;
      const { tr: i } = r, s = W2(n.doc, [...e]);
      if (J2(s).forEach(({ newRange: u }) => {
        const c = j2(r.doc, u, (h) => h.isTextblock);
        let d, f;
        if (c.length > 1 ? (d = c[0], f = r.doc.textBetween(d.pos, d.pos + d.node.nodeSize, void 0, " ")) : c.length && r.doc.textBetween(u.from, u.to, " ", " ").endsWith(" ") && (d = c[0], f = r.doc.textBetween(d.pos, u.to, void 0, " ")), d && f) {
          const h = f.split(" ").filter((b) => b !== "");
          if (h.length <= 0)
            return !1;
          const m = h[h.length - 1], g = d.pos + f.lastIndexOf(m);
          if (!m)
            return !1;
          const y = hm(m).map((b) => b.toObject(t.defaultProtocol));
          if (!VU(y))
            return !1;
          y.filter((b) => b.isLink).map((b) => ({
            ...b,
            from: g + b.start + 1,
            to: g + b.end + 1
          })).filter((b) => r.schema.marks.code ? !r.doc.rangeHasMark(b.from, b.to, r.schema.marks.code) : !0).filter((b) => t.validate(b.value)).filter((b) => t.shouldAutoLink(b.value)).forEach((b) => {
            Jh(b.from, b.to, r.doc).some((C) => C.mark.type === t.type) || i.addMark(b.from, b.to, t.type.create({
              href: b.href
            }));
          });
        }
      }), !!i.steps.length)
        return i;
    }
  });
}
function UU(t) {
  return new rn({
    key: new Fn("handleClickLink"),
    props: {
      handleClick: (e, n, r) => {
        var o, a;
        if (r.button !== 0 || !e.editable)
          return !1;
        let i = r.target;
        const s = [];
        for (; i.nodeName !== "DIV"; )
          s.push(i), i = i.parentNode;
        if (!s.find((f) => f.nodeName === "A"))
          return !1;
        const l = s1(e.state, t.type.name), u = r.target, c = (o = u == null ? void 0 : u.href) !== null && o !== void 0 ? o : l.href, d = (a = u == null ? void 0 : u.target) !== null && a !== void 0 ? a : l.target;
        return u && c ? (window.open(c, d), !0) : !1;
      }
    }
  });
}
function WU(t) {
  return new rn({
    key: new Fn("handlePasteLink"),
    props: {
      handlePaste: (e, n, r) => {
        const { state: o } = e, { selection: a } = o, { empty: i } = a;
        if (i)
          return !1;
        let s = "";
        r.content.forEach((u) => {
          s += u.textContent;
        });
        const l = Y1(s, { defaultProtocol: t.defaultProtocol }).find((u) => u.isLink && u.value === s);
        return !s || !l ? !1 : t.editor.commands.setMark(t.type, {
          href: l.href
        });
      }
    }
  });
}
const KU = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g;
function xa(t, e) {
  const n = [
    "http",
    "https",
    "ftp",
    "ftps",
    "mailto",
    "tel",
    "callto",
    "sms",
    "cid",
    "xmpp"
  ];
  return e && e.forEach((r) => {
    const o = typeof r == "string" ? r : r.scheme;
    o && n.push(o);
  }), !t || t.replace(KU, "").match(new RegExp(
    // eslint-disable-next-line no-useless-escape
    `^(?:(?:${n.join("|")}):|[^a-z]|[a-z0-9+.-]+(?:[^a-z+.-:]|$))`,
    "i"
  ));
}
const jU = so.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: !1,
  exitable: !0,
  onCreate() {
    this.options.validate && !this.options.shouldAutoLink && (this.options.shouldAutoLink = this.options.validate, console.warn("The `validate` option is deprecated. Rename to the `shouldAutoLink` option instead.")), this.options.protocols.forEach((t) => {
      if (typeof t == "string") {
        xy(t);
        return;
      }
      xy(t.scheme, t.optionalSlashes);
    });
  },
  onDestroy() {
    BU();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: !0,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      defaultProtocol: "http",
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      isAllowedUri: (t, e) => !!xa(t, e.protocols),
      validate: (t) => !!t,
      shouldAutoLink: (t) => !!t
    };
  },
  addAttributes() {
    return {
      href: {
        default: null,
        parseHTML(t) {
          return t.getAttribute("href");
        }
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "a[href]",
        getAttrs: (t) => {
          const e = t.getAttribute("href");
          return !e || !this.options.isAllowedUri(e, {
            defaultValidate: (n) => !!xa(n, this.options.protocols),
            protocols: this.options.protocols,
            defaultProtocol: this.options.defaultProtocol
          }) ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return this.options.isAllowedUri(t.href, {
      defaultValidate: (e) => !!xa(e, this.options.protocols),
      protocols: this.options.protocols,
      defaultProtocol: this.options.defaultProtocol
    }) ? ["a", nn(this.options.HTMLAttributes, t), 0] : [
      "a",
      nn(this.options.HTMLAttributes, { ...t, href: "" }),
      0
    ];
  },
  addCommands() {
    return {
      setLink: (t) => ({ chain: e }) => {
        const { href: n } = t;
        return this.options.isAllowedUri(n, {
          defaultValidate: (r) => !!xa(r, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? e().setMark(this.name, t).setMeta("preventAutolink", !0).run() : !1;
      },
      toggleLink: (t) => ({ chain: e }) => {
        const { href: n } = t;
        return this.options.isAllowedUri(n, {
          defaultValidate: (r) => !!xa(r, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? e().toggleMark(this.name, t, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run() : !1;
      },
      unsetLink: () => ({ chain: t }) => t().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
    };
  },
  addPasteRules() {
    return [
      ti({
        find: (t) => {
          const e = [];
          if (t) {
            const { protocols: n, defaultProtocol: r } = this.options, o = Y1(t).filter((a) => a.isLink && this.options.isAllowedUri(a.value, {
              defaultValidate: (i) => !!xa(i, n),
              protocols: n,
              defaultProtocol: r
            }));
            o.length && o.forEach((a) => e.push({
              text: a.value,
              data: {
                href: a.href
              },
              index: a.start
            }));
          }
          return e;
        },
        type: this.type,
        getAttributes: (t) => {
          var e;
          return {
            href: (e = t.data) === null || e === void 0 ? void 0 : e.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const t = [], { protocols: e, defaultProtocol: n } = this.options;
    return this.options.autolink && t.push(HU({
      type: this.type,
      defaultProtocol: this.options.defaultProtocol,
      validate: (r) => this.options.isAllowedUri(r, {
        defaultValidate: (o) => !!xa(o, e),
        protocols: e,
        defaultProtocol: n
      }),
      shouldAutoLink: this.options.shouldAutoLink
    })), this.options.openOnClick === !0 && t.push(UU({
      type: this.type
    })), this.options.linkOnPaste && t.push(WU({
      editor: this.editor,
      defaultProtocol: this.options.defaultProtocol,
      type: this.type
    })), t;
  }
}), zU = so.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (t) => t.includes("underline") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["u", nn(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands: t }) => t.setMark(this.name),
      toggleUnderline: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetUnderline: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
}), YU = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/, qU = br.create({
  name: "image",
  addOptions() {
    return {
      inline: !1,
      allowBase64: !1,
      HTMLAttributes: {}
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      title: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: this.options.allowBase64 ? "img[src]" : 'img[src]:not([src^="data:"])'
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["img", nn(this.options.HTMLAttributes, t)];
  },
  addCommands() {
    return {
      setImage: (t) => ({ commands: e }) => e.insertContent({
        type: this.name,
        attrs: t
      })
    };
  },
  addInputRules() {
    return [
      c1({
        find: YU,
        type: this.type,
        getAttributes: (t) => {
          const [, , e, n, r] = t;
          return { src: n, alt: e, title: r };
        }
      })
    ];
  }
}), D8 = /* @__PURE__ */ j({
  __name: "KHtmlEditor",
  props: /* @__PURE__ */ it({
    tools: {},
    id: {},
    label: {},
    labelSrOnly: { type: [Boolean, String] },
    required: { type: [Boolean, String] },
    disabled: { type: [Boolean, String] },
    marginless: { type: [Boolean, String] },
    emptyValue: {},
    defaultValue: {},
    description: {},
    errors: {},
    variant: {},
    tooltip: {},
    tooltipProps: {},
    prependIcon: {},
    appendIcon: {},
    clearable: { type: [Boolean, String] }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, n = ut(t, "modelValue"), r = A(() => ({
      "k-html-editor": !0,
      "k-input-disabled": ce(e.disabled),
      "k-html-editor-error": e.errors
    })), o = A(() => ({
      "k-html-editor-content": !0,
      "k-html-editor-content-disabled": ce(e.disabled)
    })), a = fH({
      extensions: [fU, jU, zU, qU],
      editable: !e.disabled
    }), i = fn(e), s = yn(i, e);
    return (l, u) => (w(), I(yr, oe(l.$props, {
      "description-id": p(s),
      "input-id": p(i)
    }), {
      default: S(() => [
        be("div", {
          class: Ie(r.value)
        }, [
          q(_U, {
            editor: p(a),
            tools: l.tools,
            disabled: p(ce)(l.disabled)
          }, null, 8, ["editor", "tools", "disabled"]),
          be("div", {
            class: "k-html-editor-content-wrapper",
            onClick: u[1] || (u[1] = () => {
              var c;
              return (c = p(a)) == null ? void 0 : c.chain().focus().run();
            })
          }, [
            q(p(dH), {
              class: Ie(o.value),
              editor: p(a),
              input: n.value,
              "onUpdate:input": u[0] || (u[0] = (c) => n.value = c)
            }, null, 8, ["class", "editor", "input"])
          ])
        ], 2)
      ]),
      _: 1
    }, 16, ["description-id", "input-id"]));
  }
}), GU = /* @__PURE__ */ j({
  __name: "KToggleGroup",
  props: {
    shadow: { type: [Boolean, String] }
  },
  setup(t) {
    const e = t, n = A(() => ({
      "k-toggle-group": !0,
      "k-toggle-group-shadow": ce(e.shadow)
    }));
    return (r, o) => (w(), K("span", {
      class: Ie(n.value)
    }, [
      $(r.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), P8 = /* @__PURE__ */ ya(GU, [["__scopeId", "data-v-725df3a1"]]), JU = { class: "k-input-group-body" }, N8 = /* @__PURE__ */ j({
  __name: "KInputGroup",
  props: {
    inline: { type: [Boolean, String] },
    id: {},
    label: {},
    labelSrOnly: { type: [Boolean, String] },
    required: { type: [Boolean, String] },
    disabled: { type: [Boolean, String] },
    marginless: { type: [Boolean, String] },
    emptyValue: {},
    defaultValue: {},
    description: {},
    errors: {},
    variant: {},
    tooltip: {},
    tooltipProps: {}
  },
  setup(t) {
    const e = t, n = fn(e), r = yn(n, e), o = A(() => ({
      "k-input-group": !0,
      "k-input-group-inline": ce(e.inline)
    }));
    return (a, i) => (w(), I(li, {
      as: "fieldset",
      marginless: a.marginless,
      "aria-describedby": p(r),
      class: Ie(o.value)
    }, {
      default: S(() => [
        a.label ? (w(), I(va, oe({ key: 0 }, e, {
          "input-id": p(n),
          as: "legend"
        }), null, 16, ["input-id"])) : V("", !0),
        be("div", JU, [
          $(a.$slots, "default")
        ]),
        q(si, oe(e, { "description-id": p(r) }), null, 16, ["description-id"])
      ]),
      _: 3
    }, 8, ["marginless", "aria-describedby", "class"]));
  }
});
export {
  x8 as KAccordion,
  Ug as KAccordionItem,
  ZU as KAlert,
  h8 as KAutocomplete,
  C8 as KBadge,
  zt as KButton,
  Nf as KCaption,
  e8 as KCard,
  iI as KCheckbox,
  y8 as KCheckboxList,
  EI as KChip,
  m8 as KCombobox,
  i8 as KConfirm,
  b8 as KDateInput,
  Y$ as KDropdown,
  Os as KDropdownItem,
  _8 as KDropdownLabel,
  w8 as KDropdownSeparator,
  hR as KFileIcon,
  O8 as KFileInput,
  qr as KHeading,
  D8 as KHtmlEditor,
  ht as KIcon,
  bb as KIconList,
  ZE as KImage,
  N8 as KInputGroup,
  bM as KLabel,
  $p as KLink,
  E8 as KListbox,
  iM as KModal,
  l8 as KNumberInput,
  c8 as KPasswordInput,
  B1 as KPopover,
  v8 as KRadioGroup,
  S8 as KRange,
  T8 as KReadOnly,
  p8 as KSelect,
  g8 as KSkeleton,
  Ni as KSkeletonBox,
  PI as KSkeletonHeading,
  DI as KSkeletonInput,
  $I as KSkeletonText,
  Rp as KSpinner,
  u8 as KTextArea,
  nh as KTextInput,
  ER as KTextLimiter,
  iu as KToggle,
  P8 as KToggleGroup,
  Hn as KTooltip,
  k8 as KYearInput,
  a8 as KtVueComponents,
  M8 as allTools,
  kU as defaultTools,
  ah as filterFormItems,
  D0 as findFormItem,
  P0 as findFormItemGroup,
  rI as formItemsFromEnum,
  nI as formItemsFromObject,
  kd as formatNumberToDigits,
  S0 as formatNumberToLocale,
  tI as getFileIcon,
  eh as isEmpty,
  Si as isFalse,
  ce as isTrue,
  As as normalizeForSearch,
  th as parseNumber,
  s8 as randomInteger,
  I8 as simpleTools,
  f8 as useFormItemsFromEnum,
  d8 as useFormItemsFromObject
};
